import require$$0, { $ as $$1, CorePlugin, Events as Events$1, Browser, UICorePlugin, Playback, Log as Log$1, ContainerPlugin, template, Utils, UIContainerPlugin, Styler as Styler$1, BaseObject, PlayerError, HTML5Video } from '@clappr/core';
import { Events, Styler, Utils as Utils$1, Errors as Errors$2, Models, Environment } from '@player/core';
import HLSJS from 'hls.js';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var DFPCompanion = /*#__PURE__*/function (_CorePlugin) {
  _inherits(DFPCompanion, _CorePlugin);

  var _super = _createSuper(DFPCompanion);

  _createClass(DFPCompanion, [{
    key: "name",
    get: function get() {
      return 'dfp_companion';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }]);

  function DFPCompanion(core, adNetworkId) {
    var _this;

    _classCallCheck(this, DFPCompanion);

    _this = _super.call(this, core);
    var adUnit = _this.core.options.adUnit;
    var adCompanion = _this.core.options.adCompanion;

    if (adCompanion && adNetworkId && adUnit) {
      var keys = _typeof(adCompanion) === 'object' && Object.keys(adCompanion) || [];
      var companionKey = keys[0];
      _this.unitcode = "/".concat(adNetworkId, "/").concat(adUnit);
      _this.companionWidth = +companionKey.split('x')[0];
      _this.companionHeight = +companionKey.split('x')[1];
      _this.companionDiv = adCompanion[companionKey];

      _this.embedScript();

      _this.setup();

      _this.show();
    } else {
      _this.disable();
    }

    return _this;
  }

  _createClass(DFPCompanion, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core.options.dfp, Events.DFP_CONTENT_RESUME, this.hide);
      this.listenTo(this.core.options.dfp, Events.DFP_AD_ERROR, this.hide);
      this.listenTo(this.core.options.dfp, Events.DFP_CONTENT_ENDED, this.hide);
    }
  }, {
    key: "embedScript",
    value: function embedScript() {
      var companionGoogleUrl = '//www.googletagservices.com/tag/js/gpt.js';
      var isNotEmbeded = $$1("script[src=\"".concat(companionGoogleUrl, "\"]")).length === 0;

      if (isNotEmbeded) {
        var gads = document.createElement('script');
        gads.setAttribute('type', 'text/javascript');
        gads.setAttribute('async', 'async');
        gads.setAttribute('src', companionGoogleUrl);
        document.head.appendChild(gads);
      }
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this2 = this;

      window.googletag = window.googletag || {};
      window.googletag.cmd = window.googletag.cmd || [];
      googletag.cmd.push(function () {
        googletag.defineSlot(_this2.unitcode, [_this2.companionWidth, _this2.companionHeight], _this2.companionDiv).addService(googletag.companionAds()).addService(googletag.pubads()).addService(googletag.content());
        googletag.companionAds().setRefreshUnfilledSlots(true);
        googletag.pubads().enableVideoAds();
        googletag.enableServices();
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      googletag.cmd.push(function () {
        googletag.display(_this3.companionDiv);
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      $$1("#".concat(this.companionDiv)).hide();
    }
  }]);

  return DFPCompanion;
}(CorePlugin);

var global$1 = (typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".clappr-player#wp3-player-0 .dfp-ad-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 994;\n  transform: translateY(0);\n  transition: transform 0.3s ease; }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay--notransition {\n    transition: none !important; }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay--poster-mode {\n    visibility: hidden !important;\n    pointer-events: none; }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay--poster-mobile-mode {\n    display: none !important; }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay--overlay-mode {\n    transform: translateY(-20px);\n    height: 80px; }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay--over-media-control {\n    z-index: 998; }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay--media-control-show {\n    transform: translateY(-80px); }\n  .clappr-player#wp3-player-0 .dfp-ad-overlay video {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%; }\n";
styleInject(css_248z);

var Mode = /*#__PURE__*/function () {
  function Mode() {
    _classCallCheck(this, Mode);
  }

  _createClass(Mode, null, [{
    key: "Full",
    get: function get() {
      return '';
    }
  }, {
    key: "Overlay",
    get: function get() {
      return 'dfp-ad-overlay--overlay-mode dfp-ad-overlay--over-media-control';
    }
  }, {
    key: "Hidden",
    get: function get() {
      return 'dfp-ad-overlay--poster-mode';
    }
  }, {
    key: "HiddenMobile",
    get: function get() {
      return 'dfp-ad-overlay--poster-mobile-mode';
    }
  }]);

  return Mode;
}();

var DFPAdOverlay = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(DFPAdOverlay, _UICorePlugin);

  var _super = _createSuper(DFPAdOverlay);

  _createClass(DFPAdOverlay, [{
    key: "name",
    get: function get() {
      return 'dfp_ad_overlay';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": 'dfp-ad-overlay'
      };
    }
  }], [{
    key: "Mode",
    get: function get() {
      return Mode;
    }
  }]);

  function DFPAdOverlay(core) {
    var _this;

    _classCallCheck(this, DFPAdOverlay);

    _this = _super.call(this, core);

    _this.setHiddenMode();

    if (!_this.dfp) {
      _this.disable();
    }

    return _this;
  }

  _createClass(DFPAdOverlay, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.dfp = this.core.options.dfp;
      this.listenTo(this.dfp, Events.DFP_AD_STARTED, this.adStarted);
      this.listenTo(this.dfp, Events.DFP_AD_CLOSED, this.setHiddenMode);
      this.listenTo(this.dfp, Events.DFP_AD_COMPLETED, this.adEnded);
      this.listenTo(this.dfp, Events.DFP_AD_SKIPPED, this.adEnded);
      this.listenTo(this.dfp, Events.DFP_ALL_ADS_COMPLETED, this.adEnded);
      this.listenTo(this.dfp, Events.DFP_CONTENT_STARTED, this.setHiddenMode);
      this.listenTo(this.dfp, Events.DFP_CONTENT_ENDED, this.setHiddenMode);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.updateSize);
      this.listenToOnce(this.core, Events$1.CORE_READY, this.bindMediaControlPluginsEvents);
      this.bindMediaControlEvents();
    }
  }, {
    key: "bindMediaControlEvents",
    value: function bindMediaControlEvents() {
      this.unbindMediaControlEvents();
      this.listenTo(this.core, Events$1.MEDIACONTROL_SHOW, this.mediaControlShow);
      this.listenTo(this.core, Events$1.MEDIACONTROL_HIDE, this.mediaControlHide);
      this.$el.removeClass('dfp-ad-overlay--notransition');
    }
  }, {
    key: "unbindMediaControlEvents",
    value: function unbindMediaControlEvents() {
      this.stopListening(this.core, Events$1.MEDIACONTROL_SHOW, this.mediaControlShow);
      this.stopListening(this.core, Events$1.MEDIACONTROL_HIDE, this.mediaControlHide);
      this.$el.addClass('dfp-ad-overlay--notransition');
    }
  }, {
    key: "bindMediaControlPluginsEvents",
    value: function bindMediaControlPluginsEvents() {
      this.listenTo(this.core.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.mediaControlInteractionStart);
      this.listenTo(this.core.mediaControl, Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.mediaControlInteractionEnd);
      this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_MODAL_SHOW, this.mediaControlModalShow);
      this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_MODAL_HIDE, this.mediaControlModalHide);
      this.listenTo(this.core.mediaControl, Events.WM_VOLUME_SHOW, this.mediaControlInteractionStart);
      this.listenTo(this.core.mediaControl, Events.WM_VOLUME_HIDE, this.mediaControlInteractionEnd);
    }
  }, {
    key: "adStarted",
    value: function adStarted(ad) {
      var isLinear = ad.isLinear();
      this.setMode(isLinear ? Mode.Full : Mode.Overlay);

      if (isLinear) {
        this.unbindMediaControlEvents();
        this.mediaControlHide();
      }

      Browser.isMobile && !isLinear && this.mediaControlShow();
    }
  }, {
    key: "adEnded",
    value: function adEnded(isLinear) {
      this.setHiddenMode();

      if (isLinear) {
        this.bindMediaControlEvents();
      }
    }
  }, {
    key: "setHiddenMode",
    value: function setHiddenMode() {
      this.setMode(Browser.isMobile ? Mode.HiddenMobile : Mode.Hidden);
    }
  }, {
    key: "mediaControlShow",
    value: function mediaControlShow() {
      this.$el.addClass('dfp-ad-overlay--media-control-show');
      this.updateSize();
    }
  }, {
    key: "mediaControlHide",
    value: function mediaControlHide() {
      this.$el.removeClass('dfp-ad-overlay--media-control-show');
      this.updateSize();
    }
  }, {
    key: "mediaControlModalShow",
    value: function mediaControlModalShow() {
      this._modalVisible = true;
      this.mediaControlInteractionStart();
    }
  }, {
    key: "mediaControlModalHide",
    value: function mediaControlModalHide() {
      this._modalVisible = false;
      this.mediaControlInteractionEnd();
    }
  }, {
    key: "mediaControlInteractionStart",
    value: function mediaControlInteractionStart() {
      this._mode == Mode.Overlay && this.$el.removeClass('dfp-ad-overlay--over-media-control');
    }
  }, {
    key: "mediaControlInteractionEnd",
    value: function mediaControlInteractionEnd() {
      if (this._modalVisible) return;
      this._mode == Mode.Overlay && this.$el.addClass('dfp-ad-overlay--over-media-control');
    }
  }, {
    key: "setMode",
    value: function setMode(mode) {
      var _this2 = this;

      this._mode = mode;
      this.$el.removeClass(Mode.Overlay);
      this.$el.removeClass(Mode.Hidden);
      this.$el.removeClass(Mode.HiddenMobile);

      if (mode) {
        this.$el.addClass(mode);
        nextTick(function () {
          return _this2.updateSize();
        });
      }
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var width = this.$el.width();
      var height = this.$el.height();

      if (this.dfp.adsManager && width && height) {
        this.dfp.adsManager.resize(width, height, google.ima.ViewMode.NORMAL);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.append(Styler.getStyleFrom(css_248z, {
        playerId: this.core.options.playerId
      })[0]);
      return this;
    }
  }]);

  return DFPAdOverlay;
}(UICorePlugin);

var DFPPlayback = /*#__PURE__*/function (_Playback) {
  _inherits(DFPPlayback, _Playback);

  var _super = _createSuper(DFPPlayback);

  _createClass(DFPPlayback, [{
    key: "name",
    get: function get() {
      return 'dfp_playback';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'video';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'data-dfp-playback': ''
      };
    }
  }, {
    key: "adsManager",
    get: function get() {
      return this.dfp && this.dfp.adsManager;
    }
  }, {
    key: "defaultSettings",
    get: function get() {
      return {
        seekEnabled: false
      };
    }
  }]);

  function DFPPlayback(options, dfp) {
    var _this;

    _classCallCheck(this, DFPPlayback);

    _this = _super.call(this, options);
    _this.dfp = dfp;
    _this.settings = _this.defaultSettings;

    _this.bindEvents();

    return _this;
  }

  _createClass(DFPPlayback, [{
    key: "ready",
    value: function ready() {
      this.trigger(Events$1.PLAYBACK_READY, this.name);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.dfp, Events.DFP_AD_LOADED, function (ad) {
        return _this2.duration = ad && ad.getDuration();
      });
      this.listenTo(this, Events$1.PLAYBACK_PLAY, function () {
        return _this2.playing = true;
      });
      this.listenTo(this, Events$1.PLAYBACK_PAUSE, function () {
        return _this2.playing = false;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this;
    }
  }, {
    key: "getPlaybackType",
    value: function getPlaybackType() {
      return 'ad';
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getRemainingTime",
    value: function getRemainingTime() {
      return this.adsManager ? this.adsManager.getRemainingTime() : 0;
    }
  }, {
    key: "play",
    value: function play() {
      if (!this.adsManager) return;
      this.adsManager.resume();
      !this.updateTimer && this.startUpdateTimer();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.adsManager) return;
      this.adsManager.pause();
      this.stopUpdateTimer();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopUpdateTimer();

      _get(_getPrototypeOf(DFPPlayback.prototype), "stop", this).call(this);
    }
  }, {
    key: "startUpdateTimer",
    value: function startUpdateTimer() {
      var _this3 = this;

      this.stopUpdateTimer();
      this.updateTimer = setInterval(function () {
        var remainingTime = _this3.getRemainingTime();

        _this3.trigger(Events$1.PLAYBACK_TIMEUPDATE, {
          current: _this3.duration - remainingTime,
          total: _this3.duration,
          playbackType: _this3.getPlaybackType()
        });
      }, 100);
    }
  }, {
    key: "stopUpdateTimer",
    value: function stopUpdateTimer() {
      clearInterval(this.updateTimer);
      delete this.updateTimer;
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return this.playing;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopUpdateTimer();
      this.stopListening();

      _get(_getPrototypeOf(DFPPlayback.prototype), "destroy", this).call(this);
    }
  }, {
    key: "volume",
    value: function volume(value) {
      if (!this.adsManager) return;
      this.adsManager.setVolume(value / 100);
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      if (!this.adsManager) return this.dfp.container.playback.getVolume() / 100;
      return this.adsManager.getVolume();
    }
  }]);

  return DFPPlayback;
}(Playback);

var DFPVideoAd = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(DFPVideoAd, _ContainerPlugin);

  var _super = _createSuper(DFPVideoAd);

  _createClass(DFPVideoAd, [{
    key: "name",
    get: function get() {
      return 'dfp_video_ad';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "videoElement",
    get: function get() {
      var idPlayback = this.container.playback;
      var innerPlayback = idPlayback && idPlayback.playback;
      return innerPlayback && innerPlayback.el;
    }
  }]);

  function DFPVideoAd(container) {
    var _this;

    _classCallCheck(this, DFPVideoAd);

    _this = _super.call(this, container);
    _this.isServedAd = false;
    _this.isFirstPlay = true;
    return _this;
  }

  _createClass(DFPVideoAd, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.container.playback, Events.WM_PLAY_REQUESTED_READY, this.onPlayRequestedReady);
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_SELECTED, this.onResourceSelected);
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
      this.listenTo(this.container, Events$1.CONTAINER_TIMEUPDATE, this.containerTimeUpdate);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.containerEnded);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.containerEnded);
      this.listenTo(this.container, Events$1.CONTAINER_ERROR, this.containerError);
      this.listenTo(this.options.dfp, Events.DFP_AD_LOADED, this.adLoaded);
      this.listenTo(this.options.dfp, Events.DFP_CONTENT_PAUSE, this.adBreakStarted);
      this.listenTo(this.container, Events.DFP_AD_STARTED, this.onAdStarted);
      this.listenTo(this.container, Events.DFP_AD_RESUME, this.onDFPAdResume);
      this.listenTo(this.options.dfp, Events.DFP_CONTENT_RESUME, this.adBreakEnded);
      this.listenTo(this.options.dfp, Events.DFP_AD_ERROR, this.adError);
      this.listenTo(this.container, Events.WM_MASTERTOPIP, this.onPip);
    }
  }, {
    key: "onPlayRequestedReady",
    value: function onPlayRequestedReady() {
      /*
        Disable IdPlayback playWhenReady call when DFP is enabled (i.e. shouldSkipAd is false).
        This will allow DFP manually controls the play action by calling playWhenReady on adBreakEnded
      */
      this.container.playback.disablePlayWhenReady = !this.options.dfp.shouldSkipAd;
    }
  }, {
    key: "onPip",
    value: function onPip() {
      this.stopListening();
      this.listenTo(this.container, Events.WM_PIPTOMASTER, this.bindEvents);
    }
  }, {
    key: "onResourceSelected",
    value: function onResourceSelected() {
      this.hasError = false;
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady() {
      var playbackOptions = this.container.playback.options;

      if (!playbackOptions.onPip) {
        this.adPlayback = new DFPPlayback(playbackOptions, this.options.dfp);
      }

      this.containerPlay();
      this.options.dfp.contentStarted();
    }
  }, {
    key: "containerPlay",
    value: function containerPlay() {
      var _this2 = this;

      this.containerPlaying = true;
      if (this.hasError) nextTick(function () {
        return _this2.adBreakEnded();
      });
    }
  }, {
    key: "containerEnded",
    value: function containerEnded() {
      this.options.dfp.contentEnded();
      this.stopListening();
      this.bindEvents();
      this.containerPlaying = false;
      this.hasError && this.adPlayback && this.adPlayback.stop();
    }
  }, {
    key: "containerError",
    value: function containerError() {
      this.hasError = true;
    }
  }, {
    key: "adError",
    value: function adError() {
      this.hasError = true;
      this.adBreakEnded();
    }
  }, {
    key: "adLoaded",
    value: function adLoaded(ad) {
      var _this3 = this;

      var isLinear = ad.isLinear();
      this.options.dfp.podIndex = ad.getAdPodInfo().getPodIndex();
      var linearAds = {
        '-1': function _() {
          Log$1.info(_this3.name, 'Post-roll loaded');
          _this3.adPlayback && (_this3.adPlayback.duration = ad.getDuration());
          _this3.postroll = true;
        },
        '0': function _() {
          return Log$1.info(_this3.name, 'Pre-roll loaded');
        },
        'midroll': function midroll() {
          _this3.adPlayback && (_this3.adPlayback.duration = ad.getDuration());
          Log$1.info(_this3.name, 'Mid-roll loaded');
        }
      };
      isLinear ? (linearAds[this.options.dfp.podIndex] || linearAds['midroll'])() : Log$1.info(this.name, 'Overlay loaded');
    }
  }, {
    key: "onDFPAdResume",
    value: function onDFPAdResume() {
      /*
        Some campaigns are unmuting initially muted ads without user interaction.
        It causes the ad playback to be stuck at the start because it cannot start with sound without user interaction in most cases.
        As a workaround, we are setting the volume again just before the ad starts to avoid this problem.
      */
      if (this.isFirstPlay) {
        this.syncVolumeWithIdPlayback();
        this.isFirstPlay = false;
      }
    }
  }, {
    key: "adBreakStarted",
    value: function adBreakStarted(ad) {
      this.isServedAd = true;
      this.onBreak = true;

      if (this.hasError) {
        this.adBreakEnded();
        return;
      }

      this.container.playback.isPlaying() ? this.pauseMainContent(ad) : this.initAdPlayback(ad);
    }
  }, {
    key: "onAdStarted",
    value: function onAdStarted() {
      this.container.getPlugin('click_to_pause').disable();
      this.adPlayback && this.adPlayback.play();
      this.container.settingsUpdate();
    }
  }, {
    key: "pauseMainContent",
    value: function pauseMainContent(ad) {
      this.listenToOnce(this.container.playback, Events$1.PLAYBACK_PAUSE, this.initAdPlayback.bind(this, ad));
      this.container.pause();
    }
  }, {
    key: "initAdPlayback",
    value: function initAdPlayback(ad) {
      var playbackOptions = this.container.playback.options;
      this.playback = this.container.playback;
      this.playback.stopListening();
      this.container.stopListening();

      if (!this.adPlayback) {
        this.adPlayback = new DFPPlayback(playbackOptions, this.options.dfp);
        this.adPlayback.duration = ad.getDuration();
      }

      this.syncVolumeWithIdPlayback();
      this.container.playback = this.adPlayback;
      this.container.bindEvents();
      this.adPlayback.ready();
    }
  }, {
    key: "adBreakEnded",
    value: function adBreakEnded() {
      var _this4 = this;

      if (this.onBreak) {
        this.container.stopListening();
        this.playback.bindPlaybackEvents();
        this.playback._options = _objectSpread2({}, this.adPlayback._options);
        this.container.playback = this.playback;
        this.container.playback.volume(this.adPlayback.getVolume() * 100);
        this.container.currentTime = this.playback.currentTime;
        this.options.dfp.podIndex === 0 && this.playback.checkInitialSeek();
        this.container.bindEvents();
      }

      if (this.adPlayback) {
        this.adPlayback.stop();
        this.adPlayback.destroy();
        this.adPlayback = null;
      }

      this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, function () {
        return _this4.container.settingsUpdate();
      });

      if (this.containerPlaying || this.hasError || this.options.dfp.shouldSkipAd) {
        !Browser.supportsTouchEvents && this.container.getPlugin('click_to_pause').enable();
        nextTick(function () {
          return _this4.container.playback.playWhenReady();
        });
      } else {
        this.container.getPlugin('poster').show();
      }

      this.onBreak = false;
      this.hasError = false;
      this.isServedAd = false;
    }
  }, {
    key: "syncVolumeWithIdPlayback",
    value: function syncVolumeWithIdPlayback() {
      var currentIdPlaybackVolume = this.playback.getVolume(); // if volume from id_playback is valid, set it on DFP

      if (currentIdPlaybackVolume !== null) {
        this.adPlayback.volume(currentIdPlaybackVolume);
      }
    } // for tracking mid-rolls or non-linear ads

  }, {
    key: "containerTimeUpdate",
    value: function containerTimeUpdate(timeProgress) {} // eslint-disable-line no-unused-vars

  }]);

  return DFPVideoAd;
}(ContainerPlugin);

var MediaControlPlugin = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(MediaControlPlugin, _UICorePlugin);

  var _super = _createSuper(MediaControlPlugin);

  _createClass(MediaControlPlugin, [{
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "panel",
    get: function get() {
      return 'middle';
    }
  }, {
    key: "position",
    get: function get() {
      return 'center';
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this._mediaControl || (this._mediaControl = this.core.getPlugin('globo_media_control'));
    }
  }, {
    key: "kibo",
    get: function get() {
      return this.mediaControl.kibo;
    }
  }, {
    key: "isSticky",
    get: function get() {
      return this.el.classList.contains('media-control-element--sticky');
    }
  }]);

  function MediaControlPlugin(core) {
    var _this;

    _classCallCheck(this, MediaControlPlugin);

    _this = _super.call(this, core);
    _this.core = core;

    _this.$el.on('click', function (e) {
      e.stopPropagation();

      _this.mediaControl.trigger(Events.MEDIACONTROL_ITEMCLICKED);
    });

    _this.$el.addClass('media-control-element');

    return _this;
  }

  _createClass(MediaControlPlugin, [{
    key: "applyButtonStyle",
    value: function applyButtonStyle(element) {
      if (this.buttonsColor && element) {
        $(element).find('svg path').css('fill', this.buttonsColor); // eslint-disable-line no-undef
      }
    }
  }, {
    key: "bindKeyAndShow",
    value: function bindKeyAndShow(key, callback) {
      var _this2 = this;

      this.kibo.down(key, function () {
        _this2.mediaControl.show();

        return callback();
      });
    }
  }, {
    key: "triggerWillShowModalElement",
    value: function triggerWillShowModalElement() {
      this.core.trigger(Events.WILL_SHOW_MODAL_ELEMENT, {
        name: this.name
      });
    }
  }, {
    key: "triggerDidHideModalElement",
    value: function triggerDidHideModalElement() {
      this.core.trigger(Events.DID_HIDE_MODAL_ELEMENT, {
        name: this.name
      });
    }
  }, {
    key: "setSticky",
    value: function setSticky() {
      this.el.classList.add('media-control-element--sticky');
    }
  }, {
    key: "resetSticky",
    value: function resetSticky() {
      this.el.classList.remove('media-control-element--sticky');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._mediaControl = null;

      _get(_getPrototypeOf(MediaControlPlugin.prototype), "destroy", this).call(this);
    }
  }]);

  return MediaControlPlugin;
}(UICorePlugin);

var css_248z$1 = ".clappr-player#wp3-player-0 .dfp-countdown {\n  display: none;\n  position: relative;\n  z-index: 998;\n  pointer-events: none;\n  font-size: 13px;\n  line-height: 13px;\n  color: #e5e886;\n  transition: transform 0.3s ease-out; }\n  .clappr-player#wp3-player-0 .dfp-countdown.media-control-element {\n    padding-left: 0;\n    padding-right: 0; }\n  .clappr-player#wp3-player-0 .dfp-countdown__text {\n    display: inline-block;\n    font-family: \"opensans-regular\", sans-serif; }\n  .clappr-player#wp3-player-0 .dfp-countdown__time {\n    display: inline-block;\n    font-family: \"opensans-bold\", sans-serif; }\n  .clappr-player#wp3-player-0 .dfp-countdown--hidden {\n    display: none; }\n";
styleInject(css_248z$1);

var templateHtml = "<div class=\"dfp-countdown__text\"><%= message %></div>\n<div class=\"dfp-countdown__time\"><%= remainingTime %></div>\n";

var DFPCountdown = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(DFPCountdown, _MediaControlPlugin);

  var _super = _createSuper(DFPCountdown);

  _createClass(DFPCountdown, [{
    key: "name",
    get: function get() {
      return 'dfp_countdown';
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml);
    }
  }, {
    key: "container",
    get: function get() {
      return this.core && this.core.activeContainer;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'dfp-countdown'
      };
    }
  }]);

  function DFPCountdown(core) {
    var _this;

    _classCallCheck(this, DFPCountdown);

    _this = _super.call(this, core);
    _this.core = core;
    _this.message = {
      '-1': 'Este anúncio encerra em',
      '0': 'O seu vídeo começa em',
      'midroll': 'O seu vídeo continua em'
    };
    return _this;
  }

  _createClass(DFPCountdown, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core.options.dfp, Events.DFP_AD_STARTED, this.adStarted);
      this.listenTo(this.core.options.dfp, Events.DFP_AD_COMPLETED, this.adEnded);
      this.listenTo(this.core.options.dfp, Events.DFP_AD_SKIPPED, this.adEnded);
      this.listenTo(this.core.options.dfp, Events.DFP_AD_ERROR, this.adEnded);
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.adEnded);
      this.mediaControl && this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_RENDERED, this.appendToMediaControl);
    }
  }, {
    key: "adStarted",
    value: function adStarted(ad) {
      if (!ad.isLinear()) return;
      this.playback = this.core.activePlayback;
      this.renderCountdown();
      this.listenTo(this.playback, Events$1.PLAYBACK_TIMEUPDATE, this.updateCountdown);
      this.$el.removeClass('dfp-countdown--hidden');
    }
  }, {
    key: "adEnded",
    value: function adEnded() {
      this.stopListening(this.playback, Events$1.PLAYBACK_TIMEUPDATE);
      this.$el.addClass('dfp-countdown--hidden');
    }
  }, {
    key: "renderCountdown",
    value: function renderCountdown() {
      var style = Styler.getStyleFrom(css_248z$1, {
        playerId: this.container.options.playerId
      });
      var remainingTime = typeof this.playback.getRemainingTime === 'function' ? this.playback.getRemainingTime() : 0;
      this.$el.html(this.template({
        message: this.message[this.core.options.dfp.podIndex] || this.message['midroll'],
        remainingTime: Utils.formatTime(remainingTime)
      }));
      this.$el.append(style[0]);
      this.$duration = this.$el.find('.dfp-countdown__time');
      this.$message = this.$el.find('.dfp-countdown__text');
      this.appendToMediaControl();
    }
  }, {
    key: "appendToMediaControl",
    value: function appendToMediaControl() {
      var countdownContainer = this.mediaControl.$el.find('.media-control-panel__lower .media-control-position__left');
      if (!countdownContainer[0] || this.isRendered) return;
      countdownContainer.append(this.el);
      this.isRendered = true;
    }
  }, {
    key: "updateCountdown",
    value: function updateCountdown() {
      var remainingTime = typeof this.playback.getRemainingTime === 'function' ? this.playback.getRemainingTime() : 0;
      this.$duration.text(Utils.formatTime(remainingTime));
      this.$message.text(this.message[this.core.options.dfp.podIndex] || this.message['midroll']);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();

      _get(_getPrototypeOf(DFPCountdown.prototype), "destroy", this).call(this);
    }
  }]);

  return DFPCountdown;
}(MediaControlPlugin);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

var lodash_isplainobject = isPlainObject;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = typeof iteratee == 'function' ? iteratee : identity;
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

var lodash_times = times;

/* global module */
const api = {
  _call: (method) => {
    if(window.dmp && window.dmp.api) {
      try {
        return window.dmp.api[method]();
      } catch (error) {
        console.error(`dmp-api@${method}: `, error.message);

        return null;
      }
    }

    return null;
  },

  getSegments: () => {
    const segments = api._call("getSegments");
    return segments ? segments : "";
  },

  getDmpId: () => {
    const dmpId = api._call("getDmpId");
    return dmpId ? dmpId : "";
  }
};

var src = api;

var LocalStorage = Utils$1.LocalStorage,
    embedScript = Utils$1.embedScript,
    DOM = Utils$1.DOM;
var Log = Log$1.getInstance(); // Accordly to https://support.google.com/admanager/answer/1181018?hl=pt-BR
// This list exclude 3gpp mime type following one Google recomendation (https://groups.google.com/forum/#!topic/ima-sdk/T9hcf7Wyj9E)

var IMA_SUPPORTED_MIME_TYPES = ['video/mp4', 'video/webm', 'video/x-msvideo', 'video/x-motion-jpeg', 'video/mpeg2', 'video/x-ms-wmv', 'application/x-mpegURL', 'application/vnd.apple.mpegurl', 'video/MP2T'];
var IMA_SDK_URL = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
var IMA_SCRIPT = new Promise(function (resolve, reject) {
  var loadScript = !Browser.isSmartTvEnvironment && (!window.google || !window.google.ima);
  loadScript ? embedScript(IMA_SDK_URL).then(resolve, reject) : resolve();
});

var DFP = /*#__PURE__*/function (_CorePlugin) {
  _inherits(DFP, _CorePlugin);

  var _super = _createSuper(DFP);

  _createClass(DFP, [{
    key: "name",
    get: function get() {
      return 'dfp';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": 'dfp'
      };
    }
  }, {
    key: "imaScript",
    get: function get() {
      return IMA_SCRIPT;
    }
  }, {
    key: "dfpAdTagTemplate",
    get: function get() {
      var url = "".concat(this.options.env.protocol, "://pubads.g.doubleclick.net/gampad/ads?sz=1280x720&iu=/<%= adAccountId %>/<%= adUnit %>&cmsid=<%= adCmsId %>&vid=<%= videoId %>&cust_params=<%= customParams %>&ciu_szs=940x360&impl=s&gdfp_req=1&env=vp&output=xml_vast3&unviewed_position_start=1&url=[referrer_url]&description_url=<%= descriptionUrl %>&correlator=[timestamp]");
      this.adCreativeProfile && (url += '&pp=<%= adCreativeProfile %>');
      return template(url);
    }
  }, {
    key: "sizes",
    get: function get() {
      return {
        playerWidth: this.core.el && this.core.el.offsetWidth,
        defaultWidth: 640,
        linearHeight: 400,
        nonLinearHeight: 150
      };
    }
  }, {
    key: "shouldSkipAd",
    get: function get() {
      var skipDFP = this.core.options.skipDFP;
      var hasAdBlock = !window.google || !window.google.ima;
      var hasOverlayElement = DOM.hasChildElement(this.core.el, '.dfp-ad-overlay');
      return skipDFP || hasAdBlock || !this.adUnit || !hasOverlayElement;
    }
  }], [{
    key: "DEFAULT_ACCOUNT_ID",
    get: function get() {
      return 95377733;
    }
  }, {
    key: "DEFAULT_CMS_ID",
    get: function get() {
      return 11413;
    }
  }, {
    key: "DEFAULT_DESCRIPTION_URL",
    get: function get() {
      return 'https://redeglobo.globo.com/';
    }
  }]);

  function DFP(core) {
    var _this;

    _classCallCheck(this, DFP);

    _this = _super.call(this, core);
    _this.isBootstrapReady = false;
    _this.isAllAdsCompleted = false;
    _this.isContainerEnded = false;
    _this.core.options.skipDFP && Log.info(_this.name, 'Ad Skipping is Enabled.');

    _this.attachCorePlugins();

    return _this;
  }

  _createClass(DFP, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
      this.listenTo(this.core, Events$1.CORE_OPTIONS_CHANGE, this.configure);
      this.listenTo(this.core, Events.DFP_DISABLE, this.disable);
      this.listenTo(this, Events.DFP_FINISHED, this.destroyIMA);
      this.listenTo(this.core, Events.TAP_TO_UNMUTE_CLICKED, this.onTapToUnmuteClicked);
    }
  }, {
    key: "onTapToUnmuteClicked",
    value: function onTapToUnmuteClicked() {
      if (!this.adsManager) return;
      /*
        It's necessary to make some action into adsManager to "retain" the user action.
        So, the player just update and restore the volume for consent purposes.
      */

      var currentVolume = this.adsManager.getVolume();
      this.adsManager.setVolume(1); // set volume to some value > 0

      this.adsManager.setVolume(currentVolume);
    }
  }, {
    key: "enable",
    value: function enable() {
      if (this.enabled) return;
      this.dfpAdOverlay && this.dfpAdOverlay.enable();
      this.dfpCountdown && this.dfpCountdown.enable();
      this.dfpVideoAd && this.dfpVideoAd.enable();
      this.adCompanion && this.adCompanion.enable();

      _get(_getPrototypeOf(DFP.prototype), "enable", this).call(this);

      this.bindContainerEvents();
    }
  }, {
    key: "disable",
    value: function disable() {
      if (!this.enabled) return;
      this.dfpAdOverlay && this.dfpAdOverlay.disable();
      this.dfpCountdown && this.dfpCountdown.disable();
      this.dfpVideoAd && this.dfpVideoAd.disable();
      this.adCompanion && this.adCompanion.disable();

      _get(_getPrototypeOf(DFP.prototype), "disable", this).call(this);

      this.listenToOnce(this.core, Events.DFP_ENABLE, this.enable);
    }
  }, {
    key: "attachCorePlugins",
    value: function attachCorePlugins() {
      this.watchedAds = this.core.options && this.core.options.watchedAds || 0;
      this.core._options = Object.assign(this.core.options, {
        dfp: this
      });
      this.dfpAdOverlay = new DFPAdOverlay(this.core);
      !Browser.isChromecast && (this.dfpCountdown = new DFPCountdown(this.core));
      this.core.$el.append(this.dfpAdOverlay.el);
      this.core.addPlugin(this.dfpAdOverlay);
    }
  }, {
    key: "attachContainerPlugins",
    value: function attachContainerPlugins() {
      if (this.container) {
        this.container._options = Object.assign(this.container.options, {
          dfp: this
        });
        this.dfpVideoAd = new DFPVideoAd(this.container);
        this.container.addPlugin(this.dfpVideoAd);
      }
    }
  }, {
    key: "configure",
    value: function configure() {
      this.watchedAds = this.core.options && this.core.options.watchedAds || 0;
      var options = this.core.getCurrentContainer().options;
      this.videoId = options && options.src || options.sources && options.sources[0];
      if (!(this.core.options.useStyledNonLinearAds === false)) this.core.options.useStyledNonLinearAds = true;

      if (this.container) {
        this.stopListening(this.container.playback, Events.WM_VIDEO_METADATA_LOADED);
        this.listenTo(this.container.playback, Events.WM_VIDEO_METADATA_LOADED, this.init);
      }
    }
  }, {
    key: "parseCustomData",
    value: function parseCustomData(data) {
      return lodash_isplainobject(data) ? Object.keys(data).reduce(function (result, key) {
        var value = data[key];
        var customData = "".concat(key, "=").concat(value);
        return result ? result += "&".concat(customData) : customData;
      }, '') : data;
    }
  }, {
    key: "init",
    value: function init(video) {
      var _this2 = this;

      var options = this.core.getCurrentContainer().options;
      this.adAccountId = options.adAccountId || video.adAccountId || DFP.DEFAULT_ACCOUNT_ID;
      this.adCmsId = options.adCmsId || video.adCmsId || DFP.DEFAULT_CMS_ID;
      this.descriptionUrl = video.urlForConsumption || DFP.DEFAULT_DESCRIPTION_URL;
      this.adCreativeProfile = options.adCreativeProfile;
      this.error = false;
      this.adUnit = options.adUnit || video.adUnit;
      if (!this.adUnit) return;
      this.adCustomData = this.getAdCustomData(options, video);
      this.setupCompanion();
      this.imaScript.then(function () {
        return _this2.bootstrapApi();
      }, function () {
        return _this2.onAdError({
          type: 'imaLoadError',
          message: 'google.ima not available'
        });
      });
    }
  }, {
    key: "getAdCustomData",
    value: function getAdCustomData(options, video) {
      var playlistCustomData = video.adCustomData;
      var optionsCustomData = this.parseCustomData(options.adCustomData);
      var adCustomData = '';

      if (options.adUnit) {
        adCustomData = optionsCustomData;
      } else {
        adCustomData = playlistCustomData && optionsCustomData ? "".concat(playlistCustomData, "&").concat(optionsCustomData) : playlistCustomData || optionsCustomData;
      }

      var kruxId = src.getDmpId();
      var kruxSegments = src.getSegments();
      var navegg = LocalStorage.loadRaw('nvgpersona13574', JSON.parse);
      var additionalCustomData = {};
      additionalCustomData.video_subscription = video.isSubscriberOnly || false;

      if (navegg) {
        additionalCustomData.nvg_gender = navegg.gender;
        additionalCustomData.nvg_age = navegg.age;
        additionalCustomData.nvg_income = navegg.income;
      }

      if (kruxId && kruxSegments) {
        additionalCustomData.ognCluster = kruxSegments;
        additionalCustomData.kuid = kruxId;
      }

      var hasAdditionalCustomData = Object.keys(additionalCustomData).length !== 0;
      if (!hasAdditionalCustomData) return adCustomData;
      return (adCustomData ? adCustomData + '&' : '') + this.parseCustomData(additionalCustomData);
    }
  }, {
    key: "triggerContentResume",
    value: function triggerContentResume() {
      this.trigger(Events.DFP_CONTENT_RESUME);
      this.container.trigger(Events.DFP_CONTENT_RESUME);
    }
  }, {
    key: "bootstrapApi",
    value: function bootstrapApi() {
      this.error = false;
      this.destroyIMA();
      if (this.shouldSkipAd) return;
      this.setupIMA();
      this.requestAd();
      this.isAllAdsCompleted = false;
      this.isBootstrapReady = true;
    }
  }, {
    key: "setupIMA",
    value: function setupIMA() {
      google.ima.settings.setLocale('pt-br');
      google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED);
      google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true);
      this.options.adPublisherProvidedID && google.ima.settings.setPpid(this.options.adPublisherProvidedID);

      if (!this.adDisplayContainer) {
        this.adDisplayContainer = new google.ima.AdDisplayContainer(this.dfpAdOverlay.el, this.dfpVideoAd.videoElement);
      }

      if (!this.adsLoader) {
        this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);
        this.adsLoader.getSettings().setDisableCustomPlaybackForIOS10Plus(true);
        this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), false);
        this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this), false);
      }

      if (!this.adsRenderingSettings) {
        this.adsRenderingSettings = new google.ima.AdsRenderingSettings(); // this.adsRenderingSettings.enablePreloading = true

        this.adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = !Browser.isChromecast;
        Browser.isChrome && Browser.isMobile && (this.adsRenderingSettings.mimeTypes = IMA_SUPPORTED_MIME_TYPES);
      }

      if (!this.adRequest) {
        var adSlotWidth = Math.min(this.sizes.defaultWidth, this.sizes.playerWidth);
        this.adsRequest = new google.ima.AdsRequest();
        this.adsRequest.linearAdSlotWidth = adSlotWidth;
        this.adsRequest.linearAdSlotHeight = this.sizes.linearHeight;
        this.adsRequest.nonLinearAdSlotWidth = adSlotWidth;
        this.adsRequest.nonLinearAdSlotHeight = this.sizes.nonLinearHeight;
      }
    }
  }, {
    key: "setupCompanion",
    value: function setupCompanion() {
      Object.assign({}, this.core.options, {
        adUnit: this.adUnit,
        adCustomData: this.adCustomData
      });
      this.adCompanion && this.adCompanion.stopListening();
      this.adCompanion = new DFPCompanion(this.core, this.adAccountId);
    }
  }, {
    key: "destroyIMA",
    value: function destroyIMA() {
      this.adsManager && this.adsManager.destroy();
      this.adsLoader && this.adsLoader.destroy();
      this.adsManager = null;
      this.adsLoader = null;
      this.isBootstrapReady = false;
    }
  }, {
    key: "destroyVideoAd",
    value: function destroyVideoAd() {
      if (!this.dfpVideoAd) return;
      this.dfpVideoAd.stopListening();
      this.dfpVideoAd.destroy();
      this.dfpVideoAd = null;
    }
  }, {
    key: "onAdError",
    value: function onAdError(errorEvent) {
      if (this.error) return;
      var errorData = errorEvent && this.getErrorData(errorEvent);
      Log.warn(this.name, 'dfp encountered an error, skipping -', errorData, errorEvent);
      this.error = true;
      this.trigger(Events.DFP_AD_ERROR, errorData);
      this.container.trigger(Events.DFP_AD_ERROR, errorData);
    }
  }, {
    key: "getErrorData",
    value: function getErrorData(errorEvent) {
      // Getting error data from IMA
      var error = typeof errorEvent.getError === 'function' ? errorEvent.getError() : errorEvent;
      if (!error) return {};
      var type = typeof error.getType === 'function' ? error.getType() : error.type || error.o || error;
      var message = error.message || error.l || error;
      return {
        type: type,
        message: message
      };
    }
  }, {
    key: "onAdsManagerLoaded",
    value: function onAdsManagerLoaded(loadedEvent) {
      var _this3 = this;

      this.adsRenderingSettings.useStyledNonLinearAds = this.core.options.useStyledNonLinearAds;
      this.adsManager = loadedEvent.getAdsManager(this.dfpVideoAd.videoElement, this.adsRenderingSettings);
      this.discardWatchedAds(this.watchedAds);
      this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function (errorEvent) {
        return _this3.onAdError(errorEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.LOG, function (adEvent) {
        return _this3.onAdLog(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.AD_METADATA, function (adEvent) {
        return _this3.onAdMetadata(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function (adEvent) {
        return _this3.onContentPauseRequested(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function (adEvent) {
        return _this3.onContentResumeRequested(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, function (adEvent) {
        return _this3.onAdStarted(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, function (adEvent) {
        return _this3.onAdResumed(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, function (adEvent) {
        return _this3.onAdPaused(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, function (adEvent) {
        return _this3.onAdSkipped(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, function (adEvent) {
        return _this3.onAdLoaded(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.USER_CLOSE, function (adEvent) {
        return _this3.onAdClosed(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, function (adEvent) {
        return _this3.onAdCompleted(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function (adEvent) {
        return _this3.onAllAdsCompleted(adEvent);
      });
      this.adsManager.addEventListener(google.ima.AdEvent.Type.CLICK, function (adEvent) {
        return _this3.onAdClicked(adEvent);
      });
      this.trigger(Events.DFP_MANAGER_LOADED);
      this.container.trigger(Events.DFP_MANAGER_LOADED);
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady() {
      this.isContainerEnded = false;

      if (this.shouldSkipAd) {
        this.triggerContentResume();
        return;
      }

      this.startAd();
    }
  }, {
    key: "startAd",
    value: function startAd() {
      if (!this.adsManager) {
        this.listenToOnce(this, Events.DFP_MANAGER_LOADED, this.startAd);
        return;
      }

      try {
        this.adsManager.init(this.dfpAdOverlay.$el.width(), this.dfpAdOverlay.$el.height(), google.ima.ViewMode.NORMAL);
        this.adsManager.start();
      } catch (adError) {
        this.onAdError({
          type: 'adError',
          message: adError && adError.message
        });
      }
    }
  }, {
    key: "discardWatchedAds",
    value: function discardWatchedAds(count) {
      var _this4 = this;

      lodash_times(count, function (i) {
        setTimeout(function () {
          return _this4.adsManager.discardAdBreak();
        }, 500 * i);
      });
    }
  }, {
    key: "onAdLog",
    value: function onAdLog(adEvent) {
      var adData = adEvent.getAdData() || {};
      var adError = adData.adError;
      var isEmptyAdError = adError.getErrorCode() === google.ima.AdError.ErrorCode.VAST_EMPTY_RESPONSE;
      if (!isEmptyAdError) return;
      this.onAdError(adError);
    }
  }, {
    key: "onAdClicked",
    value: function onAdClicked(adEvent) {
      var ad = adEvent.getAd();
      this.container.trigger(Events.DFP_AD_CLICKED, ad);
    }
  }, {
    key: "onAdMetadata",
    value: function onAdMetadata() {
      this.container.trigger(Events.DFP_AD_METADATA);
    }
  }, {
    key: "onAdLoaded",
    value: function onAdLoaded(adEvent) {
      this.error = false;
      var ad = adEvent.getAd();
      this.trigger(Events.DFP_AD_LOADED, ad);
      this.container.trigger(Events.DFP_AD_LOADED, ad);
    }
  }, {
    key: "onAdStarted",
    value: function onAdStarted(adEvent) {
      var ad = adEvent.getAd();
      this.watchedAds += 1;
      this.container.playback.trigger(Events$1.PLAYBACK_PLAY);
      this.trigger(Events.DFP_AD_STARTED, ad);
      this.container.trigger(Events.DFP_AD_STARTED, ad);
    }
  }, {
    key: "onAdResumed",
    value: function onAdResumed(adEvent) {
      var ad = adEvent.getAd();
      this.container.playback.trigger(Events$1.PLAYBACK_PLAY);
      this.container.trigger(Events.DFP_AD_RESUME, ad.isLinear());
    }
  }, {
    key: "onAdPaused",
    value: function onAdPaused(adEvent) {
      var ad = adEvent.getAd();
      this.container.playback.trigger(Events$1.PLAYBACK_PAUSE);
      this.container.trigger(Events.DFP_AD_PAUSE, ad.isLinear());
    }
  }, {
    key: "onAdClosed",
    value: function onAdClosed(adEvent) {
      var ad = adEvent.getAd();
      this.trigger(Events.DFP_AD_CLOSED, ad.isLinear());
      this.container.trigger(Events.DFP_AD_CLOSED, ad.isLinear());
    }
  }, {
    key: "onAdSkipped",
    value: function onAdSkipped(adEvent) {
      var ad = adEvent.getAd();
      this.trigger(Events.DFP_AD_SKIPPED, ad.isLinear());
      this.container.trigger(Events.DFP_AD_SKIPPED, ad.isLinear());
    }
  }, {
    key: "onAdCompleted",
    value: function onAdCompleted(adEvent) {
      var ad = adEvent.getAd();
      this.trigger(Events.DFP_AD_COMPLETED, ad.isLinear());
      this.container.trigger(Events.DFP_AD_COMPLETED, ad.isLinear());
    }
  }, {
    key: "onAllAdsCompleted",
    value: function onAllAdsCompleted(event) {
      this.isAllAdsCompleted = true;
      var ad = event.getAd();
      this.trigger(Events.DFP_ALL_ADS_COMPLETED, ad.isLinear());
      this.container.trigger(Events.DFP_ALL_ADS_COMPLETED, ad.isLinear());
      this.watchedAds = 0;
      this.triggerDfpFinished();
    }
  }, {
    key: "onContentPauseRequested",
    value: function onContentPauseRequested(adEvent) {
      var ad = adEvent.getAd();
      this.trigger(Events.DFP_CONTENT_PAUSE, ad);
      this.container.trigger(Events.DFP_CONTENT_PAUSE, ad);

      if (!this.core.getCurrentContainer()) {
        this.adsManager.stop();
      }
    }
  }, {
    key: "onContentResumeRequested",
    value: function onContentResumeRequested() {
      if (this.error) return;
      !this.dfpVideoAd.isServedAd && this.container.trigger(Events.DFP_AD_NOTSERVED);
      this.triggerContentResume();
    }
  }, {
    key: "containerChanged",
    value: function containerChanged() {
      this.destroyVideoAd();
      this.container = this.core.activeContainer;
      var playback = this.container.playback;

      if (!playback.options.onPip) {
        this.attachContainerPlugins();
        this.configure();
        this.bindContainerEvents();
        this.trigger(Events.DFP_CONTENT_ENDED);
        this.container.trigger(Events.DFP_CONTENT_ENDED);
      } else {
        this.listenToOnce(this.core.getCurrentContainer().playback, Events.WM_RESOURCE_READY, function () {
          return playback.play();
        });
      }

      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.onContainerEnded);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.onContainerEnded);
    }
  }, {
    key: "triggerDfpFinished",
    value: function triggerDfpFinished() {
      var isEnded = this.isContainerEnded && this.isAllAdsCompleted;
      var isEndedWithError = this.isContainerEnded && this.error;

      if (isEnded || isEndedWithError) {
        this.trigger(Events.DFP_FINISHED);
        this.container.trigger(Events.DFP_FINISHED);
      }
    }
  }, {
    key: "onContainerEnded",
    value: function onContainerEnded() {
      this.isContainerEnded = true;
      this.bindContainerEvents();
      this.triggerDfpFinished();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.listenToOnce(this.container.playback, Events.WM_PLAY_REQUESTED_READY, this.onUserGesture);
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
    }
  }, {
    key: "contentEnded",
    value: function contentEnded() {
      this.trigger(Events.DFP_CONTENT_ENDED);
      this.container.trigger(Events.DFP_CONTENT_ENDED);
      this.adsLoader && this.adsLoader.contentComplete();
    }
  }, {
    key: "contentStarted",
    value: function contentStarted() {
      this.trigger(Events.DFP_CONTENT_STARTED);
      this.container.trigger(Events.DFP_CONTENT_STARTED);
    }
  }, {
    key: "onUserGesture",
    value: function onUserGesture() {
      !this.isBootstrapReady && this.bootstrapApi();
      this.adDisplayContainer && this.adDisplayContainer.initialize();
    }
  }, {
    key: "requestAd",
    value: function requestAd() {
      // TODO: Remove this HUGE weird workaround for DFP settings that don't follow guidelines
      var adUnit = this.unescapeHtml(this.adUnit);
      var descriptionUrl = encodeURIComponent(this.descriptionUrl);
      var customParams = encodeURIComponent(this.unescapeHtml(this.adCustomData));
      var adParams = {
        adUnit: adUnit,
        adAccountId: this.adAccountId,
        adCmsId: this.adCmsId,
        videoId: this.videoId,
        descriptionUrl: descriptionUrl,
        customParams: customParams
      };
      this.adCreativeProfile && (adParams.adCreativeProfile = this.adCreativeProfile);
      this.adsRequest.adTagUrl = this.dfpAdTagTemplate(adParams);
      this.adsLoader && this.adsLoader.requestAds(this.adsRequest);
    } // TODO: Remove this HUGE weird workaround for DFP settings that don't follow guidelines

  }, {
    key: "unescapeHtml",
    value: function unescapeHtml(htmlString) {
      return $$1('<div/>').html(htmlString).text();
    }
  }]);

  return DFP;
}(CorePlugin);

var css_248z$2 = ".clappr-player#wp3-player-0 .dai-ad-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 448; }\n  .clappr-player#wp3-player-0 .dai-ad-container--hidden {\n    display: none; }\n";
styleInject(css_248z$2);

var embedScript$1 = Utils$1.embedScript;
var IMA_SDK_DAI_URL = '//imasdk.googleapis.com/js/sdkloader/ima3_dai.js';
var DAI_SCRIPT_PROMISE = new Promise(function (resolve, reject) {
  return embedScript$1(IMA_SDK_DAI_URL).then(resolve, reject);
});
Events$1.register('DAI_RESOURCE_LOADED');
Events$1.register('DAI_ERROR');
Events$1.register('DAI_AD_BREAK_STARTED');
Events$1.register('DAI_AD_BREAK_ENDED');
var ERRORS = {
  SCRIPT_NOT_AVAILABLE: 'script-not-available',
  NOT_LIVE_STREAMING: 'not-live-streaming',
  NOT_DAI_RESOURCE: 'not-dai-resource',
  PLAYBACK_NOT_SUPPORTED: 'playback-not-supported',
  DAI_ERROR: 'dai-error'
};
var SUPPORTED_PLAYBACKS = ['hls', 'html5'];

var DAI = /*#__PURE__*/function (_UIContainerPlugin) {
  _inherits(DAI, _UIContainerPlugin);

  var _super = _createSuper(DAI);

  _createClass(DAI, [{
    key: "name",
    get: function get() {
      return 'dai';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "innerPlayback",
    get: function get() {
      return this.playback && this.playback.playback;
    }
  }, {
    key: "videoElement",
    get: function get() {
      return this.playback.videoEl;
    }
  }, {
    key: "isPlaybackSupported",
    get: function get() {
      return SUPPORTED_PLAYBACKS.includes(this.playback.innerPlaybackName);
    }
  }, {
    key: "DAIScriptPromise",
    get: function get() {
      return DAI_SCRIPT_PROMISE;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": 'dai-ad-container dai-ad-container--hidden'
      };
    }
  }, {
    key: "adUiElement",
    get: function get() {
      return this.el;
    }
  }]);

  function DAI(container) {
    var _this;

    _classCallCheck(this, DAI);

    _this = _super.call(this, container);
    /*
      This informs the `resource` plugin to wait for the resource from DAI
    */

    _this.options.enableDAIResourceLoader = true;
    _this.onStreamEvent = _this.onStreamEvent.bind(_assertThisInitialized(_this));

    _this.render();

    return _this;
  }

  _createClass(DAI, [{
    key: "render",
    value: function render() {
      var styles = Styler.getStyleFrom(css_248z$2, {
        playerId: this.options.playerId
      });
      this.el.appendChild(styles[0]);
      this.container.el.appendChild(this.el);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
      this.listenToOnce(this.playback, Events.FALLBACK_SOURCE_SELECTED, this.onFallbackSourceSelected);
      this.listenToOnce(this.playback, Events$1.PLAYBACK_READY, this.onPlaybackReady);
      this.listenToOnce(this.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      if (!video.isLive) return this.onError({
        errorCode: ERRORS.NOT_LIVE_STREAMING
      });
    }
  }, {
    key: "onFallbackSourceSelected",
    value: function onFallbackSourceSelected() {
      if (this.resource && !this.resource.shouldPlayWithDAI) {
        this.resetStreamManager();
      }
    }
  }, {
    key: "onPlaybackReady",
    value: function onPlaybackReady() {
      if (!this.isPlaybackSupported) return this.onError({
        errorCode: ERRORS.PLAYBACK_NOT_SUPPORTED
      });

      switch (this.playback.innerPlaybackName) {
        case 'hls':
          this.listenTo(this.innerPlayback, Events$1.Custom.PLAYBACK_FRAGMENT_PARSING_METADATA, this.onHLSFragParsingMetadata);
          break;

        case 'html5':
          this.listenTo(this.innerPlayback, Events$1.Custom.PLAYBACK_METADATA_TRACK_CUE_CHANGE, this.onHTML5MetadataCueChance);
          break;
      }
    }
  }, {
    key: "onHTML5MetadataCueChance",
    value: function onHTML5MetadataCueChance(metadata) {
      if (!this.streamManager || !metadata) return;
      this.streamManager.onTimedMetadata(metadata);
    }
  }, {
    key: "onHLSFragParsingMetadata",
    value: function onHLSFragParsingMetadata() {
      var _this2 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          data = _ref.data;

      if (!this.streamManager || !data) return; // For each ID3 tag in the metadata, pass in the type - ID3, the
      // tag data (a byte array), and the presentation timestamp (PTS).

      data.samples.forEach(function (sample) {
        return _this2.streamManager.processMetadata('ID3', sample.data, sample.pts);
      });
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady() {
      var _this3 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          resource = _ref2.selectedResource;

      if (!resource.dai) return this.onError({
        errorCode: ERRORS.NOT_DAI_RESOURCE
      });
      this.resource = resource;
      this.DAIScriptPromise.then(function () {
        return _this3.onDAIScriptLoaded();
      }, function () {
        return _this3.onError({
          errorCode: ERRORS.SCRIPT_NOT_AVAILABLE
        });
      });
    }
  }, {
    key: "onDAIScriptLoaded",
    value: function onDAIScriptLoaded() {
      // TODO: set a timeout to trigger an error after calling initStreamManager?
      this.initStreamManager();
    }
  }, {
    key: "initStreamManager",
    value: function initStreamManager() {
      this.streamManager = new google.ima.dai.api.StreamManager(this.videoElement, this.adUiElement);
      this.streamManager.addEventListener([google.ima.dai.api.StreamEvent.Type.LOADED, google.ima.dai.api.StreamEvent.Type.ERROR, google.ima.dai.api.StreamEvent.Type.AD_PERIOD_STARTED, google.ima.dai.api.StreamEvent.Type.AD_PERIOD_ENDED, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED], this.onStreamEvent, false);
      this.requestLiveStream(this.resource.assetKey);
    }
  }, {
    key: "getAdTagParameters",
    value: function getAdTagParameters() {
      var _this$options = this.options,
          daiCustomData = _this$options.daiCustomData,
          adPublisherProvidedID = _this$options.adPublisherProvidedID;
      if (!daiCustomData && !adPublisherProvidedID) return;
      var adTagParameters = {};
      if (daiCustomData) adTagParameters.cust_params = this.parseCustomData(daiCustomData);
      if (adPublisherProvidedID) adTagParameters.ppid = adPublisherProvidedID;
      return adTagParameters;
    }
  }, {
    key: "requestLiveStream",
    value: function requestLiveStream(assetKey) {
      this.streamRequest = new google.ima.dai.api.LiveStreamRequest();
      this.streamRequest.assetKey = assetKey;
      var adTagParameters = this.getAdTagParameters();
      if (adTagParameters) this.streamRequest.adTagParameters = adTagParameters;
      this.streamManager.requestStream(this.streamRequest);
    }
  }, {
    key: "onStreamEvent",
    value: function onStreamEvent(e) {
      switch (e.type) {
        case google.ima.dai.api.StreamEvent.Type.LOADED:
          this.onDaiLoaded(e);
          break;

        case google.ima.dai.api.StreamEvent.Type.ERROR:
          this.onDaiError(e);
          break;

        case google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED:
          this.onAdBreakStarted(e);
          break;

        case google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED:
          this.onAdBreakEnded(e);
          break;

        default:
          this.onDaiEvent(e);
          break;
      }
    }
  }, {
    key: "onDaiLoaded",
    value: function onDaiLoaded(event) {
      var _event$getStreamData = event.getStreamData(),
          streamId = _event$getStreamData.streamId,
          url = _event$getStreamData.url;

      this.streamId = streamId;
      Log$1.info(this.name, "DAI loaded, streamId: ".concat(streamId));
      this.onDAIResourceLoaded(url);
    }
  }, {
    key: "onAdBreakStarted",
    value: function onAdBreakStarted() {
      this.el.classList.remove('dai-ad-container--hidden');
      this.container.trigger(Events$1.Custom.DAI_AD_BREAK_STARTED);
    }
  }, {
    key: "onAdBreakEnded",
    value: function onAdBreakEnded() {
      this.el.classList.add('dai-ad-container--hidden');
      this.container.trigger(Events$1.Custom.DAI_AD_BREAK_ENDED);
    }
  }, {
    key: "onDaiError",
    value: function onDaiError(event) {
      var _event$getStreamData2 = event.getStreamData(),
          errorMessage = _event$getStreamData2.errorMessage;

      Log$1.warn(this.name, 'DAI Error. Error Message: ', errorMessage);
      this.onError({
        errorCode: ERRORS.DAI_ERROR,
        errorMessage: errorMessage,
        event: event,
        notifiable: true
      });
    }
  }, {
    key: "onDaiEvent",
    value: function onDaiEvent(event) {
      var type = event.type;

      try {
        var streamData = event.getStreamData();
        var ad = event.getAd();
        Log$1.info(this.name, "DAI event type: ".concat(type, ", data: "), {
          streamData: streamData,
          ad: ad
        });
      } catch (error) {
        Log$1.warn(this.name, "Error getting DAI event data. DAI event type: ".concat(type, ". Error: "), error);
      }
    }
  }, {
    key: "onDAIResourceLoaded",
    value: function onDAIResourceLoaded(url) {
      this.container.trigger(Events$1.Custom.DAI_RESOURCE_LOADED, {
        url: url,
        streamId: this.streamId
      });
    }
  }, {
    key: "parseCustomData",
    value: function parseCustomData(data) {
      return Object.keys(data).reduce(function (result, key) {
        var encondedValue = encodeURIComponent(data[key]);
        var customData = "".concat(key, "=").concat(encondedValue);
        return result ? result += "&".concat(customData) : customData;
      }, '');
    }
  }, {
    key: "onError",
    value: function onError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options.enableDAIResourceLoader = false;
      this.container.trigger(Events$1.Custom.DAI_ERROR, error);
      this.resetStreamManager();
      this.stopListening();
    }
  }, {
    key: "resetStreamManager",
    value: function resetStreamManager() {
      this.streamManager && this.streamManager.reset();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.resetStreamManager();

      _get(_getPrototypeOf(DAI.prototype), "destroy", this).call(this);
    }
  }]);

  return DAI;
}(UIContainerPlugin);

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

var ClickToPausePlugin = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits$1(ClickToPausePlugin, _ContainerPlugin);

  var _super = _createSuper$1(ClickToPausePlugin);

  function ClickToPausePlugin(container) {
    _classCallCheck$1(this, ClickToPausePlugin);

    return _super.call(this, container);
  }

  _createClass$1(ClickToPausePlugin, [{
    key: "name",
    get: function get() {
      return 'click_to_pause';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.20"
      };
    }
  }, {
    key: "config",
    get: function get() {
      return this.container.options.clickToPauseConfig || {};
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.container, Events$1.CONTAINER_CLICK, this.click);
      this.listenTo(this.container, Events$1.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
    }
  }, {
    key: "click",
    value: function click() {
      var onClickPayload = this.config.onClickPayload;

      if (this.container.getPlaybackType() !== Playback.LIVE || this.container.isDvrEnabled()) {
        if (this.container.isPlaying()) this.container.pause(onClickPayload);else this.container.play(onClickPayload);
      }
    }
  }, {
    key: "settingsUpdate",
    value: function settingsUpdate() {
      var pointerEnabled = this.container.getPlaybackType() !== Playback.LIVE || this.container.isDvrEnabled();
      if (pointerEnabled === this.pointerEnabled) return;
      var method = pointerEnabled ? 'addClass' : 'removeClass';
      this.container.$el[method]('pointer-enabled');
      this.pointerEnabled = pointerEnabled;
    }
  }]);

  return ClickToPausePlugin;
}(ContainerPlugin);

var oldIcon = $$1('link[rel="shortcut icon"]');

/* eslint-disable */
// Kibo is released under the MIT License. Copyright (c) 2013 marquete.
// see https://github.com/marquete/kibo
var Kibo = function Kibo(element) {
  this.element = element || window.document;
  this.initialize();
};

Kibo.KEY_NAMES_BY_CODE = {
  8: 'backspace',
  9: 'tab',
  13: 'enter',
  16: 'shift',
  17: 'ctrl',
  18: 'alt',
  20: 'caps_lock',
  27: 'esc',
  32: 'space',
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
  48: '0',
  49: '1',
  50: '2',
  51: '3',
  52: '4',
  53: '5',
  54: '6',
  55: '7',
  56: '8',
  57: '9',
  65: 'a',
  66: 'b',
  67: 'c',
  68: 'd',
  69: 'e',
  70: 'f',
  71: 'g',
  72: 'h',
  73: 'i',
  74: 'j',
  75: 'k',
  76: 'l',
  77: 'm',
  78: 'n',
  79: 'o',
  80: 'p',
  81: 'q',
  82: 'r',
  83: 's',
  84: 't',
  85: 'u',
  86: 'v',
  87: 'w',
  88: 'x',
  89: 'y',
  90: 'z',
  112: 'f1',
  113: 'f2',
  114: 'f3',
  115: 'f4',
  116: 'f5',
  117: 'f6',
  118: 'f7',
  119: 'f8',
  120: 'f9',
  121: 'f10',
  122: 'f11',
  123: 'f12'
};
Kibo.KEY_CODES_BY_NAME = {};

(function () {
  for (var key in Kibo.KEY_NAMES_BY_CODE) {
    if (Object.prototype.hasOwnProperty.call(Kibo.KEY_NAMES_BY_CODE, key)) {
      Kibo.KEY_CODES_BY_NAME[Kibo.KEY_NAMES_BY_CODE[key]] = +key;
    }
  }
})();

Kibo.MODIFIERS = ['shift', 'ctrl', 'alt'];

Kibo.registerEvent = function () {
  if (document.addEventListener) {
    return function (element, eventName, func) {
      element.addEventListener(eventName, func, false);
    };
  } else if (document.attachEvent) {
    return function (element, eventName, func) {
      element.attachEvent('on' + eventName, func);
    };
  }
}();

Kibo.unregisterEvent = function () {
  if (document.removeEventListener) {
    return function (element, eventName, func) {
      element.removeEventListener(eventName, func, false);
    };
  } else if (document.detachEvent) {
    return function (element, eventName, func) {
      element.detachEvent('on' + eventName, func);
    };
  }
}();

Kibo.stringContains = function (string, substring) {
  return string.indexOf(substring) !== -1;
};

Kibo.neatString = function (string) {
  return string.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
};

Kibo.capitalize = function (string) {
  return string.toLowerCase().replace(/^./, function (match) {
    return match.toUpperCase();
  });
};

Kibo.isString = function (what) {
  return Kibo.stringContains(Object.prototype.toString.call(what), 'String');
};

Kibo.arrayIncludes = function () {
  if (Array.prototype.indexOf) {
    return function (haystack, needle) {
      return haystack.indexOf(needle) !== -1;
    };
  } else {
    return function (haystack, needle) {
      for (var i = 0; i < haystack.length; i++) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    };
  }
}();

Kibo.extractModifiers = function (keyCombination) {
  var modifiers, i;
  modifiers = [];

  for (i = 0; i < Kibo.MODIFIERS.length; i++) {
    if (Kibo.stringContains(keyCombination, Kibo.MODIFIERS[i])) {
      modifiers.push(Kibo.MODIFIERS[i]);
    }
  }

  return modifiers;
};

Kibo.extractKey = function (keyCombination) {
  var keys, i;
  keys = Kibo.neatString(keyCombination).split(' ');

  for (i = 0; i < keys.length; i++) {
    if (!Kibo.arrayIncludes(Kibo.MODIFIERS, keys[i])) {
      return keys[i];
    }
  }
};

Kibo.modifiersAndKey = function (keyCombination) {
  var result, key;

  if (Kibo.stringContains(keyCombination, 'any')) {
    return Kibo.neatString(keyCombination).split(' ').slice(0, 2).join(' ');
  }

  result = Kibo.extractModifiers(keyCombination);
  key = Kibo.extractKey(keyCombination);

  if (key && !Kibo.arrayIncludes(Kibo.MODIFIERS, key)) {
    result.push(key);
  }

  return result.join(' ');
};

Kibo.keyName = function (keyCode) {
  return Kibo.KEY_NAMES_BY_CODE[keyCode + ''];
};

Kibo.keyCode = function (keyName) {
  return +Kibo.KEY_CODES_BY_NAME[keyName];
};

Kibo.prototype.initialize = function () {
  var i,
      that = this;
  this.lastKeyCode = -1;
  this.lastModifiers = {};

  for (i = 0; i < Kibo.MODIFIERS.length; i++) {
    this.lastModifiers[Kibo.MODIFIERS[i]] = false;
  }

  this.keysDown = {
    any: []
  };
  this.keysUp = {
    any: []
  };
  this.downHandler = this.handler('down');
  this.upHandler = this.handler('up');
  Kibo.registerEvent(this.element, 'keydown', this.downHandler);
  Kibo.registerEvent(this.element, 'keyup', this.upHandler);
  Kibo.registerEvent(window, 'unload', function unloader() {
    Kibo.unregisterEvent(that.element, 'keydown', that.downHandler);
    Kibo.unregisterEvent(that.element, 'keyup', that.upHandler);
    Kibo.unregisterEvent(window, 'unload', unloader);
  });
};

Kibo.prototype.handler = function (upOrDown) {
  var that = this;
  return function (e) {
    var i, registeredKeys, lastModifiersAndKey;
    e = e || window.event;
    that.lastKeyCode = e.keyCode;

    for (i = 0; i < Kibo.MODIFIERS.length; i++) {
      that.lastModifiers[Kibo.MODIFIERS[i]] = e[Kibo.MODIFIERS[i] + 'Key'];
    }

    if (Kibo.arrayIncludes(Kibo.MODIFIERS, Kibo.keyName(that.lastKeyCode))) {
      that.lastModifiers[Kibo.keyName(that.lastKeyCode)] = true;
    }

    registeredKeys = that['keys' + Kibo.capitalize(upOrDown)];

    for (i = 0; i < registeredKeys.any.length; i++) {
      if (registeredKeys.any[i](e) === false && e.preventDefault) {
        e.preventDefault();
      }
    }

    lastModifiersAndKey = that.lastModifiersAndKey();

    if (registeredKeys[lastModifiersAndKey]) {
      for (i = 0; i < registeredKeys[lastModifiersAndKey].length; i++) {
        if (registeredKeys[lastModifiersAndKey][i](e) === false && e.preventDefault) {
          e.preventDefault();
        }
      }
    }
  };
};

Kibo.prototype.registerKeys = function (upOrDown, newKeys, func) {
  var i,
      keys,
      registeredKeys = this['keys' + Kibo.capitalize(upOrDown)];

  if (Kibo.isString(newKeys)) {
    newKeys = [newKeys];
  }

  for (i = 0; i < newKeys.length; i++) {
    keys = newKeys[i];
    keys = Kibo.modifiersAndKey(keys + '');

    if (registeredKeys[keys]) {
      registeredKeys[keys].push(func);
    } else {
      registeredKeys[keys] = [func];
    }
  }

  return this;
}; // jshint maxdepth:5


Kibo.prototype.unregisterKeys = function (upOrDown, newKeys, func) {
  var i,
      j,
      keys,
      registeredKeys = this['keys' + Kibo.capitalize(upOrDown)];

  if (Kibo.isString(newKeys)) {
    newKeys = [newKeys];
  }

  for (i = 0; i < newKeys.length; i++) {
    keys = newKeys[i];
    keys = Kibo.modifiersAndKey(keys + '');

    if (func === null) {
      delete registeredKeys[keys];
    } else {
      if (registeredKeys[keys]) {
        for (j = 0; j < registeredKeys[keys].length; j++) {
          if (String(registeredKeys[keys][j]) === String(func)) {
            registeredKeys[keys].splice(j, 1);
            break;
          }
        }
      }
    }
  }

  return this;
};

Kibo.prototype.off = function (keys) {
  return this.unregisterKeys('down', keys, null);
};

Kibo.prototype.delegate = function (upOrDown, keys, func) {
  return func !== null || func !== undefined ? this.registerKeys(upOrDown, keys, func) : this.unregisterKeys(upOrDown, keys, func);
};

Kibo.prototype.down = function (keys, func) {
  return this.delegate('down', keys, func);
};

Kibo.prototype.up = function (keys, func) {
  return this.delegate('up', keys, func);
};

Kibo.prototype.lastKey = function (modifier) {
  if (!modifier) {
    return Kibo.keyName(this.lastKeyCode);
  }

  return this.lastModifiers[modifier];
};

Kibo.prototype.lastModifiersAndKey = function () {
  var result, i;
  result = [];

  for (i = 0; i < Kibo.MODIFIERS.length; i++) {
    if (this.lastKey(Kibo.MODIFIERS[i])) {
      result.push(Kibo.MODIFIERS[i]);
    }
  }

  if (!Kibo.arrayIncludes(result, this.lastKey())) {
    result.push(this.lastKey());
  }

  return result.join(' ');
};

var index = {
  Kibo: Kibo
};

var Config = Utils.Config,
    Fullscreen = Utils.Fullscreen,
    formatTime$1 = Utils.formatTime,
    extend = Utils.extend,
    removeArrayItem = Utils.removeArrayItem;

var seekTimeHTML = "<span data-seek-time></span>\n<span data-duration></span>\n";

var css_248z$2$1 = ".seek-time[data-seek-time] {\n  position: absolute;\n  white-space: nowrap;\n  height: 20px;\n  line-height: 20px;\n  font-size: 0;\n  left: -100%;\n  bottom: 55px;\n  background-color: rgba(2, 2, 2, 0.5);\n  z-index: 9999;\n  transition: opacity 0.1s ease; }\n  .seek-time[data-seek-time].hidden[data-seek-time] {\n    opacity: 0; }\n  .seek-time[data-seek-time] [data-seek-time] {\n    display: inline-block;\n    color: white;\n    font-size: 10px;\n    padding-left: 7px;\n    padding-right: 7px;\n    vertical-align: top; }\n  .seek-time[data-seek-time] [data-duration] {\n    display: inline-block;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 10px;\n    padding-right: 7px;\n    vertical-align: top; }\n    .seek-time[data-seek-time] [data-duration]:before {\n      content: \"|\";\n      margin-right: 7px; }\n";

var formatTime = Utils.formatTime;

var SeekTime = /*#__PURE__*/function (_UICorePlugin) {
  _inherits$1(SeekTime, _UICorePlugin);

  var _super = _createSuper$1(SeekTime);

  function SeekTime(core) {
    var _this;

    _classCallCheck$1(this, SeekTime);

    _this = _super.call(this, core);
    _this.hoveringOverSeekBar = false;
    _this.hoverPosition = null;
    _this.duration = null;
    _this.firstFragDateTime = null;
    _this.actualLiveTime = !!_this.mediaControl.options.actualLiveTime;

    if (_this.actualLiveTime) {
      if (_this.mediaControl.options.actualLiveServerTime) _this.actualLiveServerTimeDiff = new Date().getTime() - new Date(_this.mediaControl.options.actualLiveServerTime).getTime();else _this.actualLiveServerTimeDiff = 0;
    }

    return _this;
  }

  _createClass$1(SeekTime, [{
    key: "name",
    get: function get() {
      return 'seek_time';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.20"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(seekTimeHTML);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'seek-time',
        'data-seek-time': ''
      };
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this.core.mediaControl;
    }
  }, {
    key: "mediaControlContainer",
    get: function get() {
      return this.mediaControl.container;
    }
  }, {
    key: "isLiveStreamWithDvr",
    get: function get() {
      return this.mediaControlContainer && this.mediaControlContainer.getPlaybackType() === Playback.LIVE && this.mediaControlContainer.isDvrEnabled();
    }
  }, {
    key: "durationShown",
    get: function get() {
      return this.isLiveStreamWithDvr && !this.actualLiveTime;
    }
  }, {
    key: "useActualLiveTime",
    get: function get() {
      return this.actualLiveTime && this.isLiveStreamWithDvr;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_RENDERED, this.render);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.showTime);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.hideTime);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_CONTAINERCHANGED, this.onContainerChanged);

      if (this.mediaControlContainer) {
        this.listenTo(this.mediaControlContainer, Events$1.CONTAINER_PLAYBACKDVRSTATECHANGED, this.update);
        this.listenTo(this.mediaControlContainer, Events$1.CONTAINER_TIMEUPDATE, this.updateDuration);
      }
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.stopListening();
      this.bindEvents();
    }
  }, {
    key: "updateDuration",
    value: function updateDuration(timeProgress) {
      this.duration = timeProgress.total;
      this.firstFragDateTime = timeProgress.firstFragDateTime;
      this.update();
    }
  }, {
    key: "showTime",
    value: function showTime(event) {
      this.hoveringOverSeekBar = true;
      this.calculateHoverPosition(event);
      this.update();
    }
  }, {
    key: "hideTime",
    value: function hideTime() {
      this.hoveringOverSeekBar = false;
      this.update();
    }
  }, {
    key: "calculateHoverPosition",
    value: function calculateHoverPosition(event) {
      var offset = event.pageX - this.mediaControl.$seekBarContainer.offset().left; // proportion into the seek bar that the mouse is hovered over 0-1

      this.hoverPosition = Math.min(1, Math.max(offset / this.mediaControl.$seekBarContainer.width(), 0));
    }
  }, {
    key: "getSeekTime",
    value: function getSeekTime() {
      var seekTime, secondsSinceMidnight, d, e;

      if (this.useActualLiveTime) {
        if (this.firstFragDateTime) {
          e = new Date(this.firstFragDateTime);
          d = new Date(this.firstFragDateTime);
          d.setHours(0, 0, 0, 0);
          secondsSinceMidnight = (e.getTime() - d.getTime()) / 1000 + this.duration;
        } else {
          d = new Date(new Date().getTime() - this.actualLiveServerTimeDiff);
          e = new Date(d);
          secondsSinceMidnight = (e - d.setHours(0, 0, 0, 0)) / 1000;
        }

        seekTime = secondsSinceMidnight - this.duration + this.hoverPosition * this.duration;
        if (seekTime < 0) seekTime += 86400;
      } else {
        seekTime = this.hoverPosition * this.duration;
      }

      return {
        seekTime: seekTime,
        secondsSinceMidnight: secondsSinceMidnight
      };
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.rendered) {
        // update() is always called after a render
        return;
      }

      if (!this.shouldBeVisible()) {
        this.$el.hide();
        this.$el.css('left', '-100%');
      } else {
        var seekTime = this.getSeekTime();
        var currentSeekTime = formatTime(seekTime.seekTime, this.useActualLiveTime); // only update dom if necessary, ie time actually changed

        if (currentSeekTime !== this.displayedSeekTime) {
          this.$seekTimeEl.text(currentSeekTime);
          this.displayedSeekTime = currentSeekTime;
        }

        if (this.durationShown) {
          this.$durationEl.show();
          var currentDuration = formatTime(this.actualLiveTime ? seekTime.secondsSinceMidnight : this.duration, this.actualLiveTime);

          if (currentDuration !== this.displayedDuration) {
            this.$durationEl.text(currentDuration);
            this.displayedDuration = currentDuration;
          }
        } else {
          this.$durationEl.hide();
        } // the element must be unhidden before its width is requested, otherwise it's width will be reported as 0


        this.$el.show();
        var containerWidth = this.mediaControl.$seekBarContainer.width();
        var elWidth = this.$el.width();
        var elLeftPos = this.hoverPosition * containerWidth;
        elLeftPos -= elWidth / 2;
        elLeftPos = Math.max(0, Math.min(elLeftPos, containerWidth - elWidth));
        this.$el.css('left', elLeftPos);
      }
    }
  }, {
    key: "shouldBeVisible",
    value: function shouldBeVisible() {
      return this.mediaControlContainer && this.mediaControlContainer.settings.seekEnabled && this.hoveringOverSeekBar && this.hoverPosition !== null && this.duration !== null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler$1.getStyleFor(css_248z$2$1, {
        baseUrl: this.options.baseUrl
      });
      this.rendered = true;
      this.displayedDuration = null;
      this.displayedSeekTime = null;
      this.$el.html(this.template());
      this.$el.append(style[0]);
      this.$el.hide();
      this.mediaControl.$el.append(this.el);
      this.$seekTimeEl = this.$el.find('[data-seek-time]');
      this.$durationEl = this.$el.find('[data-duration]');
      this.$durationEl.hide();
      this.update();
    }
  }]);

  return SeekTime;
}(UICorePlugin);

var mediaControlHTML = "<div class=\"media-control-panel\">\n  <div class=\"media-control-panel__back-layer\">\n    <div class=\"media-control-position__left\"></div>\n    <div class=\"media-control-position__center\"></div>\n    <div class=\"media-control-position__right\"></div>\n  </div>\n  <div class=\"media-control-panel__upper\">\n    <div class=\"opposites-container\">\n      <div class=\"media-control-position__left\"></div>\n      <div class=\"media-control-position__right\"></div>\n    </div>\n    <div class=\"media-control-position__center\"></div>\n  </div>\n  <div class=\"media-control-panel__middle\">\n    <div class=\"media-control-position__left\"></div>\n    <div class=\"media-control-position__center\"></div>\n    <div class=\"media-control-position__right\"></div>\n  </div>\n  <div class=\"media-control-panel__between\">\n    <div class=\"media-control-position__left\"></div>\n    <div class=\"media-control-position__center\"></div>\n    <div class=\"media-control-position__right\"></div>\n  </div>\n  <div class=\"media-control-panel__lower\" data-controls>\n    <div class=\"media-control-position__center\"></div>\n    <div class=\"opposites-container\">\n      <div class=\"media-control-position__left\"></div>\n      <div class=\"media-control-position__between\"></div>\n      <div class=\"media-control-position__right\"></div>\n    </div>\n  </div>\n  <div class=\"media-control-panel__front-layer\">\n    <div class=\"media-control-position__left\"></div>\n    <div class=\"media-control-position__center\"></div>\n    <div class=\"media-control-position__right\"></div>\n  </div>\n  <div class=\"media-control-panel__modal\"></div>\n</div>\n";

var getHostname = Utils$1.getHostname,
    applySizeClass = Utils$1.applySizeClass;
var defaultPadding = 4.0;
var PlayerSettings = window.WM && window.WM.Settings || {};
var Kibo$1 = index.Kibo;
var DOUBLE_TAP_TIMEOUT_VALUE = 250;

var GloboMediaControl = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(GloboMediaControl, _UICorePlugin);

  var _super = _createSuper(GloboMediaControl);

  _createClass(GloboMediaControl, [{
    key: "getTapSide",
    value: function getTapSide(horizontalClickPositionOnPage) {
      var mediaControlWidth = this.$el.width();
      var mediaControlOffset = this.$el.offset();
      var horizontalClickPositionOnPlayer = horizontalClickPositionOnPage - mediaControlOffset.left;
      return horizontalClickPositionOnPlayer < mediaControlWidth / 2 ? 'left' : 'right';
    }
  }, {
    key: "onTap",
    value: function onTap(event) {
      this.resetDoubleTapTimeout();
      var isDoubleTap = this.checkDoubleTap(event);
      isDoubleTap ? this.onDoubleTap(event) : this.waitForDoubleTap();
    }
  }, {
    key: "waitForDoubleTap",
    value: function waitForDoubleTap() {
      var _this2 = this;

      this.doubleTapWaitingTimeout = setTimeout(function () {
        _this2.onSingleTap();
      }, DOUBLE_TAP_TIMEOUT_VALUE);
    }
  }, {
    key: "onSingleTap",
    value: function onSingleTap() {
      this.toggleMediaControl();
    }
  }, {
    key: "onDoubleTap",
    value: function onDoubleTap(event) {
      var tapSide = this.getTapSide(event.pageX);
      event.preventDefault();
      this.core.trigger(Events.MEDIACONTROL_DOUBLE_TAP, {
        event: event,
        tapSide: tapSide
      });
    }
  }, {
    key: "checkDoubleTap",
    value: function checkDoubleTap(event) {
      var tapPositionSide = this.getTapSide(event.pageX);
      var currentTime = new Date().getTime();
      var tapInterval = currentTime - this.lastTapTime;
      var isDoubleTap = tapInterval < DOUBLE_TAP_TIMEOUT_VALUE && tapInterval > 0 && this.lastTapPosition === tapPositionSide;
      this.lastTapTime = currentTime;
      this.lastTapPosition = tapPositionSide;
      return isDoubleTap;
    }
  }, {
    key: "resetDoubleTapTimeout",
    value: function resetDoubleTapTimeout() {
      this.doubleTapWaitingTimeout && clearTimeout(this.doubleTapWaitingTimeout);
      this.doubleTapWaitingTimeout = null;
    }
  }, {
    key: "toggleMediaControl",
    value: function toggleMediaControl() {
      this.isVisible() ? this.hideDelayed(0, true) : this.show();
    }
  }, {
    key: "getPanel",
    value: function getPanel(panel) {
      return this.$el.find(".media-control-panel__".concat(panel));
    }
  }, {
    key: "name",
    get: function get() {
      return 'globo_media_control';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.userDisabled || this.container && this.container.getPlaybackType() === Playback.NO_OP;
    }
  }, {
    key: "hasPlaceholder",
    get: function get() {
      return this._hasPlaceholder;
    },
    set: function set(hasPlaceholder) {
      this._hasPlaceholder = hasPlaceholder;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': "media-control".concat(Browser.isMobile ? ' mobile' : '').concat(Browser.supportsTouchEvents ? ' touch' : '')
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return '';
    }
  }, {
    key: "events",
    get: function get() {
      var mobileEvents = {
        'click': 'onTap'
      };
      var desktopEvents = {
        'mouseenter [data-controls]': 'setUserKeepVisible',
        'mouseleave [data-controls]': 'resetUserKeepVisible'
      };

      var hybridEvents = _objectSpread2(_objectSpread2(_objectSpread2({}, mobileEvents), desktopEvents), {}, {
        touchend: this.resetUserKeepVisible
      });

      return Browser.isHybridDevice ? hybridEvents : Browser.isMobile ? mobileEvents : desktopEvents;
    }
  }, {
    key: "template",
    get: function get() {
      return template(mediaControlHTML);
    }
  }]);

  function GloboMediaControl(core) {
    var _this;

    _classCallCheck(this, GloboMediaControl);

    _this = _super.call(this, core);
    _this.core._mediaControl = _assertThisInitialized(_this);
    _this.keepVisible = false;
    _this.userDisabled = false;
    _this.userKeepVisible = false;
    _this.isRendered = false;
    _this.focusElement = _this.core.el;
    _this.lastChromelessValue = !!_this.options.chromeless;
    _this.lastChromelessValue && _this.updateChromelessState();
    _this.kibo = new Kibo$1(_this.focusElement);
    return _this;
  }

  _createClass(GloboMediaControl, [{
    key: "getExternalInterface",
    value: function getExternalInterface() {
      return {
        showMediaControlPanel: this.showPanel,
        hideMediaControlPanel: this.hidePanel
      };
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this3 = this;

      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onActiveContainerChanged);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.playerResize);
      this.listenTo(this.core, Events$1.CORE_MOUSE_MOVE, this.show);
      this.listenTo(this.core, Events$1.CORE_MOUSE_LEAVE, this.hideDelayed);
      this.listenTo(this, Events.MEDIACONTROL_MODAL_SHOW, this.showModal);
      this.listenTo(this, Events.MEDIACONTROL_MODAL_HIDE, this.hideModal);
      this.listenTo(this, Events.MEDIACONTROL_KEEPVISIBLE, function (keep) {
        return keep ? _this3.setUserKeepVisible() : _this3.resetUserKeepVisible();
      });
      this.listenTo(this, Events.MEDIACONTROL_ITEMCLICKED, this.resetFocus);
      this.listenTo(this.core, Events.WILL_SHOW_MODAL_ELEMENT, this.onModalElementShow);
      this.listenTo(this.core, Events.DID_HIDE_MODAL_ELEMENT, this.onModalElementHide);
      this.listenTo(this.core, Events$1.CORE_OPTIONS_CHANGE, this.onOptionsChange);
      this.listenTo(this.core, Events.WILL_SHOW_DRAWER, this.onStartExpandDrawer);
      this.listenTo(this.core, Events.WILL_HIDE_DRAWER, this.onStartShrinkDrawer);
      this.listenTo(this.core, Events.DRAWER_HAS_PLACEHOLDER, this.onPlaceholderRequested);
      this.listenTo(this.core, Events.SYNC_DRAWER_STATE_RESPONSE, this.syncWithDrawerIsShownResponse);
    }
  }, {
    key: "onStartExpandDrawer",
    value: function onStartExpandDrawer() {
      this.updatePanelsVisibility({
        hide: true,
        opaque: true
      });
      this.$modal.addClass('modal--hide');
    }
  }, {
    key: "onStartShrinkDrawer",
    value: function onStartShrinkDrawer() {
      if (this.$modal && this.$modal.contents().length == 0) {
        this.updatePanelsVisibility({
          hide: false,
          opaque: false
        });
        Browser.isMobile && this.show();
      } else {
        this.$modal.removeClass('modal--hide');
      }
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      if (!this.container) return;
      this.container.trigger(Events$1.CONTAINER_PLAYBACKDVRSTATECHANGED, this.container.isDvrInUse());
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.updatePlaybackTypeClass);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.updatePlaybackTypeClass);
      this.listenTo(this.container, Events$1.CONTAINER_MEDIACONTROL_DISABLE, this.disable);
      this.listenTo(this.container, Events$1.CONTAINER_MEDIACONTROL_ENABLE, this.enable);
      this.listenTo(this.container, Events.DFP_AD_SKIPPED, this.resetFocus);
      this.listenTo(this.container, Events.DFP_AD_CLICKED, this.resetFocus);
      this.listenTo(this.container, Events.WILL_QUICK_SEEK, this.hide);
      this.listenTo(this.container, Events$1.Custom.DAI_AD_BREAK_STARTED, this.onDAIAdBreakStarted);
      this.listenTo(this.container, Events$1.Custom.DAI_AD_BREAK_ENDED, this.onDAIAdBreakEnded);
      this.render();
      this.container.mediaControlDisabled && this.disable();
    }
  }, {
    key: "onDAIAdBreakStarted",
    value: function onDAIAdBreakStarted() {
      this.$el.addClass('media-control--dai');
    }
  }, {
    key: "onDAIAdBreakEnded",
    value: function onDAIAdBreakEnded() {
      this.$el.removeClass('media-control--dai');
    }
  }, {
    key: "onOptionsChange",
    value: function onOptionsChange() {
      this.lastChromelessValue !== !!this.options.chromeless && this.updateChromelessState();
    }
  }, {
    key: "updateChromelessState",
    value: function updateChromelessState() {
      this.lastChromelessValue = this.options.chromeless;

      if (this.options.chromeless) {
        this.options.allowUserInteraction = false;
        this.disable();
        this.$el.hide();
      } else {
        this.options.allowUserInteraction = true;
        this.enable();
        this.$el.show();
      }
    }
  }, {
    key: "onActiveContainerChanged",
    value: function onActiveContainerChanged() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      var shouldDisableMediaControl = this.container && this.container.mediaControlDisabled || this.core.options.chromeless;
      shouldDisableMediaControl && this.disable();
      this.bindContainerEvents();
      this.updatePlaybackTypeClass();
      this.trigger(Events$1.MEDIACONTROL_CONTAINERCHANGED);
    }
  }, {
    key: "createCachedElements",
    value: function createCachedElements() {
      this.$modal = this.$el.find('.media-control-panel__modal');
      this.$lowerPanel = this.$el.find('.media-control-panel__lower');
      this.$upperPanel = this.$el.find('.media-control-panel__upper');
    }
  }, {
    key: "initMediaControlPlugins",
    value: function initMediaControlPlugins() {
      var _this4 = this;

      var isMediaControlPlugin = function isMediaControlPlugin(plugin) {
        return plugin instanceof MediaControlPlugin;
      };

      var renderMediaControlPlugin = function renderMediaControlPlugin(plugin) {
        return _this4.renderMediaControlPlugin(plugin);
      };

      this.core.plugins.filter(isMediaControlPlugin).forEach(renderMediaControlPlugin);
    }
  }, {
    key: "renderMediaControlPlugin",
    value: function renderMediaControlPlugin(plugin) {
      // eslint-disable-line no-unused-vars
      throw new Error('renderMediaControlPlugin is not implemented');
    }
  }, {
    key: "updatePlaybackTypeClass",
    value: function updatePlaybackTypeClass() {
      if (!this.container) return;
      var type = this.container.getPlaybackType();
      this.$el.removeClass('vod live dvr ad dvr-disabled');
      type && this.$el.addClass(type);
      this.addDVRClass(type);
      if (type === 'ad') this.core.$el.removeClass('nocursor');
    }
  }, {
    key: "addDVRClass",
    value: function addDVRClass(type) {
      if (type !== 'live') return;
      this.container.isDvrEnabled() ? this.container.isDvrInUse() && this.$el.addClass('dvr') : this.$el.addClass('dvr-disabled');
    }
  }, {
    key: "setKeepVisible",
    value: function setKeepVisible() {
      this.keepVisible = true;
    }
  }, {
    key: "resetKeepVisible",
    value: function resetKeepVisible() {
      this.keepVisible = false;
    }
  }, {
    key: "setUserKeepVisible",
    value: function setUserKeepVisible() {
      if (this.userKeepVisible) return;
      this.userKeepVisible = true;
      this.trigger(Events.MEDIACONTROL_KEEPVISIBLE, true);
    }
  }, {
    key: "resetUserKeepVisible",
    value: function resetUserKeepVisible() {
      if (!this.userKeepVisible) return;
      this.userKeepVisible = false;
      this.trigger(Events.MEDIACONTROL_KEEPVISIBLE, false);
    }
  }, {
    key: "disable",
    value: function disable() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      options = _objectSpread2({
        hide: true
      }, options);
      this.keepVisible = false;
      this.userDisabled = true;
      this.userKeepVisible = false;
      options.hide && this.hide();
      this.updatePlaybackTypeClass();
    }
  }, {
    key: "enable",
    value: function enable() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      !this.isRendered && this.render();
      var type = this.container.getPlaybackType();

      var _ref = PlayerSettings && PlayerSettings.MediaControl || {},
          ShowOnStartList = _ref.ShowOnStartList;

      var showOnStart = (ShowOnStartList || []).find(function (host) {
        return host.test(getHostname());
      });
      var show = showOnStart || type === 'ad';
      options = _objectSpread2({
        show: show
      }, options);
      if (this.options.chromeless) return;
      this.userDisabled = false;
      options.show && this.show();
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return !this.$el.hasClass('media-control-hide');
    }
  }, {
    key: "show",
    value: function show(e) {
      var _this5 = this;

      if (Browser.isMobile && e && e.type === 'mousemove') return;
      var timeout = 3000;
      clearTimeout(this.hideId);
      this.hideId = setTimeout(function () {
        return _this5.hideDelayed();
      }, timeout);
      if (this.disabled || this.isVisible()) return;
      this.trigger(Events$1.MEDIACONTROL_SHOW);
      this.core.trigger(Events$1.MEDIACONTROL_SHOW);
      this.container.trigger(Events$1.CONTAINER_MEDIACONTROL_SHOW);
      this.$el.removeClass('media-control-hide');
      this.updateCursorStyle(true);
    }
  }, {
    key: "hideDelayed",
    value: function hideDelayed() {
      var _this6 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.container) return;
      if ((!this.isVisible() || Browser.supportsTouchEvents && !this.container.isPlaying()) && !force) return;
      var timeout = delay || 3000;
      clearTimeout(this.hideId);
      if (!this.disabled && this.options.hideMediaControl === false) return;

      if (!this.disabled && (delay || this.userKeepVisible || this.keepVisible)) {
        this.hideId = setTimeout(function () {
          return _this6.hideDelayed();
        }, timeout);
      } else {
        this.hide();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this.container || this.keepVisible || this.userKeepVisible) return;
      this.core.trigger(Events$1.MEDIACONTROL_HIDE);
      this.trigger(Events$1.MEDIACONTROL_HIDE);
      this.container.trigger(Events$1.CONTAINER_MEDIACONTROL_HIDE);
      this.$el.addClass('media-control-hide');
      this.hideModal();
      this.updateCursorStyle(false);
    }
  }, {
    key: "updateCursorStyle",
    value: function updateCursorStyle(showing) {
      if (this.container.getPlaybackType() === 'ad') return;
      showing || this.disabled ? this.core.$el.removeClass('nocursor') : this.core.$el.addClass('nocursor');
    }
  }, {
    key: "showPanel",
    value: function showPanel(_ref2) {
      var panel = _ref2.panel;
      this.getPanel(panel).removeClass('panel--hide');
    }
  }, {
    key: "hidePanel",
    value: function hidePanel(_ref3) {
      var panel = _ref3.panel;
      this.getPanel(panel).addClass('panel--hide');
    }
  }, {
    key: "showModal",
    value: function showModal(content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.$modal.html(content);
      this.$modal.show().off('transitionend');
      this.$modal.removeClass('modal--hide');
      options.hidePanels && this.updatePanelsVisibility({
        hide: true
      });
      this.updateClickToPausePlugin({
        enable: false
      });
      this.updateCastInfoVisibility({
        hidden: true
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      var _this7 = this;

      var modalContent = this.$modal && this.$modal.contents();
      if (!modalContent || modalContent && !modalContent.length) return;
      this.$modal.addClass('modal--hide').on('transitionend', function () {
        _this7.$modal.hide().off('transitionend');

        _this7.$modal.html('');
      });
      this.syncWithDrawerIsShownRequest();
      this.updatePanelsVisibility({
        hide: this.drawerOverModal
      });
      this.updateClickToPausePlugin({
        enable: true
      });
      this.updateCastInfoVisibility({
        hidden: false
      });
    }
  }, {
    key: "syncWithDrawerIsShownRequest",
    value: function syncWithDrawerIsShownRequest() {
      this.core.trigger(Events.SYNC_DRAWER_STATE_REQUEST);
    }
  }, {
    key: "syncWithDrawerIsShownResponse",
    value: function syncWithDrawerIsShownResponse(isExpanded) {
      this.drawerOverModal = isExpanded;
    }
  }, {
    key: "onModalElementShow",
    value: function onModalElementShow() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          name = _ref4.name;

      this.$el.addClass("".concat(name, "-modal--visible"));
    }
  }, {
    key: "onModalElementHide",
    value: function onModalElementHide() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          name = _ref5.name;

      this.$el.removeClass("".concat(name, "-modal--visible"));
    }
  }, {
    key: "updateCastInfoVisibility",
    value: function updateCastInfoVisibility() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = newState.hidden ? 'addClass' : 'removeClass';
      this.container && this.container.$el[method]('chromecast-playback-overlay--hidden');

      if (typeof newState.opaque === 'boolean') {
        var methodOpaque = newState.opaque ? 'addClass' : 'removeClass';
        this.$el[methodOpaque]('media-control--panels-opaque');
      }
    }
  }, {
    key: "onPlaceholderRequested",
    value: function onPlaceholderRequested() {
      this.hasPlaceholder = true;
    }
  }, {
    key: "updateClickToPausePlugin",
    value: function updateClickToPausePlugin() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = newState.enable ? 'enable' : 'disable';
      var clickToPausePlugin = this.container.getPlugin('click_to_pause');
      !Browser.isMobile && clickToPausePlugin && clickToPausePlugin[method]();
    }
  }, {
    key: "updatePanelsVisibility",
    value: function updatePanelsVisibility() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = newState.hide ? 'addClass' : 'removeClass';
      this.$el[method]('media-control--panels-hide');
    }
  }, {
    key: "updateBackgroundType",
    value: function updateBackgroundType() {
      if (this.hasPlaceholder) {
        this.$el.addClass('media-control--has-placeholder');
        return;
      }

      if (Browser.isMobile || this.disabled) return;
      var top = this.$lowerPanel.position().top;
      var lowerPanelHeight = this.$lowerPanel.height();
      var parentHeight = this.$lowerPanel.offsetParent().height();
      var bottom = Math.trunc(parentHeight - (top + lowerPanelHeight));
      var showFullBackground = bottom > defaultPadding;

      if (bottom != this._bottomPanelPosition) {
        this._bottomPanelPosition = bottom;
        showFullBackground ? this.$el.addClass('mobile') : this.$el.removeClass('mobile');
      }

      var upperPanelHeight = this.$upperPanel.height();

      if (upperPanelHeight != this._upperPanelHeight) {
        this._upperPanelHeight = upperPanelHeight;
        !showFullBackground && upperPanelHeight == 0 ? this.$el.addClass('hide-top-background') : this.$el.removeClass('hide-top-background');
      }
    }
  }, {
    key: "addResizeObserver",
    value: function addResizeObserver() {
      var _this8 = this;

      this.removeResizeObserver();
      this._resizeInterval = setInterval(function () {
        return _this8.updateBackgroundType();
      }, 500);
    }
  }, {
    key: "removeResizeObserver",
    value: function removeResizeObserver() {
      this._resizeInterval && clearInterval(this._resizeInterval);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeResizeObserver();

      _get(_getPrototypeOf(GloboMediaControl.prototype), "destroy", this).call(this);
    }
  }, {
    key: "playerResize",
    value: function playerResize(size) {
      var sizeChanged = this.currentWidth !== size.width;
      if (this.disabled || !sizeChanged) return;
      applySizeClass(this.$el, size.width);
      this.currentWidth = size.width;
    }
  }, {
    key: "resetFocus",
    value: function resetFocus() {
      this.focusElement.focus();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.container || this.isRendered) return this;
      var styleOption = {
        baseUrl: this.options.baseUrl,
        playerId: this.options.playerId
      };
      var style = Styler.getStyleFrom(this.styles.toString(), styleOption);
      this.$el.html(this.template());
      this.$el.append(style[0]);
      this.core.$el.append(this.el);
      this.createCachedElements();
      this.initMediaControlPlugins();
      this.updatePlaybackTypeClass();
      this.updateBackgroundType();
      this.addResizeObserver();
      this.disabled && this.hide();
      this.isRendered = true;
      this.trigger(Events$1.MEDIACONTROL_RENDERED);
      return this;
    }
  }]);

  return GloboMediaControl;
}(UICorePlugin);

var css_248z$3 = ".media-control-notransition {\n  transition: none !important; }\n\n.clappr-player#wp3-player-0 .media-control {\n  position: absolute;\n  border-radius: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  height: 100%;\n  z-index: 997;\n  opacity: 1;\n  will-change: opacity;\n  transition: visibility 0.3s ease, opacity 0.3s ease;\n  pointer-events: none; }\n  .clappr-player#wp3-player-0 .media-control::before, .clappr-player#wp3-player-0 .media-control::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    width: 100%;\n    height: 88px;\n    background: none;\n    z-index: -1;\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control::before {\n    top: 0;\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));\n    z-index: -1; }\n  .clappr-player#wp3-player-0 .media-control::after {\n    bottom: 0;\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7)); }\n  .clappr-player#wp3-player-0 .media-control.hide-top-background::after {\n    display: none; }\n  .clappr-player#wp3-player-0 .media-control.mobile::before, .clappr-player#wp3-player-0 .media-control.media-control--panels-hide::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.6;\n    background: #000;\n    z-index: -1; }\n  .clappr-player#wp3-player-0 .media-control.mobile.media-control--panels-opaque::before, .clappr-player#wp3-player-0 .media-control.media-control--panels-hide.media-control--panels-opaque::before {\n    opacity: 0;\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    height: 88px;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7)); }\n  .clappr-player#wp3-player-0 .media-control.mobile.media-control--panels-opaque::after, .clappr-player#wp3-player-0 .media-control.media-control--panels-hide.media-control--panels-opaque::after {\n    opacity: 0;\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control.mobile::after, .clappr-player#wp3-player-0 .media-control.media-control--panels-hide::after {\n    opacity: 0;\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control-dragging {\n    pointer-events: auto;\n    cursor: -webkit-grabbing !important;\n    cursor: grabbing !important; }\n    .clappr-player#wp3-player-0 .media-control-dragging * {\n      cursor: -webkit-grabbing !important;\n      cursor: grabbing !important; }\n  .clappr-player#wp3-player-0 .media-control-panel__middle.panel--hide .media-control-element, .clappr-player#wp3-player-0 .media-control-panel__middle.panel--hide .media-control-button, .clappr-player#wp3-player-0 .media-control-panel__between.panel--hide .media-control-element, .clappr-player#wp3-player-0 .media-control-panel__between.panel--hide .media-control-button, .clappr-player#wp3-player-0 .media-control-panel__upper.panel--hide .media-control-element, .clappr-player#wp3-player-0 .media-control-panel__upper.panel--hide .media-control-button, .clappr-player#wp3-player-0 .media-control-panel__lower.panel--hide .media-control-element, .clappr-player#wp3-player-0 .media-control-panel__lower.panel--hide .media-control-button {\n    opacity: 0; }\n  .clappr-player#wp3-player-0 .media-control-panel__lower, .clappr-player#wp3-player-0 .media-control-panel__upper {\n    position: relative; }\n  .clappr-player#wp3-player-0 .media-control-panel__front-layer {\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control-panel__modal {\n    opacity: 1;\n    will-change: opacity;\n    visibility: visible;\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n    .clappr-player#wp3-player-0 .media-control-panel__modal.modal--hide {\n      opacity: 0;\n      visibility: hidden; }\n  .clappr-player#wp3-player-0 .media-control.media-control-hide {\n    pointer-events: none; }\n    .clappr-player#wp3-player-0 .media-control.media-control-hide.touch .media-control-button {\n      opacity: 0;\n      transition: visibility 0.3s ease, opacity 0.3s ease; }\n    .clappr-player#wp3-player-0 .media-control.media-control-hide .media-control-element, .clappr-player#wp3-player-0 .media-control.media-control-hide .media-control-button {\n      pointer-events: none;\n      opacity: 0;\n      transition: visibility 0.3s ease, opacity 0.3s ease; }\n    .clappr-player#wp3-player-0 .media-control.media-control-hide::before, .clappr-player#wp3-player-0 .media-control.media-control-hide::after {\n      opacity: 0;\n      transition: visibility 0.3s ease, opacity 0.3s ease; }\n    .clappr-player#wp3-player-0 .media-control.media-control-hide .media-control-panel__front-layer {\n      opacity: 0; }\n  .clappr-player#wp3-player-0 .media-control.media-control--no-background::before {\n    opacity: 0;\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control--panels-hide:before {\n    transition: none; }\n  .clappr-player#wp3-player-0 .media-control--panels-hide .media-control-panel__middle, .clappr-player#wp3-player-0 .media-control--panels-hide .media-control-panel__between, .clappr-player#wp3-player-0 .media-control--panels-hide .media-control-panel__upper, .clappr-player#wp3-player-0 .media-control--panels-hide .media-control-panel__lower {\n    opacity: 0;\n    visibility: hidden; }\n  .clappr-player#wp3-player-0 .media-control.media-control--has-placeholder::after {\n    height: 112px; }\n\n.clappr-player#wp3-player-0 .media-control.touch .media-control-panel__between {\n  pointer-events: auto; }\n\n.clappr-player#wp3-player-0 .media-control.w360 .media-control-panel__middle {\n  width: 100%;\n  height: 100%; }\n\n.clappr-player#wp3-player-0 .media-control.w360 .media-control-panel__upper, .clappr-player#wp3-player-0 .media-control.w360 .media-control-panel__middle, .clappr-player#wp3-player-0 .media-control.w360 .media-control-panel__lower, .clappr-player#wp3-player-0 .media-control.w360 .media-control-panel__between {\n  padding: 0; }\n\n.clappr-player#wp3-player-0 .media-control .media-control-panel {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  vertical-align: middle;\n  pointer-events: none;\n  box-sizing: border-box;\n  display: flex;\n  flex-flow: column nowrap; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel .modal-element {\n    z-index: 1000; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel .opposites-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    position: relative; }\n    .clappr-player#wp3-player-0 .media-control .media-control-panel .opposites-container .media-control-position__between {\n      display: flex;\n      align-items: center;\n      justify-content: center; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel .media-control-position__left, .clappr-player#wp3-player-0 .media-control .media-control-panel .media-control-position__right {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    z-index: 300; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel .media-control-position__center {\n    display: flex;\n    justify-content: center;\n    align-items: center; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__upper .media-control-position__center {\n    flex-flow: column nowrap; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__lower, .clappr-player#wp3-player-0 .media-control .media-control-panel__between, .clappr-player#wp3-player-0 .media-control .media-control-panel__upper {\n    position: relative; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__lower .media-control-position__center {\n    flex-flow: column-reverse nowrap;\n    position: relative;\n    z-index: 200; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__middle {\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    height: 100%; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__between {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n    height: 100%; }\n    .clappr-player#wp3-player-0 .media-control .media-control-panel__between .media-control-position__left, .clappr-player#wp3-player-0 .media-control .media-control-panel__between .media-control-position__right {\n      flex-grow: 1; }\n    .clappr-player#wp3-player-0 .media-control .media-control-panel__between .media-control-position__left, .clappr-player#wp3-player-0 .media-control .media-control-panel__between .media-control-position__center, .clappr-player#wp3-player-0 .media-control .media-control-panel__between .media-control-position__right {\n      height: 100%; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__upper, .clappr-player#wp3-player-0 .media-control .media-control-panel__middle, .clappr-player#wp3-player-0 .media-control .media-control-panel__lower, .clappr-player#wp3-player-0 .media-control .media-control-panel__between {\n    padding: 0 4px; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__upper, .clappr-player#wp3-player-0 .media-control .media-control-panel__middle {\n    padding-top: 4px; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__lower, .clappr-player#wp3-player-0 .media-control .media-control-panel__middle {\n    padding-bottom: 4px; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__upper,\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__middle > *, .clappr-player#wp3-player-0 .media-control .media-control-panel__lower, .clappr-player#wp3-player-0 .media-control .media-control-panel__modal {\n    pointer-events: auto; }\n\n.clappr-player#wp3-player-0 .media-control.touch .media-control-button[data-playpause] {\n  width: 48px;\n  height: 48px; }\n\n.clappr-player#wp3-player-0 .media-control-panel__lower .media-control-element {\n  padding-top: 4px; }\n\n.clappr-player#wp3-player-0 .media-control-element {\n  padding: 12px;\n  will-change: opacity;\n  transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control-element--sticky {\n    opacity: 1 !important;\n    pointer-events: auto !important; }\n  .clappr-player#wp3-player-0 .media-control-element--hidden {\n    display: none; }\n\n.clappr-player#wp3-player-0 .media-control-button {\n  display: inline-block;\n  margin: 0;\n  border: 0;\n  cursor: pointer;\n  background-color: transparent;\n  text-align: center;\n  width: 24px;\n  height: 24px;\n  box-sizing: content-box;\n  transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control-button svg {\n    width: 100%;\n    height: 100%; }\n  .clappr-player#wp3-player-0 .media-control-button:focus {\n    outline: none; }\n  .clappr-player#wp3-player-0 .media-control-button--hidden {\n    display: none; }\n  .clappr-player#wp3-player-0 .media-control-button[data-chromecast] svg.player-cast-loading {\n    width: 24px;\n    height: 24px; }\n\n.clappr-player#wp3-player-0 .media-control.ad {\n  background: none;\n  visibility: visible;\n  opacity: 1; }\n  .clappr-player#wp3-player-0 .media-control.ad.touch {\n    visibility: hidden !important;\n    pointer-events: none; }\n    .clappr-player#wp3-player-0 .media-control.ad.touch .media-control-button {\n      visibility: hidden !important; }\n    .clappr-player#wp3-player-0 .media-control.ad.touch .media-control-panel__lower {\n      opacity: 1 !important;\n      visibility: visible !important; }\n    .clappr-player#wp3-player-0 .media-control.ad.touch .media-control-panel__modal {\n      pointer-events: auto !important; }\n    .clappr-player#wp3-player-0 .media-control.ad.touch .media-control-panel > * {\n      pointer-events: none; }\n    .clappr-player#wp3-player-0 .media-control.ad.touch .dfp-countdown {\n      visibility: hidden;\n      pointer-events: none; }\n  .clappr-player#wp3-player-0 .media-control.ad:after, .clappr-player#wp3-player-0 .media-control.ad:before {\n    content: \"\";\n    left: 0;\n    height: 48px;\n    background: none;\n    opacity: 1;\n    position: absolute;\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    width: 100%;\n    will-change: opacity;\n    z-index: -1; }\n  .clappr-player#wp3-player-0 .media-control.ad:before {\n    top: 0;\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7)); }\n  .clappr-player#wp3-player-0 .media-control.ad:after {\n    bottom: 0;\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7)); }\n  .clappr-player#wp3-player-0 .media-control.ad .media-control-panel__upper, .clappr-player#wp3-player-0 .media-control.ad .media-control-panel__middle, .clappr-player#wp3-player-0 .media-control.ad .media-control-panel__between,\n  .clappr-player#wp3-player-0 .media-control.ad .media-control-panel__lower .opposites-container {\n    opacity: 1;\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    will-change: opacity; }\n  .clappr-player#wp3-player-0 .media-control.ad .media-control-panel__upper {\n    pointer-events: none; }\n  .clappr-player#wp3-player-0 .media-control.ad.media-control-hide:before, .clappr-player#wp3-player-0 .media-control.ad.media-control-hide:after {\n    opacity: 0; }\n  .clappr-player#wp3-player-0 .media-control.ad.media-control-hide .media-control-panel__upper, .clappr-player#wp3-player-0 .media-control.ad.media-control-hide .media-control-panel__middle, .clappr-player#wp3-player-0 .media-control.ad.media-control-hide .media-control-panel__between,\n  .clappr-player#wp3-player-0 .media-control.ad.media-control-hide .media-control-panel__lower .opposites-container {\n    opacity: 0; }\n\n.clappr-player#wp3-player-0 .media-control.media-control--dai.media-control-hide .media-control-panel__upper {\n  pointer-events: none; }\n\n.clappr-player#wp3-player-0 .media-control.ad.volume-modal--visible .bar-container[data-seekbar] {\n  opacity: 1; }\n  .clappr-player#wp3-player-0 .media-control.ad.volume-modal--visible .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n    transform: scale(1); }\n\n.clappr-player#wp3-player-0 .media-control.ad .dfp-countdown {\n  display: block; }\n\n.clappr-player#wp3-player-0 .media-control.ad .media-control-button svg path[fill], .clappr-player#wp3-player-0 .media-control.ad .media-control-element svg path[fill] {\n  fill: #ffff93 !important; }\n\n.clappr-player#wp3-player-0 .media-control.ad .media-control-button[data-settings], .clappr-player#wp3-player-0 .media-control.ad .media-control-button[data-share], .clappr-player#wp3-player-0 .media-control.ad .media-control-element[data-settings], .clappr-player#wp3-player-0 .media-control.ad .media-control-element[data-share] {\n  display: none; }\n\n.clappr-player#wp3-player-0 .media-control.ad .time-indicator,\n.clappr-player#wp3-player-0 .media-control.ad .live-button,\n.clappr-player#wp3-player-0 .media-control.ad .chromecast-button {\n  display: none !important; }\n\n.clappr-player#wp3-player-0 .media-control.ad .bar-container {\n  padding: 0; }\n  .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-volume] .bar-fill-1[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-seekbar] .bar-fill-1[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-volume] .bar-fill-1[data-volume] {\n    background-color: #ffff93 !important; }\n  .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-volume] .bar-fill-2[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-seekbar] .bar-fill-2[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-volume] .bar-fill-2[data-seekbar] {\n    background-color: #ffff93 !important; }\n  .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-volume] .bar-hover[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-volume] .bar-hover[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-seekbar] .bar-hover[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-seekbar] .bar-hover[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-volume] .bar-hover[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-background[data-volume] .bar-hover[data-volume] {\n    opacity: 0; }\n  .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-scrubber[data-volume] .bar-scrubber-icon[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-scrubber[data-volume] .bar-scrubber-icon[data-seekbar] {\n    display: none; }\n  .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-scrubber[data-volume] .bar-scrubber-icon[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-volume], .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-volume] .bar-scrubber[data-volume] .bar-scrubber-icon[data-volume] {\n    background-color: #ffff93 !important; }\n\n.clappr-player#wp3-player-0 .media-control.ad .bar-container__placeholder {\n  display: none; }\n\n.clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] {\n  position: fixed;\n  width: 100%;\n  left: 50%;\n  transform: translate(-50%);\n  top: calc(100% - 4px);\n  height: 4px;\n  margin-bottom: 0;\n  overflow: hidden;\n  cursor: default;\n  opacity: 1;\n  transition: none; }\n  .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] {\n    margin: 0;\n    height: 100%;\n    border-radius: 0;\n    background-color: rgba(255, 255, 255, 0.4);\n    box-shadow: none;\n    transform: scaleY(1);\n    left: 0; }\n    .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar] {\n      display: none; }\n    .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar],\n    .clappr-player#wp3-player-0 .media-control.ad .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n      border-radius: 0; }\n\n.clappr-player#wp3-player-0 .media-control.live {\n  min-height: auto; }\n  .clappr-player#wp3-player-0 .media-control.live .media-control-panel .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n    background-color: #ff0000; }\n  .clappr-player#wp3-player-0 .media-control.live .media-control-panel .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n    background-color: #fff;\n    display: none; }\n  .clappr-player#wp3-player-0 .media-control.live .media-control-panel .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n    background-color: #ff0000; }\n  .clappr-player#wp3-player-0 .media-control.live .media-control-panel .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n    display: block; }\n  .clappr-player#wp3-player-0 .media-control.live.dvr-disabled .media-control-panel .bar-container[data-seekbar] {\n    pointer-events: none; }\n    .clappr-player#wp3-player-0 .media-control.live.dvr-disabled .media-control-panel .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n      display: none; }\n  .clappr-player#wp3-player-0 .media-control.live .time-indicator {\n    display: none; }\n\n.clappr-player#wp3-player-0 .media-control.dvr .media-control-panel .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #fff; }\n\n.clappr-player#wp3-player-0 .media-control.dvr .media-control-panel .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n  background-color: #ff0000; }\n\n.clappr-player#wp3-player-0 .media-control.dvr .media-control-panel .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n  background-color: #fff; }\n\n.clappr-player#wp3-player-0 .media-control.dvr .media-control-panel .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n  display: block; }\n";
styleInject(css_248z$3);

var WebMediaControl = /*#__PURE__*/function (_GloboMediaControl) {
  _inherits(WebMediaControl, _GloboMediaControl);

  var _super = _createSuper(WebMediaControl);

  function WebMediaControl() {
    _classCallCheck(this, WebMediaControl);

    return _super.apply(this, arguments);
  }

  _createClass(WebMediaControl, [{
    key: "bindEvents",
    value: function bindEvents() {
      _get(_getPrototypeOf(WebMediaControl.prototype), "bindEvents", this).call(this);

      this.listenTo(this.core, Events.START_DRAGGING_SEEKBAR, this.onStartDraggingSeekbar);
      this.listenTo(this.core, Events.STOP_DRAGGING_SEEKBAR, this.onStopDragginSeekbar);
    }
  }, {
    key: "renderMediaControlPlugin",
    value: function renderMediaControlPlugin(plugin) {
      var panel = plugin.panel,
          position = plugin.position,
          el = plugin.el;
      var parentSelector = ".media-control-panel__".concat(panel, " ").concat(position ? ".media-control-position__".concat(position) : '');
      this.$el.find(parentSelector).append(el);
      plugin.render();
    }
  }, {
    key: "onStartDraggingSeekbar",
    value: function onStartDraggingSeekbar() {
      // TODO: hide all panels on dragging and keep seekbar sticky
      this.hidePanel({
        panel: 'upper'
      });
      this.hidePanel({
        panel: 'between'
      });
    }
  }, {
    key: "onStopDragginSeekbar",
    value: function onStopDragginSeekbar() {
      this.showPanel({
        panel: 'upper'
      });
      this.showPanel({
        panel: 'between'
      });
    }
  }, {
    key: "styles",
    get: function get() {
      return css_248z$3;
    }
  }]);

  return WebMediaControl;
}(GloboMediaControl);

var playIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path fill=\"#FFF\" d=\"M8 5v14l11-7z\"/>\n    </g>\n</svg>";

var pauseIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M6 19h4V5H6v14zm8-14v14h4V5h-4z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var PlayButton = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(PlayButton, _MediaControlPlugin);

  var _super = _createSuper(PlayButton);

  _createClass(PlayButton, [{
    key: "name",
    get: function get() {
      return 'play_button';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return Browser.supportsTouchEvents ? 'between' : 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return Browser.supportsTouchEvents ? 'center' : 'left';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'media-control-button',
        'data-playpause': '',
        'aria-label': 'play'
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.togglePlayPause
      };
    }
  }, {
    key: "isPauseDisabled",
    get: function get() {
      var isLive = this.container && this.container.getPlaybackType() === Playback.LIVE;
      var isDvrDisabled = this.container.playback && !this.container.playback.dvrEnabled;
      return isLive && isDvrDisabled;
    }
  }]);

  function PlayButton(core) {
    _classCallCheck(this, PlayButton);

    return _super.call(this, core);
  }

  _createClass(PlayButton, [{
    key: "destroy",
    value: function destroy() {
      this.unbindKeyEvents();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.changeTogglePlay);
      this.listenTo(this.container, Events$1.CONTAINER_PAUSE, this.changeTogglePlay);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.changeTogglePlay);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.changeTogglePlay);
      this.listenTo(this.container, Events.WM_SPINNER_START, this.hidePlayButton);
      this.listenTo(this.container, Events.WM_SPINNER_STOP, this.showPlayButton);
    }
  }, {
    key: "hidePlayButton",
    value: function hidePlayButton() {
      Browser.supportsTouchEvents && this.$el.hide();
    }
  }, {
    key: "showPlayButton",
    value: function showPlayButton() {
      Browser.supportsTouchEvents && this.$el.show();
    }
  }, {
    key: "bindKeyEvents",
    value: function bindKeyEvents() {
      var _this = this;

      if (!this.kibo) return;
      this.unbindKeyEvents();
      this.bindKeyAndShow('space', function () {
        return _this.togglePlayPause();
      });
    }
  }, {
    key: "unbindKeyEvents",
    value: function unbindKeyEvents() {
      if (this.kibo) {
        this.kibo.off('space');
      }
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.bindContainerEvents();
      this.changeTogglePlay();
    }
  }, {
    key: "changeTogglePlay",
    value: function changeTogglePlay() {
      this.$el.html('');

      if (this.container && this.container.isPlaying()) {
        if (this.isPauseDisabled) {
          this.$el.hide();
        } else {
          this.$el.append(pauseIcon);
          this.$el.attr('aria-label', 'pause');
          this.$el.removeClass('play');
          this.$el.addClass('pause');
          this.$el.show();
        }

        this.trigger(Events$1.MEDIACONTROL_PLAYING);
      } else {
        this.$el.append(playIcon);
        this.$el.attr('aria-label', 'play');
        this.$el.removeClass('stop pause');
        this.$el.addClass('play');
        this.$el.show();
        this.trigger(Events$1.MEDIACONTROL_NOTPLAYING);
      }

      this.applyButtonStyle(this.$el);
    }
  }, {
    key: "togglePlayPause",
    value: function togglePlayPause() {
      if (this.isPauseDisabled) {
        // fix for iOS when the user exit fullscreen because iOS pauses the video
        !this.container.isPlaying() && this.container.play({
          userInvoked: true
        });
        return;
      }

      if (this.container.isPlaying()) {
        this.container.pause({
          userInvoked: true
        });
      } else {
        this.container.play({
          userInvoked: true
        });
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      this.bindKeyEvents();
      this.changeTogglePlay();
      return this;
    }
  }]);

  return PlayButton;
}(MediaControlPlugin);

var backIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path d=\"M0 0h24v24H0z\"/>\n    <path fill=\"#FFF\" d=\"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z\"/>\n  </g>\n</svg>";

var BackButton = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(BackButton, _MediaControlPlugin);

  var _super = _createSuper(BackButton);

  function BackButton() {
    _classCallCheck(this, BackButton);

    return _super.apply(this, arguments);
  }

  _createClass(BackButton, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_OPTIONS_CHANGE, this.onOptionsChange);
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (!this.backButtonEnabled) return;
      this.core.trigger(Events.BACK_BUTTON_CLICKED);
    }
  }, {
    key: "onOptionsChange",
    value: function onOptionsChange() {
      this.lastBackButtonValue !== !!this.backButtonEnabled && this.updateBackButtonState();
    }
  }, {
    key: "updateBackButtonState",
    value: function updateBackButtonState() {
      this.backButtonEnabled ? this.show() : this.hide();
      this.lastBackButtonValue = this.backButtonEnabled;
    }
  }, {
    key: "show",
    value: function show() {
      this.$el.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.hide();
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.html('');
      this.$el.append(backIcon);
      this.updateBackButtonState();
      return this;
    }
  }, {
    key: "name",
    get: function get() {
      return 'back_button';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'upper';
    }
  }, {
    key: "position",
    get: function get() {
      return 'left';
    }
  }, {
    key: "backButtonEnabled",
    get: function get() {
      return this.options.events && typeof this.options.events.onBackButtonClicked === 'function';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'media-control-button',
        'data-controls': '',
        'aria-label': 'back'
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.onClick
      };
    }
  }]);

  return BackButton;
}(MediaControlPlugin);

var fullscreenIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M19 21h-4v-2h4v-4h2v6h-2zm0-18h2v6h-2V5h-4V3h4zM5 19h4v2H3v-6h2v4zM5 3h4v2H5v4H3V3h2z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var exitFullscreenIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M7 15h2v6H7v-4H3v-2h4zm10-8h4v2h-6V3h2v4zM7 9H3V7h4V3h2v6H7zm10 6h4v2h-4v4h-2v-6h2z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var FullscreenButton = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(FullscreenButton, _MediaControlPlugin);

  var _super = _createSuper(FullscreenButton);

  _createClass(FullscreenButton, [{
    key: "getExternalInterface",
    value: function getExternalInterface() {
      return {
        toggleFullscreen: this.toggleFullscreen
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'fullscreen_button';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'right';
    }
  }, {
    key: "playback",
    get: function get() {
      return this.core && this.core.activePlayback;
    }
  }, {
    key: "screenOrientationAvailable",
    get: function get() {
      return screen && screen.orientation;
    }
  }, {
    key: "isIdle",
    get: function get() {
      var posterPlugin = this.container.getPlugin('poster');
      return posterPlugin && !posterPlugin.$el.hasClass('poster--hidden');
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'media-control-button',
        'data-fullscreen': '',
        'aria-label': 'fullscreen'
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.onClick
      };
    }
  }]);

  function FullscreenButton(core) {
    var _this;

    _classCallCheck(this, FullscreenButton);

    _this = _super.call(this, core);
    _this.fullScreenOnVideoTagSupported = null; // unknown

    return _this;
  }

  _createClass(FullscreenButton, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.changeToggleFullscreen);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      this.fullScreenOnVideoTagSupported = null;
      if (!this.container) return;
      this.bindKeyEvents();
      this.listenTo(this.container, Events$1.CONTAINER_DBLCLICK, this.toggleFullscreen);

      if (this.playback.videoEl && this.playback.videoEl.nodeName.toLowerCase() === 'video') {
        // wait until the metadata has loaded and then check if fullscreen on video tag is supported
        this.listenToOnce(this.container, Events$1.CONTAINER_LOADEDMETADATA, this.onLoadedMetadataOnVideoTag);
      }

      if (Browser.isIE && !Browser.isIE11 || Browser.supportsTouchEvents) {
        this.stopListening(this.container, Events$1.CONTAINER_DBLCLICK);
      }
    }
  }, {
    key: "bindKeyEvents",
    value: function bindKeyEvents() {
      var _this2 = this;

      if (!this.kibo) return;
      this.unbindKeyEvents();
      this.bindKeyAndShow('f', function () {
        return _this2.toggleFullscreen();
      });
    }
  }, {
    key: "unbindKeyEvents",
    value: function unbindKeyEvents() {
      if (this.kibo) {
        this.kibo.off('f');
      }
    }
  }, {
    key: "onLoadedMetadataOnVideoTag",
    value: function onLoadedMetadataOnVideoTag() {
      // video.webkitSupportsFullscreen is deprecated but iOS appears to only use this
      // see https://github.com/clappr/clappr/issues/1127
      if (!Utils.Fullscreen.fullscreenEnabled() && this.playback.videoEl.webkitSupportsFullscreen) {
        this.fullScreenOnVideoTagSupported = true;
        this.render();
      }
    }
  }, {
    key: "changeToggleFullscreen",
    value: function changeToggleFullscreen() {
      this.$el.html('');

      if (Utils.Fullscreen.fullscreenElement()) {
        this.$el.append(exitFullscreenIcon);
      } else {
        this.$el.append(fullscreenIcon);
      }

      this.applyButtonStyle(this.$el);
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.toggleFullscreen();
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      this.container.fullscreen();
      this.core.toggleFullscreen();
      this.mediaControl.resetUserKeepVisible();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.fullScreenOnVideoTagSupported && !Utils.Fullscreen.fullscreenEnabled()) return;
      this.changeToggleFullscreen();
      return this;
    }
  }]);

  return FullscreenButton;
}(MediaControlPlugin);

var css_248z$4 = ".clappr-player#wp3-player-0 .time-indicator {\n  display: flex;\n  height: 24px;\n  box-sizing: content-box;\n  align-items: center;\n  cursor: default;\n  position: relative;\n  font-family: \"opensans-regular\", sans-serif;\n  font-size: 14px;\n  line-height: 16px;\n  color: #ffffff;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5); }\n  .clappr-player#wp3-player-0 .time-indicator .separator {\n    display: inline;\n    margin: 0 5px;\n    opacity: 0.5; }\n  .clappr-player#wp3-player-0 .time-indicator--collapse {\n    cursor: pointer; }\n    .clappr-player#wp3-player-0 .time-indicator--collapse .separator, .clappr-player#wp3-player-0 .time-indicator--collapse [data-duration] {\n      display: none; }\n\n.clappr-player#wp3-player-0 .media-control:not(.mobile) .time-indicator {\n  padding-left: 0; }\n\n.clappr-player#wp3-player-0 [data-position],\n.clappr-player#wp3-player-0 [data-duration] {\n  display: inline; }\n";
styleInject(css_248z$4);

var NOT_COLLAPSE_WIDTH = 130;

var TimeIndicator = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(TimeIndicator, _MediaControlPlugin);

  var _super = _createSuper(TimeIndicator);

  _createClass(TimeIndicator, [{
    key: "name",
    get: function get() {
      return 'time_indicator';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'left';
    }
  }, {
    key: "hasSizeChanged",
    get: function get() {
      return this.lastSize === this.actualSize;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'time-indicator'
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.toggleTimeIndicator
      };
    }
  }]);

  function TimeIndicator(core) {
    _classCallCheck(this, TimeIndicator);

    return _super.call(this, core);
  }

  _createClass(TimeIndicator, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.playback && this.stopListening(this.playback);
      this.container = this.core.activeContainer;
      this.playback = this.core.activePlayback;
      if (!this.container) return;
      this.listenTo(this.container, Events$1.CONTAINER_TIMEUPDATE, this.onTimeUpdate);
      this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.setDuration);
    }
  }, {
    key: "setDuration",
    value: function setDuration(video) {
      var duration = Utils.formatTime(video.duration / 1000);
      this.$duration.text(duration);
      this.$rightContainer = this.mediaControl.$el.find('.media-control-panel__lower .media-control-position__right');
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize(size) {
      if (!size.width || typeof size.width !== 'number' || !this.$rightContainer) return;
      this.actualSize = size;
      this.shouldCollapse = this.actualSize.width - this.$rightContainer.width() < NOT_COLLAPSE_WIDTH;

      if (this.shouldCollapse) {
        this.$el.addClass('time-indicator--collapse');
        this.$duration.hide();
      } else {
        this.$el.removeClass('time-indicator--collapse');
        this.$duration.show();
      }

      this.$position.show();
      this.updateTimeIndicator();
      this.lastSize = this.actualSize;
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate(timeProgress) {
      if (timeProgress.playbackType === 'ad') return;
      this.currentPositionValue = timeProgress.current < 0 ? timeProgress.total : timeProgress.current;
      this.currentDurationValue = timeProgress.total;
      if (this.currentPositionValue === null || this.currentDurationValue === null) return;
      this.updateTimeIndicator();
    }
  }, {
    key: "updateTimeIndicator",
    value: function updateTimeIndicator() {
      this.updatePosition();
      this.shouldCollapse ? this.updateRemainingTime() : this.updateDuration();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.hasSizeChanged && parseInt(this.currentPositionValue) === parseInt(this.lastPositionValue)) return;
      var formattedCurrentPositison = Utils.formatTime(this.currentPositionValue);
      this.$position.text(formattedCurrentPositison);
      this.lastPositionValue = this.currentPositionValue;
    }
  }, {
    key: "updateRemainingTime",
    value: function updateRemainingTime() {
      var remainingTime = (this.currentPositionValue - this.currentDurationValue) * -1;
      if (this.hasSizeChanged && parseInt(remainingTime) === parseInt(this.lastRemainingTime)) return;
      var hasRemainingTime = remainingTime > 1;
      var formattedTime = '';
      formattedTime = Utils.formatTime(hasRemainingTime ? remainingTime : 0);
      formattedTime = (hasRemainingTime ? '-' : '') + formattedTime;
      this.lastRemainingTime = remainingTime;
      this.$duration.text(formattedTime);
    }
  }, {
    key: "updateDuration",
    value: function updateDuration() {
      if (this.hasSizeChanged && parseInt(this.currentDurationValue) === parseInt(this.lastDurationValue)) return;
      var formattedTime = Utils.formatTime(this.currentDurationValue);
      this.$duration.text(formattedTime);
      this.lastDurationValue = this.currentDurationValue;
    }
  }, {
    key: "toggleTimeIndicator",
    value: function toggleTimeIndicator(event) {
      event && event.stopPropagation();
      if (!this.shouldCollapse) return;
      this.$position.is(':visible') ? this.$position.hide() : this.$position.show();
      this.$duration.is(':visible') ? this.$duration.hide() : this.$duration.show();
    }
  }, {
    key: "render",
    value: function render() {
      this.$position = $('<span/>').attr('data-position', '').html('00:00'); // eslint-disable-line no-undef

      this.$separator = $('<span/>').addClass('separator').html('/'); // eslint-disable-line no-undef

      this.$duration = $('<span/>').attr('data-duration', '').html('00:00'); // eslint-disable-line no-undef

      this.$el.empty();
      var style = Styler.getStyleFrom(css_248z$4, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
      this.$el.append(this.$position[0]);
      this.$el.append(this.$separator[0]);
      this.$el.append(this.$duration[0]);
      return this;
    }
  }]);

  return TimeIndicator;
}(MediaControlPlugin);

var pluginHTML = "<span class=\"skip-button__label\"><%= label %></span>\n";

var css_248z$5 = ".clappr-player#wp3-player-0 .media-control .skip-button {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  bottom: -8px;\n  right: 0;\n  width: auto;\n  height: auto;\n  border-radius: 4px;\n  background-color: #333;\n  margin: 0 12px;\n  pointer-events: auto;\n  z-index: 400;\n  will-change: opacity, transform;\n  transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control .skip-button__label {\n    font-family: \"opensans-regular\", sans-serif;\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.14;\n    letter-spacing: normal;\n    color: #eeeeee; }\n  .clappr-player#wp3-player-0 .media-control .skip-button:hover, .clappr-player#wp3-player-0 .media-control .skip-button:focus {\n    background-color: #eeeeee;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5); }\n    .clappr-player#wp3-player-0 .media-control .skip-button:hover .skip-button__label, .clappr-player#wp3-player-0 .media-control .skip-button:focus .skip-button__label {\n      color: #111111; }\n    .clappr-player#wp3-player-0 .media-control .skip-button:hover svg path[fill], .clappr-player#wp3-player-0 .media-control .skip-button:focus svg path[fill] {\n      fill: #111111 !important; }\n  .clappr-player#wp3-player-0 .media-control .skip-button--hidden {\n    visibility: hidden;\n    opacity: 0; }\n  .clappr-player#wp3-player-0 .media-control .skip-button--left {\n    right: auto;\n    left: 0; }\n  .clappr-player#wp3-player-0 .media-control .skip-button svg {\n    width: 24px;\n    height: 24px; }\n  .clappr-player#wp3-player-0 .media-control .skip-button--live_button, .clappr-player#wp3-player-0 .media-control .skip-button--start_over {\n    padding: 6px 12px;\n    background-color: #eee; }\n    .clappr-player#wp3-player-0 .media-control .skip-button--live_button svg, .clappr-player#wp3-player-0 .media-control .skip-button--start_over svg {\n      margin-top: 2px; }\n      .clappr-player#wp3-player-0 .media-control .skip-button--live_button svg path[fill], .clappr-player#wp3-player-0 .media-control .skip-button--start_over svg path[fill] {\n        fill: #111111; }\n    .clappr-player#wp3-player-0 .media-control .skip-button--live_button .skip-button__label, .clappr-player#wp3-player-0 .media-control .skip-button--start_over .skip-button__label {\n      color: #111111; }\n    .clappr-player#wp3-player-0 .media-control .skip-button--live_button:hover, .clappr-player#wp3-player-0 .media-control .skip-button--live_button:focus, .clappr-player#wp3-player-0 .media-control .skip-button--start_over:hover, .clappr-player#wp3-player-0 .media-control .skip-button--start_over:focus {\n      background-color: #cecece; }\n  .clappr-player#wp3-player-0 .media-control .skip-button--live_button svg {\n    transform: rotate(180deg);\n    margin-left: 5px; }\n  .clappr-player#wp3-player-0 .media-control .skip-button--start_over svg {\n    margin-right: 5px; }\n\n.clappr-player#wp3-player-0 .media-control.touch .skip-button--sticky {\n  transform: translateY(0px); }\n\n.clappr-player#wp3-player-0 .media-control.touch .skip-button--force-transform-animation {\n  transition: transform 0.3s ease; }\n\n.clappr-player#wp3-player-0 .media-control-hide .skip-button--sticky {\n  opacity: 1 !important;\n  pointer-events: auto !important; }\n\n.clappr-player#wp3-player-0 .media-control-hide.touch .skip-button--sticky {\n  transform: translateY(52px); }\n\n.clappr-player#wp3-player-0 .media-control-hide.touch.w360 .skip-button--sticky {\n  transform: translateY(60px); }\n\n.clappr-player#wp3-player-0 .media-control.volume-modal--visible.touch .skip-button, .clappr-player#wp3-player-0 .media-control.thumb-preview-modal--visible.touch .skip-button {\n  opacity: 0.5; }\n\n.clappr-player#wp3-player-0 .media-control.volume-modal--visible .skip-button, .clappr-player#wp3-player-0 .media-control.thumb-preview-modal--visible .skip-button {\n  opacity: 0.5;\n  z-index: 100; }\n\n.clappr-player#wp3-player-0 .media-control.settings-modal--visible .skip-button {\n  visibility: hidden;\n  opacity: 0; }\n\n.clappr-player#wp3-player-0 .media-control.ad .skip-button {\n  visibility: hidden;\n  opacity: 0; }\n";
styleInject(css_248z$5);

var STICKY_TIMEOUT = 5;
var MINIMUM_INTEVAL = 10;

var SkipButton = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(SkipButton, _MediaControlPlugin);

  var _super = _createSuper(SkipButton);

  function SkipButton() {
    _classCallCheck(this, SkipButton);

    return _super.apply(this, arguments);
  }

  _createClass(SkipButton, [{
    key: "onClick",
    value: function onClick() {
      this.disableButton();
      this.container.trigger(Events.SKIP_BUTTON_CLICKED, {
        name: this.name
      });
      this.seekToEndCuepoint();
    }
  }, {
    key: "seekToEndCuepoint",
    value: function seekToEndCuepoint() {
      this.container.seek(this.endCuepoint.time);
      !this.container.isPlaying() && this.container.play();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.listenTo(this.container, Events.DID_LOAD_CUEPOINTS, this.onCuepointsLoaded);
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.disableButton();
      this.resetState();
      this.bindContainerEvents();
    }
  }, {
    key: "onCuepointsLoaded",
    value: function onCuepointsLoaded() {
      var _this = this;

      var cuepoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.startCuepoint = cuepoints.find(function (cuepoint) {
        return cuepoint.type === _this.startCuepointType;
      });
      this.endCuepoint = cuepoints.find(function (cuepoint) {
        return cuepoint.type === _this.endCuepointType;
      });

      if (this.startCuepoint && this.endCuepoint && this.shouldActive) {
        this.listenTo(this.container.playback, Events$1.PLAYBACK_TIMEUPDATE, this.onTimeUpdate);
      }
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          current = _ref.current;

      var isActive = current >= this.startCuepoint.time && current < this.endCuepoint.time;
      var isSticky = current >= this.startCuepoint.time && current < this.startCuepoint.time + STICKY_TIMEOUT;

      if (isActive !== this.isActive) {
        isActive ? this.enableButton() : this.disableButton();
      }

      if (isSticky !== this.isSticky) {
        isSticky ? this.setSticky() : this.resetSticky();
      }
    }
  }, {
    key: "enableButton",
    value: function enableButton() {
      this.container.trigger(Events.SKIP_BUTTON_SHOW, {
        name: this.name
      });
      this.$el.removeClass('skip-button--hidden');
      this.bindKeyEvents();
      this.isActive = true;
    }
  }, {
    key: "disableButton",
    value: function disableButton() {
      this.$el.addClass('skip-button--hidden').removeClass('skip-button--sticky').off('transitionend');
      this.isActive = false;
    }
  }, {
    key: "setSticky",
    value: function setSticky() {
      var _this2 = this;

      if (this.mediaControl.isVisible()) return this.$el.addClass('skip-button--sticky skip-button--force-transform-animation');
      this.$el.addClass('skip-button--sticky').on('transitionend', function () {
        _this2.$el.addClass('skip-button--force-transform-animation').off('transitionend');
      });
    }
  }, {
    key: "resetSticky",
    value: function resetSticky() {
      var _this3 = this;

      this.$el.removeClass('skip-button--sticky').on('transitionend', function () {
        _this3.$el.removeClass('skip-button--force-transform-animation').off('transitionend');
      });
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.isActive = false;
    }
  }, {
    key: "bindKeyEvents",
    value: function bindKeyEvents() {
      var _this4 = this;

      if (!this.kibo) return;
      this.unbindKeyEvents();
      this.bindKeyAndShow('enter', function () {
        _this4.isSticky && _this4.onClick();
      });
    }
  }, {
    key: "unbindKeyEvents",
    value: function unbindKeyEvents() {
      if (!this.kibo) return;
      this.kibo.off('enter');
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.template({
        'label': this.label
      });
      var style = Styler.getStyleFrom(css_248z$5, {
        playerId: this.core.options.playerId
      });
      this.$el.html(content);
      this.$el.append(style[0]);
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unbindKeyEvents();

      _get(_getPrototypeOf(SkipButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "name",
    get: function get() {
      return 'skip_button';
    }
  }, {
    key: "type",
    get: function get() {
      return '';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'between';
    }
  }, {
    key: "position",
    get: function get() {
      return '';
    }
  }, {
    key: "template",
    get: function get() {
      return template(pluginHTML);
    }
  }, {
    key: "label",
    get: function get() {
      return '';
    }
  }, {
    key: "startCuepointType",
    get: function get() {
      return '';
    }
  }, {
    key: "endCuepointType",
    get: function get() {
      return '';
    }
  }, {
    key: "shouldActive",
    get: function get() {
      return this.endCuepoint.time - this.startCuepoint.time >= MINIMUM_INTEVAL;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': "media-control-button skip-button skip-button--".concat(this.type, " skip-button--hidden"),
        'data-skip-button': ''
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.onClick
      };
    }
  }, {
    key: "isSticky",
    get: function get() {
      return this.$el.hasClass('skip-button--sticky');
    }
  }]);

  return SkipButton;
}(MediaControlPlugin);

var seekStringToSeconds = Utils$1.seekStringToSeconds;

var SkipRecap = /*#__PURE__*/function (_SkipButton) {
  _inherits(SkipRecap, _SkipButton);

  var _super = _createSuper(SkipRecap);

  function SkipRecap() {
    _classCallCheck(this, SkipRecap);

    return _super.apply(this, arguments);
  }

  _createClass(SkipRecap, [{
    key: "onCuepointsLoaded",
    value: function onCuepointsLoaded() {
      var cuepoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      _get(_getPrototypeOf(SkipRecap.prototype), "onCuepointsLoaded", this).call(this, cuepoints);

      if (this.autoSkipEnabled) {
        var initialTime = this.endCuepoint.time;

        if (initialTime) {
          this.container.trigger(Events.WILL_AUTO_SKIP_RECAP);
          this.container.playback.setInitialTime(initialTime);
        }
      }
    }
  }, {
    key: "name",
    get: function get() {
      return 'skip_recap';
    }
  }, {
    key: "type",
    get: function get() {
      return 'recap';
    }
  }, {
    key: "label",
    get: function get() {
      return 'Pular Resumo';
    }
  }, {
    key: "startCuepointType",
    get: function get() {
      return 'recap_start';
    }
  }, {
    key: "endCuepointType",
    get: function get() {
      return 'recap_end';
    }
  }, {
    key: "autoSkipEnabled",
    get: function get() {
      var resumeAtEnabled = this.options.resumeAt || seekStringToSeconds();
      var autoSkipAvailable = this.options.skipRecap && this.endCuepoint;
      return autoSkipAvailable && !resumeAtEnabled;
    }
  }]);

  return SkipRecap;
}(SkipButton);

var SkipIntro = /*#__PURE__*/function (_SkipButton) {
  _inherits(SkipIntro, _SkipButton);

  var _super = _createSuper(SkipIntro);

  function SkipIntro() {
    _classCallCheck(this, SkipIntro);

    return _super.apply(this, arguments);
  }

  _createClass(SkipIntro, [{
    key: "name",
    get: function get() {
      return 'skip_intro';
    }
  }, {
    key: "type",
    get: function get() {
      return 'intro';
    }
  }, {
    key: "label",
    get: function get() {
      return 'Pular Abertura';
    }
  }, {
    key: "startCuepointType",
    get: function get() {
      return 'opening_start';
    }
  }, {
    key: "endCuepointType",
    get: function get() {
      return 'opening_end';
    }
  }]);

  return SkipIntro;
}(SkipButton);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$2.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$2(value) && objectToString$2.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_throttle = throttle;

var fowardIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title>\n        Backward\n    </title>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M11.5 18V6L3 12l8.5 6zm.5-6l8.5 6V6L12 12z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var getHostname$1 = Utils$1.getHostname,
    getCurrentTime = Utils$1.getCurrentTime,
    getTimeFromPosition = Utils$1.getTimeFromPosition;
var PROGRAM_START_TOLERANCE = 5;
var PlayerSettings$1 = window.WM && window.WM.Settings || {};

var StartOver = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(StartOver, _MediaControlPlugin);

  var _super = _createSuper(StartOver);

  _createClass(StartOver, [{
    key: "name",
    get: function get() {
      return 'start_over';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'between';
    }
  }, {
    key: "position",
    get: function get() {
      return '';
    }
  }, {
    key: "template",
    get: function get() {
      return template(pluginHTML);
    }
  }, {
    key: "innerPlayback",
    get: function get() {
      return this.playback && this.playback.playback;
    }
  }, {
    key: "programStartPositionOffset",
    get: function get() {
      return getCurrentTime(this.innerPlayback) - this.currentProgram.startTime;
    }
  }, {
    key: "programStartPosition",
    get: function get() {
      return this.innerPlayback.getCurrentTime() - this.programStartPositionOffset;
    }
  }, {
    key: "label",
    get: function get() {
      var content = 'Início';
      var fullContent = "Assistir do ".concat(content.toLowerCase());
      return this.playerSize && this.playerSize.width <= 421 ? content : fullContent;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': "media-control-button skip-button skip-button--left skip-button--".concat(this.name, " skip-button--hidden"),
        'data-skip-button': ''
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.onClick
      };
    }
  }, {
    key: "canSeekToProgramStart",
    get: function get() {
      var isStartPositionOnSeekableRange = this.innerPlayback.getCurrentTime() - this.programStartPositionOffset >= 0;
      return this.programStartPositionOffset > PROGRAM_START_TOLERANCE && isStartPositionOnSeekableRange;
    }
  }]);

  function StartOver(core) {
    var _this;

    _classCallCheck(this, StartOver);

    _this = _super.call(this, core);
    _this._throttledPositionUpdate = lodash_throttle(function () {
      var _this2;

      return (_this2 = _this).updateButtonState.apply(_this2, arguments);
    }, 5000, {
      trailing: false
    });
    _this.currentProgram = {};

    var _ref = PlayerSettings$1 && PlayerSettings$1.StartOver || {},
        Blacklist = _ref.Blacklist;

    var shouldDisable = (Blacklist || []).find(function (host) {
      return host.test(getHostname$1());
    });

    if (shouldDisable) {
      _this.destroy();
    }

    return _this;
  }

  _createClass(StartOver, [{
    key: "onClick",
    value: function onClick() {
      this.container.trigger(Events.SKIP_BUTTON_CLICKED, {
        name: this.name
      });
      if (!this.canSeekToProgramStart) return;
      this.seekToProgramStart();
      this.updateButtonState();
    }
  }, {
    key: "seekToProgramStart",
    value: function seekToProgramStart() {
      this.container.seek(this.programStartPosition);
      !this.container.isPlaying() && this.container.play();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.playback && this.stopListening(this.playback);
      this.container = this.core.activeContainer;
      this.playback = this.core.activePlayback;
      if (!this.container) return;
      this.listenToOnce(this.container, Events.DID_LOAD_EPG, this.onEPGLoaded);
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.disableButton();
      this.resetState();
      this.bindContainerEvents();
    }
  }, {
    key: "onEPGLoaded",
    value: function onEPGLoaded() {
      this.listenTo(this.container, Events.DID_CHANGE_CURRENT_PROGRAM, this.onProgramChange);
      this.listenTo(this.playback, Events$1.PLAYBACK_TIMEUPDATE, this._throttledPositionUpdate);
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize(size) {
      if (!size.width || typeof size.width !== 'number') return;
      this.playerSize = size;
      this.updateLabel();
    }
  }, {
    key: "getCurrentPositionTime",
    value: function getCurrentPositionTime() {
      var currentPosition = this.innerPlayback.getCurrentTime();
      var firstFragDateTime = this.innerPlayback.getProgramDateTime();
      var programDateTime = new Date(firstFragDateTime);
      return getTimeFromPosition(currentPosition, programDateTime);
    }
  }, {
    key: "onProgramChange",
    value: function onProgramChange() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$program = _ref2.program,
          program = _ref2$program === void 0 ? {} : _ref2$program;

      this.currentProgram = program || {};
      this.updateButtonState();
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState() {
      var stateChanged = this.isActive !== this.canSeekToProgramStart;

      if (stateChanged) {
        this.isActive = this.canSeekToProgramStart;
        this.isActive ? this.enableButton() : this.disableButton();
      }
    }
  }, {
    key: "enableButton",
    value: function enableButton() {
      this.container.trigger(Events.SKIP_BUTTON_SHOW, {
        name: this.name
      });
      this.$el.removeClass('skip-button--hidden');
    }
  }, {
    key: "disableButton",
    value: function disableButton() {
      this.$el.addClass('skip-button--hidden');
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      this.$el.find('.skip-button__label').text(this.label);
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.isActive = false;
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.template({
        'label': this.label
      });
      var style = Styler.getStyleFrom(css_248z$5, {
        playerId: this.core.options.playerId
      });
      this.$el.html(content);
      this.$el.prepend(fowardIcon);
      this.$el.append(style[0]);
      return this;
    }
  }]);

  return StartOver;
}(MediaControlPlugin);

var getHostname$2 = Utils$1.getHostname;
var PlayerSettings$2 = window.WM && window.WM.Settings || {};

var LiveButton = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(LiveButton, _MediaControlPlugin);

  var _super = _createSuper(LiveButton);

  _createClass(LiveButton, [{
    key: "name",
    get: function get() {
      return 'live_button';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'between';
    }
  }, {
    key: "position",
    get: function get() {
      return '';
    }
  }, {
    key: "template",
    get: function get() {
      return template(pluginHTML);
    }
  }, {
    key: "events",
    get: function get() {
      return {
        click: this.onClick
      };
    }
  }, {
    key: "label",
    get: function get() {
      var content = this.options && this.options.isLiveContent ? 'ao vivo' : 'agora';
      var fullContent = "Assistir ".concat(content);
      return this.playerSize && this.playerSize.width <= 421 ? content : fullContent;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': "media-control-button skip-button skip-button--".concat(this.name, " skip-button--hidden"),
        'data-skip-button': ''
      };
    }
  }]);

  function LiveButton(core) {
    var _this;

    _classCallCheck(this, LiveButton);

    _this = _super.call(this, core);

    var _ref = PlayerSettings$2 && PlayerSettings$2.StartOver || {},
        Blacklist = _ref.Blacklist;

    var shouldDisable = (Blacklist || []).find(function (host) {
      return host.test(getHostname$2());
    });

    if (shouldDisable) {
      _this.destroy();
    }

    return _this;
  }

  _createClass(LiveButton, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      this.resetDvrState();
      this.updateState();
      this.listenTo(this.container, Events$1.CONTAINER_PLAYBACKDVRSTATECHANGED, this.toggleButton);
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.updateState);
      this.listenTo(this.container, Events$1.CONTAINER_PAUSE, this.updateState);
    }
  }, {
    key: "toggleButton",
    value: function toggleButton(dvrInUse) {
      this.dvrInUse = dvrInUse;
      this.dvrInUse ? this.enableButton() : this.disableButton();
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize(size) {
      if (!size.width || typeof size.width !== 'number') return;
      this.playerSize = size;
      this.updateLabel();
    }
  }, {
    key: "onClick",
    value: function onClick() {
      // fix for iOS when the user exit fullscreen because iOS pauses the video
      if (!this.core.mediaControl.container.isPlaying()) {
        this.core.mediaControl.container.play();
      }

      if (!this.dvrInUse) return;
      this.core.mediaControl.container.seek(this.core.mediaControl.container.getDuration());
    }
  }, {
    key: "updateState",
    value: function updateState() {
      this.dvrInUse ? this.enableButton() : this.disableButton();
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      this.$el.find('.skip-button__label').text(this.label);
    }
  }, {
    key: "resetDvrState",
    value: function resetDvrState() {
      this.dvrInUse = false;
    }
  }, {
    key: "enableButton",
    value: function enableButton() {
      this.$el.removeClass('skip-button--hidden');
    }
  }, {
    key: "disableButton",
    value: function disableButton() {
      this.$el.addClass('skip-button--hidden');
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler.getStyleFrom(css_248z$5, {
        playerId: this.core.options.playerId
      });
      this.$el.html(this.template({
        'label': this.label
      }));
      this.$el.append(fowardIcon);
      this.$el.append(style[0]);
      return this;
    }
  }]);

  return LiveButton;
}(MediaControlPlugin);

var volumeHTML = "<div class=\"drawer-icon-container\" data-volume>\n  <button class=\"drawer-icon media-control-button media-control-element\" data-volume></button>\n</div>\n\n<div class=\"bar-container\" data-volume>\n  <div class=\"bar-background\" data-volume>\n    <div class=\"bar-fill-1\" data-volume></div>\n    <div class=\"bar-hover\" data-volume></div>\n  </div>\n  <div class=\"bar-scrubber\" data-volume>\n    <div class=\"bar-scrubber-icon\" data-volume></div>\n  </div>\n</div>\n";

var css_248z$6 = ".clappr-player#wp3-player-0 .drawer-container[data-volume] {\n  z-index: 300;\n  position: relative;\n  cursor: pointer; }\n  .clappr-player#wp3-player-0 .drawer-container[data-volume] .media-control-button {\n    padding: 0; }\n  .clappr-player#wp3-player-0 .drawer-container[data-volume].volume-hide {\n    z-index: auto; }\n    .clappr-player#wp3-player-0 .drawer-container[data-volume].volume-hide .bar-container[data-volume] {\n      opacity: 0;\n      visibility: hidden; }\n\n.clappr-player#wp3-player-0 .drawer-icon-container {\n  width: 24px;\n  height: 24px; }\n\n.clappr-player#wp3-player-0 .bar-container[data-volume] {\n  will-change: visibility, opacity;\n  position: absolute;\n  bottom: 42px;\n  width: 30px;\n  height: 115px;\n  left: 8px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.85);\n  transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .bar-container[data-volume]:after {\n    content: \"\";\n    width: 100%;\n    position: absolute;\n    height: 10px;\n    bottom: -10px;\n    left: 0; }\n  .clappr-player#wp3-player-0 .bar-container[data-volume] .bar-background[data-volume] {\n    position: relative;\n    top: 15px;\n    width: 2px;\n    margin-left: 14px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 10px;\n    height: calc(100% - 30px);\n    overflow: hidden;\n    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.5); }\n    .clappr-player#wp3-player-0 .bar-container[data-volume] .bar-background[data-volume] .bar-fill-1[data-volume] {\n      position: absolute;\n      bottom: 0;\n      background: #fff;\n      width: 100%;\n      height: 0;\n      transition: height .2s ease; }\n  .clappr-player#wp3-player-0 .bar-container[data-volume] .bar-scrubber[data-volume] {\n    position: absolute;\n    left: 9px;\n    width: 12px;\n    height: 12px;\n    bottom: 40%;\n    transition: bottom .2s ease; }\n    .clappr-player#wp3-player-0 .bar-container[data-volume] .bar-scrubber[data-volume] .bar-scrubber-icon[data-volume] {\n      width: 100%;\n      height: 100%;\n      border-radius: 6px;\n      background-color: #fff;\n      box-shadow: 0 0 1px black; }\n";
styleInject(css_248z$6);

var volumeOnIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M3 8.77v6h4l5 5v-16l-5 5H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var volumeOffIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var autoplayManager = Utils$1.autoplayManager;

var Volume = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(Volume, _MediaControlPlugin);

  var _super = _createSuper(Volume);

  _createClass(Volume, [{
    key: "name",
    get: function get() {
      return 'volume';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'right';
    }
  }, {
    key: "template",
    get: function get() {
      return template(volumeHTML);
    }
  }, {
    key: "volume",
    get: function get() {
      return this.container.volume;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.volume === 0;
    }
  }, {
    key: "isAd",
    get: function get() {
      return this.container.getPlaybackType() === 'ad';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'drawer-container volume-hide',
        'data-volume': ''
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        mouseenter: this.showVolumeBar,
        mouseleave: this.hideVolumeBar,
        'click .bar-container[data-volume]': 'onVolumeClick',
        'click .drawer-icon[data-volume]': 'toggleMute',
        'mousedown .bar-container[data-volume]': 'startVolumeDrag'
      };
    }
  }, {
    key: "mutedAutoplay",
    get: function get() {
      return this.idPlayback.mutedAutoplay;
    }
  }]);

  function Volume(core) {
    var _this;

    _classCallCheck(this, Volume);

    _this = _super.call(this, core);
    _this.persistConfig = _this.core.options.persistConfig;
    _this.isUserGesture = false;

    _this.stopDragHandler = function (event) {
      return _this.stopDrag(event);
    };

    _this.updateDragHandler = function (event) {
      return _this.updateDrag(event);
    };

    $(document).bind('mouseup', _this.stopDragHandler); // eslint-disable-line no-undef

    $(document).bind('mousemove', _this.updateDragHandler); // eslint-disable-line no-undef

    return _this;
  }

  _createClass(Volume, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Volume.prototype), "destroy", this).call(this);

      $(document).unbind('mouseup', this.stopDragHandler); // eslint-disable-line no-undef

      $(document).unbind('mousemove', this.updateDragHandler); // eslint-disable-line no-undef
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
      this.listenTo(this.core, Events.TAP_TO_UNMUTE_CLICKED, this.onTapToUnmuteClicked);
    }
  }, {
    key: "updateContainer",
    value: function updateContainer() {
      this.unbindContainerEvents();
      this.container = this.core.activeContainer;
      this.idPlayback = this.container && this.container.playback;
      this.container && this.bindContainerEvents();
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.updateContainer();
      this.setInitialVolume();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.listenTo(this.container, Events$1.CONTAINER_VOLUME, this.onContainerVolumeUpdate);
      this.listenTo(this.idPlayback, Events.WM_USER_PLAY_REQUESTED, this.setInitialVolume);
    }
  }, {
    key: "unbindContainerEvents",
    value: function unbindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.idPlayback && this.stopListening(this.idPlayback);
    }
  }, {
    key: "getInitialVolume",
    value: function getInitialVolume() {
      var initialVolume = this.persistConfig ? Utils.Config.restore('volume') : 100;
      this.lastVolume = initialVolume;
      if (this.core.options.mute || this.mutedAutoplay) initialVolume = 0;
      this.currentVolume = initialVolume;
      return initialVolume;
    }
  }, {
    key: "setInitialVolume",
    value: function setInitialVolume() {
      this.setVolume(this.getInitialVolume(), {
        initial: true
      });
    }
  }, {
    key: "onTapToUnmuteClicked",
    value: function onTapToUnmuteClicked() {
      this.isUserGesture = true;
      this.setVolume(this.lastVolume || 100);
      this.isAd && this.idPlayback.volume(this.lastVolume || 100);
      autoplayManager.consent();
    }
  }, {
    key: "toggleMute",
    value: function toggleMute(e) {
      e && e.stopPropagation();
      this.isUserGesture = true;
      this.setVolume(this.muted ? this.lastVolume || 100 : 0);
    }
  }, {
    key: "onContainerVolumeUpdate",
    value: function onContainerVolumeUpdate(value) {
      value = typeof value !== 'undefined' && value >= 0 ? value : this.volume;
      this.updateVolumeUI(value);
      if (this.draggingVolumeBar) return;

      if (this.currentVolume > 0 && this.muted) {
        this.container.trigger(Events.WM_MUTED, this.lastVolume, this.isUserGesture);
      } else if (this.currentVolume <= 0 && !this.muted) {
        this.container.trigger(Events.WM_UNMUTED, this.lastVolume, this.isUserGesture);
      }

      this.isUserGesture = false;
      this.lastVolume = this.currentVolume !== value ? this.currentVolume : this.lastVolume;
      this.currentVolume = value;
    }
  }, {
    key: "updateVolumeUI",
    value: function updateVolumeUI(value) {
      var _this2 = this;

      if (!this.container.isReady) {
        this.listenToOnce(this.container, Events$1.CONTAINER_READY, function () {
          return _this2.updateVolumeUI(value);
        });
      } else if (this.$volumeBarContainer) {
        this.updateVolumeBar(value);
        this.updateVolumeIcon(value);
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(value) {
      var _this3 = this;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var initial = config.initial;
      value = Math.min(100, Math.max(value, 0)); // this will hold the intended volume
      // it may not actually get set to this straight away if the container is not ready etc

      this.persistConfig && !initial && Utils.Config.persist('volume', value);

      var setWhenContainerReady = function setWhenContainerReady() {
        _this3.stopListening(_this3.idPlayback, Events.WM_PLAYBACK_WILL_PLAY);

        if (_this3.container.isReady) {
          _this3.container.setVolume(value);
        } else {
          _this3.listenToOnce(_this3.idPlayback, Events.WM_PLAYBACK_WILL_PLAY, function () {
            _this3.container.setVolume(_this3.getInitialVolume());
          });
        }
      };

      if (!this.container) {
        this.listenToOnce(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, function () {
          setWhenContainerReady();
        });
      } else {
        setWhenContainerReady();
      }
    }
  }, {
    key: "onVolumeClick",
    value: function onVolumeClick(event) {
      this.setVolume(this.getVolumeFromUIEvent(event));
    }
  }, {
    key: "getVolumeFromUIEvent",
    value: function getVolumeFromUIEvent(event) {
      var offsetY = event.pageY - this.$volumeBarContainer.offset().top;
      var volumeFromUI = (1 - offsetY / this.$volumeBarContainer.height()) * 100;
      return Math.min(100, Math.max(volumeFromUI, 0));
    }
  }, {
    key: "updateVolumeBar",
    value: function updateVolumeBar(volume) {
      var containerHeight = this.$volumeBarContainer.height();
      var barHeight = this.$volumeBarBackground.height();
      var offset = (containerHeight - barHeight) / 2.0;
      var pos = barHeight * volume / 100.0 - this.$volumeBarScrubber.height() / 2.0 + offset;
      this.$volumeBarFill.css({
        height: volume + '%'
      });
      this.$volumeBarScrubber.css({
        bottom: pos
      });
    }
  }, {
    key: "updateVolumeIcon",
    value: function updateVolumeIcon(volume) {
      this.$volumeIcon.html('');
      if (volume > 0) this.$volumeIcon.append(volumeOnIcon);else this.$volumeIcon.append(volumeOffIcon);
    }
  }, {
    key: "startVolumeDrag",
    value: function startVolumeDrag(event) {
      this.draggingVolumeBar = true;
      this.mediaControl.$el.addClass('media-control-dragging');
      this.mediaControl.setKeepVisible();
      event && event.preventDefault();
    }
  }, {
    key: "stopDrag",
    value: function stopDrag(event) {
      if (!this.draggingVolumeBar) return;
      this.mediaControl.resetKeepVisible();
      this.mediaControl.$el.removeClass('media-control-dragging');
      this.draggingVolumeBar = false;
      this.isUserGesture = true;
      this.setVolume(this.getVolumeFromUIEvent(event));
    }
  }, {
    key: "updateDrag",
    value: function updateDrag(event) {
      if (this.draggingVolumeBar) {
        event.preventDefault();
        this.setVolume(this.getVolumeFromUIEvent(event));
      }
    }
  }, {
    key: "showVolumeBar",
    value: function showVolumeBar() {
      if (Browser.supportsTouchEvents) return;
      this.hideVolumeId && clearTimeout(this.hideVolumeId);
      this.triggerWillShowModalElement();
      this.$el.removeClass('volume-hide');
      this.mediaControl && this.mediaControl.trigger(Events.WM_VOLUME_SHOW);
      this.isVolumeBarVisible = true;
    }
  }, {
    key: "hideVolumeBar",
    value: function hideVolumeBar() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isVolumeBarVisible || !this.$volumeBarContainer) return;
      typeof options.timeout !== 'number' && (options.timeout = 150);

      if (this.draggingVolumeBar) {
        this.hideVolumeId = setTimeout(function () {
          return _this4.hideVolumeBar(options);
        }, options.timeout);
      } else {
        this.hideVolumeId && clearTimeout(this.hideVolumeId);
        this.hideVolumeId = setTimeout(function () {
          _this4.$el.addClass('volume-hide');

          _this4.mediaControl && _this4.mediaControl.trigger(Events.WM_VOLUME_HIDE);
          _this4.isVolumeBarVisible = false;

          _this4.triggerDidHideModalElement();
        }, options.timeout);
      }
    }
  }, {
    key: "createCachedElements",
    value: function createCachedElements() {
      this.hasCachedElements = true;
      this.$volumeBarContainer = this.$el.find('.bar-container');
      this.$volumeIcon = this.$el.find('.drawer-icon');
      this.$volumeBarBackground = this.$el.find('.bar-background');
      this.$volumeBarFill = this.$el.find('.bar-fill-1');
      this.$volumeBarScrubber = this.$el.find('.bar-scrubber');
    }
  }, {
    key: "render",
    value: function render() {
      if (this.hasCachedElements) return;
      this.$el.html(this.template());
      var style = Styler.getStyleFrom(css_248z$6, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
      this.createCachedElements();
      this.$volumeIcon.html(volumeOnIcon);
      return this;
    }
  }]);

  return Volume;
}(MediaControlPlugin);

var seekbarHTML = "<div class=\"bar-background\" data-seekbar>\n  <div class=\"bar-fill-1\" data-seekbar></div>\n  <div class=\"bar-fill-2\" data-seekbar></div>\n  <div class=\"bar-hover\" data-seekbar></div>\n</div>\n<div class=\"bar-scrubber\" data-seekbar>\n  <div class=\"bar-scrubber-icon\" data-seekbar></div>\n</div>\n";

var css_248z$7 = ".clappr-player#wp3-player-0 .media-control.volume-modal--visible .bar-container[data-seekbar] {\n  opacity: 0.5; }\n\n.clappr-player#wp3-player-0 .media-control.volume-modal--visible .thumb-preview {\n  display: none !important; }\n\n.clappr-player#wp3-player-0 .media-control-panel__lower .bar-container[data-seekbar] {\n  padding: 12px 0; }\n\n.clappr-player#wp3-player-0 .media-control.touch .bar-container[data-seekbar]:hover .bar-background[data-seekbar] {\n  transform: translate(-50%, -50%); }\n\n.clappr-player#wp3-player-0 .media-control.touch .bar-container[data-seekbar]:hover .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n  transform: none; }\n\n.clappr-player#wp3-player-0 .media-control-dragging .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n  transform: scale(2) !important; }\n\n.clappr-player#wp3-player-0 .bar-container__placeholder {\n  height: 36px; }\n\n.clappr-player#wp3-player-0 .bar-container[data-seekbar] {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  width: calc(100% - 24px);\n  height: 24px;\n  cursor: pointer;\n  box-sizing: content-box;\n  transition: visibility 0.3s ease, opacity 0.3s ease;\n  touch-action: manipulation;\n  top: calc(50% + 6px);\n  left: 50%;\n  transform: translate(-50%, -50%); }\n  .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-background[data-seekbar] {\n    position: absolute;\n    display: flex;\n    align-self: center;\n    width: 100%;\n    height: 2px;\n    background-color: rgba(255, 255, 255, 0.2);\n    overflow: hidden;\n    top: 50%;\n    left: 50%;\n    will-change: transform;\n    transform-origin: top;\n    transform: scaleY(1) translate(-50%, -50%);\n    transition: transform .2s ease; }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar],\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 0;\n      height: 100%; }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar] {\n      background-color: rgba(255, 255, 255, 0.3);\n      transition: width .1s ease; }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n      background-color: #ffffff; }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n      display: none;\n      position: absolute;\n      width: 5px;\n      height: 100%;\n      background-color: #ff0000; }\n  .clappr-player#wp3-player-0 .bar-container[data-seekbar]:hover .bar-background[data-seekbar] {\n    transform: scaleY(2) translate(-50%, -50%); }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n      display: block; }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover-disable[data-seekbar] {\n      display: none; }\n  .clappr-player#wp3-player-0 .bar-container[data-seekbar]:hover .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n    transform: scale(1.5); }\n  .clappr-player#wp3-player-0 .bar-container[data-seekbar].seek-disabled {\n    cursor: default; }\n  .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n    position: relative;\n    display: flex;\n    align-self: center;\n    left: 0;\n    width: 8px;\n    height: 8px;\n    text-align: center;\n    z-index: 200; }\n    .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n      display: inline-block;\n      position: absolute;\n      left: 0;\n      background-color: #fff;\n      border-radius: 50%;\n      height: 100%;\n      width: 100%;\n      will-change: transform;\n      transform: scale(1);\n      transition: transform .2s ease; }\n  .clappr-player#wp3-player-0 .bar-container[data-seekbar] .bar-scrubber-mobile[data-seekbar] {\n    transition: unset; }\n";
styleInject(css_248z$7);

var Seekbar = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(Seekbar, _MediaControlPlugin);

  var _super = _createSuper(Seekbar);

  _createClass(Seekbar, [{
    key: "name",
    get: function get() {
      return 'seekbar';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'center';
    }
  }, {
    key: "template",
    get: function get() {
      return template(seekbarHTML);
    }
  }, {
    key: "settings",
    get: function get() {
      return this.container ? this.container.settings : {};
    }
  }, {
    key: "isLivePlayback",
    get: function get() {
      return this.container && this.container.getPlaybackType() === Playback.LIVE;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'bar-container',
        'data-seekbar': ''
      };
    }
  }, {
    key: "events",
    get: function get() {
      var touchEvents = {
        click: this.seek,
        touchmove: this.startActionOnSeekBar,
        touchend: this.leaveActionOnSeekBar,
        touchstart: this.startSeekDrag
      };
      var mouseEvents = {
        click: this.seek,
        mousemove: this.startActionOnSeekBar,
        mouseleave: this.leaveActionOnSeekBar,
        'mousedown .bar-scrubber[data-seekbar]': 'startSeekDrag'
      };

      var hybridEvents = _objectSpread2(_objectSpread2({}, touchEvents), mouseEvents);

      return Browser.isHybridDevice ? hybridEvents : Browser.supportsTouchEvents ? touchEvents : mouseEvents;
    }
  }]);

  function Seekbar(core) {
    var _this;

    _classCallCheck(this, Seekbar);

    _this = _super.call(this, core);

    _this.stopDragHandler = function (event) {
      return _this.stopDrag(event);
    };

    _this.updateDragHandler = function (event) {
      return _this.updateDrag(event);
    };

    if (Browser.supportsTouchEvents) {
      $$1(document).bind('touchend', _this.stopDragHandler); // eslint-disable-line no-undef

      $$1(document).bind('touchmove', _this.updateDragHandler); // eslint-disable-line no-undef
    }

    if (!Browser.supportsTouchEvents || Browser.isHybridDevice) {
      $$1(document).bind('mouseup', _this.stopDragHandler); // eslint-disable-line no-undef

      $$1(document).bind('mousemove', _this.updateDragHandler); // eslint-disable-line no-undef
    }

    return _this;
  }

  _createClass(Seekbar, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Seekbar.prototype), "destroy", this).call(this);

      $$1(document).unbind('mouseup', this.stopDragHandler); // eslint-disable-line no-undef

      $$1(document).unbind('touchend', this.stopDragHandler); // eslint-disable-line no-undef

      $$1(document).unbind('mousemove', this.updateDragHandler); // eslint-disable-line no-undef

      $$1(document).unbind('touchmove', this.updateDragHandler); // eslint-disable-line no-undef
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.listenTo(this.container, Events$1.CONTAINER_TIMEUPDATE, this.onTimeUpdate);
      this.listenTo(this.container, Events$1.CONTAINER_PROGRESS, this.updateProgressBar); // reset seekbar state when change container (update video source)

      this.setSeekPercentage(0);
    }
  }, {
    key: "createCachedElements",
    value: function createCachedElements() {
      this.$seekBarContainer = this.$el;
      this.$seekBarHover = this.$el.find('.bar-hover[data-seekbar]');
      this.$seekBarLoaded = this.$el.find('.bar-fill-1[data-seekbar]');
      this.$seekBarPosition = this.$el.find('.bar-fill-2[data-seekbar]');
      this.$seekBarScrubber = this.$el.find('.bar-scrubber[data-seekbar]');
      this.$seekBarScrubberIcon = this.$el.find('.bar-scrubber-icon[data-seekbar]');

      if (Browser.isMobile) {
        this.$seekBarHover.addClass('bar-hover-disable');
        this.$seekBarScrubber.addClass('bar-scrubber-mobile');
      }

      this.mediaControl.$seekBarContainer = this.$seekBarContainer;
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize() {
      this.setSeekPercentage(this.currentSeekPercentage);
    }
  }, {
    key: "setSeekPercentage",
    value: function setSeekPercentage(value) {
      value = Math.min(value, 100.0);
      var pos = this.$seekBarContainer.width() * value / 100.0 - this.$seekBarScrubber.width() / 2.0;
      pos = Math.max(pos, -(this.$seekBarScrubber.width() - this.$seekBarScrubberIcon.width()) / 2.0);
      pos = Math.min(pos, this.$seekBarContainer.width() - this.$seekBarScrubber.width() / 2.0 - this.$seekBarScrubberIcon.width() / 2.0);
      this.currentSeekPercentage = value;
      var offset = this.$seekBarScrubberIcon.width() / 4.0;
      if (isNaN(offset) || isNaN(value) || isNaN(pos)) return;
      this.$seekBarPosition.css({
        width: "calc(".concat(value, "% + ").concat(offset, "px)")
      });
      this.$seekBarScrubber.css({
        transform: "translateX(".concat(pos, "px)")
      });
    }
  }, {
    key: "stopDrag",
    value: function stopDrag(event) {
      if (!this.draggingSeekBar) return;

      if (this.draggingSeekBar) {
        this.seek(event);
      }

      this.mediaControl.$el.removeClass('media-control-dragging');
      this.$seekBarLoaded.removeClass('media-control-notransition');
      this.$seekBarPosition.removeClass('media-control-notransition');
      this.$seekBarScrubber.removeClass('media-control-notransition media-control-dragging');
      this.core.trigger(Events.STOP_DRAGGING_SEEKBAR);
      this.draggingSeekBar = false;
      this.mediaControl.resetKeepVisible();
    }
  }, {
    key: "lastTouchEvent",
    value: function lastTouchEvent(e) {
      var event = e.originalEvent ? e.originalEvent : e;

      if (event.touches && event.touches.length > 0) {
        return event.touches[event.touches.length - 1];
      } else if (event.changedTouches && event.changedTouches.length > 0) {
        return event.changedTouches[event.changedTouches.length - 1];
      }

      return {};
    }
  }, {
    key: "updateDrag",
    value: function updateDrag(event) {
      if (!this.draggingSeekBar) return;
      event.preventDefault();
      var pageX = event.pageX || this.lastTouchEvent(event).pageX;
      var offsetX = pageX - this.$seekBarContainer.offset().left;
      var pos = offsetX / this.$seekBarContainer.width() * 100;
      pos = Math.min(100, Math.max(pos, 0));
      this.setSeekPercentage(pos);
    }
  }, {
    key: "startSeekDrag",
    value: function startSeekDrag(e) {
      if (!this.settings.seekEnabled) return;
      this.core.trigger(Events.START_DRAGGING_SEEKBAR);
      this.draggingSeekBar = true;
      this.mediaControl.setKeepVisible();
      this.mediaControl.$el.addClass('media-control-dragging');
      this.$seekBarLoaded.addClass('media-control-notransition');
      this.$seekBarPosition.addClass('media-control-notransition');
      this.$seekBarScrubber.addClass('media-control-notransition');
      Browser.isHybridDevice && e && e.preventDefault();
    }
  }, {
    key: "startActionOnSeekBar",
    value: function startActionOnSeekBar(event) {
      if (this.settings.seekEnabled) {
        var pageX = event.pageX || this.lastTouchEvent(event).pageX;
        var offsetX = pageX - this.$seekBarContainer.offset().left - this.$seekBarHover.width() / 2;
        this.$seekBarHover.css({
          left: offsetX
        });
      }

      this.mediaControl.trigger(Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, event);
    }
  }, {
    key: "leaveActionOnSeekBar",
    value: function leaveActionOnSeekBar(event) {
      this.mediaControl.trigger(Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, event);
    }
  }, {
    key: "seek",
    value: function seek(event) {
      if (!this.settings.seekEnabled) return;
      var pageX = event.pageX || this.lastTouchEvent(event).pageX || 0;
      var offsetX = Math.max(0, pageX - this.$seekBarContainer.offset().left);
      var pos = offsetX / this.$seekBarContainer.width() * 100;
      pos = Math.min(100, Math.max(pos, 0.01));
      this.container.seekPercentage(pos);
      this.setSeekPercentage(pos);
      return false;
    }
  }, {
    key: "updateProgressBar",
    value: function updateProgressBar(progress) {
      var loadedStart = progress.start / progress.total * 100;
      var loadedEnd = progress.current / progress.total * 100;
      this.$seekBarLoaded.css({
        left: "".concat(loadedStart, "%"),
        width: "".concat(loadedEnd - loadedStart, "%")
      });
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate(timeProgress) {
      if (this.draggingSeekBar) return;
      this.currentPositionValue = timeProgress.current < 0 ? 0 : timeProgress.current;
      this.currentDurationValue = timeProgress.total;
      this.renderSeekBar();
    }
  }, {
    key: "renderSeekBar",
    value: function renderSeekBar() {
      // this will be triggered as soon as these become available
      if (this.currentPositionValue === null || this.currentDurationValue === null) return;
      this.currentSeekBarPercentage = this.isLivePlayback ? 100 : 0;

      if (!this.isLivePlayback || this.container.isDvrInUse()) {
        this.currentSeekBarPercentage = this.currentPositionValue / this.currentDurationValue * 100;
      }

      this.setSeekPercentage(this.currentSeekBarPercentage);
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.html(this.template());
      var style = Styler.getStyleFrom(css_248z$7, {
        playerId: this.core.options.playerId
      });
      var seekbarPlaceholder = $$1('<div>').addClass('bar-container__placeholder');
      this.$el.append(style[0]);
      this.$el.parent().append(seekbarPlaceholder);
      this.createCachedElements();
      return this;
    }
  }]);

  return Seekbar;
}(MediaControlPlugin);

var quickSeekHTML = "<div class=\"quick-seek-container\">\n  <div class=\"quick-seek-placeholder quick-seek-placeholder--left\">\n    <div class=\"quick-seek-placeholder-background quick-seek-placeholder-background--left\"></div>\n    <div class=\"quick-seek-arrow-placeholder\">\n      <figure class=\"quick-seek-arrow\">\n        <%= backwardSeekArrow %>\n      </figure>\n      <span class=\"quick-seek-label left\"><%= currentSeekTime %></span>\n    </div>\n  </div>\n  <div class=\"quick-seek-placeholder quick-seek-placeholder--right\">\n    <div class=\"quick-seek-placeholder-background quick-seek-placeholder-background--right\"></div>\n    <div class=\"quick-seek-arrow-placeholder\">\n      <figure class=\"quick-seek-arrow\">\n        <%= forwardSeekArrow %>\n      </figure>\n      <span class=\"quick-seek-label\"><%= currentSeekTime %></span>\n    </div>\n  </div>\n</div>";

var css_248z$8 = ".clappr-player#wp3-player-0 .media-control .quick-seek {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek.hidden {\n    visibility: hidden; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-container {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-label {\n    display: inline-block;\n    position: absolute;\n    font-weight: bold;\n    font-family: \"opensans-regular\";\n    font-weight: 700;\n    letter-spacing: 0px;\n    font-size: 12px;\n    color: #eee;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    margin-bottom: 8px;\n    top: 40%;\n    left: 36%; }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-label.triple-digit {\n      font-size: 10px;\n      left: calc(50% - 9px); }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-label.visible {\n      opacity: 1; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-arrow-placeholder {\n    position: relative;\n    display: flex; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-arrow {\n    display: inline-block;\n    justify-content: center;\n    opacity: 0;\n    transform-origin: 24px 26px;\n    transition: transform 0.6s ease, opacity 0.3s ease;\n    margin: 0; }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-arrow.visible {\n      opacity: 1; }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-arrow svg {\n      width: 48px;\n      height: 48px; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-placeholder {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #eee;\n    width: 45%; }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-placeholder-background {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      z-index: -1;\n      right: -50%;\n      bottom: 0px;\n      border-radius: 50%;\n      background: rgba(0, 0, 0, 0.3);\n      transform: scaleX(0.9) scaleY(1.4);\n      transform-origin: center center;\n      opacity: 0;\n      will-change: opacity, transform; }\n      .clappr-player#wp3-player-0 .media-control .quick-seek-placeholder-background--left {\n        left: -50%; }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-placeholder--left .quick-seek-arrow-placeholder {\n      flex-direction: row-reverse; }\n    .clappr-player#wp3-player-0 .media-control .quick-seek-placeholder-background.background-show {\n      opacity: 1;\n      transition: transform 0.6s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek.media-control-element {\n    padding: 0;\n    opacity: 1 !important; }\n";
styleInject(css_248z$8);

var backwardSeekArrow = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 48 48\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path fill=\"#111\" fill-opacity=\"0\" d=\"M0 0H48V48H0z\"/>\n        <path fill=\"#EEE\" fill-rule=\"nonzero\" d=\"M24 10V2L14 12l10 10v-8c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z\"/>\n    </g>\n</svg>";

var forwardSeekArrow = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 48 48\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path fill=\"#111\" fill-opacity=\"0\" d=\"M0 0H48V48H0z\"/>\n        <path fill=\"#EEE\" fill-rule=\"nonzero\" d=\"M24 10V2l10 10-10 10v-8c-6.62 0-12 5.38-12 12s5.38 12 12 12 12-5.38 12-12h4c0 8.84-7.16 16-16 16S8 34.84 8 26s7.16-16 16-16z\"/>\n    </g>\n</svg>";

var DEFAULT_SEEK_VALUE = 10;
var FEEDBACK_HIDE_DELAY = 400; // 400ms

var numberKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
var mapKeyToTime = {
  'left': -10,
  'right': 10,
  'shift left': -15,
  'shift right': 15,
  'shift ctrl left': -20,
  'shift ctrl right': 20
};

var QuickSeek = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(QuickSeek, _MediaControlPlugin);

  var _super = _createSuper(QuickSeek);

  function QuickSeek() {
    _classCallCheck(this, QuickSeek);

    return _super.apply(this, arguments);
  }

  _createClass(QuickSeek, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events.MEDIACONTROL_DOUBLE_TAP, this.onMediaControlDoubleTap);
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.updateContainer);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_SHOW, this.onMediaControlShow);
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, this.bindKeyEvents);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.onContainerEnd);
    }
  }, {
    key: "bindKeyEvents",
    value: function bindKeyEvents() {
      var _this = this;

      if (!this.kibo) return;
      this.unbindKeyEvents();
      Object.keys(mapKeyToTime).forEach(function (key) {
        _this.bindKeyAndShow(key, function () {
          return _this.onKeyPress(key);
        });
      });
      numberKeys.forEach(function (i) {
        _this.bindKeyAndShow(i, function () {
          return _this.canSeek && _this.container.seekPercentage(i * 10 + 0.1);
        });
      });
    }
  }, {
    key: "unbindKeyEvents",
    value: function unbindKeyEvents() {
      if (!this.kibo) return;
      this.kibo.off(Object.keys(mapKeyToTime));
      this.kibo.off(numberKeys);
    }
  }, {
    key: "updateContainer",
    value: function updateContainer() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      this.bindContainerEvents();
    }
  }, {
    key: "onContainerEnd",
    value: function onContainerEnd() {
      this.unbindKeyEvents();
      this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, this.bindKeyEvents);
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(key) {
      if (!this.canSeek) return;
      this.container.trigger(Events.WILL_QUICK_SEEK);
      this.seekRelative(mapKeyToTime[key]);
    }
  }, {
    key: "seekRelative",
    value: function seekRelative(delta) {
      var currentTime = this.container.getCurrentTime();
      var duration = this.container.getDuration();
      var position = Math.min(Math.max(currentTime + delta, 0), duration);
      position = Math.min(position * 100 / duration + 0.01, 100);
      this.container.seekPercentage(position);
    }
  }, {
    key: "onMediaControlDoubleTap",
    value: function onMediaControlDoubleTap() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          tapSide = _ref.tapSide;

      if (!this.canSeek || tapSide === 'left' && this.willBackwardToVideoEnd || tapSide === 'right' && this.willForwardToVideoEnd) return;
      this.container.trigger(Events.WILL_QUICK_SEEK);

      if ('vibrate' in navigator) {
        window.navigator.vibrate(15);
      }

      if (this.feedBackInProgress) {
        if (this.lastTapSide === tapSide) {
          this.updateQuickSeekFeedback();
        } else {
          this.hideQuickSeekFeedback();
          this.showQuickSeekFeedback(tapSide);
        }
      } else {
        this.showQuickSeekFeedback(tapSide);
      }

      this.container.seek(this.targetSeekValue(tapSide));
    }
  }, {
    key: "targetSeekValue",
    value: function targetSeekValue(tapSide) {
      var quickSeekValue = tapSide === 'right' ? DEFAULT_SEEK_VALUE : -DEFAULT_SEEK_VALUE;
      return Math.min(this.container.getDuration() - 1, Math.max(0.1, this.container.currentTime + quickSeekValue));
    }
  }, {
    key: "cacheAnimatedElements",
    value: function cacheAnimatedElements(tapSide) {
      this.background = this.$el.find(".quick-seek-placeholder-background--".concat(tapSide));
      this.arrow = this.$el.find(".quick-seek-placeholder--".concat(tapSide, " .quick-seek-arrow-placeholder .quick-seek-arrow"));
      this.label = this.$el.find(".quick-seek-placeholder--".concat(tapSide, " .quick-seek-label"));
    }
  }, {
    key: "showQuickSeekFeedback",
    value: function showQuickSeekFeedback(tapSide) {
      var _this2 = this;

      // animation flow:
      // display background -> display arrow -> display label
      // -> hide all plugin elements
      this.lastTapSide = tapSide;
      this.feedBackInProgress = true;
      this.showPlugin();
      this.cacheAnimatedElements(tapSide);
      this.resetLabelClasses(); // Zepto.js was, in this plugin's specific case, replaced by native JS Event Handling
      // because the animations weren't flowing properly when using the Mobile Player in Globoplay. 
      // We also had to use setTimeout to delay the addition of classes, in order for the animations to
      // properly occur.

      this.background[0].addEventListener('transitionend', function (e) {
        return _this2.onBackgroundShow(e);
      }, {
        once: true
      });
      setTimeout(function () {
        return _this2.background.addClass('background-show');
      });
      this.displayArrow();
    }
  }, {
    key: "onBackgroundShow",
    value: function onBackgroundShow(e) {
      e.stopPropagation(); // will complete background show when propertyName is equal to transition

      if (e.propertyName === 'opacity') return; // force opacity transtition for hiding animation

      this.background.addClass('opacity-transition');
    }
  }, {
    key: "displayArrow",
    value: function displayArrow() {
      var _this3 = this;

      this.arrow[0].addEventListener('transitionend', function (e) {
        return _this3.onArrowShow(e);
      }, {
        once: true
      });
      setTimeout(function () {
        return _this3.arrow.addClass('visible');
      });
      this.spinArrow();
    }
  }, {
    key: "onArrowShow",
    value: function onArrowShow(e) {
      e.stopPropagation();
      this.displayLabel();
    }
  }, {
    key: "spinArrow",
    value: function spinArrow() {
      var _this4 = this;

      if (this.lastTapSide === 'left') {
        !this.leftArrowDegrees && (this.leftArrowDegrees = 0);
        this.leftArrowDegrees -= 360;
        setTimeout(function () {
          return _this4.arrow[0].style.cssText = "transform: rotate(".concat(_this4.leftArrowDegrees, "deg);");
        });
      } else {
        !this.rightArrowDegrees && (this.rightArrowDegrees = 0);
        this.rightArrowDegrees += 360;
        setTimeout(function () {
          return _this4.arrow[0].style.cssText = "transform: rotate(".concat(_this4.rightArrowDegrees, "deg);");
        });
      }
    }
  }, {
    key: "displayLabel",
    value: function displayLabel() {
      var _this5 = this;

      // update font size and pixel position for triple digit numbers
      if (this.currentSeekTime >= 100) this.label.addClass('triple-digit');
      this.label.text(this.currentSeekTime);
      this.label[0].addEventListener('transitionend', function (e) {
        return _this5.onLabelShow(e);
      }, {
        once: true
      });
      setTimeout(function () {
        return _this5.label.addClass('visible');
      });
    }
  }, {
    key: "onLabelShow",
    value: function onLabelShow(e) {
      var _this6 = this;

      e.stopPropagation();
      this.timeoutId = setTimeout(function () {
        _this6.hideQuickSeekFeedback();
      }, FEEDBACK_HIDE_DELAY);
    }
  }, {
    key: "updateQuickSeekFeedback",
    value: function updateQuickSeekFeedback() {
      var _this7 = this;

      this.timeoutId && clearTimeout(this.timeoutId);
      this.spinArrow();
      this.currentSeekTime += DEFAULT_SEEK_VALUE;
      this.hideLabel();
      if (this.currentSeekTime !== 990) setTimeout(function () {
        _this7.displayLabel();
      }, 350);
    }
  }, {
    key: "hideQuickSeekFeedback",
    value: function hideQuickSeekFeedback() {
      if (!this.feedBackInProgress) return;
      clearTimeout(this.timeoutId);
      this.hideLabel();
      this.hideArrow();
      this.hideBackground();
      this.currentSeekTime = DEFAULT_SEEK_VALUE;
      this.feedBackInProgress = false;
      this.hidePlugin();
    }
  }, {
    key: "onMediaControlShow",
    value: function onMediaControlShow() {
      this.hideQuickSeekFeedback();
    }
  }, {
    key: "hideLabel",
    value: function hideLabel() {
      this.label.removeClass('visible');
    }
  }, {
    key: "resetLabelClasses",
    value: function resetLabelClasses() {
      this.label.removeClass('triple-digit');
    }
  }, {
    key: "hideArrow",
    value: function hideArrow() {
      this.arrow.removeClass('visible');
    }
  }, {
    key: "hideBackground",
    value: function hideBackground() {
      this.background.removeClass('background-show');
    }
  }, {
    key: "showPlugin",
    value: function showPlugin() {
      this.$el.removeClass('hidden');
    }
  }, {
    key: "hidePlugin",
    value: function hidePlugin() {
      this.$el.addClass('hidden');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(QuickSeek.prototype), "destroy", this).call(this);

      this.unbindKeyEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler.getStyleFrom(css_248z$8, {
        playerId: this.core.options.playerId
      });
      this.$el.html(this.template({
        backwardSeekArrow: backwardSeekArrow,
        forwardSeekArrow: forwardSeekArrow,
        currentSeekTime: this.currentSeekTime
      }));
      this.$el.append(style[0]);
      return this;
    }
  }, {
    key: "name",
    get: function get() {
      return 'quick_seek';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'middle';
    }
  }, {
    key: "position",
    get: function get() {
      return '';
    }
  }, {
    key: "template",
    get: function get() {
      return template(quickSeekHTML);
    }
  }, {
    key: "settings",
    get: function get() {
      return this.container ? this.container.settings : {};
    }
  }, {
    key: "canSeek",
    get: function get() {
      return this.settings.seekEnabled;
    }
  }, {
    key: "willBackwardToVideoEnd",
    get: function get() {
      return this.container.currentTime - 3 < 0;
    }
  }, {
    key: "willForwardToVideoEnd",
    get: function get() {
      return this.container.currentTime + DEFAULT_SEEK_VALUE > this.container.getDuration();
    }
  }, {
    key: "currentSeekTime",
    get: function get() {
      return this._currentSeekTime || DEFAULT_SEEK_VALUE;
    },
    set: function set(value) {
      if (value <= 990) this._currentSeekTime = value;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'quick-seek hidden'
      };
    }
  }]);

  return QuickSeek;
}(MediaControlPlugin);

var arrowKey = "<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><rect stroke=\"#EEE\" opacity=\".3\" x=\".5\" y=\".5\" width=\"19\" height=\"19\" rx=\"2\"/><path d=\"M8 9h8v2H8v3l-4-4 4-4v3z\" fill=\"#EEE\"/></g></svg>";

var backward10 = "<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><path d=\"M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.2-.1-.2-.3-.3-.6-.1-.3-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.3.2.5.3.2.1.2.3.3.6.1.3.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3c0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.1 0-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3c0 .1.1.1.2.2s.2.1.3.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z\" fill=\"#FFF\" fill-rule=\"nonzero\"/></g></svg>";

var forward10 = "<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><path d=\"M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16h-.1zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.2-.1-.2-.3-.3-.6-.1-.3-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.3.2.5.3.2.1.2.3.3.6.1.3.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3c0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.1 0-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3c0 .1.1.1.2.2s.2.1.3.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z\" fill=\"#FFF\" fill-rule=\"nonzero\"/></g></svg>";

var quickSeekHintHTML = "<span class=\"quick-seek-hint__label\">\n  <% if (isMobile) { %>\n    <span class=\"quick-seek-hint__arrow quick-seek-hint__arrow--left\"><%= backward10 %></span>\n    Toque duplo para avançar\n    <span class=\"quick-seek-hint__arrow quick-seek-hint__arrow--right\"><%= forward10 %></span>\n  <% } else { %>\n    Use as teclas\n    <span class=\"quick-seek-hint__arrow quick-seek-hint__arrow--left\"><%= arrow %></span>\n    <span class=\"quick-seek-hint__arrow quick-seek-hint__arrow--right\"><%= arrow %></span>\n  para avançar\n  <% } %>\n</span>\n";

var css_248z$9 = ".clappr-player#wp3-player-0 .media-control.ad .quick-seek-hint {\n  display: none; }\n\n.clappr-player#wp3-player-0 .media-control.touch .quick-seek-hint {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  width: 100%;\n  padding-right: 0;\n  padding-left: 0; }\n  .clappr-player#wp3-player-0 .media-control.touch .quick-seek-hint__label {\n    margin: 0 auto; }\n  .clappr-player#wp3-player-0 .media-control.touch .quick-seek-hint__arrow {\n    width: 24px;\n    height: 24px; }\n    .clappr-player#wp3-player-0 .media-control.touch .quick-seek-hint__arrow--left {\n      margin-left: 0;\n      margin-right: 8px; }\n    .clappr-player#wp3-player-0 .media-control.touch .quick-seek-hint__arrow--right {\n      margin-right: 0;\n      margin-left: 8px;\n      transform: rotate(0); }\n\n.clappr-player#wp3-player-0 .media-control .quick-seek-hint--disabled {\n  display: none; }\n\n.clappr-player#wp3-player-0 .media-control .quick-seek-hint.hidden {\n  opacity: 0;\n  visibility: hidden; }\n\n.clappr-player#wp3-player-0 .media-control .quick-seek-hint__container {\n  display: flex; }\n\n.clappr-player#wp3-player-0 .media-control .quick-seek-hint__arrow {\n  display: inline-block;\n  width: 20px;\n  height: 20px; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-hint__arrow svg {\n    width: 100%;\n    height: 100%; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-hint__arrow--left {\n    margin-left: 8px;\n    margin-right: 4px; }\n  .clappr-player#wp3-player-0 .media-control .quick-seek-hint__arrow--right {\n    margin-right: 8px;\n    transform: rotate(180deg); }\n\n.clappr-player#wp3-player-0 .media-control .quick-seek-hint__label {\n  display: flex;\n  align-items: center;\n  opacity: 0.8;\n  font-family: \"opensans-regular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.14;\n  letter-spacing: normal;\n  color: #eeeeee; }\n";
styleInject(css_248z$9);

var DESKTOP_BREAKPOINT = 600;
var MOBILE_BREAKPOINT = 361;
var HIDE_DELAY_TIMEOUT = 4000;
var SHOW_DELAY_TIMEOUT = 1000;

var QuickSeekHint = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(QuickSeekHint, _MediaControlPlugin);

  var _super = _createSuper(QuickSeekHint);

  _createClass(QuickSeekHint, [{
    key: "name",
    get: function get() {
      return 'quick_seek_hint';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return Browser.isMobile ? 'upper' : 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return Browser.isMobile ? '' : 'between';
    }
  }, {
    key: "template",
    get: function get() {
      return template(quickSeekHintHTML);
    }
  }, {
    key: "container",
    get: function get() {
      return this.core && this.core.activeContainer;
    }
  }, {
    key: "settings",
    get: function get() {
      return this.container ? this.container.settings : {};
    }
  }, {
    key: "canSeek",
    get: function get() {
      return this.settings.seekEnabled;
    }
  }, {
    key: "shouldDisable",
    get: function get() {
      return this.currentWidth <= (Browser.isMobile ? MOBILE_BREAKPOINT : DESKTOP_BREAKPOINT);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'quick-seek-hint hidden'
      };
    }
  }]);

  function QuickSeekHint(core) {
    var _this;

    _classCallCheck(this, QuickSeekHint);

    _this = _super.call(this, core);
    _this.mouseOverSeekbar = false;
    _this.draggingSeekbar = false;
    _this.isVisible = false;
    _this.waitingTimeoutToShow = false;
    _this.waitingTimeoutToHide = false;
    return _this;
  }

  _createClass(QuickSeekHint, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
      this.bindSeekbarEvents();
    }
  }, {
    key: "bindSeekbarEvents",
    value: function bindSeekbarEvents() {
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.onMousemoveSeekbar);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.onMouseLeaveSeekbar);
      this.listenTo(this.core, Events.START_DRAGGING_SEEKBAR, this.onStartDraggingSeekbar);
      this.listenTo(this.core, Events.STOP_DRAGGING_SEEKBAR, this.onStopDraggingSeekbar);
      this.seekbarEventsActive = true;
    }
  }, {
    key: "unbindSeekbarEvents",
    value: function unbindSeekbarEvents() {
      this.stopListening(this.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.onMousemoveSeekbar);
      this.stopListening(this.mediaControl, Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.onMouseLeaveSeekbar);
      this.stopListening(this.core, Events.START_DRAGGING_SEEKBAR, this.onStartDraggingSeekbar);
      this.stopListening(this.core, Events.STOP_DRAGGING_SEEKBAR, this.onStopDraggingSeekbar);
      this.seekbarEventsActive = false;
    }
  }, {
    key: "onStartDraggingSeekbar",
    value: function onStartDraggingSeekbar() {
      this.draggingSeekbar = true;
    }
  }, {
    key: "onStopDraggingSeekbar",
    value: function onStopDraggingSeekbar() {
      this.draggingSeekbar = false; // clear showTimeout when stop dragging. It can happen on mobile devices

      if (this.waitingTimeoutToShow) {
        this.resetTimeoutToShow();
      } // force hide on stop dragging on mobile or when mouse is not over seekbar on desktop


      if (this.waitingTimeoutToHide && (Browser.isMobile || !this.mouseOverSeekbar)) {
        this.resetTimeoutToHide();
        this.hide();
      }
    }
  }, {
    key: "onMousemoveSeekbar",
    value: function onMousemoveSeekbar() {
      var _this2 = this;

      this.mouseOverSeekbar = true;
      if (this.isVisible || this.waitingTimeoutToShow || this.draggingSeekbar && !Browser.isMobile || this.waitingMouseLeaveSeekbarAfterHide) return; // no timeout to show on mobile

      if (Browser.isMobile) return this.show();
      this.waitingTimeoutToShow = true;
      this.showTimeoutId = setTimeout(function () {
        _this2.showTimeoutId = null;
        _this2.waitingTimeoutToShow = false;

        _this2.show();
      }, SHOW_DELAY_TIMEOUT);
    }
  }, {
    key: "onMouseLeaveSeekbar",
    value: function onMouseLeaveSeekbar() {
      this.mouseOverSeekbar = false;
      this.waitingMouseLeaveSeekbarAfterHide = false; // avoid hide when leave seekbar while holding (dragging)

      if (this.draggingSeekbar) return;
      this.waitingTimeoutToHide && this.resetTimeoutToHide();
      this.waitingTimeoutToShow && this.resetTimeoutToShow();
      this.hide();
    }
  }, {
    key: "resetTimeoutToHide",
    value: function resetTimeoutToHide() {
      clearTimeout(this.hideTimeoutId);
      this.waitingTimeoutToHide = false;
      this.hideTimeoutId = null;
    }
  }, {
    key: "resetTimeoutToShow",
    value: function resetTimeoutToShow() {
      clearTimeout(this.showTimeoutId);
      this.waitingTimeoutToShow = false;
      this.showTimeoutId = null;
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isValidSize = size.width && typeof size.width === 'number';
      var sizeChanged = this.currentWidth !== size.width;
      if (!isValidSize || !sizeChanged) return;
      this.currentWidth = size.width;
      this.currentHeight = size.height;
      this.updateResponsiveStyle();
    }
  }, {
    key: "updateResponsiveStyle",
    value: function updateResponsiveStyle() {
      if (this.shouldDisable) {
        this.unbindSeekbarEvents();
        this.$el.addClass('quick-seek-hint--disabled');
      } else {
        !this.seekbarEventsActive && this.bindSeekbarEvents();
        this.$el.removeClass('quick-seek-hint--disabled');
      }
    }
  }, {
    key: "show",
    value: function show() {
      if (this.isVisible) return;
      this.isVisible = true;
      this.core.trigger(Events.WILL_SHOW_QUICK_SEEK_HINT);
      this.$el.removeClass('hidden');
      Browser.isMobile && this.$el.addClass('media-control-element--sticky');
      this.hideDelayed();
    }
  }, {
    key: "hideDelayed",
    value: function hideDelayed() {
      var _this3 = this;

      this.waitingTimeoutToHide = true;
      this.hideTimeoutId = setTimeout(function () {
        _this3.hideTimeoutId = null;
        _this3.waitingTimeoutToHide = false;

        _this3.hide();
      }, HIDE_DELAY_TIMEOUT);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.mouseOverSeekbar && (this.waitingMouseLeaveSeekbarAfterHide = true);
      if (!this.isVisible) return;
      this.core.trigger(Events.WILL_HIDE_QUICK_SEEK_HINT);
      this.$el.addClass('hidden');
      Browser.isMobile && this.$el.removeClass('media-control-element--sticky');
      this.isVisible = false;
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler.getStyleFrom(css_248z$9, {
        playerId: this.core.options.playerId
      });
      this.$el.html(this.template({
        isMobile: Browser.isMobile,
        arrow: arrowKey,
        backward10: backward10,
        forward10: forward10
      }));
      this.$el.append(style[0]);
      return this;
    }
  }]);

  return QuickSeekHint;
}(MediaControlPlugin);

function getUrlWithUTMQueryString(url, source) {
  return encodeURIComponent(url + "?utm_source=".concat(source, "&utm_medium=share-player-desktop"));
}

function openShareWindow(url, windowTitle) {
  var size = 500;
  var left = window.screen.width / 2 - (size / 2 + 10);
  var top = window.screen.height / 2 - (size / 2 + 50);
  var props = "height=".concat(size, ",width=").concat(size, ",left=").concat(left, ",top=").concat(top, ",screenX=").concat(left, ",screenY=").concat(top, ",\n               resizable=yes,status=no,toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");
  window.open(url, windowTitle, props);
}
function facebookWindow(videoUrl, videoTitle) {
  // https://developers.facebook.com/docs/sharing/reference/share-dialog
  var globoAppID = '289255557788943';
  var urlWithUTMQueryString = getUrlWithUTMQueryString(videoUrl, 'facebook');
  var baseUrl = 'https://www.facebook.com/dialog/share';
  var queryString = "?app_id=".concat(globoAppID, "&display=popup&href=").concat(urlWithUTMQueryString);
  var globoPlayURL = videoUrl.search('globoplay') != -1 ? true : false;
  if (globoPlayURL) queryString += "&hashtag=".concat(encodeURIComponent('#GloboPlay'));
  var shareUrl = "".concat(baseUrl).concat(queryString);
  openShareWindow(shareUrl, videoTitle);
}
function twitterWindow(videoUrl, videoTitle, videoProgram) {
  // it's possible to add parameters using twitter snnipet https://dev.twitter.com/web/tweet-button
  var programHashtag = getVideoProgramHashtag(videoProgram);
  var globoPlayMessage = videoUrl.search('globoplay') != -1 ? ' pelo #GloboPlay' : '';
  var programMessage = programHashtag && globoPlayMessage ? "Assista ".concat(programHashtag) : "".concat(videoTitle); // should it be setted by product?

  var urlWithUTMQueryString = getUrlWithUTMQueryString(videoUrl, 'twitter');
  var baseUrl = 'https://twitter.com/intent/tweet';
  var text = encodeURIComponent("".concat(programMessage).concat(globoPlayMessage));
  var queryString = "?text=".concat(text, "&url=").concat(urlWithUTMQueryString);
  var shareUrl = baseUrl + queryString;
  openShareWindow(shareUrl, videoTitle);
}
function getVideoProgramHashtag(videoProgram) {
  var programHashtag = videoProgram ? "#".concat(videoProgram.split(' ').map(function (s) {
    return s[0].toUpperCase() + s.slice(1);
  }).join('').replace(/[-:]/g, '')) : '';
  return programHashtag;
}

var pluginHTML$1 = "<div class=\"share__box\">\n  <% for (var i = 0; i < shareItems.length; i++) { %>\n    <button class=\"share__button\" data-share-item=\"<%= shareItems[i].name %>\"> <%= shareItems[i].element %> </button>\n  <% } %>\n  <h1 class=\"share__title\">Link Copiado</h1>\n  <div class=\"share__item-copied-box\">\n    <h2 class=\"share__subtitle\"><%= videoUrl %></h2>\n  </div>\n  <button class=\"share__close\"></button>\n</div>\n";

var css_248z$a = ".clappr-player#wp3-player-0 .media-control.w360 .share__box--link-copied .share__button[data-share-item=\"link\"] {\n  transform: translate(-286%, 0px); }\n\n.clappr-player#wp3-player-0 .media-control.w360 .share__button {\n  width: 40px;\n  height: 40px;\n  padding: 4px;\n  margin-left: 32px; }\n  .clappr-player#wp3-player-0 .media-control.w360 .share__button:first-child {\n    margin-left: 0; }\n  .clappr-player#wp3-player-0 .media-control.w360 .share__button:nth-last-child(3) {\n    margin-right: 0; }\n\n.clappr-player#wp3-player-0 .media-control.w360 .share__close {\n  box-sizing: content-box;\n  padding: 12px;\n  top: 0;\n  right: 0; }\n\n.clappr-player#wp3-player-0 .share__box {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  z-index: 998;\n  height: 100%;\n  width: 100%; }\n  .clappr-player#wp3-player-0 .share__box--link-copied .share__button {\n    visibility: hidden; }\n  .clappr-player#wp3-player-0 .share__box--link-copied .share__button[data-share-item=\"link\"] {\n    visibility: visible;\n    transition: transform 0.3s ease;\n    transform: translate(-344%, 0px);\n    opacity: 1;\n    cursor: default; }\n  .clappr-player#wp3-player-0 .share__box--link-copied .share__item-copied-box, .clappr-player#wp3-player-0 .share__box--link-copied .share__title {\n    transition: visibility .7s ease, opacity .7s ease;\n    visibility: visible;\n    opacity: 1; }\n\n.clappr-player#wp3-player-0 .share__button {\n  padding: 0px;\n  background-color: transparent;\n  border: 0;\n  opacity: 0.6;\n  cursor: pointer;\n  transition: opacity .2s ease;\n  outline: none;\n  width: 48px;\n  height: 48px;\n  margin-left: 56px;\n  box-sizing: content-box; }\n  .clappr-player#wp3-player-0 .share__button:hover, .clappr-player#wp3-player-0 .share__button:focus {\n    opacity: 1; }\n  .clappr-player#wp3-player-0 .share__button svg {\n    width: 100%; }\n  .clappr-player#wp3-player-0 .share__button:first-child {\n    margin-left: 0; }\n  .clappr-player#wp3-player-0 .share__button:nth-last-child(3) {\n    margin-right: 0; }\n\n.clappr-player#wp3-player-0 .share__item-copied-box {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  position: absolute;\n  top: calc(50% + 22px);\n  left: 0;\n  opacity: 0;\n  visibility: hidden; }\n\n.clappr-player#wp3-player-0 .share__title {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  position: absolute;\n  font-family: \"opensans-regular\", sans-serif;\n  font-size: 16px;\n  color: #ffffff;\n  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);\n  cursor: default;\n  visibility: hidden;\n  top: calc(50% - 13px);\n  left: calc(50% - 22px); }\n\n.clappr-player#wp3-player-0 .share__subtitle {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  padding: 0 35px;\n  max-width: 100%;\n  word-wrap: break-word;\n  font-family: \"opensans-regular\", sans-serif;\n  font-size: 12px;\n  letter-spacing: -0.5px;\n  color: #ffffff;\n  -webkit-user-select: text;\n     -moz-user-select: text;\n      -ms-user-select: text;\n          user-select: text;\n  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);\n  margin: 0; }\n\n.clappr-player#wp3-player-0 .share__close {\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n  transition: opacity 0.3s ease;\n  opacity: 0.6;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 24px;\n  height: 24px;\n  outline: none;\n  cursor: pointer; }\n  .clappr-player#wp3-player-0 .share__close:hover, .clappr-player#wp3-player-0 .share__close:focus {\n    opacity: 1; }\n  .clappr-player#wp3-player-0 .share__close svg {\n    width: 100%;\n    height: 100%; }\n";
styleInject(css_248z$a);

var shareIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M17 16.08c-.76 0-1.44.3-1.96.77L7.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L7.04 9.81C6.5 9.31 5.79 9 5 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var closeIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"/>\n    </g>\n</svg>";

var facebookShareIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M15.04 20v-6.196h2.08l.31-2.415h-2.39V9.848c0-.7.194-1.176 1.196-1.176h1.28v-2.16c-.222-.03-.981-.095-1.864-.095-1.844 0-3.106 1.125-3.106 3.192v1.78h-2.085v2.415h2.085V20H4.883C4.395 20 4 19.605 4 19.117V4.883C4 4.395 4.395 4 4.883 4h14.234c.488 0 .883.395.883.883v14.234c0 .488-.395.883-.883.883H15.04z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var twitterShareIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M8.66 19.617c6.794 0 10.508-5.623 10.508-10.499 0-.16-.003-.319-.01-.477.72-.52 1.348-1.17 1.842-1.91-.662.293-1.374.491-2.12.58.762-.457 1.347-1.18 1.623-2.04-.713.422-1.504.729-2.345.895C17.484 5.449 16.525 5 15.462 5c-2.039 0-3.693 1.653-3.693 3.69 0 .29.033.57.096.841-3.07-.154-5.79-1.623-7.612-3.855-.318.545-.5 1.178-.5 1.854 0 1.28.652 2.41 1.643 3.072-.606-.019-1.175-.185-1.673-.462v.048c0 1.787 1.273 3.279 2.963 3.617-.31.084-.637.13-.974.13-.238 0-.47-.024-.694-.067.47 1.466 1.833 2.533 3.45 2.563-1.264.99-2.857 1.58-4.587 1.58-.298 0-.592-.017-.881-.051 1.634 1.046 3.575 1.657 5.661 1.657\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\n    </g>\n</svg>";

var linkShareIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var copyToClipboard = Utils$1.copyToClipboard;

var ShareButton = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(ShareButton, _MediaControlPlugin);

  var _super = _createSuper(ShareButton);

  _createClass(ShareButton, [{
    key: "name",
    get: function get() {
      return 'share';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'upper';
    }
  }, {
    key: "position",
    get: function get() {
      return 'right';
    }
  }, {
    key: "template",
    get: function get() {
      return template(pluginHTML$1);
    }
  }, {
    key: "modal",
    get: function get() {
      return this.mediaControl.$modal;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'media-control-button',
        'data-share': '',
        'data-controls': ''
      };
    }
  }]);

  function ShareButton(core) {
    var _this;

    _classCallCheck(this, ShareButton);

    _this = _super.call(this, core);
    _this.core = core;
    _this.shouldRender = false; // flag changes to true when resource is selected and verified

    _this.$el.on('click', function () {
      return _this.showShareBox();
    });

    if (_this.options.share && _this.options.share.enabled === false) _this.disable();
    return _this;
  }

  _createClass(ShareButton, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.mediaControl, Events.WM_SHARE_SHOW, this.start);
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;

      var $shareBox = this.modal.find('.share__box');
      var $shareClose = this.modal.find('.share__close');
      $shareBox && $shareBox.on('click', function (e) {
        e && e.stopPropagation();

        _this2.hideModal();
      });
      $shareClose && $shareClose.append(closeIcon);
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.playback && this.stopListening(this.playback);
      this.container = this.core.activeContainer;
      this.playback = this.core.activePlayback;
      this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
      this.listenToOnce(this.playback, Events.WM_RESOURCE_SELECTED, this.checkUrl);
      this.listenTo(this.container, Events$1.CONTAINER_SETTINGSUPDATE, this.shouldHideModal);
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      this.video = video;
      this.shareUrl = this.video.urlForConsumption.replace(/(^\w+:|^)\/\//, '');
      var hasSocialList = this.core.options.share && this.core.options.share.socialList;
      this.loadSocialList(hasSocialList ? hasSocialList : []);
    }
  }, {
    key: "checkUrl",
    value: function checkUrl() {
      this.shouldRender = true; // destroy plugin in case of unexpected url instead of use this flag

      this.render();
    }
  }, {
    key: "shouldHideModal",
    value: function shouldHideModal() {
      var playbackType = this.playback && this.playback.getPlaybackType();

      if (playbackType !== 'vod' && playbackType !== 'live') {
        this.hideModal();
      }
    }
  }, {
    key: "loadSocialList",
    value: function loadSocialList(list) {
      if (list && list.length > 0) {
        this.socialList = this.verifySocialList(list);
      } else {
        this.socialList = this.getDefaultSocialList();
      }
    }
  }, {
    key: "verifySocialList",
    value: function verifySocialList(list) {
      var _this3 = this;

      var checkedList = [];
      list.forEach(function (network) {
        // iterate over socialList from options
        _this3.getDefaultSocialList().forEach(function (social) {
          // verify if is a valid option
          social.name === network && checkedList.push(social);
        });
      });
      return checkedList;
    }
  }, {
    key: "getDefaultSocialList",
    value: function getDefaultSocialList() {
      var _this4 = this;

      return [{
        name: 'facebook',
        element: facebookShareIcon,
        onClickAction: function onClickAction() {
          facebookWindow(_this4.video.urlForConsumption, _this4.video.title);
        }
      }, {
        name: 'twitter',
        element: twitterShareIcon,
        onClickAction: function onClickAction() {
          twitterWindow(_this4.video.urlForConsumption, _this4.video.title, _this4.video.program);
        }
      }, {
        name: 'link',
        element: linkShareIcon,
        onClickAction: function onClickAction(e) {
          e.stopPropagation();

          _this4.showLinkCopiedBox();

          copyToClipboard(_this4.video.urlForConsumption, _this4.modal);
        }
      }];
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      var $shareBox = this.modal && this.modal.find('.share__box');
      var shareBoxContent = $shareBox && $shareBox.contents();
      if (!shareBoxContent || shareBoxContent && !shareBoxContent.length) return;
      $shareBox.off('click');
      this.mediaControl.trigger(Events.WM_SHARE_HIDE);
      this.core.trigger(Events.WM_SHARE_HIDE);
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_HIDE);
      this.mediaControl.resetKeepVisible();
      this.mediaControl.resetFocus();
      this.triggerDidHideModalElement();
      this.hasPlayingBeforeModal && this.playback.play();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.shouldRender) return;
      this.shouldRender = false;
      this.$el.html('');
      var style = Styler.getStyleFrom(css_248z$a, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
      this.$el.append(shareIcon);
      return this;
    }
  }, {
    key: "bindShareEvents",
    value: function bindShareEvents() {
      var _this5 = this;

      this.socialList.forEach(function (item) {
        var $button = _this5.modal.find(".share__button[data-share-item=".concat(item.name, "]"));

        typeof item.onClickAction === 'function' && $button.on('click', item.onClickAction);
      });
    }
  }, {
    key: "showShareBox",
    value: function showShareBox(e) {
      e && e.stopPropagation();
      this.hasPlayingBeforeModal = this.playback.isPlaying();
      this.hasPlayingBeforeModal && this.playback.pause();
      var shareBoxHTML = this.template({
        'shareItems': this.socialList,
        videoUrl: this.shareUrl
      });
      this.triggerWillShowModalElement();
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_SHOW, shareBoxHTML, {
        hidePanels: true
      });
      this.mediaControl.trigger(Events.WM_SHARE_SHOW);
      this.core.trigger(Events.WM_SHARE_SHOW);
      this.mediaControl.setKeepVisible();
      this.bindShareEvents();
      var $shareButton = this.modal.find('.share__button, .share__item-copied-box, .share__title');
      $shareButton && $shareButton.on('click', function (e) {
        return e.stopPropagation();
      }); // prevents close modal when click on text
    }
  }, {
    key: "showLinkCopiedBox",
    value: function showLinkCopiedBox() {
      var $shareBox = this.modal.find('.share__box');
      $shareBox && $shareBox.addClass('share__box--link-copied');
    }
  }]);

  return ShareButton;
}(MediaControlPlugin);

var unmuteModalHTML = "<div class=\"unmute-modal\">\n  <div class=\"unmute-modal__button-box\">\n    <button class=\"unmute-modal__button unmute-modal__button--on unmute-modal__button--hide\"><%= volumeOnIcon %></button>\n    <button class=\"unmute-modal__button unmute-modal__button--off\"><%= volumeOffIcon %></button>\n    <span class=\"unmute-modal__label\">Ativar som</span>\n  </div>\n</div>\n";

var css_248z$b = ".clappr-player#wp3-player-0 .unmute-modal {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: absolute;\n  pointer-events: auto;\n  right: 0px;\n  bottom: 0px;\n  z-index: 998;\n  height: 100%;\n  width: 100%; }\n  .clappr-player#wp3-player-0 .unmute-modal__button-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 32px;\n    background-color: rgba(17, 17, 17, 0.8);\n    width: 118px;\n    transition: width .5s ease;\n    box-sizing: border-box;\n    margin: 12px;\n    border-radius: 4px; }\n    .clappr-player#wp3-player-0 .unmute-modal__button-box--no-label {\n      width: 40px; }\n  .clappr-player#wp3-player-0 .unmute-modal__button {\n    background-color: transparent;\n    border: 0;\n    opacity: 1;\n    cursor: pointer;\n    margin: 0;\n    padding: 0;\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    outline: none; }\n    .clappr-player#wp3-player-0 .unmute-modal__button--hide {\n      display: none; }\n    .clappr-player#wp3-player-0 .unmute-modal__button:hover, .clappr-player#wp3-player-0 .unmute-modal__button:focus {\n      opacity: 1; }\n    .clappr-player#wp3-player-0 .unmute-modal__button svg {\n      height: 24px;\n      width: 24px; }\n  .clappr-player#wp3-player-0 .unmute-modal__label {\n    font-family: \"opensans-regular\", sans-serif;\n    font-size: 14px;\n    line-height: 1.14;\n    color: #ffffff;\n    width: 77px;\n    padding-left: 7px;\n    opacity: 1;\n    transition: width .5s ease;\n    margin-top: -2px; }\n    .clappr-player#wp3-player-0 .unmute-modal__label--hide {\n      width: 0;\n      opacity: 0;\n      padding: 0; }\n";
styleInject(css_248z$b);

var autoplayManager$1 = Utils$1.autoplayManager;

var TapToUnmute = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(TapToUnmute, _UICorePlugin);

  var _super = _createSuper(TapToUnmute);

  function TapToUnmute() {
    _classCallCheck(this, TapToUnmute);

    return _super.apply(this, arguments);
  }

  _createClass(TapToUnmute, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      this.idPlayback = this.core.activePlayback;
      this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, this.showUnmuteModal);
      this.listenToOnce(this.container, Events.WM_UNMUTED, this.hideUnmuteModal);
    }
  }, {
    key: "bindUnmuteModalEvents",
    value: function bindUnmuteModalEvents() {
      this.modal && this.modal.on('click', this.onUnmuteModalClick.bind(this));
    }
  }, {
    key: "showUnmuteModal",
    value: function showUnmuteModal() {
      var _this = this;

      var isChromelessDesktop = this.options.chromeless && !Browser.isMobile;
      var startMuted = this.options.mute || this.mutedAutoplay && !autoplayManager$1.playerHasConsent;
      var willRender = !isChromelessDesktop && startMuted;
      if (!willRender) return;
      this.renderUnmuteModal();
      this.isVisible = true;
      setTimeout(function () {
        _this.hideLabel();
      }, 5000);
    }
  }, {
    key: "renderUnmuteModal",
    value: function renderUnmuteModal() {
      var unmuteModal = template(unmuteModalHTML)({
        volumeOffIcon: volumeOffIcon,
        volumeOnIcon: volumeOnIcon
      });
      var style = Styler.getStyleFrom(css_248z$b, {
        playerId: this.core.options.playerId
      });
      this.mediaControl && this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_SHOW, unmuteModal, {
        hidePanels: true
      });
      this.core.trigger(Events.TAP_TO_UNMUTE_SHOW);
      this.modal && this.modal.find('.unmute-modal').append(style[0]);
      this.mediaControl && this.mediaControl.setKeepVisible();
      this.bindUnmuteModalEvents();
      this.mediaControl && this.mediaControl.$el.addClass('media-control--no-background');
    }
  }, {
    key: "onUnmuteModalClick",
    value: function onUnmuteModalClick(e) {
      var _this2 = this;

      e && e.stopPropagation();
      this.core.trigger(Events.TAP_TO_UNMUTE_CLICKED);
      this.hideLabel();
      this.toggleUnmuteButton();
      setTimeout(function () {
        _this2.hideUnmuteModal();
      }, 1000);
    }
  }, {
    key: "hideUnmuteModal",
    value: function hideUnmuteModal() {
      if (!this.isVisible) return;
      this.modal.off('click');
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_HIDE);
      this.isVisible = false;
      this.mediaControl.resetKeepVisible();
      this.mediaControl.resetFocus();
      this.mediaControl.$el.removeClass('media-control--no-background');
    }
  }, {
    key: "toggleUnmuteButton",
    value: function toggleUnmuteButton() {
      if (!this.modal) return;
      this.modal.find('.unmute-modal__button--off').addClass('unmute-modal__button--hide');
      this.modal.find('.unmute-modal__button--on').removeClass('unmute-modal__button--hide');
    }
  }, {
    key: "hideLabel",
    value: function hideLabel() {
      if (!this.modal) return;
      this.modal.find('.unmute-modal__label').addClass('unmute-modal__label--hide');
      this.modal.find('.unmute-modal__button-box').addClass('unmute-modal__button-box--no-label');
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.html('');
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._mediaControl = null;

      _get(_getPrototypeOf(TapToUnmute.prototype), "destroy", this).call(this);
    }
  }, {
    key: "name",
    get: function get() {
      return 'tap_to_unmute';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this._mediaControl || (this._mediaControl = this.core.getPlugin('globo_media_control'));
    }
  }, {
    key: "template",
    get: function get() {
      return template(unmuteModalHTML);
    }
  }, {
    key: "modal",
    get: function get() {
      return this.mediaControl && this.mediaControl.$modal;
    }
  }, {
    key: "mutedAutoplay",
    get: function get() {
      return this.idPlayback && this.idPlayback.mutedAutoplay;
    }
  }]);

  return TapToUnmute;
}(UICorePlugin);

var css_248z$c = ".clappr-player#wp3-player-0 .bar-container[data-seekbar]:hover .cuepoint:before {\n  transform: scale(1.35, 1.35); }\n\n.clappr-player#wp3-player-0 .cuepoint {\n  position: absolute;\n  height: 100%;\n  width: 2px;\n  bottom: 0px;\n  z-index: 200; }\n  .clappr-player#wp3-player-0 .cuepoint:before {\n    position: absolute;\n    display: inline-block;\n    width: 100%;\n    height: 2px;\n    content: '';\n    left: -2px;\n    top: 21px;\n    background-color: #000;\n    border-radius: 50%;\n    border: solid 2px #fff;\n    will-change: transform;\n    transition: transform 0.3s ease; }\n  .clappr-player#wp3-player-0 .cuepoint:hover:before {\n    transform: scale(2, 2) !important; }\n  .clappr-player#wp3-player-0 .cuepoint__details {\n    width: 100%;\n    height: 100%;\n    line-height: 16px;\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    z-index: 100; }\n    .clappr-player#wp3-player-0 .cuepoint__details-title {\n      font-family: \"opensans-regular\", sans-serif;\n      font-size: 14px;\n      text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n      padding: 4px 9px;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      text-align: left;\n      overflow: hidden;\n      position: absolute;\n      left: 0; }\n    .clappr-player#wp3-player-0 .cuepoint__details-time {\n      padding: 3px 8px 2px;\n      font-family: \"opensans-regular\", sans-serif;\n      font-size: 14px;\n      color: #fff;\n      text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n      border-radius: 2px;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      background-color: rgba(0, 0, 0, 0.5);\n      display: flex;\n      z-index: 100;\n      align-self: flex-end; }\n";
styleInject(css_248z$c);

var pluginHTML$2 = "<% for (var i = 0; i < cuepoints.length; i++) { %>\n<div class=\"cuepoint\"></div>\n<% } %>\n";

var CuepointMarkers = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(CuepointMarkers, _UICorePlugin);

  var _super = _createSuper(CuepointMarkers);

  _createClass(CuepointMarkers, [{
    key: "name",
    get: function get() {
      return 'cuepoint_markers';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'cuepoints'
      };
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this.core.mediaControl;
    }
  }, {
    key: "seekbar",
    get: function get() {
      return this.core.getPlugin('seekbar');
    }
  }, {
    key: "template",
    get: function get() {
      return template(pluginHTML$2);
    }
  }, {
    key: "playbackType",
    get: function get() {
      return this.container && this.container.getPlaybackType();
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'mouseenter': 'showDetails',
        'mouseleave': 'hideDetails',
        'click': 'clicked'
      };
    }
  }]);

  function CuepointMarkers(core) {
    var _this;

    _classCallCheck(this, CuepointMarkers);

    _this = _super.call(this, core);
    _this.$thumbPreview = _this.core.getPlugin('thumb-preview').$el;
    return _this;
  }

  _createClass(CuepointMarkers, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.playback && this.stopListening(this.playback);
      this.container = this.core.activeContainer;
      this.playback = this.core.activePlayback;
      if (!this.container) return;
      this.listenTo(this.container, Events$1.CONTAINER_SETTINGSUPDATE, this.render);
      this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.parseCuepoints);
      this.listenToOnce(this.playback, Events.WM_RESOURCE_READY, this.render);
    }
  }, {
    key: "containerChanged",
    value: function containerChanged() {
      this.seekbar.$el.find('.cuepoint').remove();
      this.cuepoints = [];
      this.bindContainerEvents();
    }
  }, {
    key: "parseCuepoints",
    value: function parseCuepoints(video) {
      this.duration = video.duration;
      var customCuepoints = this.core.options.cuepoints && this.core.options.cuepoints.values;

      if (customCuepoints) {
        this.cuepoints = customCuepoints;
      } else {
        var cuepointsFromPlaylist = video && video.cuepoints || [];
        this.cuepoints = cuepointsFromPlaylist.map(function (cuepoint) {
          cuepoint.time /= 1000;
          return cuepoint;
        });
      }
    }
  }, {
    key: "clicked",
    value: function clicked(e) {
      e.stopPropagation();
      this.container.seek(this.cuepoints[$$1(e.target).index()].time);
    }
  }, {
    key: "showDetails",
    value: function showDetails(e) {
      var $thumbPosition = this.$thumbPreview.find('.thumb-preview__position');
      var cuepointIndex = $$1(e.target).index();
      $thumbPosition.toggleClass('thumb-preview__position cuepoint__details');
      $thumbPosition.empty();
      var $cuepointTitle = $$1('<div/>', {
        'class': 'cuepoint__details-title'
      });
      var $cuepointTime = $$1('<div/>', {
        'class': 'cuepoint__details-time'
      });
      $cuepointTitle.text(this.cuepoints[cuepointIndex].title || "Bloco ".concat(cuepointIndex + 2));
      $cuepointTime.text(Utils.formatTime(this.cuepoints[cuepointIndex].time));
      $thumbPosition.append($cuepointTitle, $cuepointTime);
      this.seekbar.$el.find('.bar-hover[data-seekbar]').css('visibility', 'hidden');
    }
  }, {
    key: "hideDetails",
    value: function hideDetails(e) {
      // eslint-disable-line no-unused-vars
      var $cuepointDetails = this.$thumbPreview.find('.cuepoint__details');
      $cuepointDetails.toggleClass('thumb-preview__position cuepoint__details');
      this.seekbar.$el.find('.bar-hover[data-seekbar]').css('visibility', 'visible');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.cuepoints || !this.cuepoints.length || this.playbackType === 'ad') return;
      this.seekbar.$el.find('.cuepoint').remove();
      var style = Styler.getStyleFrom(css_248z$c, {
        playerId: this.core.options.playerId
      });
      this.$el.html(this.template({
        cuepoints: this.cuepoints
      }));
      this.$el.append(style[0]);
      this.cuepoints.forEach(function (cuepoint, index) {
        var duration = _this2.duration || 0;
        var leftPos = cuepoint.time * 100 / (duration / 1000);

        var $cuepoint = _this2.$el.find('.cuepoint').eq(index);

        $cuepoint.css('left', "".concat(leftPos, "%"));
      });
      this.seekbar.$el.append(this.el);
    }
  }]);

  return CuepointMarkers;
}(UICorePlugin);

var css_248z$d = ".clappr-player#wp3-player-0 .media-control .media-control-panel__lower .live-indicator {\n  display: flex;\n  align-self: flex-start;\n  margin-top: 5px;\n  border-radius: 2px;\n  background-color: red;\n  padding: 3px 6px; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__lower .live-indicator--hide {\n    display: none; }\n  .clappr-player#wp3-player-0 .media-control .media-control-panel__lower .live-indicator--first-element {\n    margin-left: 12px; }\n\n.clappr-player#wp3-player-0 [data-live-indicator] {\n  color: #ffffff;\n  font-family: \"opensans-bold\", sans-serif;\n  font-size: 11px;\n  line-height: 1.45;\n  letter-spacing: -0.5px; }\n";
styleInject(css_248z$d);

var LiveIndicator = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(LiveIndicator, _MediaControlPlugin);

  var _super = _createSuper(LiveIndicator);

  function LiveIndicator() {
    _classCallCheck(this, LiveIndicator);

    return _super.apply(this, arguments);
  }

  _createClass(LiveIndicator, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      this.resetDvrState();
      this.updateState();
      this.listenTo(this.container, Events$1.CONTAINER_PLAYBACKDVRSTATECHANGED, this.onDVRUpdated);
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.updateState);
      this.listenTo(this.container, Events$1.CONTAINER_PAUSE, this.updateState);
    }
  }, {
    key: "onDVRUpdated",
    value: function onDVRUpdated(dvrInUse) {
      this.dvrInUse = dvrInUse;
      this.updateState();
    }
  }, {
    key: "updateState",
    value: function updateState() {
      if (!this.isLive) return this.hide();
      this.dvrInUse ? this.hide() : this.show();
      this.$el["".concat(this.container.isDvrEnabled() ? 'remove' : 'add', "Class")]('live-indicator--first-element');
      Browser.supportsTouchEvents && this.$el.addClass('live-indicator--first-element');
    }
  }, {
    key: "resetDvrState",
    value: function resetDvrState() {
      this.dvrInUse = false;
    }
  }, {
    key: "show",
    value: function show() {
      this.$el.removeClass('live-indicator--hide');
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.addClass('live-indicator--hide');
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.empty();
      this.$indicator = $('<span/>').attr('data-live-indicator', '').html(this.label); // eslint-disable-line no-undef

      var style = Styler.getStyleFrom(css_248z$d, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
      this.$el.append(this.$indicator[0]);
      return this;
    }
  }, {
    key: "name",
    get: function get() {
      return 'live_indicator';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'left';
    }
  }, {
    key: "label",
    get: function get() {
      return this.options && this.options.isLiveContent ? 'AO VIVO' : 'AGORA';
    }
  }, {
    key: "isLive",
    get: function get() {
      return this.container && this.container.getPlaybackType() === Playback.LIVE;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'live-indicator live-indicator--hide'
      };
    }
  }]);

  return LiveIndicator;
}(MediaControlPlugin);

var css_248z$e = ".clappr-player#wp3-player-0 .pip-transition[data-pip] {\n  transition: all 0.3s ease-out; }\n\n.clappr-player#wp3-player-0.nocursor .container[data-container].master-container[data-pip], .clappr-player#wp3-player-0.nocursor .container[data-container].pip-container[data-pip] {\n  cursor: none; }\n  .clappr-player#wp3-player-0.nocursor .container[data-container].master-container[data-pip].pointer-enabled, .clappr-player#wp3-player-0.nocursor .container[data-container].pip-container[data-pip].pointer-enabled {\n    cursor: none; }\n\n.clappr-player#wp3-player-0 .container[data-container].master-container[data-pip] {\n  cursor: default;\n  width: 100%;\n  height: 100%;\n  font-size: 100%;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  border: none; }\n  .clappr-player#wp3-player-0 .container[data-container].master-container[data-pip].pointer-enabled {\n    cursor: pointer; }\n    .clappr-player#wp3-player-0 .container[data-container].master-container[data-pip].pointer-enabled.chromeless {\n      cursor: default; }\n  .clappr-player#wp3-player-0 .container[data-container].master-container[data-pip].pip-transition {\n    z-index: 1000; }\n\n.clappr-player#wp3-player-0 .container[data-container].pip-container[data-pip] {\n  cursor: default;\n  width: 24%;\n  height: 24%;\n  min-width: 0;\n  font-size: 24%;\n  z-index: 1000;\n  position: absolute;\n  padding: 0;\n  margin: 0;\n  right: 23px;\n  bottom: 23px;\n  border-width: 2px;\n  border-radius: 3px;\n  border-style: solid;\n  border-color: rgba(255, 255, 255, 0.25);\n  background-clip: padding-box;\n  -webkit-background-clip: padding-box; }\n  .clappr-player#wp3-player-0 .container[data-container].pip-container[data-pip].pointer-enabled {\n    cursor: pointer; }\n  .clappr-player#wp3-player-0 .container[data-container].pip-container[data-pip].over-media-control {\n    transform: translateY(-43px); }\n  .clappr-player#wp3-player-0 .container[data-container].pip-container[data-pip].mouse-over {\n    border-color: rgba(255, 255, 255, 0.5); }\n  .clappr-player#wp3-player-0 .container[data-container].pip-container[data-pip].unobtrusive-mode {\n    opacity: .3;\n    z-index: 993; }\n";
styleInject(css_248z$e);

var PipPlugin = /*#__PURE__*/function (_CorePlugin) {
  _inherits(PipPlugin, _CorePlugin);

  var _super = _createSuper(PipPlugin);

  _createClass(PipPlugin, [{
    key: "name",
    get: function get() {
      return 'pip';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this.core.getPlugin('globo_media_control');
    }
  }]);

  function PipPlugin(core) {
    var _this;

    _classCallCheck(this, PipPlugin);

    _this = _super.call(this, core);
    _this.core = core;
    _this.allowPipToMaster = _this.core.options.allowPipToMaster ? true : false;
    var style = Styler.getStyleFrom(css_248z$e, {
      playerId: _this.core.options.playerId
    });

    _this.core.$el.append(style[0]);

    _this.setupContainers();

    _this.addListeners();

    return _this;
  }

  _createClass(PipPlugin, [{
    key: "getExternalInterface",
    value: function getExternalInterface() {
      return {
        addPip: this.addPip,
        discardPip: this.discardPip,
        addMaster: this.addMaster,
        changeMaster: this.changeMaster,
        getPipSource: this.getPipSource,
        pipToMaster: this.pipToMaster,
        hasPip: this.hasPip
      };
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this2 = this;

      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.mediaControlContainerChanged);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_SHOW, this.onMediaControlShow);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_HIDE, this.onMediaControlHide);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, function (event) {
        return _this2.onMouseMove(event);
      });
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.onMouseLeave);
      this.listenTo(this.mediaControl, Events.WM_SETTINGS_SHOW, this.setSettingsUnobtrusiveMode);
      this.listenTo(this.mediaControl, Events.WM_SETTINGS_HIDE, this.removeSettingsUnobtrusiveMode);
      this.listenTo(this.mediaControl, Events.WM_VOLUME_SHOW, this.setVolumeUnobtrusiveMode);
      this.listenTo(this.mediaControl, Events.WM_VOLUME_HIDE, this.removeVolumeUnobtrusiveMode);
      this.listenTo(this.mediaControl, Events.WM_SHARE_SHOW, this.setUnobtrusiveMode);
      this.listenTo(this.mediaControl, Events.WM_SHARE_HIDE, this.removeUnobtrusiveMode);
    }
  }, {
    key: "mediaControlContainerChanged",
    value: function mediaControlContainerChanged() {
      if (this.core.options.dfp) {
        this.stopListening(this.core.options.dfp);
        this.listenTo(this.core.options.dfp, Events.DFP_AD_STARTED, this.setUnobtrusiveMode);
        this.listenTo(this.core.options.dfp, Events.DFP_AD_COMPLETED, this.removeUnobtrusiveMode);
        this.listenTo(this.core.options.dfp, Events.DFP_AD_CLOSED, this.removeUnobtrusiveMode);
        this.listenTo(this.core.options.dfp, Events.DFP_AD_SKIPPED, this.removeUnobtrusiveMode);
      }

      this.masterContainer = this.core.activeContainer;
      this.setMasterStyle(this.masterContainer, false);
    }
  }, {
    key: "setupContainers",
    value: function setupContainers() {
      if (this.core.containers.length > 0) {
        this.masterContainer = this.core.containers[0];
        this.setMasterStyle(this.masterContainer, false);

        if (this.core.containers.length === 2) {
          this.pipContainer = this.core.containers[1];
          this.setPipStyle(this.pipContainer, false);
          this.masterContainer.playback && this.masterContainer.playback.playWhenReady() || this.masterContainer.play();
          this.pipContainer.playback && this.pipContainer.playback.playWhenReady() || this.pipContainer.play();
          this.pipContainer.setVolume(0);
          this.pipContainer.playback.isPip(true);
          this.listenToPipClick();
        }
      }
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      if (this.isOnUnobtrusiveMode) return;

      if ((!event || this.mediaControl.container.playback.settings.seekEnabled && !['thumb', 'thumb-position'].includes(event.target.className)) && this.pipContainer) {
        this.pipContainer.$el.addClass('unobtrusive-mode');
      } else {
        this.onMouseLeave();
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      if (this.isOnUnobtrusiveMode) return;

      if (this.pipContainer) {
        this.pipContainer.$el.removeClass('unobtrusive-mode');
      }
    }
  }, {
    key: "hasPip",
    value: function hasPip() {
      return !!this.pipContainer;
    }
  }, {
    key: "getPipSource",
    value: function getPipSource() {
      return this.pipContainer.playback.src;
    }
  }, {
    key: "canAddMaster",
    value: function canAddMaster() {
      // we can't add a master if it's playing an ad
      return this.masterContainer && this.masterContainer.getPlaybackType() !== 'ad';
    }
  }, {
    key: "addPip",
    value: function addPip() {
      var _this3 = this;

      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var playback = this.core.getCurrentPlayback();
      var container = this.core.getCurrentContainer();
      var isValidPlayback = !!playback.getPlaybackType() && playback.getPlaybackType() !== 'ad';

      if (isValidPlayback && playback.isPlaying()) {
        this.discardPip();
        this.pipContainer = this.core.createContainer(source, {
          onPip: true
        });
        this.addPipCallback();
      } else {
        container.once(Events$1.CONTAINER_PLAY, function () {
          return _this3.addPip(source);
        });
      }
    }
  }, {
    key: "addPipCallback",
    value: function addPipCallback() {
      var _this4 = this;

      var playback = this.pipContainer.playback;
      playback.once(Events.WM_PLAYBACK_WILL_PLAY, function () {
        return _this4.pipContainer.setVolume(0);
      });
      this.setPipStyle(this.pipContainer);
      playback && playback.playWhenReady() || this.pipContainer.play();
      this.stopListening(this.pipContainer);
      this.listenToPipClick();
      this.listenTo(this.pipContainer, Events$1.CONTAINER_ENDED, this.discardPip);
      this.listenTo(this.pipContainer, Events$1.CONTAINER_MOUSE_ENTER, this.mouseEnterPip);
      this.listenTo(this.pipContainer, Events$1.CONTAINER_MOUSE_LEAVE, this.mouseLeavePip);
      this.listenTo(this.masterContainer, Events$1.CONTAINER_ENDED, this.pipToMaster);
      playback.isPip(true);
      this.core.trigger(Events.WM_PIP_ADDED);
    }
  }, {
    key: "mouseEnterPip",
    value: function mouseEnterPip() {
      this.pipContainer.$el.addClass('mouse-over');
      this.pipContainer.setVolume(this.masterContainer.volume);
      this.masterContainer.setVolume(0);
    }
  }, {
    key: "mouseLeavePip",
    value: function mouseLeavePip() {
      this.pipContainer.$el.removeClass('mouse-over');
      this.masterContainer.setVolume(this.pipContainer.volume);
      this.pipContainer.setVolume(0);
    }
  }, {
    key: "discardPip",
    value: function discardPip() {
      if (this.pipContainer) {
        this.mouseLeavePip();
        this.stopListening(this.pipContainer);
        this.discardContainer(this.pipContainer);
        this.pipContainer = undefined;
        this.core.trigger(Events.WM_PIP_DISCARDED);
      }
    }
  }, {
    key: "discardMaster",
    value: function discardMaster() {
      if (this.masterContainer) {
        this.stopListening(this.masterContainer);
        this.discardContainer(this.masterContainer);
        this.masterContainer = undefined;
      }
    }
  }, {
    key: "setMasterContainer",
    value: function setMasterContainer(container) {
      this.discardMaster();
      this.masterContainer = container;
      this.setMasterStyle(this.masterContainer);
      this.listenTo(this.masterContainer, Events$1.CONTAINER_ENDED, this.pipToMaster);
      this.masterContainer.playback && this.masterContainer.playback.playWhenReady() || this.masterContainer.play();
    }
  }, {
    key: "addMaster",
    value: function addMaster() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (this.canAddMaster() && this.masterContainer) {
        this.stopListening(this.masterContainer);
        this.tmpContainer = this.masterContainer;
        this.tmpContainer.$el.addClass('pip-transition');
        var container = this.core.createContainer(source.toString(), {
          onMaster: true
        });
        this.addMasterCallback(container);
      }
    }
  }, {
    key: "addMasterContainer",
    value: function addMasterContainer(container) {
      if (this.masterContainer) {
        this.tmpContainer = this.masterContainer;
        this.tmpContainer.$el.addClass('pip-transition');
        this.addMasterCallback(container);
      }
    }
  }, {
    key: "addMasterCallback",
    value: function addMasterCallback(container) {
      var actualVolume = Math.max(this.masterContainer.volume, this.pipContainer && this.pipContainer.volume || 0);
      this.tmpContainer.setVolume(0);
      this.masterContainer = container;

      if (this.pipContainer) {
        this.discardPip();
      }

      this.pipContainer = this.tmpContainer;
      this.setPipStyle(this.pipContainer);
      this.setMasterStyle(this.masterContainer);
      var playback = this.masterContainer.playback;
      var playWhenReady = playback && playback.playWhenReady.bind(playback) || this.masterContainer.play.bind(this.masterContainer);

      if (!this.masterContainer.isReady) {
        this.listenToOnce(playback, Events.WM_PLAYBACK_WILL_PLAY, function () {
          return playWhenReady();
        });
      } else {
        playWhenReady();
      }

      this.animateMasterToPip();
      this.listenTo(this.pipContainer, Events$1.CONTAINER_MOUSE_ENTER, this.mouseEnterPip);
      this.listenTo(this.pipContainer, Events$1.CONTAINER_MOUSE_LEAVE, this.mouseLeavePip);
      this.tmpContainer = undefined;
      this.masterContainer.setVolume(actualVolume);
      this.pipContainer.trigger(Events.WM_MASTERTOPIP);
      this.core.trigger(Events.WM_MASTER_ADDED);
    }
  }, {
    key: "animateMasterToPip",
    value: function animateMasterToPip() {
      this.listenTo(this.masterContainer, Events$1.CONTAINER_ENDED, this.pipToMaster);
      this.pipContainer.playback.isPip(true);
      this.setPipStyle(this.pipContainer);
      this.core.activeContainer = this.masterContainer;
      this.listenToPipClick();
    }
  }, {
    key: "changeMaster",
    value: function changeMaster() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (this.masterContainer) {
        this.stopListening(this.masterContainer);
        this.tmpContainer = this.masterContainer;
        this.tmpContainer.$el.addClass('pip-transition');
        var container = this.core.createContainer(source.toString(), {
          onMaster: true
        });
        this.changeMasterCallback(container);
      }
    }
  }, {
    key: "changeMasterCallback",
    value: function changeMasterCallback(container) {
      this.masterContainer.destroy();
      this.masterContainer = container;
      this.tmpContainer = undefined;
      this.setMasterStyle(this.masterContainer);
      this.listenTo(this.masterContainer, Events$1.CONTAINER_ENDED, this.pipToMaster);
      var playback = this.masterContainer.playback;
      var playWhenReady = playback && playback.playWhenReady.bind(playback) || this.masterContainer.play.bind(this.masterContainer);

      if (!this.masterContainer.isReady) {
        this.listenToOnce(this.masterContainer.playback, Events.WM_PLAYBACK_WILL_PLAY, function () {
          return playWhenReady();
        });
      } else {
        playWhenReady();
      }

      this.core.activeContainer = this.masterContainer;
      this.core.trigger(Events.WM_MASTER_CHANGED);
    }
  }, {
    key: "listenToPipClick",
    value: function listenToPipClick() {
      if (this.pipContainer && this.allowPipToMaster) {
        this.stopListening(this.pipContainer);
        this.listenTo(this.pipContainer, Events$1.CONTAINER_CLICK, this.pipToMaster.bind(this));
      }
    }
  }, {
    key: "discardContainer",
    value: function discardContainer(container) {
      container.destroy();
    }
  }, {
    key: "pipToMaster",
    value: function pipToMaster() {
      var _this5 = this;

      this.stopListening(this.masterContainer);
      this.stopListening(this.pipContainer);

      if (this.pipContainer) {
        this.pipContainer.$el.addClass('pip-transition');
        this.setMasterStyle(this.pipContainer);
        this.pipContainer.$el.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          _this5.pipContainer.$el.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');

          _this5.pipToMasterCallback();
        });
      }

      return this;
    }
  }, {
    key: "pipToMasterCallback",
    value: function pipToMasterCallback() {
      var actualVolume = Math.max(this.masterContainer.volume, this.pipContainer.volume);
      this.discardMaster();
      this.pipContainer.playback.isPip(false);
      this.masterContainer = this.pipContainer;
      this.pipContainer = undefined;
      this.core.activeContainer = this.masterContainer;
      this.mediaControl.updatePlaybackTypeClass();
      this.mediaControl.enable();
      this.masterContainer.setVolume(actualVolume);
      this.masterContainer.trigger(Events.WM_PIPTOMASTER);
    }
  }, {
    key: "onMediaControlShow",
    value: function onMediaControlShow() {
      if (this.mediaControl.disabled) return;

      if (this.pipContainer) {
        this.pipContainer.$el.addClass('pip-transition over-media-control');
      }
    }
  }, {
    key: "onMediaControlHide",
    value: function onMediaControlHide() {
      if (this.mediaControl.keepVisible) return;

      if (this.masterContainer) {
        this.masterContainer.$el.removeClass('over-media-control');
      }

      if (this.pipContainer) {
        this.pipContainer.$el.addClass('pip-transition');
        this.pipContainer.$el.removeClass('over-media-control');
      }
    }
  }, {
    key: "setAnimatedTransition",
    value: function setAnimatedTransition(container, animated) {
      if (animated) {
        container.$el.addClass('pip-transition');
      } else {
        container.$el.removeClass('pip-transition');
      }
    }
  }, {
    key: "setPipStyle",
    value: function setPipStyle(container) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.setAnimatedTransition(container, animated);
      container.$el.attr('data-pip', '');
      container.$el.addClass('pip-container');
      container.$el.removeClass('over-media-control master-container');

      if (container.hasPlugin('click_to_pause')) {
        container.getPlugin('click_to_pause').disable();
        container.getPlugin('click_to_pause').settingsUpdate();
      }

      if (this.mediaControl.isVisible()) this.onMediaControlShow();
    }
  }, {
    key: "setMasterStyle",
    value: function setMasterStyle(container) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.setAnimatedTransition(container, animated);
      container.$el.attr('data-pip', '');
      container.$el.addClass('master-container');
      container.$el.removeClass('over-media-control pip-container');

      if (container.hasPlugin('click_to_pause')) {
        !Browser.supportsTouchEvents && container.getPlugin('click_to_pause').enable();
        container.getPlugin('click_to_pause').settingsUpdate();
      }
    }
  }, {
    key: "setUnobtrusiveMode",
    value: function setUnobtrusiveMode() {
      this.isOnUnobtrusiveMode = true;
      this.pipContainer && this.pipContainer.$el.addClass('unobtrusive-mode');
    }
  }, {
    key: "removeUnobtrusiveMode",
    value: function removeUnobtrusiveMode() {
      if (this.volumeUnobtrusive || this.settingsUnobtrusive) return;
      this.isOnUnobtrusiveMode = false;
      this.pipContainer && this.pipContainer.$el.removeClass('unobtrusive-mode');
    }
  }, {
    key: "setVolumeUnobtrusiveMode",
    value: function setVolumeUnobtrusiveMode() {
      this.volumeUnobtrusive = true;
      this.setUnobtrusiveMode();
    }
  }, {
    key: "removeVolumeUnobtrusiveMode",
    value: function removeVolumeUnobtrusiveMode() {
      this.volumeUnobtrusive = false;
      this.removeUnobtrusiveMode();
    }
  }, {
    key: "setSettingsUnobtrusiveMode",
    value: function setSettingsUnobtrusiveMode() {
      this.settingsUnobtrusive = true;
      this.setUnobtrusiveMode();
    }
  }, {
    key: "removeSettingsUnobtrusiveMode",
    value: function removeSettingsUnobtrusiveMode() {
      this.settingsUnobtrusive = false;
      this.removeUnobtrusiveMode();
    }
  }]);

  return PipPlugin;
}(CorePlugin);

var templateHtml$1 = "<ul class=\"settings__options-menu\">\n  <% for (var i = 0; i < options.length; i++) { %>\n    <% if (options[i].selected) { %>\n      <li data-option-id=\"<%= options[i].id %>\" class=\"settings__options-item settings__options-item--active\">\n        <span class=\"settings__options-active-icon\"><%= activeIcon %></span><span class=\"label\" data-option-id=\"<%= options[i].id %>\"><%= options[i].label %></span>\n      </li>\n    <% } else { %>\n      <li data-option-id=\"<%= options[i].id %>\" class=\"settings__options-item\">\n        <span class=\"label\" data-option-id=\"<%= options[i].id %>\"><%= options[i].label %></span>\n      </li>\n    <% } %>\n  <% } %>\n</ul>\n";

var arrowIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M8 16.59L12.58 12 8 7.41 9.41 6l6 6-6 6z\"/>\n    </g>\n</svg>";

var activeIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path fill=\"#FFF\" d=\"M8.59 15.58l-4.17-4.17L3 12.82l5.59 5.59 12-12L19.18 5z\"/>\n    </g>\n</svg>";

var Selector = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(Selector, _UICorePlugin);

  var _super = _createSuper(Selector);

  function Selector() {
    _classCallCheck(this, Selector);

    return _super.apply(this, arguments);
  }

  _createClass(Selector, [{
    key: "shouldRender",
    value: function shouldRender() {
      return this.options && this.options.length > 1;
    }
  }, {
    key: "clickOption",
    value: function clickOption(e) {
      e.stopPropagation();
      var optionIdStr = $$1(e.target).data('option-id');
      var optionIdInt = parseInt(optionIdStr);
      this.selectOption(!isNaN(optionIdInt) ? optionIdInt : optionIdStr);
    }
  }, {
    key: "selectOption",
    value: function selectOption(optionId) {
      this.playbackUpdate(optionId);
      this.interfaceUpdate(optionId);
      this.trigger(Events.WM_SETTINGS_OPTIONS_CHANGED);
    }
  }, {
    key: "interfaceUpdate",
    value: function interfaceUpdate(optionId) {
      this.availableOptions = this.options.map(function (option) {
        return _objectSpread2(_objectSpread2({}, option), {}, {
          selected: option.id.toString() === optionId.toString()
        });
      });
      this.$('.settings__options-menu li').find('.settings__options-active-icon').remove();
      this.$('.settings__options-menu li').removeClass('settings__options-item--active');
      var activeIconBox = $$1('<span>').addClass('settings__options-active-icon').append(activeIcon);
      this.$("li[data-option-id=\"".concat(optionId, "\"]")).addClass('settings__options-item--active').prepend(activeIconBox);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.shouldRender()) {
        this.$el.html(this.template({
          options: this.options || [],
          title: this.title,
          activeIcon: activeIcon,
          arrowIcon: arrowIcon
        }));
        this.$el.addClass('settings__options-wrapper');
      }

      return this;
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$1);
    }
  }, {
    key: "options",
    get: function get() {
      return this.availableOptions || [];
    }
  }, {
    key: "selected",
    get: function get() {
      var selected = this.options.find(function (option) {
        return option.selected;
      });
      var option = selected || this.options.length && this.options[0];
      return option && option.label;
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click .settings__options-item': 'clickOption'
      };
    }
  }]);

  return Selector;
}(UICorePlugin);

var LANGUAGES = {
  por: {
    label: 'Português',
    language: 'por',
    keys: ['pt', 'por']
  },
  eng: {
    label: 'Inglês',
    language: 'eng',
    keys: ['en', 'eng']
  },
  ger: {
    label: 'Alemão',
    language: 'ger',
    keys: ['de', 'ger']
  },
  esp: {
    label: 'Espanhol',
    language: 'spa',
    keys: ['es', 'esp', 'spa']
  },
  ron: {
    label: 'Romeno',
    language: 'ron',
    keys: ['ro', 'ron']
  },
  cat: {
    label: 'Catalão',
    language: 'cat',
    keys: ['ca', 'cat']
  },
  chi: {
    label: 'Chinês',
    language: 'chi',
    keys: ['zh', 'chi']
  },
  kor: {
    label: 'Coreano',
    language: 'kor',
    keys: ['ko', 'kor']
  },
  dan: {
    label: 'Dinamarquês',
    language: 'dan',
    keys: ['da', 'dan']
  },
  fin: {
    label: 'Finlandês',
    language: 'fin',
    keys: ['fi', 'fin']
  },
  fre: {
    label: 'Francês',
    language: 'fre',
    keys: ['fr', 'fre']
  },
  wel: {
    label: 'Galês',
    language: 'wel',
    keys: ['cy', 'wel']
  },
  heb: {
    label: 'Hebraico',
    language: 'heb',
    keys: ['he', 'heb']
  },
  dut: {
    label: 'Holandês',
    language: 'dut',
    keys: ['nl', 'dut']
  },
  hin: {
    label: 'Hindi',
    language: 'hin',
    keys: ['hi', 'hin']
  },
  hun: {
    label: 'Húngaro',
    language: 'hun',
    keys: ['hu', 'hun']
  },
  ind: {
    label: 'Indonésio',
    language: 'ind',
    keys: ['id', 'ind']
  },
  ita: {
    label: 'Italiano',
    language: 'ita',
    keys: ['it', 'ita']
  },
  jpn: {
    label: 'Japonês',
    language: 'jpn',
    keys: ['ja', 'jpn']
  },
  nor: {
    label: 'Norueguês',
    language: 'nor',
    keys: ['no', 'nor', 'nob', 'nb']
  },
  per: {
    label: 'Persa',
    language: 'per',
    keys: ['fa', 'per']
  },
  rus: {
    label: 'Russo',
    language: 'rus',
    keys: ['ru', 'rus']
  },
  swe: {
    label: 'Sueco',
    language: 'swe',
    keys: ['sv', 'swe']
  },
  tha: {
    label: 'Tailandês',
    language: 'tha',
    keys: ['th', 'tha']
  },
  tur: {
    label: 'Turco',
    language: 'tur',
    keys: ['tr', 'tur']
  },
  ara: {
    label: 'Arábico',
    language: 'ara',
    keys: ['ar', 'ara']
  },
  fil: {
    label: 'Filipino',
    language: 'fil',
    keys: ['fil']
  },
  ice: {
    label: 'Islandês',
    language: 'ice',
    keys: ['ice', 'isl', 'is']
  },
  geo: {
    label: 'Georgiano',
    language: 'geo',
    keys: ['geo', 'kat', 'ka']
  },
  gre: {
    label: 'Grego',
    language: 'gre',
    keys: ['gre', 'ell', 'el', 'grc']
  },
  pol: {
    label: 'Polônes',
    language: 'pol',
    keys: ['pol', 'pl']
  },
  srp: {
    label: 'Sérvio',
    language: 'srp',
    keys: ['srp', 'scc', 'sr']
  },
  yid: {
    label: 'Iídiche',
    language: 'yid',
    keys: ['yid', 'yi']
  }
};

var PREFERRED_SUBTITLE = 'off';
var SUBTITLE_LANGUAGES = _objectSpread2(_objectSpread2({}, LANGUAGES), {}, {
  off: {
    label: 'Desabilitado',
    language: 'off',
    keys: ['off']
  }
});
var SUBTITLES_LIST = [];
var inc = 0;

for (var i in SUBTITLE_LANGUAGES) {
  SUBTITLES_LIST.push(_objectSpread2({
    id: inc
  }, SUBTITLE_LANGUAGES[i]));
  inc++;
}

var subtitle_config = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PREFERRED_SUBTITLE: PREFERRED_SUBTITLE,
  SUBTITLE_LANGUAGES: SUBTITLE_LANGUAGES,
  SUBTITLES_LIST: SUBTITLES_LIST
});

var subtitleIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var SubtitleSelector = /*#__PURE__*/function (_Selector) {
  _inherits(SubtitleSelector, _Selector);

  var _super = _createSuper(SubtitleSelector);

  _createClass(SubtitleSelector, [{
    key: "name",
    get: function get() {
      return 'subtitle_selector';
    }
  }, {
    key: "optionName",
    get: function get() {
      return 'subtitle';
    }
  }, {
    key: "title",
    get: function get() {
      return 'Legenda';
    }
  }, {
    key: "isReady",
    get: function get() {
      return this.video && this.playback.innerPlaybackName;
    }
  }, {
    key: "icon",
    get: function get() {
      return subtitleIcon;
    }
  }, {
    key: "container",
    get: function get() {
      return this.core && this.core.activeContainer;
    }
  }, {
    key: "initialSubtitleOption",
    get: function get() {
      return this.core.options.defaultSubtitle;
    }
  }, {
    key: "defaultOption",
    get: function get() {
      return this.initialSubtitleOption || PREFERRED_SUBTITLE;
    }
  }, {
    key: "resourceSubtitles",
    get: function get() {
      return this.video.selectedResource && this.video.selectedResource.subtitles;
    }
  }, {
    key: "subtitleTrackAutoHandled",
    get: function get() {
      return Browser.isiOS || Browser.isSafari && this.playback.innerPlaybackName === 'hls_fairplay_playback';
    }
  }, {
    key: "tagVideo",
    get: function get() {
      return this.playback.videoEl;
    }
  }]);

  function SubtitleSelector(core) {
    var _this;

    _classCallCheck(this, SubtitleSelector);

    _this = _super.call(this, core);
    _this.core = core;

    _this.setInitialValues();

    _this.onAddTrack = _this.onAddTrack.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SubtitleSelector, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);

      if (this.playback) {
        this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, function (video) {
          return _this2.video = video;
        });
        this.listenToOnce(this.playback, Events.WM_RESOURCE_READY, this.setup);
      }
    }
  }, {
    key: "containerChanged",
    value: function containerChanged() {
      this.stopListening();
      this.playback = this.core.activePlayback;
      this.bindEvents();
    }
  }, {
    key: "stopListening",
    value: function stopListening() {
      _get(_getPrototypeOf(SubtitleSelector.prototype), "stopListening", this).call(this);

      this.playback && this.subtitleTrackAutoHandled && this.tagVideo.textTracks.removeEventListener('addtrack', this.onAddTrack);
    }
  }, {
    key: "setInitialValues",
    value: function setInitialValues() {
      this.availableOptions = [];
      this.availableContents = [];
      this.currentSubtitleId = null;
    }
  }, {
    key: "setup",
    value: function setup() {
      this.setInitialValues();
      var subtitles = this.getSubtitleResource();
      if (!this.isReady || subtitles.length === 0) return;
      this.onSubtitleLoaded('off', '');
      this.subtitleTrackAutoHandled ? this.setupTextTracks() : this.loadSubtitles(subtitles);
    }
  }, {
    key: "getSubtitleResource",
    value: function getSubtitleResource() {
      var srtSubtitles = this.video.selectedResource.subtitles;
      var webvttSubtitles = this.video.selectedResource.subtitlesWebVTT;
      return !!this.core.options.shouldDeviceUseWebVTT && webvttSubtitles.length > 0 && webvttSubtitles || srtSubtitles;
    }
  }, {
    key: "setupTextTracks",
    value: function setupTextTracks() {
      this.tagVideo.textTracks.addEventListener('addtrack', this.onAddTrack);
    }
  }, {
    key: "onAddTrack",
    value: function onAddTrack(e) {
      var textTracks = this.tagVideo.textTracks;
      this.onSubtitleLoaded(e.track.language, '');
      if (this.availableOptions.length - 1 === textTracks.length) this.onAllSubtitlesLoaded(); // (availableOptions - 1): to remove 'off' from count
    }
  }, {
    key: "loadSubtitles",
    value: function loadSubtitles(subtitles) {
      var _this3 = this;

      var subtitlesRequestsList = subtitles.map(function (subtitle) {
        return _this3.fetchSubtitle(subtitle);
      });
      Promise.all(subtitlesRequestsList).then(function () {
        return _this3.onAllSubtitlesLoaded();
      });
    }
  }, {
    key: "fetchSubtitle",
    value: function fetchSubtitle(subtitle) {
      var _this4 = this;

      return new Promise(function (resolve) {
        $$1.ajax({
          url: subtitle.url,
          timeout: 3000,
          success: function success(subtitleContent) {
            _this4.onSubtitleLoaded(subtitle.language, subtitleContent, subtitle.type);

            resolve();
          },
          error: function error(_error) {
            _this4.onSubtitleLoadError(_error);

            resolve();
          }
        });
      });
    }
  }, {
    key: "onSubtitleLoadError",
    value: function onSubtitleLoadError(error) {
      Log$1.error(this.name, error);
    }
  }, {
    key: "onSubtitleLoaded",
    value: function onSubtitleLoaded(language, subtitleContent, type) {
      var subtitleOption = Object.values(SUBTITLE_LANGUAGES).find(function (option) {
        return option.keys.includes(language);
      });
      if (!subtitleOption) return;
      subtitleOption.id = this.availableOptions.length;
      type && (subtitleOption.type = type);
      this.availableOptions.push(_objectSpread2({}, subtitleOption));
      this.availableContents.push(subtitleContent);
    }
  }, {
    key: "onAllSubtitlesLoaded",
    value: function onAllSubtitlesLoaded() {
      // availableOptions's length is always >= 1 because 'off' / 'disabled' is an universal option.
      // If availableOption's length === 1, then it only includes 'off', and onSubtitlesReady shouldn't be called.
      if (this.availableOptions.length === 1) return;
      this.onSubtitlesReady();
    }
  }, {
    key: "onSubtitlesReady",
    value: function onSubtitlesReady() {
      this.setInitialSubtitle();
      this.container.trigger(Events.WM_SUBTITLE_AVAILABLE, this.availableOptions, this.availableContents);
      this.trigger(Events.WM_SETTINGS_OPTIONS_CHANGED);
    }
  }, {
    key: "findSubtitleOption",
    value: function findSubtitleOption(language) {
      return this.availableOptions.find(function (subtitle) {
        return subtitle.language === language;
      });
    }
  }, {
    key: "setInitialSubtitle",
    value: function setInitialSubtitle() {
      if (!this.availableOptions.length) return;
      var selectedSubtitleOption = this.findSubtitleOption(this.initialSubtitleOption);
      var preferredSubtitleOption = this.findSubtitleOption(PREFERRED_SUBTITLE);
      var subtitleOption = selectedSubtitleOption || preferredSubtitleOption;
      this.playbackUpdate(subtitleOption.id, false);
      this.interfaceUpdate(subtitleOption.id);
    }
  }, {
    key: "playbackUpdate",
    value: function playbackUpdate(id) {
      var triggerPublicEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.currentSubtitleId === id) return;
      this.selectedSubtitle = this.availableOptions[id];
      this.selectedSubtitle['selected'] = true;
      this.currentSubtitleId = id;
      this.playback.currentSubtitle = this.selectedSubtitle;
      triggerPublicEvent && this.container.trigger(Events.WM_SUBTITLE_CHANGED, this.selectedSubtitle);
    }
  }, {
    key: "getCurrentOption",
    value: function getCurrentOption() {
      return this.selectedSubtitle;
    }
  }]);

  return SubtitleSelector;
}(Selector);

var PREFERRED_AUDIO_OPTION = {
  language: 'por'
};
var AUDIOS_LIST = [];
var inc$1 = 0;

for (var i$1 in LANGUAGES) {
  AUDIOS_LIST.push(_objectSpread2({
    id: inc$1
  }, LANGUAGES[i$1]));
  inc$1++;
}

var audio_config = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PREFERRED_AUDIO_OPTION: PREFERRED_AUDIO_OPTION,
  AUDIOS_LIST: AUDIOS_LIST
});

var languageMatch = function languageMatch(audio, language) {
  return audio.language === language || audio.keys.includes(language);
};

var roleMatch = function roleMatch(audio, role) {
  return audio.role === role;
};

var BaseAudioSelector = /*#__PURE__*/function (_BaseObject) {
  _inherits(BaseAudioSelector, _BaseObject);

  var _super = _createSuper(BaseAudioSelector);

  _createClass(BaseAudioSelector, [{
    key: "initialAudioOption",
    get: function get() {
      return this.idPlayback.currentAudio || this.options.defaultAudio;
    }
  }, {
    key: "playback",
    get: function get() {
      return this.idPlayback.playback;
    }
  }, {
    key: "audioTracks",
    get: function get() {
      return [];
    }
  }]);

  function BaseAudioSelector(idPlayback) {
    var _this;

    _classCallCheck(this, BaseAudioSelector);

    _this = _super.call(this, idPlayback.options);
    _this.idPlayback = idPlayback;
    _this.ready = false;
    _this.availableOptions = [];
    _this.selectedAudio = null;
    _this.currentAudioId = null;

    _this.bindEvents();

    return _this;
  }

  _createClass(BaseAudioSelector, [{
    key: "bindEvents",
    value: function bindEvents() {
      if (!this.playback) return;
      this.listenToOnce(this.playback, Events$1.PLAYBACK_PLAY, this.setup);
    }
  }, {
    key: "onReady",
    value: function onReady() {
      this.ready = true;
      this.trigger(Events.WM_AUDIOSELECTOR_READY);
    } // override

  }, {
    key: "setup",
    value: function setup() {}
  }, {
    key: "parseAudioTracks",
    value: function parseAudioTracks() {}
  }, {
    key: "updateAudioPlayback",
    value: function updateAudioPlayback() {}
  }, {
    key: "getAudioInfo",
    value: function getAudioInfo(language) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : language;
      var role = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (typeof language !== 'string' || language === '' || language === 'audio') return;
      var audioData = this.findAudioData(language);
      if (!audioData) return;
      return _objectSpread2(_objectSpread2({}, audioData), {}, {
        language: language,
        label: this.getAudioLabel(audioData, role),
        role: role,
        id: id
      });
    }
  }, {
    key: "findAudioData",
    value: function findAudioData(language) {
      return AUDIOS_LIST.find(function (audio) {
        return languageMatch(audio, language);
      });
    }
  }, {
    key: "getAudioLabel",
    value: function getAudioLabel(_ref, role) {
      var label = _ref.label;
      if (role === 'description') return label.concat(' (Audiodescrição)');
      return label;
    }
  }, {
    key: "findAudioOption",
    value: function findAudioOption() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          language = _ref2.language,
          _ref2$role = _ref2.role,
          role = _ref2$role === void 0 ? '' : _ref2$role;

      return this.availableOptions.find(function (audio) {
        return languageMatch(audio, language) && roleMatch(audio, role);
      }) || this.availableOptions.find(function (audio) {
        return languageMatch(audio, language);
      });
    }
  }, {
    key: "setInitialAudio",
    value: function setInitialAudio() {
      if (!this.availableOptions.length) return;
      var selectedAudioOption = this.findAudioOption(this.initialAudioOption);
      var preferredAudioOption = this.findAudioOption(PREFERRED_AUDIO_OPTION);
      var audioOption = selectedAudioOption || preferredAudioOption;
      this.audioSwitch(audioOption.id, true);
    }
  }, {
    key: "getSelectedOption",
    value: function getSelectedOption() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id;
      if (typeof id === 'undefined' && typeof language === 'undefined') return;
      return this.availableOptions.find(function (t) {
        return t.id.toString() === id.toString() || t.language.toString() === language.toString() || t.keys.includes(language);
      });
    }
  }, {
    key: "audioSwitch",
    value: function audioSwitch(id) {
      var disableEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.currentAudioId === id && !disableEvent) return;
      this.selectedAudio = this.getSelectedOption(id);
      if (!this.selectedAudio) return;
      this.idPlayback.currentAudio = this.selectedAudio;
      this.selectedAudio['selected'] = true;
      this.currentAudioId = id;
      this.updateAudioPlayback();
      !disableEvent && this.trigger(Events.WM_AUDIO_CHANGED, this.selectedAudio);
    }
  }, {
    key: "getCurrentOption",
    value: function getCurrentOption() {
      return this.selectedAudio;
    }
  }]);

  return BaseAudioSelector;
}(BaseObject);

var DashSelector = /*#__PURE__*/function (_BaseAudioSelector) {
  _inherits(DashSelector, _BaseAudioSelector);

  var _super = _createSuper(DashSelector);

  function DashSelector() {
    _classCallCheck(this, DashSelector);

    return _super.apply(this, arguments);
  }

  _createClass(DashSelector, [{
    key: "setup",
    value: function setup() {
      if (this.audioTracks.length > 1) {
        this.parseAudioTracks();
        this.setInitialAudio();
      }
    }
  }, {
    key: "parseAudioTracks",
    value: function parseAudioTracks() {
      var _this = this;

      this.availableOptions = [];
      var id = 0;
      this.audioTracks.forEach(function (track) {
        var role = _this.getAudioRole(track);

        var audio = _this.getAudioInfo(track.language, id, role);

        audio && _this.availableOptions.push(audio);
        id++;
      });
      this.onReady();
    }
  }, {
    key: "getAudioRole",
    value: function getAudioRole(_ref) {
      var role = _ref.role;
      return role === 'alternate' ? 'description' : '';
    }
  }, {
    key: "updateAudioPlayback",
    value: function updateAudioPlayback() {
      var _this$playback, _this$playback$_playe;

      var _this$selectedAudio = this.selectedAudio,
          language = _this$selectedAudio.language,
          role = _this$selectedAudio.role;
      var shakaLanguageRole = role === 'description' ? 'alternate' : 'main';
      (_this$playback = this.playback) === null || _this$playback === void 0 ? void 0 : (_this$playback$_playe = _this$playback._player) === null || _this$playback$_playe === void 0 ? void 0 : _this$playback$_playe.selectAudioLanguage(language, shakaLanguageRole);
    }
  }, {
    key: "audioTracks",
    get: function get() {
      var _this$playback2, _this$playback2$_play;

      return ((_this$playback2 = this.playback) === null || _this$playback2 === void 0 ? void 0 : (_this$playback2$_play = _this$playback2._player) === null || _this$playback2$_play === void 0 ? void 0 : _this$playback2$_play.getAudioLanguagesAndRoles()) || [];
    }
  }]);

  return DashSelector;
}(BaseAudioSelector);

var HLSAudioSelector = /*#__PURE__*/function (_BaseAudioSelector) {
  _inherits(HLSAudioSelector, _BaseAudioSelector);

  var _super = _createSuper(HLSAudioSelector);

  function HLSAudioSelector() {
    _classCallCheck(this, HLSAudioSelector);

    return _super.apply(this, arguments);
  }

  _createClass(HLSAudioSelector, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      if (!this.playback._hls) return;

      if (this.audioTracks.length > 1) {
        this.parseAudioTracks();
        this.setInitialAudio();
      } else {
        this.playback._hls.once(HLSJS.Events.AUDIO_TRACKS_UPDATED, function () {
          return _this.setup();
        });
      }
    }
  }, {
    key: "parseAudioTracks",
    value: function parseAudioTracks() {
      var _this2 = this;

      this.availableOptions = [];
      this.audioTracks.forEach(function (track) {
        var language = (track.lang || track.name || '').toLowerCase();

        var role = _this2.getAudioRole(track);

        var audio = _this2.getAudioInfo(language, track.id, role);

        audio && _this2.availableOptions.push(audio);
      });
      this.onReady();
    }
  }, {
    key: "getAudioRole",
    value: function getAudioRole(track) {
      if (this.checkIfAudioTrackDescriptive(track)) return 'description';
      return '';
    }
  }, {
    key: "checkIfAudioTrackDescriptive",
    value: function checkIfAudioTrackDescriptive(track) {
      var _track$attrs, _track$attrs$CHARACTE;

      return (_track$attrs = track.attrs) === null || _track$attrs === void 0 ? void 0 : (_track$attrs$CHARACTE = _track$attrs.CHARACTERISTICS) === null || _track$attrs$CHARACTE === void 0 ? void 0 : _track$attrs$CHARACTE.includes('public.accessibility.describes-video');
    }
  }, {
    key: "updateAudioPlayback",
    value: function updateAudioPlayback() {
      if (this.playback && this.playback._hls) this.playback._hls.audioTrack = this.selectedAudio.id;
    }
  }, {
    key: "audioTracks",
    get: function get() {
      return this.playback._hls.audioTracks || [];
    }
  }]);

  return HLSAudioSelector;
}(BaseAudioSelector);

var HTML5Selector = /*#__PURE__*/function (_BaseAudioSelector) {
  _inherits(HTML5Selector, _BaseAudioSelector);

  var _super = _createSuper(HTML5Selector);

  function HTML5Selector() {
    _classCallCheck(this, HTML5Selector);

    return _super.apply(this, arguments);
  }

  _createClass(HTML5Selector, [{
    key: "setup",
    value: function setup() {
      if (this.audioTracks.length > 1) {
        this.parseAudioTracks();
        this.setInitialAudio();
      }
    }
  }, {
    key: "parseAudioTracks",
    value: function parseAudioTracks() {
      var _this = this;

      this.availableOptions = [];
      this.audioTracks.forEach(function (track) {
        var language = (track.language || track.label || '').toLowerCase();

        var role = _this.getAudioRole(track);

        var audio = _this.getAudioInfo(language, track.id, role);

        audio && _this.availableOptions.push(audio);
      });
      this.onReady();
    }
  }, {
    key: "getAudioRole",
    value: function getAudioRole(_ref) {
      var kind = _ref.kind;
      if (kind === 'description') return kind;
      return '';
    }
  }, {
    key: "updateAudioPlayback",
    value: function updateAudioPlayback() {
      var _this2 = this;

      this.audioTracks.forEach(function (track) {
        track.enabled = track.id.toString() === _this2.selectedAudio.id.toString();
      });
    }
  }, {
    key: "audioTracks",
    get: function get() {
      var audioTracks = this.playback && this.playback.el && this.playback.el.audioTracks;
      if (_typeof(audioTracks) === 'object') audioTracks = Object.keys(audioTracks).map(function (key) {
        return audioTracks[key];
      });
      return audioTracks || [];
    }
  }]);

  return HTML5Selector;
}(BaseAudioSelector);

var CastAudioSelector = /*#__PURE__*/function (_BaseObject) {
  _inherits(CastAudioSelector, _BaseObject);

  var _super = _createSuper(CastAudioSelector);

  _createClass(CastAudioSelector, [{
    key: "audioTracks",
    get: function get() {
      return this.playback.getAudioStreams() || [];
    }
  }]);

  function CastAudioSelector(idPlayback) {
    var _this;

    _classCallCheck(this, CastAudioSelector);

    _this = _super.call(this, idPlayback.options);
    _this.idPlayback = idPlayback;
    _this.ready = false;
    _this.playback = _this.idPlayback.playback;

    _this.bindEvents();

    return _this;
  }

  _createClass(CastAudioSelector, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.playback, Events$1.PLAYBACK_PLAY, this.setup);
    }
  }, {
    key: "setup",
    value: function setup() {
      this.audioTracks.length > 1 && this.parseAudioTracks();
    }
  }, {
    key: "parseAudioTracks",
    value: function parseAudioTracks() {
      this.ready = true;
      this.trigger(Events.WM_AUDIOSELECTOR_READY);
      this.trigger(Events.WM_AUDIO_AVAILABLE, this.audioTracks);
    }
  }]);

  return CastAudioSelector;
}(BaseObject);

var audioIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var AudioSelector = /*#__PURE__*/function (_Selector) {
  _inherits(AudioSelector, _Selector);

  var _super = _createSuper(AudioSelector);

  function AudioSelector() {
    _classCallCheck(this, AudioSelector);

    return _super.apply(this, arguments);
  }

  _createClass(AudioSelector, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
      this.playback && this.listenTo(this.playback, Events.WM_PLAYBACK_WILL_PLAY, this.setup);
      this.playback && this.playback.isReady && this.setup();
    }
  }, {
    key: "containerChanged",
    value: function containerChanged() {
      this.stopListening();
      this.playback = this.core.activePlayback;
      this.bindEvents();
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this = this;

      this.availableOptions = [];
      var innerPlaybackName = this.playback.innerPlaybackName;

      if (!innerPlaybackName) {
        Log$1.info(this.name, 'should not setup audio selector');
        return;
      }

      this.selector && this.stopListening(this.selector);

      if (innerPlaybackName === 'dash_shaka_playback') {
        this.selector = new DashSelector(this.playback);
      } else if (innerPlaybackName === 'hls') {
        this.selector = new HLSAudioSelector(this.playback);
      } else if (['html5', 'html5_video', 'hls_fairplay_playback'].includes(innerPlaybackName)) {
        this.selector = new HTML5Selector(this.playback);
      } else if (innerPlaybackName === 'cast') {
        this.selector = new CastAudioSelector(this.playback);
      } else {
        Log$1.info(this.name, 'could not setup audio selector');
        return;
      }

      this.listenTo(this.selector, Events.WM_AUDIOSELECTOR_READY, this.onSelectorReady);
      this.listenTo(this.selector, Events.WM_AUDIO_CHANGED, this.onAudioChanged);
      this.listenTo(this.selector, Events.WM_AUDIO_AVAILABLE, function (availableOptions) {
        _this.container.trigger(Events.WM_AUDIO_AVAILABLE, availableOptions);
      });
      this.selector.setup();
    }
  }, {
    key: "onSelectorReady",
    value: function onSelectorReady() {
      this.availableOptions = this.selector.availableOptions;
      this.trigger(Events.WM_SETTINGS_OPTIONS_CHANGED);
    }
  }, {
    key: "playbackUpdate",
    value: function playbackUpdate(optionId) {
      this.selector.audioSwitch(optionId);
    }
  }, {
    key: "onAudioChanged",
    value: function onAudioChanged(selectedAudio) {
      this.container.trigger(Events.WM_AUDIO_CHANGED, selectedAudio);
    }
  }, {
    key: "getCurrentOption",
    value: function getCurrentOption() {
      return this.selector.getCurrentOption();
    }
  }, {
    key: "name",
    get: function get() {
      return 'audio_selector';
    }
  }, {
    key: "optionName",
    get: function get() {
      return 'audio';
    }
  }, {
    key: "title",
    get: function get() {
      return '&Aacute;udio';
    }
  }, {
    key: "icon",
    get: function get() {
      return audioIcon;
    }
  }, {
    key: "container",
    get: function get() {
      return this.core && this.core.activeContainer;
    }
  }, {
    key: "defaultOption",
    get: function get() {
      return this.core.options.defaultAudio || PREFERRED_AUDIO_OPTION;
    }
  }]);

  return AudioSelector;
}(Selector);

var css_248z$f = ".clappr-player#wp3-player-0 .media-control.volume-modal--visible .settings__box {\n  opacity: 0.3; }\n\n.clappr-player#wp3-player-0 .media-control.volume-modal--visible .media-control-panel__modal {\n  z-index: -1; }\n\n.clappr-player#wp3-player-0 .media-control.touch .media-control-panel__modal .settings__menu-item-option, .clappr-player#wp3-player-0 .media-control.touch .media-control-panel__modal .settings__menu-item-selected {\n  padding-top: 8px;\n  padding-bottom: 8px; }\n\n.clappr-player#wp3-player-0 .media-control.touch .media-control-panel__modal .settings__options-item {\n  padding: 8px 32px 8px 60px; }\n  .clappr-player#wp3-player-0 .media-control.touch .media-control-panel__modal .settings__options-item--active {\n    padding-left: 4px; }\n\n.clappr-player#wp3-player-0 .media-control .media-control-panel .settings .settings__box--hidden {\n  opacity: 0; }\n\n.clappr-player#wp3-player-0 .media-control-panel__modal.settings__modal {\n  z-index: 998; }\n\n.clappr-player#wp3-player-0 .media-control.w360 .settings__box, .clappr-player#wp3-player-0 .media-control.w480 .settings__box, .clappr-player#wp3-player-0 .media-control.w540 .settings__box {\n  background-color: transparent; }\n\n.clappr-player#wp3-player-0 .settings {\n  position: relative;\n  cursor: pointer;\n  line-height: 100%; }\n  .clappr-player#wp3-player-0 .settings__button {\n    width: 100%;\n    height: 100%;\n    padding: 0; }\n  .clappr-player#wp3-player-0 .settings__box {\n    position: absolute;\n    right: 12px;\n    bottom: 64px;\n    cursor: default;\n    border-radius: 4px;\n    background-color: rgba(17, 17, 17, 0.8);\n    z-index: 998;\n    box-sizing: content-box;\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    will-change: opacity; }\n    .clappr-player#wp3-player-0 .settings__box--options-rendered .settings__header {\n      display: flex; }\n    .clappr-player#wp3-player-0 .settings__box--options-rendered .settings__title {\n      padding-right: 32px; }\n  .clappr-player#wp3-player-0 .settings__header {\n    display: none;\n    flex-shrink: 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    cursor: pointer; }\n    .clappr-player#wp3-player-0 .settings__header-info-container {\n      display: flex; }\n    .clappr-player#wp3-player-0 .settings__header--hidden {\n      display: none !important; }\n  .clappr-player#wp3-player-0 .settings__body {\n    display: flex;\n    width: 100%;\n    flex-grow: 2;\n    box-sizing: content-box;\n    padding: 8px 0;\n    align-items: center;\n    max-height: 180px;\n    overflow: auto; }\n  .clappr-player#wp3-player-0 .settings__menu, .clappr-player#wp3-player-0 .settings__options, .clappr-player#wp3-player-0 .settings__options-wrapper, .clappr-player#wp3-player-0 .settings__options-menu {\n    max-height: inherit;\n    overflow: inherit; }\n  .clappr-player#wp3-player-0 .settings__title {\n    display: flex;\n    padding: 12px;\n    align-items: center;\n    opacity: 0.5;\n    font-family: \"opensans-regular\";\n    letter-spacing: -0.5;\n    font-size: 15px;\n    line-height: 1;\n    color: #FFFFFF;\n    text-transform: capitalize; }\n    .clappr-player#wp3-player-0 .settings__title-option {\n      padding-left: 0; }\n  .clappr-player#wp3-player-0 .settings__close {\n    display: none;\n    box-sizing: content-box;\n    width: 24px;\n    height: 24px;\n    padding: 12px;\n    cursor: pointer; }\n    .clappr-player#wp3-player-0 .settings__close svg {\n      width: 100%;\n      height: 100%; }\n  .clappr-player#wp3-player-0 .settings__separator {\n    display: block;\n    width: 100%;\n    height: 1px;\n    border: 0;\n    background-color: #666;\n    opacity: .4;\n    margin: 12px 0; }\n  .clappr-player#wp3-player-0 .settings__menu {\n    display: flex;\n    flex-direction: column;\n    list-style-type: none;\n    background: none;\n    padding: 0;\n    margin: 0;\n    height: auto;\n    cursor: pointer; }\n    .clappr-player#wp3-player-0 .settings__menu-item {\n      display: flex;\n      flex-shrink: 0;\n      align-items: center;\n      justify-content: space-between;\n      align-self: stretch;\n      position: static;\n      line-height: 1.14;\n      padding: 0;\n      margin: 0;\n      background: none; }\n      .clappr-player#wp3-player-0 .settings__menu-item-option {\n        padding: 4px 0 4px 16px; }\n      .clappr-player#wp3-player-0 .settings__menu-item-selected {\n        padding: 4px 16px 4px 24px; }\n      .clappr-player#wp3-player-0 .settings__menu-item:hover {\n        cursor: pointer; }\n      .clappr-player#wp3-player-0 .settings__menu-item-option {\n        display: flex;\n        align-items: center;\n        pointer-events: none; }\n      .clappr-player#wp3-player-0 .settings__menu-item-icon {\n        width: 16px;\n        height: 16px;\n        margin-right: 8px; }\n        .clappr-player#wp3-player-0 .settings__menu-item-icon svg {\n          width: 100%;\n          height: 100%; }\n      .clappr-player#wp3-player-0 .settings__menu-item-title {\n        display: inline;\n        pointer-events: none;\n        font-family: \"opensans-regular\", sans-serif;\n        text-transform: capitalize;\n        font-size: 14px;\n        line-height: 1.14;\n        color: #FFFFFF;\n        opacity: 1; }\n      .clappr-player#wp3-player-0 .settings__menu-item-selected {\n        display: flex;\n        align-items: center;\n        padding-left: 24px;\n        pointer-events: none; }\n      .clappr-player#wp3-player-0 .settings__menu-item-arrow-icon {\n        width: 24px;\n        height: 24px;\n        margin-left: 8px; }\n        .clappr-player#wp3-player-0 .settings__menu-item-arrow-icon svg {\n          width: 100%;\n          height: 100%; }\n      .clappr-player#wp3-player-0 .settings__menu-item-value {\n        font-family: \"opensans-regular\", sans-serif;\n        font-size: 14px;\n        color: #FFFFFF;\n        opacity: 0.5;\n        cursor: pointer; }\n      .clappr-player#wp3-player-0 .settings__menu-item-title, .clappr-player#wp3-player-0 .settings__menu-item-value {\n        height: 16px; }\n    .clappr-player#wp3-player-0 .settings__menu--hidden {\n      display: none !important; }\n  .clappr-player#wp3-player-0 .settings__back-icon {\n    display: flex;\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    padding: 12px;\n    margin-right: 4px;\n    box-sizing: content-box; }\n    .clappr-player#wp3-player-0 .settings__back-icon svg {\n      width: 100%;\n      height: 100%; }\n    .clappr-player#wp3-player-0 .settings__back-icon--hidden {\n      display: none !important; }\n  .clappr-player#wp3-player-0 .settings__options {\n    display: flex;\n    cursor: pointer;\n    width: 100%; }\n    .clappr-player#wp3-player-0 .settings__options-wrapper {\n      margin: 0 auto;\n      width: 100%; }\n    .clappr-player#wp3-player-0 .settings__options-header {\n      display: flex;\n      align-items: center; }\n    .clappr-player#wp3-player-0 .settings__options-title {\n      display: flex;\n      cursor: pointer;\n      opacity: 0.7;\n      font-family: \"opensans-regular\", sans-serif;\n      color: #FFFFFF;\n      text-transform: capitalize;\n      text-align: left;\n      font-size: 14px; }\n    .clappr-player#wp3-player-0 .settings__options-menu {\n      list-style-type: none;\n      background: none;\n      padding: 0;\n      margin: 0; }\n    .clappr-player#wp3-player-0 .settings__options-item {\n      display: flex;\n      align-items: center;\n      box-sizing: content-box;\n      height: 24px;\n      padding: 4px 32px 4px 56px;\n      background: none;\n      font-family: \"opensans-regular\", sans-serif;\n      font-size: 14px;\n      line-height: 1.14;\n      color: #FFFFFF;\n      opacity: 1; }\n      .clappr-player#wp3-player-0 .settings__options-item::before {\n        content: \"\"; }\n      .clappr-player#wp3-player-0 .settings__options-item .label {\n        display: inline-block;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n      .clappr-player#wp3-player-0 .settings__options-item--active {\n        margin-left: 0;\n        font-family: \"opensans-regular\", sans-serif;\n        opacity: 1;\n        padding-left: 0; }\n    .clappr-player#wp3-player-0 .settings__options-active-icon {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      padding: 0 16px;\n      box-sizing: content-box; }\n      .clappr-player#wp3-player-0 .settings__options-active-icon svg {\n        width: 100%;\n        height: 100%; }\n    .clappr-player#wp3-player-0 .settings__options--hidden {\n      display: none !important; }\n";
styleInject(css_248z$f);

var css_248z$g = ".clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  right: 0;\n  bottom: 0;\n  padding: 0; }\n  .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__header {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    margin-bottom: 8px; }\n  .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__body {\n    max-height: calc(100% - 57px) !important;\n    max-width: 336px;\n    padding: 0; }\n  .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__menu {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    flex-direction: column;\n    max-height: 100%; }\n    .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__menu-item-title {\n      align-self: center; }\n    .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__menu-item-value {\n      line-height: 1.14; }\n  .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__options {\n    max-height: 100%; }\n    .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__options-wrapper {\n      margin-left: 20%; }\n    .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__options-title {\n      height: 24px;\n      align-items: center; }\n    .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__options-item {\n      padding-right: 88px; }\n  .clappr-player#wp3-player-0 .media-control .settings__box.settings__fullscreen .settings__close {\n    display: flex; }\n";
styleInject(css_248z$g);

var templateHtml$2 = "<div class=\"settings__box settings__box--hidden\" data-controls>\n  <div class=\"settings__header\">\n    <div class=\"settings__header-info-container\">\n      <span class=\"settings__back-icon settings__back-icon--hidden\"><%= backIcon %></span>\n      <span class=\"settings__title\">configurações</span>\n    </div>\n    <span class=\"settings__close settings__close--hidden\"><%= closeIcon %></span>\n  </div>\n  <div class=\"settings__body\">\n    <ul class=\"settings__menu\">\n      <% for (var i = 0; i < selectors.length; i++) { %>\n        <li data-selector-name=\"<%= selectors[i].name %>\" class=\"settings__menu-item\">\n          <span class=\"settings__menu-item-option\">\n            <span class=\"settings__menu-item-icon\"><%= selectors[i].icon %></span>\n            <span class=\"settings__menu-item-title\"><%= selectors[i].title %></span>\n          </span>\n          <span class=\"settings__menu-item-selected\">\n            <span class=\"settings__menu-item-value\"><%= selectors[i].selected %></span>\n            <span class=\"settings__menu-item-arrow-icon\"><%= arrowIcon %></span>\n          </span>\n        </li>\n      <% } %>\n    </ul>\n    <div class=\"settings__options settings__options--hidden\"></div>\n  </div>\n</div>\n";

var speechBubbleIcon = "<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.26892 3H20.2689C21.3689 3 22.2589 3.9 22.2589 5L22.2689 23L18.2689 19H4.26892C3.16892 19 2.26892 18.1 2.26892 17V5C2.26892 3.9 3.16892 3 4.26892 3ZM20.2689 11H16.2689V13H20.2689V11ZM20.2689 17H10.2689V15H20.2689V17ZM4.26892 17H8.26892V15H4.26892V17ZM14.2689 13H4.26892V11H14.2689V13Z\" fill=\"#EEEEEE\"/>\n<mask id=\"mask0_6_301\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"2\" y=\"3\" width=\"21\" height=\"20\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.26892 3H20.2689C21.3689 3 22.2589 3.9 22.2589 5L22.2689 23L18.2689 19H4.26892C3.16892 19 2.26892 18.1 2.26892 17V5C2.26892 3.9 3.16892 3 4.26892 3ZM20.2689 11H16.2689V13H20.2689V11ZM20.2689 17H10.2689V15H20.2689V17ZM4.26892 17H8.26892V15H4.26892V17ZM14.2689 13H4.26892V11H14.2689V13Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_6_301)\">\n</g>\n</svg>";

var SETTINGS_FULLSCREEN_BREAKPOINT = 540;
var BOX_CLASS = '.settings__box';
var MENU_CLASS = '.settings__menu';
var OPTIONS_CONTENT_CLASS = '.settings__options';
var HEADER_TITLE_CLASS = '.settings__title';
var SETTINGS_BACK_ICON_CLASS = '.settings__back-icon';
var HEADER_OPTIONS_TITLE_CLASS_NAME = 'settings__title-option';
var BOX_WITH_OPTIONS_RENDERED_CLASS_NAME = 'settings__box--options-rendered';
var SETTINGS_TITLE = 'Configurações';

var Settings = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(Settings, _MediaControlPlugin);

  var _super = _createSuper(Settings);

  _createClass(Settings, [{
    key: "getExternalInterface",
    value: function getExternalInterface() {
      return {
        getSelectedSettings: this.getSelectedSettings,
        getDefaultSettings: this.getDefaultSettings
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'settings';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'right';
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$2);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'settings',
        'data-settings': ''
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.core && this.core.activePlayback;
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click': 'toggleSettingsBox'
      };
    }
  }, {
    key: "selectors",
    get: function get() {
      this._selectors = this._selectors || [new AudioSelector(this.core), new SubtitleSelector(this.core)];
      return this._selectors;
    }
  }, {
    key: "availableSelectors",
    get: function get() {
      return this.selectors.filter(function (selector) {
        return selector.shouldRender();
      });
    }
  }]);

  function Settings(core) {
    var _this;

    _classCallCheck(this, Settings);

    _this = _super.call(this, core);

    _this.hideSettingsBoxHandler = function () {
      return _this.hideSettingsBox();
    };

    return _this;
  }

  _createClass(Settings, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_RENDERED, this.render);
      this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_HIDE, this.onMediaControlhide);
      this.selectors.forEach(function (selector) {
        _this2.listenTo(selector, Events.WM_SETTINGS_OPTIONS_CHANGED, _this2.render);
      });
    }
  }, {
    key: "onMediaControlhide",
    value: function onMediaControlhide() {
      if (this.mediaControl.keepVisible || !this.isSettingsBoxVisible) return;
      this.$settingsBox.remove();
      var $modalPanel = this.mediaControl.$modal;
      $modalPanel && $modalPanel.removeClass('settings__modal');
      this.resetSettings();
      this.triggerDidHideModalElement();
    }
  }, {
    key: "bindMenuClickEvents",
    value: function bindMenuClickEvents() {
      this.unbindMenuClickEvents();
      this.$settingsMenuitem = this.$settingsBox.find('.settings__menu-item');
      this.$settingsMenuitem.on('click', this.clickMenu.bind(this));
    }
  }, {
    key: "unbindMenuClickEvents",
    value: function unbindMenuClickEvents() {
      this.$settingsMenuitem && this.$settingsMenuitem.off('click');
    }
  }, {
    key: "bindSettingsEvents",
    value: function bindSettingsEvents() {
      var _this3 = this;

      this.unbindSettingsEvents();
      this.$settingsOptionsTitle = this.$settingsBox.find('.settings__options-title');
      this.$settingsBox.on('click', function (e) {
        return e.stopPropagation();
      });
      this.bindMenuClickEvents();
      nextTick(function () {
        $$1(document).one('click', _this3.hideSettingsBoxHandler); // eslint-disable-line no-undef

        _this3.listenTo(_this3.mediaControl, Events.MEDIACONTROL_ITEMCLICKED, _this3.hideSettingsBoxHandler);
      });
    }
  }, {
    key: "unbindSettingsEvents",
    value: function unbindSettingsEvents() {
      this.$settingsOptionsTitle && this.$settingsOptionsTitle.off('click');
      this.$settingsClose && this.$settingsClose.off('click');
      $$1(document).off('click', this.hideSettingsBoxHandler); // eslint-disable-line no-undef

      this.stopListening(this.mediaControl, Events.MEDIACONTROL_ITEMCLICKED, this.hideSettingsBoxHandler);
    }
  }, {
    key: "onContainerChanged",
    value: function onContainerChanged() {
      this.resetSettings();
      this.render();
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!size.width || typeof size.width !== 'number') return;
      this.currentWidth = size.width;
      this.updateSettingsBoxMaxHeight();
      this.updateSettingsFullScreenState(this.settingsFullScreenEnabled);
    }
  }, {
    key: "updateSettingsFullScreenState",
    value: function updateSettingsFullScreenState(previousFullscreenEnabled) {
      this.settingsFullScreenEnabled = this.currentWidth < SETTINGS_FULLSCREEN_BREAKPOINT;
      if (!this.isSettingsBoxVisible || previousFullscreenEnabled === this.settingsFullScreenEnabled) return;
      this.settingsFullScreenEnabled ? this.showSettingsFullScreen() : this.hideSettingsFullScreen();
    }
  }, {
    key: "getPanelBetweenHeight",
    value: function getPanelBetweenHeight() {
      var betweenPanel = this.mediaControl.$el.find('.media-control-panel__between');
      return betweenPanel && betweenPanel.height();
    }
  }, {
    key: "getSettingBoxHeaderHeight",
    value: function getSettingBoxHeaderHeight() {
      var settingsBoxHeader = this.mediaControl.$modal.find('.settings__header');
      return settingsBoxHeader && settingsBoxHeader.height();
    }
  }, {
    key: "updateSettingsBoxMaxHeight",
    value: function updateSettingsBoxMaxHeight() {
      if (!this.isSettingsBoxVisible) return;
      var panelBetweenHeight = this.getPanelBetweenHeight();
      var settingsBoxHeaderHeight = this.getSettingBoxHeaderHeight();

      if (panelBetweenHeight >= 0 && settingsBoxHeaderHeight >= 0) {
        var maxHeight = panelBetweenHeight - settingsBoxHeaderHeight;
        this.mediaControl.$modal.find('.settings__body').css({
          maxHeight: maxHeight
        });
      }
    }
  }, {
    key: "clickMenu",
    value: function clickMenu(e) {
      e.stopPropagation();
      var selectorName = $$1(e.target).data('selector-name');
      var selectedOption = this.selectors.find(function (selector) {
        return selector.name === selectorName;
      });
      this.fromMenuToOptions();
      this.renderOptions(selectedOption);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(option) {
      this.$settingsBox.find(OPTIONS_CONTENT_CLASS).html(option.render().el);
      this.$settingsBox.find(HEADER_TITLE_CLASS).html(option.title);
      this.$settingsBox.find(HEADER_TITLE_CLASS).addClass(HEADER_OPTIONS_TITLE_CLASS_NAME);
      this.$settingsBox.find('.settings__header').on('click', this.fromOptionsToMenu.bind(this));
    }
  }, {
    key: "fromMenuToOptions",
    value: function fromMenuToOptions() {
      this.$settingsBox.addClass(BOX_WITH_OPTIONS_RENDERED_CLASS_NAME);
      this.$settingsBox.find(MENU_CLASS).addClass('settings__menu--hidden');
      this.$settingsBox.find(OPTIONS_CONTENT_CLASS).removeClass('settings__options--hidden');
      this.$settingsBox.find(SETTINGS_BACK_ICON_CLASS).removeClass('settings__back-icon--hidden');
      this.updateSettingsBoxMaxHeight();
    }
  }, {
    key: "fromOptionsToMenu",
    value: function fromOptionsToMenu(e) {
      e && e.stopPropagation();
      this.$settingsBox.removeClass(BOX_WITH_OPTIONS_RENDERED_CLASS_NAME);
      this.$settingsBox.find(MENU_CLASS).removeClass('settings__menu--hidden');
      this.$settingsBox.find(OPTIONS_CONTENT_CLASS).addClass('settings__options--hidden');
      this.$settingsBox.find(SETTINGS_BACK_ICON_CLASS).addClass('settings__back-icon--hidden');
      this.$settingsBox.find(HEADER_TITLE_CLASS).html(SETTINGS_TITLE);
      this.$settingsBox.find(HEADER_TITLE_CLASS).removeClass(HEADER_OPTIONS_TITLE_CLASS_NAME);
      this.updateSettingsBoxMaxHeight();
      this.updateAllSelectors();
    }
  }, {
    key: "toggleSettingsBox",
    value: function toggleSettingsBox(e) {
      e.stopPropagation();
      this.isSettingsBoxVisible ? this.hideSettingsBox() : this.showSettingsBox();
    }
  }, {
    key: "showSettingsBox",
    value: function showSettingsBox() {
      var _this4 = this;

      var settingsBoxHTML = this.template({
        'selectors': this.availableSelectors,
        arrowIcon: arrowIcon,
        backIcon: backIcon,
        closeIcon: closeIcon
      });
      this.triggerWillShowModalElement();

      if (!this.settingsFullScreenEnabled) {
        this.$settingsBox = $$1(settingsBoxHTML);
        this.$el.append(this.$settingsBox);
        nextTick(function () {
          return _this4.$settingsBox.removeClass('settings__box--hidden');
        });
      }

      this.mediaControl.$modal.addClass('settings__modal');
      this.mediaControl.trigger(Events.WM_SETTINGS_SHOW);
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_SHOW, '<div/>');
      this.isSettingsBoxVisible = true;
      this.updateSettingsBoxMaxHeight();
      this.updateSettingsFullScreenState(false);
      this.bindSettingsEvents();
      this.mediaControl.setKeepVisible();
    }
  }, {
    key: "updateAllSelectors",
    value: function updateAllSelectors() {
      var _this5 = this;

      this.availableSelectors.forEach(function (selector) {
        _this5.updateSelectorValue(selector);
      });
    }
  }, {
    key: "updateSelectorValue",
    value: function updateSelectorValue(selector) {
      var itemSelector = "li[data-selector-name=".concat(selector.name, "] .settings__menu-item-value");
      var item = this.$settingsBox && this.$settingsBox.find(itemSelector);
      item && item.html(selector.selected);
      this.bindMenuClickEvents();
    }
  }, {
    key: "showSettingsFullScreen",
    value: function showSettingsFullScreen() {
      var _this6 = this;

      if (!this.isSettingsBoxVisible) return;
      this.$settingsBox && this.$settingsBox.remove();
      var settingsBoxHTML = this.template({
        'selectors': this.availableSelectors,
        arrowIcon: arrowIcon,
        backIcon: backIcon,
        closeIcon: closeIcon
      });
      this.mediaControl.updatePanelsVisibility({
        hide: true
      });
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_SHOW, settingsBoxHTML);
      this.hasPlayingBeforeModal = this.playback.isPlaying();
      this.hasPlayingBeforeModal && this.playback.pause();
      this.$settingsBox = this.mediaControl.$modal.find(BOX_CLASS);
      this.$settingsBox.addClass('settings__fullscreen');
      this.bindSettingsEvents();
      nextTick(function () {
        _this6.$settingsBox.removeClass('settings__box--hidden');

        _this6.$settingsClose = _this6.$settingsBox.find('.settings__close');
        _this6.$settingsClose && _this6.$settingsClose.removeClass('settings__close--hidden');
        _this6.$settingsClose && _this6.$settingsClose.on('click', _this6.hideSettingsBox.bind(_this6));
      });
    }
  }, {
    key: "hideSettingsBox",
    value: function hideSettingsBox() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isSettingsBoxVisible) return;
      this.$settingsBox.addClass('settings__box--hidden');
      this.$settingsBox.one('transitionend', function () {
        return _this7.$settingsBox.remove();
      });
      this.unbindSettingsEvents();
      this.resetSettings();
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_HIDE, options);
      this.mediaControl.trigger(Events.WM_SETTINGS_HIDE);
      this.mediaControl.resetKeepVisible();
      this.triggerDidHideModalElement();
      this.resetSettings();
      this.hasPlayingBeforeModal && this.playback.play();
    }
  }, {
    key: "hideSettingsFullScreen",
    value: function hideSettingsFullScreen() {
      this.mediaControl.updatePanelsVisibility({
        hide: false
      });
      this.showSettingsBox();
    }
  }, {
    key: "resetSettings",
    value: function resetSettings() {
      this.isSettingsBoxVisible = false;
    }
  }, {
    key: "getSelectedSettings",
    value: function getSelectedSettings() {
      var selectedOptions = {};
      this.availableSelectors.forEach(function (selector) {
        selectedOptions[selector.optionName] = selector.getCurrentOption();
      });
      return selectedOptions;
    }
  }, {
    key: "getDefaultSettings",
    value: function getDefaultSettings() {
      var defaultSettings = {};
      this.selectors.forEach(function (selector) {
        defaultSettings[selector.optionName] = selector.defaultOption;
      });
      return defaultSettings;
    }
  }, {
    key: "shouldRender",
    value: function shouldRender() {
      return this.availableSelectors.length > 0 && !['ad', 'live'].includes(this.core.getPlaybackType());
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isSettingsBoxVisible) return;
      this.$el.html('');
      var style = Styler.getStyleFrom(css_248z$f, {
        playerId: this.core.options.playerId
      });
      var responsiveStyle = Styler.getStyleFrom(css_248z$g, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]).append(responsiveStyle[0]);

      if (this.shouldRender()) {
        this.$el.removeClass('media-control-element--hidden');
        this.$el.attr('style', '');
        var $button = $$1('<button class="settings__button media-control-button"></button>');
        $button.append(speechBubbleIcon);
        this.$el.append($button);
      } else {
        this.$el.addClass('media-control-element--hidden');
      }

      return this;
    }
  }]);

  return Settings;
}(MediaControlPlugin);

var templateHtml$3 = "<div class=\"thumb-preview__thumb\"></div>\n<div class=\"thumb-preview__position\"></div>\n";

var css_248z$h = ".clappr-player#wp3-player-0 .media-control.settings-modal--visible .thumb-preview {\n  display: none; }\n\n.clappr-player#wp3-player-0 .media-control.touch .thumb-preview {\n  bottom: 52px; }\n\n.clappr-player#wp3-player-0 .thumb-preview {\n  opacity: 1;\n  visibility: visible;\n  transition: visibility 0.3s ease, opacity 0.3s ease;\n  position: absolute;\n  bottom: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; }\n  .clappr-player#wp3-player-0 .thumb-preview--hidden {\n    opacity: 0;\n    visibility: hidden; }\n  .clappr-player#wp3-player-0 .thumb-preview__thumb {\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.75);\n    border-radius: 2px;\n    outline: 1px solid transparent;\n    background-repeat: no-repeat;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%; }\n    .clappr-player#wp3-player-0 .thumb-preview__thumb--no-outline {\n      outline: 0 !important; }\n  .clappr-player#wp3-player-0 .thumb-preview__position {\n    padding: 2px 8px 3px;\n    font-family: \"opensans-regular\", sans-serif;\n    font-size: 14px;\n    color: #fff;\n    text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n    border-radius: 2px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    z-index: 100;\n    align-self: flex-end; }\n\n.clappr-player#wp3-player-0 .w425 .thumb-preview, .clappr-player#wp3-player-0 .thumb-preview-basic .thumb-preview {\n  border-radius: 3px;\n  background-color: rgba(0, 0, 0, 0.5);\n  width: auto;\n  height: 16px; }\n  .clappr-player#wp3-player-0 .w425 .thumb-preview__position, .clappr-player#wp3-player-0 .thumb-preview-basic .thumb-preview__position {\n    display: inline-block;\n    overflow: hidden;\n    position: initial;\n    padding: 0 6px;\n    width: auto;\n    height: auto;\n    font-size: 10px;\n    line-height: 16px; }\n";
styleInject(css_248z$h);

var ThumbPreview = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(ThumbPreview, _UICorePlugin);

  var _super = _createSuper(ThumbPreview);

  _createClass(ThumbPreview, [{
    key: "name",
    get: function get() {
      return 'thumb-preview';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this._mediaControl || (this._mediaControl = this.core.getPlugin('globo_media_control'));
    }
  }, {
    key: "seekbar",
    get: function get() {
      return this._seekbar || (this._seekbar = this.core.getPlugin('seekbar'));
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$3);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'thumb-preview'
      };
    }
  }, {
    key: "thumbHost",
    get: function get() {
      return this.options.env.name === 'prod' ? "".concat(this.options.env.protocol, "://live-thumbs.video.globo.com/") : "".concat(this.options.env.protocol, "://live-thumbs.video.globo.com/");
    }
  }]);

  function ThumbPreview(core) {
    var _this;

    _classCallCheck(this, ThumbPreview);

    _this = _super.call(this, core);
    _this.supportedTypes = {
      'vod': {
        'thumb': function thumb(ts) {
          return _this.updateThumbForVod(ts);
        },
        'text': function text(options) {
          return _this.thumbTextForVod(options);
        }
      },
      'live': {
        'thumb': function thumb(ts) {
          return _this.updateThumbForLive(ts);
        },
        'text': function text(options) {
          return _this.thumbTextForLive(options);
        }
      }
    };
    return _this;
  }

  _createClass(ThumbPreview, [{
    key: "bindEvents",
    value: function bindEvents() {
      if (this.mediaControl) {
        this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.show);
        this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.calculatePosition);
        this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.hide);
        this.listenTo(this.mediaControl, Events$1.MEDIACONTROL_HIDE, this.hide);
        this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
        this.listenTo(this.core, Events$1.CORE_RESIZE, this.checkOutline);
        this.trigger('plugin:thumbpreview:ready');
        this.bindContainerEvents();
      }
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      if (!this.mediaControl.container) return;
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      this.container && this.container.playback && this.stopListening(this.container.playback);
      this.listenTo(this.container, Events$1.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
      this.listenTo(this.container.playback, Events.WM_RESOURCE_SELECTED, this.onResourceSelected);
    }
  }, {
    key: "checkOutline",
    value: function checkOutline() {
      if (Utils.Fullscreen.fullscreenElement() && Browser.isIE11) {
        this.$el.find('.thumb-preview__thumb').addClass('thumb-preview__thumb--no-outline');
      } else {
        this.$el.find('.thumb-preview__thumb').removeClass('thumb-preview__thumb--no-outline');
      }
    }
  }, {
    key: "onResourceSelected",
    value: function onResourceSelected(video) {
      this.thumbUrl = video.selectedResource && video.selectedResource.thumbUrl;
    }
  }, {
    key: "updateThumbForVod",
    value: function updateThumbForVod(timestamp) {
      if (this.lastTimestamp === timestamp) return;
      this.lastTimestamp = timestamp;

      if (this.thumbUrl) {
        var thumbMinute = Math.floor(timestamp / 60);
        var thumbIndex = Math.floor(timestamp % 60 / 5);
        var thumbUrl = "".concat(this.thumbUrl, "/x96/tile/").concat(thumbMinute, ".jpg");
        this.$el.css({
          'height': this.thumbSize.height,
          'width': this.thumbSize.width
        });
        this.$el.find('.thumb-preview__thumb').css({
          'background-image': "url(".concat(thumbUrl, ")"),
          'background-position': "center ".concat(thumbIndex * -this.thumbSize.height, "px")
        });
        this.mediaControl.$el.removeClass('thumb-preview-basic');
      } else {
        this.mediaControl.$el.addClass('thumb-preview-basic');
      }
    }
  }, {
    key: "thumbTextForVod",
    value: function thumbTextForVod(options) {
      return options.formattedTime;
    }
  }, {
    key: "updateThumbForLive",
    value: function updateThumbForLive(timestamp) {
      var _this2 = this;

      // Since lastProgramDate is not supported by Clappr, replace it temporarily with current time
      if (!this.throttledUpdateThumb) {
        this.throttledUpdateThumb = lodash_throttle(function (timestamp) {
          var lastProgramDate = Math.floor(Date.now() / 1000);

          var duration = _this2.mediaControl.container.playback.getDuration();

          var thumbMoment = Math.floor((lastProgramDate - (duration - timestamp)) / 10) * 10;

          var signal = _this2.core.getCurrentPlayback().video.transmission.signal;

          var thumbUrl = _this2.thumbHost + signal + '/snapshot/172/97/?utc=' + thumbMoment;

          _this2.$el.css({
            'height': _this2.thumbSize.height,
            'width': _this2.thumbSize.width
          });

          _this2.$el.find('.thumb-preview__thumb').css({
            'background-image': 'url(' + thumbUrl + ')',
            'background-size': 'cover'
          });
        }, 500, true);
      }

      this.mediaControl.container.playback.dvrEnabled && this.throttledUpdateThumb(timestamp);
    }
  }, {
    key: "thumbTextForLive",
    value: function thumbTextForLive(options) {
      if (this.mediaControl.currentSeekPercentage === 100) {
        var remaining = this.mediaControl.container.playback.getDuration() - options.timestamp;
        return 'Voltar ' + this.formatTimeInterval(remaining);
      }

      return options.formattedTime;
    }
  }, {
    key: "show",
    value: function show(event) {
      this.$el.removeClass('thumb-preview--hidden');

      if (this.canShow(event)) {
        this.core.trigger(Events.WILL_SHOW_MODAL_ELEMENT, {
          name: this.name
        });
        this.$el.css({
          'z-index': 997
        });
        this.$el.removeClass('thumb-preview--hidden');
      } else {
        this.hide();
      }
    }
  }, {
    key: "canShow",
    value: function canShow(event) {
      // eslint-disable-line no-unused-vars
      return this.mediaControl.container.playback.settings.seekEnabled && Object.keys(this.supportedTypes).includes(this.playbackType);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.addClass('thumb-preview--hidden');
      this.core.trigger(Events.DID_HIDE_MODAL_ELEMENT, {
        name: this.name
      });
    }
  }, {
    key: "settingsUpdate",
    value: function settingsUpdate() {
      this.playbackType = this.mediaControl.container.getPlaybackType();
      this.thumbSize = {
        width: 170,
        height: 96
      };
    }
  }, {
    key: "containerChanged",
    value: function containerChanged() {
      var _this3 = this;

      var seekTime = this.core.getPlugin('seek_time');

      seekTime.render = function () {
        return _this3.render();
      };

      seekTime.stopListening(this.mediaControl.container, Events$1.CONTAINER_PLAYBACKDVRSTATECHANGED, seekTime.update);

      seekTime.update = function (opts) {
        return _this3.update(opts);
      };

      seekTime.listenTo(this.mediaControl.container, Events$1.CONTAINER_PLAYBACKDVRSTATECHANGED, seekTime.update);
      this.bindContainerEvents();
      this.settingsUpdate();
      this.trigger('plugin:thumbpreview:ready');
    }
  }, {
    key: "render",
    value: function render() {
      var seekTime = this.core.getPlugin('seek_time');

      if (this.mediaControl && seekTime) {
        this.$el.html(this.template());
        var style = Styler.getStyleFrom(css_248z$h, {
          playerId: this.core.options.playerId
        });
        this.$el.append(style[0]);
        seekTime.setElement(this.el);
        this.seekbar.$seekBarContainer.append(this.el);
        this.$el.addClass('thumb-preview--hidden');
      } else {
        this.listenToOnce(this, 'plugin:thumbpreview:ready', this.render);
      }

      this.checkOutline();
    }
  }, {
    key: "calculatePosition",
    value: function calculatePosition(event) {
      var touchEvent = event.touches && event.touches.length > 0 && event.touches[event.touches.length - 1] || {};
      var pageX = event.pageX || touchEvent.pageX;
      var offset = pageX - this.seekbar.$seekBarContainer.offset().left; // proportion into the seek bar that the mouse is hovered over 0-1

      this.hoverPosition = Math.min(1, Math.max(offset / this.mediaControl.$seekBarContainer.width(), 0));
    }
  }, {
    key: "update",
    value: function update() {
      var seekTime = this.core.getPlugin('seek_time');

      if (this.hoverPosition && seekTime.hoveringOverSeekBar) {
        var timestamp = this.hoverPosition * this.core.getCurrentContainer().getDuration();
        var formattedTime = Utils.formatTime(timestamp);
        var containerElement = this.seekbar.$seekBarContainer;
        if (!containerElement.length) return;
        if (isNaN(timestamp)) return;

        if (Object.keys(this.supportedTypes).includes(this.playbackType)) {
          var updateThumbUrl = this.supportedTypes[this.playbackType].thumb;
          var thumbTextCallback = this.supportedTypes[this.playbackType].text;
          var containerWidth = containerElement.width();
          var thumbMiddle = this.$el.width() / 2;
          var left = this.hoverPosition * containerWidth - thumbMiddle;
          var maxLeft = containerWidth - this.$el.width();
          left = Math.max(0, Math.min(left, maxLeft));
          this.$el.css('left', left);
          this.$el.find('.thumb-preview__position').text(thumbTextCallback({
            timestamp: timestamp,
            formattedTime: formattedTime
          }));

          if (!this.core.mediaControl.$el.hasClass('w425')) {
            updateThumbUrl(timestamp);
          }
        }
      }
    }
  }, {
    key: "formatTimeInterval",
    value: function formatTimeInterval(time) {
      var hasHours = false;
      time = time * 1000;
      time = parseInt(time / 1000, 10);
      var seconds = time % 60;
      time = parseInt(time / 60, 10);
      var minutes = time % 60;
      time = parseInt(time / 60, 10);
      var hours = time % 24;
      var out = '';

      if (hours && hours > 0) {
        out += hours.toString().slice(-2) + 'h';
        hasHours = true;
      }

      if (minutes && minutes > 0) {
        out += minutes.toString().slice(-2) + 'm';
      }

      if (!hasHours) {
        out += ('0' + seconds).slice(-2) + 's';
      }

      return out.trim();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._mediaControl = null;

      _get(_getPrototypeOf(ThumbPreview.prototype), "destroy", this).call(this);
    }
  }]);

  return ThumbPreview;
}(UICorePlugin);

var infoIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var icon10 = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#0095DA\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_13_12566)\">\n<path d=\"M18.9195 36H13.4879V21.1289L13.5406 18.6855L13.6285 16.0137C12.7261 16.916 12.0992 17.5078 11.7476 17.7891L8.79449 20.1621L6.17535 16.8926L14.4547 10.3008H18.9195V36Z\" fill=\"#EEEEEE\"/>\n<path d=\"M40.6077 23.1504C40.6077 27.6387 39.8694 30.9609 38.3929 33.1172C36.928 35.2734 34.6663 36.3516 31.6077 36.3516C28.6429 36.3516 26.4046 35.2383 24.8929 33.0117C23.3929 30.7852 22.6429 27.498 22.6429 23.1504C22.6429 18.6152 23.3753 15.2754 24.8401 13.1309C26.305 10.9746 28.5608 9.89648 31.6077 9.89648C34.5725 9.89648 36.8108 11.0215 38.3225 13.2715C39.846 15.5215 40.6077 18.8145 40.6077 23.1504ZM28.0393 23.1504C28.0393 26.3027 28.3089 28.5645 28.8479 29.9355C29.3987 31.2949 30.3186 31.9746 31.6077 31.9746C32.8733 31.9746 33.7874 31.2832 34.3499 29.9004C34.9124 28.5176 35.1936 26.2676 35.1936 23.1504C35.1936 19.998 34.9065 17.7363 34.3323 16.3652C33.7698 14.9824 32.8616 14.291 31.6077 14.291C30.3304 14.291 29.4163 14.9824 28.8655 16.3652C28.3147 17.7363 28.0393 19.998 28.0393 23.1504Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_13_12566\" x=\"6.17535\" y=\"9.89648\" width=\"36.4323\" height=\"28.4551\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"2\" dy=\"2\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_13_12566\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_13_12566\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var icon12 = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#FBC115\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_13_12578)\">\n<path d=\"M18.9195 36H13.4879V21.1289L13.5406 18.6855L13.6285 16.0137C12.7261 16.916 12.0992 17.5078 11.7476 17.7891L8.79449 20.1621L6.17535 16.8926L14.4547 10.3008H18.9195V36Z\" fill=\"#EEEEEE\"/>\n<path d=\"M40.7483 36H22.7835V32.2207L29.2347 25.6992C31.1448 23.7422 32.3929 22.3887 32.9788 21.6387C33.5647 20.877 33.9866 20.1738 34.2444 19.5293C34.5022 18.8848 34.6311 18.2168 34.6311 17.5254C34.6311 16.4941 34.344 15.7266 33.7698 15.2227C33.2073 14.7188 32.4515 14.4668 31.5022 14.4668C30.5061 14.4668 29.5393 14.6953 28.6018 15.1523C27.6643 15.6094 26.6858 16.2598 25.6663 17.1035L22.7132 13.6055C23.9788 12.5273 25.0276 11.7656 25.8597 11.3203C26.6917 10.875 27.5999 10.5352 28.5843 10.3008C29.5686 10.0547 30.6702 9.93164 31.889 9.93164C33.4944 9.93164 34.9124 10.2246 36.1429 10.8105C37.3733 11.3965 38.3284 12.2168 39.0081 13.2715C39.6878 14.3262 40.0276 15.5332 40.0276 16.8926C40.0276 18.0762 39.8167 19.1895 39.3948 20.2324C38.9847 21.2637 38.3401 22.3242 37.4612 23.4141C36.594 24.5039 35.0589 26.0566 32.8558 28.0723L29.5511 31.1836V31.4297H40.7483V36Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_13_12578\" x=\"6.17535\" y=\"9.93164\" width=\"36.573\" height=\"28.0684\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"2\" dy=\"2\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_13_12578\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_13_12578\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var icon14 = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#F58220\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_13_12590)\">\n<path d=\"M18.9195 36H13.4879V21.1289L13.5406 18.6855L13.6285 16.0137C12.7262 16.916 12.0992 17.5078 11.7476 17.7891L8.79451 20.1621L6.17537 16.8926L14.4547 10.3008H18.9195V36Z\" fill=\"#EEEEEE\"/>\n<path d=\"M41.3284 30.6738H38.2347V36H32.9261V30.6738H21.9573V26.8945L33.2249 10.3008H38.2347V26.4551H41.3284V30.6738ZM32.9261 26.4551V22.0957C32.9261 21.3691 32.9554 20.3145 33.014 18.9316C33.0726 17.5488 33.1194 16.7461 33.1546 16.5234H33.014C32.5804 17.4844 32.0589 18.4219 31.4495 19.3359L26.7386 26.4551H32.9261Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_13_12590\" x=\"6.17537\" y=\"10.3008\" width=\"37.1531\" height=\"27.6992\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"2\" dy=\"2\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_13_12590\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_13_12590\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var icon16 = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#EC1D25\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_13_12602)\">\n<path d=\"M18.9195 36H13.4879V21.1289L13.5406 18.6855L13.6285 16.0137C12.7262 16.916 12.0992 17.5078 11.7476 17.7891L8.79451 20.1621L6.17537 16.8926L14.4547 10.3008H18.9195V36Z\" fill=\"#EEEEEE\"/>\n<path d=\"M22.6077 25.084C22.6077 19.998 23.68 16.2129 25.8245 13.7285C27.9808 11.2441 31.2034 10.002 35.4925 10.002C36.9573 10.002 38.1058 10.0898 38.9378 10.2656V14.6074C37.8948 14.373 36.8636 14.2559 35.844 14.2559C33.9808 14.2559 32.4573 14.5371 31.2737 15.0996C30.1019 15.6621 29.223 16.4941 28.637 17.5957C28.0511 18.6973 27.7054 20.2617 27.5999 22.2891H27.8284C28.9886 20.2969 30.846 19.3008 33.4007 19.3008C35.6976 19.3008 37.4964 20.0215 38.7972 21.4629C40.098 22.9043 40.7483 24.8965 40.7483 27.4395C40.7483 30.1816 39.9749 32.3555 38.428 33.9609C36.8812 35.5547 34.7366 36.3516 31.9944 36.3516C30.096 36.3516 28.4378 35.9121 27.0198 35.0332C25.6136 34.1543 24.5237 32.8711 23.7503 31.1836C22.9886 29.4961 22.6077 27.4629 22.6077 25.084ZM31.889 32.0098C33.0491 32.0098 33.9398 31.623 34.5608 30.8496C35.1819 30.0645 35.4925 28.9512 35.4925 27.5098C35.4925 26.2559 35.1995 25.2715 34.6136 24.5566C34.0394 23.8301 33.1663 23.4668 31.9944 23.4668C30.8929 23.4668 29.9495 23.8242 29.1644 24.5391C28.3909 25.2539 28.0042 26.0859 28.0042 27.0352C28.0042 28.4297 28.3675 29.6074 29.094 30.5684C29.8323 31.5293 30.764 32.0098 31.889 32.0098Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_13_12602\" x=\"6.17537\" y=\"10.002\" width=\"36.573\" height=\"28.3496\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"2\" dy=\"2\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_13_12602\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_13_12602\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var icon18 = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"black\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_13_12620)\">\n<path d=\"M18.9195 36H13.4879V21.1289L13.5406 18.6855L13.6285 16.0137C12.7262 16.916 12.0992 17.5078 11.7476 17.7891L8.79451 20.1621L6.17537 16.8926L14.4547 10.3008H18.9195V36Z\" fill=\"#EEEEEE\"/>\n<path d=\"M31.6429 9.9668C34.1038 9.9668 36.0843 10.5293 37.5843 11.6543C39.096 12.7676 39.8519 14.2734 39.8519 16.1719C39.8519 17.4844 39.4886 18.6562 38.762 19.6875C38.0355 20.707 36.8636 21.6211 35.2464 22.4297C37.1683 23.4609 38.5452 24.5391 39.3773 25.6641C40.221 26.7773 40.6429 28.002 40.6429 29.3379C40.6429 31.4473 39.8167 33.1465 38.1644 34.4355C36.512 35.7129 34.3382 36.3516 31.6429 36.3516C28.8304 36.3516 26.6214 35.7539 25.0159 34.5586C23.4105 33.3633 22.6077 31.6699 22.6077 29.4785C22.6077 28.0137 22.9944 26.7129 23.7679 25.5762C24.553 24.4395 25.8069 23.4375 27.5296 22.5703C26.0648 21.6445 25.0101 20.6543 24.3655 19.5996C23.721 18.5449 23.3987 17.3906 23.3987 16.1367C23.3987 14.2969 24.1605 12.8086 25.6839 11.6719C27.2073 10.5352 29.1937 9.9668 31.6429 9.9668ZM27.6351 29.1621C27.6351 30.1699 27.9866 30.9551 28.6898 31.5176C29.3929 32.0801 30.3538 32.3613 31.5726 32.3613C32.9202 32.3613 33.928 32.0742 34.596 31.5C35.264 30.9141 35.598 30.1465 35.598 29.1973C35.598 28.4121 35.264 27.6797 34.596 27C33.9398 26.3086 32.8675 25.5762 31.3792 24.8027C28.8831 25.9512 27.6351 27.4043 27.6351 29.1621ZM31.6077 13.9395C30.6819 13.9395 29.9319 14.1797 29.3577 14.6602C28.7952 15.1289 28.514 15.7617 28.514 16.5586C28.514 17.2617 28.7366 17.8945 29.1819 18.457C29.639 19.0078 30.4593 19.5762 31.6429 20.1621C32.7913 19.623 33.594 19.0723 34.0511 18.5098C34.5081 17.9473 34.7366 17.2969 34.7366 16.5586C34.7366 15.75 34.4437 15.1113 33.8577 14.6426C33.2718 14.1738 32.5218 13.9395 31.6077 13.9395Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_13_12620\" x=\"6.17537\" y=\"9.9668\" width=\"36.4675\" height=\"28.3848\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"2\" dy=\"2\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_13_12620\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_13_12620\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var iconGeneral = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#00A651\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_13_12552)\">\n<path d=\"M16.0351 36V10.3008H21.4843V31.5H31.9081V36H16.0351Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_13_12552\" x=\"16.0351\" y=\"10.3008\" width=\"17.873\" height=\"27.6992\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"2\" dy=\"2\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_13_12552\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_13_12552\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var selfRatedIcon10 = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#0095DA\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_179_73319)\">\n<path d=\"M14.6068 35L13.8321 31.0044H8.72117L7.92493 35H3.25513L8.38761 13.5933H14.0581L19.2551 35H14.6068ZM12.9498 26.2798L12.2719 22.7801C12.1141 22.0023 11.9204 20.9962 11.6909 19.7615C11.4685 18.5269 11.3215 17.6423 11.2497 17.1076C11.1852 17.6034 11.0561 18.42 10.8624 19.5574C10.6759 20.6948 10.2562 22.9356 9.60348 26.2798H12.9498Z\" fill=\"#EEEEEE\"/>\n</g>\n<g filter=\"url(#filter1_d_179_73319)\">\n<path d=\"M27.7539 35H23.2275V22.6074L23.2715 20.5713L23.3447 18.3447C22.5928 19.0967 22.0703 19.5898 21.7773 19.8242L19.3164 21.8018L17.1338 19.0771L24.0332 13.584H27.7539V35Z\" fill=\"#EEEEEE\"/>\n<path d=\"M44.5547 24.292C44.5547 28.0322 43.9395 30.8008 42.709 32.5977C41.4883 34.3945 39.6035 35.293 37.0547 35.293C34.584 35.293 32.7188 34.3652 31.459 32.5098C30.209 30.6543 29.584 27.915 29.584 24.292C29.584 20.5127 30.1943 17.7295 31.415 15.9424C32.6357 14.1455 34.5156 13.2471 37.0547 13.2471C39.5254 13.2471 41.3906 14.1846 42.6504 16.0596C43.9199 17.9346 44.5547 20.6787 44.5547 24.292ZM34.0811 24.292C34.0811 26.9189 34.3057 28.8037 34.7549 29.9463C35.2139 31.0791 35.9805 31.6455 37.0547 31.6455C38.1094 31.6455 38.8711 31.0693 39.3398 29.917C39.8086 28.7646 40.043 26.8896 40.043 24.292C40.043 21.665 39.8037 19.7803 39.3252 18.6377C38.8564 17.4854 38.0996 16.9092 37.0547 16.9092C35.9902 16.9092 35.2285 17.4854 34.7695 18.6377C34.3105 19.7803 34.0811 21.665 34.0811 24.292Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_179_73319\" x=\"3.25513\" y=\"13.5933\" width=\"17\" height=\"22.4067\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73319\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73319\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_179_73319\" x=\"17.1338\" y=\"13.2471\" width=\"28.4209\" height=\"23.0459\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73319\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73319\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var selfRatedIcon12 = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#FBC115\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_179_73290)\">\n<path d=\"M14.6076 35L13.8329 31.0044H8.7219L7.92566 35H3.25586L8.38834 13.5933H14.0588L19.2559 35H14.6076ZM12.9505 26.2798L12.2727 22.7801C12.1149 22.0023 11.9212 20.9962 11.6916 19.7615C11.4693 18.5269 11.3222 17.6423 11.2505 17.1076C11.1859 17.6034 11.0568 18.42 10.8631 19.5574C10.6766 20.6948 10.257 22.9356 9.60421 26.2798H12.9505Z\" fill=\"#EEEEEE\"/>\n</g>\n<g filter=\"url(#filter1_d_179_73290)\">\n<path d=\"M27.7539 35H23.2275V22.6074L23.2715 20.5713L23.3447 18.3447C22.5928 19.0967 22.0703 19.5898 21.7773 19.8242L19.3164 21.8018L17.1338 19.0771L24.0332 13.584H27.7539V35Z\" fill=\"#EEEEEE\"/>\n<path d=\"M44.6719 35H29.7012V31.8506L35.0771 26.416C36.6689 24.7852 37.709 23.6572 38.1973 23.0322C38.6855 22.3975 39.0371 21.8115 39.252 21.2744C39.4668 20.7373 39.5742 20.1807 39.5742 19.6045C39.5742 18.7451 39.335 18.1055 38.8564 17.6855C38.3877 17.2656 37.7578 17.0557 36.9668 17.0557C36.1367 17.0557 35.3311 17.2461 34.5498 17.627C33.7686 18.0078 32.9531 18.5498 32.1035 19.2529L29.6426 16.3379C30.6973 15.4395 31.5713 14.8047 32.2646 14.4336C32.958 14.0625 33.7148 13.7793 34.5352 13.584C35.3555 13.3789 36.2734 13.2764 37.2891 13.2764C38.627 13.2764 39.8086 13.5205 40.834 14.0088C41.8594 14.4971 42.6553 15.1807 43.2217 16.0596C43.7881 16.9385 44.0713 17.9443 44.0713 19.0771C44.0713 20.0635 43.8955 20.9912 43.5439 21.8604C43.2021 22.7197 42.665 23.6035 41.9326 24.5117C41.21 25.4199 39.9307 26.7139 38.0947 28.3936L35.3408 30.9863V31.1914H44.6719V35Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_179_73290\" x=\"3.25586\" y=\"13.5933\" width=\"17\" height=\"22.4067\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73290\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73290\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_179_73290\" x=\"17.1338\" y=\"13.2764\" width=\"28.5381\" height=\"22.7236\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73290\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73290\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var selfRatedIcon14 = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#F58220\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_179_73298)\">\n<path d=\"M14.6076 35L13.8329 31.0044H8.7219L7.92566 35H3.25586L8.38834 13.5933H14.0588L19.2559 35H14.6076ZM12.9505 26.2798L12.2727 22.7801C12.1149 22.0023 11.9212 20.9962 11.6916 19.7615C11.4693 18.5269 11.3222 17.6423 11.2505 17.1076C11.1859 17.6034 11.0568 18.42 10.8631 19.5574C10.6766 20.6948 10.257 22.9356 9.60421 26.2798H12.9505Z\" fill=\"#EEEEEE\"/>\n</g>\n<g filter=\"url(#filter1_d_179_73298)\">\n<path d=\"M27.7539 35H23.2275V22.6074L23.2715 20.5713L23.3447 18.3447C22.5928 19.0967 22.0703 19.5898 21.7773 19.8242L19.3164 21.8018L17.1338 19.0771L24.0332 13.584H27.7539V35Z\" fill=\"#EEEEEE\"/>\n<path d=\"M45.1553 30.5615H42.5771V35H38.1533V30.5615H29.0127V27.4121L38.4023 13.584H42.5771V27.0459H45.1553V30.5615ZM38.1533 27.0459V23.4131C38.1533 22.8076 38.1777 21.9287 38.2266 20.7764C38.2754 19.624 38.3145 18.9551 38.3438 18.7695H38.2266C37.8652 19.5703 37.4307 20.3516 36.9229 21.1133L32.9971 27.0459H38.1533Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_179_73298\" x=\"3.25586\" y=\"13.5933\" width=\"17\" height=\"22.4067\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73298\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73298\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_179_73298\" x=\"17.1338\" y=\"13.584\" width=\"29.0215\" height=\"22.416\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73298\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73298\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var selfRatedIcon16 = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#EC1D25\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_179_73305)\">\n<path d=\"M14.6076 35L13.8329 31.0044H8.7219L7.92566 35H3.25586L8.38834 13.5933H14.0588L19.2559 35H14.6076ZM12.9505 26.2798L12.2727 22.7801C12.1149 22.0023 11.9212 20.9962 11.6916 19.7615C11.4693 18.5269 11.3222 17.6423 11.2505 17.1076C11.1859 17.6034 11.0568 18.42 10.8631 19.5574C10.6766 20.6948 10.257 22.9356 9.60421 26.2798H12.9505Z\" fill=\"#EEEEEE\"/>\n</g>\n<g filter=\"url(#filter1_d_179_73305)\">\n<path d=\"M27.7539 35H23.2275V22.6074L23.2715 20.5713L23.3447 18.3447C22.5928 19.0967 22.0703 19.5898 21.7773 19.8242L19.3164 21.8018L17.1338 19.0771L24.0332 13.584H27.7539V35Z\" fill=\"#EEEEEE\"/>\n<path d=\"M29.5547 25.9033C29.5547 21.665 30.4482 18.5107 32.2354 16.4404C34.0322 14.3701 36.7178 13.335 40.292 13.335C41.5127 13.335 42.4697 13.4082 43.1631 13.5547V17.1729C42.2939 16.9775 41.4346 16.8799 40.585 16.8799C39.0322 16.8799 37.7627 17.1143 36.7764 17.583C35.7998 18.0518 35.0674 18.7451 34.5791 19.6631C34.0908 20.5811 33.8027 21.8848 33.7148 23.5742H33.9053C34.8721 21.9141 36.4199 21.084 38.5488 21.084C40.4629 21.084 41.9619 21.6846 43.0459 22.8857C44.1299 24.0869 44.6719 25.7471 44.6719 27.8662C44.6719 30.1514 44.0273 31.9629 42.7383 33.3008C41.4492 34.6289 39.6621 35.293 37.377 35.293C35.7949 35.293 34.4131 34.9268 33.2314 34.1943C32.0596 33.4619 31.1514 32.3926 30.5068 30.9863C29.8721 29.5801 29.5547 27.8857 29.5547 25.9033ZM37.2891 31.6748C38.2559 31.6748 38.998 31.3525 39.5156 30.708C40.0332 30.0537 40.292 29.126 40.292 27.9248C40.292 26.8799 40.0479 26.0596 39.5596 25.4639C39.0811 24.8584 38.3535 24.5557 37.377 24.5557C36.459 24.5557 35.6729 24.8535 35.0186 25.4492C34.374 26.0449 34.0518 26.7383 34.0518 27.5293C34.0518 28.6914 34.3545 29.6729 34.96 30.4736C35.5752 31.2744 36.3516 31.6748 37.2891 31.6748Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_179_73305\" x=\"3.25586\" y=\"13.5933\" width=\"17\" height=\"22.4067\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73305\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73305\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_179_73305\" x=\"17.1338\" y=\"13.335\" width=\"28.5381\" height=\"22.958\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73305\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73305\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var selfRatedIcon18 = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"black\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_179_73326)\">\n<path d=\"M14.6076 35L13.8329 31.0044H8.7219L7.92566 35H3.25586L8.38834 13.5933H14.0588L19.2559 35H14.6076ZM12.9505 26.2798L12.2727 22.7801C12.1149 22.0023 11.9212 20.9962 11.6916 19.7615C11.4693 18.5269 11.3222 17.6423 11.2505 17.1076C11.1859 17.6034 11.0568 18.42 10.8631 19.5574C10.6766 20.6948 10.257 22.9356 9.60421 26.2798H12.9505Z\" fill=\"#EEEEEE\"/>\n</g>\n<g filter=\"url(#filter1_d_179_73326)\">\n<path d=\"M27.7539 35H23.2275V22.6074L23.2715 20.5713L23.3447 18.3447C22.5928 19.0967 22.0703 19.5898 21.7773 19.8242L19.3164 21.8018L17.1338 19.0771L24.0332 13.584H27.7539V35Z\" fill=\"#EEEEEE\"/>\n<path d=\"M37.084 13.3057C39.1348 13.3057 40.7852 13.7744 42.0352 14.7119C43.2949 15.6396 43.9248 16.8945 43.9248 18.4766C43.9248 19.5703 43.6221 20.5469 43.0166 21.4062C42.4111 22.2559 41.4346 23.0176 40.0869 23.6914C41.6885 24.5508 42.8359 25.4492 43.5293 26.3867C44.2324 27.3145 44.584 28.335 44.584 29.4482C44.584 31.2061 43.8955 32.6221 42.5186 33.6963C41.1416 34.7607 39.3301 35.293 37.084 35.293C34.7402 35.293 32.8994 34.7949 31.5615 33.7988C30.2236 32.8027 29.5547 31.3916 29.5547 29.5654C29.5547 28.3447 29.877 27.2607 30.5215 26.3135C31.1758 25.3662 32.2207 24.5312 33.6562 23.8086C32.4355 23.0371 31.5566 22.2119 31.0195 21.333C30.4824 20.4541 30.2139 19.4922 30.2139 18.4473C30.2139 16.9141 30.8486 15.6738 32.1182 14.7266C33.3877 13.7793 35.043 13.3057 37.084 13.3057ZM33.7441 29.3018C33.7441 30.1416 34.0371 30.7959 34.623 31.2646C35.209 31.7334 36.0098 31.9678 37.0254 31.9678C38.1484 31.9678 38.9883 31.7285 39.5449 31.25C40.1016 30.7617 40.3799 30.1221 40.3799 29.3311C40.3799 28.6768 40.1016 28.0664 39.5449 27.5C38.998 26.9238 38.1045 26.3135 36.8643 25.6689C34.7842 26.626 33.7441 27.8369 33.7441 29.3018ZM37.0547 16.6162C36.2832 16.6162 35.6582 16.8164 35.1797 17.2168C34.7109 17.6074 34.4766 18.1348 34.4766 18.7988C34.4766 19.3848 34.6621 19.9121 35.0332 20.3809C35.4141 20.8398 36.0977 21.3135 37.084 21.8018C38.041 21.3525 38.71 20.8936 39.0908 20.4248C39.4717 19.9561 39.6621 19.4141 39.6621 18.7988C39.6621 18.125 39.418 17.5928 38.9297 17.2021C38.4414 16.8115 37.8164 16.6162 37.0547 16.6162Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_179_73326\" x=\"3.25586\" y=\"13.5933\" width=\"17\" height=\"22.4067\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73326\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73326\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_179_73326\" x=\"17.1338\" y=\"13.3057\" width=\"28.4502\" height=\"22.9873\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73326\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73326\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var selfRatedIconGeneral = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"48\" height=\"48\" rx=\"3\" fill=\"#00A651\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"47\" height=\"47\" rx=\"2.5\" stroke=\"#EEEEEE\" stroke-opacity=\"0.6\"/>\n<g filter=\"url(#filter0_d_179_73312)\">\n<path d=\"M19.3517 35L18.577 31.0044H13.466L12.6698 35H8L13.1325 13.5933H18.803L24 35H19.3517ZM17.6947 26.2798L17.0168 22.7801C16.859 22.0023 16.6653 20.9962 16.4358 19.7615C16.2134 18.5269 16.0664 17.6423 15.9946 17.1076C15.9301 17.6034 15.8009 18.42 15.6073 19.5574C15.4208 20.6948 15.0011 22.9356 14.3484 26.2798H17.6947Z\" fill=\"#EEEEEE\"/>\n</g>\n<g filter=\"url(#filter1_d_179_73312)\">\n<path d=\"M26.2372 35V13.584H30.7783V31.25H39.4648V35H26.2372Z\" fill=\"#EEEEEE\"/>\n</g>\n<defs>\n<filter id=\"filter0_d_179_73312\" x=\"8\" y=\"13.5933\" width=\"17\" height=\"22.4067\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73312\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73312\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_179_73312\" x=\"26.2372\" y=\"13.584\" width=\"14.2275\" height=\"22.416\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dx=\"1\" dy=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_179_73312\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_179_73312\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>";

var contentRatingIcons = {
  'default': {
    10: icon10,
    12: icon12,
    14: icon14,
    16: icon16,
    18: icon18,
    L: iconGeneral
  },
  'self_rated': {
    10: selfRatedIcon10,
    12: selfRatedIcon12,
    14: selfRatedIcon14,
    16: selfRatedIcon16,
    18: selfRatedIcon18,
    L: selfRatedIconGeneral
  }
};

var css_248z$i = ".clappr-player#wp3-player-0 .media-control--keep-video-info .media-control-panel__upper {\n  opacity: 1 !important;\n  transform: translateY(0) !important; }\n\n.clappr-player#wp3-player-0 .media-control--keep-video-info .video-info {\n  display: block; }\n\n.clappr-player#wp3-player-0 .media-control.w320 .video-info, .clappr-player#wp3-player-0 .media-control.w360 .video-info, .clappr-player#wp3-player-0 .media-control.w480 .video-info {\n  height: 48px; }\n  .clappr-player#wp3-player-0 .media-control.w320 .video-info--inline, .clappr-player#wp3-player-0 .media-control.w320 .video-info--full, .clappr-player#wp3-player-0 .media-control.w360 .video-info--inline, .clappr-player#wp3-player-0 .media-control.w360 .video-info--full, .clappr-player#wp3-player-0 .media-control.w480 .video-info--inline, .clappr-player#wp3-player-0 .media-control.w480 .video-info--full {\n    pointer-events: auto; }\n    .clappr-player#wp3-player-0 .media-control.w320 .video-info--inline .drawer-info-icon, .clappr-player#wp3-player-0 .media-control.w320 .video-info--full .drawer-info-icon, .clappr-player#wp3-player-0 .media-control.w360 .video-info--inline .drawer-info-icon, .clappr-player#wp3-player-0 .media-control.w360 .video-info--full .drawer-info-icon, .clappr-player#wp3-player-0 .media-control.w480 .video-info--inline .drawer-info-icon, .clappr-player#wp3-player-0 .media-control.w480 .video-info--full .drawer-info-icon {\n      cursor: pointer;\n      padding: 0px; }\n  .clappr-player#wp3-player-0 .media-control.w320 .video-info__mobile-container, .clappr-player#wp3-player-0 .media-control.w360 .video-info__mobile-container, .clappr-player#wp3-player-0 .media-control.w480 .video-info__mobile-container {\n    display: flex;\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    z-index: 998;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.6); }\n  .clappr-player#wp3-player-0 .media-control.w320 .video-info__mobile-header, .clappr-player#wp3-player-0 .media-control.w360 .video-info__mobile-header, .clappr-player#wp3-player-0 .media-control.w480 .video-info__mobile-header {\n    height: 36px;\n    width: 100%; }\n  .clappr-player#wp3-player-0 .media-control.w320 .video-info__data, .clappr-player#wp3-player-0 .media-control.w360 .video-info__data, .clappr-player#wp3-player-0 .media-control.w480 .video-info__data {\n    display: flex;\n    flex-flow: column;\n    flex-grow: 1;\n    justify-content: center;\n    margin: 0;\n    padding: 0 12px 12px; }\n  .clappr-player#wp3-player-0 .media-control.w320 .video-info__close, .clappr-player#wp3-player-0 .media-control.w360 .video-info__close, .clappr-player#wp3-player-0 .media-control.w480 .video-info__close {\n    background-color: transparent;\n    border: 0;\n    box-sizing: content-box;\n    padding: 12px;\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    position: absolute;\n    right: 0;\n    width: 24px;\n    height: 24px;\n    outline: none;\n    cursor: pointer; }\n    .clappr-player#wp3-player-0 .media-control.w320 .video-info__close svg, .clappr-player#wp3-player-0 .media-control.w360 .video-info__close svg, .clappr-player#wp3-player-0 .media-control.w480 .video-info__close svg {\n      width: 100%;\n      height: 100%; }\n\n.clappr-player#wp3-player-0 .video-info {\n  box-sizing: border-box;\n  color: white;\n  pointer-events: none;\n  text-shadow: none;\n  z-index: 996; }\n  .clappr-player#wp3-player-0 .video-info__data {\n    height: 24px;\n    visibility: visible;\n    text-align: left; }\n    .clappr-player#wp3-player-0 .video-info__data-title {\n      margin-bottom: 5px;\n      font-size: 18px;\n      line-height: 24px; }\n    .clappr-player#wp3-player-0 .video-info__data-subtitle {\n      display: flex;\n      flex-direction: row;\n      align-items: center; }\n      .clappr-player#wp3-player-0 .video-info__data-subtitle-rating {\n        display: flex;\n        margin-right: 8px; }\n        .clappr-player#wp3-player-0 .video-info__data-subtitle-rating svg {\n          height: 16px;\n          width: 16px; }\n        .clappr-player#wp3-player-0 .video-info__data-subtitle-rating:empty {\n          margin-right: 0px; }\n      .clappr-player#wp3-player-0 .video-info__data-subtitle-program {\n        font-size: 14px;\n        line-height: 18px; }\n    .clappr-player#wp3-player-0 .video-info__data-title, .clappr-player#wp3-player-0 .video-info__data-subtitle-program {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      font-family: \"opensans-regular\";\n      letter-spacing: 0;\n      color: #ffffff;\n      text-shadow: 0 0 2px rgba(0, 0, 0, 0.5); }\n  .clappr-player#wp3-player-0 .video-info__status {\n    text-align: left;\n    font-family: \"opensans-regular\";\n    font-size: 16px;\n    line-height: 16px; }\n  .clappr-player#wp3-player-0 .video-info__data, .clappr-player#wp3-player-0 .video-info__status {\n    transition: all ease .2s; }\n  .clappr-player#wp3-player-0 .video-info--chromecast {\n    position: absolute;\n    top: 0;\n    background-color: transparent;\n    transition: opacity ease-in .2s; }\n    .clappr-player#wp3-player-0 .video-info--chromecast .video-info__data {\n      margin: 5vw 0 0 5vw; }\n      .clappr-player#wp3-player-0 .video-info--chromecast .video-info__data-title {\n        font-size: 3.4vh;\n        line-height: 4.4vh;\n        margin-bottom: 8px; }\n      .clappr-player#wp3-player-0 .video-info--chromecast .video-info__data-subtitle-program {\n        font-size: 2.4vh;\n        line-height: 2.6vh; }\n  .clappr-player#wp3-player-0 .video-info--ad .video-info__data {\n    display: none !important; }\n  .clappr-player#wp3-player-0 .video-info--ad .video-info__status {\n    font-size: 14px;\n    line-height: normal;\n    color: #ffff93; }\n    .clappr-player#wp3-player-0 .video-info--ad .video-info__status:after {\n      content: \"Publicidade\"; }\n  .clappr-player#wp3-player-0 .video-info--hidden {\n    display: none; }\n";
styleInject(css_248z$i);

var templateHtml$4 = "<% if (modalMode === true) { %>\n  <div class=\"video-info__mobile-container\">\n    <div class=\"video-info__mobile-header\">\n      <button class=\"video-info__close\"></button>\n    </div>\n<% } %>\n  <div class=\"video-info__data\">\n    <div class=\"video-info__data-title\"><%= title %></div>\n    <div class=\"video-info__data-subtitle\">\n      <div class=\"video-info__data-subtitle-rating\"><%= rating %></div>\n      <div class=\"video-info__data-subtitle-program\"><%= program %></div>\n    </div>\n  </div>\n  <div class=\"video-info__status\"></div>\n<% if (modalMode === true) { %>\n</div>\n<% } %>\n";

var buttonHtml = "<button class=\"drawer-info-icon media-control-button\" data-video-info></button>\n";

function selectRatingIcon(rating, type) {
  if (!rating) return;
  return contentRatingIcons[type][rating];
}

var VideoInfo = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(VideoInfo, _MediaControlPlugin);

  var _super = _createSuper(VideoInfo);

  function VideoInfo() {
    _classCallCheck(this, VideoInfo);

    return _super.apply(this, arguments);
  }

  _createClass(VideoInfo, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      var _this = this;

      this.container && this.stopListening(this.container);
      this.container && this.container.playback && this.stopListening(this.container.playback);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.listenTo(this.container.playback, Events.WM_VIDEO_METADATA_LOADED, this.initialize);
      this.listenTo(this.container, Events.WM_PIPTOMASTER, this.onPipToMaster);
      this.listenTo(this.container, Events.DFP_AD_STARTED, this.updateState);
      this.listenTo(this.container, Events.WM_MASTERTOPIP, function () {
        return _this.$el.addClass('video-info--hidden');
      });
      this.listenTo(this.container.playback, Events$1.PLAYBACK_PLAY_INTENT, this.updateState);
      this.container.options.chromeless && this.disable();
    }
  }, {
    key: "initialize",
    value: function initialize(playlist) {
      this.playlist = playlist;
      this.render();
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize(size) {
      this.playerSize = size;
      this.render();
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var stateChanged = this.currentState !== this.renderedState || Browser.isMobile;
      if (!stateChanged) return;
      this.$el.removeClass(this.allStates);
      this.$el.addClass("video-info--".concat(this.currentState));
      var shouldDisplay = this.displayInlineMode || this.displayFullScreenMode || this.container.getPlaybackType() === 'ad';
      shouldDisplay ? this.$el.removeClass('video-info--hidden') : this.$el.addClass('video-info--hidden');
      this.renderedState = this.currentState;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.container) return;

      if (Browser.isChromecast) {
        this.$el.remove();
        this.container.$el.append(this.el);
      }

      this.updateState();

      var videoInfoHTML = _objectSpread2(_objectSpread2({}, this.videoInfoHTMLData), {}, {
        'modalMode': false
      });

      !this.currentState.includes('video-info--ad') && this.$el.html(this.shouldUseInfoButton ? this.buttonTemplate() : this.template(videoInfoHTML));
      this.$el.append(Styler.getStyleFrom(css_248z$i, {
        playerId: this.options.playerId
      })[0]);
      this.shouldUseInfoButton && this.$el.find('.drawer-info-icon').html(infoIcon);
      return this;
    }
  }, {
    key: "showModalvideoInfo",
    value: function showModalvideoInfo(e) {
      var _this2 = this;

      var smallScreenVideoInfoHTML = _objectSpread2(_objectSpread2({}, this.videoInfoHTMLData), {}, {
        'modalMode': true
      });

      e && e.stopPropagation();
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_SHOW, this.template(smallScreenVideoInfoHTML), {
        hidePanels: true
      });
      this.mediaControl.$el.addClass('media-control--keep-video-info');
      var $videoInfoBox = this.modal.find('.video-info__mobile-container');
      var $videoInfoClose = this.modal.find('.video-info__close');
      $videoInfoBox && $videoInfoBox.on('click', function (e) {
        e && e.stopPropagation();

        _this2.hideModal();
      });
      $videoInfoClose && $videoInfoClose.append(closeIcon);
      this.mediaControl.setKeepVisible();
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      this.modal && this.modal.find('.video-info__mobile-container').off('click');
      this.mediaControl.trigger(Events.MEDIACONTROL_MODAL_HIDE);
      this.mediaControl.resetKeepVisible();
      this.mediaControl.resetFocus();
      this.mediaControl.$el.removeClass('media-control--keep-video-info');
    }
  }, {
    key: "name",
    get: function get() {
      return 'video_info';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'upper';
    }
  }, {
    key: "position",
    get: function get() {
      return 'left';
    }
  }, {
    key: "videoTitle",
    get: function get() {
      return this.options.videoInfo && this.options.videoInfo.title || this.playlist && this.playlist.title;
    }
  }, {
    key: "videoRating",
    get: function get() {
      return this.playlist && this.playlist.contentRating;
    }
  }, {
    key: "videoRatingType",
    get: function get() {
      return this.playlist && this.playlist.isSelfRated ? 'self_rated' : 'default';
    }
  }, {
    key: "videoProgram",
    get: function get() {
      return this.options.videoInfo && this.options.videoInfo.secondaryText || this.playlist && this.playlist.program;
    }
  }, {
    key: "videoInfoHTMLData",
    get: function get() {
      return {
        'title': this.videoTitle,
        'rating': selectRatingIcon(this.videoRating, this.videoRatingType),
        'program': this.videoProgram
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$4);
    }
  }, {
    key: "buttonTemplate",
    get: function get() {
      return template(buttonHtml);
    }
  }, {
    key: "shouldUseInfoButton",
    get: function get() {
      return this.playerSize && this.playerSize.width <= 480;
    }
  }, {
    key: "modal",
    get: function get() {
      return this.mediaControl.$modal;
    }
  }, {
    key: "allStates",
    get: function get() {
      return 'video-info--chromecast video-info--full video-info--inline video-info--ad video-info--live video-info--dvr';
    }
  }, {
    key: "displayInlineMode",
    get: function get() {
      return this.options.videoInfo.inlineEnabled && this.$el.hasClass('video-info--inline');
    }
  }, {
    key: "displayFullScreenMode",
    get: function get() {
      return this.options.videoInfo.fullscreenEnabled && this.$el.hasClass('video-info--full');
    }
  }, {
    key: "currentState",
    get: function get() {
      if (!this.container) return null;
      var mode = Browser.isChromecast ? 'chromecast' : Utils$1.Fullscreen.isFullscreen() ? 'full' : 'inline';
      this.status = [];
      var playbackType = this.container.getPlaybackType();
      playbackType === 'live' && this.status.push('video-info--live');
      this.container.isDvrInUse() && this.status.push('video-info--dvr');
      playbackType === 'ad' && this.status.push('video-info--ad');
      return "".concat(mode, " ").concat(this.status.join(' '));
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click .drawer-info-icon[data-video-info]': 'showModalvideoInfo'
      };
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'video-info',
        'data-video-info': ''
      };
    }
  }]);

  return VideoInfo;
}(MediaControlPlugin);

var chromecastHTML = "<div class=\"chromecast-playback-background\"></div>\n";

var TICK_INTERVAL = 100;

var ChromecastPlayback = /*#__PURE__*/function (_Playback) {
  _inherits(ChromecastPlayback, _Playback);

  var _super = _createSuper(ChromecastPlayback);

  _createClass(ChromecastPlayback, [{
    key: "name",
    get: function get() {
      return 'chromecast_playback';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(chromecastHTML);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": 'chromecast-playback'
      };
    }
  }, {
    key: "isReady",
    get: function get() {
      return true;
    }
  }]);

  function ChromecastPlayback(options) {
    var _this;

    _classCallCheck(this, ChromecastPlayback);

    _this = _super.call(this, options);
    _this.src = options.src;
    _this.currentMedia = options.currentMedia;
    _this.mediaControl = options.mediaControl;

    _this.currentMedia.addUpdateListener(function () {
      return _this.onMediaStatusUpdate();
    });

    _this.settings = options.settings; //let noVolume = (name) => name != 'volume'
    //this.settings.default && (this.settings.default = this.settings.default.filter(noVolume))
    //this.settings.left && (this.settings.left = this.settings.left.filter(noVolume))
    //this.settings.right && (this.settings.right = this.settings.right.filter(noVolume))

    return _this;
  }

  _createClass(ChromecastPlayback, [{
    key: "render",
    value: function render() {
      var template = this.template();
      this.$el.html(template);

      if (this.options.poster) {
        this.$('.chromecast-playback-background').css('background-image', 'url(' + this.options.poster + ')');
      } else {
        this.$('.chromecast-playback-background').css('background-color', '#666');
      }
    }
  }, {
    key: "configure",
    value: function configure(options) {
      var _this2 = this;

      Log$1.debug(this.name, 'configure', options);

      _get(_getPrototypeOf(ChromecastPlayback.prototype), "configure", this).call(this, options);

      if (options.currentMedia) {
        this.currentMedia = options.currentMedia;
        this.previousMediaState = undefined;
        this.currentMedia.addUpdateListener(function () {
          return _this2.onMediaStatusUpdate();
        });
        clearTimeout(this.idleTimeout);
        this.onMediaStatusUpdate();
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.currentMedia.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.stopTimer();
      this.currentMedia.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopTimer();
      this.currentMedia.stop();
    }
  }, {
    key: "volume",
    value: function volume(value) {
      var _this3 = this;

      var level = value / 100;
      var volume = new chrome.cast.Volume(level, false);
      var request = new chrome.cast.media.VolumeRequest(volume);
      this.currentMedia.setVolume(request, function () {
        return Log$1.info(_this3.name, 'volume set');
      }, function (err) {
        return Log$1.warn(_this3.name, err);
      });
    }
  }, {
    key: "seek",
    value: function seek(time) {
      var _this4 = this;

      this.stopTimer();
      var request = new chrome.cast.media.SeekRequest();
      request.currentTime = time;
      this.currentMedia.seek(request, function () {
        return _this4.startTimer();
      }, function () {
        return Log$1.warn(_this4.name, 'seek failed');
      });
    }
  }, {
    key: "getVolume",
    value: function getVolume() {}
  }, {
    key: "seekPercentage",
    value: function seekPercentage(percentage) {
      if (percentage >= 0 && percentage <= 100) {
        var duration = this.getDuration();
        this.seek(percentage * duration / 100);
      }
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this5 = this;

      this.timer = setInterval(function () {
        return _this5.updateMediaControl();
      }, TICK_INTERVAL);
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.currentMedia.media.duration;
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return this.currentMedia.playerState === 'PLAYING' || this.currentMedia.playerState === 'BUFFERING';
    }
  }, {
    key: "getPlaybackType",
    value: function getPlaybackType() {
      return this.currentMedia.streamType == 'LIVE' ? Playback.LIVE : Playback.VOD;
    }
  }, {
    key: "onMediaStatusUpdate",
    value: function onMediaStatusUpdate() {
      var _this6 = this;

      var loadingQueueItem = this.currentMedia.loadingItemId || this.currentMedia.preloadedItemId;
      Log$1.debug(this.name, 'onMediaStatusUpdate', this.currentMedia.playerState, loadingQueueItem); // this.mediaControl.changeTogglePlay()

      if (this.isPlaying() && !this.timer) this.startTimer();
      this.updateBufferState();
      if (this.idleTimeout && this.currentMedia.playerState !== 'IDLE') clearTimeout(this.idleTimeout);

      if (this.currentMedia.playerState === 'PLAYING') {
        this.trigger(Events$1.PLAYBACK_PLAY, this.name);
        this.trigger(Events$1.PLAYBACK_MEDIACONTROL_ENABLE, this.name);
      } else if (!loadingQueueItem && this.currentMedia.playerState === 'IDLE' && this.previousMediaState === 'PLAYING' && this.currentMedia.idleReason === 'FINISHED') {
        this.idleTimeout = setTimeout(function () {
          return _this6.trigger(Events$1.PLAYBACK_ENDED, _this6.name);
        }, 1000);
      } else if (this.currentMedia.playerState === 'IDLE' && this.currentMedia.idleReason === 'FINISHED') {
        this.trigger(Events$1.PLAYBACK_MEDIACONTROL_DISABLE, this.name);
      }

      this.previousMediaState = this.currentMedia.playerState;
    }
  }, {
    key: "updateBufferState",
    value: function updateBufferState() {
      if (this.currentMedia.playerState === 'BUFFERING') {
        this.isBuffering = true;
        this.trigger(Events$1.PLAYBACK_BUFFERING, this.name);
      } else if (this.isBuffering) {
        this.isBuffering = false;
        this.trigger(Events$1.PLAYBACK_BUFFERFULL, this.name);
      }
    }
  }, {
    key: "updateMediaControl",
    value: function updateMediaControl() {
      if (!this.currentMedia.media) return;
      var position = this.currentMedia.getEstimatedTime();
      var duration = this.currentMedia.media.duration;
      this.trigger(Events$1.PLAYBACK_TIMEUPDATE, {
        current: position,
        total: duration
      }, this.name);
    }
  }, {
    key: "show",
    value: function show() {
      this.$el.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.hide();
    }
  }]);

  return ChromecastPlayback;
}(Playback);

var castIconSvg = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n        <path d=\"M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z\" id=\"cast-off-a\"/>\n        <path id=\"cast-off-c\" d=\"M0 0h24v24H0z\"/>\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <mask id=\"cast-off-b\" fill=\"#fff\">\n            <use xlink:href=\"#cast-off-a\"/>\n        </mask>\n        <use fill=\"#FFF\" xlink:href=\"#cast-off-a\"/>\n        <g mask=\"url(#cast-off-b)\">\n            <use fill=\"#FFF\" xlink:href=\"#cast-off-c\"/>\n            <path stroke=\"#E5E5E5\" d=\"M.5.5h23v23H.5z\"/>\n        </g>\n    </g>\n</svg>";

var connectedIconSvg = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n        <path d=\"M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\" id=\"cast-on-a\"/>\n        <path id=\"cast-on-c\" d=\"M0 0h24v24H0z\"/>\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <mask id=\"cast-on-b\" fill=\"#fff\">\n            <use xlink:href=\"#cast-on-a\"/>\n        </mask>\n        <use fill=\"#FFF\" xlink:href=\"#cast-on-a\"/>\n        <g mask=\"url(#cast-on-b)\">\n            <use fill=\"#FFF\" xlink:href=\"#cast-on-c\"/>\n            <path stroke=\"#E5E5E5\" d=\"M.5.5h23v23H.5z\"/>\n        </g>\n    </g>\n</svg>";

var connecting1IconSvg = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg class=\"player-cast-loading\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"ic_cast0_black_24dp\" sketch:type=\"MSArtboardGroup\">\n            <g id=\"ic_remove_circle_white_24dp\" sketch:type=\"MSLayerGroup\">\n                <path d=\"M1,18 L1,21 L4,21 C4,19.34 2.66,18 1,18 L1,18 Z\" id=\"Path\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M1,14 L1,16 C3.76,16 6,18.24 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z\" id=\"Path\" opacity=\"0.3\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M1,10 L1,12 C5.97,12 10,16.03 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z\" id=\"Path\" opacity=\"0.3\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z\" id=\"Path\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <rect id=\"bounds\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>\n            </g>\n        </g>\n        <g id=\"assets\" sketch:type=\"MSLayerGroup\" transform=\"translate(-240.000000, -106.000000)\">\n            <g id=\"64px\" transform=\"translate(0.000000, 114.000000)\"></g>\n        </g>\n    </g>\n</svg>";

var connecting2IconSvg = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg class=\"player-cast-loading\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"ic_cast1_black_24dp\" sketch:type=\"MSArtboardGroup\">\n            <g id=\"ic_remove_circle_white_24dp\" sketch:type=\"MSLayerGroup\">\n                <path d=\"M1,18 L1,21 L4,21 C4,19.34 2.66,18 1,18 L1,18 Z\" id=\"Path\" opacity=\"0.3\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M1,14 L1,16 C3.76,16 6,18.24 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z\" id=\"Path\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M1,10 L1,12 C5.97,12 10,16.03 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z\" id=\"Path\" opacity=\"0.3\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z\" id=\"cast\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <rect id=\"bounds\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>\n            </g>\n        </g>\n        <g id=\"assets\" sketch:type=\"MSLayerGroup\" transform=\"translate(-272.000000, -106.000000)\">\n            <g id=\"64px\" transform=\"translate(0.000000, 114.000000)\"></g>\n        </g>\n    </g>\n</svg>";

var connecting3IconSvg = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg class=\"player-cast-loading\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"ic_cast2_black_24dp\" sketch:type=\"MSArtboardGroup\">\n            <g id=\"ic_remove_circle_white_24dp\" sketch:type=\"MSLayerGroup\">\n                <path d=\"M1,18 L1,21 L4,21 C4,19.34 2.66,18 1,18 L1,18 Z\" id=\"Path\" opacity=\"0.3\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M1,14 L1,16 C3.76,16 6,18.24 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z\" id=\"Path\" opacity=\"0.3\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M1,10 L1,12 C5.97,12 10,16.03 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z\" id=\"Path\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <path d=\"M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z\" id=\"cast\" fill=\"#000000\" sketch:type=\"MSShapeGroup\"></path>\n                <rect id=\"bounds\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>\n            </g>\n        </g>\n        <g id=\"assets\" sketch:type=\"MSLayerGroup\" transform=\"translate(-304.000000, -106.000000)\">\n            <g id=\"64px\" transform=\"translate(0.000000, 114.000000)\"></g>\n        </g>\n    </g>\n</svg>";

var css_248z$j = ".clappr-player#wp3-player-0 svg #cast, .clappr-player#wp3-player-0 svg #cast-on, .clappr-player#wp3-player-0 svg #Path {\n  fill: #fff; }\n\n.clappr-player#wp3-player-0 .chromecast-playback {\n  height: 100%;\n  width: 100%; }\n  .clappr-player#wp3-player-0 .chromecast-playback .chromecast-playback-background {\n    background-size: cover; }\n\n.clappr-player#wp3-player-0 .chromecast-playback-background,\n.clappr-player#wp3-player-0 .chromecast-playback-overlay {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0; }\n\n.clappr-player#wp3-player-0 .media-control-panel .chromecast-sender-indicator.media-control-element {\n  padding-bottom: 0;\n  padding-top: 0; }\n";
styleInject(css_248z$j);

var DEFAULT_COOKIE_NAME = 'GLBID';
var MESSAGE_BUS_NAMESPACE = 'urn:x-cast:wm.player';
var DEVICE_STATE = {
  'IDLE': 0,
  'ACTIVE': 1,
  'WARNING': 2,
  'ERROR': 3
};
var MIMETYPES = {
  'mp4': 'video/mp4',
  'ogg': 'video/ogg',
  '3gpp': 'video/3gpp',
  'webm': 'video/webm',
  'mkv': 'video/x-matroska',
  'm3u8': 'application/x-mpegurl',
  'mpd': 'application/dash+xml',
  'ogv': 'video/ogg',
  '3gp': 'video/3gpp'
};

var getCookie = Utils$1.getCookie;

var ChromecastPlugin = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(ChromecastPlugin, _MediaControlPlugin);

  var _super = _createSuper(ChromecastPlugin);

  _createClass(ChromecastPlugin, [{
    key: "version",
    get: function get() {
      return VERSION;
    }
  }, {
    key: "name",
    get: function get() {
      return 'chromecast';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'right';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'chromecast-button media-control-button',
        'data-chromecast': ''
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click': 'click'
      };
    }
  }, {
    key: "options",
    get: function get() {
      return this.core.options.chromecast || (this.core.options.chromecast = {});
    }
  }, {
    key: "hasCastLib",
    get: function get() {
      return window.chrome && window.chrome.cast;
    }
  }, {
    key: "isCastAvailable",
    get: function get() {
      return this.hasCastLib && window.chrome.cast.isAvailable;
    }
  }], [{
    key: "Movie",
    get: function get() {
      return 'movie';
    }
  }, {
    key: "TvShow",
    get: function get() {
      return 'tv_show';
    }
  }, {
    key: "Generic",
    get: function get() {
      return 'none';
    }
  }, {
    key: "version",
    get: function get() {
      return VERSION;
    }
  }]);

  function ChromecastPlugin(core) {
    var _this;

    _classCallCheck(this, ChromecastPlugin);

    _this = _super.call(this, core);
    _this.contentType = 'application/video-id';

    if (!Browser.isiOS && Browser.isChrome && _this.options.appId) {
      _this.appId = _this.options.appId;
      _this.deviceState = DEVICE_STATE.IDLE;

      _this.embedScript();
    } else {
      _this.disable();
    }

    _this.subtitlesAvailable = [];
    _this.audiosAvailable = [];
    return _this;
  }

  _createClass(ChromecastPlugin, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core.mediaControl, Events$1.MEDIACONTROL_RENDERED, this.render);
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);

      if (this.container) {
        this.listenTo(this.container, Events$1.CONTAINER_TIMEUPDATE, this.containerTimeUpdate);
        this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.containerPlay);
        this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.sessionStopped);
        this.listenTo(this.container, Events$1.CONTAINER_VOLUME, this.onVolumeChanged);
        this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
        this.listenTo(this.container, Events.WM_SUBTITLE_CHANGED, this.onSubtitleChanged);
        this.listenTo(this.container, Events.WM_AUDIO_CHANGED, this.onAudioChanged);
      }
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      this.providerId = video.providerId;
    }
  }, {
    key: "onVolumeChanged",
    value: function onVolumeChanged(value) {
      var _this2 = this;

      if (!this.session) return;
      var newLevel = value / 100;
      this.session.setReceiverVolumeLevel(newLevel, function () {
        return Log$1.info(_this2.name, 'volume set');
      }, function (err) {
        return Log$1.error(_this2.name, err);
      });
    }
  }, {
    key: "onSubtitleChanged",
    value: function onSubtitleChanged(subtitleOption) {
      if (!this.session) return;
      var selectedSubtitle = this.subtitlesAvailable.find(function (s) {
        return s.language === subtitleOption.language || subtitleOption.keys.includes(s.language) || s.id === subtitleOption.id;
      });
      var messageData = {
        action: 'SUBTITLE_CHANGED',
        payload: selectedSubtitle
      };
      this.sendMessage(messageData);
    }
  }, {
    key: "onAudioChanged",
    value: function onAudioChanged(audioOption) {
      if (!this.session) return;
      var selectedAudio = this.audiosAvailable.find(function (a) {
        return audioOption.keys.includes(a.language) && a.role === audioOption.role;
      });
      var messageData = {
        action: 'AUDIO_CHANGED',
        payload: selectedAudio
      };
      this.sendMessage(messageData);
    }
  }, {
    key: "enable",
    value: function enable() {
      _get(_getPrototypeOf(ChromecastPlugin.prototype), "enable", this).call(this);

      this.render();
      this.embedScript();
    }
  }, {
    key: "embedScript",
    value: function embedScript() {
      var _this3 = this;

      var bootstrapCastApi = function bootstrapCastApi() {
        return nextTick(function () {
          return _this3.bootstrapCastApi();
        });
      };

      if (!this.isCastAvailable) {
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('async', 'async');
        script.setAttribute('src', 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js');

        script.onload = function () {
          _this3.core.trigger(Events.CHROMECAST_SCRIPT_LOADED);

          _this3.bootstrapCastApi();
        };

        script.onerror = function () {
          _this3.core.trigger(Events.CHROMECAST_SCRIPT_ERROR, {
            code: 'chromecast-script-error',
            description: 'Chromecast script error.',
            level: 'INFO'
          });
        };

        document.body.appendChild(script);
      } else {
        bootstrapCastApi();
      }
    }
  }, {
    key: "bootstrapCastApi",
    value: function bootstrapCastApi() {
      var _this4 = this;

      if (!this.isCastAvailable) {
        window['__onGCastApiAvailable'] = function (loaded, errorInfo) {
          if (loaded) {
            _this4.core.trigger(Events.CHROMECAST_API_READY);

            _this4.initializeCastApi();
          } else {
            Log$1.warn(_this4.name, 'GCastApi error', errorInfo);

            _this4.core.trigger(Events.CHROMECAST_API_ERROR, {
              code: 'chromecast-api-error',
              description: errorInfo,
              level: 'INFO'
            });

            _this4.disable();
          }
        };
      } else {
        this.initializeCastApi();
      }
    }
  }, {
    key: "initializeCastApi",
    value: function initializeCastApi() {
      var _this5 = this;

      var autoJoinPolicy = chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED;
      var sessionRequest = new chrome.cast.SessionRequest(this.appId);
      var apiConfig = new chrome.cast.ApiConfig(sessionRequest, function (session) {
        return _this5.sessionListener(session);
      }, function (e) {
        return _this5.receiverListener(e);
      }, autoJoinPolicy);
      chrome.cast.initialize(apiConfig, function () {
        _this5.core.trigger(Events.CHROMECAST_INITIALIZE_SUCCESS);

        Log$1.debug(_this5.name, 'init success');
      }, function () {
        _this5.core.trigger(Events.CHROMECAST_INITIALIZE_ERROR, {
          code: 'chromecast-init-error',
          description: 'Chromecast initialize error.',
          level: 'INFO'
        });

        Log$1.warn(_this5.name, 'init error');
      });
    }
  }, {
    key: "sessionListener",
    value: function sessionListener(session) {
      Log$1.debug(this.name, 'new session id:' + session.sessionId);
      this.newSession(session);
    }
  }, {
    key: "sessionUpdateListener",
    value: function sessionUpdateListener() {
      if (this.session) {
        Log$1.debug(this.name, this.session.status);

        if (this.session.status === chrome.cast.SessionStatus.STOPPED) {
          this.sessionStopped();
          this.session = null;
        }
      }
    }
  }, {
    key: "mediaListener",
    value: function mediaListener() {
      Log$1.debug(this.name, 'mediaListener', this.session.media);

      if (this.session.media) {
        var currentMedia = this.session.media[this.session.media.length - 1];
        this.mediaSession = currentMedia;
        this.playbackProxy && this.playbackProxy.configure({
          currentMedia: currentMedia
        });
      }
    }
  }, {
    key: "receiverListener",
    value: function receiverListener(e) {
      if (e === chrome.cast.ReceiverAvailability.AVAILABLE) {
        this.core.trigger(Events.CHROMECAST_AVAILABLE);
        Log$1.debug(this.name, 'receiver found');
        this.show();
      } else {
        this.core.trigger(Events.CHROMECAST_UNAVAILABLE);
        Log$1.debug(this.name, 'receiver list empty');
        this.hide();
      }
    }
  }, {
    key: "launchSuccess",
    value: function launchSuccess(session) {
      clearInterval(this.connectAnimInterval);
      this.core.trigger(Events.CHROMECAST_LAUNCH_SUCCESS);
      Log$1.debug(this.name, 'launch success - session: ' + session.sessionId);
      this.newSession(session);
    }
  }, {
    key: "launchError",
    value: function launchError(e) {
      var isNotIdle = this.mediaSession && this.mediaSession.playerState !== chrome.cast.media.PlayerState.IDLE;
      var isCastPlaying = this.mediaSession && this.mediaSession.playerState === chrome.cast.media.PlayerState.PLAYING;
      var cancelAction = e.code === chrome.cast.ErrorCode.CANCEL;
      this.core.trigger(Events.CHROMECAST_LAUNCH_ERROR, e);
      if (isNotIdle && cancelAction) return;
      Log$1.debug(this.name, 'error on launch', e);
      this.renderDisconnected();
      clearInterval(this.connectAnimInterval);

      if (this.isPlayingBeforeConnect || isCastPlaying) {
        this.container.play();
        this.container.seek(this.currentTime);
      }
    }
  }, {
    key: "loadMediaSuccess",
    value: function loadMediaSuccess(how, mediaSession) {
      this.core.trigger(Events.CHROMECAST_MEDIA_LOAD_SUCCESS);
      Log$1.debug(this.name, 'new media session', mediaSession, "(".concat(how, ")"));
      this.originalPlayback = this.core.getCurrentPlayback();
      var options = Object.assign({}, this.originalPlayback.options, {
        currentMedia: mediaSession,
        mediaControl: this.core.mediaControl,
        poster: this.container.options.poster,
        settings: this.originalPlayback.settings
      });
      this.src = this.originalPlayback.src;
      this.playbackProxy = new ChromecastPlayback(options);
      this.playbackProxy.render();
      this.mediaSession = mediaSession;
      this.originalPlayback.$el.hide();
      var container = this.core.getCurrentContainer();
      container.$el.append(this.playbackProxy.el);
      container.stopListening();
      container.playback = this.playbackProxy;
      container.bindEvents();
      container.settingsUpdate();
    }
  }, {
    key: "loadMediaError",
    value: function loadMediaError(e) {
      this.core.trigger(Events.CHROMECAST_MEDIA_LOAD_ERROR, e);
      Log$1.warn(this.name, 'media error', e);
    }
  }, {
    key: "newSession",
    value: function newSession(session) {
      var _this6 = this;

      this.session = session;
      this.deviceState = DEVICE_STATE.ACTIVE;
      this.renderConnected();
      this.core.trigger(Events.DFP_DISABLE);
      session.addUpdateListener(function () {
        return _this6.sessionUpdateListener();
      });
      session.addMediaListener(function () {
        return _this6.mediaListener();
      });
      session.addMessageListener(MESSAGE_BUS_NAMESPACE, function (channel, msg) {
        return _this6.wmpMessageListener(channel, msg);
      });
      this.containerPlay();
    }
  }, {
    key: "sessionStopped",
    value: function sessionStopped() {
      this.renderDisconnected();
      var container = this.core.getCurrentContainer();
      var playerState = undefined;

      if (this.mediaSession) {
        playerState = this.mediaSession.playerState;
        this.mediaSession = null;
        this.playbackProxy.$el && this.playbackProxy.$el.remove();
        this.originalPlayback.$el && this.originalPlayback.$el.show();
        container.stopListening();
        container.playback = this.originalPlayback;
        container.bindEvents();
        container.settingsUpdate();
        this.core.trigger(Events.DFP_ENABLE);
      }

      if (this.playbackProxy) {
        if (this.playbackProxy.isPlaying() || playerState === 'PLAYING') {
          container.play();
          container.seek(this.currentTime);
        }

        this.playbackProxy.stop();
        this.playbackProxy = null;
      }
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(messageData) {
      var _this7 = this;

      this.session.sendMessage(MESSAGE_BUS_NAMESPACE, messageData, function (data) {
        return _this7.onMessageSuccess(data);
      }, function (error) {
        return _this7.onMessageFailure(error);
      });
    }
  }, {
    key: "onMessageSuccess",
    value: function onMessageSuccess(data) {
      Log$1.info(this.name, 'message bus: send message success', data);
    }
  }, {
    key: "onMessageFailure",
    value: function onMessageFailure(error) {
      Log$1.error(this.name, 'message bus: send message error', error);
    }
  }, {
    key: "loadMedia",
    value: function loadMedia() {
      var _this8 = this;

      if (this.playback && !this.playback.isReady) {
        this.listenToOnce(this.playback, Events$1.PLAYBACK_READY, this.loadMedia);
        return;
      }

      this.container.pause();
      var src = this.container.options.src;
      Log$1.debug(this.name, 'loading... ' + src);
      var mediaInfo = this.createMediaInfo(src);
      var request = new chrome.cast.media.LoadRequest(mediaInfo);
      request.autoplay = true;
      request.currentTime = this.core.getPlaybackType() == 'ad' ? 0 : this.currentTime || 0;
      this.session.loadMedia(request, function (mediaSession) {
        return _this8.loadMediaSuccess('loadMedia', mediaSession);
      }, function (e) {
        return _this8.loadMediaError(e);
      });
    }
  }, {
    key: "createMediaInfo",
    value: function createMediaInfo(src) {
      var mimeType = ChromecastPlugin.mimeTypeFor(src);
      var options = this.core.options;
      var dfp = options.dfp;
      var watchedAds = dfp.watchedAds;
      var defaultSettings = this.getSelectedSettings();
      if (this.core.getPlaybackType() === 'ad') watchedAds += 1;
      var customData = {
        token: options.token || this.getTokenFromCookie(),
        adUnit: dfp.adUnit,
        adCustomData: dfp.adCustomData,
        adAccountId: dfp.adAccountId,
        adCmsId: dfp.adCmsId,
        daiCustomData: options.daiCustomData,
        adPublisherProvidedID: options.adPublisherProvidedID,
        watchedAds: watchedAds,
        ga: options.ga,
        defaultSubtitle: defaultSettings.subtitle,
        defaultAudio: defaultSettings.audio,
        videoInfo: options.videoInfo,
        enableBingeWatch: this.options.enableBingeWatch || false,
        upa: options.upa,
        globoId: options.globoId || undefined,
        horizon: options.horizon || {}
      };
      var mediaInfo = new chrome.cast.media.MediaInfo(src);
      mediaInfo.contentType = this.contentType || mimeType;
      mediaInfo.customData = customData;
      mediaInfo.metadata = this.createMediaMetadata();
      return mediaInfo;
    }
  }, {
    key: "getSelectedSettings",
    value: function getSelectedSettings() {
      var settings = this.core.getPlugin('settings');

      var _ref = settings.getSelectedSettings() || {},
          audio = _ref.audio,
          _ref$subtitle = _ref.subtitle;

      _ref$subtitle = _ref$subtitle === void 0 ? {} : _ref$subtitle;
      var subtitle = _ref$subtitle.language;
      return _objectSpread2(_objectSpread2({}, settings.getDefaultSettings() || {}), {}, {
        audio: audio,
        subtitle: subtitle
      });
    }
  }, {
    key: "getTokenFromCookie",
    value: function getTokenFromCookie() {
      var cookieName = this.providerId ? "WMPTOKEN_".concat(this.providerId) : DEFAULT_COOKIE_NAME;
      return getCookie(cookieName);
    }
  }, {
    key: "createMediaMetadata",
    value: function createMediaMetadata() {
      this.options.media || (this.options.media = {});
      var type = this.options.media.type;
      var metadata = this.createCastMediaMetadata(type);
      metadata.title = this.options.media.title;
      metadata.subtitle = this.options.media.subtitle;
      metadata.releaseDate = this.options.media.releaseDate;

      if (type === ChromecastPlugin.TvShow) {
        metadata.episode = this.options.media.episode;
        metadata.originalAirdate = this.options.media.originalAirdate;
        metadata.season = this.options.media.season;
        metadata.seriesTitle = this.options.media.seriesTitle;
      } else if (type === ChromecastPlugin.Movie) {
        metadata.studio = this.options.media.studio;
      }

      if (this.options.media.images) {
        metadata.images = this.options.media.images.map(function (url) {
          return new chrome.cast.Image(url);
        });
      }

      if (!metadata.images && this.core.options.poster) {
        metadata.images = [new chrome.cast.Image(this.core.options.poster)];
      }

      return metadata;
    }
  }, {
    key: "createCastMediaMetadata",
    value: function createCastMediaMetadata(type) {
      switch (type) {
        case ChromecastPlugin.Movie:
          return new chrome.cast.media.MovieMediaMetadata();

        case ChromecastPlugin.TvShow:
          return new chrome.cast.media.TvShowMediaMetadata();

        default:
          return new chrome.cast.media.GenericMediaMetadata();
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.$el.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.hide();
    }
  }, {
    key: "click",
    value: function click() {
      var _this9 = this;

      this.core.trigger(Events.CHROMECAST_LAUNCH_REQUEST);
      chrome.cast.requestSession(function (session) {
        return _this9.launchSuccess(session);
      }, function (e) {
        return _this9.launchError(e);
      });

      if (!this.session) {
        this.isPlayingBeforeConnect = this.container.isPlaying();
        this.container.pause();
        var position = 0;
        clearInterval(this.connectAnimInterval);
        this.connectAnimInterval = setInterval(function () {
          _this9.renderConnecting(position);

          position = (position + 1) % 3;
        }, 600);
      }
    }
  }, {
    key: "containerChanged",
    value: function containerChanged() {
      this.stopListening();
      this.container = this.core.activeContainer;
      this.playback = this.core.activePlayback;
      this.bindEvents();
      this.currentTime = 0;
      this.session && (this.originalPlayback = this.playback) && this.sessionStopped();
    }
  }, {
    key: "containerTimeUpdate",
    value: function containerTimeUpdate(timeProgress) {
      this.currentTime = timeProgress.current;
    }
  }, {
    key: "containerPlay",
    value: function containerPlay() {
      if (this.session && (!this.mediaSession || this.mediaSession.playerStatus === 'IDLE')) {
        Log$1.debug(this.name, 'load media');
        this.currentTime = this.currentTime || 0;
        this.loadMedia();
      }
    }
  }, {
    key: "wmpMessageListener",
    value: function wmpMessageListener(channel, msg) {
      if (!this.session) return;
      var parsedMessage = JSON.parse(msg);
      this.handleAdBreak(parsedMessage);
      this.handleMediaTracks(parsedMessage);
    }
  }, {
    key: "handleAdBreak",
    value: function handleAdBreak(message) {
      if (message.name === 'adBreakStarted') {
        Log$1.debug(this.name, 'ad break started');

        if (this.playbackProxy) {
          this.playbackProxy.settings.seekEnabled = false;
          this.playbackProxy.trigger(Events$1.PLAYBACK_SETTINGSUPDATE);
        }
      } else if (message.name === 'adBreakEnded') {
        Log$1.debug(this.name, 'ad break ended');

        if (this.playbackProxy) {
          this.playbackProxy.settings.seekEnabled = true;
          this.playbackProxy.trigger(Events$1.PLAYBACK_SETTINGSUPDATE);
        }
      }
    }
  }, {
    key: "handleMediaTracks",
    value: function handleMediaTracks(message) {
      switch (message.action) {
        case 'SUBTITLE_AVAILABLE':
          this.subtitlesAvailable = message.payload;
          break;

        case 'AUDIO_AVAILABLE':
          this.audiosAvailable = message.payload;
          break;
      }
    }
  }, {
    key: "createCachedElements",
    value: function createCachedElements() {
      this.$mediaControl = this.mediaControl && this.mediaControl.$el;
      this.$settingsButton = this.$mediaControl.find('.media-control-button[data-settings]');
    }
  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      this.removeOverlay();
      this.createCachedElements();

      if (this.session) {
        var receiverName = this.session && this.session.receiver && this.session.receiver.friendlyName;
        this.core.trigger(Events.CHROMECAST_MEDIA_WATCHING, receiverName);
      }
    }
  }, {
    key: "renderConnecting",
    value: function renderConnecting(position) {
      var connectingIcons = [connecting1IconSvg, connecting2IconSvg, connecting3IconSvg];
      this.$el.html(connectingIcons[position]);
      this.container && this.container.$el.addClass('cast-connecting');
      this.$mediaControl.addClass('media-control-disabled media-control--no-background');
      this.mediaControl.setKeepVisible();
      this.renderStyle();
    }
  }, {
    key: "removeOverlay",
    value: function removeOverlay() {
      this.core.trigger(Events.CHROMECAST_MEDIA_STOP_WATCHING);
    }
  }, {
    key: "renderConnected",
    value: function renderConnected() {
      this.$el.html(connectedIconSvg);
      this.$mediaControl.removeClass('media-control-disabled');
      this.mediaControl.setKeepVisible();
      this.container.$el.removeClass('cast-connecting');
      this.container.$el.addClass('cast-enabled');
      this.renderStyle();
      this.renderOverlay();
    }
  }, {
    key: "renderDisconnected",
    value: function renderDisconnected() {
      this.$el.html(castIconSvg);
      this.$mediaControl.removeClass('media-control-disabled');
      this.mediaControl.resetKeepVisible();
      this.container && this.container.$el.removeClass('cast-enabled cast-connecting');
      this.$mediaControl.removeClass('media-control--no-background');
      this.renderStyle();
      this.removeOverlay();
    }
  }, {
    key: "renderStyle",
    value: function renderStyle() {
      var style = Styler.getStyleFrom(css_248z$j, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
    }
  }, {
    key: "render",
    value: function render() {
      this.createCachedElements();
      this.session ? this.renderConnected() : this.renderDisconnected();
      this.appendToMediaControl();
      return this;
    }
  }, {
    key: "appendToMediaControl",
    value: function appendToMediaControl() {
      var fullscreenButton = this.$mediaControl && this.$mediaControl.find('.media-control-button[data-fullscreen]');

      if (fullscreenButton.length > 0) {
        $$1(this.el).insertBefore(fullscreenButton);
      } else {
        this.$mediaControl.find('.media-control-center-panel').append(this.el);
      }
    }
  }], [{
    key: "mimeTypeFor",
    value: function mimeTypeFor(srcUrl) {
      var extension = (srcUrl.split('?')[0].match(/.*\.(.*)$/) || [])[1];

      if (MIMETYPES[extension]) {
        return MIMETYPES[extension];
      } else if (srcUrl.indexOf('.ism') > -1) {
        return 'application/vnd.ms-sstr+xml';
      }
    }
  }]);

  return ChromecastPlugin;
}(MediaControlPlugin);

var chromecastOverlayHTML = "<div class=\"chromecast-playback-overlay\">\n  <div class=\"chromecast-status\">\n    <span class=\"label-watching\">Assistindo em</span>\n    <span class=\"label-device\"></span>\n  </div>\n</div>\n";

var css_248z$k = ".clappr-player#wp3-player-0 .thumb-preview-modal--visible .chromecast-sender-indicator {\n  opacity: 0; }\n\n.clappr-player#wp3-player-0 .media-control-panel .chromecast-sender-indicator {\n  padding: 0; }\n\n.clappr-player#wp3-player-0 .media-control-panel .chromecast-playback-overlay {\n  display: flex;\n  justify-content: center;\n  z-index: 100;\n  pointer-events: none;\n  flex-direction: row;\n  align-items: center; }\n  .clappr-player#wp3-player-0 .media-control-panel .chromecast-playback-overlay .chromecast-status {\n    position: relative;\n    top: -16px; }\n    .clappr-player#wp3-player-0 .media-control-panel .chromecast-playback-overlay .chromecast-status .label-watching,\n    .clappr-player#wp3-player-0 .media-control-panel .chromecast-playback-overlay .chromecast-status .label-device {\n      font-family: \"opensans-regular\", sans-serif;\n      font-size: 14px;\n      color: #fff; }\n    .clappr-player#wp3-player-0 .media-control-panel .chromecast-playback-overlay .chromecast-status .label-device {\n      font-weight: bold; }\n\n.clappr-player#wp3-player-0 .media-control-panel__between .chromecast-playback-overlay .chromecast-status {\n  top: -36px; }\n";
styleInject(css_248z$k);

var ChromecastSenderIndicator = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(ChromecastSenderIndicator, _MediaControlPlugin);

  var _super = _createSuper(ChromecastSenderIndicator);

  _createClass(ChromecastSenderIndicator, [{
    key: "name",
    get: function get() {
      return 'chromecast_sender_indicator';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'div';
    }
  }, {
    key: "panel",
    get: function get() {
      return Browser.supportsTouchEvents ? 'between' : 'lower';
    }
  }, {
    key: "position",
    get: function get() {
      return 'center';
    }
  }, {
    key: "overlayTemplate",
    get: function get() {
      return template(chromecastOverlayHTML);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'chromecast-sender-indicator'
      };
    }
  }]);

  function ChromecastSenderIndicator(core) {
    var _this;

    _classCallCheck(this, ChromecastSenderIndicator);

    _this = _super.call(this, core);

    _this.$el.hide();

    return _this;
  }

  _createClass(ChromecastSenderIndicator, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events.CHROMECAST_MEDIA_WATCHING, this.renderTemplate);
      this.listenTo(this.core, Events.CHROMECAST_MEDIA_STOP_WATCHING, this.hideRender);
    }
  }, {
    key: "hideRender",
    value: function hideRender() {
      this.$el.empty();
      this.$el.hide();
    }
  }, {
    key: "renderStyle",
    value: function renderStyle() {
      var style = Styler.getStyleFrom(css_248z$k, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
    }
  }, {
    key: "renderTemplate",
    value: function renderTemplate(receiverName) {
      this.hideRender();
      this.renderStyle();
      this.$el.append(this.overlayTemplate());
      this.$el.show();
      receiverName && this.$el.find('.label-device').html(receiverName);
    }
  }]);

  return ChromecastSenderIndicator;
}(MediaControlPlugin);

var iconErrorDefault = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"45.695px\" height=\"45.782px\" viewBox=\"0 0 45.695 45.782\" enable-background=\"new 0 0 45.695 45.782\" xml:space=\"preserve\">\r\n<g id=\"vector\">\r\n\t<path d=\"M45.272,38.282L45.272,38.282L24.659,5.224l0,0c-0.356-0.55-0.987-0.921-1.716-0.921c-0.722,0-1.351,0.367-1.707,0.916l0,0\r\n\t\tc-5.22,8.377-20.606,33.05-20.606,33.05v0.004c-0.186,0.289-0.294,0.634-0.294,0.999c0,1.07,0.898,1.939,2.015,1.939\r\n\t\tc0.027,0,0.054-0.008,0.082-0.008l0.004,0.008h41.085v-0.004c0.011,0,0.02,0.004,0.021,0.004c1.113,0,2.016-0.869,2.016-1.939\r\n\t\tC45.559,38.911,45.452,38.572,45.272,38.282z M24.174,13.673c1.476,0.464,2.424,1.896,2.221,3.591\r\n\t\tc-0.203,1.723-0.555,3.428-0.826,5.145c-0.323,2.036-0.624,4.071-0.951,6.185c-1.11,0-2.138,0-3.177,0\r\n\t\tc-0.347-2.168-0.673-4.303-1.031-6.431c-0.239-1.422-0.524-2.838-0.791-4.257C19.066,14.951,21.386,12.789,24.174,13.673z\r\n\t\t M22.98,37.174c-1.914,0-3.455-1.479-3.448-3.324c0.005-0.702,0.259-1.352,0.678-1.883c0.632-0.811,1.655-1.344,2.78-1.344\r\n\t\tc1.913-0.004,3.452,1.487,3.438,3.332C26.416,35.736,24.886,37.167,22.98,37.174z\"/>\r\n</g>\r\n<g id=\"vector_2_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.886,44.697c-1.023,1.025-2.684,1.025-3.71,0L1.009,4.526\r\n\t\tc-1.026-1.021-1.026-2.685,0-3.707c1.023-1.028,2.684-1.028,3.709,0l40.168,40.168C45.912,42.013,45.912,43.67,44.886,44.697z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M23.341,6.386c0.821-0.008,1.574,0.409,1.568,1.217c-0.016,1.454-0.036,3.013-0.036,6.013\r\n\t\t\tc1.215,0,1.561,0,4.561,0c0-3,0-5.613,0-7.525c0-2.509-1.47-3.31-3.948-3.314c-4.139-0.012-8.458-0.012-12.601-0.017l3.582,3.64\r\n\t\t\tC18.776,6.412,21.035,6.409,23.341,6.386z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M29.434,15.457c0,0,0,0,0,0.003c0-0.008,0.646-0.008,1.427-0.014c0.804-0.003,0.849,0.274,0.845,1.075\r\n\t\t\tc-0.02,1.672-0.08,3.349-0.094,5.021l3.6,3.628c0.022-3.341,0.037-6.678,0.037-10.02c0-2.507-0.671-3.314-3.149-3.317\r\n\t\t\tc-1.263-0.004-2.558-0.001-3.539-0.004l0,0c-1.379-0.002-2.719-0.005-4.094-0.005c-0.688,0-1.641,0.028-2.569,0.061l3.726,3.494\r\n\t\t\tC26.836,15.403,27.434,15.464,29.434,15.457z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M28.083,37.331c-0.903-0.008-1.809-0.02-2.708-0.02c-1.645,0-2.94,0.029-4.583,0.025\r\n\t\t\tc-1.747-0.004-1.738-0.754-1.738-0.754c0.004-5,0.155-4.457,0.155-6.563l-3.886-4.667c0.027,1.189,0.095,2.059,0.122,3.268\r\n\t\t\tc-0.804,0.006-1.816,0.084-2.274,0.088c-0.792,0.013-1.008-0.559-1.002-1.401c0.008-1.923,0.022-3.892,0.034-5.81l-3.516-3.538\r\n\t\t\tc-0.019,0.509-0.026,0.797-0.026,0.797c0,3.753-0.001,7.828,0.004,11.912c0,2.504,0.535,3.131,3.02,3.138\r\n\t\t\tc0.865,0.003,2.8-0.075,3.925-0.124c0.058,2.576,0.097,4.729,0.098,5.886c0,2.192,0.6,2.985,2.413,3.177\r\n\t\t\tc0.258,0.028,0.542-0.002,0.853-0.002c4.332,0.014,8.662-0.01,12.994-0.007c0.531,0,0.977-0.055,1.36-0.161L28.083,37.331z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"vector_4_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M38.618,3.387H6.309c-1.657,0-3,1.343-3,3v33.008c0,1.658,1.343,3,3,3h32.311\r\n\t\tc1.656,0,3-1.342,3-3V6.387C41.618,4.73,40.275,3.387,38.618,3.387z M32.371,13.745c0,0.032-1.535,0.748-2.529,1.801\r\n\t\tc-0.908,0.965-1.46,5.07-1.471,5.07c1.317,0,3.062,0,3.062,0s0,2.001,0,3.507c0,0.279-3.292,0.285-5.146,0.275\r\n\t\tc-0.186,0-2.037,4.171-3.279,5.973c-1.604,2.322-3.759,3.744-6.474,4.349c-0.958,0.211-1.916,0.294-2.889,0.335\r\n\t\tc-0.165,0.01-1.338-0.17-1.334-0.342c0.005-1.561,0.039-3.123,0.034-4.688c0-0.164,0.089-0.103,0.089-0.092\r\n\t\tc0,0.017,0,0.036,0,0.052c1,0.104,4.33-0.785,5.325-1.809c0.364-0.37,1.775-2.266,2.091-2.805c0.19-0.332,1.627-3.421,1.9-4.141\r\n\t\tc0.303-0.795,0.618-1.602,0.918-2.397c0.116-0.309,0.831-1.83,0.906-1.97c0.408-0.755,0.814-1.517,1.243-2.267\r\n\t\tc0.239-0.421,0.509-0.83,0.798-1.216c1.606-2.158,3.36-3.726,5.94-4.406c0.938-0.249,0.938-0.249,0.938-0.249\r\n\t\tC32.493,11.876,32.371,12.061,32.371,13.745z\"/>\r\n</g>\r\n<g id=\"vector_5_\" display=\"none\">\r\n\t<g display=\"inline\">\r\n\t\t<g>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M22.957,4.179c-6.904,0-12.493,4.152-12.493,13.283v11.199c0,5.51,4.287,8.729,9.307,9.674\r\n\t\t\t\tc-2.807-1.61-5.027-5.127-5.027-10.25v-7.414c0-6.755,3.661-12.231,8.216-12.231c4.511,0,8.194,5.476,8.194,12.231v7.414\r\n\t\t\t\tc0,5.117-1.674,8.379-3.949,10.006c4.539-1.184,8.229-4.32,8.229-9.43V17.462C35.431,8.332,29.842,4.179,22.957,4.179z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M36.555,23.558H10.081c-1.828,0-2.969-0.675-2.969,1.121v11.903\r\n\t\tc0,1.795,1.141,3.498,2.969,3.498h26.474c1.827,0,2.228-1.703,2.228-3.498V24.679C38.782,22.882,38.381,23.558,36.555,23.558z\r\n\t\t M23.446,35.267c-2.219,0-4.017-1.798-4.017-4.015c0-2.219,1.798-4.018,4.017-4.018c2.218,0,4.016,1.799,4.016,4.018\r\n\t\tC27.461,33.469,25.664,35.267,23.446,35.267z\"/>\r\n</g>\r\n<g id=\"vector_3_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M34.12,35.643c-0.285-0.025-0.573-0.048-0.889-0.048c-0.316-2.489,0.356-5.019-0.644-7.36\r\n\t\tc-0.976-2.29-2.576-4.057-4.304-5.764c1.711-1.707,3.295-3.446,4.281-5.69c1.018-2.311,0.364-4.787,0.662-7.279\r\n\t\tc0.335,0,0.601,0.018,0.859-0.004c0.817-0.067,1.342-0.619,1.35-1.414c0.01-0.827-0.537-1.275-1.402-1.332\r\n\t\tc-0.146-0.009-22.139-0.014-22.342,0.013c-0.752,0.097-1.237,0.607-1.234,1.37c0.005,0.765,0.497,1.277,1.256,1.352\r\n\t\tc0.399,0.042,0.805,0.007,1.313,0.007c0,1.422,0.023,2.749-0.004,4.078c-0.042,1.875,0.456,3.582,1.513,5.056\r\n\t\tc0.982,1.371,2.086,2.644,3.17,4.005c-1.609,1.622-3.17,3.37-4.118,5.636c-0.979,2.338-0.324,4.838-0.646,7.312\r\n\t\tc-0.499,0-0.945-0.062-1.371,0.014c-0.684,0.121-1.09,0.594-1.106,1.348c-0.021,0.801,0.391,1.615,1.109,1.792\r\n\t\tc0.195,0.048,22.397,0.039,22.514,0.029c0.815-0.072,1.342-0.796,1.349-1.589C35.445,36.379,34.926,35.715,34.12,35.643z\r\n\t\t M17.009,10.403c3.966,0,7.907,0,11.875,0c0.169,0,0.1,3.687-0.472,4.513c-1.547,2.235-3.539,4.395-5.545,6.213\r\n\t\tc-1.979-1.691-3.883-4.215-5.326-6.393C16.936,13.819,16.829,10.403,17.009,10.403z M28.885,34.517c-3.967,0-7.907,0-11.875,0\r\n\t\tc-0.169,0-0.1-3.386,0.472-4.211c1.547-2.235,3.539-3.772,5.545-5.591c1.979,1.691,3.883,3.518,5.326,5.695\r\n\t\tC28.959,31.327,29.065,34.517,28.885,34.517z\"/>\r\n</g>\r\n<g id=\"vector_1_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.479,43.969c-1.006,0.992-2.636,0.992-3.642,0L1.413,5.136\r\n\t\tc-1.004-0.994-1.004-2.599,0-3.589c1.008-0.993,2.636-0.993,3.643,0L44.48,40.385C45.485,41.377,45.485,42.98,44.479,43.969z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M16.546,34.493c-0.961,0.01-1.326-0.262-1.325-1.27c0.016-3.178,0.046-5.826,0.004-8.35l-3.792-3.853\r\n\t\t\tc0,1.537,0,2.963,0,4.159c0,0-0.247,9.863-0.241,14.75c0,2.994,0.761,4.139,3.773,4.146c5.258,0.014,10.425,0.112,15.686,0.116\r\n\t\t\tc1.493,0,2.451-0.313,3.038-1.028l-8.815-8.686C22.1,34.465,19.314,34.467,16.546,34.493z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M28.656,11.656c0.994-0.007,1.321,0.32,1.311,1.29c-0.022,2.392,0.016,4.782,0.019,7.179l4.448,4.355\r\n\t\t\tc0-4.402,0-8.798,0-13.204c0-3.002-0.978-3.934-3.993-3.937c-4.484-0.018-8.98-0.018-13.465-0.02l4.396,4.34\r\n\t\t\tC23.802,11.673,26.227,11.682,28.656,11.656z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"Layer_7\" display=\"none\">\r\n</g>\r\n</svg>";

var iconUnsupportedDevice = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"45.695px\" height=\"45.782px\" viewBox=\"0 0 45.695 45.782\" enable-background=\"new 0 0 45.695 45.782\" xml:space=\"preserve\">\r\n<g id=\"vector\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M45.272,38.282L45.272,38.282L24.659,5.224l0,0c-0.356-0.55-0.987-0.921-1.716-0.921\r\n\t\tc-0.722,0-1.351,0.367-1.707,0.916l0,0c-5.22,8.377-20.606,33.05-20.606,33.05v0.004c-0.186,0.289-0.294,0.634-0.294,0.999\r\n\t\tc0,1.07,0.898,1.939,2.015,1.939c0.027,0,0.054-0.008,0.082-0.008l0.004,0.008h41.085v-0.004c0.011,0,0.02,0.004,0.021,0.004\r\n\t\tc1.113,0,2.016-0.869,2.016-1.939C45.559,38.911,45.452,38.572,45.272,38.282z M24.174,13.673c1.476,0.464,2.424,1.896,2.221,3.591\r\n\t\tc-0.203,1.723-0.555,3.428-0.826,5.145c-0.323,2.036-0.624,4.071-0.951,6.185c-1.11,0-2.138,0-3.177,0\r\n\t\tc-0.347-2.168-0.673-4.303-1.031-6.431c-0.239-1.422-0.524-2.838-0.791-4.257C19.066,14.951,21.386,12.789,24.174,13.673z\r\n\t\t M22.98,37.174c-1.914,0-3.455-1.479-3.448-3.324c0.005-0.702,0.259-1.352,0.678-1.883c0.632-0.811,1.655-1.344,2.78-1.344\r\n\t\tc1.913-0.004,3.452,1.487,3.438,3.332C26.416,35.736,24.886,37.167,22.98,37.174z\"/>\r\n</g>\r\n<g id=\"vector_2_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.886,44.697c-1.023,1.025-2.684,1.025-3.71,0L1.009,4.526\r\n\t\tc-1.026-1.021-1.026-2.685,0-3.707c1.023-1.028,2.684-1.028,3.709,0l40.168,40.168C45.912,42.013,45.912,43.67,44.886,44.697z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M24.341,6.386c0.821-0.008,1.574,0.409,1.568,1.217c-0.016,1.454-0.036,3.013-0.036,6.013\r\n\t\t\tc1.215,0,1.561,0,4.561,0c0-3,0-5.613,0-7.525c0-2.509-1.47-3.31-3.948-3.314c-4.139-0.012-8.458-0.012-12.601-0.017l3.582,3.64\r\n\t\t\tC19.776,6.412,22.035,6.409,24.341,6.386z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M30.434,15.457c0,0,0,0,0,0.003c0-0.008,0.646-0.008,1.427-0.014c0.804-0.003,0.849,0.274,0.845,1.075\r\n\t\t\tc-0.02,1.672-0.08,3.349-0.094,5.021l3.6,3.628c0.022-3.341,0.037-6.678,0.037-10.02c0-2.507-0.671-3.314-3.149-3.317\r\n\t\t\tc-1.263-0.004-2.558-0.001-3.539-0.004l0,0c-1.379-0.002-2.719-0.005-4.094-0.005c-0.688,0-1.641,0.028-2.569,0.061l3.726,3.494\r\n\t\t\tC27.836,15.403,28.434,15.464,30.434,15.457z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M29.083,37.331c-0.903-0.008-1.809-0.02-2.708-0.02c-1.645,0-2.94,0.029-4.583,0.025\r\n\t\t\tc-1.747-0.004-1.738-0.754-1.738-0.754c0.004-5,0.155-4.457,0.155-6.563l-3.886-4.667c0.027,1.189,0.095,2.059,0.122,3.268\r\n\t\t\tc-0.804,0.006-1.816,0.084-2.274,0.088c-0.792,0.013-1.008-0.559-1.002-1.401c0.008-1.923,0.022-3.892,0.034-5.81l-3.516-3.538\r\n\t\t\tc-0.019,0.509-0.026,0.797-0.026,0.797c0,3.753-0.001,7.828,0.004,11.912c0,2.504,0.535,3.131,3.02,3.138\r\n\t\t\tc0.865,0.003,2.8-0.075,3.925-0.124c0.058,2.576,0.097,4.729,0.098,5.886c0,2.192,0.6,2.985,2.413,3.177\r\n\t\t\tc0.258,0.028,0.542-0.002,0.853-0.002c4.332,0.014,8.662-0.01,12.994-0.007c0.531,0,0.977-0.055,1.36-0.161L29.083,37.331z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"vector_4_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M40.294,3.616H8.433c-2.344,0-5-0.268-5,2.107v30.15c0,2.379,2.655,6.742,5,6.742h31.861\r\n\t\tc2.345,0,1.14-4.363,1.14-6.742V5.723C41.434,3.349,42.639,3.616,40.294,3.616z M32.434,12.648c0,0.032,0.733,0.058,0.405,0.1\r\n\t\tc-1.443,0.175-1.94,0.697-2.935,1.75c-0.907,0.965-1.46,5.118-1.471,5.118c1.318,0,3,0,3,0s0,1.904,0,3.411\r\n\t\tc0,0.279,0.48,0.279,0.211,0.279c-1.854,0-3.472,0.005-5.327-0.004c-0.185,0-2.021,4.171-3.264,5.973\r\n\t\tc-1.604,2.322-3.751,3.743-6.466,4.349c-0.958,0.211-1.912,0.293-2.884,0.334c-0.165,0.01-0.211-0.037-0.208-0.209\r\n\t\tc0.005-1.56,0.008-3.123,0.003-4.688c0-0.164-0.555-0.307-0.304-0.264c-0.071,0.017-0.763,0.029-0.763,0.039\r\n\t\tc0,0.017,0,0.035,0,0.052c0,0,0.84,0.006,0.976,0c1.58-0.095,3.26-0.655,4.381-1.808c0.363-0.371,1.791-2.267,2.105-2.807\r\n\t\tc0.19-0.331,1.635-3.421,1.908-4.14c0.303-0.795,0.622-1.602,0.922-2.397c0.116-0.309,0.833-1.83,0.908-1.97\r\n\t\tc0.409-0.755,0.816-1.517,1.245-2.267c0.239-0.421,0.508-0.83,0.797-1.216c1.607-2.158,3.362-3.726,5.941-4.406\r\n\t\tc0.938-0.249,0.815-0.551,0.815-0.551C32.434,10.478,32.434,10.964,32.434,12.648z\"/>\r\n</g>\r\n<g id=\"vector_5_\" display=\"none\">\r\n\t<g display=\"inline\">\r\n\t\t<g>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M22.957,5.179c-6.904,0-12.493,4.152-12.493,13.283v11.199c0,5.51,4.287,8.729,9.307,9.674\r\n\t\t\t\tc-2.807-1.61-5.027-5.127-5.027-10.25v-7.414c0-6.755,3.661-12.231,8.216-12.231c4.511,0,8.194,5.476,8.194,12.231v7.414\r\n\t\t\t\tc0,5.117-1.674,8.379-3.949,10.006c4.539-1.184,8.229-4.32,8.229-9.43V18.462C35.431,9.332,29.842,5.179,22.957,5.179z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M36.555,14.558H10.081c-1.828,0-2.969-0.675-2.969,1.121v11.903\r\n\t\tc0,1.795,1.141,3.498,2.969,3.498h26.474c1.827,0,2.228-1.703,2.228-3.498V15.679C38.782,13.882,38.381,14.558,36.555,14.558z\r\n\t\t M23.446,26.267c-2.219,0-4.017-1.798-4.017-4.015c0-2.219,1.798-4.017,4.017-4.017c2.218,0,4.016,1.798,4.016,4.017\r\n\t\tC27.461,24.469,25.664,26.267,23.446,26.267z\"/>\r\n</g>\r\n<g id=\"vector_3_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M34.12,35.643c-0.285-0.025-0.573-0.048-0.889-0.048c-0.316-2.489,0.356-5.019-0.644-7.36\r\n\t\tc-0.976-2.29-2.576-4.057-4.304-5.764c1.711-1.707,3.295-3.446,4.281-5.69c1.018-2.311,0.364-4.787,0.662-7.279\r\n\t\tc0.335,0,0.601,0.018,0.859-0.004c0.817-0.067,1.342-0.619,1.35-1.414c0.01-0.827-0.537-1.275-1.402-1.332\r\n\t\tc-0.146-0.009-22.139-0.014-22.342,0.013c-0.752,0.097-1.237,0.607-1.234,1.37c0.005,0.765,0.497,1.277,1.256,1.352\r\n\t\tc0.399,0.042,0.805,0.007,1.313,0.007c0,1.422,0.023,2.749-0.004,4.078c-0.042,1.875,0.456,3.582,1.513,5.056\r\n\t\tc0.982,1.371,2.086,2.644,3.17,4.005c-1.609,1.622-3.17,3.37-4.118,5.636c-0.979,2.338-0.324,4.838-0.646,7.312\r\n\t\tc-0.499,0-0.945-0.062-1.371,0.014c-0.684,0.121-1.09,0.594-1.106,1.348c-0.021,0.801,0.391,1.615,1.109,1.792\r\n\t\tc0.195,0.048,22.397,0.039,22.514,0.029c0.815-0.072,1.342-0.796,1.349-1.589C35.445,36.379,34.926,35.715,34.12,35.643z\r\n\t\t M17.009,10.403c3.966,0,7.907,0,11.875,0c0.169,0,0.1,3.687-0.472,4.513c-1.547,2.235-3.539,4.395-5.545,6.213\r\n\t\tc-1.979-1.691-3.883-4.215-5.326-6.393C16.936,13.819,16.829,10.403,17.009,10.403z M28.885,34.517c-3.967,0-7.907,0-11.875,0\r\n\t\tc-0.169,0-0.1-3.386,0.472-4.211c1.547-2.235,3.539-3.772,5.545-5.591c1.979,1.691,3.883,3.518,5.326,5.695\r\n\t\tC28.959,31.327,29.065,34.517,28.885,34.517z\"/>\r\n</g>\r\n<g id=\"vector_1_\">\r\n\t<path d=\"M44.479,43.969c-1.006,0.992-2.636,0.992-3.642,0L1.413,5.136c-1.004-0.994-1.004-2.599,0-3.589\r\n\t\tc1.008-0.993,2.636-0.993,3.643,0L44.48,40.385C45.485,41.377,45.485,42.98,44.479,43.969z\"/>\r\n\t<g>\r\n\t\t<path d=\"M16.546,34.493c-0.961,0.01-1.326-0.262-1.325-1.27c0.016-3.178,0.046-5.826,0.004-8.35l-3.792-3.853\r\n\t\t\tc0,1.537,0,2.963,0,4.159c0,0-0.247,9.863-0.241,14.75c0,2.994,0.761,4.139,3.773,4.146c5.258,0.014,10.425,0.112,15.686,0.116\r\n\t\t\tc1.493,0,2.451-0.313,3.038-1.028l-8.815-8.686C22.1,34.465,19.314,34.467,16.546,34.493z\"/>\r\n\t\t<path d=\"M28.656,11.656c0.994-0.007,1.321,0.32,1.311,1.29c-0.022,2.392,0.016,4.782,0.019,7.179l4.448,4.355\r\n\t\t\tc0-4.402,0-8.798,0-13.204c0-3.002-0.978-3.934-3.993-3.937c-4.484-0.018-8.98-0.018-13.465-0.02l4.396,4.34\r\n\t\t\tC23.802,11.673,26.227,11.682,28.656,11.656z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"Layer_7\" display=\"none\">\r\n</g>\r\n</svg>";

var iconSubscriberOnly = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"45.695px\" height=\"45.782px\" viewBox=\"0 0 45.695 45.782\" enable-background=\"new 0 0 45.695 45.782\" xml:space=\"preserve\">\r\n<g id=\"vector\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M45.272,38.282L45.272,38.282L24.659,5.224l0,0c-0.356-0.55-0.987-0.921-1.716-0.921\r\n\t\tc-0.722,0-1.351,0.367-1.707,0.916l0,0c-5.22,8.377-20.606,33.05-20.606,33.05v0.004c-0.186,0.289-0.294,0.634-0.294,0.999\r\n\t\tc0,1.07,0.898,1.939,2.015,1.939c0.027,0,0.054-0.008,0.082-0.008l0.004,0.008h41.085v-0.004c0.011,0,0.02,0.004,0.021,0.004\r\n\t\tc1.113,0,2.016-0.869,2.016-1.939C45.559,38.911,45.452,38.572,45.272,38.282z M24.174,13.673c1.476,0.464,2.424,1.896,2.221,3.591\r\n\t\tc-0.203,1.723-0.555,3.428-0.826,5.145c-0.323,2.036-0.624,4.071-0.951,6.185c-1.11,0-2.138,0-3.177,0\r\n\t\tc-0.347-2.168-0.673-4.303-1.031-6.431c-0.239-1.422-0.524-2.838-0.791-4.257C19.066,14.951,21.386,12.789,24.174,13.673z\r\n\t\t M22.98,37.174c-1.914,0-3.455-1.479-3.448-3.324c0.005-0.702,0.259-1.352,0.678-1.883c0.632-0.811,1.655-1.344,2.78-1.344\r\n\t\tc1.913-0.004,3.452,1.487,3.438,3.332C26.416,35.736,24.886,37.167,22.98,37.174z\"/>\r\n</g>\r\n<g id=\"vector_2_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.886,44.697c-1.023,1.025-2.684,1.025-3.71,0L1.009,4.526\r\n\t\tc-1.026-1.021-1.026-2.685,0-3.707c1.023-1.028,2.684-1.028,3.709,0l40.168,40.168C45.912,42.013,45.912,43.67,44.886,44.697z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M24.341,6.386c0.821-0.008,1.574,0.409,1.568,1.217c-0.016,1.454-0.036,3.013-0.036,6.013\r\n\t\t\tc1.215,0,1.561,0,4.561,0c0-3,0-5.613,0-7.525c0-2.509-1.47-3.31-3.948-3.314c-4.139-0.012-8.458-0.012-12.601-0.017l3.582,3.64\r\n\t\t\tC19.776,6.412,22.035,6.409,24.341,6.386z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M30.434,15.457c0,0,0,0,0,0.003c0-0.008,0.646-0.008,1.427-0.014c0.804-0.003,0.849,0.274,0.845,1.075\r\n\t\t\tc-0.02,1.672-0.08,3.349-0.094,5.021l3.6,3.628c0.022-3.341,0.037-6.678,0.037-10.02c0-2.507-0.671-3.314-3.149-3.317\r\n\t\t\tc-1.263-0.004-2.558-0.001-3.539-0.004l0,0c-1.379-0.002-2.719-0.005-4.094-0.005c-0.688,0-1.641,0.028-2.569,0.061l3.726,3.494\r\n\t\t\tC27.836,15.403,28.434,15.464,30.434,15.457z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M29.083,37.331c-0.903-0.008-1.809-0.02-2.708-0.02c-1.645,0-2.94,0.029-4.583,0.025\r\n\t\t\tc-1.747-0.004-1.738-0.754-1.738-0.754c0.004-5,0.155-4.457,0.155-6.563l-3.886-4.667c0.027,1.189,0.095,2.059,0.122,3.268\r\n\t\t\tc-0.804,0.006-1.816,0.084-2.274,0.088c-0.792,0.013-1.008-0.559-1.002-1.401c0.008-1.923,0.022-3.892,0.034-5.81l-3.516-3.538\r\n\t\t\tc-0.019,0.509-0.026,0.797-0.026,0.797c0,3.753-0.001,7.828,0.004,11.912c0,2.504,0.535,3.131,3.02,3.138\r\n\t\t\tc0.865,0.003,2.8-0.075,3.925-0.124c0.058,2.576,0.097,4.729,0.098,5.886c0,2.192,0.6,2.985,2.413,3.177\r\n\t\t\tc0.258,0.028,0.542-0.002,0.853-0.002c4.332,0.014,8.662-0.01,12.994-0.007c0.531,0,0.977-0.055,1.36-0.161L29.083,37.331z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"vector_4_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M40.294,3.616H8.433c-2.344,0-5-0.268-5,2.107v30.15c0,2.379,2.655,6.742,5,6.742h31.861\r\n\t\tc2.345,0,1.14-4.363,1.14-6.742V5.723C41.434,3.349,42.639,3.616,40.294,3.616z M32.434,12.648c0,0.032,0.733,0.058,0.405,0.1\r\n\t\tc-1.443,0.175-1.94,0.697-2.935,1.75c-0.907,0.965-1.46,5.118-1.471,5.118c1.318,0,3,0,3,0s0,1.904,0,3.411\r\n\t\tc0,0.279,0.48,0.279,0.211,0.279c-1.854,0-3.472,0.005-5.327-0.004c-0.185,0-2.021,4.171-3.264,5.973\r\n\t\tc-1.604,2.322-3.751,3.743-6.466,4.349c-0.958,0.211-1.912,0.293-2.884,0.334c-0.165,0.01-0.211-0.037-0.208-0.209\r\n\t\tc0.005-1.56,0.008-3.123,0.003-4.688c0-0.164-0.555-0.307-0.304-0.264c-0.071,0.017-0.763,0.029-0.763,0.039\r\n\t\tc0,0.017,0,0.035,0,0.052c0,0,0.84,0.006,0.976,0c1.58-0.095,3.26-0.655,4.381-1.808c0.363-0.371,1.791-2.267,2.105-2.807\r\n\t\tc0.19-0.331,1.635-3.421,1.908-4.14c0.303-0.795,0.622-1.602,0.922-2.397c0.116-0.309,0.833-1.83,0.908-1.97\r\n\t\tc0.409-0.755,0.816-1.517,1.245-2.267c0.239-0.421,0.508-0.83,0.797-1.216c1.607-2.158,3.362-3.726,5.941-4.406\r\n\t\tc0.938-0.249,0.815-0.551,0.815-0.551C32.434,10.478,32.434,10.964,32.434,12.648z\"/>\r\n</g>\r\n<g id=\"vector_5_\">\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path d=\"M22.957,4.179c-6.904,0-12.493,4.152-12.493,13.283v11.199c0,5.51,4.287,8.729,9.307,9.674\r\n\t\t\t\tc-2.807-1.61-5.027-5.127-5.027-10.25v-7.414c0-6.755,3.661-12.231,8.216-12.231c4.511,0,8.194,5.476,8.194,12.231v7.414\r\n\t\t\t\tc0,5.117-1.674,8.379-3.949,10.006c4.539-1.184,8.229-4.32,8.229-9.43V17.462C35.431,8.332,29.842,4.179,22.957,4.179z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<path d=\"M36.555,23.558H10.081c-1.828,0-2.969-0.675-2.969,1.121v11.903c0,1.795,1.141,3.498,2.969,3.498h26.474\r\n\t\tc1.827,0,2.228-1.703,2.228-3.498V24.679C38.782,22.882,38.381,23.558,36.555,23.558z M23.446,35.267\r\n\t\tc-2.219,0-4.017-1.798-4.017-4.015c0-2.219,1.798-4.018,4.017-4.018c2.218,0,4.016,1.799,4.016,4.018\r\n\t\tC27.461,33.469,25.664,35.267,23.446,35.267z\"/>\r\n</g>\r\n<g id=\"vector_3_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M34.12,35.643c-0.285-0.025-0.573-0.048-0.889-0.048c-0.316-2.489,0.356-5.019-0.644-7.36\r\n\t\tc-0.976-2.29-2.576-4.057-4.304-5.764c1.711-1.707,3.295-3.446,4.281-5.69c1.018-2.311,0.364-4.787,0.662-7.279\r\n\t\tc0.335,0,0.601,0.018,0.859-0.004c0.817-0.067,1.342-0.619,1.35-1.414c0.01-0.827-0.537-1.275-1.402-1.332\r\n\t\tc-0.146-0.009-22.139-0.014-22.342,0.013c-0.752,0.097-1.237,0.607-1.234,1.37c0.005,0.765,0.497,1.277,1.256,1.352\r\n\t\tc0.399,0.042,0.805,0.007,1.313,0.007c0,1.422,0.023,2.749-0.004,4.078c-0.042,1.875,0.456,3.582,1.513,5.056\r\n\t\tc0.982,1.371,2.086,2.644,3.17,4.005c-1.609,1.622-3.17,3.37-4.118,5.636c-0.979,2.338-0.324,4.838-0.646,7.312\r\n\t\tc-0.499,0-0.945-0.062-1.371,0.014c-0.684,0.121-1.09,0.594-1.106,1.348c-0.021,0.801,0.391,1.615,1.109,1.792\r\n\t\tc0.195,0.048,22.397,0.039,22.514,0.029c0.815-0.072,1.342-0.796,1.349-1.589C35.445,36.379,34.926,35.715,34.12,35.643z\r\n\t\t M17.009,10.403c3.966,0,7.907,0,11.875,0c0.169,0,0.1,3.687-0.472,4.513c-1.547,2.235-3.539,4.395-5.545,6.213\r\n\t\tc-1.979-1.691-3.883-4.215-5.326-6.393C16.936,13.819,16.829,10.403,17.009,10.403z M28.885,34.517c-3.967,0-7.907,0-11.875,0\r\n\t\tc-0.169,0-0.1-3.386,0.472-4.211c1.547-2.235,3.539-3.772,5.545-5.591c1.979,1.691,3.883,3.518,5.326,5.695\r\n\t\tC28.959,31.327,29.065,34.517,28.885,34.517z\"/>\r\n</g>\r\n<g id=\"vector_1_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.479,43.969c-1.006,0.992-2.636,0.992-3.642,0L1.413,5.136\r\n\t\tc-1.004-0.994-1.004-2.599,0-3.589c1.008-0.993,2.636-0.993,3.643,0L44.48,40.385C45.485,41.377,45.485,42.98,44.479,43.969z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M16.546,34.493c-0.961,0.01-1.326-0.262-1.325-1.27c0.016-3.178,0.046-5.826,0.004-8.35l-3.792-3.853\r\n\t\t\tc0,1.537,0,2.963,0,4.159c0,0-0.247,9.863-0.241,14.75c0,2.994,0.761,4.139,3.773,4.146c5.258,0.014,10.425,0.112,15.686,0.116\r\n\t\t\tc1.493,0,2.451-0.313,3.038-1.028l-8.815-8.686C22.1,34.465,19.314,34.467,16.546,34.493z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M28.656,11.656c0.994-0.007,1.321,0.32,1.311,1.29c-0.022,2.392,0.016,4.782,0.019,7.179l4.448,4.355\r\n\t\t\tc0-4.402,0-8.798,0-13.204c0-3.002-0.978-3.934-3.993-3.937c-4.484-0.018-8.98-0.018-13.465-0.02l4.396,4.34\r\n\t\t\tC23.802,11.673,26.227,11.682,28.656,11.656z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"Layer_7\" display=\"none\">\r\n</g>\r\n</svg>";

var iconGeoblocking = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"45.7px\" height=\"45.8px\" viewBox=\"0 0 45.7 45.8\" enable-background=\"new 0 0 45.7 45.8\" xml:space=\"preserve\">\r\n<g id=\"Layer_1_1_\" display=\"none\">\r\n\t<g id=\"vector\" display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M45.3,38.3L45.3,38.3L24.7,5.2l0,0c-0.4-0.6-1-0.9-1.7-0.9c-0.7,0-1.4,0.4-1.7,0.9l0,0\r\n\t\t\tC16,13.6,0.6,38.3,0.6,38.3v0c-0.2,0.3-0.3,0.6-0.3,1c0,1.1,0.9,1.9,2,1.9c0,0,0.1,0,0.1,0l0,0h41.1v0c0,0,0,0,0,0\r\n\t\t\tc1.1,0,2-0.9,2-1.9C45.6,38.9,45.5,38.6,45.3,38.3z M24.2,13.7c1.5,0.5,2.4,1.9,2.2,3.6c-0.2,1.7-0.6,3.4-0.8,5.1\r\n\t\t\tc-0.3,2-0.6,4.1-1,6.2c-1.1,0-2.1,0-3.2,0c-0.3-2.2-0.7-4.3-1-6.4c-0.2-1.4-0.5-2.8-0.8-4.3C19.1,15,21.4,12.8,24.2,13.7z\r\n\t\t\t M23,37.2c-1.9,0-3.5-1.5-3.4-3.3c0-0.7,0.3-1.4,0.7-1.9c0.6-0.8,1.7-1.3,2.8-1.3c1.9,0,3.5,1.5,3.4,3.3\r\n\t\t\tC26.4,35.7,24.9,37.2,23,37.2z\"/>\r\n\t</g>\r\n\t<g id=\"vector_2_\" display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M44.9,44.7c-1,1-2.7,1-3.7,0L1,4.5c-1-1-1-2.7,0-3.7c1-1,2.7-1,3.7,0L44.9,41C45.9,42,45.9,43.7,44.9,44.7\r\n\t\t\tz\"/>\r\n\t\t<g>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M24.3,6.4c0.8,0,1.6,0.4,1.6,1.2c0,1.5,0,3,0,6c1.2,0,1.6,0,4.6,0c0-3,0-5.6,0-7.5c0-2.5-1.5-3.3-3.9-3.3\r\n\t\t\t\tc-4.1,0-8.5,0-12.6,0l3.6,3.6C19.8,6.4,22,6.4,24.3,6.4z\"/>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M30.4,15.5C30.4,15.5,30.4,15.5,30.4,15.5c0,0,0.6,0,1.4,0c0.8,0,0.8,0.3,0.8,1.1c0,1.7-0.1,3.3-0.1,5\r\n\t\t\t\tl3.6,3.6c0-3.3,0-6.7,0-10c0-2.5-0.7-3.3-3.1-3.3c-1.3,0-2.6,0-3.5,0l0,0c-1.4,0-2.7,0-4.1,0c-0.7,0-1.6,0-2.6,0.1l3.7,3.5\r\n\t\t\t\tC27.8,15.4,28.4,15.5,30.4,15.5z\"/>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M29.1,37.3c-0.9,0-1.8,0-2.7,0c-1.6,0-2.9,0-4.6,0c-1.7,0-1.7-0.8-1.7-0.8c0-5,0.2-4.5,0.2-6.6l-3.9-4.7\r\n\t\t\t\tc0,1.2,0.1,2.1,0.1,3.3c-0.8,0-1.8,0.1-2.3,0.1c-0.8,0-1-0.6-1-1.4c0-1.9,0-3.9,0-5.8L9.7,18c0,0.5,0,0.8,0,0.8\r\n\t\t\t\tc0,3.8,0,7.8,0,11.9c0,2.5,0.5,3.1,3,3.1c0.9,0,2.8-0.1,3.9-0.1c0.1,2.6,0.1,4.7,0.1,5.9c0,2.2,0.6,3,2.4,3.2c0.3,0,0.5,0,0.9,0\r\n\t\t\t\tc4.3,0,8.7,0,13,0c0.5,0,1-0.1,1.4-0.2L29.1,37.3z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<g id=\"vector_4_\" display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M40.3,3.6H8.4c-2.3,0-5-0.3-5,2.1v30.2c0,2.4,2.7,6.7,5,6.7h31.9c2.3,0,1.1-4.4,1.1-6.7V5.7\r\n\t\t\tC41.4,3.3,42.6,3.6,40.3,3.6z M32.4,12.6c0,0,0.7,0.1,0.4,0.1c-1.4,0.2-1.9,0.7-2.9,1.8c-0.9,1-1.5,5.1-1.5,5.1c1.3,0,3,0,3,0\r\n\t\t\ts0,1.9,0,3.4c0,0.3,0.5,0.3,0.2,0.3c-1.9,0-3.5,0-5.3,0c-0.2,0-2,4.2-3.3,6c-1.6,2.3-3.8,3.7-6.5,4.3c-1,0.2-1.9,0.3-2.9,0.3\r\n\t\t\tc-0.2,0-0.2,0-0.2-0.2c0-1.6,0-3.1,0-4.7c0-0.2-0.6-0.3-0.3-0.3c-0.1,0-0.8,0-0.8,0c0,0,0,0,0,0.1c0,0,0.8,0,1,0\r\n\t\t\tc1.6-0.1,3.3-0.7,4.4-1.8c0.4-0.4,1.8-2.3,2.1-2.8c0.2-0.3,1.6-3.4,1.9-4.1c0.3-0.8,0.6-1.6,0.9-2.4c0.1-0.3,0.8-1.8,0.9-2\r\n\t\t\tc0.4-0.8,0.8-1.5,1.2-2.3c0.2-0.4,0.5-0.8,0.8-1.2c1.6-2.2,3.4-3.7,5.9-4.4c0.9-0.2,0.8-0.6,0.8-0.6C32.4,10.5,32.4,11,32.4,12.6z\r\n\t\t\t\"/>\r\n\t</g>\r\n\t<g id=\"vector_5_\" display=\"inline\">\r\n\t\t<g>\r\n\t\t\t<g>\r\n\t\t\t\t<path fill=\"#CCCBCB\" d=\"M23,5.2c-6.9,0-12.5,4.2-12.5,13.3v11.2c0,5.5,4.3,8.7,9.3,9.7c-2.8-1.6-5-5.1-5-10.2v-7.4\r\n\t\t\t\t\tc0-6.8,3.7-12.2,8.2-12.2c4.5,0,8.2,5.5,8.2,12.2v7.4c0,5.1-1.7,8.4-3.9,10c4.5-1.2,8.2-4.3,8.2-9.4V18.5\r\n\t\t\t\t\tC35.4,9.3,29.8,5.2,23,5.2z\"/>\r\n\t\t\t</g>\r\n\t\t</g>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M36.6,14.6H10.1c-1.8,0-3-0.7-3,1.1v11.9c0,1.8,1.1,3.5,3,3.5h26.5c1.8,0,2.2-1.7,2.2-3.5V15.7\r\n\t\t\tC38.8,13.9,38.4,14.6,36.6,14.6z M23.4,26.3c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4C27.5,24.5,25.7,26.3,23.4,26.3z\"/>\r\n\t</g>\r\n\t<g id=\"vector_3_\" display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M34.1,35.6c-0.3,0-0.6,0-0.9,0c-0.3-2.5,0.4-5-0.6-7.4c-1-2.3-2.6-4.1-4.3-5.8c1.7-1.7,3.3-3.4,4.3-5.7\r\n\t\t\tc1-2.3,0.4-4.8,0.7-7.3c0.3,0,0.6,0,0.9,0c0.8-0.1,1.3-0.6,1.4-1.4c0-0.8-0.5-1.3-1.4-1.3c-0.1,0-22.1,0-22.3,0\r\n\t\t\tc-0.8,0.1-1.2,0.6-1.2,1.4c0,0.8,0.5,1.3,1.3,1.4c0.4,0,0.8,0,1.3,0c0,1.4,0,2.7,0,4.1c0,1.9,0.5,3.6,1.5,5.1c1,1.4,2.1,2.6,3.2,4\r\n\t\t\tc-1.6,1.6-3.2,3.4-4.1,5.6c-1,2.3-0.3,4.8-0.6,7.3c-0.5,0-0.9-0.1-1.4,0c-0.7,0.1-1.1,0.6-1.1,1.3c0,0.8,0.4,1.6,1.1,1.8\r\n\t\t\tc0.2,0,22.4,0,22.5,0c0.8-0.1,1.3-0.8,1.3-1.6C35.4,36.4,34.9,35.7,34.1,35.6z M17,10.4c4,0,7.9,0,11.9,0c0.2,0,0.1,3.7-0.5,4.5\r\n\t\t\tc-1.5,2.2-3.5,4.4-5.5,6.2c-2-1.7-3.9-4.2-5.3-6.4C16.9,13.8,16.8,10.4,17,10.4z M28.9,34.5c-4,0-7.9,0-11.9,0\r\n\t\t\tc-0.2,0-0.1-3.4,0.5-4.2c1.5-2.2,3.5-3.8,5.5-5.6c2,1.7,3.9,3.5,5.3,5.7C29,31.3,29.1,34.5,28.9,34.5z\"/>\r\n\t</g>\r\n\t<g id=\"vector_1_\" display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M44.5,44c-1,1-2.6,1-3.6,0L1.4,5.1c-1-1-1-2.6,0-3.6c1-1,2.6-1,3.6,0l39.4,38.8C45.5,41.4,45.5,43,44.5,44\r\n\t\t\tz\"/>\r\n\t\t<g>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M16.5,34.5c-1,0-1.3-0.3-1.3-1.3c0-3.2,0-5.8,0-8.3L11.4,21c0,1.5,0,3,0,4.2c0,0-0.2,9.9-0.2,14.8\r\n\t\t\t\tc0,3,0.8,4.1,3.8,4.1c5.3,0,10.4,0.1,15.7,0.1c1.5,0,2.5-0.3,3-1l-8.8-8.7C22.1,34.5,19.3,34.5,16.5,34.5z\"/>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M28.7,11.7c1,0,1.3,0.3,1.3,1.3c0,2.4,0,4.8,0,7.2l4.4,4.4c0-4.4,0-8.8,0-13.2c0-3-1-3.9-4-3.9\r\n\t\t\t\tc-4.5,0-9,0-13.5,0l4.4,4.3C23.8,11.7,26.2,11.7,28.7,11.7z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<g id=\"Layer_7\" display=\"inline\">\r\n\t</g>\r\n</g>\r\n<g id=\"Layer_2\">\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path d=\"M28.5,25.6l0.1-2c0-5.9,4.2-7.6,8.7-7.6c1.1,0,2.2,0.2,3.2,0.5c-0.9-2.9-2.5-5.5-4.9-7.8c-3.9-3.9-8.5-5.8-14-5.8\r\n\t\t\t\tc-5.3,0-9.9,1.9-13.7,5.6c1.3,0.4,3,1,5.1,1.9c0.2,0.1-0.1,0.4-0.1,0.6c0,0.6,0.5,0.9,1.1,0.7c0.6-0.2,1.1-0.6,1.6-0.9\r\n\t\t\t\tc0.8-0.4,1.6-0.7,2.5-0.6c0.5,0.1,0.9,0.4,0.8,0.9c0,0.4-0.2,0.8-0.3,1.3c-0.2,0.5-0.4,0.9-0.5,1.3c-0.1,0.5,0.1,0.7,0.6,0.5\r\n\t\t\t\tc0.4-0.2,0.7-0.4,1.1-0.6c0.7-0.4,1.3-0.1,1.6,0.6c0.1,0.4,0.1,0.8-0.2,1.1c-0.3,0.4-0.6,0.8-0.9,1.2c-0.6,0.7-1.1,1.4-1.3,2.3\r\n\t\t\t\tc-0.1,0.5-0.3,1.3-0.5,1.7c-0.1,0.2-0.2,0.8-0.3,0.8c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.9-0.3-1.2c-0.3-0.9-0.7-1.4-1.6-1.5\r\n\t\t\t\tc-0.3,0-0.6-0.1-0.8-0.1c-1,0.1-1.7,0.6-1.8,1.5c-0.2,1.3,0.8,2.8,2,3.1c0.7,0.1,1.3,0.1,2,0.1c0.6,0,1.3-0.1,1.9,0\r\n\t\t\t\tc1.3,0,2.3,0.6,2.9,1.8c0.6,1.1,0.8,2.3,0.7,3.5c-0.1,1.3-0.6,2.3-1.7,3c-0.4,0.2-0.7,0.5-1,0.8c-0.5,0.4-0.8,1-0.9,1.7\r\n\t\t\t\tc-0.2,1.3-0.9,2.4-1.8,3.4c0,0.1-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.1-0.6-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.7-0.5-1.1-1.1-1.3-1.9\r\n\t\t\t\tc-0.2-1-0.4-2.1-0.5-3.2c-0.2-1.4-0.7-2.7-1.9-3.6c-0.2-0.1-0.3-0.3-0.5-0.4c-1-0.9-1-2.2-0.1-3.2c0.2-0.3,0.5-0.5,0.7-0.8\r\n\t\t\t\tc0.4-0.5,0.4-1.1,0-1.6c-0.3-0.4-0.7-0.8-1.1-1c-1.2-0.7-2.5-1.4-4-0.7c-0.3,0.1-0.5,0-0.6-0.3c-0.2-0.4-0.3-0.8-0.4-1.2\r\n\t\t\t\tc-0.1-0.7,0-1.4,0-2c0-0.9-0.1-1.8-0.5-2.7c-0.1-0.2-0.8-1-1.5-2c-1.9,3.1-2.9,6.5-2.9,10.4c0,5.5,1.9,10.1,5.8,14\r\n\t\t\t\tc3.9,3.9,8.5,6.4,14,6.4c4.8,0,9-0.9,12.6-3.9h-5.7c-1.2,0-1.7-2.2-1.7-3.4v-7.8C26.9,26.8,27.3,27.3,28.5,25.6z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<g>\r\n\t\t\t\t<path d=\"M37.2,19.6c-3.2,0-5.7,1.9-5.7,6.1v5.1c0,6.1,11.4,6.1,11.4,0v-5.1C42.9,21.5,40.4,19.6,37.2,19.6z M40.5,29.7\r\n\t\t\t\t\tc0,6.3-6.5,5.5-6.5,0v-2.9c0-2.7,1.4-4.8,3.3-4.8c1.8,0,3.2,2.2,3.2,4.8V29.7z\"/>\r\n\t\t\t</g>\r\n\t\t</g>\r\n\t\t<path d=\"M43.2,28.1H31.1c-0.8,0-1.3-0.2-1.3,0.7v5.4c0,0.8,0.5,1.9,1.3,1.9h12.1c0.8,0,0.6-1.1,0.6-1.9v-5.4\r\n\t\t\tC43.9,27.9,44.1,28.1,43.2,28.1z M37.3,33.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6\r\n\t\t\tS38.2,33.6,37.3,33.6z\"/>\r\n\t</g>\r\n</g>\r\n</svg>";

var iconPauseTimeExpired = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"45.695px\" height=\"45.782px\" viewBox=\"0 0 45.695 45.782\" enable-background=\"new 0 0 45.695 45.782\" xml:space=\"preserve\">\r\n<g id=\"vector\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M45.272,38.282L45.272,38.282L24.659,5.224l0,0c-0.356-0.55-0.987-0.921-1.716-0.921\r\n\t\tc-0.722,0-1.351,0.367-1.707,0.916l0,0c-5.22,8.377-20.606,33.05-20.606,33.05v0.004c-0.186,0.289-0.294,0.634-0.294,0.999\r\n\t\tc0,1.07,0.898,1.939,2.015,1.939c0.027,0,0.054-0.008,0.082-0.008l0.004,0.008h41.085v-0.004c0.011,0,0.02,0.004,0.021,0.004\r\n\t\tc1.113,0,2.016-0.869,2.016-1.939C45.559,38.911,45.452,38.572,45.272,38.282z M24.174,13.673c1.476,0.464,2.424,1.896,2.221,3.591\r\n\t\tc-0.203,1.723-0.555,3.428-0.826,5.145c-0.323,2.036-0.624,4.071-0.951,6.185c-1.11,0-2.138,0-3.177,0\r\n\t\tc-0.347-2.168-0.673-4.303-1.031-6.431c-0.239-1.422-0.524-2.838-0.791-4.257C19.066,14.951,21.386,12.789,24.174,13.673z\r\n\t\t M22.98,37.174c-1.914,0-3.455-1.479-3.448-3.324c0.005-0.702,0.259-1.352,0.678-1.883c0.632-0.811,1.655-1.344,2.78-1.344\r\n\t\tc1.913-0.004,3.452,1.487,3.438,3.332C26.416,35.736,24.886,37.167,22.98,37.174z\"/>\r\n</g>\r\n<g id=\"vector_2_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.886,44.697c-1.023,1.025-2.684,1.025-3.71,0L1.009,4.526\r\n\t\tc-1.026-1.021-1.026-2.685,0-3.707c1.023-1.028,2.684-1.028,3.709,0l40.168,40.168C45.912,42.013,45.912,43.67,44.886,44.697z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M24.341,6.386c0.821-0.008,1.574,0.409,1.568,1.217c-0.016,1.454-0.036,3.013-0.036,6.013\r\n\t\t\tc1.215,0,1.561,0,4.561,0c0-3,0-5.613,0-7.525c0-2.509-1.47-3.31-3.948-3.314c-4.139-0.012-8.458-0.012-12.601-0.017l3.582,3.64\r\n\t\t\tC19.776,6.412,22.035,6.409,24.341,6.386z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M30.434,15.457c0,0,0,0,0,0.003c0-0.008,0.646-0.008,1.427-0.014c0.804-0.003,0.849,0.274,0.845,1.075\r\n\t\t\tc-0.02,1.672-0.08,3.349-0.094,5.021l3.6,3.628c0.022-3.341,0.037-6.678,0.037-10.02c0-2.507-0.671-3.314-3.149-3.317\r\n\t\t\tc-1.263-0.004-2.558-0.001-3.539-0.004l0,0c-1.379-0.002-2.719-0.005-4.094-0.005c-0.688,0-1.641,0.028-2.569,0.061l3.726,3.494\r\n\t\t\tC27.836,15.403,28.434,15.464,30.434,15.457z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M29.083,37.331c-0.903-0.008-1.809-0.02-2.708-0.02c-1.645,0-2.94,0.029-4.583,0.025\r\n\t\t\tc-1.747-0.004-1.738-0.754-1.738-0.754c0.004-5,0.155-4.457,0.155-6.563l-3.886-4.667c0.027,1.189,0.095,2.059,0.122,3.268\r\n\t\t\tc-0.804,0.006-1.816,0.084-2.274,0.088c-0.792,0.013-1.008-0.559-1.002-1.401c0.008-1.923,0.022-3.892,0.034-5.81l-3.516-3.538\r\n\t\t\tc-0.019,0.509-0.026,0.797-0.026,0.797c0,3.753-0.001,7.828,0.004,11.912c0,2.504,0.535,3.131,3.02,3.138\r\n\t\t\tc0.865,0.003,2.8-0.075,3.925-0.124c0.058,2.576,0.097,4.729,0.098,5.886c0,2.192,0.6,2.985,2.413,3.177\r\n\t\t\tc0.258,0.028,0.542-0.002,0.853-0.002c4.332,0.014,8.662-0.01,12.994-0.007c0.531,0,0.977-0.055,1.36-0.161L29.083,37.331z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"vector_4_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M40.294,3.616H8.433c-2.344,0-5-0.268-5,2.107v30.15c0,2.379,2.655,6.742,5,6.742h31.861\r\n\t\tc2.345,0,1.14-4.363,1.14-6.742V5.723C41.434,3.349,42.639,3.616,40.294,3.616z M32.434,12.648c0,0.032,0.733,0.058,0.405,0.1\r\n\t\tc-1.443,0.175-1.94,0.697-2.935,1.75c-0.907,0.965-1.46,5.118-1.471,5.118c1.318,0,3,0,3,0s0,1.904,0,3.411\r\n\t\tc0,0.279,0.48,0.279,0.211,0.279c-1.854,0-3.472,0.005-5.327-0.004c-0.185,0-2.021,4.171-3.264,5.973\r\n\t\tc-1.604,2.322-3.751,3.743-6.466,4.349c-0.958,0.211-1.912,0.293-2.884,0.334c-0.165,0.01-0.211-0.037-0.208-0.209\r\n\t\tc0.005-1.56,0.008-3.123,0.003-4.688c0-0.164-0.555-0.307-0.304-0.264c-0.071,0.017-0.763,0.029-0.763,0.039\r\n\t\tc0,0.017,0,0.035,0,0.052c0,0,0.84,0.006,0.976,0c1.58-0.095,3.26-0.655,4.381-1.808c0.363-0.371,1.791-2.267,2.105-2.807\r\n\t\tc0.19-0.331,1.635-3.421,1.908-4.14c0.303-0.795,0.622-1.602,0.922-2.397c0.116-0.309,0.833-1.83,0.908-1.97\r\n\t\tc0.409-0.755,0.816-1.517,1.245-2.267c0.239-0.421,0.508-0.83,0.797-1.216c1.607-2.158,3.362-3.726,5.941-4.406\r\n\t\tc0.938-0.249,0.815-0.551,0.815-0.551C32.434,10.478,32.434,10.964,32.434,12.648z\"/>\r\n</g>\r\n<g id=\"vector_5_\" display=\"none\">\r\n\t<g display=\"inline\">\r\n\t\t<g>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M22.957,5.179c-6.904,0-12.493,4.152-12.493,13.283v11.199c0,5.51,4.287,8.729,9.307,9.674\r\n\t\t\t\tc-2.807-1.61-5.027-5.127-5.027-10.25v-7.414c0-6.755,3.661-12.231,8.216-12.231c4.511,0,8.194,5.476,8.194,12.231v7.414\r\n\t\t\t\tc0,5.117-1.674,8.379-3.949,10.006c4.539-1.184,8.229-4.32,8.229-9.43V18.462C35.431,9.332,29.842,5.179,22.957,5.179z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M36.555,14.558H10.081c-1.828,0-2.969-0.675-2.969,1.121v11.903\r\n\t\tc0,1.795,1.141,3.498,2.969,3.498h26.474c1.827,0,2.228-1.703,2.228-3.498V15.679C38.782,13.882,38.381,14.558,36.555,14.558z\r\n\t\t M23.446,26.267c-2.219,0-4.017-1.798-4.017-4.015c0-2.219,1.798-4.017,4.017-4.017c2.218,0,4.016,1.798,4.016,4.017\r\n\t\tC27.461,24.469,25.664,26.267,23.446,26.267z\"/>\r\n</g>\r\n<g id=\"vector_3_\">\r\n\t<path d=\"M34.12,35.643c-0.285-0.025-0.573-0.048-0.889-0.048c-0.316-2.489,0.356-5.019-0.644-7.36\r\n\t\tc-0.976-2.29-2.576-4.057-4.304-5.764c1.711-1.707,3.295-3.446,4.281-5.69c1.018-2.311,0.364-4.787,0.662-7.279\r\n\t\tc0.335,0,0.601,0.018,0.859-0.004c0.817-0.067,1.342-0.619,1.35-1.414c0.01-0.827-0.537-1.275-1.402-1.332\r\n\t\tc-0.146-0.009-22.139-0.014-22.342,0.013c-0.752,0.097-1.237,0.607-1.234,1.37c0.005,0.765,0.497,1.277,1.256,1.352\r\n\t\tc0.399,0.042,0.805,0.007,1.313,0.007c0,1.422,0.023,2.749-0.004,4.078c-0.042,1.875,0.456,3.582,1.513,5.056\r\n\t\tc0.982,1.371,2.086,2.644,3.17,4.005c-1.609,1.622-3.17,3.37-4.118,5.636c-0.979,2.338-0.324,4.838-0.646,7.312\r\n\t\tc-0.499,0-0.945-0.062-1.371,0.014c-0.684,0.121-1.09,0.594-1.106,1.348c-0.021,0.801,0.391,1.615,1.109,1.792\r\n\t\tc0.195,0.048,22.397,0.039,22.514,0.029c0.815-0.072,1.342-0.796,1.349-1.589C35.445,36.379,34.926,35.715,34.12,35.643z\r\n\t\t M17.009,10.403c3.966,0,7.907,0,11.875,0c0.169,0,0.1,3.687-0.472,4.513c-1.547,2.235-3.539,4.395-5.545,6.213\r\n\t\tc-1.979-1.691-3.883-4.215-5.326-6.393C16.936,13.819,16.829,10.403,17.009,10.403z M28.885,34.517c-3.967,0-7.907,0-11.875,0\r\n\t\tc-0.169,0-0.1-3.386,0.472-4.211c1.547-2.235,3.539-3.772,5.545-5.591c1.979,1.691,3.883,3.518,5.326,5.695\r\n\t\tC28.959,31.327,29.065,34.517,28.885,34.517z\"/>\r\n</g>\r\n<g id=\"vector_1_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.479,43.969c-1.006,0.992-2.636,0.992-3.642,0L1.413,5.136\r\n\t\tc-1.004-0.994-1.004-2.599,0-3.589c1.008-0.993,2.636-0.993,3.643,0L44.48,40.385C45.485,41.377,45.485,42.98,44.479,43.969z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M16.546,34.493c-0.961,0.01-1.326-0.262-1.325-1.27c0.016-3.178,0.046-5.826,0.004-8.35l-3.792-3.853\r\n\t\t\tc0,1.537,0,2.963,0,4.159c0,0-0.247,9.863-0.241,14.75c0,2.994,0.761,4.139,3.773,4.146c5.258,0.014,10.425,0.112,15.686,0.116\r\n\t\t\tc1.493,0,2.451-0.313,3.038-1.028l-8.815-8.686C22.1,34.465,19.314,34.467,16.546,34.493z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M28.656,11.656c0.994-0.007,1.321,0.32,1.311,1.29c-0.022,2.392,0.016,4.782,0.019,7.179l4.448,4.355\r\n\t\t\tc0-4.402,0-8.798,0-13.204c0-3.002-0.978-3.934-3.993-3.937c-4.484-0.018-8.98-0.018-13.465-0.02l4.396,4.34\r\n\t\t\tC23.802,11.673,26.227,11.682,28.656,11.656z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"Layer_7\" display=\"none\">\r\n</g>\r\n</svg>";

var iconSimultaneousAccess = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"45.695px\" height=\"45.782px\" viewBox=\"0 0 45.695 45.782\" enable-background=\"new 0 0 45.695 45.782\" xml:space=\"preserve\">\r\n<g id=\"vector\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M45.272,38.282L45.272,38.282L24.659,5.224l0,0c-0.356-0.55-0.987-0.921-1.716-0.921\r\n\t\tc-0.722,0-1.351,0.367-1.707,0.916l0,0c-5.22,8.377-20.606,33.05-20.606,33.05v0.004c-0.186,0.289-0.294,0.634-0.294,0.999\r\n\t\tc0,1.07,0.898,1.939,2.015,1.939c0.027,0,0.054-0.008,0.082-0.008l0.004,0.008h41.085v-0.004c0.011,0,0.02,0.004,0.021,0.004\r\n\t\tc1.113,0,2.016-0.869,2.016-1.939C45.559,38.911,45.452,38.572,45.272,38.282z M24.174,13.673c1.476,0.464,2.424,1.896,2.221,3.591\r\n\t\tc-0.203,1.723-0.555,3.428-0.826,5.145c-0.323,2.036-0.624,4.071-0.951,6.185c-1.11,0-2.138,0-3.177,0\r\n\t\tc-0.347-2.168-0.673-4.303-1.031-6.431c-0.239-1.422-0.524-2.838-0.791-4.257C19.066,14.951,21.386,12.789,24.174,13.673z\r\n\t\t M22.98,37.174c-1.914,0-3.455-1.479-3.448-3.324c0.005-0.702,0.259-1.352,0.678-1.883c0.632-0.811,1.655-1.344,2.78-1.344\r\n\t\tc1.913-0.004,3.452,1.487,3.438,3.332C26.416,35.736,24.886,37.167,22.98,37.174z\"/>\r\n</g>\r\n<g id=\"vector_2_\">\r\n\t<path d=\"M44.886,44.697c-1.023,1.025-2.684,1.025-3.71,0L1.009,4.526c-1.026-1.021-1.026-2.685,0-3.707\r\n\t\tc1.023-1.028,2.684-1.028,3.709,0l40.168,40.168C45.912,42.013,45.912,43.67,44.886,44.697z\"/>\r\n\t<g>\r\n\t\t<path d=\"M23.341,6.386c0.821-0.008,1.574,0.409,1.568,1.217c-0.016,1.454-0.036,3.013-0.036,6.013c1.215,0,1.561,0,4.561,0\r\n\t\t\tc0-3,0-5.613,0-7.525c0-2.509-1.47-3.31-3.948-3.314c-4.139-0.012-8.458-0.012-12.601-0.017l3.582,3.64\r\n\t\t\tC18.776,6.412,21.035,6.409,23.341,6.386z\"/>\r\n\t\t<path d=\"M29.434,15.457c0,0,0,0,0,0.003c0-0.008,0.646-0.008,1.427-0.014c0.804-0.003,0.849,0.274,0.845,1.075\r\n\t\t\tc-0.02,1.672-0.08,3.349-0.094,5.021l3.6,3.628c0.022-3.341,0.037-6.678,0.037-10.02c0-2.507-0.671-3.314-3.149-3.317\r\n\t\t\tc-1.263-0.004-2.558-0.001-3.539-0.004l0,0c-1.379-0.002-2.719-0.005-4.094-0.005c-0.688,0-1.641,0.028-2.569,0.061l3.726,3.494\r\n\t\t\tC26.836,15.403,27.434,15.464,29.434,15.457z\"/>\r\n\t\t<path d=\"M28.083,37.331c-0.903-0.008-1.809-0.02-2.708-0.02c-1.645,0-2.94,0.029-4.583,0.025\r\n\t\t\tc-1.747-0.004-1.738-0.754-1.738-0.754c0.004-5,0.155-4.457,0.155-6.563l-3.886-4.667c0.027,1.189,0.095,2.059,0.122,3.268\r\n\t\t\tc-0.804,0.006-1.816,0.084-2.274,0.088c-0.792,0.013-1.008-0.559-1.002-1.401c0.008-1.923,0.022-3.892,0.034-5.81l-3.516-3.538\r\n\t\t\tc-0.019,0.509-0.026,0.797-0.026,0.797c0,3.753-0.001,7.828,0.004,11.912c0,2.504,0.535,3.131,3.02,3.138\r\n\t\t\tc0.865,0.003,2.8-0.075,3.925-0.124c0.058,2.576,0.097,4.729,0.098,5.886c0,2.192,0.6,2.985,2.413,3.177\r\n\t\t\tc0.258,0.028,0.542-0.002,0.853-0.002c4.332,0.014,8.662-0.01,12.994-0.007c0.531,0,0.977-0.055,1.36-0.161L28.083,37.331z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"vector_4_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M38.618,3.387H6.309c-1.657,0-3,1.343-3,3v33.008c0,1.658,1.343,3,3,3h32.311\r\n\t\tc1.656,0,3-1.342,3-3V6.387C41.618,4.73,40.275,3.387,38.618,3.387z M32.371,13.745c0,0.032-1.535,0.748-2.529,1.801\r\n\t\tc-0.908,0.965-1.46,5.07-1.471,5.07c1.317,0,3.062,0,3.062,0s0,2.001,0,3.507c0,0.279-3.292,0.285-5.146,0.275\r\n\t\tc-0.186,0-2.037,4.171-3.279,5.973c-1.604,2.322-3.759,3.744-6.474,4.349c-0.958,0.211-1.916,0.294-2.889,0.335\r\n\t\tc-0.165,0.01-1.338-0.17-1.334-0.342c0.005-1.561,0.039-3.123,0.034-4.688c0-0.164,0.089-0.103,0.089-0.092\r\n\t\tc0,0.017,0,0.036,0,0.052c1,0.104,4.33-0.785,5.325-1.809c0.364-0.37,1.775-2.266,2.091-2.805c0.19-0.332,1.627-3.421,1.9-4.141\r\n\t\tc0.303-0.795,0.618-1.602,0.918-2.397c0.116-0.309,0.831-1.83,0.906-1.97c0.408-0.755,0.814-1.517,1.243-2.267\r\n\t\tc0.239-0.421,0.509-0.83,0.798-1.216c1.606-2.158,3.36-3.726,5.94-4.406c0.938-0.249,0.938-0.249,0.938-0.249\r\n\t\tC32.493,11.876,32.371,12.061,32.371,13.745z\"/>\r\n</g>\r\n<g id=\"vector_5_\" display=\"none\">\r\n\t<g display=\"inline\">\r\n\t\t<g>\r\n\t\t\t<path fill=\"#CCCBCB\" d=\"M22.957,4.179c-6.904,0-12.493,4.152-12.493,13.283v11.199c0,5.51,4.287,8.729,9.307,9.674\r\n\t\t\t\tc-2.807-1.61-5.027-5.127-5.027-10.25v-7.414c0-6.755,3.661-12.231,8.216-12.231c4.511,0,8.194,5.476,8.194,12.231v7.414\r\n\t\t\t\tc0,5.117-1.674,8.379-3.949,10.006c4.539-1.184,8.229-4.32,8.229-9.43V17.462C35.431,8.332,29.842,4.179,22.957,4.179z\"/>\r\n\t\t</g>\r\n\t</g>\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M36.555,23.558H10.081c-1.828,0-2.969-0.675-2.969,1.121v11.903\r\n\t\tc0,1.795,1.141,3.498,2.969,3.498h26.474c1.827,0,2.228-1.703,2.228-3.498V24.679C38.782,22.882,38.381,23.558,36.555,23.558z\r\n\t\t M23.446,35.267c-2.219,0-4.017-1.798-4.017-4.015c0-2.219,1.798-4.018,4.017-4.018c2.218,0,4.016,1.799,4.016,4.018\r\n\t\tC27.461,33.469,25.664,35.267,23.446,35.267z\"/>\r\n</g>\r\n<g id=\"vector_3_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M34.12,35.643c-0.285-0.025-0.573-0.048-0.889-0.048c-0.316-2.489,0.356-5.019-0.644-7.36\r\n\t\tc-0.976-2.29-2.576-4.057-4.304-5.764c1.711-1.707,3.295-3.446,4.281-5.69c1.018-2.311,0.364-4.787,0.662-7.279\r\n\t\tc0.335,0,0.601,0.018,0.859-0.004c0.817-0.067,1.342-0.619,1.35-1.414c0.01-0.827-0.537-1.275-1.402-1.332\r\n\t\tc-0.146-0.009-22.139-0.014-22.342,0.013c-0.752,0.097-1.237,0.607-1.234,1.37c0.005,0.765,0.497,1.277,1.256,1.352\r\n\t\tc0.399,0.042,0.805,0.007,1.313,0.007c0,1.422,0.023,2.749-0.004,4.078c-0.042,1.875,0.456,3.582,1.513,5.056\r\n\t\tc0.982,1.371,2.086,2.644,3.17,4.005c-1.609,1.622-3.17,3.37-4.118,5.636c-0.979,2.338-0.324,4.838-0.646,7.312\r\n\t\tc-0.499,0-0.945-0.062-1.371,0.014c-0.684,0.121-1.09,0.594-1.106,1.348c-0.021,0.801,0.391,1.615,1.109,1.792\r\n\t\tc0.195,0.048,22.397,0.039,22.514,0.029c0.815-0.072,1.342-0.796,1.349-1.589C35.445,36.379,34.926,35.715,34.12,35.643z\r\n\t\t M17.009,10.403c3.966,0,7.907,0,11.875,0c0.169,0,0.1,3.687-0.472,4.513c-1.547,2.235-3.539,4.395-5.545,6.213\r\n\t\tc-1.979-1.691-3.883-4.215-5.326-6.393C16.936,13.819,16.829,10.403,17.009,10.403z M28.885,34.517c-3.967,0-7.907,0-11.875,0\r\n\t\tc-0.169,0-0.1-3.386,0.472-4.211c1.547-2.235,3.539-3.772,5.545-5.591c1.979,1.691,3.883,3.518,5.326,5.695\r\n\t\tC28.959,31.327,29.065,34.517,28.885,34.517z\"/>\r\n</g>\r\n<g id=\"vector_1_\" display=\"none\">\r\n\t<path display=\"inline\" fill=\"#CCCBCB\" d=\"M44.479,43.969c-1.006,0.992-2.636,0.992-3.642,0L1.413,5.136\r\n\t\tc-1.004-0.994-1.004-2.599,0-3.589c1.008-0.993,2.636-0.993,3.643,0L44.48,40.385C45.485,41.377,45.485,42.98,44.479,43.969z\"/>\r\n\t<g display=\"inline\">\r\n\t\t<path fill=\"#CCCBCB\" d=\"M16.546,34.493c-0.961,0.01-1.326-0.262-1.325-1.27c0.016-3.178,0.046-5.826,0.004-8.35l-3.792-3.853\r\n\t\t\tc0,1.537,0,2.963,0,4.159c0,0-0.247,9.863-0.241,14.75c0,2.994,0.761,4.139,3.773,4.146c5.258,0.014,10.425,0.112,15.686,0.116\r\n\t\t\tc1.493,0,2.451-0.313,3.038-1.028l-8.815-8.686C22.1,34.465,19.314,34.467,16.546,34.493z\"/>\r\n\t\t<path fill=\"#CCCBCB\" d=\"M28.656,11.656c0.994-0.007,1.321,0.32,1.311,1.29c-0.022,2.392,0.016,4.782,0.019,7.179l4.448,4.355\r\n\t\t\tc0-4.402,0-8.798,0-13.204c0-3.002-0.978-3.934-3.993-3.937c-4.484-0.018-8.98-0.018-13.465-0.02l4.396,4.34\r\n\t\t\tC23.802,11.673,26.227,11.682,28.656,11.656z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"Layer_7\" display=\"none\">\r\n</g>\r\n</svg>";

var iconUnsupportedBrowser = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"94.054px\" height=\"58.925px\" viewBox=\"0 0 94.054 58.925\" enable-background=\"new 0 0 94.054 58.925\" xml:space=\"preserve\">\r\n<g>\r\n\t<path d=\"M89.057,0H13.051c-2.755,0-4.997,2.242-4.997,4.997v14.44C3.515,20.05,0,23.941,0,28.646v28.278c0,1.104,0.896,2,2,2\r\n\t\ts2-0.896,2-2V28.646c0-2.492,1.734-4.574,4.054-5.139v30.421c0,2.755,2.241,4.996,4.997,4.996h76.006\r\n\t\tc2.756,0,4.997-2.241,4.997-4.996V4.997C94.054,2.242,91.812,0,89.057,0z M23.054,3c1.105,0,2,0.896,2,2s-0.895,2-2,2\r\n\t\tc-1.104,0-2-0.896-2-2S21.95,3,23.054,3z M18.054,3c1.104,0,2,0.896,2,2s-0.896,2-2,2s-2-0.896-2-2S16.95,3,18.054,3z M13.054,3\r\n\t\tc1.104,0,2,0.896,2,2s-0.896,2-2,2s-2-0.896-2-2S11.95,3,13.054,3z M91.054,53.929c0,1.102-0.894,1.996-1.997,1.996H13.051\r\n\t\tc-1.103,0-1.997-0.895-1.997-1.996V23.663c2.062,0.728,3.552,2.676,3.552,4.983c0,1.104,0.896,2,2,2s2-0.896,2-2\r\n\t\tc0-4.531-3.257-8.311-7.552-9.133V10h80V53.929z M91.054,6c0,0.552-0.447,1-1,1h-61c-0.552,0-1-0.448-1-1V4c0-0.552,0.448-1,1-1h61\r\n\t\tc0.553,0,1,0.448,1,1V6z\"/>\r\n\t<path d=\"M55.14,37.386c-0.828,0-1.5,0.672-1.5,1.5c0,1.379-1.121,2.5-2.5,2.5s-2.5-1.121-2.5-2.5c0-0.828-0.672-1.5-1.5-1.5\r\n\t\tc-0.829,0-1.5,0.672-1.5,1.5c0,3.032,2.468,5.5,5.5,5.5s5.5-2.468,5.5-5.5C56.64,38.058,55.968,37.386,55.14,37.386z\"/>\r\n\t<path d=\"M21.921,23.039c3.199,0,5.802,2.604,5.802,5.804c0,4.854,3.951,8.805,8.808,8.805c4.854,0,8.803-3.95,8.803-8.805\r\n\t\tc0-3.2,2.604-5.804,5.805-5.804c3.199,0,5.803,2.604,5.803,5.804c0,4.854,3.949,8.805,8.804,8.805s8.804-3.95,8.804-8.805\r\n\t\tc0-3.2,2.604-5.804,5.804-5.804c0.828,0,1.5-0.671,1.5-1.5s-0.672-1.5-1.5-1.5c-3.038,0-5.721,1.547-7.304,3.894\r\n\t\tc-1.583-2.347-4.266-3.894-7.304-3.894s-5.721,1.547-7.304,3.894c-1.583-2.347-4.266-3.894-7.303-3.894\r\n\t\tc-3.038,0-5.722,1.547-7.305,3.894c-1.583-2.347-4.265-3.894-7.303-3.894c-3.039,0-5.724,1.547-7.307,3.895\r\n\t\tc-1.583-2.348-4.265-3.895-7.303-3.895c-0.829,0-1.5,0.671-1.5,1.5S21.093,23.039,21.921,23.039z M65.745,23.039\r\n\t\tc3.2,0,5.804,2.604,5.804,5.804c0,3.201-2.604,5.805-5.804,5.805s-5.804-2.604-5.804-5.805\r\n\t\tC59.941,25.643,62.545,23.039,65.745,23.039z M36.531,23.039c3.2,0,5.803,2.604,5.803,5.804c0,3.201-2.603,5.805-5.803,5.805\r\n\t\tc-3.202,0-5.808-2.604-5.808-5.805C30.724,25.643,33.329,23.039,36.531,23.039z\"/>\r\n\t<path d=\"M21.921,30.343h2.937c0.829,0,1.5-0.672,1.5-1.5s-0.671-1.5-1.5-1.5h-2.937c-0.829,0-1.5,0.672-1.5,1.5\r\n\t\tS21.093,30.343,21.921,30.343z\"/>\r\n\t<path d=\"M80.353,27.343h-2.938c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5h2.938c0.828,0,1.5-0.672,1.5-1.5\r\n\t\tS81.181,27.343,80.353,27.343z\"/>\r\n\t<path d=\"M78.476,31.036c-0.586-0.586-1.535-0.586-2.121,0s-0.586,1.535,0,2.121l1.492,1.492c0.293,0.293,0.677,0.439,1.061,0.439\r\n\t\ts0.768-0.146,1.061-0.439c0.586-0.586,0.586-1.535,0-2.121L78.476,31.036z\"/>\r\n\t<path d=\"M23.797,31.037l-1.49,1.492c-0.585,0.586-0.584,1.535,0.001,2.121c0.293,0.292,0.676,0.438,1.06,0.438\r\n\t\tc0.384,0,0.769-0.146,1.062-0.44l1.49-1.492c0.585-0.586,0.584-1.535-0.001-2.121C25.333,30.45,24.383,30.449,23.797,31.037z\"/>\r\n</g>\r\n</svg>";

var iconWrongTime = "<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><path d=\"M11.99 2C17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12S6.47 2 11.99 2zM12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm.5-13v5.25l4.5 2.67-.75 1.23L11 13V7h1.5z\" fill=\"#FFF\" fill-rule=\"nonzero\"/></g></svg>";

var Errors = {
  DEFAULT_ERROR: _objectSpread2(_objectSpread2({}, Errors$2.DEFAULT_ERROR), {}, {
    UI: {
      title: 'N&#227;o foi poss&#237;vel exibir o v&#237;deo.',
      message: 'Ocorreu um problema ao tentar carregar o v&#237;deo. ' + '<a class="player-error__link"  href="" onclick="window.location.reload(); return false;">Atualize</a> a sua p&#225;gina para tentar novamente.',
      className: 'default-error',
      icon: iconErrorDefault
    }
  })
};
Errors = _objectSpread2(_objectSpread2({}, Errors), {}, {
  AUTH_REQUIRED: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.AUTH_REQUIRED), {}, {
    UI: {
      title: 'Faça seu login para assistir aos conteúdos exclusivos.',
      message: 'Alguns vídeos podem ser restritos a assinantes.',
      className: 'auth-required',
      icon: iconSubscriberOnly
    }
  }),
  DEVICE_NOT_AUTHORIZED: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.DEVICE_NOT_AUTHORIZED), {}, {
    UI: {
      title: 'Dispositivo n&#227;o autorizado.',
      message: 'Voc&#234; precisa cadastrar seu dispositivo para ter acesso ao conte&#250;do exclusivo.',
      className: 'unsupported-device',
      icon: iconUnsupportedDevice
    }
  }),
  DEVICE_NOT_SUPPORTED: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.DEVICE_NOT_SUPPORTED), {}, {
    UI: {
      title: 'Dispositivo n&#227;o suportado.',
      message: 'Infelizmente, n&#227;o foi poss&#237;vel encontrar um v&#237;deo compat&#237;vel com o seu dispositivo.',
      className: 'unsupported-device',
      icon: iconUnsupportedDevice
    }
  }),
  GEOFENCING: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.GEOFENCING), {}, {
    UI: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR.UI), {}, {
      title: 'O vídeo não está disponível nesta localidade',
      icon: iconGeoblocking
    })
  }),
  GEO_BLOCKED: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.GEO_BLOCKED), {}, {
    UI: {
      title: 'V&#237;deo indispon&#237;vel nessa regi&#227;o',
      message: 'Este v&#237;deo n&#227;o est&#225; dispon&#237;vel para ser exibido na sua regi&#227;o. Desculpe-nos pelo inconveniente.',
      className: 'geoblocking',
      icon: iconGeoblocking
    }
  }),
  HASH_LOAD_ERROR: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.HASH_LOAD_ERROR),
  PLAYER_NOT_RECOGNIZED: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.PLAYER_NOT_RECOGNIZED),
  RESOURCE_LOAD_ERROR: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.RESOURCE_LOAD_ERROR),
  LOCATION_UNAVAILABLE: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.LOCATION_UNAVAILABLE), {}, {
    UI: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR.UI), {}, {
      title: 'Conteúdo disponível apenas com informação de localização.',
      icon: iconGeoblocking
    })
  }),
  NOT_ALLOWED_DOMAIN: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.NOT_ALLOWED_DOMAIN),
  NOT_FOUND: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.NOT_FOUND), {}, {
    UI: {
      title: 'Conte&#250;do n&#227;o dispon&#237;vel.',
      message: 'Infelizmente este v&#237;deo n&#227;o est&#225; mais dispon&#237;vel. Desculpe-nos pelo inconveniente.',
      className: 'default-error',
      // the right icon is not available yet
      icon: iconErrorDefault
    }
  }),
  PLAYLIST_LOAD_ERROR: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.PLAYLIST_LOAD_ERROR), {}, {
    UI: _objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR.UI), {}, {
      title: 'Erro ao carregar o recurso de v&#237;deo.'
    })
  }),
  RESTRICTED_CONTENT: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.RESTRICTED_CONTENT), {}, {
    UI: {
      title: 'Conteúdo restrito.',
      message: 'O vídeo não está autorizado a ser exibido.',
      className: 'default-error',
      icon: iconErrorDefault
    }
  }),
  SIMULTANEOUS_ACCESS: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.SIMULTANEOUS_ACCESS), {}, {
    UI: {
      title: 'Acesso Simult&#226;neo.',
      message: 'Existem muitas sess&#245;es ativas utilizando esta conta. Por favor, pare de assistir em algum dispositivo para continuar.',
      className: 'simultaneous-access',
      icon: iconSimultaneousAccess
    }
  }),
  STREAMING_PAUSE_TIME_EXPIRED: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.STREAMING_PAUSE_TIME_EXPIRED), {}, {
    UI: {
      title: 'Sess&#227;o expirada.',
      message: 'O v&#237;deo ficou pausado por muito tempo. Para voltar a assistir, <a class="player-error__link" href="" onclick="window.location.reload(); return false;">atualize</a> a p&#225;gina.',
      className: 'time-expired',
      icon: iconPauseTimeExpired
    }
  }),
  SUBSCRIBERS_ONLY: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.SUBSCRIBERS_ONLY), {}, {
    UI: {
      title: 'Conte&#250;do exclusivo para assinantes.',
      message: 'Voc&#234; precisa ser assinante para ter acesso ao conte&#250;do.',
      className: 'subscriber-only',
      icon: iconSubscriberOnly
    }
  }),
  UNSUPPORTED_BROWSER: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.UNSUPPORTED_BROWSER), {}, {
    UI: {
      title: 'Seu navegador est&#225; velhinho.',
      message: 'Para assistir aos nossos v&#237;deos, por favor, atualize-o para uma vers&#227;o mais nova.',
      className: 'unsupported-browser',
      icon: iconUnsupportedBrowser
    }
  }),
  UNSUPPORTED_MOBILE_DEVICE: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.UNSUPPORTED_MOBILE_DEVICE), {}, {
    UI: {
      title: 'Dispositivo n&#227;o suportado.',
      message: 'Infelizmente, n&#227;o foi poss&#237;vel encontrar um v&#237;deo compat&#237;vel com o seu dispositivo.',
      className: 'unsupported-device',
      icon: iconUnsupportedDevice
    }
  }),
  TIMESTAMP_ERROR: _objectSpread2(_objectSpread2(_objectSpread2({}, Errors.DEFAULT_ERROR), Errors$2.TIMESTAMP_ERROR), {}, {
    UI: {
      title: 'Relógio adiantado.',
      message: 'Para assistir, ajuste o horário do seu dispositivo conforme sua localização.',
      className: 'unsupported-device',
      icon: iconWrongTime
    }
  })
});
var Errors$1 = Errors;

var css_248z$l = ".clappr-player#wp3-player-0 .player-error {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  cursor: default;\n  color: #CCCACA;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%; }\n  .clappr-player#wp3-player-0 .player-error__background-overlay {\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    position: absolute;\n    top: 0; }\n  .clappr-player#wp3-player-0 .player-error__link, .clappr-player#wp3-player-0 .player-error__link:visited {\n    color: #CCCACA; }\n  .clappr-player#wp3-player-0 .player-error__content {\n    position: relative;\n    line-height: 1.4; }\n  .clappr-player#wp3-player-0 .player-error__title {\n    color: #CCCACA;\n    font-weight: bold;\n    font-size: 18px; }\n  .clappr-player#wp3-player-0 .player-error__description {\n    color: #CCCACA;\n    width: 90%;\n    margin: 0 auto;\n    font-size: 14px; }\n  .clappr-player#wp3-player-0 .player-error__icon svg {\n    width: 30px;\n    max-height: 30px;\n    fill: #ffffff; }\n  .clappr-player#wp3-player-0 .player-error__icon.unsupported-browser svg {\n    width: 40px; }\n  .clappr-player#wp3-player-0 .player-error--hide {\n    display: none; }\n";
styleInject(css_248z$l);

var templateHtml$5 = "<div class=\"player-error__background-overlay\"></div>\n<div class=\"player-error__content\">\n  <span class=\"player-error__icon <%= className %>\"><%= icon %></span>\n  <p class=\"player-error__title\"><%= title %></p>\n  <p class=\"player-error__description\"><%= message %></p>\n</div>\n";

var PluginEvents = {
  ERROR_SCREEN_SHOW: 'ERROR_SCREEN_SHOW',
  ERROR_SCREEN_HIDE: 'ERROR_SCREEN_HIDE'
};

var session = Utils$1.session;
Events$1.register(PluginEvents.ERROR_SCREEN_SHOW);
Events$1.register(PluginEvents.ERROR_SCREEN_HIDE);

var ErrorScreen = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(ErrorScreen, _UICorePlugin);

  var _super = _createSuper(ErrorScreen);

  _createClass(ErrorScreen, [{
    key: "name",
    get: function get() {
      return 'error_screen';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$5);
    }
  }, {
    key: "container",
    get: function get() {
      return this.core.getCurrentContainer();
    }
  }, {
    key: "playback",
    get: function get() {
      return this.core.getCurrentPlayback();
    }
  }, {
    key: "posterImage",
    get: function get() {
      return this.container && (this.container.getPlugin('poster') || {}).posterImage;
    }
  }, {
    key: "isRenewPossible",
    get: function get() {
      return !this.playback.isRenewingResource;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'player-error'
      };
    }
  }]);

  function ErrorScreen(core) {
    var _this;

    _classCallCheck(this, ErrorScreen);

    _this = _super.call(this, core);
    _this.playerId = _this.options.playerId;
    _this.errorCount = 0;
    return _this;
  }

  _createClass(ErrorScreen, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.ERROR, this.onError);
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.clearErrors);
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.error = null;
      this.errorCount = 0;
      this.$el.hide();
      this.core.trigger(Events$1.Custom.ERROR_SCREEN_HIDE);
    }
  }, {
    key: "onError",
    value: function onError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (error.level === PlayerError.Levels.FATAL && this.isRenewPossible) return;
      error = _objectSpread2(_objectSpread2({}, error), {}, {
        videoSessionId: session.getVideoSessionId(this.options.playerId)
      });

      if (error.level === PlayerError.Levels.FATAL && this.errorCount === 0) {
        this.errorCount += 1;
        this.error = error;
        this.showErrorScreen();
      }

      this.logError(error);
    }
  }, {
    key: "showErrorScreen",
    value: function showErrorScreen() {
      this.render();
      this.$el.show();
      this.core.trigger(Events$1.Custom.ERROR_SCREEN_SHOW);
    }
  }, {
    key: "logError",
    value: function logError(error) {
      switch (error.level) {
        case PlayerError.Levels.INFO:
          Log$1.info('player_error', '', error);
          break;

        case PlayerError.Levels.WARN:
          Log$1.warn('player_error', '', error);
          break;

        case PlayerError.Levels.FATAL:
        default:
          Log$1.error('player_error', '', error);
      }
    }
  }, {
    key: "setPoster",
    value: function setPoster() {
      var isRestrictedContentCode = this.error.code === Errors$1.RESTRICTED_CONTENT.code;

      if (!isRestrictedContentCode && this.posterImage) {
        this.$el.css({
          'background-image': 'url(' + this.posterImage + ')'
        });
      }
    }
  }, {
    key: "getErrorUI",
    value: function getErrorUI(errorCode) {
      var errorData = Object.values(Errors$1).find(function (error) {
        return error.code === errorCode;
      });
      var errorUI = errorData && errorData.UI || Errors$1.DEFAULT_ERROR.UI;
      return errorUI;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.error) return;
      Object.assign(this.error.UI, this.getErrorUI(this.error.code));
      var style = Styler.getStyleFrom(css_248z$l, {
        playerId: this.playerId
      });
      this.$el.html(this.template(_objectSpread2({}, this.error.UI)));
      this.setPoster();
      this.$el.append(style[0]);
      this.core.$el.append(this.el);
      return this;
    }
  }]);

  return ErrorScreen;
}(UICorePlugin);

var css_248z$m = ".clappr-player#wp3-player-0 .container-overlay {\n  width: 100%;\n  z-index: 2; }\n  .clappr-player#wp3-player-0 .container-overlay--hidden {\n    visibility: hidden; }\n\n.clappr-player#wp3-player-0 .media-control::after {\n  height: 0; }\n";
styleInject(css_248z$m);

var Overlay = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(Overlay, _UICorePlugin);

  var _super = _createSuper(Overlay);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _super.apply(this, arguments);
  }

  _createClass(Overlay, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.core, Events$1.CORE_READY, this.initPlugins);
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.bindContainerEvents();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.bindAdEvents();
    }
  }, {
    key: "bindAdEvents",
    value: function bindAdEvents() {
      this.listenTo(this.container, Events.DFP_AD_STARTED, this.disableVisibility);
      this.listenTo(this.container, Events.DFP_AD_COMPLETED, this.enableVisibility);
      this.listenTo(this.container, Events.DFP_AD_CLOSED, this.enableVisibility);
      this.listenTo(this.container, Events.DFP_AD_SKIPPED, this.enableVisibility);
    }
  }, {
    key: "disableVisibility",
    value: function disableVisibility() {
      this.$el.addClass("".concat(this.internalName, "--hidden"));
    }
  }, {
    key: "enableVisibility",
    value: function enableVisibility() {
      this.$el.removeClass("".concat(this.internalName, "--hidden"));
    }
  }, {
    key: "filterItems",
    value: function filterItems(plugin) {
      return plugin instanceof Overlay && plugin !== this;
    }
  }, {
    key: "initPlugins",
    value: function initPlugins() {
      var _this = this;

      var renderPlugin = function renderPlugin(plugin) {
        return _this.renderPlugin(plugin);
      };

      var filterItems = function filterItems(plugin) {
        return _this.filterItems(plugin);
      };

      this.corePlugins.filter(filterItems).forEach(renderPlugin);
    }
  }, {
    key: "renderPlugin",
    value: function renderPlugin(plugin) {
      var el = plugin.el;
      this.$el.append(el);
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.empty();
      var style = Styler.getStyleFrom(css_248z$m, {
        playerId: this.playerId
      });
      this.$el.append(style[0]);
      this.core.$el.append(this.el);
      this.triggerDidShowOverlay();
      return this;
    }
  }, {
    key: "triggerDidShowOverlay",
    value: function triggerDidShowOverlay() {
      this.core.trigger(Events.DID_SHOW_OVERLAY);
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'overlay';
    }
  }, {
    key: "internalName",
    get: function get() {
      return 'container-overlay';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": "".concat(this.internalName)
      };
    }
  }, {
    key: "playerId",
    get: function get() {
      return this.options.playerId;
    }
  }, {
    key: "corePlugins",
    get: function get() {
      return this.core.plugins;
    }
  }]);

  return Overlay;
}(UICorePlugin);

var css_248z$n = ":root {\n  --player-drawer-hint-size: heightHint; }\n\n.clappr-player#wp3-player-0 .drawer--bottom {\n  display: flex;\n  width: 100%;\n  position: absolute;\n  bottom: calc(-100% + var(--player-drawer-hint-size));\n  height: 100%;\n  background: transparent;\n  z-index: 9999;\n  will-change: transform, opacity;\n  transform: translateY(0);\n  transition-property: opacity, transform;\n  transition-duration: 0.3s; }\n  .clappr-player#wp3-player-0 .drawer--bottom * {\n    pointer-events: none; }\n  .clappr-player#wp3-player-0 .drawer--bottom:hover {\n    transform: translateY(-12px);\n    transition: transform 0.3s; }\n  .clappr-player#wp3-player-0 .drawer--bottom-expand {\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0, rgba(0, 0, 0, 0.8) 100%);\n    transform: translateY(heightImmersion);\n    transition: transform 0.3s; }\n    .clappr-player#wp3-player-0 .drawer--bottom-expand * {\n      pointer-events: auto; }\n    .clappr-player#wp3-player-0 .drawer--bottom-expand:hover {\n      transform: translateY(heightImmersion); }\n    .clappr-player#wp3-player-0 .drawer--bottom-expand:before {\n      content: '';\n      position: absolute;\n      top: -100%;\n      height: 100%;\n      width: 100%;\n      background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 32px); }\n    .clappr-player#wp3-player-0 .drawer--bottom-expand__collapse {\n      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0, rgba(0, 0, 0, 0.8) 100%); }\n      .clappr-player#wp3-player-0 .drawer--bottom-expand__collapse:hover {\n        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0, rgba(0, 0, 0, 0.8) 100%); }\n      .clappr-player#wp3-player-0 .drawer--bottom-expand__collapse:before {\n        content: '';\n        position: absolute;\n        top: -100%;\n        height: 100%;\n        width: 100%;\n        background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 32px); }\n    .clappr-player#wp3-player-0 .drawer--bottom-expand-with-header:before {\n      transition: visibility 0.3s ease, opacity 0.3s ease;\n      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.6) 100%); }\n  .clappr-player#wp3-player-0 .drawer--bottom-disabled {\n    display: none; }\n  .clappr-player#wp3-player-0 .drawer--bottom-hidden {\n    pointer-events: none;\n    opacity: 0;\n    transition: visibility 0.3s ease, opacity 0.3s ease; }\n    .clappr-player#wp3-player-0 .drawer--bottom-hidden:hover {\n      transition: visibility 0.3s ease, opacity 0.3s ease; }\n\n.clappr-player#wp3-player-0.fullscreen .drawer--bottom-expand {\n  transform: translateY(immersionFullScreen); }\n  .clappr-player#wp3-player-0.fullscreen .drawer--bottom-expand:hover {\n    transform: translateY(immersionFullScreen); }\n";
styleInject(css_248z$n);

var BREAKPOINT_WIDTH = '532px';
var IMMERSION_SIZE_PERCENTAGE = '50%';
var GRADIENT_HEAD_SIZE = '32px';
var MIN_HINT_SIZE = '24px';
var MAX_HINT_SIZE = '40px';
var HEADER_SIZE = '57px';
var THROTTLE_TIMING = 100;

var Drawer = /*#__PURE__*/function (_Overlay) {
  _inherits(Drawer, _Overlay);

  var _super = _createSuper(Drawer);

  _createClass(Drawer, [{
    key: "name",
    get: function get() {
      return 'drawer';
    }
  }, {
    key: "internalName",
    get: function get() {
      return 'drawer';
    }
  }, {
    key: "isExpanded",
    get: function get() {
      return this._isExpanded;
    },
    set: function set(expanded) {
      this._isExpanded = expanded;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': "".concat(this.internalName, " ").concat(this.internalName, "-hidden")
      };
    }
  }]);

  function Drawer(core) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _super.call(this, core);
    _this.lastChromelessValue = !!_this.options.chromeless;
    return _this;
  }

  _createClass(Drawer, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.bindMouseEvents();
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.onActiveContainerChanged);
      this.listenTo(this.core, Events$1.MEDIACONTROL_SHOW, this.showHint);
      this.listenTo(this.core, Events.WM_SHARE_HIDE, this.showHint);
      this.listenTo(this.core, Events.TAP_TO_UNMUTE_SHOW, this.showHint);
      this.listenTo(this.core, Events.TAP_TO_UNMUTE_CLICKED, this.onTapToUnmuteClicked);
      this.listenTo(this.core, Events.WM_SHARE_HIDE, this.bindMouseEvents);
      this.listenTo(this.core, Events$1.MEDIACONTROL_HIDE, this.hideHint);
      this.listenTo(this.core, Events.WM_SHARE_SHOW, this.unbindMouseEvents);
      this.listenTo(this.core, Events.WM_SHARE_SHOW, this.hideHint);
      this.listenTo(this.core, Events.DID_CLOSE_HEADER, this.hide);
      this.listenTo(this.core, Events.SYNC_DRAWER_STATE_REQUEST, this.currentState);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
      this.listenTo(this.core, Events$1.CORE_OPTIONS_CHANGE, this.onOptionsChange);
      this.listenTo(this.core, Events$1.ERROR, this.onError);
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.listenTo(this.container, Events.DFP_AD_STARTED, this.onDfpStarted);
      this.listenTo(this.container, Events.DFP_AD_SKIPPED, this.onDfpClose);
      this.listenTo(this.container, Events.DFP_AD_CLOSED, this.onDfpClose);
      this.listenTo(this.container, Events.DFP_AD_COMPLETED, this.onDfpClose);
    }
  }, {
    key: "onActiveContainerChanged",
    value: function onActiveContainerChanged() {
      this.container && this.stopListening(this.container);
      this.bindContainerEvents();
    }
  }, {
    key: "onDfpStarted",
    value: function onDfpStarted() {
      this.isDfpActive = true;
      this.isPreviouslyExpanded = this.isExpanded;
      this.hide();
      this.hideHint();
    }
  }, {
    key: "onDfpClose",
    value: function onDfpClose() {
      this.isDfpActive = false;
      this.isPreviouslyExpanded && this.show();
    }
  }, {
    key: "onOptionsChange",
    value: function onOptionsChange() {
      this.lastChromelessValue !== !!this.options.chromeless && this.updateChromelessState();
    }
  }, {
    key: "onError",
    value: function onError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (error.level === PlayerError.Levels.FATAL) this.showHint();
    }
  }, {
    key: "updateChromelessState",
    value: function updateChromelessState() {
      this.disableDrawer();

      if (this.options.chromeless === false) {
        this.hideHint();
        this.enableDrawer();
      }

      this.lastChromelessValue = this.options.chromeless;
    }
    /**
     * Because of class extension and bindEvents being called
     * before constructor variables is setted. enableVisitilityDebounced
     * was configured on bindMouseEvents method
    **/

  }, {
    key: "bindMouseEvents",
    value: function bindMouseEvents() {
      var _this2 = this;

      if (!this.enableVisibilityDebounced) {
        this.enableVisibilityDebounced = lodash_throttle(function () {
          return _this2.enableVisibility.apply(_this2, arguments);
        }, THROTTLE_TIMING, {
          trailing: false
        });
      }

      this.listenTo(this.core, Events$1.CORE_MOUSE_MOVE, this.enableVisibilityDebounced);
      this.listenTo(this.core, Events$1.CORE_MOUSE_LEAVE, this.hideDelayed);
    }
  }, {
    key: "unbindMouseEvents",
    value: function unbindMouseEvents() {
      this.stopListening(this.core, Events$1.CORE_MOUSE_MOVE, this.enableVisibilityDebounced);
      this.stopListening(this.core, Events$1.CORE_MOUSE_LEAVE, this.hideDelayed);
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isValidSize = size.width && typeof size.width === 'number';
      var sizeChanged = this.currentWidth !== size.width;
      if (!isValidSize || !sizeChanged) return;
      this.currentWidth = size.width;
      this.currentHeight = size.height;
      !this.lastChromelessValue && this.updateResponsiveStyle();
    }
  }, {
    key: "onTapToUnmuteClicked",
    value: function onTapToUnmuteClicked() {
      Browser.isMobile && this.hideHint();
    }
  }, {
    key: "updateResponsiveStyle",
    value: function updateResponsiveStyle() {
      if (this.shouldDisable) {
        this.disableDrawer();
      } else {
        this.enableDrawer();
      }
    }
  }, {
    key: "enableDrawer",
    value: function enableDrawer() {
      this.$el.removeClass("".concat(this.internalName, "-disabled"));
    }
  }, {
    key: "disableDrawer",
    value: function disableDrawer() {
      this.$el.addClass("".concat(this.internalName, "-disabled"));
    }
  }, {
    key: "showHint",
    value: function showHint() {
      if (!this.isVisible() && !this.isDfpActive) {
        this.$el.removeClass("".concat(this.internalName, "-hidden"));
        this.onDidShowDrawerHint();
      }
    }
  }, {
    key: "onDidShowDrawerHint",
    value: function onDidShowDrawerHint() {
      this.core.trigger(Events.DID_SHOW_DRAWER_HINT);
    }
  }, {
    key: "hideHint",
    value: function hideHint() {
      if (!this.isExpanded && this.isVisible()) {
        this.disableVisibility();
        this.onDidHideDrawerHint();
      }
    }
  }, {
    key: "onDidHideDrawerHint",
    value: function onDidHideDrawerHint() {
      this.core.trigger(Events.DID_HIDE_DRAWER_HINT);
    }
  }, {
    key: "disableVisibility",
    value: function disableVisibility() {
      this.$el.addClass("".concat(this.internalName, "-hidden"));
    }
  }, {
    key: "currentState",
    value: function currentState() {
      this.core.trigger(Events.SYNC_DRAWER_STATE_RESPONSE, this.isExpanded);
    }
  }, {
    key: "show",
    value: function show(e) {
      if (this.isExpanded) return;
      e && e.stopPropagation();
      this.isExpanded = true;
      this.hideDelayed();
      this.core.trigger(Events.WILL_SHOW_DRAWER);
      this.addExpandBackground();
      this.onDidShowDrawer();
    }
  }, {
    key: "onDidShowDrawer",
    value: function onDidShowDrawer() {
      this.core.trigger(Events.DID_SHOW_DRAWER);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;

      if (!this.isExpanded) return;
      this.isExpanded = false;
      this.core.trigger(Events.WILL_HIDE_DRAWER);
      this.$el.removeClass("".concat(this.internalName, "-expand")).on('transitionend', function () {
        _this3.$el.removeClass("".concat(_this3.internalName, "-expand__collapse")).off('transitionend');
      });
      this.onDidHideDrawer();
    }
  }, {
    key: "onDidHideDrawer",
    value: function onDidHideDrawer() {
      this.core.trigger(Events.DID_HIDE_DRAWER);
    }
  }, {
    key: "enableVisibility",
    value: function enableVisibility(e) {
      var _this4 = this;

      if (Browser.isMobile && e && e.type === 'mousemove') return;
      clearTimeout(this.hideId);
      this.hideId = setTimeout(function () {
        return _this4.hideDelayed();
      }, this.inactivityTimeout);
      if (this.isExpanded && this.isVisible()) return;
      this.showHint();
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return !this.$el.hasClass("".concat(this.internalName, "-hidden"));
    }
  }, {
    key: "hideDelayed",
    value: function hideDelayed(e) {
      var _this5 = this;

      if (!this.isExpanded || this.inactivityTimeout <= 0 || !this.isVisible() || Browser.supportsTouchEvents) return;
      clearTimeout(this.hideId);

      if (this.userKeepVisible || e && e.type === 'mouseout') {
        this.hideId = setTimeout(function () {
          return _this5.hideDelayed();
        }, this.inactivityTimeout);
      } else {
        !this.userKeepVisible && this.disableVisibility();
      }
    }
  }, {
    key: "resetUserKeepVisible",
    value: function resetUserKeepVisible() {
      if (!this.userKeepVisible) return;
      this.userKeepVisible = false;
    }
  }, {
    key: "setUserKeepVisible",
    value: function setUserKeepVisible() {
      if (this.userKeepVisible) return;
      this.userKeepVisible = true;
    }
  }, {
    key: "parseStyle",
    value: function parseStyle() {
      var parsedStyle = css_248z$n.toString();
      parsedStyle = parsedStyle.replace(/heightImmersion/g, this.expandOffset());
      parsedStyle = parsedStyle.replace(/immersionFullScreen/g, this.expandOffsetFullscreen());
      parsedStyle = parsedStyle.replace(/heightHint/g, this.effectiveHeightHint);
      return parsedStyle;
    }
  }, {
    key: "expandOffset",
    value: function expandOffset() {}
  }, {
    key: "expandOffsetFullscreen",
    value: function expandOffsetFullscreen() {}
  }, {
    key: "addExpandBackground",
    value: function addExpandBackground() {
      var _this6 = this;

      this.$el.addClass("".concat(this.internalName, "-expand")).on('transitionend', function () {
        _this6.$el.addClass("".concat(_this6.internalName, "-expand__collapse")).off('transitionend');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler.getStyleFrom(this.parseStyle(), {
        playerId: this.playerId
      });
      this.$el.html(this.content);
      this.$el.append(style[0]);
      this.core.trigger(Events.SHOW_DRAWER_REQUESTED);
      this.hasPlaceholder && this.core.trigger(Events.DRAWER_HAS_PLACEHOLDER, this.effectiveHeightHint);
      this.updateChromelessState();
      return this;
    }
  }, {
    key: "content",
    get: function get() {
      return this._content || '';
    },
    set: function set() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this._content = content;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height || 'inherit';
    },
    set: function set(value) {
      this._height = value;
    }
  }, {
    key: "heightImmersion",
    get: function get() {
      return IMMERSION_SIZE_PERCENTAGE;
    }
  }, {
    key: "heightImmersionUnit",
    get: function get() {
      return this.heightImmersion.includes('%') ? '%' : 'px';
    }
  }, {
    key: "heightHint",
    get: function get() {
      return MIN_HINT_SIZE;
    }
  }, {
    key: "headerHeight",
    get: function get() {
      return HEADER_SIZE;
    }
  }, {
    key: "hasHeader",
    get: function get() {
      return false;
    }
  }, {
    key: "hasPlaceholder",
    get: function get() {
      return false;
    }
  }, {
    key: "shouldDisable",
    get: function get() {
      return this.currentWidth < parseInt(BREAKPOINT_WIDTH, 10);
    }
  }, {
    key: "gradientHeadSize",
    get: function get() {
      return parseInt(GRADIENT_HEAD_SIZE, 10);
    }
  }, {
    key: "defaultExpandValues",
    get: function get() {
      return {
        drawerExpanded: IMMERSION_SIZE_PERCENTAGE,
        drawerHintSize: this.effectiveHeightHint
      };
    }
  }, {
    key: "effectiveHeightHint",
    get: function get() {
      var MIN_HINT_SIZE_VALUE = parseInt(this.heightHint, 10);
      if (!Number.isInteger(MIN_HINT_SIZE_VALUE)) return MIN_HINT_SIZE;
      if (MIN_HINT_SIZE_VALUE > parseInt(MAX_HINT_SIZE, 10)) return MAX_HINT_SIZE;
      if (MIN_HINT_SIZE_VALUE < parseInt(MIN_HINT_SIZE, 10)) return MIN_HINT_SIZE;
      return this.heightHint;
    }
  }, {
    key: "container",
    get: function get() {
      return this.core.activeContainer;
    }
  }, {
    key: "inactivityTimeout",
    get: function get() {
      return 2000;
    }
  }, {
    key: "events",
    get: function get() {
      var mobileEvents = {
        'click': 'toggle'
      };
      var desktopEvents = {
        'mouseenter': 'setUserKeepVisible',
        'mouseleave': 'resetUserKeepVisible',
        'click': 'toggle'
      };

      var hybridEvents = _objectSpread2(_objectSpread2(_objectSpread2({}, mobileEvents), desktopEvents), {}, {
        touchend: this.resetUserKeepVisible
      });

      return Browser.isHybridDevice ? hybridEvents : Browser.isMobile ? mobileEvents : desktopEvents;
    }
  }]);

  return Drawer;
}(Overlay);

var DrawerBottom = /*#__PURE__*/function (_Drawer) {
  _inherits(DrawerBottom, _Drawer);

  var _super = _createSuper(DrawerBottom);

  function DrawerBottom() {
    _classCallCheck(this, DrawerBottom);

    return _super.apply(this, arguments);
  }

  _createClass(DrawerBottom, [{
    key: "expandOffset",

    /**
     * It expands the Drawer between the specified and maxExpand available that will require a Header
     */
    value: function expandOffset() {
      return "max(".concat(this.specifiedExpandOffset(), ", ").concat(this.maxExpandOffset(), ") ");
    }
    /**
     * It expands the Drawer between the specified and maxExpand available that will require a Header for Fullscreen
     */

  }, {
    key: "expandOffsetFullscreen",
    value: function expandOffsetFullscreen() {
      if (this.heightImmersionUnit == 'px') {
        return "max(-".concat(this.specifiedExpandOffset(), ", ").concat(this.maxExpandOffset(), ") ");
      }

      return "max(".concat(this.specifiedExpandOffsetPercentageFullscreen(), ", ").concat(this.maxExpandOffset(), ") ");
    }
    /**
     * | Header         |________
     * | content head   |________maxExpandOffset
     * | content drawer |
     * | content drawer |________
     * It returns the max value that Drawer is able to translate over player in CSS calc string value
     * It is the top Y of Drawer content
     * @return {Strings} string with values to be the guard in calc
     */

  }, {
    key: "maxExpandOffset",
    value: function maxExpandOffset() {
      return "".concat(this.effectiveHeightHint, " + ").concat(this.headerSize());
    }
    /**
     * It returns the value specified by the plugin in percentage
     * @return {Strings} string with values to be used in CSS calc
     */

  }, {
    key: "specifiedExpandOffset",
    value: function specifiedExpandOffset() {
      return "".concat(this.effectiveHeightHint, " - ").concat(this.translateYValue());
    }
    /**
     * It returns the value specified by the plugin
     * @return {Strings} string with values to be used in CSS calc
     */

  }, {
    key: "specifiedExpandOffsetPercentageFullscreen",
    value: function specifiedExpandOffsetPercentageFullscreen() {
      return "-".concat(this.translateYValue());
    }
    /**           ________
     * | header  |________headerSize
     * | content |
     * | content |
     * It returns the max value that Drawer is able to translate over player in CSS calc string value
     * It is the top Y of Drawer content for Fullscreen mode
     * @return {Strings} string with values to be the guard in calc
     */

  }, {
    key: "headerSize",
    value: function headerSize() {
      return "".concat(this.headerHeight, "  - 100%");
    }
    /**
     * It returns the specified value in products getter that defines the drawer height.
     * It returns a translate to be applied in CSS variable
     */

  }, {
    key: "translateYValue",
    value: function translateYValue() {
      return "".concat(parseInt(this.heightImmersion, 10)).concat(this.heightImmersionUnit);
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      if (!e) return;

      if (!this.isExpanded) {
        _get(_getPrototypeOf(DrawerBottom.prototype), "show", this).call(this);
      } else {
        this.clickAtHideArea(e) && _get(_getPrototypeOf(DrawerBottom.prototype), "hide", this).call(this);
      }
    }
    /**           ________
     * | header  |________beforePseudoElement
     * | content |
     * | content |
     * It's the click inside the before pseudoelement area
     * @return {boolean} string with values to be the guard in calc
     */

  }, {
    key: "clickAtHideArea",
    value: function clickAtHideArea(e) {
      return e.clientY >= 0 && e.clientY <= this.drawerYPosition();
    }
    /**
     * Drawer top Y position
     * | header  |________drawerYPosition
     * | content |
     * | content |
     */

  }, {
    key: "drawerYPosition",
    value: function drawerYPosition() {
      return Math.round(this.$el[0].getBoundingClientRect().top) - 1;
    }
  }, {
    key: "name",
    get: function get() {
      return 'drawer_bottom';
    }
  }, {
    key: "internalName",
    get: function get() {
      return 'drawer--bottom';
    }
  }, {
    key: "hasPlaceholder",
    get: function get() {
      return true;
    }
  }]);

  return DrawerBottom;
}(Drawer);

var DrawerBottomHeader = /*#__PURE__*/function (_DrawerBottom) {
  _inherits(DrawerBottomHeader, _DrawerBottom);

  var _super = _createSuper(DrawerBottomHeader);

  function DrawerBottomHeader() {
    _classCallCheck(this, DrawerBottomHeader);

    return _super.apply(this, arguments);
  }

  _createClass(DrawerBottomHeader, [{
    key: "addExpandBackground",
    value: function addExpandBackground() {
      _get(_getPrototypeOf(DrawerBottomHeader.prototype), "addExpandBackground", this).call(this);

      this.$el.addClass("".concat(this.internalName, "-expand-with-header"));
      this.core.trigger(Events.SHOW_HEADER_REQUESTED, this.title);
    }
  }]);

  return DrawerBottomHeader;
}(DrawerBottom);

var css_248z$o = ".clappr-player#wp3-player-0 .drawer-header {\n  height: 57px;\n  left: 0px;\n  position: absolute;\n  width: 100%;\n  z-index: 999;\n  transform: translateY(0);\n  transition-property: opacity, transform;\n  transition-duration: 0.3s; }\n  .clappr-player#wp3-player-0 .drawer-header-modal--visible .media-control-panel__upper {\n    display: none; }\n  .clappr-player#wp3-player-0 .drawer-header-panel {\n    padding: 4px 4px 0;\n    position: relative; }\n    .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      position: relative; }\n      .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__left, .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__right {\n        display: flex;\n        flex-flow: row nowrap;\n        align-items: center; }\n        .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__left .drawer-header-element, .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__right .drawer-header-element {\n          padding: 12px;\n          will-change: opacity;\n          transition: visibility 0.3s ease, opacity 0.3s ease; }\n        .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__left .drawer-header-button, .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__right .drawer-header-button {\n          display: inline-block;\n          margin: 0;\n          border: 0;\n          cursor: pointer;\n          background-color: transparent;\n          text-align: center;\n          width: 24px;\n          height: 24px;\n          box-sizing: content-box;\n          transition: visibility 0.3s ease, opacity 0.3s ease; }\n      .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__left {\n        width: calc(100% - 48px); }\n        .clappr-player#wp3-player-0 .drawer-header-panel .opposites-container .drawer-header-position__left .drawer-header-title {\n          box-sizing: border-box;\n          color: #fff;\n          pointer-events: none;\n          text-align: left;\n          text-shadow: none;\n          transition: visibility 0.3s ease, opacity 0.3s ease;\n          overflow: hidden;\n          font-family: \"opensans-regular\";\n          letter-spacing: 0;\n          color: #fff;\n          text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n          margin-bottom: 6px;\n          font-size: 18px;\n          line-height: 24px;\n          white-space: nowrap;\n          text-overflow: ellipsis; }\n    .clappr-player#wp3-player-0 .drawer-header-panel--hidden {\n      display: none !important; }\n  .clappr-player#wp3-player-0 .drawer-header--hidden {\n    opacity: 0;\n    transform: translateY(100%);\n    transition: visibility 0.3s ease, opacity 0.3s ease;\n    z-index: 0; }\n";
styleInject(css_248z$o);

var pluginTemplate = "<div class=\"drawer-header-panel drawer-header-panel--hidden\">\n    <div class=\"opposites-container\">\n        <div class=\"drawer-header-position__left\">\n            <div class=\"drawer-header-element drawer-header-title\">\n                <%= title %>\n            </div>\n        </div>\n        <div class=\"drawer-header-position__right\">\n            <div class=\"drawer-header-element drawer-header-button\" data-controls data-close>\n                <div class=\"drawer-header__close\"><%= closeIcon %></div>\n            </div>\n        </div>\n    </div>\n</div>";

var DrawerHeader = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(DrawerHeader, _UICorePlugin);

  var _super = _createSuper(DrawerHeader);

  function DrawerHeader() {
    _classCallCheck(this, DrawerHeader);

    return _super.apply(this, arguments);
  }

  _createClass(DrawerHeader, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events.SHOW_HEADER_REQUESTED, this.showHeader);
      this.listenTo(this.core, Events.CLOSE_HEADER_REQUESTED, this.closeHeader);
    }
  }, {
    key: "bindCloseButton",
    value: function bindCloseButton() {
      var _this = this;

      var $headerClose = this.$el.find(".".concat(this.name, "__close"));
      $headerClose.on('click', function (e) {
        e && e.stopPropagation();

        _this.closeHeader();
      });
    }
  }, {
    key: "showHeader",
    value: function showHeader(title) {
      this.updateTitle(title);
      this.core.trigger(Events.WILL_SHOW_HEADER);
      this.show();
      this.core.trigger(Events.DID_SHOW_HEADER);
    }
  }, {
    key: "closeHeader",
    value: function closeHeader() {
      this.core.trigger(Events.WILL_CLOSE_HEADER);
      this.hide();
      this.core.trigger(Events.DID_CLOSE_HEADER);
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      this.title = title;
      this.$el.find(".".concat(this.name, "-title")).text(this.title);
    }
  }, {
    key: "show",
    value: function show() {
      this.core.trigger(Events.WILL_SHOW_MODAL_ELEMENT, {
        name: this.name
      });
      this.$el.find(".".concat(this.name, "-panel")).removeClass("".concat(this.name, "-panel--hidden"));
      this.$el.removeClass("".concat(this.name, "--hidden"));
    }
  }, {
    key: "hide",
    value: function hide() {
      this.core.trigger(Events.DID_HIDE_MODAL_ELEMENT, {
        name: this.name
      });
      this.$el.find(".".concat(this.name, "-panel")).addClass("".concat(this.name, "-panel--hidden"));
      this.$el.addClass("".concat(this.name, "--hidden"));
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler.getStyleFrom(css_248z$o, {
        playerId: this.core.options.playerId
      });
      this.$el.empty();
      this.$el.html(this.template({
        'title': this.title,
        closeIcon: closeIcon
      }));
      this.$el.append(style[0]);
      this.core.$el.append(this.el);
      this.bindCloseButton();
      return this;
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'drawer-header';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': "".concat(this.name, " ").concat(this.name, "--hidden")
      };
    }
  }, {
    key: "title",
    set: function set() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this._title = title;
    },
    get: function get() {
      return this._title;
    }
  }, {
    key: "template",
    get: function get() {
      return template(pluginTemplate);
    }
  }]);

  return DrawerHeader;
}(UICorePlugin);

var css_248z$p = ".clappr-player#wp3-player-0 .media-control-panel__front-layer .media-control-placeholder {\n  position: relative;\n  width: 100%;\n  height: 24px; }\n  .clappr-player#wp3-player-0 .media-control-panel__front-layer .media-control-placeholder.hidden {\n    visibility: hidden; }\n  .clappr-player#wp3-player-0 .media-control-panel__front-layer .media-control-placeholder.disabled {\n    display: none; }\n  .clappr-player#wp3-player-0 .media-control-panel__front-layer .media-control-placeholder.media-control-element {\n    padding: 0; }\n\n.clappr-player#wp3-player-0 .media-control.ad .media-control-placeholder {\n  display: none; }\n";
styleInject(css_248z$p);

var BREAKPOINT_WIDTH$1 = '532px';

var MediaControlPlaceHolder = /*#__PURE__*/function (_MediaControlPlugin) {
  _inherits(MediaControlPlaceHolder, _MediaControlPlugin);

  var _super = _createSuper(MediaControlPlaceHolder);

  function MediaControlPlaceHolder() {
    _classCallCheck(this, MediaControlPlaceHolder);

    return _super.apply(this, arguments);
  }

  _createClass(MediaControlPlaceHolder, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events.DRAWER_HAS_PLACEHOLDER, this.onDrawerHasPlaceholder);
      this.listenTo(this.core, Events$1.CORE_RESIZE, this.onPlayerResize);
    }
  }, {
    key: "onDrawerHasPlaceholder",
    value: function onDrawerHasPlaceholder() {
      this.hasDrawer = true;
      this.enablePlaceholder();
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isValidSize = size.width && typeof size.width === 'number';
      var sizeChanged = this.currentWidth !== size.width;
      if (!isValidSize || !sizeChanged) return;
      this.currentWidth = size.width;
      this.updateResponsiveStyle();
    }
  }, {
    key: "enablePlaceholder",
    value: function enablePlaceholder(height) {
      if (height && this.heightHint !== height) {
        this.$el.css({
          height: height
        });
      }

      this.$el.removeClass('disabled');
    }
  }, {
    key: "disablePlaceholder",
    value: function disablePlaceholder() {
      this.$el.addClass('disabled');
    }
  }, {
    key: "show",
    value: function show() {
      this.$el.removeClass('hidden');
    }
  }, {
    key: "updateResponsiveStyle",
    value: function updateResponsiveStyle() {
      if (!this.hasDrawer) return;

      if (this.shouldDisable) {
        this.disablePlaceholder();
      } else {
        this.enablePlaceholder();
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.empty();
      var style = Styler.getStyleFrom(css_248z$p, {
        playerId: this.core.options.playerId
      });
      this.$el.append(style[0]);
      return this;
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'media_control_placeholder';
    }
  }, {
    key: "panel",
    get: function get() {
      return 'front-layer';
    }
  }, {
    key: "position",
    get: function get() {
      return '';
    }
  }, {
    key: "heightHint",
    get: function get() {
      return 0;
    }
  }, {
    key: "shouldDisable",
    get: function get() {
      return this.currentWidth < parseInt(BREAKPOINT_WIDTH$1, 10);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'media-control-placeholder disabled hidden'
      };
    }
  }]);

  return MediaControlPlaceHolder;
}(MediaControlPlugin);

var clapprStats = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(require$$0);
})(window, function(__WEBPACK_EXTERNAL_MODULE__clappr_core__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "latest/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/clappr-stats.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/lodash.get/index.js":
/*!******************************************!*\
  !*** ./node_modules/lodash.get/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var _Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function (string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")));

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "./src/clappr-stats.js":
/*!*****************************!*\
  !*** ./src/clappr-stats.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(/*! @clappr/core */ "@clappr/core");

var _lodash = __webpack_require__(/*! lodash.get */ "./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClapprStats = function (_ContainerPlugin) {
  _inherits(ClapprStats, _ContainerPlugin);

  _createClass(ClapprStats, [{
    key: '_now',
    value: function _now() {
      var hasPerformanceSupport = window.performance && typeof window.performance.now === 'function';
      return hasPerformanceSupport ? window.performance.now() : new Date();
    }
  }, {
    key: '_inc',
    value: function _inc(counter) {
      this._metrics.counters[counter] += 1;
    }
  }, {
    key: '_timerHasStarted',
    value: function _timerHasStarted(timer) {
      return this['_start' + timer] !== undefined;
    }
  }, {
    key: '_start',
    value: function _start(timer) {
      this['_start' + timer] = this._now();
    }
  }, {
    key: '_stop',
    value: function _stop(timer) {
      this._metrics.timers[timer] += this._now() - this['_start' + timer];
    }
  }, {
    key: '_defaultReport',
    value: function _defaultReport(metrics) {
      console.log(metrics);
    } //eslint-disable-line no-console

  }, {
    key: 'name',
    get: function get() {
      return 'clappr_stats';
    }
  }, {
    key: 'supportedVersion',
    get: function get() {
      return { min: '0.4.2' };
    }
  }, {
    key: '_playbackName',
    get: function get() {
      return this.container.playback.name;
    }
  }, {
    key: '_playbackType',
    get: function get() {
      return this.container.getPlaybackType();
    }
  }]);

  function ClapprStats(container) {
    _classCallCheck(this, ClapprStats);

    var _this = _possibleConstructorReturn(this, (ClapprStats.__proto__ || Object.getPrototypeOf(ClapprStats)).call(this, container));

    _this._runEach = (0, _lodash2.default)(container, 'options.clapprStats.runEach', 5000);
    _this._onReport = (0, _lodash2.default)(container, 'options.clapprStats.onReport', _this._defaultReport);
    _this._uriToMeasureLatency = (0, _lodash2.default)(container, 'options.clapprStats.uriToMeasureLatency');
    _this._urisToMeasureBandwidth = (0, _lodash2.default)(container, 'options.clapprStats.urisToMeasureBandwidth');
    _this._runBandwidthTestEvery = (0, _lodash2.default)(container, 'options.clapprStats.runBandwidthTestEvery', 10);
    _this._bwMeasureCount = 0;

    _this._completion = {
      watch: (0, _lodash2.default)(container, 'options.clapprStats.onCompletion', []),
      calls: []
    };

    _this._newMetrics();
    _this.on(ClapprStats.REPORT_EVENT, _this._onReport);
    return _this;
  }

  _createClass(ClapprStats, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.container, _core.Events.CONTAINER_BITRATE, this.onBitrate);
      this.listenTo(this.container, _core.Events.CONTAINER_STOP, this.stopReporting);
      this.listenTo(this.container, _core.Events.CONTAINER_ENDED, this.stopReporting);
      this.listenToOnce(this.container.playback, _core.Events.PLAYBACK_PLAY_INTENT, this.startTimers);
      this.listenToOnce(this.container, _core.Events.CONTAINER_PLAY, this.onFirstPlaying);
      this.listenTo(this.container, _core.Events.CONTAINER_PLAY, this.onPlay);
      this.listenTo(this.container, _core.Events.CONTAINER_PAUSE, this.onPause);
      this.listenToOnce(this.container, _core.Events.CONTAINER_STATE_BUFFERING, this.onBuffering);
      this.listenTo(this.container, _core.Events.CONTAINER_SEEK, this.onSeek);
      this.listenTo(this.container, _core.Events.CONTAINER_ERROR, function () {
        return _this2._inc('error');
      });
      this.listenTo(this.container, _core.Events.CONTAINER_FULLSCREEN, function () {
        return _this2._inc('fullscreen');
      });
      this.listenTo(this.container, _core.Events.CONTAINER_PLAYBACKDVRSTATECHANGED, function (dvrInUse) {
        dvrInUse && _this2._inc('dvrUsage');
      });
      this.listenTo(this.container.playback, _core.Events.PLAYBACK_PROGRESS, this.onProgress);
      this.listenTo(this.container.playback, _core.Events.PLAYBACK_TIMEUPDATE, this.onTimeUpdate);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.stopReporting();
      _get(ClapprStats.prototype.__proto__ || Object.getPrototypeOf(ClapprStats.prototype), 'destroy', this).call(this);
    }
  }, {
    key: 'onBitrate',
    value: function onBitrate(newBitrate) {
      var bitrate = parseInt((0, _lodash2.default)(newBitrate, 'bitrate', 0), 10);
      var now = this._now();

      if (this._metrics.extra.bitratesHistory.length > 0) {
        var beforeLast = this._metrics.extra.bitratesHistory[this._metrics.extra.bitratesHistory.length - 1];
        beforeLast.end = now;
        beforeLast.time = now - beforeLast.start;
      }

      this._metrics.extra.bitratesHistory.push({ start: this._now(), bitrate: bitrate });

      this._inc('changeLevel');
    }
  }, {
    key: 'stopReporting',
    value: function stopReporting() {
      this._buildReport();

      clearInterval(this._intervalId);
      this._newMetrics();

      this.stopListening();
      this.bindEvents();
    }
  }, {
    key: 'startTimers',
    value: function startTimers() {
      this._intervalId = setInterval(this._buildReport.bind(this), this._runEach);
      this._start('session');
      this._start('startup');
    }
  }, {
    key: 'onFirstPlaying',
    value: function onFirstPlaying() {
      this.listenTo(this.container, _core.Events.CONTAINER_TIMEUPDATE, this.onContainerUpdateWhilePlaying);

      this._start('watch');
      this._stop('startup');
    }
  }, {
    key: 'playAfterPause',
    value: function playAfterPause() {
      this.listenTo(this.container, _core.Events.CONTAINER_TIMEUPDATE, this.onContainerUpdateWhilePlaying);
      this._stop('pause');
      this._start('watch');
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this._inc('play');
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this._stop('watch');
      this._start('pause');
      this._inc('pause');
      this.listenToOnce(this.container, _core.Events.CONTAINER_PLAY, this.playAfterPause);
      this.stopListening(this.container, _core.Events.CONTAINER_TIMEUPDATE, this.onContainerUpdateWhilePlaying);
    }
  }, {
    key: 'onSeek',
    value: function onSeek(e) {
      this._inc('seek');
      this._metrics.extra.watchHistory.push([e * 1000, e * 1000]);
    }
  }, {
    key: 'onTimeUpdate',
    value: function onTimeUpdate(e) {
      var current = e.current * 1000,
          total = e.total * 1000,
          l = this._metrics.extra.watchHistory.length;

      this._metrics.extra.duration = total;
      this._metrics.extra.currentTime = current;
      this._metrics.extra.watchedPercentage = current / total * 100;

      if (l === 0) {
        this._metrics.extra.watchHistory.push([current, current]);
      } else {
        this._metrics.extra.watchHistory[l - 1][1] = current;
      }

      if (this._metrics.extra.bitratesHistory.length > 0) {
        var lastBitrate = this._metrics.extra.bitratesHistory[this._metrics.extra.bitratesHistory.length - 1];
        if (!lastBitrate.end) {
          lastBitrate.time = this._now() - lastBitrate.start;
        }
      }

      this._onCompletion();
    }
  }, {
    key: 'onContainerUpdateWhilePlaying',
    value: function onContainerUpdateWhilePlaying() {
      if (this.container.playback.isPlaying()) {
        this._stop('watch');
        this._start('watch');
      }
    }
  }, {
    key: 'onBuffering',
    value: function onBuffering() {
      this._inc('buffering');
      this._start('buffering');
      this.listenToOnce(this.container, _core.Events.CONTAINER_STATE_BUFFERFULL, this.onBufferfull);
    }
  }, {
    key: 'onBufferfull',
    value: function onBufferfull() {
      this._stop('buffering');
      this.listenToOnce(this.container, _core.Events.CONTAINER_STATE_BUFFERING, this.onBuffering);
    }
  }, {
    key: 'onProgress',
    value: function onProgress(progress) {
      this._metrics.extra.buffersize = progress.current * 1000;
    }
  }, {
    key: '_newMetrics',
    value: function _newMetrics() {
      this._metrics = {
        counters: {
          play: 0, pause: 0, error: 0, buffering: 0, decodedFrames: 0, droppedFrames: 0,
          fps: 0, changeLevel: 0, seek: 0, fullscreen: 0, dvrUsage: 0
        },
        timers: {
          startup: 0, watch: 0, pause: 0, buffering: 0, session: 0, latency: 0
        },
        extra: {
          playbackName: '', playbackType: '', bitratesHistory: [], bitrateWeightedMean: 0,
          bitrateMostUsed: 0, buffersize: 0, watchHistory: [], watchedPercentage: 0,
          bufferingPercentage: 0, bandwidth: 0, duration: 0, currentTime: 0
        }
      };
    }
  }, {
    key: '_onCompletion',
    value: function _onCompletion() {
      var currentPercentage = this._metrics.extra.watchedPercentage;
      var allPercentages = this._completion.watch;
      var isCalled = this._completion.calls.indexOf(currentPercentage) != -1;

      if (allPercentages.indexOf(currentPercentage) != -1 && !isCalled) {
        _core.Log.info(this.name + ' PERCENTAGE_EVENT: ' + currentPercentage);
        this._completion.calls.push(currentPercentage);
        this.trigger(ClapprStats.PERCENTAGE_EVENT, currentPercentage);
      }
    }
  }, {
    key: '_buildReport',
    value: function _buildReport() {
      this._stop('session');
      this._start('session');

      this._metrics.extra.playbackName = this._playbackName;
      this._metrics.extra.playbackType = this._playbackType;

      this._calculateBitrates();
      this._calculatePercentages();
      this._fetchFPS();
      this._measureLatency();
      this._measureBandwidth();

      this.trigger(ClapprStats.REPORT_EVENT, JSON.parse(JSON.stringify(this._metrics)));
    }
  }, {
    key: '_fetchFPS',
    value: function _fetchFPS() {
      // flashls ??? - hls.droppedFramesl hls.stream.bufferLength (seconds)
      // hls ??? (use the same?)
      var fetchFPS = {
        'html5_video': this._html5FetchFPS,
        'hls': this._html5FetchFPS,
        'dash_shaka_playback': this._html5FetchFPS
      };

      fetchFPS[this._playbackName] && fetchFPS[this._playbackName].call(this);
    }
  }, {
    key: '_calculateBitrates',
    value: function _calculateBitrates() {
      var totalTime = this._metrics.extra.bitratesHistory.map(function (x) {
        return x.time;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this._metrics.extra.bitrateWeightedMean = this._metrics.extra.bitratesHistory.map(function (x) {
        return x.bitrate * x.time;
      }).reduce(function (a, b) {
        return a + b;
      }, 0) / totalTime;

      if (this._metrics.extra.bitratesHistory.length > 0) {
        this._metrics.extra.bitrateMostUsed = this._metrics.extra.bitratesHistory.slice().sort(function (a, b) {
          return a.time < b.time;
        })[0].bitrate;
      }
    }
  }, {
    key: '_calculatePercentages',
    value: function _calculatePercentages() {
      if (this._metrics.extra.duration > 0) {
        this._metrics.extra.bufferingPercentage = this._metrics.timers.buffering / this._metrics.extra.duration * 100;
      }
    }
  }, {
    key: '_html5FetchFPS',
    value: function _html5FetchFPS() {
      var videoTag = this.container.playback.el;
      var decodedFrames = videoTag.webkitDecodedFrameCount || videoTag.mozDecodedFrames || 0;
      var droppedFrames = videoTag.webkitDroppedFrameCount || videoTag.mozParsedFrames - videoTag.mozDecodedFrames || 0;
      var decodedFramesLastTime = decodedFrames - (this._lastDecodedFramesCount || 0);

      this._metrics.counters.decodedFrames = decodedFrames;
      this._metrics.counters.droppedFrames = droppedFrames;
      this._metrics.counters.fps = decodedFramesLastTime / (this._runEach / 1000);

      this._lastDecodedFramesCount = decodedFrames;
    }

    // originally from https://www.smashingmagazine.com/2011/11/analyzing-network-characteristics-using-javascript-and-the-dom-part-1/

  }, {
    key: '_measureLatency',
    value: function _measureLatency() {
      var _this3 = this;

      if (this._uriToMeasureLatency) {
        var t = [],
            n = 2,
            rtt;
        var ld = function ld() {
          t.push(_this3._now());
          if (t.length > n) done();else {
            var img = new Image();
            img.onload = ld;
            img.src = _this3._uriToMeasureLatency + '?' + Math.random() + '=' + _this3._now();
          }
        };
        var done = function done() {
          rtt = t[2] - t[1];
          _this3._metrics.timers.latency = rtt;
        };
        ld();
      }
    }

    // originally from https://www.smashingmagazine.com/2011/11/analyzing-network-characteristics-using-javascript-and-the-dom-part-1/

  }, {
    key: '_measureBandwidth',
    value: function _measureBandwidth() {
      var _this4 = this;

      if (this._urisToMeasureBandwidth && this._bwMeasureCount % this._runBandwidthTestEvery == 0) {
        var i = 0;

        var ld = function ld(e) {
          if (i > 0) {
            _this4._urisToMeasureBandwidth[i - 1].end = _this4._now();
            clearTimeout(_this4._urisToMeasureBandwidth[i - 1].timer);
          }
          if (i >= _this4._urisToMeasureBandwidth.length || i > 0 && _this4._urisToMeasureBandwidth[i - 1].expired) done(e);else {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', _this4._urisToMeasureBandwidth[i].url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onload = xhr.onabort = ld;
            _this4._urisToMeasureBandwidth[i].start = _this4._now();
            _this4._urisToMeasureBandwidth[i].timer = setTimeout(function (j) {
              _this4._urisToMeasureBandwidth[j].expired = true;
              xhr.abort();
            }, _this4._urisToMeasureBandwidth[i].timeout, i);
            xhr.send();
          }
          i++;
        };

        var done = function done(e) {
          var timeSpent = (_this4._urisToMeasureBandwidth[i - 1].end - _this4._urisToMeasureBandwidth[i - 1].start) / 1000;
          var bandwidthBps = e.loaded * 8 / timeSpent;
          _this4._metrics.extra.bandwidth = bandwidthBps;
          _this4._urisToMeasureBandwidth.forEach(function (x) {
            x.start = 0;
            x.end = 0;
            x.expired = false;
            clearTimeout(x.timer);
          });
        };

        ld();
      }
      this._bwMeasureCount++;
    }
  }]);

  return ClapprStats;
}(_core.ContainerPlugin);

exports.default = ClapprStats;


ClapprStats.REPORT_EVENT = 'clappr:stats:report';
ClapprStats.PERCENTAGE_EVENT = 'clappr:stats:percentage';
module.exports = exports['default'];

/***/ }),

/***/ "@clappr/core":
/*!*************************!*\
  !*** external "Clappr" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__clappr_core__;

/***/ })

/******/ });
});

});

var ClapprStats = /*@__PURE__*/getDefaultExportFromCjs(clapprStats);

var PlayerStats = /*#__PURE__*/function (_ClapprStats) {
  _inherits(PlayerStats, _ClapprStats);

  var _super = _createSuper(PlayerStats);

  _createClass(PlayerStats, [{
    key: "innerPlayback",
    get: function get() {
      return this.container.playback && this.container.playback.playback;
    }
  }, {
    key: "_playbackName",
    get: function get() {
      return this.innerPlayback && this.innerPlayback.name;
    }
  }]);

  function PlayerStats(container) {
    var _this;

    _classCallCheck(this, PlayerStats);

    container.options.clapprStats = container.options.clapprStats || {
      runEach: 1000,
      onReport: function onReport(metrics) {
        return _this.onMetricsReceived(metrics);
      }
    };
    return _this = _super.call(this, container);
  }

  _createClass(PlayerStats, [{
    key: "_html5FetchFPS",
    value: function _html5FetchFPS() {
      var videoTag = this.container.playback.playback.el;
      var decodedFrames = videoTag.webkitDecodedFrameCount || videoTag.mozDecodedFrames || 0;
      var droppedFrames = videoTag.webkitDroppedFrameCount || videoTag.mozParsedFrames - videoTag.mozDecodedFrames || 0;
      var decodedFramesLastTime = decodedFrames - (this._lastDecodedFramesCount || 0);
      this._metrics.counters.decodedFrames = decodedFrames;
      this._metrics.counters.droppedFrames = droppedFrames;
      this._metrics.counters.fps = decodedFramesLastTime / (this._runEach / 1000);
      this._lastDecodedFramesCount = decodedFrames;
    }
  }, {
    key: "onMetricsReceived",
    value: function onMetricsReceived(metrics) {
      this.container.trigger(Events.WM_STATS_REPORTED, metrics);
    }
  }]);

  return PlayerStats;
}(ClapprStats);

var MAX_TIMESTAMP_DIFFERENCE = 1.0;

var Cuepoints = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(Cuepoints, _ContainerPlugin);

  var _super = _createSuper(Cuepoints);

  function Cuepoints() {
    _classCallCheck(this, Cuepoints);

    return _super.apply(this, arguments);
  }

  _createClass(Cuepoints, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.stopListening();
      this.listenTo(this.container.playback, Events.WM_VIDEO_METADATA_LOADED, this._parseCuepoints);
    }
  }, {
    key: "_bindPlaybackEvents",
    value: function _bindPlaybackEvents() {
      this.listenTo(this.container.playback, Events$1.PLAYBACK_TIMEUPDATE, this._onPositionUpdate);
    }
  }, {
    key: "_onPositionUpdate",
    value: function _onPositionUpdate(_ref) {
      var _this = this;

      var current = _ref.current;

      this._cuepoints.forEach(function (cuepoint) {
        if (_this._previousPosition < cuepoint.time || current === cuepoint.time) {
          if (current === cuepoint.time || current >= cuepoint.time && current - _this._previousPosition <= MAX_TIMESTAMP_DIFFERENCE) {
            Log$1.debug(_this.name, 'cuepoint reached:', cuepoint);

            _this.container.trigger(Events.DID_REACH_CUEPOINT, cuepoint);
          }
        }
      });

      this._previousPosition = current;
    }
  }, {
    key: "_parseCuepoints",
    value: function _parseCuepoints(video) {
      var _this2 = this;

      this._cuepoints = (video.cuepoints || []).map(function (cuepoint) {
        var result = _objectSpread2({}, cuepoint);

        result.time /= 1000;
        return result;
      }).sort(function (c1, c2) {
        return c1.time - c2.time;
      });
      Log$1.debug(this.name, 'cuepoints loaded:', this._cuepoints);

      if (this._cuepoints.length > 0) {
        nextTick(function () {
          return _this2.container.trigger(Events.DID_LOAD_CUEPOINTS, _this2._cuepoints);
        });

        this._bindPlaybackEvents();

        this._previousPosition = -0.01;
      }
    }
  }, {
    key: "name",
    get: function get() {
      return 'cuepoints';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }]);

  return Cuepoints;
}(ContainerPlugin);

var GLOBOCOM_SUBDOMAIN_PATTERN = /^https?:\/\/([a-z0-9\.\-]*)\.globoi?\.com/; // eslint-disable-line no-useless-escape

var TECHTUDO_PATTERN = /^https?:\/\/[w]*\.?(techtudo)\.com\.br/;

var Comscore = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(Comscore, _ContainerPlugin);

  var _super = _createSuper(Comscore);

  _createClass(Comscore, [{
    key: "name",
    get: function get() {
      return 'comscore';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "environment",
    get: function get() {
      return this.container.options.env;
    }
  }, {
    key: "scorecardBeacon",
    get: function get() {
      return "".concat(this.environment.protocol, "://").concat(this.options.httpOnly ? '' : 's', "b.scorecardresearch.com/beacon.js");
    }
  }]);

  function Comscore(container) {
    var _this;

    _classCallCheck(this, Comscore);

    _this = _super.call(this, container);
    _this.siteName = _this.options.siteName;

    _this.listenToOnce(_this.container.playback, Events.WM_RESOURCE_READY, _this.onResourceReady);

    _this.embedPlugin();

    return _this;
  }

  _createClass(Comscore, [{
    key: "embedPlugin",
    value: function embedPlugin() {
      var _this2 = this;

      if (!window.COMSCORE) {
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = this.scorecardBeacon;

        script.onload = function () {
          return _this2.ready();
        };

        document.head.appendChild(script);
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      this.isReady = true;
      this.trigger('comscore:ready');
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady(video) {
      var _this3 = this;

      if (window.COMSCORE) {
        this.video = video;
        this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, this.onPlay);
        this.listenToOnce(this.container, Events$1.CONTAINER_STOP, this.onStop);
        this.listenToOnce(this.container, Events$1.CONTAINER_ENDED, this.onStop);
      } else {
        this.listenToOnce(this, 'comscore:ready', function () {
          return _this3.onResourceReady(video);
        });
      }
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      var metadata = {
        c2: 6035227,
        c3: this.getSiteName(),
        c4: this.video.channel,
        c5: this.getVideoType(),
        c6: null,
        c10: '1|1',
        // resource index|resource count
        rn: Math.random()
      };

      if (window.location.host.match(/globotv\.globo\.com$/)) {
        metadata.c6 = 'Globotv - ' + this.video.channel;
      }

      COMSCORE.beacon(metadata);
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.stopListening();
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
    }
  }, {
    key: "getSiteName",
    value: function getSiteName() {
      return this.siteName ? this.siteName : this.getSubdomain(window.location.href);
    }
  }, {
    key: "getSubdomain",
    value: function getSubdomain(url) {
      if (url) {
        var match = url.match(GLOBOCOM_SUBDOMAIN_PATTERN) || url.match(TECHTUDO_PATTERN);
        return match ? match[1] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "getVideoType",
    value: function getVideoType() {
      return {
        'ad': '09',
        'live': '03'
      }[this.video.kind] || '02';
    }
  }]);

  return Comscore;
}(ContainerPlugin);

var Program = /*#__PURE__*/function () {
  function Program(data) {
    _classCallCheck(this, Program);

    this.channel = data.channel;
    this.channelId = data.channel_id;
    this.program = data.program;
    this.programId = data.program_id;
    this.startTime = data.start_time;
    this.endTime = data.end_time;
    this.rawData = data;
  }

  _createClass(Program, [{
    key: "contains",
    value: function contains(time) {
      var tolerance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return time >= this.startTime - tolerance && time < this.endTime + tolerance;
    }
  }, {
    key: "toString",
    value: function toString() {
      var options = {
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };
      var startStr = new Date(this.startTime * 1000).toLocaleDateString(undefined, options);
      var endStr = new Date(this.endTime * 1000).toLocaleDateString(undefined, options);
      return "Program [".concat(this.channel).concat(this.channelId ? " (".concat(this.channelId, ")") : '', " - ").concat(this.program).concat(this.programId ? " (".concat(this.programId, ")") : '', ": ").concat(startStr, " - ").concat(endStr, "]");
    }
  }]);

  return Program;
}();

var EPG = /*#__PURE__*/function () {
  _createClass(EPG, [{
    key: "programs",
    get: function get() {
      return this._programs;
    }
  }, {
    key: "latestProgram",
    get: function get() {
      return this.programs[0];
    }
  }]);

  function EPG(data) {
    _classCallCheck(this, EPG);

    this._programs = data.programs || [];
    this._programs = this._programs.map(function (p) {
      return new Program(p);
    }).sort(function (p1, p2) {
      return p2.endTime - p1.endTime;
    });
    this.rawData = data;
  }

  _createClass(EPG, [{
    key: "getProgramForTime",
    value: function getProgramForTime(time, tolerance) {
      return this.programs && this.programs.find(function (program) {
        return program.contains(time, tolerance);
      });
    }
  }]);

  return EPG;
}();

var truncateTimeSeconds = Utils$1.truncateTimeSeconds,
    getCurrentTime$1 = Utils$1.getCurrentTime;
var MINUTE_SECS = 60;
var PROGRAM_CHANGE_TOLERANCE_SECS = 5;

var EPGPlugin = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(EPGPlugin, _ContainerPlugin);

  var _super = _createSuper(EPGPlugin);

  _createClass(EPGPlugin, [{
    key: "name",
    get: function get() {
      return 'epg';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "epgApiUrl",
    get: function get() {
      return "".concat(this.options.env.protocol, "://epg-api.video.globo.com/v2/programs");
    }
  }, {
    key: "playback",
    get: function get() {
      return this._playback;
    }
  }, {
    key: "innerPlayback",
    get: function get() {
      return this.playback && this.playback.playback;
    }
  }]);

  function EPGPlugin(container) {
    var _this;

    _classCallCheck(this, EPGPlugin);

    _this = _super.call(this, container);
    _this._playback = container.playback;
    _this._throttledPositionUpdate = lodash_throttle(function () {
      var _this2;

      return (_this2 = _this)._onPositionUpdate.apply(_this2, arguments);
    }, 5000, {
      trailing: false
    });
    _this._url = _this.epgApiUrl;
    return _this;
  }

  _createClass(EPGPlugin, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.stopListening();
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this._onResourceReady);
    }
  }, {
    key: "parseEPG",
    value: function parseEPG(data) {
      this._updating = false;
      this._epg = new EPG(data);
      this.container.trigger(Events.DID_LOAD_EPG, {
        programs: this._epg.programs
      });

      this._onPositionUpdate();
    }
  }, {
    key: "updateEPG",
    value: function updateEPG() {
      if (this._updating) return;
      this._updating = true;
      var currentPositionTime = getCurrentTime$1(this.innerPlayback);
      var startTime = truncateTimeSeconds(currentPositionTime - this.playback.getDuration());
      var endTime = truncateTimeSeconds(currentPositionTime + 30 * MINUTE_SECS);

      this._loadEpgData(startTime, endTime);
    }
  }, {
    key: "updateProgramForTime",
    value: function updateProgramForTime(time) {
      if (!this._currentProgram || !this._currentProgram.contains(time)) {
        var program = this._epg && this._epg.getProgramForTime(time, PROGRAM_CHANGE_TOLERANCE_SECS);

        var programChanged = this._currentProgram !== program;

        if (programChanged) {
          this._currentProgram = program;
          this.container.trigger(Events.DID_CHANGE_CURRENT_PROGRAM, {
            program: this._currentProgram
          });
        }
      }
    }
  }, {
    key: "_onResourceReady",
    value: function _onResourceReady(video) {
      var _this$innerPlayback;

      var isLive = video.isLive;
      var transmissionId = video.transmission && video.transmission.id;
      var playbackCanGetProgramStartTime = !!((_this$innerPlayback = this.innerPlayback) === null || _this$innerPlayback === void 0 ? void 0 : _this$innerPlayback.getProgramDateTime);

      if (isLive && transmissionId && playbackCanGetProgramStartTime) {
        this._video = video;
        this._transmissionId = transmissionId;
        this.listenTo(this.playback, Events$1.PLAYBACK_TIMEUPDATE, this._throttledPositionUpdate);
        this.listenTo(this.playback, Events$1.PLAYBACK_SEEKED, this._onPositionUpdate);
        this.listenToOnce(this.playback, Events$1.PLAYBACK_PLAY, this.updateEPG);
      } else {
        Log$1.info(this.name, "skipping EPG loading (isLive=".concat(isLive, ", transmissionId=").concat(transmissionId, ")"));
      }
    }
  }, {
    key: "_loadEpgData",
    value: function _loadEpgData(start, end) {
      var _this3 = this;

      if (isNaN(start) || isNaN(end)) {
        Log$1.warn(this.name, "skipping EPG request. Invalid start or end time. start: ".concat(start, ",  end: ").concat(end));
        return;
      }

      var url = "".concat(this._url, "?transmission_id=").concat(this._transmissionId, "&start_time=").concat(start, "&end_time=").concat(end);
      return $$1.ajax({
        url: url
      }).then(function (data) {
        return _this3.parseEPG(data);
      }, function (_, status, error) {
        Log$1.error(_this3.name, 'could not load EPG:', error || status);
        !_this3._epg && _this3.stopListening(_this3.playback);
      });
    }
  }, {
    key: "_onPositionUpdate",
    value: function _onPositionUpdate() {
      if (!this.innerPlayback) return;
      var currentPositionTime = getCurrentTime$1(this.innerPlayback);
      this.updateProgramForTime(currentPositionTime);
      var latestProgram = this._epg && this._epg.latestProgram;

      if (!this._updating && latestProgram && latestProgram.endTime - currentPositionTime <= 5 * MINUTE_SECS) {
        this.updateEPG();
      }
    }
  }]);

  return EPGPlugin;
}(ContainerPlugin);

var css_248z$q = ".clappr-player#wp3-player-0 .poster {\n  cursor: pointer;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 998;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  visibility: visible;\n  opacity: 1;\n  transition: visibility 0.3s ease, opacity 0.3s ease; }\n  .clappr-player#wp3-player-0 .poster--hidden {\n    visibility: hidden;\n    opacity: 0; }\n  .clappr-player#wp3-player-0 .poster:hover .poster__play-wrapper {\n    filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.5)); }\n  .clappr-player#wp3-player-0 .poster__background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: 50% 50%; }\n  .clappr-player#wp3-player-0 .poster__background-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); }\n  .clappr-player#wp3-player-0 .poster__play-wrapper {\n    width: 100%;\n    height: 30%;\n    text-align: center;\n    opacity: 0.97;\n    transition: filter 0.3s; }\n    .clappr-player#wp3-player-0 .poster__play-wrapper svg {\n      height: 100%;\n      display: inline; }\n";
styleInject(css_248z$q);

var templateHtml$6 = "<div class=\"poster__background\"></div>\n<div class=\"poster__background-overlay\"></div>\n<div class=\"poster__play-wrapper\"></div>\n";

var playPosterIconSvg = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M8 6.267c0-.661.468-.931 1.04-.601l9.93 5.733c.573.33.573.871 0 1.202l-9.93 5.733c-.572.33-1.04.06-1.04-.6V6.266z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var autoplayManager$2 = Utils$1.autoplayManager;

var Poster = /*#__PURE__*/function (_UIContainerPlugin) {
  _inherits(Poster, _UIContainerPlugin);

  var _super = _createSuper(Poster);

  _createClass(Poster, [{
    key: "name",
    get: function get() {
      return 'poster';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$6);
    }
  }, {
    key: "disableImage",
    get: function get() {
      return this.options.poster && this.options.poster.disableImage;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'poster'
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click': 'clicked'
      };
    }
  }, {
    key: "posterImage",
    get: function get() {
      if (!this.options.src || !this.options.sources || !this.options.sources.length) return null;
      var posterImageUrls = this.video && this.video.posterImageUrls || {};
      var availableHeights = Object.keys(posterImageUrls);
      var playerHeight = this.container.currentSize.height;
      var height = availableHeights.find(function (height) {
        return height >= playerHeight;
      }) || availableHeights[availableHeights.length - 1];
      return posterImageUrls[height];
    }
  }]);

  function Poster(containter) {
    var _this;

    _classCallCheck(this, Poster);

    _this = _super.call(this, containter);
    if (!_this.options.disableControlsOnPoster) _this.options.disableControlsOnPoster = true;

    if (_this.options.disableControlsOnPoster) {
      _this.container.disableMediaControl();
    }

    _this._clicked = false;
    _this.playButtonVisible = true;

    _this.render();

    return _this;
  }

  _createClass(Poster, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.container.playback, Events.WM_PLAY_REQUESTED, this.hidePlayButton);
      this.listenTo(this.container.playback, Events.WM_VIDEO_METADATA_LOADED, this.onVideoMetadataLoaded);
      this.listenTo(this.container.playback, Events.WM_AUTOPLAY_BLOCKED, this.onAutoplayBlocked);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.onBuffering);
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.onPlay);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.onStop);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.onStop);
    }
  }, {
    key: "onVideoMetadataLoaded",
    value: function onVideoMetadataLoaded(video) {
      this.video = video;
      this.authorizePosterImage = video.adult ? this.options.allowRestrictedContent : true;
      this.authorizePosterImage && !this.disableImage && this.addPosterImage();
    }
  }, {
    key: "onAutoplayBlocked",
    value: function onAutoplayBlocked() {
      this.stopListening(this.container.playback, Events.WM_PLAY_REQUESTED);
      this.showPlayButton();
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      this._clicked = true;
      this.hidePlayButton();
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      this.$el.addClass('poster--hidden');

      if (this.options.disableControlsOnPoster) {
        this.container.enableMediaControl();
      }
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this._clicked = false;
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      this.$el.removeClass('poster--hidden');

      if (this.options.disableControlsOnPoster) {
        this.container.disableMediaControl();
      }

      if (!(this.options.poster && this.options.poster.disablePlayButton) && !Browser.isChromecast) {
        this.showPlayButton();
      }
    }
  }, {
    key: "hidePlayButton",
    value: function hidePlayButton() {
      this.$playButton.hide();
      this.playButtonVisible = false;
    }
  }, {
    key: "showPlayButton",
    value: function showPlayButton() {
      this.playButtonVisible = true;
      this.$playButton.show();
    }
  }, {
    key: "clicked",
    value: function clicked(event) {
      event.stopPropagation();
      if (this._clicked || !this.playButtonVisible) return;
      this.container.playback.trigger(Events.WM_USER_PLAY_REQUESTED, {
        event: event
      });
      this.container.playback.playback && this.container.playback.consent();
      this.container.playback.play();
      this.hidePlayButton();
      this._clicked = true;
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var style = Styler.getStyleFrom(css_248z$q, {
        playerId: this.options.playerId
      });
      this.$el.html(this.template());
      this.$el.append(style[0]);
      this.container.$el.append(this.el);
      this.$playButton = this.$el.find('.poster__play-wrapper');
      this.$playButton.append(playPosterIconSvg);
      this.options.autoPlay && this.hidePlayButton();
      autoplayManager$2.onAutoplayAvailable(function () {
        return _this2.hidePlayButton();
      }, this.options, function () {
        if (!autoplayManager$2.isAutoPlayMutedAllowed(_this2.options) && !_this2._clicked) _this2.showPlayButton();
      });
      return this;
    }
  }, {
    key: "addPosterImage",
    value: function addPosterImage() {
      if (this.container.currentSize && this.container.currentSize.height > 0) {
        var posterImage = this.posterImage;

        if (posterImage) {
          this.container.options.poster = posterImage;
          this.imgEl = this.$('.poster__background');
          this.imgEl.css({
            'background-image': 'url(' + posterImage + ')'
          });
          this.$el.prepend(this.imgEl[0]);
          var video = this.container.$el.find('video');
          video.length && (video[0].poster = posterImage);
        }
      } else {
        this.listenToOnce(this.container, Events$1.CONTAINER_RESIZE, this.addPosterImage);
      }
    }
  }]);

  return Poster;
}(UIContainerPlugin);

var css_248z$r = ".clappr-player#wp3-player-0 .spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 998;\n  width: 48px;\n  height: 48px;\n  margin: -24px 0 0 -24px;\n  cursor: default; }\n  .clappr-player#wp3-player-0 .spinner__svg {\n    line-height: 100%;\n    height: 100%;\n    width: 100%;\n    margin: 0; }\n    .clappr-player#wp3-player-0 .spinner__svg--animated {\n      -webkit-animation: rotate-spinner-player 0.5s linear infinite normal forwards;\n              animation: rotate-spinner-player 0.5s linear infinite normal forwards; }\n  .clappr-player#wp3-player-0 .spinner--hidden {\n    display: none; }\n\n@-webkit-keyframes rotate-spinner-player {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes rotate-spinner-player {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n";
styleInject(css_248z$r);

var templateHtml$7 = "<figure class=\"spinner__svg\">\n  <%= spinnerIcon %>\n</figure>\n";

var spinnerIcon = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h24v24H0z\"/>\n        <path d=\"M2.4 12c0-5.302 4.298-9.6 9.6-9.6.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2-3.976 0-7.2 3.224-7.2 7.2 0 .663-.537 1.2-1.2 1.2-.663 0-1.2-.537-1.2-1.2z\" fill=\"#FFF\"/>\n    </g>\n</svg>";

var SPINNER_START_DELAY = 300;

var Spinner = /*#__PURE__*/function (_UIContainerPlugin) {
  _inherits(Spinner, _UIContainerPlugin);

  var _super = _createSuper(Spinner);

  _createClass(Spinner, [{
    key: "name",
    get: function get() {
      return 'spinner';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$7);
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'spinner spinner--hidden'
      };
    }
  }]);

  function Spinner(container) {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _super.call(this, container);

    _this.render();

    return _this;
  }

  _createClass(Spinner, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.playback, Events.WM_PLAY_REQUESTED, this.start);
      this.listenToOnce(this.playback, Events.WM_AUTOPLAY_BLOCKED, this.onAutoplayBlocked);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.start);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERFULL, this.onBufferfull);
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.stop);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.stop);
      this.listenTo(this.container, Events$1.CONTAINER_ERROR, this.stop);
    }
  }, {
    key: "onAutoplayBlocked",
    value: function onAutoplayBlocked() {
      /*
        When autoplay is blocked, only the user will be able to request play.
      */
      this.stop();
      this.stopListening(this.playback, Events.WM_PLAY_REQUESTED);
      this.listenToOnce(this.playback, Events.WM_USER_PLAY_REQUESTED, this.start);
    }
  }, {
    key: "enable",
    value: function enable() {
      if (!this.enabled) {
        this.bindEvents();
        this.enabled = true;
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      this.stop();
      this.stopListening();
      this.enabled = false;
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;

      this.disableTimeUpdateObserver();
      this.resetTimeoutToStart();
      this.timeoutId = setTimeout(function () {
        _this2.$el.removeClass('spinner--hidden');

        _this2.$el.addClass('spinner__svg--animated');

        _this2.isVisible = true;

        _this2.container.trigger(Events.WM_SPINNER_START);

        _this2.timeoutId = null;
      }, SPINNER_START_DELAY);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.disableTimeUpdateObserver();
      this.resetTimeoutToStart();
      if (!this.isVisible) return;
      this.isVisible = false;
      this.$el.removeClass('spinner__svg--animated');
      this.$el.addClass('spinner--hidden');
      this.container.trigger(Events.WM_SPINNER_STOP);
    }
  }, {
    key: "resetTimeoutToStart",
    value: function resetTimeoutToStart() {
      this.timeoutId && clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }, {
    key: "disableTimeUpdateObserver",
    value: function disableTimeUpdateObserver() {
      if (!this.waitingTimeUpdateToStop) return;
      this.waitingTimeUpdateToStop = false;
      this.stopListening(this.container, Events$1.CONTAINER_TIMEUPDATE);
    }
  }, {
    key: "enableTimeUpdateObserver",
    value: function enableTimeUpdateObserver() {
      this.waitingTimeUpdateToStop = true;
      this.listenToOnce(this.container, Events$1.CONTAINER_TIMEUPDATE, this.stop);
    }
  }, {
    key: "onBufferfull",
    value: function onBufferfull() {
      var videoEl = this.playback && this.playback.videoEl;
      var isPlaying = videoEl && videoEl.currentTime > 0;
      isPlaying ? this.stop() : this.enableTimeUpdateObserver();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      this.$el.html(this.template({
        spinnerIcon: spinnerIcon
      }));
      var style = Styler.getStyleFrom(css_248z$r, {
        playerId: this.options.playerId
      });
      this.container.$el.append(style[0]);
      this.container.$el.append(this.el);
      this.options.autoPlay ? this.start() : this.stop();
      Utils$1.autoplayManager.onAutoplayAvailable(function () {
        return _this3.start();
      }, this.options, function () {
        if (!Utils$1.autoplayManager.isAutoPlayMutedAllowed(_this3.options)) _this3.stop();
      });
      return this;
    }
  }]);

  return Spinner;
}(UIContainerPlugin);

var GLOBOCOM_SUBDOMAIN_PATTERN$1 = /([a-z0-9\.\-]*)\.globoi?\.com/; // eslint-disable-line no-useless-escape

var TECHTUDO_PATTERN$1 = /[w]*\.?(techtudo)\.com\.br/;
var UNAVAILABLE_INFO = '*null';

var StreamSense = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(StreamSense, _ContainerPlugin);

  var _super = _createSuper(StreamSense);

  _createClass(StreamSense, [{
    key: "name",
    get: function get() {
      return 'streamsense';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "waitForDFP",
    get: function get() {
      return !Browser.isChromecast && !Browser.isMobile;
    }
  }, {
    key: "isAdPlayback",
    get: function get() {
      return this.container.getPlaybackType() === 'ad';
    }
  }, {
    key: "currentTimeInMilliseconds",
    get: function get() {
      return this.toMilliseconds(this.currentTime);
    }
  }, {
    key: "streamsenseScript",
    get: function get() {
      return "".concat(this.options.env.protocol, "://s3.glbimg.com/v1/AUTH_e1b09a2d222b4900a437a46914be81e5/static/vendor/libs/comScore-JS-6.3.1.181004.min.js");
    }
  }, {
    key: "scorecardMeasurement",
    get: function get() {
      return "".concat(this.options.env.protocol, "://").concat(this.options.httpOnly ? '' : 's', "b.scorecardresearch.com/p?c1=2&c2=6035227&ns_site=globo");
    }
  }, {
    key: "contentType",
    get: function get() {
      var isLive = this.video.kind === 'live';
      var durationInMinutes = !isLive && this.video.duration / 1000 / 60;
      var isLongForm = !isLive && durationInMinutes >= 10;
      return isLive ? 'vc13' : isLongForm ? 'vc12' : 'vc11';
    }
  }]);

  function StreamSense(container) {
    var _this;

    _classCallCheck(this, StreamSense);

    _this = _super.call(this, container);
    _this.options.daxExtras || (_this.options.daxExtras = _this.options.daxextras);
    _this.adError = false;
    _this.isReady = false;
    _this.started = false;
    _this.currentTime = 0;

    _this.embedScript();

    return _this;
  }

  _createClass(StreamSense, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      if (this.waitForDFP) {
        this.listenTo(this.container, Events.DFP_CONTENT_RESUME, function () {
          return _this2.checkAd(false);
        });
        this.listenTo(this.container, Events.DFP_AD_ERROR, function () {
          return _this2.checkAd(true);
        });
        this.listenTo(this.container, Events.DFP_CONTENT_ENDED, this.bindPlaybackEvents);
      }

      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, function (video) {
        return _this2.setupStart(video);
      });
    }
  }, {
    key: "bindPlaybackEvents",
    value: function bindPlaybackEvents() {
      var _containerEvents,
          _this3 = this;

      var containerEvents = (_containerEvents = {}, _defineProperty(_containerEvents, Events$1.CONTAINER_TIMEUPDATE, this.timeUpdate), _defineProperty(_containerEvents, Events$1.CONTAINER_PLAY, this.onPlay), _defineProperty(_containerEvents, Events$1.CONTAINER_PAUSE, this.onPause), _defineProperty(_containerEvents, Events$1.CONTAINER_ERROR, this.onError), _defineProperty(_containerEvents, Events$1.CONTAINER_SEEK, this.onSeek), _defineProperty(_containerEvents, Events$1.CONTAINER_STATE_BUFFERING, this.onBuffering), _containerEvents);

      var playbackEvents = _defineProperty({}, Events$1.PLAYBACK_ENDED, this.onEnded);

      Object.keys(containerEvents).forEach(function (eventName) {
        var eventHandler = containerEvents[eventName];

        _this3.stopListening(_this3.container, eventName, eventHandler);

        _this3.listenTo(_this3.container, eventName, eventHandler);
      });
      Object.keys(playbackEvents).forEach(function (eventName) {
        var eventHandler = playbackEvents[eventName];

        _this3.stopListening(_this3.container.playback, eventName, eventHandler);

        _this3.listenTo(_this3.container.playback, eventName, eventHandler);
      });
    }
  }, {
    key: "setupStart",
    value: function setupStart(video) {
      var _this4 = this;

      this.video = video;

      if ((this.isReady || window.ns_) && (this.dfpReady || !this.waitForDFP)) {
        this.start();
        !this.waitForDFP && this.bindPlaybackEvents();
      } else {
        this.listenToOnce(this, Events.STREAMSENSE_READY, function () {
          return _this4.setupStart(video);
        });
      }
    }
  }, {
    key: "checkAd",
    value: function checkAd(error) {
      this.adError = error;
      this.dfpReady = true;
      !this.started && this.setupStart(this.video);
      this.bindPlaybackEvents();
    }
  }, {
    key: "ready",
    value: function ready() {
      if (window.ns_) {
        this.isReady = true;
        this.trigger(Events.STREAMSENSE_READY);
      } else {
        this.disable();
      }
    }
  }, {
    key: "embedScript",
    value: function embedScript() {
      var _this5 = this;

      if (!window.ns_ || !window.ns_.StreamingAnalytics) {
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('async', 'async');
        script.setAttribute('src', this.streamsenseScript);

        script.onload = function () {
          return _this5.ready();
        };

        script.onerror = function () {
          return _this5.ready();
        };

        document.head.appendChild(script);
      }
    }
  }, {
    key: "start",
    value: function start() {
      if (this.video && ns_.StreamingAnalytics) {
        this.streamSense = new ns_.StreamingAnalytics({
          liveEndpointURL: this.scorecardMeasurement
        });
        this.setStreamSenseInitData();
        this.setClip();
        this.started = true;
      }
    }
  }, {
    key: "setStreamSenseInitData",
    value: function setStreamSenseInitData() {
      var version = PLAYER_VERSION;
      this.streamSense.setLabels && this.streamSense.setLabels({
        ns_st_mp: 'Player',
        ns_st_mv: version
      });
      this.streamSense.createPlaybackSession && this.streamSense.createPlaybackSession({
        ns_st_pl: this.video.program + '-' + this.video.title
      });
    }
  }, {
    key: "getSubdomain",
    value: function getSubdomain(hostname) {
      if (hostname) {
        var match = hostname.match(GLOBOCOM_SUBDOMAIN_PATTERN$1) || hostname.match(TECHTUDO_PATTERN$1);
        return match ? match[1] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "setClip",
    value: function setClip() {
      var streamSenseTypes = {
        'short': 'vc11',
        'full': 'vc12',
        'live': 'vc13',
        'collaborative': 'vc21',
        'ad': 'va00'
      };
      var type = streamSenseTypes[this.contentType];
      var url = this.container.options.dax && this.container.options.dax.url;
      var domain = this.container.options.dax && this.container.options.dax;
      domain || (domain = this.container.options.domain);
      var reportedDomain = domain || url && new URL(url).hostname || document.location.hostname;
      var clipLabels = {
        c3: this.getSubdomain(reportedDomain),
        // subdomain of the page in which the video is embedded
        c4: this.video.channel,
        // broadcasting station
        ns_st_ty: type,
        // clip type
        ns_st_ct: this.contentType,
        // content type (long form (duration greater than 10 minutes) - vc12, short form (duration less than 10 minutes) - vc11, live - vc13, advertising, etc)
        ns_st_pr: this.video.program,
        // program title
        ns_st_ep: this.video.title,
        // episode title
        ns_st_st: this.video.channel,
        // broadcasting station
        ns_st_pu: 'Globo',
        // publisher brand name
        ns_st_ge: this.video.category,
        // genre
        ns_st_ci: '' + this.video.id,
        // asset id
        ns_st_cu: url || document.location.href,
        // clip url
        ns_st_cl: this.video.duration || 0,
        // clip length (0 for live)
        ns_st_cn: 1,
        // clip number
        ns_st_pn: 1,
        // part number
        ns_st_tp: 1,
        // total parts (0 for unknown)
        ns_st_ia: UNAVAILABLE_INFO,
        // Ad Load Flag
        ns_st_ce: UNAVAILABLE_INFO,
        // Complete Episode Flag // ask if it should be null or complete episode flag
        ns_st_ddt: UNAVAILABLE_INFO,
        // Digital Air Date
        ns_st_tdt: UNAVAILABLE_INFO // TV Airdate

      };
      Object.assign(clipLabels, this.options.daxExtras);
      this.streamSense.getPlaybackSession && this.streamSense.getPlaybackSession().setAsset(clipLabels);
    }
  }, {
    key: "timeUpdate",
    value: function timeUpdate(timeProgress) {
      this.currentTime = timeProgress.current;
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      if (this.started && !this.isAdPlayback) {
        this.streamSense.notifyPlay(this.currentTimeInMilliseconds);
      }
    }
  }, {
    key: "onPause",
    value: function onPause() {
      if (this.started && !this.isAdPlayback) {
        this.streamSense.notifyPause(this.currentTimeInMilliseconds);
      }
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      if (this.started && !this.isAdPlayback) {
        this.streamSense.notifyEnd(this.currentTimeInMilliseconds);
      }
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      if (this.started && !this.isAdPlayback && this.video && this.video.type === 'Live') {
        this.streamSense.notifyBufferStart(this.currentTimeInMilliseconds);
      }
    }
  }, {
    key: "onSeek",
    value: function onSeek() {
      this.onPause();
    }
  }, {
    key: "onError",
    value: function onError() {}
  }, {
    key: "toMilliseconds",
    value: function toMilliseconds(time) {
      return time * 1000 >> 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.started) {
        this.streamSense.notifyEnd(this.currentTimeInMilliseconds);
      }

      _get(_getPrototypeOf(StreamSense.prototype), "destroy", this).call(this);
    }
  }]);

  return StreamSense;
}(ContainerPlugin);

var Ajax = Utils$1.Ajax,
    loadUrlAsImage = Utils$1.loadUrlAsImage,
    hexGrf = Utils$1.hexGrf;

var WebmediaAPIHit = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(WebmediaAPIHit, _ContainerPlugin);

  var _super = _createSuper(WebmediaAPIHit);

  _createClass(WebmediaAPIHit, [{
    key: "name",
    get: function get() {
      return 'webmedia_api_hit';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "type",
    get: function get() {
      return Browser.isMobile ? 'mobile_browser' : 'desktop';
    }
  }, {
    key: "environment",
    get: function get() {
      return this.container.options.env;
    }
  }, {
    key: "webmediaApiHit",
    get: function get() {
      return this.environment.name === 'prod' || this.environment.name === 'local' ? "".concat(this.environment.protocol, "://stats.video.globo.com") : "".concat(this.environment.protocol, "://stats.video.dev.globoi.com");
    }
  }]);

  function WebmediaAPIHit(container) {
    var _this;

    _classCallCheck(this, WebmediaAPIHit);

    _this = _super.call(this, container);
    _this.url = _this.webmediaApiHit;
    return _this;
  }

  _createClass(WebmediaAPIHit, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.stopListening();
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this.fillIds);
      this.listenToOnce(this.container.playback, Events$1.PLAYBACK_PLAY, this.seed);
      this.listenToOnce(this.container.playback, Events$1.PLAYBACK_ENDED, this.bindEvents);
      this.listenToOnce(this.container.playback, Events$1.PLAYBACK_STOP, this.bindEvents);
    }
  }, {
    key: "fillIds",
    value: function fillIds(playlist) {
      this.videoId = playlist.id;
      this.programId = playlist.programId;
    }
  }, {
    key: "seed",
    value: function seed() {
      var _this2 = this;

      if (!this.videoId || !this.programId) {
        this.logError('no argument was passed');
        return;
      }

      var callbackName = "hitStats_".concat(+new Date());
      var statsPath = "/hits/".concat(this.videoId, "?type=").concat(this.type, "&callback=").concat(callbackName);
      var statsUrl = "".concat(this.url).concat(statsPath);
      Ajax.jsonp({
        url: statsUrl,
        callbackName: callbackName,
        timeout: 5000
      }).then(function (seed) {
        return _this2.hit(seed);
      }, this.logError);
    }
  }, {
    key: "hit",
    value: function hit(data) {
      var seed = data.data;
      var signed = "".concat(seed).concat(hexGrf(seed + 'w3bM3d!A'));
      var callbackName = "hitIncStats_".concat(+new Date());
      var statsPath = "/hits/".concat(this.videoId, "/").concat(this.programId, "/").concat(signed, "?type=").concat(this.type, "&callback=").concat(callbackName);
      var statsUrl = "".concat(this.url).concat(statsPath);
      loadUrlAsImage(statsUrl);
    }
  }, {
    key: "logError",
    value: function logError(error) {
      Log$1.error(this.name, 'Webmedia api hit was not possible because ', error);
    }
  }]);

  return WebmediaAPIHit;
}(ContainerPlugin);

var BLOCK_PATTERN = /\n?(\r?\n){2}/;
var LINES_PATTERN = /\r?\n/;
var TIME_PATTERN = /([0-9]{2}):([0-9]{2}):([0-9]{2}),([0-9]*)?/;
var TIME_SPLIT_PATTERN = /[0-9:,]+/g;
var SPACES_PATTERN = /[^\S\r\n]+$/gm;

var SrtParser = /*#__PURE__*/function () {
  function SrtParser(subtitlesText) {
    var _this = this;

    _classCallCheck(this, SrtParser);

    this.subtitleItems = [];
    var blocks = subtitlesText.replace(SPACES_PATTERN, '').split(BLOCK_PATTERN);
    var validBlocks = blocks.filter(function (block) {
      return _this.isValid(block);
    });
    this.subtitleItems = validBlocks.map(function (block) {
      return _this.parseSubtitle(block);
    });
  }

  _createClass(SrtParser, [{
    key: "isCurrentSubtitle",
    value: function isCurrentSubtitle() {
      var subtitleItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var timeMillis = arguments.length > 1 ? arguments[1] : undefined;
      return timeMillis >= subtitleItem.start && timeMillis <= subtitleItem.end;
    }
  }, {
    key: "getSubtitleAt",
    value: function getSubtitleAt() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.subtitleItems[index];
    }
  }, {
    key: "getSubtitleBy",
    value: function getSubtitleBy(timeMillis) {
      var start = 0;
      var stop = this.subtitleItems.length - 1;
      var index = Math.floor((start + stop) / 2);

      while (!this.isCurrentSubtitle(this.subtitleItems[index], timeMillis) && start < stop) {
        if (timeMillis > this.subtitleItems[index].start) {
          start = index + 1;
        } else {
          stop = index - 1;
        }

        index = Math.floor((start + stop) / 2);
      }

      var found = this.isCurrentSubtitle(this.subtitleItems[index], timeMillis);
      return found ? {
        index: index,
        subtitle: this.subtitleItems[index]
      } : undefined;
    }
  }, {
    key: "isValid",
    value: function isValid(value) {
      return value && value.trim() !== '';
    }
  }, {
    key: "millisFromTimestamp",
    value: function millisFromTimestamp(match) {
      match = match.match(TIME_PATTERN);
      var millis = parseInt(match[1], 10) * 60 * 60 * 1000;
      millis += parseInt(match[2], 10) * 60 * 1000;
      millis += parseInt(match[3], 10) * 1000;

      if (match[4]) {
        millis += parseInt(match[4], 10);
      }

      return millis;
    }
  }, {
    key: "parseSubtitle",
    value: function parseSubtitle(block) {
      var START_TIME = 0,
          END_TIME = 1,
          start = -1,
          end = -1;
      var content = '';
      var blockLines = block.split(LINES_PATTERN);
      var hasValidBlockLines = blockLines.length >= 2;

      if (hasValidBlockLines) {
        var timeMatcher = blockLines[1].match(TIME_SPLIT_PATTERN);

        if (timeMatcher[START_TIME]) {
          start = this.millisFromTimestamp(timeMatcher[START_TIME]);
        }

        if (timeMatcher[END_TIME]) {
          end = this.millisFromTimestamp(timeMatcher[END_TIME]);
        }

        var hasStartAndEnd = start !== -1 && end !== -1;

        if (hasStartAndEnd) {
          var blockLinesContent = blockLines.slice(2);
          content = blockLinesContent.join('<br>');
        }

        return {
          start: start,
          end: end,
          content: content
        };
      }
    }
  }]);

  return SrtParser;
}();

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof commonjsGlobal !== "undefined") {
    win = commonjsGlobal;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

var window_1 = win;

var slice = Array.prototype.slice;

var domWalk = iterativelyWalk;

function iterativelyWalk(nodes, cb) {
    if (!('length' in nodes)) {
        nodes = [nodes];
    }
    
    nodes = slice.call(nodes);

    while(nodes.length) {
        var node = nodes.shift(),
            ret = cb(node);

        if (ret) {
            return ret
        }

        if (node.childNodes && node.childNodes.length) {
            nodes = slice.call(node.childNodes).concat(nodes);
        }
    }
}

var domComment = Comment;

function Comment(data, owner) {
    if (!(this instanceof Comment)) {
        return new Comment(data, owner)
    }

    this.data = data;
    this.nodeValue = data;
    this.length = data.length;
    this.ownerDocument = owner || null;
}

Comment.prototype.nodeType = 8;
Comment.prototype.nodeName = "#comment";

Comment.prototype.toString = function _Comment_toString() {
    return "[object Comment]"
};

var domText = DOMText;

function DOMText(value, owner) {
    if (!(this instanceof DOMText)) {
        return new DOMText(value)
    }

    this.data = value || "";
    this.length = this.data.length;
    this.ownerDocument = owner || null;
}

DOMText.prototype.type = "DOMTextNode";
DOMText.prototype.nodeType = 3;
DOMText.prototype.nodeName = "#text";

DOMText.prototype.toString = function _Text_toString() {
    return this.data
};

DOMText.prototype.replaceData = function replaceData(index, length, value) {
    var current = this.data;
    var left = current.substring(0, index);
    var right = current.substring(index + length, current.length);
    this.data = left + value + right;
    this.length = this.data.length;
};

var dispatchEvent_1 = dispatchEvent;

function dispatchEvent(ev) {
    var elem = this;
    var type = ev.type;

    if (!ev.target) {
        ev.target = elem;
    }

    if (!elem.listeners) {
        elem.listeners = {};
    }

    var listeners = elem.listeners[type];

    if (listeners) {
        return listeners.forEach(function (listener) {
            ev.currentTarget = elem;
            if (typeof listener === 'function') {
                listener(ev);
            } else {
                listener.handleEvent(ev);
            }
        })
    }

    if (elem.parentNode) {
        elem.parentNode.dispatchEvent(ev);
    }
}

var addEventListener_1 = addEventListener;

function addEventListener(type, listener) {
    var elem = this;

    if (!elem.listeners) {
        elem.listeners = {};
    }

    if (!elem.listeners[type]) {
        elem.listeners[type] = [];
    }

    if (elem.listeners[type].indexOf(listener) === -1) {
        elem.listeners[type].push(listener);
    }
}

var removeEventListener_1 = removeEventListener;

function removeEventListener(type, listener) {
    var elem = this;

    if (!elem.listeners) {
        return
    }

    if (!elem.listeners[type]) {
        return
    }

    var list = elem.listeners[type];
    var index = list.indexOf(listener);
    if (index !== -1) {
        list.splice(index, 1);
    }
}

var serialize = serializeNode;

var voidElements = ["area","base","br","col","embed","hr","img","input","keygen","link","menuitem","meta","param","source","track","wbr"];

function serializeNode(node) {
    switch (node.nodeType) {
        case 3:
            return escapeText(node.data)
        case 8:
            return "<!--" + node.data + "-->"
        default:
            return serializeElement(node)
    }
}

function serializeElement(elem) {
    var strings = [];

    var tagname = elem.tagName;

    if (elem.namespaceURI === "http://www.w3.org/1999/xhtml") {
        tagname = tagname.toLowerCase();
    }

    strings.push("<" + tagname + properties(elem) + datasetify(elem));

    if (voidElements.indexOf(tagname) > -1) {
        strings.push(" />");
    } else {
        strings.push(">");

        if (elem.childNodes.length) {
            strings.push.apply(strings, elem.childNodes.map(serializeNode));
        } else if (elem.textContent || elem.innerText) {
            strings.push(escapeText(elem.textContent || elem.innerText));
        } else if (elem.innerHTML) {
            strings.push(elem.innerHTML);
        }

        strings.push("</" + tagname + ">");
    }

    return strings.join("")
}

function isProperty(elem, key) {
    var type = typeof elem[key];

    if (key === "style" && Object.keys(elem.style).length > 0) {
      return true
    }

    return elem.hasOwnProperty(key) &&
        (type === "string" || type === "boolean" || type === "number") &&
        key !== "nodeName" && key !== "className" && key !== "tagName" &&
        key !== "textContent" && key !== "innerText" && key !== "namespaceURI" &&  key !== "innerHTML"
}

function stylify(styles) {
    if (typeof styles === 'string') return styles
    var attr = "";
    Object.keys(styles).forEach(function (key) {
        var value = styles[key];
        key = key.replace(/[A-Z]/g, function(c) {
            return "-" + c.toLowerCase();
        });
        attr += key + ":" + value + ";";
    });
    return attr
}

function datasetify(elem) {
    var ds = elem.dataset;
    var props = [];

    for (var key in ds) {
        props.push({ name: "data-" + key, value: ds[key] });
    }

    return props.length ? stringify(props) : ""
}

function stringify(list) {
    var attributes = [];
    list.forEach(function (tuple) {
        var name = tuple.name;
        var value = tuple.value;

        if (name === "style") {
            value = stylify(value);
        }

        attributes.push(name + "=" + "\"" + escapeAttributeValue(value) + "\"");
    });

    return attributes.length ? " " + attributes.join(" ") : ""
}

function properties(elem) {
    var props = [];
    for (var key in elem) {
        if (isProperty(elem, key)) {
            props.push({ name: key, value: elem[key] });
        }
    }

    for (var ns in elem._attributes) {
      for (var attribute in elem._attributes[ns]) {
        var prop = elem._attributes[ns][attribute];
        var name = (prop.prefix ? prop.prefix + ":" : "") + attribute;
        props.push({ name: name, value: prop.value });
      }
    }

    if (elem.className) {
        props.push({ name: "class", value: elem.className });
    }

    return props.length ? stringify(props) : ""
}

function escapeText(s) {
    var str = '';

    if (typeof(s) === 'string') { 
        str = s; 
    } else if (s) {
        str = s.toString();
    }

    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
}

function escapeAttributeValue(str) {
    return escapeText(str).replace(/"/g, "&quot;")
}

var htmlns = "http://www.w3.org/1999/xhtml";

var domElement = DOMElement;

function DOMElement(tagName, owner, namespace) {
    if (!(this instanceof DOMElement)) {
        return new DOMElement(tagName)
    }

    var ns = namespace === undefined ? htmlns : (namespace || null);

    this.tagName = ns === htmlns ? String(tagName).toUpperCase() : tagName;
    this.nodeName = this.tagName;
    this.className = "";
    this.dataset = {};
    this.childNodes = [];
    this.parentNode = null;
    this.style = {};
    this.ownerDocument = owner || null;
    this.namespaceURI = ns;
    this._attributes = {};

    if (this.tagName === 'INPUT') {
      this.type = 'text';
    }
}

DOMElement.prototype.type = "DOMElement";
DOMElement.prototype.nodeType = 1;

DOMElement.prototype.appendChild = function _Element_appendChild(child) {
    if (child.parentNode) {
        child.parentNode.removeChild(child);
    }

    this.childNodes.push(child);
    child.parentNode = this;

    return child
};

DOMElement.prototype.replaceChild =
    function _Element_replaceChild(elem, needle) {
        // TODO: Throw NotFoundError if needle.parentNode !== this

        if (elem.parentNode) {
            elem.parentNode.removeChild(elem);
        }

        var index = this.childNodes.indexOf(needle);

        needle.parentNode = null;
        this.childNodes[index] = elem;
        elem.parentNode = this;

        return needle
    };

DOMElement.prototype.removeChild = function _Element_removeChild(elem) {
    // TODO: Throw NotFoundError if elem.parentNode !== this

    var index = this.childNodes.indexOf(elem);
    this.childNodes.splice(index, 1);

    elem.parentNode = null;
    return elem
};

DOMElement.prototype.insertBefore =
    function _Element_insertBefore(elem, needle) {
        // TODO: Throw NotFoundError if referenceElement is a dom node
        // and parentNode !== this

        if (elem.parentNode) {
            elem.parentNode.removeChild(elem);
        }

        var index = needle === null || needle === undefined ?
            -1 :
            this.childNodes.indexOf(needle);

        if (index > -1) {
            this.childNodes.splice(index, 0, elem);
        } else {
            this.childNodes.push(elem);
        }

        elem.parentNode = this;
        return elem
    };

DOMElement.prototype.setAttributeNS =
    function _Element_setAttributeNS(namespace, name, value) {
        var prefix = null;
        var localName = name;
        var colonPosition = name.indexOf(":");
        if (colonPosition > -1) {
            prefix = name.substr(0, colonPosition);
            localName = name.substr(colonPosition + 1);
        }
        if (this.tagName === 'INPUT' && name === 'type') {
          this.type = value;
        }
        else {
          var attributes = this._attributes[namespace] || (this._attributes[namespace] = {});
          attributes[localName] = {value: value, prefix: prefix};
        }
    };

DOMElement.prototype.getAttributeNS =
    function _Element_getAttributeNS(namespace, name) {
        var attributes = this._attributes[namespace];
        var value = attributes && attributes[name] && attributes[name].value;
        if (this.tagName === 'INPUT' && name === 'type') {
          return this.type;
        }
        if (typeof value !== "string") {
            return null
        }
        return value
    };

DOMElement.prototype.removeAttributeNS =
    function _Element_removeAttributeNS(namespace, name) {
        var attributes = this._attributes[namespace];
        if (attributes) {
            delete attributes[name];
        }
    };

DOMElement.prototype.hasAttributeNS =
    function _Element_hasAttributeNS(namespace, name) {
        var attributes = this._attributes[namespace];
        return !!attributes && name in attributes;
    };

DOMElement.prototype.setAttribute = function _Element_setAttribute(name, value) {
    return this.setAttributeNS(null, name, value)
};

DOMElement.prototype.getAttribute = function _Element_getAttribute(name) {
    return this.getAttributeNS(null, name)
};

DOMElement.prototype.removeAttribute = function _Element_removeAttribute(name) {
    return this.removeAttributeNS(null, name)
};

DOMElement.prototype.hasAttribute = function _Element_hasAttribute(name) {
    return this.hasAttributeNS(null, name)
};

DOMElement.prototype.removeEventListener = removeEventListener_1;
DOMElement.prototype.addEventListener = addEventListener_1;
DOMElement.prototype.dispatchEvent = dispatchEvent_1;

// Un-implemented
DOMElement.prototype.focus = function _Element_focus() {
    return void 0
};

DOMElement.prototype.toString = function _Element_toString() {
    return serialize(this)
};

DOMElement.prototype.getElementsByClassName = function _Element_getElementsByClassName(classNames) {
    var classes = classNames.split(" ");
    var elems = [];

    domWalk(this, function (node) {
        if (node.nodeType === 1) {
            var nodeClassName = node.className || "";
            var nodeClasses = nodeClassName.split(" ");

            if (classes.every(function (item) {
                return nodeClasses.indexOf(item) !== -1
            })) {
                elems.push(node);
            }
        }
    });

    return elems
};

DOMElement.prototype.getElementsByTagName = function _Element_getElementsByTagName(tagName) {
    tagName = tagName.toLowerCase();
    var elems = [];

    domWalk(this.childNodes, function (node) {
        if (node.nodeType === 1 && (tagName === '*' || node.tagName.toLowerCase() === tagName)) {
            elems.push(node);
        }
    });

    return elems
};

DOMElement.prototype.contains = function _Element_contains(element) {
    return domWalk(this, function (node) {
        return element === node
    }) || false
};

var domFragment = DocumentFragment;

function DocumentFragment(owner) {
    if (!(this instanceof DocumentFragment)) {
        return new DocumentFragment()
    }

    this.childNodes = [];
    this.parentNode = null;
    this.ownerDocument = owner || null;
}

DocumentFragment.prototype.type = "DocumentFragment";
DocumentFragment.prototype.nodeType = 11;
DocumentFragment.prototype.nodeName = "#document-fragment";

DocumentFragment.prototype.appendChild  = domElement.prototype.appendChild;
DocumentFragment.prototype.replaceChild = domElement.prototype.replaceChild;
DocumentFragment.prototype.removeChild  = domElement.prototype.removeChild;

DocumentFragment.prototype.toString =
    function _DocumentFragment_toString() {
        return this.childNodes.map(function (node) {
            return String(node)
        }).join("")
    };

var event = Event$1;

function Event$1(family) {}

Event$1.prototype.initEvent = function _Event_initEvent(type, bubbles, cancelable) {
    this.type = type;
    this.bubbles = bubbles;
    this.cancelable = cancelable;
};

Event$1.prototype.preventDefault = function _Event_preventDefault() {
    
};

var document$1 = Document$1;

function Document$1() {
    if (!(this instanceof Document$1)) {
        return new Document$1();
    }

    this.head = this.createElement("head");
    this.body = this.createElement("body");
    this.documentElement = this.createElement("html");
    this.documentElement.appendChild(this.head);
    this.documentElement.appendChild(this.body);
    this.childNodes = [this.documentElement];
    this.nodeType = 9;
}

var proto = Document$1.prototype;
proto.createTextNode = function createTextNode(value) {
    return new domText(value, this)
};

proto.createElementNS = function createElementNS(namespace, tagName) {
    var ns = namespace === null ? null : String(namespace);
    return new domElement(tagName, this, ns)
};

proto.createElement = function createElement(tagName) {
    return new domElement(tagName, this)
};

proto.createDocumentFragment = function createDocumentFragment() {
    return new domFragment(this)
};

proto.createEvent = function createEvent(family) {
    return new event(family)
};

proto.createComment = function createComment(data) {
    return new domComment(data, this)
};

proto.getElementById = function getElementById(id) {
    id = String(id);

    var result = domWalk(this.childNodes, function (node) {
        if (String(node.id) === id) {
            return node
        }
    });

    return result || null
};

proto.getElementsByClassName = domElement.prototype.getElementsByClassName;
proto.getElementsByTagName = domElement.prototype.getElementsByTagName;
proto.contains = domElement.prototype.contains;

proto.removeEventListener = removeEventListener_1;
proto.addEventListener = addEventListener_1;
proto.dispatchEvent = dispatchEvent_1;

var minDocument = new document$1();

var topLevel = typeof commonjsGlobal !== 'undefined' ? commonjsGlobal :
    typeof window !== 'undefined' ? window : {};


var doccy;

if (typeof document !== 'undefined') {
    doccy = document;
} else {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];

    if (!doccy) {
        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDocument;
    }
}

var document_1 = doccy;

// Try to parse input as a time stamp.
function parseTimeStamp(input) {

  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
  }

  var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  if (!m) {
    return null;
  }

  if (m[3]) {
    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
  } else if (m[1] > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0,  m[4]);
  } else {
    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
  }
}

var parseTimestamp = parseTimeStamp;

// When evaluating this file as part of a Webpack bundle for server
// side rendering, `document` is an empty object.
var TEXTAREA_ELEMENT = document_1.createElement && document_1.createElement("textarea");

var NEEDS_PARENT = {
  rt: "ruby"
};

var TAG_NAME = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
};

var TAG_ANNOTATION = {
  v: "title",
  lang: "lang"
};

// 5.1 default text color
// 5.2 default text background color is equivalent to text color with bg_ prefix
var DEFAULT_COLOR_CLASS = {
  white: 'rgba(255,255,255,1)',
  lime: 'rgba(0,255,0,1)',
  cyan: 'rgba(0,255,255,1)',
  red: 'rgba(255,0,0,1)',
  yellow: 'rgba(255,255,0,1)',
  magenta: 'rgba(255,0,255,1)',
  blue: 'rgba(0,0,255,1)',
  black: 'rgba(0,0,0,1)'
};

// Parse content into a document fragment.
function parseContent(window, input) {
  function nextToken() {
    // Check for end-of-string.
    if (!input) {
      return null;
    }

    // Consume 'n' characters from the input.
    function consume(result) {
      input = input.substr(result.length);
      return result;
    }

    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
    // If there is some text before the next tag, return it, otherwise return
    // the tag.
    return consume(m[1] ? m[1] : m[2]);
  }

  function unescape(s) {
    TEXTAREA_ELEMENT.innerHTML = s;
    s = TEXTAREA_ELEMENT.textContent;
    TEXTAREA_ELEMENT.textContent = "";
    return s;
  }

  function shouldAdd(current, element) {
    return !NEEDS_PARENT[element.localName] ||
           NEEDS_PARENT[element.localName] === current.localName;
  }

  // Create an element for this tag.
  function createElement(type, annotation) {
    var tagName = TAG_NAME[type];
    if (!tagName) {
      return null;
    }
    var element = window.document.createElement(tagName);
    var name = TAG_ANNOTATION[type];
    if (name && annotation) {
      element[name] = annotation.trim();
    }
    return element;
  }

  var rootDiv = window.document.createElement("div"),
      current = rootDiv,
      t,
      tagStack = [];

  while ((t = nextToken()) !== null) {
    if (t[0] === '<') {
      if (t[1] === "/") {
        // If the closing tag matches, move back up to the parent node.
        if (tagStack.length &&
            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
          tagStack.pop();
          current = current.parentNode;
        }
        // Otherwise just ignore the end tag.
        continue;
      }
      var ts = parseTimestamp(t.substr(1, t.length - 2));
      var node;
      if (ts) {
        // Timestamps are lead nodes as well.
        node = window.document.createProcessingInstruction("timestamp", ts);
        current.appendChild(node);
        continue;
      }
      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      // If we can't parse the tag, skip to the next tag.
      if (!m) {
        continue;
      }
      // Try to construct an element, and ignore the tag if we couldn't.
      node = createElement(m[1], m[3]);
      if (!node) {
        continue;
      }
      // Determine if the tag should be added based on the context of where it
      // is placed in the cuetext.
      if (!shouldAdd(current, node)) {
        continue;
      }
      // Set the class list (as a list of classes, separated by space).
      if (m[2]) {
        var classes = m[2].split('.');

        classes.forEach(function(cl) {
          var bgColor = /^bg_/.test(cl);
          // slice out `bg_` if it's a background color
          var colorName = bgColor ? cl.slice(3) : cl;

          if (Object.prototype.hasOwnProperty.call(DEFAULT_COLOR_CLASS, colorName)) {
            var propName = bgColor ? 'background-color' : 'color';
            var propValue = DEFAULT_COLOR_CLASS[colorName];

            node.style[propName] = propValue;
          }
        });

        node.className = classes.join(' ');
      }
      // Append the node to the current node, and enter the scope of the new
      // node.
      tagStack.push(m[1]);
      current.appendChild(node);
      current = node;
      continue;
    }

    // Text nodes are leaf nodes.
    current.appendChild(window.document.createTextNode(unescape(t)));
  }

  return rootDiv;
}

var parseContent_1 = parseContent;

var convertCueToDOMTree = function(window, cuetext) {
  if (!window || !cuetext) {
    return null;
  }
  return parseContent_1(window, cuetext);
};

var convertCueToDomTree = convertCueToDOMTree;

// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function BoxPosition(obj) {
  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
  // was passed in and we need to copy the results of 'getBoundingClientRect'
  // as the object returned is readonly. All co-ordinate values are in reference
  // to the viewport origin (top left).
  var lh, height, width, top;
  if (obj.div) {
    height = obj.div.offsetHeight;
    width = obj.div.offsetWidth;
    top = obj.div.offsetTop;

    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
                rects.getClientRects && rects.getClientRects();
    obj = obj.div.getBoundingClientRect();
    // In certain cases the outter div will be slightly larger then the sum of
    // the inner div's lines. This could be due to bold text, etc, on some platforms.
    // In this case we should get the average line height and use that. This will
    // result in the desired behaviour.
    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
               : 0;

  }
  this.left = obj.left;
  this.right = obj.right;
  this.top = obj.top || top;
  this.height = obj.height || height;
  this.bottom = obj.bottom || (top + (obj.height || height));
  this.width = obj.width || width;
  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
}

// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
BoxPosition.prototype.move = function(axis, toMove) {
  toMove = toMove !== undefined ? toMove : this.lineHeight;
  switch (axis) {
  case "+x":
    this.left += toMove;
    this.right += toMove;
    break;
  case "-x":
    this.left -= toMove;
    this.right -= toMove;
    break;
  case "+y":
    this.top += toMove;
    this.bottom += toMove;
    break;
  case "-y":
    this.top -= toMove;
    this.bottom -= toMove;
    break;
  }
};

// Check if this box overlaps another box, b2.
BoxPosition.prototype.overlaps = function(b2) {
  return this.left < b2.right &&
         this.right > b2.left &&
         this.top < b2.bottom &&
         this.bottom > b2.top;
};

// Check if this box overlaps any other boxes in boxes.
BoxPosition.prototype.overlapsAny = function(boxes) {
  for (var i = 0; i < boxes.length; i++) {
    if (this.overlaps(boxes[i])) {
      return true;
    }
  }
  return false;
};

// Check if this box is within another box.
BoxPosition.prototype.within = function(container) {
  return this.top >= container.top &&
         this.bottom <= container.bottom &&
         this.left >= container.left &&
         this.right <= container.right;
};

// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
  switch (axis) {
  case "+x":
    return this.left < container.left;
  case "-x":
    return this.right > container.right;
  case "+y":
    return this.top < container.top;
  case "-y":
    return this.bottom > container.bottom;
  }
};

// Find the percentage of the area that this box is overlapping with another
// box.
BoxPosition.prototype.intersectPercentage = function(b2) {
  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
      intersectArea = x * y;
  return intersectArea / (this.height * this.width);
};

// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
BoxPosition.prototype.toCSSCompatValues = function(reference) {
  return {
    top: this.top - reference.top,
    bottom: reference.bottom - this.bottom,
    left: this.left - reference.left,
    right: reference.right - this.right,
    height: this.height,
    width: this.width
  };
};

// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
BoxPosition.getSimpleBoxPosition = function(obj) {
  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;

  obj = obj.div ? obj.div.getBoundingClientRect() :
                obj.tagName ? obj.getBoundingClientRect() : obj;
  var ret = {
    left: obj.left,
    right: obj.right,
    top: obj.top || top,
    height: obj.height || height,
    bottom: obj.bottom || (top + (obj.height || height)),
    width: obj.width || width
  };
  return ret;
};

var boxPosition = BoxPosition;

function StyleBox() {
}

// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
StyleBox.prototype.applyStyles = function(styles, div) {
  div = div || this.div;
  for (var prop in styles) {
    if (Object.prototype.hasOwnProperty.call(styles, prop)) {
      div.style[prop] = styles[prop];
    }
  }
};

StyleBox.prototype.formatStyle = function(val, unit) {
  return val === 0 ? 0 : val + unit;
};

var styleBox = StyleBox;

// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];

function isStrongRTLChar(charCode) {
  for (var i = 0; i < strongRTLRanges.length; i++) {
    var currentRange = strongRTLRanges[i];
    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
      return true;
    }
  }

  return false;
}

var isStrongRtlChar = isStrongRTLChar;

function determineBidi(cueDiv) {
  var nodeStack = [],
      text = "",
      charCode;

  if (!cueDiv || !cueDiv.childNodes) {
    return "ltr";
  }

  function pushNodes(nodeStack, node) {
    for (var i = node.childNodes.length - 1; i >= 0; i--) {
      nodeStack.push(node.childNodes[i]);
    }
  }

  function nextTextNode(nodeStack) {
    if (!nodeStack || !nodeStack.length) {
      return null;
    }

    var node = nodeStack.pop(),
        text = node.textContent || node.innerText;
    if (text) {
      // TODO: This should match all unicode type B characters (paragraph
      // separator characters). See issue #115.
      var m = text.match(/^.*(\n|\r)/);
      if (m) {
        nodeStack.length = 0;
        return m[0];
      }
      return text;
    }
    if (node.tagName === "ruby") {
      return nextTextNode(nodeStack);
    }
    if (node.childNodes) {
      pushNodes(nodeStack, node);
      return nextTextNode(nodeStack);
    }
  }

  pushNodes(nodeStack, cueDiv);
  while ((text = nextTextNode(nodeStack))) {
    for (var i = 0; i < text.length; i++) {
      charCode = text.charCodeAt(i);
      if (isStrongRtlChar(charCode)) {
        return "rtl";
      }
    }
  }
  return "ltr";
}

var determineBidi_1 = determineBidi;

// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function CueStyleBox(window, cue, styleOptions) {
  styleBox.call(this);
  this.cue = cue;

  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
  // have inline positioning and will function as the cue background box.
  this.cueDiv = parseContent_1(window, cue.text);
  var styles = {
    color: styleOptions.color || "rgba(255, 255, 255, 1)",
    backgroundColor: styleOptions.backgroundColor || "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: styleOptions.display || "inline",
    writingMode: cue.vertical === "" ? "horizontal-tb"
                                     : cue.vertical === "lr" ? "vertical-lr"
                                                             : "vertical-rl",
    unicodeBidi: "plaintext",
    padding: styleOptions.padding,
    borderRadius: styleOptions.borderRadius
  };

  this.applyStyles(styles, this.cueDiv);

  // Create an absolutely positioned div that will be used to position the cue
  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
  // mirrors of them except middle instead of center on Safari.
  this.div = window.document.createElement("div");
  styles = {
    direction: determineBidi_1(this.cueDiv),
    writingMode: cue.vertical === "" ? "horizontal-tb"
                                     : cue.vertical === "lr" ? "vertical-lr"
                                                             : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: cue.align === "middle" ? "center" : cue.align,
    font: styleOptions.font,
    whiteSpace: "pre-line",
    position: "absolute"
  };

  this.applyStyles(styles);
  this.div.appendChild(this.cueDiv);

  // Calculate the distance from the reference edge of the viewport to the text
  // position of the cue box. The reference edge will be resolved later when
  // the box orientation styles are applied.
  var textPos = 0;
  switch (cue.positionAlign) {
  case "start":
    textPos = cue.position;
    break;
  case "center":
    textPos = cue.position - (cue.size / 2);
    break;
  case "end":
    textPos = cue.position - cue.size;
    break;
  }

  // Horizontal box orientation; textPos is the distance from the left edge of the
  // area to the left edge of the box and cue.size is the distance extending to
  // the right from there.
  if (cue.vertical === "") {
    this.applyStyles({
      left:  this.formatStyle(textPos, "%"),
      width: this.formatStyle(cue.size, "%")
    });
  // Vertical box orientation; textPos is the distance from the top edge of the
  // area to the top edge of the box and cue.size is the height extending
  // downwards from there.
  } else {
    this.applyStyles({
      top: this.formatStyle(textPos, "%"),
      height: this.formatStyle(cue.size, "%")
    });
  }

  this.move = function(box) {
    this.applyStyles({
      top: this.formatStyle(box.top, "px"),
      bottom: this.formatStyle(box.bottom, "px"),
      left: this.formatStyle(box.left, "px"),
      right: this.formatStyle(box.right, "px"),
      height: this.formatStyle(box.height, "px"),
      width: this.formatStyle(box.width, "px")
    });
  };
}
CueStyleBox.prototype = Object.create(styleBox.prototype);
CueStyleBox.prototype.constructor = CueStyleBox;

var cueStyleBox = CueStyleBox;

function computeLinePos(cue) {
  if (typeof cue.line === "number" &&
      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
    return cue.line;
  }
  if (!cue.track || !cue.track.textTrackList ||
      !cue.track.textTrackList.mediaElement) {
    return -1;
  }
  var track = cue.track,
      trackList = track.textTrackList,
      count = 0;
  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
    if (trackList[i].mode === "showing") {
      count++;
    }
  }
  return ++count * -1;
}

var computeLinePos_1 = computeLinePos;

// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {

  // Find the best position for a cue box, b, on the video. The axis parameter
  // is a list of axis, the order of which, it will move the box along. For example:
  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
  // direction. If it doesn't find a good position for it there it will then move
  // it along the x axis in the negative direction.
  function findBestPosition(b, axis) {
    var bestPosition,
        specifiedPosition = new boxPosition(b),
        percentage = 1; // Highest possible so the first thing we get is better.

    for (var i = 0; i < axis.length; i++) {
      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
        b.move(axis[i]);
      }
      // We found a spot where we aren't overlapping anything. This is our
      // best position.
      if (b.within(containerBox)) {
        return b;
      }
      var p = b.intersectPercentage(containerBox);
      // If we're outside the container box less then we were on our last try
      // then remember this position as the best position.
      if (percentage > p) {
        bestPosition = new boxPosition(b);
        percentage = p;
      }
      // Reset the box position to the specified position.
      b = new boxPosition(specifiedPosition);
    }
    return bestPosition || specifiedPosition;
  }

  var boxPosition$1 = new boxPosition(styleBox),
      cue = styleBox.cue,
      linePos = computeLinePos_1(cue),
      axis = [];

  // If we have a line number to align the cue to.
  if (cue.snapToLines) {
    var size;
    switch (cue.vertical) {
    case "":
      axis = [ "+y", "-y" ];
      size = "height";
      break;
    case "rl":
      axis = [ "+x", "-x" ];
      size = "width";
      break;
    case "lr":
      axis = [ "-x", "+x" ];
      size = "width";
      break;
    }

    var step = boxPosition$1.lineHeight,
        position = step * Math.round(linePos),
        maxPosition = containerBox[size] + step,
        initialAxis = axis[0];

    // If the specified intial position is greater then the max position then
    // clamp the box to the amount of steps it would take for the box to
    // reach the max position.
    if (Math.abs(position) > maxPosition) {
      position = position < 0 ? -1 : 1;
      position *= Math.ceil(maxPosition / step) * step;
    }

    // If computed line position returns negative then line numbers are
    // relative to the bottom of the video instead of the top. Therefore, we
    // need to increase our initial position by the length or width of the
    // video, depending on the writing direction, and reverse our axis directions.
    if (linePos < 0) {
      position += cue.vertical === "" ? containerBox.height : containerBox.width;
      axis = axis.reverse();
    }

    // Move the box to the specified position. This may not be its best
    // position.
    boxPosition$1.move(initialAxis, position);

  } else {
    // If we have a percentage line value for the cue.
    var calculatedPercentage = (boxPosition$1.lineHeight / containerBox.height) * 100;

    switch (cue.lineAlign) {
    case "center":
      linePos -= (calculatedPercentage / 2);
      break;
    case "end":
      linePos -= calculatedPercentage;
      break;
    }

    // Apply initial line position to the cue box.
    switch (cue.vertical) {
    case "":
      styleBox.applyStyles({
        top: styleBox.formatStyle(linePos, "%")
      });
      break;
    case "rl":
      styleBox.applyStyles({
        left: styleBox.formatStyle(linePos, "%")
      });
      break;
    case "lr":
      styleBox.applyStyles({
        right: styleBox.formatStyle(linePos, "%")
      });
      break;
    }

    axis = [ "+y", "-x", "+x", "-y" ];

    // Get the box position again after we've applied the specified positioning
    // to it.
    boxPosition$1 = new boxPosition(styleBox);
  }

  var bestPosition = findBestPosition(boxPosition$1, axis);
  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}

var moveBoxToLinePosition_1 = moveBoxToLinePosition;

var FONT_SIZE_PERCENT = 0.05;
var FONT_STYLE = "sans-serif";
var CUE_BACKGROUND_PADDING = "1.5%";

// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
var processCues = function(window, cues, overlay, customStyle) {
  if (!window || !cues || !overlay) {
    return null;
  }

  customStyle = customStyle || {};

  // Remove all previous children.
  while (overlay.firstChild) {
    overlay.removeChild(overlay.firstChild);
  }

  var paddedOverlay = window.document.createElement("div");
  paddedOverlay.style.position = "absolute";
  paddedOverlay.style.left = "0";
  paddedOverlay.style.right = "0";
  paddedOverlay.style.top = "0";
  paddedOverlay.style.bottom = "0";
  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
  overlay.appendChild(paddedOverlay);

  // Determine if we need to compute the display states of the cues. This could
  // be the case if a cue's state has been changed since the last computation or
  // if it has not been computed yet.
  function shouldCompute(cues) {
    for (var i = 0; i < cues.length; i++) {
      if (cues[i].hasBeenReset || !cues[i].displayState) {
        return true;
      }
    }
    return false;
  }

  // We don't need to recompute the cues' display states. Just reuse them.
  if (!shouldCompute(cues)) {
    for (var i = 0; i < cues.length; i++) {
      paddedOverlay.appendChild(cues[i].displayState);
    }
    return;
  }

  var boxPositions = [],
      containerBox = boxPosition.getSimpleBoxPosition(paddedOverlay),
      fontSize = customStyle.fontSize || Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100,
      fontFamily = customStyle.fontFamily || FONT_STYLE;

  var styleOptions = Object.assign({
    font: fontSize + "px " + fontFamily,
  }, customStyle, styleOptions);

  (function() {
    var styleBox, cue;

    for (var i = 0; i < cues.length; i++) {
      cue = cues[i];

      // Compute the intial position and styles of the cue div.
      styleBox = new cueStyleBox(window, cue, styleOptions);
      paddedOverlay.appendChild(styleBox.div);

      // Move the cue div to it's correct line position.
      moveBoxToLinePosition_1(window, styleBox, containerBox, boxPositions);

      // Remember the computed div so that we don't have to recompute it later
      // if we don't have too.
      cue.displayState = styleBox.div;

      boxPositions.push(boxPosition.getSimpleBoxPosition(styleBox));
    }
  })();
};

var processCues_1 = processCues;

// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function ParsingError(errorData, message) {
  this.name = "ParsingError";
  this.code = errorData.code;
  this.message = message || errorData.message;
}
ParsingError.prototype = Object.create(Error.prototype);
ParsingError.prototype.constructor = ParsingError;

// ParsingError metadata for acceptable ParsingErrors.
ParsingError.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};

var parsingError = ParsingError;

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings$1() {
  this.values = Object.create(null);
}

Settings$1.prototype = {
  // Only accept the first assignment to any key.
  set: function(k, v) {
    if (!this.get(k) && v !== "") {
      this.values[k] = v;
    }
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  // Check whether we have a value for a key.
  has: function(k) {
    return k in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(k, v, a) {
    for (var n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(k, v) {
    if (/^-?\d+$/.test(v)) { // integer
      this.set(k, parseInt(v, 10));
    }
  },
  // Accept a setting if its a valid percentage.
  percent: function(k, v) {
    // eslint-disable-next-line
    var m;
    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};

var settings = Settings$1;

// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== "string") {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0];
    var v = kv[1];
    callback(k, v);
  }
}

var parseOptions_1 = parseOptions;

function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  var oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    var ts = parseTimestamp(input);
    if (ts === null) {
      throw new parsingError(parsingError.Errors.BadTimeStamp,
                            "Malformed timestamp: " + oInput);
    }
    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, "");
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    var settings$1 = new settings();

    parseOptions_1(input, function (k, v) {
      switch (k) {
      case "region":
        // Find the last region we parsed with the same region id.
        for (var i = regionList.length - 1; i >= 0; i--) {
          if (regionList[i].id === v) {
            settings$1.set(k, regionList[i].region);
            break;
          }
        }
        break;
      case "vertical":
        settings$1.alt(k, v, ["rl", "lr"]);
        break;
      case "line":
        var vals = v.split(","),
            vals0 = vals[0];
        settings$1.integer(k, vals0);
        settings$1.percent(k, vals0) ? settings$1.set("snapToLines", false) : null;
        settings$1.alt(k, vals0, ["auto"]);
        if (vals.length === 2) {
          settings$1.alt("lineAlign", vals[1], ["start", "center", "end"]);
        }
        break;
      case "position":
        vals = v.split(",");
        settings$1.percent(k, vals[0]);
        if (vals.length === 2) {
          settings$1.alt("positionAlign", vals[1], ["start", "center", "end"]);
        }
        break;
      case "size":
        settings$1.percent(k, v);
        break;
      case "align":
        settings$1.alt(k, v, ["start", "center", "end", "left", "right"]);
        break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings$1.get("region", null);
    cue.vertical = settings$1.get("vertical", "");
    try {
      cue.line = settings$1.get("line", -1);
    } catch (e) {
      // eslint-ignore-line
    }
    cue.lineAlign = settings$1.get("lineAlign", "start");
    cue.snapToLines = settings$1.get("snapToLines", true);
    cue.size = settings$1.get("size", 100);
    // Safari still uses the old middle value and won't accept center
    try {
      cue.align = settings$1.get("align", "center");
    } catch (e) {
      cue.align = settings$1.get("align", "middle");
    }
    try {
      cue.position = settings$1.get("position", -1);
    } catch (e) {
      cue.position = settings$1.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, cue.align);
    }


    cue.positionAlign = settings$1.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, cue.align);
  }

  function skipWhitespace() {
    input = input.replace(/^\s+/, "");
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
  skipWhitespace();
  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
    throw new parsingError(parsingError.Errors.BadTimeStamp,
                           "Malformed time stamp (time stamps must be separated by '-->'): " +
                           oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp();     // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}

var parseCue_1 = parseCue;

var Parser = function(window, vttjs, decoder) {
  if (!decoder) {
    decoder = vttjs;
    vttjs = {};
  }
  if (!vttjs) {
    vttjs = {};
  }

  this.window = window;
  this.vttjs = vttjs;
  this.state = "INITIAL";
  this.buffer = "";
  this.decoder = decoder || new window.TextDecoder("utf8");
  this.regionList = [];
};

// If the error is a ParsingError then report it to the consumer if
// possible. If it's not a ParsingError then throw it like normal.
Parser.prototype.reportOrThrowError = function(e) {
  if (e instanceof parsingError) {
    this.onparsingerror && this.onparsingerror(e);
  } else {
    throw e;
  }
};

Parser.prototype.parse = function (data) {
  var self = this;

  // If there is no data then we won't decode it, but will just try to parse
  // whatever is in buffer already. This may occur in circumstances, for
  // example when flush() is called.
  if (data) {
    // Try to decode the data that we received.
    self.buffer += self.decoder.decode(data, {stream: true});
  }

  function collectNextLine() {
    var buffer = self.buffer;
    var pos = 0;
    while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
      ++pos;
    }
    var line = buffer.substr(0, pos);
    // Advance the buffer early in case we fail below.
    if (buffer[pos] === '\r') {
      ++pos;
    }
    if (buffer[pos] === '\n') {
      ++pos;
    }
    self.buffer = buffer.substr(pos);
    return line;
  }

  // 3.4 WebVTT region and WebVTT region settings syntax
  function parseRegion(input) {
    var settings$1 = new settings();

    parseOptions_1(input, function (k, v) {
      switch (k) {
      case "id":
        settings$1.set(k, v);
        break;
      case "width":
        settings$1.percent(k, v);
        break;
      case "lines":
        settings$1.integer(k, v);
        break;
      case "regionanchor":
      case "viewportanchor":
        var xy = v.split(',');
        if (xy.length !== 2) {
          break;
        }
        // We have to make sure both x and y parse, so use a temporary
        // settings object here.
        var anchor = new settings();
        anchor.percent("x", xy[0]);
        anchor.percent("y", xy[1]);
        if (!anchor.has("x") || !anchor.has("y")) {
          break;
        }
        settings$1.set(k + "X", anchor.get("x"));
        settings$1.set(k + "Y", anchor.get("y"));
        break;
      case "scroll":
        settings$1.alt(k, v, ["up"]);
        break;
      }
    }, /=/, /\s/);

    // Create the region, using default values for any values that were not
    // specified.
    if (settings$1.has("id")) {
      var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
      region.width = settings$1.get("width", 100);
      region.lines = settings$1.get("lines", 3);
      region.regionAnchorX = settings$1.get("regionanchorX", 0);
      region.regionAnchorY = settings$1.get("regionanchorY", 100);
      region.viewportAnchorX = settings$1.get("viewportanchorX", 0);
      region.viewportAnchorY = settings$1.get("viewportanchorY", 100);
      region.scroll = settings$1.get("scroll", "");
      // Register the region.
      self.onregion && self.onregion(region);
      // Remember the VTTRegion for later in case we parse any VTTCues that
      // reference it.
      self.regionList.push({
        id: settings$1.get("id"),
        region: region
      });
    }
  }

  // draft-pantos-http-live-streaming-20
  // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
  // 3.5 WebVTT
  function parseTimestampMap(input) {
    var settings$1 = new settings();

    parseOptions_1(input, function(k, v) {
      switch(k) {
      case "MPEGT":
        settings$1.integer(k + 'S', v);
        break;
      case "LOCA":
        settings$1.set(k + 'L', parseTimestamp(v));
        break;
      }
    }, /[^\d]:/, /,/);

    self.ontimestampmap && self.ontimestampmap({
      "MPEGTS": settings$1.get("MPEGTS"),
      "LOCAL": settings$1.get("LOCAL")
    });
  }

  // 3.2 WebVTT metadata header syntax
  function parseHeader(input) {
    if (input.match(/X-TIMESTAMP-MAP/)) {
      // This line contains HLS X-TIMESTAMP-MAP metadata
      parseOptions_1(input, function(k, v) {
        switch(k) {
        case "X-TIMESTAMP-MAP":
          parseTimestampMap(v);
          break;
        }
      }, /=/);
    } else {
      parseOptions_1(input, function (k, v) {
        switch (k) {
        case "Region":
          // 3.3 WebVTT region metadata header syntax
          parseRegion(v);
          break;
        }
      }, /:/);
    }

  }

  // 5.1 WebVTT file parsing.
  try {
    var line;
    if (self.state === "INITIAL") {
      // We can't start parsing until we have the first line.
      if (!/\r\n|\n/.test(self.buffer)) {
        return this;
      }

      line = collectNextLine();

      var m = line.match(/^WEBVTT([ \t].*)?$/);
      if (!m || !m[0]) {
        throw new parsingError(parsingError.Errors.BadSignature);
      }

      self.state = "HEADER";
    }

    var alreadyCollectedLine = false;
    while (self.buffer) {
      // We can't parse a line until we have the full line.
      if (!/\r\n|\n/.test(self.buffer)) {
        return this;
      }

      if (!alreadyCollectedLine) {
        line = collectNextLine();
      } else {
        alreadyCollectedLine = false;
      }

      switch (self.state) {
      case "HEADER":
        // 13-18 - Allow a header (metadata) under the WEBVTT line.
        if (/:/.test(line)) {
          parseHeader(line);
        } else if (!line) {
          // An empty line terminates the header and starts the body (cues).
          self.state = "ID";
        }
        continue;
      case "NOTE":
        // Ignore NOTE blocks.
        if (!line) {
          self.state = "ID";
        }
        continue;
      case "ID":
        // Check for the start of NOTE blocks.
        if (/^NOTE($|[ \t])/.test(line)) {
          self.state = "NOTE";
          break;
        }
        // 19-29 - Allow any number of line terminators, then initialize new cue values.
        if (!line) {
          continue;
        }
        self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
        // Safari still uses the old middle value and won't accept center
        try {
          self.cue.align = "center";
        } catch (e) {
          self.cue.align = "middle";
        }
        self.state = "CUE";
        // 30-39 - Check if self line contains an optional identifier or timing data.
        if (line.indexOf("-->") === -1) {
          self.cue.id = line;
          continue;
        }
        // Process line as start of a cue.
        /*falls through*/
      case "CUE":
        // 40 - Collect cue timings and settings.
        try {
          parseCue_1(line, self.cue, self.regionList);
        } catch (e) {
          self.reportOrThrowError(e);
          // In case of an error ignore rest of the cue.
          self.cue = null;
          self.state = "BADCUE";
          continue;
        }
        self.state = "CUETEXT";
        continue;
      case "CUETEXT":
        var hasSubstring = line.indexOf("-->") !== -1;
        // 34 - If we have an empty line then report the cue.
        // 35 - If we have the special substring '-->' then report the cue,
        // but do not collect the line as we need to process the current
        // one as a new cue.
        if (!line || hasSubstring && (alreadyCollectedLine = true)) {
          // We are done parsing self cue.
          self.oncue && self.oncue(self.cue);
          self.cue = null;
          self.state = "ID";
          continue;
        }
        if (self.cue.text) {
          self.cue.text += "\n";
        }
        self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
        continue;
      case "BADCUE": // BADCUE
        // 54-62 - Collect and discard the remaining cue.
        if (!line) {
          self.state = "ID";
        }
        continue;
      }
    }
  } catch (e) {
    self.reportOrThrowError(e);

    // If we are currently parsing a cue, report what we have.
    if (self.state === "CUETEXT" && self.cue && self.oncue) {
      self.oncue(self.cue);
    }
    self.cue = null;
    // Enter BADWEBVTT state if header was not parsed correctly otherwise
    // another exception occurred so enter BADCUE state.
    self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
  }
  return this;
};

Parser.prototype.flush = function () {
  var self = this;
  try {
    // Finish decoding the stream.
    self.buffer += self.decoder.decode();
    // Synthesize the end of the current cue or region.
    if (self.cue || self.state === "HEADER") {
      self.buffer += "\n\n";
      self.parse();
    }
    // If we've flushed, parsed, and we're still on the INITIAL state then
    // that means we don't have enough of the stream to parse the first
    // line.
    if (self.state === "INITIAL") {
      throw new parsingError(parsingError.Errors.BadSignature);
    }
  } catch(e) {
    self.reportOrThrowError(e);
  }
  self.onflush && self.onflush();
  return this;
};

var parser = Parser;

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */

function getDefault(module) {
  return module.default || module;
}

function WebVTT() {
  // Nothing
}

// Helper to allow strings to be decoded instead of the default binary utf8 data.
WebVTT.StringDecoder = function() {
  return {
    decode: function(data) {
      if (!data) {
        return "";
      }
      if (typeof data !== "string") {
        throw new Error("Error - expected string data.");
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
};

WebVTT.convertCueToDOMTree = getDefault(convertCueToDomTree);

WebVTT.processCues = getDefault(processCues_1);

WebVTT.Parser = getDefault(parser);

var vtt = WebVTT;

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getDefault$1(module) {
  return module.default || module;
}

var convertCueToDOMTree$1 = getDefault$1(convertCueToDomTree);

var autoKeyword = "auto";
var directionSetting = {
  "": 1,
  "lr": 1,
  "rl": 1
};
var alignSetting = {
  "start": 1,
  "center": 1,
  "end": 1,
  "left": 1,
  "right": 1,
  "auto": 1,
  "line-left": 1,
  "line-right": 1
};

function findDirectionSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var dir = directionSetting[value.toLowerCase()];
  return dir ? value.toLowerCase() : false;
}

function findAlignSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var align = alignSetting[value.toLowerCase()];
  return align ? value.toLowerCase() : false;
}

function VTTCue$1(startTime, endTime, text) {
  /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */

  // Lets us know when the VTTCue's data has changed in such a way that we need
  // to recompute its display state. This lets us compute its display state
  // lazily.
  this.hasBeenReset = false;

  /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */

  var _id = "";
  var _pauseOnExit = false;
  var _startTime = startTime;
  var _endTime = endTime;
  var _text = text;
  var _region = null;
  var _vertical = "";
  var _snapToLines = true;
  var _line = "auto";
  var _lineAlign = "start";
  var _position = "auto";
  var _positionAlign = "auto";
  var _size = 100;
  var _align = "center";

  Object.defineProperties(this, {
    "id": {
      enumerable: true,
      get: function() {
        return _id;
      },
      set: function(value) {
        _id = "" + value;
      }
    },

    "pauseOnExit": {
      enumerable: true,
      get: function() {
        return _pauseOnExit;
      },
      set: function(value) {
        _pauseOnExit = !!value;
      }
    },

    "startTime": {
      enumerable: true,
      get: function() {
        return _startTime;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("Start time must be set to a number.");
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    },

    "endTime": {
      enumerable: true,
      get: function() {
        return _endTime;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("End time must be set to a number.");
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    },

    "text": {
      enumerable: true,
      get: function() {
        return _text;
      },
      set: function(value) {
        _text = "" + value;
        this.hasBeenReset = true;
      }
    },

    "region": {
      enumerable: true,
      get: function() {
        return _region;
      },
      set: function(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    },

    "vertical": {
      enumerable: true,
      get: function() {
        return _vertical;
      },
      set: function(value) {
        var setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    },

    "snapToLines": {
      enumerable: true,
      get: function() {
        return _snapToLines;
      },
      set: function(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    },

    "line": {
      enumerable: true,
      get: function() {
        return _line;
      },
      set: function(value) {
        if (typeof value !== "number" && value !== autoKeyword) {
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        }
        _line = value;
        this.hasBeenReset = true;
      }
    },

    "lineAlign": {
      enumerable: true,
      get: function() {
        return _lineAlign;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("lineAlign: an invalid or illegal string was specified.");
        } else {
          _lineAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },

    "position": {
      enumerable: true,
      get: function() {
        return _position;
      },
      set: function(value) {
        if (value < 0 || value > 100) {
          throw new Error("Position must be between 0 and 100.");
        }
        _position = value;
        this.hasBeenReset = true;
      }
    },

    "positionAlign": {
      enumerable: true,
      get: function() {
        return _positionAlign;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("positionAlign: an invalid or illegal string was specified.");
        } else {
          _positionAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },

    "size": {
      enumerable: true,
      get: function() {
        return _size;
      },
      set: function(value) {
        if (value < 0 || value > 100) {
          throw new Error("Size must be between 0 and 100.");
        }
        _size = value;
        this.hasBeenReset = true;
      }
    },

    "align": {
      enumerable: true,
      get: function() {
        return _align;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }
  });

  /**
   * Other <track> spec defined properties
   */

  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
  this.displayState = undefined;
}

/**
 * VTTCue methods
 */

VTTCue$1.prototype.getCueAsHTML = function() {
  // Assume WebVTT.convertCueToDOMTree is on the global.
  return convertCueToDOMTree$1(window, this.text);
};

var vttcue = VTTCue$1;

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var scrollSetting = {
  "": true,
  "up": true
};

function findScrollSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var scroll = scrollSetting[value.toLowerCase()];
  return scroll ? value.toLowerCase() : false;
}

function isValidPercentValue(value) {
  return typeof value === "number" && (value >= 0 && value <= 100);
}

// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function VTTRegion() {
  var _width = 100;
  var _lines = 3;
  var _regionAnchorX = 0;
  var _regionAnchorY = 100;
  var _viewportAnchorX = 0;
  var _viewportAnchorY = 100;
  var _scroll = "";

  Object.defineProperties(this, {
    "width": {
      enumerable: true,
      get: function() {
        return _width;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("Width must be between 0 and 100.");
        }
        _width = value;
      }
    },
    "lines": {
      enumerable: true,
      get: function() {
        return _lines;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("Lines must be set to a number.");
        }
        _lines = value;
      }
    },
    "regionAnchorY": {
      enumerable: true,
      get: function() {
        return _regionAnchorY;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorX must be between 0 and 100.");
        }
        _regionAnchorY = value;
      }
    },
    "regionAnchorX": {
      enumerable: true,
      get: function() {
        return _regionAnchorX;
      },
      set: function(value) {
        if(!isValidPercentValue(value)) {
          throw new Error("RegionAnchorY must be between 0 and 100.");
        }
        _regionAnchorX = value;
      }
    },
    "viewportAnchorY": {
      enumerable: true,
      get: function() {
        return _viewportAnchorY;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        }
        _viewportAnchorY = value;
      }
    },
    "viewportAnchorX": {
      enumerable: true,
      get: function() {
        return _viewportAnchorX;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        }
        _viewportAnchorX = value;
      }
    },
    "scroll": {
      enumerable: true,
      get: function() {
        return _scroll;
      },
      set: function(value) {
        var setting = findScrollSetting(value);
        // Have to check for false as an empty string is a legal value.
        if (setting === false) {
          console.warn("Scroll: an invalid or illegal string was specified.");
        } else {
          _scroll = setting;
        }
      }
    }
  });
}

var vttregion = VTTRegion;

var browserIndex = createCommonjsModule(function (module) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.



var vttjs = module.exports = {
  WebVTT: vtt,
  VTTCue: vttcue,
  VTTRegion: vttregion
};

window_1.vttjs = vttjs;
window_1.WebVTT = vttjs.WebVTT;

var cueShim = vttjs.VTTCue;
var regionShim = vttjs.VTTRegion;
var nativeVTTCue = window_1.VTTCue;
var nativeVTTRegion = window_1.VTTRegion;

vttjs.shim = function() {
  window_1.VTTCue = cueShim;
  window_1.VTTRegion = regionShim;
};

vttjs.restore = function() {
  window_1.VTTCue = nativeVTTCue;
  window_1.VTTRegion = nativeVTTRegion;
};

if (!window_1.VTTCue) {
  vttjs.shim();
}
});

var WebVTTParser = /*#__PURE__*/function (_BaseObject) {
  _inherits(WebVTTParser, _BaseObject);

  var _super = _createSuper(WebVTTParser);

  function WebVTTParser(subtitlesText) {
    var _this;

    _classCallCheck(this, WebVTTParser);

    _this = _super.call(this);
    _this.subtitleItems = _this.parseVttFile(subtitlesText);
    return _this;
  }

  _createClass(WebVTTParser, [{
    key: "init",
    value: function init() {
      return {
        parser: new browserIndex.WebVTT.Parser(window, browserIndex.WebVTT.StringDecoder()),
        cues: []
      };
    }
  }, {
    key: "bindEvents",
    value: function bindEvents(parser, cues) {
      parser.onparsingerror = function (err) {
        Log$1.error(this.name, "\n Error when trying to parse WebVTT file: ".concat(err));
      };

      parser.oncue = function (cue) {
        cues.push(cue);
      };
    }
  }, {
    key: "parseVttFile",
    value: function parseVttFile(content) {
      if (!content) return;

      var _this$init = this.init(),
          parser = _this$init.parser,
          cues = _this$init.cues;

      this.bindEvents(parser, cues);
      parser.parse(content);
      parser.flush();
      return cues;
    }
  }, {
    key: "getActiveCue",
    value: function getActiveCue(targetTime) {
      var subtitlesArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.subtitleItems;

      var arrayData = _toConsumableArray(subtitlesArray);

      var arrayLength = arrayData.length;
      var leftIndex = 0;
      var rightIndex = arrayLength - 1;
      var middleIndex = Math.floor((arrayLength - 1) / 2);
      var middleCue = arrayData[middleIndex];
      var leftArray = arrayData.splice(0, middleIndex + 1);
      var rightArray = arrayData;
      if (leftIndex > rightIndex || !middleCue.startTime) return;

      if (targetTime >= middleCue.startTime && targetTime <= middleCue.endTime) {
        return [middleCue];
      }

      if (arrayLength <= 1) {
        return [];
      }

      if (targetTime <= middleCue.startTime) {
        return this.getActiveCue(targetTime, leftArray);
      }

      if (targetTime > middleCue.startTime) {
        return this.getActiveCue(targetTime, rightArray);
      }
    }
  }, {
    key: "processActiveCue",
    value: function processActiveCue(activeCue, elementToAppend, customStyle) {
      browserIndex.WebVTT.processCues(window, activeCue, elementToAppend, customStyle);
    }
  }]);

  return WebVTTParser;
}(BaseObject);

var css_248z$s = ".clappr-player#wp3-player-0 .subtitle {\n  background-color: rgba(0, 0, 0, 0.7);\n  position: relative;\n  font-family: \"clearsans-bold\", sans-serif;\n  font-size: 14px;\n  color: #f1f1f1;\n  line-height: 1.4;\n  margin: auto;\n  display: inline-block;\n  pointer-events: none; }\n  .clappr-player#wp3-player-0 .subtitle--hidden {\n    visibility: hidden;\n    opacity: 0; }\n  .clappr-player#wp3-player-0 .subtitle--opacity-media-control-show, .clappr-player#wp3-player-0 .subtitle--opacity-media-control-hide {\n    transition: opacity 0.3s ease-in-out; }\n  .clappr-player#wp3-player-0 .subtitle--opacity-media-control-show {\n    opacity: 0.5; }\n  .clappr-player#wp3-player-0 .subtitle--opacity-media-control-hide {\n    opacity: 1; }\n  .clappr-player#wp3-player-0 .subtitle__wrapper {\n    display: flex;\n    bottom: 0;\n    position: absolute;\n    width: 100%;\n    z-index: 993;\n    will-change: transform;\n    transition: transform 0.3s ease-out; }\n    .clappr-player#wp3-player-0 .subtitle__wrapper--override-webvtt {\n      /* This section is responsible for override wrapper styles for WebVTT resources */\n      bottom: auto;\n      height: 100%; }\n      .clappr-player#wp3-player-0 .subtitle__wrapper--override-webvtt .subtitle {\n        background-color: transparent;\n        /* The WebVTT parser lib calculates based on the screen size where to put\n            the subtitles. This leaves 10/12 portion so it wont be placed on the screen limit */\n        height: 98%;\n        width: 98%; }\n        .clappr-player#wp3-player-0 .subtitle__wrapper--override-webvtt .subtitle i {\n          font-family: \"clearsans-bolditalic\"; }\n\n.clappr-player#wp3-player-0 .cast-enabled .subtitle__wrapper, .clappr-player#wp3-player-0 .cast-connecting .subtitle__wrapper {\n  display: none; }\n";
styleInject(css_248z$s);

var templateHtml$8 = "<p class=\"subtitle\"></p>\n";

var SUBTITLE_FONT_FAMILY = 'clearsans-bold';
var SUBTITLE_PADDING = '0.2em';
var SUBITITLE_BORDER_RADIUS = '0.2em';
var SUBTITLE_DISPLAY = 'inline-block';
var webVttStyles = {
  fontFamily: SUBTITLE_FONT_FAMILY,
  padding: SUBTITLE_PADDING,
  borderRadius: SUBITITLE_BORDER_RADIUS,
  display: SUBTITLE_DISPLAY
};

var SUBTITLE_FONT_SIZE_BREAKPOINT = 560;

var Subtitle = /*#__PURE__*/function (_UIContainerPlugin) {
  _inherits(Subtitle, _UIContainerPlugin);

  var _super = _createSuper(Subtitle);

  _createClass(Subtitle, [{
    key: "attributes",
    get: function get() {
      return {
        'class': 'subtitle__wrapper',
        'data-subtitle': ''
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'subtitle';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$8);
    }
  }, {
    key: "tagVideo",
    get: function get() {
      return this.idPlayback.videoEl;
    }
  }, {
    key: "subtitleTrackAutoHandled",
    get: function get() {
      return Browser.isiOS || Browser.isSafari && this.idPlayback.innerPlaybackName === 'hls_fairplay_playback';
    }
  }]);

  function Subtitle(container) {
    var _this;

    _classCallCheck(this, Subtitle);

    _this = _super.call(this, container);

    _this.render();

    _this.createCachedElements();

    _this.idPlayback = _this.container.playback;
    _this.enableWebVtt = !!_this.options.shouldDeviceUseWebVTT;
    return _this;
  }

  _createClass(Subtitle, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.container, Events$1.CONTAINER_TIMEUPDATE, this.updateSubtitle);
      this.listenTo(this.container, Events.WM_SUBTITLE_CHANGED, this.onSubtitleChanged);
      this.listenTo(this.container, Events.WM_SUBTITLE_AVAILABLE, this.onSubtitleAvailable);
      this.listenTo(this.container, Events$1.CONTAINER_MEDIACONTROL_SHOW, function () {
        return _this2.onMediaControlShow();
      });
      this.listenTo(this.container, Events$1.CONTAINER_MEDIACONTROL_HIDE, function () {
        return _this2.onMediaControlHide();
      });
      this.listenTo(this.container, Events.WM_MASTERTOPIP, function () {
        return _this2.$el.hide();
      });
      this.listenTo(this.container, Events.WM_PIPTOMASTER, function () {
        return _this2.$el.show();
      });
      this.listenTo(this.container, Events$1.CONTAINER_RESIZE, this.onPlayerResize);
      this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, this.onPlay);
      this.listenToOnce(this.container.playback, Events.WM_PLAYBACK_CAN_PLAY, this.onCanPlay);
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      this.createCachedElements();
      this.updateCurrentSize();
      this.updateResponsiveStyle();
    }
  }, {
    key: "onCanPlay",
    value: function onCanPlay() {
      var _this3 = this;

      this.listenToOnce(this.idPlayback.playback, Events$1.PLAYBACK_SUBTITLE_CHANGED, function () {
        _this3.innerPlaybackSubtitleChanged = true;
      });
    }
  }, {
    key: "updateCurrentSize",
    value: function updateCurrentSize() {
      this.currentWidth = this.container.el.clientWidth;
      this.currentHeight = this.container.el.clientHeight;
    }
  }, {
    key: "onSubtitleAvailable",
    value: function onSubtitleAvailable(availableSubtitles, availableContents) {
      this.availableSubtitles = availableSubtitles;
      this.enableWebVtt = availableSubtitles.some(function (subtitle) {
        return subtitle.type === 'webvtt';
      });
      this.generateSubtitleParser(availableContents);
      this.updateStyle();
      /* Html5 Based playbacks listen to textTrack and set all of its subtitles as disabled on load flow. 
      This change triggers a PLAYBACK_SUBTITLE_CHANGED event, so we set the default subtitle after that. 
      Sometimes, however, this event is triggered before onSubtitleAvailable is called, so we save the 
      possible ocurrence of the event with the aforementioned onCanPlay callback. */

      if (this.shouldCreateSubtitleTrack() && !this.innerPlaybackSubtitleChanged) this.listenToOnce(this.idPlayback.playback, Events$1.PLAYBACK_SUBTITLE_CHANGED, this.setInitialSubtitle);else this.setInitialSubtitle();
    }
  }, {
    key: "shouldCreateSubtitleTrack",
    value: function shouldCreateSubtitleTrack() {
      return !this.subtitleTrackAutoHandled && this.enableWebVtt;
    }
  }, {
    key: "generateSubtitleParser",
    value: function generateSubtitleParser(availableContents) {
      var _this4 = this;

      this.availableContents = availableContents.map(function (content) {
        return content && (_this4.enableWebVtt ? new WebVTTParser(content) : new SrtParser(content));
      });
    }
  }, {
    key: "onMediaControlShow",
    value: function onMediaControlShow() {
      this.$subtitle.removeClass('subtitle--opacity-media-control-hide').addClass('subtitle--opacity-media-control-show');
    }
  }, {
    key: "onMediaControlHide",
    value: function onMediaControlHide() {
      this.$subtitle.removeClass('subtitle--opacity-media-control-show').addClass('subtitle--opacity-media-control-hide');
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!size.width || typeof size.width !== 'number') return;
      this.currentWidth = size.width;
      this.currentHeight = size.height;
      this.updateResponsiveStyle();
    }
  }, {
    key: "updateResponsiveStyle",
    value: function updateResponsiveStyle() {
      this.updateSize();
      this.updateStyle();
    }
  }, {
    key: "setInitialSubtitle",
    value: function setInitialSubtitle() {
      var _this5 = this;

      var selected = this.availableSubtitles.find(function (subtitle) {
        return subtitle.selected;
      });
      /*
        Delay call to onSubtitleChanged on Safari (when subtitleTrackAutoHandled is true).
        It avoids a bug where the track change stop working.
      */

      this.subtitleTrackAutoHandled ? setTimeout(function () {
        return _this5.onSubtitleChanged(selected);
      }) : this.onSubtitleChanged(selected);
    }
  }, {
    key: "onSubtitleChanged",
    value: function onSubtitleChanged() {
      var subtitleOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.subtitleTrackAutoHandled) {
        this.changeTextTrack(subtitleOption);
        return;
      }

      var subtitleContent = this.availableContents[subtitleOption.id];

      if (subtitleContent) {
        this.subtitleParser = subtitleContent;
        this.currentIndex = 0;
        this.$el.show();
        this.$subtitle.addClass('subtitle--hidden');
      } else {
        delete this.subtitleParser;
        delete this.currentIndex;
        this.$subtitle.html('');
        this.$el.hide();
      }
    }
  }, {
    key: "changeTextTrack",
    value: function changeTextTrack(subtitleOption) {
      // A bug was happening in iOS devices where the Player's subtitles were rendered alongside Apple's native subtitles.
      // The Player's subtitles have been disabled in favor of TextTracks.
      var textTracks = this.tagVideo.textTracks;
      Object.values(textTracks).forEach(function (track) {
        return track.mode = 'hidden';
      });
      var currentTrack = Object.values(textTracks).find(function (track) {
        return subtitleOption.keys.includes(track.language);
      });
      currentTrack && (currentTrack.mode = 'showing');
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      Utils$1.applySizeClass(this.$el, this.container.$el.width());
    }
  }, {
    key: "updateStyle",
    value: function updateStyle() {
      if (this.enableWebVtt) this.processVttActiveCue();
      this.updateFontSize();
      this.updateVerticalPosition();
    }
  }, {
    key: "updateFontSize",
    value: function updateFontSize() {
      this.$subtitle.css({
        fontSize: this.getFontSize()
      });
    }
  }, {
    key: "updateVerticalPosition",
    value: function updateVerticalPosition() {
      this.enableWebVtt ? this.$el.css({
        bottom: 'auto'
      }) : this.$el.css({
        bottom: this.getVerticalPosition()
      });
    }
  }, {
    key: "updateSubtitle",
    value: function updateSubtitle(timeProgress) {
      if (!this.subtitleParser) return;
      this.enableWebVtt ? this.updateWebVTTSubtitleContent(timeProgress.current) : this.updateSrtSubtitleContent(timeProgress.current * 1000);
    }
  }, {
    key: "updateWebVTTSubtitleContent",
    value: function updateWebVTTSubtitleContent(currentTimeProgress) {
      if (!this.subtitleParser.subtitleItems) return;
      this.activeSubtitle = this.subtitleParser.getActiveCue(currentTimeProgress);
      var shouldDisplay = this.activeSubtitle && !!this.activeSubtitle.length;

      if (shouldDisplay) {
        this.$el.addClass('subtitle__wrapper--override-webvtt');
        this.$subtitle.removeClass('subtitle--hidden');
        this.processVttActiveCue();
      } else {
        this.$subtitle.addClass('subtitle--hidden');
      }
    }
  }, {
    key: "processVttActiveCue",
    value: function processVttActiveCue() {
      this.resetVttCueStyle();
      this.subtitleParser && this.subtitleParser.processActiveCue(this.activeSubtitle, this.$subtitle[0], this.getVttStyles());
    }
  }, {
    key: "resetVttCueStyle",
    value: function resetVttCueStyle() {
      if (!this.activeSubtitle || !this.activeSubtitle[0]) return;
      /** Set hasBeenReset flag from vtt parser to recalculte processed cues styles when player container width changes */

      this.activeSubtitle[0].hasBeenReset = this.activeSubtitle[0].playerWidth !== this.currentWidth;
      this.activeSubtitle[0].playerWidth = this.currentWidth;
    }
  }, {
    key: "getVttStyles",
    value: function getVttStyles() {
      return _objectSpread2({
        fontSize: this.getFontSize()
      }, webVttStyles);
    }
  }, {
    key: "updateSrtSubtitleContent",
    value: function updateSrtSubtitleContent(currentTimeProgress) {
      var item = this.subtitleParser.getSubtitleAt(this.currentIndex);
      var shouldDisplay = this.subtitleParser.isCurrentSubtitle(item, currentTimeProgress);

      if (!shouldDisplay) {
        // Current subtitle item does not correspond to current position
        var nextIndex = this.currentIndex + 1;
        var nextItem = this.subtitleParser.getSubtitleAt(nextIndex);
        shouldDisplay = this.subtitleParser.isCurrentSubtitle(nextItem, currentTimeProgress);

        if (shouldDisplay) {
          this.currentIndex = nextIndex;
          item = nextItem;
        } else if (nextItem && (currentTimeProgress > nextItem.end || currentTimeProgress < item.start)) {
          // Next item does not correspond to current position
          // Current position is not within the range [currentItem.start, nextItem.end]
          // In this case, we must look for the subtitle that corresponds to current time
          var subtitleItem = this.subtitleParser.getSubtitleBy(currentTimeProgress);
          item = subtitleItem && subtitleItem.subtitle;
          subtitleItem && (this.currentIndex = subtitleItem.index);
          shouldDisplay = !!subtitleItem;
        }
      }

      if (item && this.$subtitle.html() != item.content) {
        this.$subtitle.html(item.content);
      }

      shouldDisplay ? this.$subtitle.removeClass('subtitle--hidden') : this.$subtitle.addClass('subtitle--hidden');
    }
  }, {
    key: "getMediaControlLowerHeight",
    value: function getMediaControlLowerHeight() {
      return this.$mediaControlPanelLower && this.$mediaControlPanelLower.getBoundingClientRect().height || 80;
    }
  }, {
    key: "getVerticalPosition",
    value: function getVerticalPosition() {
      return this.currentHeight / 12.0;
    }
  }, {
    key: "getFontSize",
    value: function getFontSize() {
      return this.currentWidth < SUBTITLE_FONT_SIZE_BREAKPOINT ? 14 : this.currentWidth * 2.5 / 100.0;
    }
  }, {
    key: "createCachedElements",
    value: function createCachedElements() {
      this.$subtitle = this.$el.find('.subtitle');
      var panelLowerSelector = ".clappr-player#wp3-player-".concat(this.options.playerId, " .media-control-panel__lower");
      this.$mediaControlPanelLower = document.querySelector(panelLowerSelector);
    }
  }, {
    key: "render",
    value: function render() {
      var style = Styler.getStyleFrom(css_248z$s, {
        playerId: this.options.playerId
      });
      this.$el.html(this.template());
      this.$el.append(style[0]);
      this.$el.hide();
      this.container.$el.append(this.el);
      return this;
    }
  }]);

  return Subtitle;
}(UIContainerPlugin);

var HorizonYoubora = /*#__PURE__*/function () {
  _createClass(HorizonYoubora, [{
    key: "YOUBORA_SERVICES",
    get: function get() {
      return ['init', 'adInit', 'adStart', 'adJoinTime', 'adStop', 'joinTime'];
    }
  }]);

  function HorizonYoubora() {
    _classCallCheck(this, HorizonYoubora);

    this.youboraTimersStopped = false;
    this.metrics = {};
    this.youboraTimers = {};
    this.initYouboraTimers();
  }

  _createClass(HorizonYoubora, [{
    key: "initYouboraTimers",
    value: function initYouboraTimers() {
      var _this = this;

      this.YOUBORA_SERVICES.forEach(function (service) {
        return _this.youboraTimers[service] = 0;
      });
    }
  }, {
    key: "delta",
    value: function delta(serviceA, serviceB) {
      var value = this.youboraTimers[serviceA] - this.youboraTimers[serviceB];
      return value > 0 ? value : 0;
    }
  }, {
    key: "onTimemark",
    value: function onTimemark(_ref) {
      var time = _ref.time,
          service = _ref.service;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ignoreRequest = service !== 'init' && this.youboraTimersStopped;
      if (this.YOUBORA_SERVICES.indexOf(service) === -1 || ignoreRequest) return;
      this.youboraTimers[service] = time;
      this.setAdMetrics();
      this.setDFPMetrics();
      this.setContentMetrics();

      if (this.willSendParams(service)) {
        this.setParams(params);
        this.initYouboraTimers();
      }
    }
  }, {
    key: "setAdMetrics",
    value: function setAdMetrics() {
      this.metrics.adInitTime = this.delta('adInit', 'init');
      this.metrics.adStartTime = this.delta('adStart', 'adInit');
      this.metrics.adJoinTime = this.delta('adJoinTime', 'adStart');
    }
  }, {
    key: "setDFPMetrics",
    value: function setDFPMetrics() {
      this.metrics.dfpSetupTime = this.metrics.adStartTime + this.metrics.adJoinTime;
      this.metrics.dfpRunTime = this.delta('adStop', 'adInit');
      this.metrics.dfpTime = this.metrics.dfpSetupTime ? this.metrics.dfpSetupTime : this.metrics.dfpRunTime;
      var adWatched = this.youboraTimers.adStop && this.youboraTimers.adJoinTime;
      this.metrics.dfpWatchedTime = adWatched ? this.youboraTimers.adStop - this.youboraTimers.adJoinTime : 0;
    }
  }, {
    key: "setContentMetrics",
    value: function setContentMetrics() {
      this.metrics.contentStartTime = this.youboraTimers.adStop ? this.delta('joinTime', 'adStop') : 0;
      this.metrics.joinTime = this.delta('joinTime', 'init') - this.metrics.dfpWatchedTime;
    }
  }, {
    key: "willSendParams",
    value: function willSendParams(service) {
      var isJoinEvent = service === 'joinTime';
      this.youboraTimersStopped = isJoinEvent;
      return isJoinEvent;
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      params.youboraMetrics = this.metrics;
    }
  }]);

  return HorizonYoubora;
}();

var Video = Models.Video;
var getExperimentsList = Utils$1.getExperimentsList,
    API_VERSION = Utils$1.API_VERSION,
    getPlatformName = Utils$1.getPlatformName,
    toQueryString = Utils$1.toQueryString,
    secondsToMillis = Utils$1.secondsToMillis,
    getCookie$1 = Utils$1.getCookie,
    session$1 = Utils$1.session,
    User = Utils$1.User,
    autoplayManager$3 = Utils$1.autoplayManager;

var Horizon = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(Horizon, _ContainerPlugin);

  var _super = _createSuper(Horizon);

  _createClass(Horizon, [{
    key: "shouldIgnoreVolumeUpdate",
    value: function shouldIgnoreVolumeUpdate(volume, isUserGesture) {
      var isPlaybackIdle = !this.isReady && !this.container.playback.isPlaying();
      return volume === null || isPlaybackIdle || !isUserGesture;
    }
  }, {
    key: "setYouboraParams",
    value: function setYouboraParams(params) {
      var metricsObj = this.externalData && this.externalData.youboraMetrics || {};
      var metrics = Object.keys(metricsObj);
      metrics.forEach(function (metric) {
        params[metric] = metricsObj[metric];
      });
    }
  }, {
    key: "setVideoSessionID",
    value: function setVideoSessionID() {
      this.params.video_session_id = session$1.getVideoSessionId(this.options.playerId);
    }
  }, {
    key: "setDeviceInfo",
    value: function setDeviceInfo() {
      var _this2 = this;

      var metrics = Object.keys(this.options.deviceInfo);
      metrics.forEach(function (metric) {
        _this2.params["device_".concat(metric)] = _this2.options.deviceInfo[metric];
      });
    }
  }, {
    key: "getPercentage",
    value: function getPercentage(position) {
      return position === 0 ? position : position / this.session.duration * 100;
    }
  }, {
    key: "initValues",
    value: function initValues() {
      this.params = {};
      this.dfpInit = 0;
      this.bufftime = 0;
      this.playRequestTime = 0;
      this.isBuffering = false;
      this.hasStartedClip = false;
      this.isPlaying = false;
    }
  }, {
    key: "name",
    get: function get() {
      return 'horizon';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "isAd",
    get: function get() {
      return this.container.getPlaybackType() === 'ad';
    }
  }, {
    key: "isLive",
    get: function get() {
      return this.video.kind === 'live' || this.container.getPlaybackType() === 'live';
    }
  }, {
    key: "isAdsDisabled",
    get: function get() {
      return this.options.skipDFP || false;
    }
  }, {
    key: "currentTime",
    get: function get() {
      return this.currentTimeValue;
    },
    set: function set(value) {
      this.currentTimeValue = value;
    }
  }, {
    key: "horizonHost",
    get: function get() {
      return "".concat(this.options.env.protocol, "://horizon.globo.com");
    }
  }, {
    key: "tenant",
    get: function get() {
      var _this$options$horizon = this.options.horizon,
          horizon = _this$options$horizon === void 0 ? {} : _this$options$horizon;
      return horizon.tenant || 'unknown';
    }
  }, {
    key: "isEncrypted",
    get: function get() {
      var encrypted = this.video && this.video.encrypted;
      return typeof encrypted !== 'undefined' ? encrypted : 'unknown';
    }
  }, {
    key: "playbackName",
    get: function get() {
      var container = this.container;
      var playback = container && container.playback;
      if (!playback) return null;
      return playback.innerPlaybackName || playback.name || '';
    }
  }, {
    key: "bufferingTime",
    get: function get() {
      if (this.isBuffering) {
        this.bufftime += Utils.now() - this.buffstarttime;
        this.buffstarttime = Utils.now();
      }

      var btime = this.bufftime;
      this.bufftime = 0;
      return Math.trunc(btime);
    }
  }]);

  function Horizon(container) {
    var _this;

    _classCallCheck(this, Horizon);

    _this = _super.call(this, container);

    _this.initValues();

    _this.video = {};

    _this.setVideoSessionID();

    _this.browser = "".concat(Browser.name).concat(Browser.version);
    _this.playerId = Environment.playerId;
    _this.url = "".concat(_this.horizonHost, "/auth-session/activity/webmedia/watch");
    _this.domain = _this.options.domain || window.location.hostname.replace('www.', '').split('.')[0];
    _this.experiments = getExperimentsList(_this.options);
    autoplayManager$3.onAutoplayAvailable(_this.onAutoplaySuccess.bind(_assertThisInitialized(_this)), _this.options, _this.onAutoplayFailed.bind(_assertThisInitialized(_this)));
    _this.youboraTimemark = new HorizonYoubora();
    _this.externalData = {};

    _this.onDFPInit();

    return _this;
  }

  _createClass(Horizon, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.container, Events$1.CONTAINER_PLAY, this.onFirstPlaying);
      this.listenToOnce(this.container.playback, Events.WM_PLAY_REQUESTED_READY, this.onPlayRequested);
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.play);
      this.listenTo(this.container, Events$1.CONTAINER_PAUSE, this.pause);
      this.listenTo(this.container, Events$1.CONTAINER_SEEK, this.seek);
      this.listenTo(this.container, Events$1.CONTAINER_TIMEUPDATE, this.timeUpdate);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.end);
      this.listenTo(this.container, Events$1.CONTAINER_DESTROYED, this.end);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.end);
      this.listenTo(this.container, Events$1.CONTAINER_STATS_REPORT, this.onOldStatsReport);
      this.listenTo(this.container, Events$1.CONTAINER_ERROR, this.onError);
      this.listenTo(this.container, Events.WM_STATS_REPORTED, this.onStatsReport);
      this.listenTo(this.container, Events.WM_MUTED, this.onVolumeMuted);
      this.listenTo(this.container, Events.WM_UNMUTED, this.onVolumeUnmuted);
      this.listenTo(this.container, Events.WM_SUBTITLE_CHANGED, this.onSubtitleChanged);
      this.listenTo(this.container, Events.WM_LOCATION_AVAILABLE, this.onLocationAvailable);
      this.listenTo(this.container, Events.DFP_AD_ERROR, this.onAdError);
      this.listenTo(this.container, Events.DFP_AD_NOTSERVED, this.onAdNotServed);
      this.listenTo(this.container, Events.WM_BITRATE_CAP, this.onBitrateCap);
      this.listenTo(this.container, Events.DID_CHANGE_CURRENT_PROGRAM, this.onCurrentProgramUpdated);
      this.listenTo(this.container, Events.WM_GA_UNTRACKED_EVENT, this.onGoogleAnalyticsEventUntracked);
      this.listenTo(this.container.playback, Events.WM_STREAMING_DATA_LOADED, this.onStreamingDataLoaded);
      this.listenTo(this.container.playback, Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
      this.listenTo(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
      this.listenTo(this.container.playback, Events.WILL_SELECT_FALLBACK_SOURCE, this.onFallbackSource);
      this.listenTo(this.container.playback, Events.FALLBACK_SOURCE_SELECTED, this.onFallbackSourceSelected);
      this.listenTo(this.container.playback, Events.WILL_RENEW_RESOURCE, this.onRenewResource);
      this.listenTo(this.container.playback, Events.WM_WROOM_WAITING, this.onWRWaiting);
      this.listenToOnce(this.container, Events$1.Custom.DAI_ERROR, this.onDaiError);
      this.listenToOnce(this.container, Events.WM_RESOURCE_REQUEST_STATS, this.onResourceRequestStats);
    } // PLAYER EVENTS

  }, {
    key: "onPlayRequested",
    value: function onPlayRequested() {
      this.playRequestTime = Utils.now();
      this.isReady = true;
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      if (!video) return;
      this.video = video;
      this.params.playback_id = video.id;
      this.params.subscriber_only = video.isSubscriberOnly;
      this.params.title = video.title;
      this.params.program = video.program;
      this.params.channel = video.channel;
      this.params.kind = video.kind;
      this.setExperimentsParams();
    }
  }, {
    key: "setExperimentsParams",
    value: function setExperimentsParams() {
      if (this.experiments.length > 0 && this.experiments[0]) this.params.experiment_1 = this.experiments[0];
      if (this.experiments.length > 1 && this.experiments[1]) this.params.experiment_2 = this.experiments[1];
    }
  }, {
    key: "onStreamingDataLoaded",
    value: function onStreamingDataLoaded(_ref) {
      var pop = _ref.pop,
          host = _ref.host;
      this.params.host = host;
      this.params.pop = pop;
    }
  }, {
    key: "onFallbackSource",
    value: function onFallbackSource(data) {
      this.notifyAction(secondsToMillis(this.currentTime), 'will_fallback_source', data);
    }
  }, {
    key: "onFallbackSourceSelected",
    value: function onFallbackSourceSelected(data) {
      this.notifyAction(secondsToMillis(this.currentTime), 'fallback_source_selected', data);
    }
  }, {
    key: "onRenewResource",
    value: function onRenewResource(data) {
      this.notifyAction(secondsToMillis(this.currentTime), 'willRenewResource', data);
    }
  }, {
    key: "onDaiError",
    value: function onDaiError(error) {
      if (!error.notifiable) return;
      var daiErrorCode = error.errorCode,
          daiErrorMessage = error.errorMessage;
      this.notifyAction(secondsToMillis(this.currentTime), 'dai_error', {
        daiErrorCode: daiErrorCode,
        daiErrorMessage: daiErrorMessage
      });
    }
  }, {
    key: "onBitrateCap",
    value: function onBitrateCap(bitrate) {
      this.params.cap_bitrate = bitrate;
    }
  }, {
    key: "onDFPInit",
    value: function onDFPInit() {
      this.dfpInit = Utils.now();
    }
  }, {
    key: "onAdNotServed",
    value: function onAdNotServed() {
      this.params.dfp_status = 'not served';
    }
  }, {
    key: "onAdError",
    value: function onAdError() {
      this.params.dfp_status = 'error';
    }
  }, {
    key: "onOldStatsReport",
    value: function onOldStatsReport(stats) {
      if (this.isLive) this.params.dvr = stats.dvr ? 1 : 0;
    }
  }, {
    key: "onStatsReport",
    value: function onStatsReport(stats) {
      if (stats.extra.bitratesHistory.length > 0) {
        this.params.nominal_bitrate = stats.extra.bitratesHistory[stats.extra.bitratesHistory.length - 1].bitrate;
      }

      this.params.avg_bitrate = Math.trunc(stats.extra.bitrateWeightedMean);
      this.params.session_time = Math.trunc(stats.timers.session);
      this.params.watch_time = Math.trunc(stats.timers.watch);
    }
  }, {
    key: "onFirstPlaying",
    value: function onFirstPlaying() {
      this.listenToOnce(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.buffering);

      if (this.isAd && !this.dfp_startup_time) {
        this.params.dfp_status = 'delivered';
        this.params.dfp_startup_time = Math.trunc(Utils.now() - this.dfpInit);
        return;
      }

      this.params.startup_time = Math.trunc(Utils.now() - this.playRequestTime);
    }
  }, {
    key: "onVolumeMuted",
    value: function onVolumeMuted(volume, isUserGesture) {
      if (this.shouldIgnoreVolumeUpdate(volume, isUserGesture)) return;
      this.hasStartedClip && this.notify(secondsToMillis(this.currentTime), {
        mute_status: true
      });
    }
  }, {
    key: "onVolumeUnmuted",
    value: function onVolumeUnmuted(volume, isUserGesture) {
      if (this.shouldIgnoreVolumeUpdate(volume, isUserGesture)) return;
      this.hasStartedClip && this.notify(secondsToMillis(this.currentTime), {
        mute_status: false
      });
    }
  }, {
    key: "onSubtitleChanged",
    value: function onSubtitleChanged(subtitle) {
      this.hasStartedClip && this.notify(secondsToMillis(this.currentTime), {
        subtitle_status: subtitle.language === 'none' ? 'disabled' : 'enabled',
        subtitle_language: subtitle.language
      });
    }
  }, {
    key: "onLocationAvailable",
    value: function onLocationAvailable(coordinates) {
      this.params.lat = coordinates.latitude;
      this.params["long"] = coordinates.longitude;
    }
  }, {
    key: "onCurrentProgramUpdated",
    value: function onCurrentProgramUpdated(data) {
      typeof data.program !== 'undefined' && (this.params.program = data.program);
      typeof data.channel !== 'undefined' && (this.params.channel = data.channel);
    }
  }, {
    key: "onGoogleAnalyticsEventUntracked",
    value: function onGoogleAnalyticsEventUntracked() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$eventName = _ref2.eventName,
          eventName = _ref2$eventName === void 0 ? '' : _ref2$eventName;

      this.params.ga_untracked_event = eventName;
    }
  }, {
    key: "onWRWaiting",
    value: function onWRWaiting() {
      this.params.wroom = 1;
      this.isLive ? this.ping() : this.sendRequest("".concat(this.url, "?").concat(toQueryString(this.params)));
    }
  }, {
    key: "onAutoplaySuccess",
    value: function onAutoplaySuccess() {
      this.params.autoPlayAvailable = true;
    }
  }, {
    key: "onAutoplayFailed",
    value: function onAutoplayFailed() {
      this.params.autoPlayAvailable = false;
    }
  }, {
    key: "updateAuthorizedWRState",
    value: function updateAuthorizedWRState() {
      this.params.wroom = 0;
      this.ping();
    }
  }, {
    key: "onResourceRequestStats",
    value: function onResourceRequestStats(_ref3) {
      var retries = _ref3.retries,
          usedFallback = _ref3.usedFallback;
      this.retryHistory = JSON.stringify({
        attempts: retries,
        fallback: usedFallback
      });
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady() {
      this.updateAuthorizedWRState();
      !this.session && this.startSession();
      this.retryHistory && this.notifyRequestStats(this.retryHistory);
    } // PLAYBACK ACTIONS

  }, {
    key: "play",
    value: function play() {
      var _this3 = this;

      if (this.isAd) return;
      this.notifyPlayOrSeek(secondsToMillis(this.currentTime));

      if (!this.isPlaying) {
        this.breakTimerId = setInterval(function () {
          _this3.isPlaying = true;

          _this3.notifyRelevantPoint(secondsToMillis(_this3.currentTime));
        }, 15000);
        this.ping();
      }

      this.doingSeek = false;
      this.paused = false;
    }
  }, {
    key: "pause",
    value: function pause(name) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$userInvoked = options.userInvoked,
          userInvoked = _options$userInvoked === void 0 ? false : _options$userInvoked;
      this.pauseTimerId = setTimeout(function () {
        _this4.notifyAction(secondsToMillis(_this4.currentTime), 'pause', {
          'user_invoked': userInvoked
        });
      }, 100);
    }
  }, {
    key: "seek",
    value: function seek(time) {
      // eslint-disable-line no-unused-vars
      if (this.pauseTimerId) {
        clearTimeout(this.pauseTimerId);
        this.pauseTimerId = null;
      }

      this.doingSeek = true;
    }
  }, {
    key: "timeUpdate",
    value: function timeUpdate() {
      var timeProgress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.currentTime = timeProgress.current;
    }
  }, {
    key: "onBufferStart",
    value: function onBufferStart() {
      this.isBuffering = true;
      this.buffstarttime = Utils.now();
    }
  }, {
    key: "onBufferEnd",
    value: function onBufferEnd() {
      this.isBuffering = false;
      this.bufftime += Utils.now() - this.buffstarttime;
    }
  }, {
    key: "buffering",
    value: function buffering() {
      this.onBufferStart();
      this.listenToOnce(this.container, Events$1.CONTAINER_STATE_BUFFERFULL, this.bufferfull);
    }
  }, {
    key: "bufferfull",
    value: function bufferfull() {
      this.onBufferEnd();
      this.listenToOnce(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.buffering);
    }
  }, {
    key: "end",
    value: function end() {
      this.notifyAction(secondsToMillis(this.currentTime), 'stop');
      this.cancelBreakTimer();
      this.cancelPing();
      this.initValues();
    } // CLEAR

  }, {
    key: "clear",
    value: function clear() {
      this.params.dfp_startup_time = null;
      this.params.dfp_status = null;
    }
  }, {
    key: "cancelBreakTimer",
    value: function cancelBreakTimer() {
      clearInterval(this.breakTimerId);
      clearInterval(this.playOrSeekTimerId);
      this.breakTimerId = null;
      this.isPlaying = false;
    }
  }, {
    key: "cancelPing",
    value: function cancelPing() {
      if (!this.isLive) return;
      clearInterval(this.pingTimerId);
      this.pingTimerId = null;
    } // SESSION

  }, {
    key: "startSession",
    value: function startSession() {
      var startedAt = new Date().getTime().toString();
      this.lastNotifiedPoint = -1;
      this.totalActions = 0;

      if (this.isLive) {
        this.params.signal = this.video.selectedResource.signal;
        this.params.started_at = startedAt;
      }

      this.video.providerId && (this.params.gst = getCookie$1('GST'));
      this.session = {
        duration: this.video.duration,
        started_at: startedAt,
        play: 0,
        seek: 0,
        pause: 0,
        stop: 0,
        mute: 0,
        unmute: 0,
        subtitle_enable: 0,
        subtitle_disable: 0,
        will_fallback_source: 0,
        fallback_source_selected: 0,
        willRenewResource: 0,
        dai_error: 0,
        retry_history: 0
      };
      this.doingSeek = false;
      this.hasStartedClip = true;
    } // PINGS

  }, {
    key: "notifyRelevantPoint",
    value: function notifyRelevantPoint(position) {
      if (this.hasStartedClip) {
        var percent = this.getPercentage(position);
        var nearestRelevantPoint = Math.floor(percent / 5) * 5;

        if (nearestRelevantPoint > this.lastNotifiedPoint) {
          this.notify(position);
          this.lastNotifiedPoint = nearestRelevantPoint;
        } else if (this.verbose) {
          Log$1.info(this.name, "do not notify: ".concat(nearestRelevantPoint, " !> ").concat(this.lastNotifiedPoint));
        }
      }
    }
  }, {
    key: "notifyPlayOrSeek",
    value: function notifyPlayOrSeek(position) {
      var _this5 = this;

      var doingSeek = this.doingSeek;
      this.playOrSeekTimerId = setTimeout(function () {
        if (doingSeek) _this5.notifyAction(position, 'seek');else _this5.notifyAction(position, 'play');
      }, 100);
    }
  }, {
    key: "notifyRequestStats",
    value: function notifyRequestStats(retryHistory) {
      this.notifyAction(secondsToMillis(this.currentTime), 'retry_history', {
        retryHistory: retryHistory
      });
    }
  }, {
    key: "notifyAction",
    value: function notifyAction(position, name) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.hasStartedClip) {
        var actionId = ++this.session[name];
        params["".concat(name, "_total")] = actionId;
        params["".concat(name, "_id_").concat(actionId)] = position;
        this.notify(position, params);
      }
    }
  }, {
    key: "notify",
    value: function notify(position) {
      var paramsSent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.hasStartedClip) return;
      this.setCommonParams();
      var actionId = ++this.totalActions;

      var params = _objectSpread2(_objectSpread2(_objectSpread2({}, paramsSent), this.params), {}, _defineProperty({
        duration: this.session.duration,
        started_at: this.session.started_at,
        last_at: new Date().getTime().toString(),
        btime: this.bufferingTime
      }, "time_".concat(actionId), position));

      actionId === 1 && this.setYouboraParams(params);
      this.sendRequest("".concat(this.url, "?").concat(toQueryString(params)));
      this.clear();
    }
  }, {
    key: "onError",
    value: function onError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var route = this.isLive ? 'watchlive' : 'watch';
      this.url = "".concat(this.horizonHost, "/auth-session/activity/webmedia/").concat(route);
      this.params.started_at = new Date().getTime().toString();
      this.params.error = error.code || 'unknown';
      this.params.errorDescription = error.description || 'unknown';
      this.params.retryHistory = this.retryHistory;
      this.setCommonParams();
      this.setExperimentsParams();
      this.sendRequest("".concat(this.url, "?").concat(toQueryString(this.params)));
    }
  }, {
    key: "ping",
    value: function ping() {
      var _this6 = this;

      if (!this.isLive) return;
      this.url = "".concat(this.horizonHost, "/auth-session/activity/webmedia/watchlive");
      this.params.dvr = this.params.dvr || 0;
      this.setCommonParams();

      if (!this.pingTimerId) {
        this.sendPing();
        this.pingTimerId = setInterval(function () {
          _this6.sendPing();
        }, 60000);
      }
    }
  }, {
    key: "sendPing",
    value: function sendPing() {
      this.params.btime = this.bufferingTime;
      this.params.n = ++this.totalActions;
      var params = Object.assign({}, this.params);
      this.totalActions === 1 && this.setYouboraParams(params);
      this.sendRequest("".concat(this.url, "?").concat(toQueryString(params)));
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(url) {
      return Browser.isSmartTvEnvironment ? this.sendRequestWithHeaders(url) : this.sendRequestAsJsonP(url);
    }
  }, {
    key: "sendRequestAsJsonP",
    value: function sendRequestAsJsonP(url) {
      var image = new Image();
      image.src = url;
      return image;
    }
  }, {
    key: "sendRequestWithHeaders",
    value: function sendRequestWithHeaders(url) {
      var _this7 = this;

      $$1.ajax({
        url: url,
        xhrFields: {
          withCredentials: true
        },
        headers: _defineProperty({}, this.options.token ? 'GLBID' : 'GLBUID', this.options.token || User.uid),
        error: function error(xhr, textStatus, errorThrown) {
          return Log$1.warn(_this7.name, "could not send request: ".concat(errorThrown));
        }
      });
    } // PARAMS

  }, {
    key: "setCommonParams",
    value: function setCommonParams() {
      var videoId = this.video && this.video.id || this.options.sources;
      var playerType = this.video && this.video.playerType || Video.getPlayerType();
      this.setVideoSessionID();
      this.options.deviceInfo && this.setDeviceInfo();
      this.params.player_id = this.playerId;
      this.params.browser = this.browser;
      this.params.object = "video:".concat(videoId);
      this.params.playback_id = this.params.playback_id || videoId;
      this.params.playback = this.playbackName;
      this.params.player_type = playerType;
      this.params.platform = getPlatformName(playerType);
      this.params.ads_disabled = this.isAdsDisabled;
      this.params.encrypted = this.isEncrypted;
      this.params.url = document.location.href;
      this.params.domain = this.domain;
      this.params.cdn = this.video.cdn;
      this.params.player_version = PLAYER_VERSION;
      this.params.api_version = API_VERSION;
      this.params.tenant = this.tenant;
    }
  }]);

  return Horizon;
}(ContainerPlugin);

var mapCustomDimensions = {
  'ambient': 'dimension1',
  'provider': 'dimension21',
  'userId': 'dimension22',
  'platform': 'dimension36',
  'platform_manufacturer': 'dimension37',
  'platform_model': 'dimension38',
  'arc': 'dimension100',
  'signal': 'dimension101',
  'id': 'dimension102',
  'channel': 'dimension103',
  'program': 'dimension104',
  'episode': 'dimension105',
  'domain': 'dimension106',
  'type': 'dimension107',
  'kind': 'dimension108',
  'length_range': 'dimension109',
  'gsat_op': 'dimension110',
  'pisp': 'dimension111',
  'channel_id': 'dimension112',
  'program_id': 'dimension113',
  'keep_watching': 'dimension114',
  'pub_err': 'dimension115',
  'exb_date': 'dimension116',
  'creation_date': 'dimension117',
  'length': 'dimension118',
  'auto_play': 'dimension119',
  'quality': 'dimension120',
  'player_version': 'dimension121',
  'schema_version': 'dimension122',
  'affiliate_code': 'dimension123',
  'service_id': 'dimension124',
  'dvr_status': 'dimension128',
  'current_subtitle': 'dimension130',
  'current_audio': 'dimension131',
  'EPG_program_id': 'dimension132',
  'EPG_program': 'dimension133',
  'EPG_channel_id': 'dimension134',
  'EPG_channel': 'dimension135',
  'video_session_id': 'dimension136'
};
var mapCustomsMetrics = {
  'start': 'metric100',
  'seconds_watched': 'metric101',
  'complete': 'metric102',
  'bucket10': 'metric103',
  'bucket25': 'metric104',
  'bucket50': 'metric105',
  'bucket75': 'metric106',
  'bucket90': 'metric107',
  'bucket100': 'metric108',
  'seek': 'metric109',
  'load': 'metric110',
  'load_time': 'metric111',
  'skip_recap_displayed': 'metric112',
  'skip_recap_clicked': 'metric113',
  'skip_intro_displayed': 'metric114',
  'skip_intro_clicked': 'metric115',
  'quick_seek': 'metric116',
  'start_over_clicked': 'metric117',
  'auto_skip_recap': 'metric118',
  'start_over_displayed': 'metric119'
};

var session$2 = Utils$1.session;
var embedScript$2 = Utils$1.embedScript,
    registerGlobal = Utils$1.registerGlobal,
    LocalStorage$1 = Utils$1.LocalStorage,
    now$1 = Utils$1.now,
    seekStringToSeconds$1 = Utils$1.seekStringToSeconds,
    toDurationString = Utils$1.toDurationString,
    toLowerCase = Utils$1.toLowerCase,
    User$1 = Utils$1.User;
var FiveMinutesInSeconds = 300;
var unloadEvent = _typeof(window.onbeforeunload) === 'object' ? 'beforeunload' : 'unload';
var SkipMetricState = {
  READY_TO_SEND: 1,
  SENT: 2
};

var GoogleAnalytics = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(GoogleAnalytics, _ContainerPlugin);

  var _super = _createSuper(GoogleAnalytics);

  _createClass(GoogleAnalytics, [{
    key: "name",
    get: function get() {
      return 'google_analytics';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "isLive",
    get: function get() {
      return this.container.getPlaybackType() === 'live';
    }
  }, {
    key: "schemaVersion",
    get: function get() {
      return '2.0';
    }
  }, {
    key: "inflatedPlaytime",
    get: function get() {
      return this.isLive ? FiveMinutesInSeconds : this.video.duration / 1000 * 3;
    }
  }, {
    key: "shouldResetPlaytime",
    get: function get() {
      return this.trackedPlayTime > this.inflatedPlaytime || this.trackedPlayTime < 0;
    }
  }, {
    key: "oneDayInMiliseconds",
    get: function get() {
      return 86400000;
    }
  }, {
    key: "playerTracker",
    get: function get() {
      return "playerTracker".concat(this.options.playerId);
    }
  }, {
    key: "productTracker",
    get: function get() {
      return "productTracker".concat(this.options.playerId);
    }
  }, {
    key: "ambient",
    get: function get() {
      return Browser.isSmartTvEnvironment ? 'app_tv' : 'web';
    }
  }, {
    key: "platform",
    get: function get() {
      if (Browser.isSmartTvEnvironment) return 'big screen';
      return Browser.isMobile ? 'mobile' : 'desktop';
    }
  }]);

  function GoogleAnalytics(container) {
    var _this;

    _classCallCheck(this, GoogleAnalytics);

    _this = _super.call(this, container);
    _this.videoUA = _this.options.env.name === 'prod' ? 'UA-296593-59' : 'UA-296593-62';
    _this.productUA = _this.options.ga && _this.options.ga.productUA || _this.options.gaProductua;
    _this.gaClientId = _this.options.ga && _this.options.ga.productClientId;
    _this.gaExtras = _this.options.ga && _this.options.ga.extras || {};
    _this.isPaused = false;
    _this.seekCounter = 0;
    _this.checkpoint = 0;
    _this.trackedPlayTime = 0;
    _this.loadTimer = 0;
    _this.sentBuckets = {};
    _this.deviceInfo = _this.options.deviceInfo || {};
    registerGlobal('ga');

    if (!window.ga) {
      embedScript$2('https://www.google-analytics.com/analytics.js').then(function () {
        _this.getGAClientId();

        _this.setupAnalytics();
      });
    } else {
      _this.getGAClientId();

      _this.setupAnalytics();
    }

    return _this;
  }

  _createClass(GoogleAnalytics, [{
    key: "getGAClientId",
    value: function getGAClientId() {
      // Checking if the product is passing your own clientId to player
      if (this.gaClientId) return; // trying to get clientId via ga object previously with productUA

      if (window.GoogleAnalyticsObject && window[window.GoogleAnalyticsObject] && window[window.GoogleAnalyticsObject].getAll) {
        var gaObjects = window[window.GoogleAnalyticsObject].getAll();

        var _iterator = _createForOfIteratorHelper(gaObjects),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var gaInstance = _step.value;

            if (gaInstance.get('trackingId') === this.productUA) {
              this.gaClientId = gaInstance.get('clientId');
              Log$1.info(this.name, 'Getting GA product client id via GoogleAnalyticsObject');
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        // if not exist product clientId, create a clientId and store on localSotorage for use on next iteration
        var videoGa = LocalStorage$1.loadRaw('wm.player._videoGa');

        if (!videoGa) {
          var date = new Date();
          date.setFullYear(date.getFullYear() + 2);
          LocalStorage$1.store('_videoGa', User$1.uid, date);
        }

        this.gaClientId = videoGa;
        Log$1.info(this.name, 'Player has not found a valid client id. It`s been generated by the player.');
      }
    }
  }, {
    key: "setupAnalytics",
    value: function setupAnalytics() {
      window.ga = window.ga || function () {
        (ga.q = ga.q || []).push(arguments);
      };

      ga.l = +new Date();
      this.createGATrackers();
    }
  }, {
    key: "createGATrackers",
    value: function createGATrackers() {
      var initialParameters = this.mountGAInitialParameters();
      ga('create', this.videoUA, 'auto', this.playerTracker, initialParameters);
      ga("".concat(this.playerTracker, ".set"), 'location', window.location.href);

      if (this.productUA) {
        ga('create', this.productUA, 'auto', this.productTracker, initialParameters);
        ga("".concat(this.productTracker, ".set"), 'location', window.location.href);
      }
    }
  }, {
    key: "mountGAInitialParameters",
    value: function mountGAInitialParameters() {
      var initialParameters = {};
      if (this.gaExtras && this.gaExtras.uid) initialParameters.userId = this.gaExtras.uid;
      if (this.productUA) initialParameters.clientId = this.gaClientId;
      return initialParameters;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.container, Events.DFP_CONTENT_RESUME, function () {
        _this2.DFPError = 'false';
      });
      this.listenTo(this.container, Events.DFP_AD_ERROR, function () {
        _this2.DFPError = 'true';
      });
      this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
      this.listenToOnce(this.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
      this.listenTo(this.playback, Events$1.PLAYBACK_PLAY, this.onPlay);
      this.listenTo(this.playback, Events$1.PLAYBACK_PAUSE, this.onPause);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.onBuffering);
      this.listenTo(this.container, Events$1.CONTAINER_SEEK, this.onSeek);
      this.listenTo(this.container, Events.WM_SETTINGS_LEVEL_SELECTED, this.onQualitySelected);
      this.listenTo(this.playback, Events$1.PLAYBACK_TIMEUPDATE, this.onTimeUpdate);
      this.listenTo(this.playback, Events$1.PLAYBACK_STOP, this.onEnd);
      this.listenTo(this.playback, Events$1.PLAYBACK_ENDED, function () {
        _this2.onEnd('complete');
      });
      this.listenTo(this.container, Events$1.CONTAINER_DESTROYED, this.onEnd);
      this.listenTo(this.container, Events.WM_STATS_REPORTED, function (stats) {
        _this2.watchedTime = stats.timers.watch;
      });
      this.listenTo(this.container, Events.SKIP_BUTTON_CLICKED, this.onSkipButtonClicked);
      this.listenTo(this.container, Events.SKIP_BUTTON_SHOW, this.onSkipButtonDisplayed);
      this.listenTo(this.playback, Events$1.PLAYBACK_DVR, this.onDVR);
      this.listenTo(this.container, Events.DID_CHANGE_CURRENT_PROGRAM, this.onCurrentProgramUpdated);
      this.listenTo(this.container, Events.WM_AUDIO_CHANGED, this.onAudioChanged);
      this.listenTo(this.container, Events.WM_SUBTITLE_CHANGED, this.onSubtitleChanged);
      this.listenTo(this.container, Events.WILL_QUICK_SEEK, this.onQuickSeek);
      this.listenTo(this.container, Events.WILL_AUTO_SKIP_RECAP, this.onAutoSkipRecap);
      this.bindCustomEvents();
    }
  }, {
    key: "bindCustomEvents",
    value: function bindCustomEvents() {
      this.boundOnEnd = this.onEnd.bind(this);
      window.addEventListener(unloadEvent, this.boundOnEnd);
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      this.video = video;
      this.defineBuckets(this.video.duration);
      this.setVideoLayer();
      this.layer.schema_version = this.schemaVersion;
      this.layer.gaAccounts = [this.videoUA];
      this.productUA && this.layer.gaAccounts.push(this.productUA);
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady(video, user) {
      this.layer.video_session_id = session$2.getVideoSessionId(this.options.playerId);
      if (user && user.product) this.layer.pisp = user.product; // isp product used for authorization

      if (this.video.geofencing && video.transmission && video.transmission.affiliate) {
        this.layer.affiliate_code = video.transmission.affiliate.code;
      }
    }
  }, {
    key: "setVideoLayer",
    value: function setVideoLayer() {
      var videoTypesMapping = {
        'excerpt': 'short',
        'segment': 'short',
        'episode': 'full'
      };
      var videoType = videoTypesMapping[this.video.kind] || this.video.kind;
      var initialTime = this.options.resumeAt || seekStringToSeconds$1();
      var domainProvidedByProduct = this.container.options.domain;
      this.layer = {
        arc: this.video.isArchived ? 'acervo' : 'grade',
        //whether or not the video is archived
        signal: this.video.isSubscriberOnly ? 'fechado' : 'aberto',
        // whether or not the video is subscriber only
        id: "".concat(this.video.id),
        // asset id
        channel: this.video.channel,
        // broadcasting station
        program: this.video.program,
        // program title
        episode: this.video.title,
        // episode title
        domain: domainProvidedByProduct || document.location.hostname,
        // domain of the page in which the video is embedded
        type: videoType,
        // clip type
        kind: toLowerCase(this.video.category),
        // genre
        length_range: toDurationString(this.video.duration),
        // duration string for the video
        channel_id: this.video.channelId,
        // broadcast id
        program_id: this.video.programId,
        // program id
        keep_watching: initialTime > 0 ? 'true' : 'false',
        // flag that indicates the use of keep watching feature
        exb_date: this.video.exhibitedAt,
        // date on which the video was displayed
        creation_date: this.video.createdAt,
        // date on which the video was created
        length: Math.trunc(this.video.duration / 1000),
        // clip length (0 for live)
        auto_play: this.options.autoPlay + '',
        // flag that indicates the use of auto play feature
        player_version: PLAYER_VERSION,
        // actual globo player version
        start: 0,
        // flag that indicates if video is started
        service_id: this.video.serviceId,
        ambient: this.ambient,
        platform: this.platform
      };

      if (this.video.providerId && this.video.isSubscriberOnly) {
        this.layer.gsat_op = toLowerCase(this.options.payTvServiceProvider); // pay tv service provider used for authentication
      }

      if (Browser.isSmartTvEnvironment) {
        this.layer = _objectSpread2(_objectSpread2({}, this.layer), {}, {
          platform_manufacturer: this.deviceInfo.manufacturer || Browser.device && Browser.device.brand,
          platform_model: this.deviceInfo.model || Browser.device && Browser.device.model
        });
      }
    }
  }, {
    key: "onQualitySelected",
    value: function onQualitySelected() {
      var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!levels.length) return;
      var selectedLevel = levels.find(function (level) {
        return level.selected;
      }) || levels[0];
      this.levelSelected = selectedLevel && selectedLevel.name;
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      if (this.isFirstPlay()) {
        this.isPaused = false;
        return;
      }

      if (!this.isPaused) return;
      this.initialTrackedPlayTime = now$1();
      this.track('play');
      this.isPaused = false;
    }
  }, {
    key: "isFirstPlay",
    value: function isFirstPlay() {
      if (this.layer.start === 0) {
        this.isLive && (this.layer.dvr_status = this.container.isDvrEnabled() ? 'em-simulcast' : 'nao-disponivel');
        this.playback.currentAudio && (this.layer.current_audio = this.playback.currentAudio.language);
        this.playback.currentSubtitle && (this.layer.current_subtitle = this.playback.currentSubtitle.language);
        this.layer.start = 1;
        this.initialTrackedPlayTime = now$1();
        this.track('start');
        return true;
      }

      return false;
    }
  }, {
    key: "calculatePlayTime",
    value: function calculatePlayTime() {
      if (!this.initialTrackedPlayTime) return;
      var finalTrackedPlayTime = now$1();
      var deltaTrackedPlaytime = (finalTrackedPlayTime - this.initialTrackedPlayTime) / 1000;

      if (this.isBuffering) {
        // update loadTimer with the current buffering time before getting trackedPlayTime
        this.calculateBufferTime();
        this.onBufferStart();
      }

      this.trackedPlayTime = deltaTrackedPlaytime - this.loadTimer;
      this.hasSentBuffer();

      if (this.shouldResetPlaytime) {
        this.sendToSentry({
          type: 'GA ERROR: Not possible to calculate trackedPlayTime',
          description: "initialTrackedPlayTime = ".concat(this.initialTrackedPlayTime, " / finalTrackedPlayTime = ").concat(finalTrackedPlayTime)
        });
        this.trackedPlayTime = null;
      }

      this.initialTrackedPlayTime = 0;
    }
  }, {
    key: "milestone",
    value: function milestone(time) {
      if (!this.isPaused && time !== 0 && this.checkpoint !== time && time % 60 < 1) {
        this.calculatePlayTime();
        this.layer.start === 1 && this.track('milestone');
        this.initialTrackedPlayTime = now$1();
      }

      this.checkpoint = time;
    }
  }, {
    key: "onSkipButtonDisplayed",
    value: function onSkipButtonDisplayed() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          name = _ref.name;

      this["".concat(name, "_displayed")] !== SkipMetricState.SENT && (this["".concat(name, "_displayed")] = SkipMetricState.READY_TO_SEND);
    }
  }, {
    key: "onSkipButtonClicked",
    value: function onSkipButtonClicked() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          name = _ref2.name;

      this["".concat(name, "_clicked")] !== SkipMetricState.SENT && (this["".concat(name, "_clicked")] = SkipMetricState.READY_TO_SEND);
    }
  }, {
    key: "onAutoSkipRecap",
    value: function onAutoSkipRecap() {
      this.auto_skip_recap !== SkipMetricState.SENT && (this.auto_skip_recap = SkipMetricState.READY_TO_SEND);
    }
  }, {
    key: "onCurrentProgramUpdated",
    value: function onCurrentProgramUpdated() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          program = _ref3.program;

      this.layer.EPG_program = program && program.program || null;
      this.layer.EPG_channel = program && program.channel || null;
      this.layer.EPG_program_id = program && program.programId || null;
      this.layer.EPG_channel_id = program && program.channelId || null;
    }
  }, {
    key: "onAudioChanged",
    value: function onAudioChanged(audio) {
      this.layer.current_audio = audio && audio.language || null;
    }
  }, {
    key: "onSubtitleChanged",
    value: function onSubtitleChanged(subtitle) {
      this.layer.current_subtitle = subtitle && subtitle.language || null;
    }
  }, {
    key: "onQuickSeek",
    value: function onQuickSeek() {
      this.didQuickSeek = true;
    }
  }, {
    key: "onPause",
    value: function onPause() {
      this.calculatePlayTime();
      this.track('pause');
      this.isPaused = true;
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      if (this.isBuffering) return;
      this.isBuffering = true;
      this.listenToOnce(this.container, Events$1.CONTAINER_STATE_BUFFERFULL, this.onBufferFull);
      this.onBufferStart();
    }
  }, {
    key: "onBufferStart",
    value: function onBufferStart() {
      this.loadInitialTime = now$1();
    }
  }, {
    key: "onBufferFull",
    value: function onBufferFull() {
      this.calculateBufferTime();
      this.isBuffering = false;
    }
  }, {
    key: "calculateBufferTime",
    value: function calculateBufferTime() {
      this.loadEndTime = now$1();
      if (this.loadEndTime > 0 && this.loadInitialTime > 0 && this.loadEndTime > this.loadInitialTime) this.loadTimer += (this.loadEndTime - this.loadInitialTime) / 1000;
      this.loadInitialTime = 0;
      this.loadEndTime = 0;
    }
  }, {
    key: "hasSentBuffer",
    value: function hasSentBuffer() {
      this.loadTimer = 0;
      this.layer.load = 0;
      this.layer.load_time = 0;
    }
  }, {
    key: "onSeek",
    value: function onSeek() {
      this.hasSeeked = true;
      this.seekCounter++;
    }
  }, {
    key: "onEnd",
    value: function onEnd(event) {
      if (!this.layer || this.layer && this.layer.start === 0) return;
      this.layer.start = 0;
      this.hasVideoCompleted = event === 'complete';
      this.calculatePlayTime();
      this.track('end');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener(unloadEvent, this.boundOnEnd);

      _get(_getPrototypeOf(GoogleAnalytics.prototype), "destroy", this).call(this);

      this.stopListening();
      window.ga && ga.getByName && ga.getByName(this.playerTracker) && ga("".concat(this.playerTracker, ".remove"));
      window.ga && ga.getByName && ga.getByName(this.productTracker) && ga("".concat(this.productTracker, ".remove"));
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate(timeProgress) {
      this.currentTime = this.isLive ? Math.trunc(this.watchedTime / 1000) : timeProgress.current;
      this.milestone(Math.trunc(this.currentTime));
    }
  }, {
    key: "onDVR",
    value: function onDVR(enabled) {
      this.layer.dvr_status = enabled ? 'em-dvr' : 'em-simulcast';
    }
  }, {
    key: "track",
    value: function track(eventName) {
      if (!window.ga) {
        this.container.trigger(Events.WM_GA_UNTRACKED_EVENT, {
          eventName: eventName
        });
        return;
      }

      this.layer.event = eventName;
      this.layer.quality = this.levelSelected;
      this.layer.pub_err = this.DFPError;
      this.setGACustomMetrics(this.layer.event);
      this.useGAtracker();
    }
  }, {
    key: "setGACustomMetrics",
    value: function setGACustomMetrics(eventName) {
      this.GACustomMetrics = {};
      this.GACustomMetrics[mapCustomsMetrics['start']] = eventName === 'start' && 1;
      this.GACustomMetrics[mapCustomsMetrics['seconds_watched']] = this.shouldSendPlayTime() && this.trackedPlayTime;
      this.trackedPlayTime = 0; // test for identify milestone error

      this.GACustomMetrics[mapCustomsMetrics['load']] = this.shouldSendLoadTime() && 1;
      this.GACustomMetrics[mapCustomsMetrics['load_time']] = this.shouldSendLoadTime() && this.loadTimer;
      this.GACustomMetrics[mapCustomsMetrics['complete']] = eventName === 'end' && this.hasVideoCompleted && 1;
      this.setSkipButtonsCustomMetric();

      if (this.didQuickSeek) {
        this.GACustomMetrics[mapCustomsMetrics['quick_seek']] = 1;
        this.didQuickSeek = false;
      }

      if (eventName !== 'milestone' && this.hasSeeked) {
        this.hasSeeked = false;
        this.GACustomMetrics[mapCustomsMetrics['seek']] = this.seekCounter;
        this.seekCounter = 0;
      }

      !this.isLive && this.watchedTime && this.calculateBuckets(this.watchedTime);

      for (var key in this.GACustomMetrics) {
        this.GACustomMetrics[key] === false && delete this.GACustomMetrics[key];
      }
    }
  }, {
    key: "setSkipButtonsCustomMetric",
    value: function setSkipButtonsCustomMetric() {
      var _this3 = this;

      var skipActions = ['skip_recap_displayed', 'skip_recap_clicked', 'skip_intro_displayed', 'skip_intro_clicked', 'start_over_displayed', 'start_over_clicked', 'auto_skip_recap'];
      skipActions.forEach(function (skipAction) {
        if (_this3[skipAction] === SkipMetricState.READY_TO_SEND) {
          _this3.GACustomMetrics[mapCustomsMetrics[skipAction]] = 1;
          _this3[skipAction] = SkipMetricState.SENT;
        }
      });
    }
  }, {
    key: "useGAtracker",
    value: function useGAtracker() {
      this.setGACustomDimensions(this.playerTracker);
      this.sendtoGA(this.playerTracker);

      if (this.productUA) {
        this.setGACustomDimensions(this.productTracker);
        this.sendtoGA(this.productTracker);
      }
    }
  }, {
    key: "setGACustomDimensions",
    value: function setGACustomDimensions(tracker) {
      var _this4 = this;

      for (var key in mapCustomDimensions) {
        typeof this.layer[key] !== 'undefined' && ga("".concat(tracker, ".set"), mapCustomDimensions[key], this.layer[key]);
      }

      this.gaExtras && Object.keys(this.gaExtras).forEach(function (key) {
        if (!_this4.gaExtras[key]) return;
        ga("".concat(tracker, ".set"), mapCustomDimensions[key] || key, _this4.gaExtras[key]);
      });
    }
  }, {
    key: "sendtoGA",
    value: function sendtoGA(tracker) {
      if (this.isLive) {
        this.milestoneTime = this.milliToMinutes(this.watchedTime);
      } else {
        this.milestoneTime = Math.trunc(this.currentTime / 60);
      }

      this.gaEventLabel = this.layer.event === 'milestone' ? "minute - ".concat(this.milestoneTime) : this.layer.episode;
      ga("".concat(tracker, ".send"), 'event', 'video', this.layer.event, this.gaEventLabel, this.GACustomMetrics);
      this.shouldSendLoadTime() && this.hasSentBuffer();
    }
  }, {
    key: "shouldSendPlayTime",
    value: function shouldSendPlayTime() {
      return this.layer.event === 'milestone' || this.layer.event === 'pause' || this.layer.event === 'end';
    }
  }, {
    key: "shouldSendLoadTime",
    value: function shouldSendLoadTime() {
      return this.layer.event === 'start' || this.layer.event === 'play';
    }
  }, {
    key: "defineBuckets",
    value: function defineBuckets(duration) {
      this.videobuckets = {};
      var bucketsPercentages = [10, 25, 50, 75, 90, 100];

      for (var _i = 0, _bucketsPercentages = bucketsPercentages; _i < _bucketsPercentages.length; _i++) {
        var percentage = _bucketsPercentages[_i];
        this.videobuckets["bucket".concat(percentage)] = percentage / 100 * duration;
      }
    }
  }, {
    key: "calculateBuckets",
    value: function calculateBuckets(timeWatched) {
      for (var slice in this.videobuckets) {
        if (timeWatched >= this.videobuckets[slice] && !this.sentBuckets[slice]) {
          this.GACustomMetrics[mapCustomsMetrics[slice]] = 1;
          this.sentBuckets[slice] = 1;
        }
      }
    }
  }, {
    key: "milliToMinutes",
    value: function milliToMinutes(milliseconds) {
      return Math.trunc(milliseconds / 6e4);
    }
  }, {
    key: "sendToSentry",
    value: function sendToSentry(error) {
      this.container.trigger('wm:ga:error', error);
    }
  }]);

  return GoogleAnalytics;
}(ContainerPlugin);

var css_248z$t = ".clappr-player#wp3-player-0 .waiting-room {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: #202020;\n  background-size: cover;\n  z-index: 999;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0; }\n  .clappr-player#wp3-player-0 .waiting-room__aligner {\n    flex-grow: 1;\n    width: 100%; }\n  .clappr-player#wp3-player-0 .waiting-room__main-text {\n    color: #cccccc;\n    font-family: \"opensans-bold\", sans-serif;\n    font-size: 18px;\n    width: 100%;\n    left: 0; }\n  .clappr-player#wp3-player-0 .waiting-room__countdown {\n    color: #cccccc;\n    font-family: \"opensans-bold\", sans-serif;\n    font-size: 18px;\n    margin: 0 auto;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    display: inline-block;\n    text-align: center; }\n";
styleInject(css_248z$t);

var templateHtml$9 = "<div class=\"waiting-room__aligner\">\n<div class=\"waiting-room__main-text\">Estamos lotados! Tentaremos carregar a transmissão novamente em </div>\n<p class=\"waiting-room__countdown\"></p>\n</div>\n";

var WaitingRoom = /*#__PURE__*/function (_UIContainerPlugin) {
  _inherits(WaitingRoom, _UIContainerPlugin);

  var _super = _createSuper(WaitingRoom);

  _createClass(WaitingRoom, [{
    key: "name",
    get: function get() {
      return 'waiting_room';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "template",
    get: function get() {
      return template(templateHtml$9);
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        'class': 'waiting-room'
      };
    }
  }]);

  function WaitingRoom(container) {
    var _this;

    _classCallCheck(this, WaitingRoom);

    _this = _super.call(this, container);
    _this.rendered = false;
    return _this;
  }

  _createClass(WaitingRoom, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.container.playback, Events.WM_WROOM_WAITING, this.onResponse);
    }
  }, {
    key: "onResponse",
    value: function onResponse() {
      var _this2 = this;

      this.retryInterval = this.setRetryInterval();
      this.rendered ? this.updateScreenVisibility('flex') : this.render();
      this.countdownStart = Date.now();
      this.retryID = setTimeout(function () {
        _this2.retry();
      }, this.retryInterval);
      this.countdownID = setInterval(function () {
        _this2.updateScreen();
      }, 1000);
    }
  }, {
    key: "retry",
    value: function retry() {
      clearInterval(this.retryID);
      clearInterval(this.countdownID);
      this.updateScreenVisibility('none');
      this.container.playback.trigger(Events.WILL_RESTART_PLAYBACK, 'wroom');
    }
  }, {
    key: "updateScreen",
    value: function updateScreen() {
      this.updateCountdownElement(this.updateCountdownTime());
    }
  }, {
    key: "updateScreenVisibility",
    value: function updateScreenVisibility(state) {
      this.$el[0].style.display = state;
    }
  }, {
    key: "updateCountdownElement",
    value: function updateCountdownElement(time) {
      this.$el.find('.waiting-room__countdown').text(this.toSeconds(time));
    }
  }, {
    key: "updateCountdownTime",
    value: function updateCountdownTime() {
      return this.retryInterval - (Date.now() - this.countdownStart);
    }
  }, {
    key: "toSeconds",
    value: function toSeconds(t) {
      return Math.floor(t / 1000);
    }
  }, {
    key: "setRetryInterval",
    value: function setRetryInterval() {
      var min = 30000;
      var max = 50000;
      return Math.round(Math.random() * (min - max)) + max;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.rendered) {
        this.$el.html(this.template());
        var style = Styler.getStyleFrom(css_248z$t, {
          baseUrl: this.options.baseUrl,
          playerId: this.options.playerId
        });
        this.$el.append(style[0]);
        this.container.$el.append(this.el);
        this.rendered = true;
        return this;
      }
    }
  }]);

  return WaitingRoom;
}(UIContainerPlugin);

var BaseYouboraPlugin = function BaseYouboraPlugin() {
  _classCallCheck(this, BaseYouboraPlugin);

  Object.assign(BaseYouboraPlugin.prototype, $YB.plugins.Generic.prototype);
};
var BaseYouboraAdnalyzers = function BaseYouboraAdnalyzers() {
  _classCallCheck(this, BaseYouboraAdnalyzers);

  Object.assign(BaseYouboraAdnalyzers.prototype, $YB.adnalyzers.Generic.prototype);
};

var YouboraGenericPlugin = /*#__PURE__*/function (_BaseYouboraPlugin) {
  _inherits(YouboraGenericPlugin, _BaseYouboraPlugin);

  var _super = _createSuper(YouboraGenericPlugin);

  function YouboraGenericPlugin(container, options) {
    var _this;

    _classCallCheck(this, YouboraGenericPlugin);

    _this = _super.call(this);

    try {
      _this.pluginName = 'clappr';
      _this.pluginVersion = '6.0.0-clappr-5.5.4-lib';
      _this.container = container;
      _this.playback = _this.container.playback;
      _this.tag = _this.playback.$el && _this.playback.$el.find('video')[0] || _this.playback.el;

      _this.startMonitoring(container, options);
    } catch (err) {
      $YB.error(err);
    }

    return _this;
  }

  _createClass(YouboraGenericPlugin, [{
    key: "getPlayhead",
    value: function getPlayhead() {
      if (!this.viewManager.isShowingAds) {
        this.playhead = this.playback.getStartTimeOffset() + this.container.getCurrentTime();
      }

      return this.playhead;
    }
  }, {
    key: "getMediaDuration",
    value: function getMediaDuration() {
      return this.container.getDuration();
    }
  }, {
    key: "getIsLive",
    value: function getIsLive() {
      return this.container.getPlaybackType() === 'live';
    }
  }, {
    key: "getResource",
    value: function getResource() {
      var src = this.playback.options.sources;
      return _typeof(src) === 'object' ? src.source : src;
    }
  }, {
    key: "getPlayerVersion",
    value: function getPlayerVersion() {
      return 'Clappr' + Clappr.version;
    }
  }, {
    key: "getBitrate",
    value: function getBitrate() {
      return this.bitrate || -1;
    }
  }, {
    key: "getThroughput",
    value: function getThroughput() {
      return this.throughput || -1;
    }
  }, {
    key: "getRendition",
    value: function getRendition() {
      return this.rendition || '';
    }
  }]);

  return YouboraGenericPlugin;
}(BaseYouboraPlugin);

var Youbora = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(Youbora, _ContainerPlugin);

  var _super = _createSuper(Youbora);

  _createClass(Youbora, [{
    key: "name",
    get: function get() {
      return 'youbora_plugin';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "youboraUrl",
    get: function get() {
      return '';
    }
  }, {
    key: "youboraOptions",
    get: function get() {
      return {};
    }
  }, {
    key: "youboraPlugin",
    get: function get() {
      return YouboraGenericPlugin;
    }
  }]);

  function Youbora(container) {
    var _this;

    _classCallCheck(this, Youbora);

    _this = _super.call(this, container);

    _this.insertYouboraScript();

    return _this;
  }

  _createClass(Youbora, [{
    key: "insertYouboraScript",
    value: function insertYouboraScript() {
      var _this2 = this;

      if (window.$YB) {
        this.createPlugin();
      } else {
        var scriptElement = document.createElement('script');
        scriptElement.src = this.youboraUrl;

        scriptElement.onload = function () {
          _this2.createPlugin();
        };

        document.body.appendChild(scriptElement);
      }
    }
  }, {
    key: "createPlugin",
    value: function createPlugin() {
      $YB.plugins.Clappr = this.youboraPlugin;
      this.plugin = new $YB.plugins.Clappr(this.container, this.youboraOptions);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.container.playback, Events$1.PLAYBACK_PLAY_INTENT, this.onPlayIntent);
      this.listenTo(this.container, Events$1.CONTAINER_PLAY, this.onPlay);
      this.listenTo(this.container, Events$1.CONTAINER_PAUSE, this.onPause);
      this.listenTo(this.container, Events$1.CONTAINER_STOP, this.onStop);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.onEnded);
      this.listenTo(this.container, Events$1.CONTAINER_ERROR, this.onError);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERING, this.onBuffering);
      this.listenTo(this.container, Events$1.CONTAINER_STATE_BUFFERFULL, this.onBufferfull);
      this.listenTo(this.container, Events$1.CONTAINER_BITRATE, this.onBitrate);
      this.listenTo(this.container, Events$1.CONTAINER_SEEKED, this.onContainerSeeked);
      this.listenTo(this.container, Events$1.CONTAINER_SEEK, this.onContainerSeek);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.plugin && this.plugin.endedHandler();

      _get(_getPrototypeOf(Youbora.prototype), "destroy", this).call(this);
    }
  }, {
    key: "onPlayIntent",
    value: function onPlayIntent() {
      this.plugin.playHandler();
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      this.plugin.playingHandler();
    }
  }, {
    key: "onPause",
    value: function onPause() {
      this.plugin.pauseHandler();
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.plugin && this.plugin.endedHandler();
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      this.plugin.endedHandler();
    }
  }, {
    key: "onContainerSeeked",
    value: function onContainerSeeked() {
      if (!this.plugin) return;
      this.plugin.seekedHandler();
      this.plugin.currentTime = null;
    }
  }, {
    key: "onError",
    value: function onError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (error.code === Errors$2.PLAYLIST_LOAD_ERROR.code) return;
      this.plugin && this.plugin.errorHandler(error.code, error.description);
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      this.plugin && this.plugin.bufferingHandler();
    }
  }, {
    key: "onBufferfull",
    value: function onBufferfull() {
      this.plugin && this.plugin.bufferedHandler();
    }
  }, {
    key: "onBitrate",
    value: function onBitrate(event) {
      var levels = this.container.playback.levels;
      this.plugin.bitrate = event.bitrate;
      this.plugin.throughput = event.bandwidth;
      if (!(levels && levels.length)) return;
      var currentLevel = levels.filter(function (level) {
        return event.level === level.id;
      });
      this.plugin.rendition = currentLevel && currentLevel[0].label;
    }
  }, {
    key: "onContainerSeek",
    value: function onContainerSeek(time) {
      if (!this.plugin) return;
      this.plugin.currentTime = time;
      this.plugin.seekingHandler();
    }
  }]);

  return Youbora;
}(ContainerPlugin);

var GloboYouboraAdnalyzer = /*#__PURE__*/function (_BaseYouboraAdnalyzer) {
  _inherits(GloboYouboraAdnalyzer, _BaseYouboraAdnalyzer);

  var _super = _createSuper(GloboYouboraAdnalyzer);

  _createClass(GloboYouboraAdnalyzer, [{
    key: "ad",
    get: function get() {
      return this.ads.ad;
    },
    set: function set(ad) {
      this.ads.ad = ad;
    }
  }]);

  function GloboYouboraAdnalyzer(plugin, ima) {
    var _this;

    _classCallCheck(this, GloboYouboraAdnalyzer);

    _this = _super.call(this);
    _this.adnalyzerVersion = '6.0.0-IMA';

    _this.startMonitoring(plugin, ima);

    return _this;
  }

  _createClass(GloboYouboraAdnalyzer, [{
    key: "getAdPosition",
    value: function getAdPosition() {
      var adPosition = null;

      if (!this.ad || this.ad.getAdPodInfo().getPodIndex() === 0) {
        adPosition = 'pre';
      } else if (this.ad.getAdPodInfo().getPodIndex() === -1) {
        adPosition = 'post';
      } else {
        adPosition = 'mid';
      }

      return adPosition;
    }
  }, {
    key: "getAdResource",
    value: function getAdResource() {
      if (!this.ad) return _get(_getPrototypeOf(GloboYouboraAdnalyzer.prototype), "getAdResource", this).call(this);
      return this.ad.getMediaUrl();
    }
  }, {
    key: "getAdTitle",
    value: function getAdTitle() {
      if (!this.ad) return _get(_getPrototypeOf(GloboYouboraAdnalyzer.prototype), "getAdTitle", this).call(this);
      return this.ad.getTitle();
    }
  }, {
    key: "getAdDuration",
    value: function getAdDuration() {
      if (!this.ad) return _get(_getPrototypeOf(GloboYouboraAdnalyzer.prototype), "getAdDuration", this).call(this);
      return this.ad.getDuration();
    }
  }, {
    key: "getMediaPlayhead",
    value: function getMediaPlayhead() {
      return this.plugin.getPlayhead();
    }
  }, {
    key: "getAdPlayhead",
    value: function getAdPlayhead() {
      var playback = this.plugin.container.playback;
      var duration = typeof playback.getDuration !== 'undefined' ? playback.getDuration() : 0;
      var remaining = typeof playback.getRemainingTime !== 'undefined' ? playback.getRemainingTime() : 0;
      return duration - remaining || this.plugin.container.getCurrentTime();
    }
  }]);

  return GloboYouboraAdnalyzer;
}(BaseYouboraAdnalyzers);

var GloboYouboraPlugin = /*#__PURE__*/function (_YouboraGenericPlugin) {
  _inherits(GloboYouboraPlugin, _YouboraGenericPlugin);

  var _super = _createSuper(GloboYouboraPlugin);

  function GloboYouboraPlugin(container, options) {
    var _this;

    _classCallCheck(this, GloboYouboraPlugin);

    _this = _super.call(this, container, options);
    _this.options = options;
    _this.container = container;

    _this.setupAdnalyzer();

    return _this;
  }

  _createClass(GloboYouboraPlugin, [{
    key: "setupAdnalyzer",
    value: function setupAdnalyzer() {
      this.adnalyzer = new GloboYouboraAdnalyzer(this, {});
    }
  }, {
    key: "getPlayerVersion",
    value: function getPlayerVersion() {
      return GloboYouboraPlugin.playerVersion();
    }
  }, {
    key: "endedHandler",
    value: function endedHandler() {
      this.stopMonitoring();

      _get(_getPrototypeOf(GloboYouboraPlugin.prototype), "endedHandler", this).call(this);
    }
  }], [{
    key: "playerVersion",
    value: function playerVersion() {
      return PLAYER_VERSION;
    }
  }]);

  return GloboYouboraPlugin;
}(YouboraGenericPlugin);

var session$3 = Utils$1.session,
    toLowerCase$1 = Utils$1.toLowerCase,
    getExperimentsList$1 = Utils$1.getExperimentsList,
    API_VERSION$1 = Utils$1.API_VERSION,
    getPlatformName$1 = Utils$1.getPlatformName;
var Video$1 = Models.Video;
var AD_STATES = {
  initial: 1,
  initialized: 2,
  completed: 3
};

var GloboYouBora = /*#__PURE__*/function (_Youbora) {
  _inherits(GloboYouBora, _Youbora);

  var _super = _createSuper(GloboYouBora);

  _createClass(GloboYouBora, [{
    key: "name",
    get: function get() {
      return 'globo_youbora_plugin';
    }
  }, {
    key: "youboraPlugin",
    get: function get() {
      return GloboYouboraPlugin;
    }
  }, {
    key: "youboraUrl",
    get: function get() {
      return "".concat(this.options.env.protocol, "://s3.glbimg.com/v1/AUTH_e1b09a2d222b4900a437a46914be81e5/static/vendor/libs/youboralib-v5.5.4.min.js");
    }
  }, {
    key: "dashboardAccount",
    get: function get() {
      return this.options.youbora ? this.options.youbora.account : this.options.env.name;
    }
  }, {
    key: "youboraOptions",
    get: function get() {
      var _this$video, _ref, _this$video2, _this$video3, _this$video3$selected, _this$video4, _this$video5, _this$video6, _this$video7, _this$video8;

      return {
        accountCode: this.dashboardAccount === 'prod' ? 'globo' : 'globodev',
        enableAnalytics: true,
        username: this.options.globoId || undefined,
        transactionCode: session$3.getVideoSessionId(this.options.playerId),
        httpSecure: !this.options.httpOnly,
        enableInit: true,
        media: {
          title: ((_this$video = this.video) === null || _this$video === void 0 ? void 0 : _this$video.title) || '',
          duration: (_ref = ((_this$video2 = this.video) === null || _this$video2 === void 0 ? void 0 : _this$video2.duration) / 1000) !== null && _ref !== void 0 ? _ref : '',
          // duration in seconds
          isLive: this.container.getPlaybackType() === 'live',
          resource: ((_this$video3 = this.video) === null || _this$video3 === void 0 ? void 0 : (_this$video3$selected = _this$video3.selectedResource) === null || _this$video3$selected === void 0 ? void 0 : _this$video3$selected.url) || ''
        },
        ads: {
          campaign: this.options.adUnit || ((_this$video4 = this.video) === null || _this$video4 === void 0 ? void 0 : _this$video4.adUnit) || ''
        },
        extraParams: {
          param1: "".concat(this.options.src),
          param2: ((_this$video5 = this.video) === null || _this$video5 === void 0 ? void 0 : _this$video5.programId) || '',
          param3: ((_this$video6 = this.video) === null || _this$video6 === void 0 ? void 0 : _this$video6.channelId) || '',
          param4: this.getPlayerVersion(),
          param5: API_VERSION$1,
          param6: toLowerCase$1((_this$video7 = this.video) === null || _this$video7 === void 0 ? void 0 : _this$video7.kind) || '',
          param7: document.location.hostname,
          param8: getPlatformName$1(Video$1.getPlayerType()),
          param9: getExperimentsList$1(this.options).toString(),
          param10: this.container.playback.name,
          param11: undefined,
          param12: !!this.options.autoPlay,
          param13: this.container.getPlaybackType() !== Playback.LIVE && !!this.options.resumeAt && this.options.resumeAt > 0,
          param14: null,
          param15: undefined,
          param16: false,
          param17: ((_this$video8 = this.video) === null || _this$video8 === void 0 ? void 0 : _this$video8.isLive) ? false : null,
          // Reset the previous DAI Played (param17). It will be updated on onDaiResourceLoaded callback
          param18: '',
          // Reset the previous streamId (param18). It will be updated on onDaiResourceLoaded callback
          param19: !!this.options.skipDFP,
          param20: undefined
        }
      };
    }
  }]);

  function GloboYouBora(container) {
    var _this;

    _classCallCheck(this, GloboYouBora);

    _this = _super.call(this, container);
    _this.requestState = AD_STATES.initial;
    return _this;
  }

  _createClass(GloboYouBora, [{
    key: "bindEvents",
    value: function bindEvents() {
      _get(_getPrototypeOf(GloboYouBora.prototype), "bindEvents", this).call(this);

      this.listenTo(this.container.playback, Events.WM_VIDEO_METADATA_LOADED, this.onVideoMetadataLoaded);
      this.listenToOnce(this.container.playback, Events.WM_PLAY_REQUESTED_READY, this.onPlayRequestedReady);
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
      this.listenToOnce(this.container, Events$1.Custom.DAI_RESOURCE_LOADED, this.onDaiResourceLoaded);
      this.listenTo(this.container, Events.DFP_FINISHED, _get(_getPrototypeOf(GloboYouBora.prototype), "onEnded", this));
      this.listenTo(this.container, Events.DFP_AD_LOADED, this.onAdLoaded);
      this.listenTo(this.container, Events.DFP_AD_STARTED, this.onAdStarted);
      this.listenTo(this.container, Events.DFP_AD_PAUSE, this.onAdPause);
      this.listenTo(this.container, Events.DFP_AD_RESUME, this.onAdResume);
      this.listenTo(this.container, Events.DFP_AD_CLICKED, this.onAdClicked);
      this.listenTo(this.container, Events.DFP_AD_SKIPPED, this.onAdSkipped);
      this.listenTo(this.container, Events.DFP_ALL_ADS_COMPLETED, this.onAllAdsCompleted);
      this.listenTo(this.container, Events.DFP_CONTENT_RESUME, this.onContentResume);
      this.listenTo(this.container, Events.DFP_AD_ERROR, this.onAdError);
      this.listenTo(this.container, Events.DFP_AD_NOTSERVED, this.onAdNotServed);
      this.listenToOnce(this.container, Events.WM_RESOURCE_REQUEST_STATS, this.onResourceRequestStats);
    }
  }, {
    key: "getPlayerVersion",
    value: function getPlayerVersion() {
      var playerVersion = this.youboraPlugin.playerVersion();
      var _window = window,
          _window$GloboplaySDKP = _window.GloboplaySDKPlugins,
          GloboplaySDKPlugins = _window$GloboplaySDKP === void 0 ? {} : _window$GloboplaySDKP;

      if (GloboplaySDKPlugins.Version) {
        playerVersion = "".concat(playerVersion, "/").concat(GloboplaySDKPlugins.Version);
      }

      return playerVersion;
    }
  }, {
    key: "createPlugin",
    value: function createPlugin() {
      this.hasYouboraScript = true;

      this._startYouBora();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      _get(_getPrototypeOf(GloboYouBora.prototype), "destroy", this).call(this);

      if (this.plugin) nextTick(function () {
        _this2.plugin.endedHandler();
      });
    }
  }, {
    key: "onPlayRequestedReady",
    value: function onPlayRequestedReady() {
      if (!this.plugin) return;
      this.plugin.playhead = 0;
      this.plugin.playHandler();
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady(video) {
      this.setupAdHandler();
      this.setupInfoManager(video);
    }
  }, {
    key: "onDaiResourceLoaded",
    value: function onDaiResourceLoaded() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          streamId = _ref2.streamId;

      if (!this.plugin || !this.plugin.infoManager) return;
      var infoManagerOptions = {
        extraParams: {
          param17: true,
          // DAI Played
          param18: streamId
        }
      };
      this.plugin.infoManager.setOptions(infoManagerOptions);
    }
  }, {
    key: "setupInfoManager",
    value: function setupInfoManager(video) {
      if (!this.plugin || !this.plugin.infoManager) return;
      var infoManagerOptions = {
        transactionCode: session$3.getVideoSessionId(this.options.playerId),
        media: {
          cdn: (video.cdn || '').toUpperCase(),
          resource: video.selectedResource.url
        },
        extraParams: {
          param11: this.video.kind == 'live' ? this.video.transmission.signal : '',
          param15: this.video.selectedResource && this.video.selectedResource.resourcePOP || '',
          param20: this.video.isLive ? this.video.selectedResource && this.video.selectedResource.dai : ''
        }
      };
      this.plugin.infoManager.setOptions(infoManagerOptions);
    }
  }, {
    key: "onVideoMetadataLoaded",
    value: function onVideoMetadataLoaded(video) {
      this.video = video;
      if (!this.plugin || !this.plugin.infoManager) return;
      this.plugin.infoManager.setOptions(this.youboraOptions);
    } // Override this method to normalize behavior when content has pos-roll

  }, {
    key: "onPlaybackEnded",
    value: function onPlaybackEnded() {
      (!this.container.options.dfp || this.hasAdBlock) && _get(_getPrototypeOf(GloboYouBora.prototype), "onEnded", this).call(this);
    }
  }, {
    key: "setupAdHandler",
    value: function setupAdHandler() {
      if (this.hasAdBlock || this.options.skipDFP) return;
      this.requestState = AD_STATES.initialized;
      this.adnalyzer && this.adnalyzer.initAdHandler();
    }
  }, {
    key: "onAdLoaded",
    value: function onAdLoaded(ad) {
      this.adnalyzer.ad = ad;
      if (this.requestState === AD_STATES.initialized) return;
      this.adnalyzer.playAdHandler();
    }
  }, {
    key: "onAdStarted",
    value: function onAdStarted() {
      if (this.requestState === AD_STATES.initialized) {
        this.requestState = AD_STATES.completed;
        this.adnalyzer.playAdHandler();
      } else {
        this.adnalyzer.joinAdHandler();
      }
    }
  }, {
    key: "onAdPause",
    value: function onAdPause() {
      this.adnalyzer.pauseAdHandler();
    }
  }, {
    key: "onAdResume",
    value: function onAdResume() {
      this.adnalyzer.resumeAdHandler();
    }
  }, {
    key: "onAdClicked",
    value: function onAdClicked() {
      this.adnalyzer.clickAdHandler();
    }
  }, {
    key: "onAdSkipped",
    value: function onAdSkipped() {
      this.adnalyzer.skipAdHandler();
    }
  }, {
    key: "onContentResume",
    value: function onContentResume() {
      if (this.hasAdBlock) return;
      this.adnalyzer.endedAdHandler();
    }
  }, {
    key: "onAdError",
    value: function onAdError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.requestState === AD_STATES.initial) {
        this.hasAdBlock = true;
        return;
      }

      this.adnalyzer.errorAdHandler(error.type, error.message);
      this.adnalyzer.endedAdHandler();
    }
  }, {
    key: "onAdNotServed",
    value: function onAdNotServed() {
      this.requestState = AD_STATES.completed;
      var code = 'AD_NOT_SERVED';
      var message = 'Ad not served';
      this.adnalyzer.noServedAdHandler(code, message);
    }
  }, {
    key: "onResourceRequestStats",
    value: function onResourceRequestStats(_ref3) {
      var totalAttempts = _ref3.totalAttempts,
          usedFallback = _ref3.usedFallback;
      if (!this.plugin || !this.plugin.infoManager) return;
      var infoManagerOptions = {
        extraParams: {
          param14: totalAttempts,
          param16: usedFallback
        }
      };
      this.plugin.infoManager.setOptions(infoManagerOptions);
    }
  }, {
    key: "_startYouBora",
    value: function _startYouBora() {
      _get(_getPrototypeOf(GloboYouBora.prototype), "createPlugin", this).call(this);

      this.adnalyzer = this.plugin.adnalyzer;
    }
  }]);

  return GloboYouBora;
}(Youbora);

var global$2 =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  (typeof global$2 !== 'undefined' && global$2);

var support = {
  searchParams: 'URLSearchParams' in global$2,
  iterable: 'Symbol' in global$2 && 'iterator' in Symbol,
  blob:
    'FileReader' in global$2 &&
    'Blob' in global$2 &&
    (function() {
      try {
        new Blob();
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in global$2,
  arrayBuffer: 'ArrayBuffer' in global$2
};

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ];

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    };
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift();
      return {done: value === undefined, value: value}
    }
  };

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    };
  }

  return iterator
}

function Headers(headers) {
  this.map = {};

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name]);
    }, this);
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ', ' + value : value;
};

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)];
};

Headers.prototype.get = function(name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null
};

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
};

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};

Headers.prototype.keys = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push(name);
  });
  return iteratorFor(items)
};

Headers.prototype.values = function() {
  var items = [];
  this.forEach(function(value) {
    items.push(value);
  });
  return iteratorFor(items)
};

Headers.prototype.entries = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items)
};

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true;
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = function() {
      reject(reader.error);
    };
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false;

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed;
    this._bodyInit = body;
    if (!body) {
      this._bodyText = '';
    } else if (typeof body === 'string') {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8');
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
    }
  };

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    };

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    };
  }

  this.text = function() {
    var rejected = consumed(this);
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  };

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    };
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  };

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {};
  var body = options.body;

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }

  this.credentials = options.credentials || this.credentials || 'same-origin';
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || 'GET');
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body);

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/;
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/;
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
};

function decode(body) {
  var form = new FormData();
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers();
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':');
    var key = parts.shift().trim();
    if (key) {
      var value = parts.join(':').trim();
      headers.append(key, value);
    }
  });
  return headers
}

Body.call(Request.prototype);

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {};
  }

  this.type = 'default';
  this.status = options.status === undefined ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = 'statusText' in options ? options.statusText : '';
  this.headers = new Headers(options.headers);
  this.url = options.url || '';
  this._initBody(bodyInit);
}

Body.call(Response.prototype);

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
};

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''});
  response.type = 'error';
  return response
};

var redirectStatuses = [301, 302, 303, 307, 308];

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
};

var DOMException$1 = global$2.DOMException;
try {
  new DOMException$1();
} catch (err) {
  DOMException$1 = function(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };
  DOMException$1.prototype = Object.create(Error.prototype);
  DOMException$1.prototype.constructor = DOMException$1;
}

function fetch$1(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init);

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException$1('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest();

    function abortXhr() {
      xhr.abort();
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      };
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
      var body = 'response' in xhr ? xhr.response : xhr.responseText;
      setTimeout(function() {
        resolve(new Response(body, options));
      }, 0);
    };

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'));
      }, 0);
    };

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'));
      }, 0);
    };

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException$1('Aborted', 'AbortError'));
      }, 0);
    };

    function fixUrl(url) {
      try {
        return url === '' && global$2.location.href ? global$2.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true);

    if (request.credentials === 'include') {
      xhr.withCredentials = true;
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false;
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob';
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer';
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
      });
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr);

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr);
        }
      };
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
  })
}

fetch$1.polyfill = true;

if (!global$2.fetch) {
  global$2.fetch = fetch$1;
  global$2.Headers = Headers;
  global$2.Request = Request;
  global$2.Response = Response;
}

var PlayerSettings$3 = window.WM && window.WM.Settings || {};
var bitrateCappingSettings = PlayerSettings$3.bitrateCapping && PlayerSettings$3.bitrateCapping || {};
var second = 1000;
var minute = 60 * second;
var defaultPoolingInterval = 10 * minute;
var POOLING_INTERVAL = bitrateCappingSettings.poolingInterval || PlayerSettings$3.bitrateCappingPoolingInterval || defaultPoolingInterval;
var BITRATE_UNLIMITED = 0;
var LEVEL_UNLIMITED = -1;

var checkStatus = function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) return response;
  var error = new Error(response.statusText);
  error.response = response;
  throw error;
};

var extractJSON = function extractJSON(response) {
  return response.json();
};

var BitrateCapping = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(BitrateCapping, _ContainerPlugin);

  var _super = _createSuper(BitrateCapping);

  _createClass(BitrateCapping, [{
    key: "name",
    get: function get() {
      return 'bitrate_capping';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "host",
    get: function get() {
      return "".concat(this.options.env.protocol, "://wroom.video.globo.com/limits");
    }
  }, {
    key: "isHlsjsPlayback",
    get: function get() {
      return this.playback.name === 'id_playback' && this.playback.innerPlaybackName === 'hls';
    }
  }]);

  function BitrateCapping(container) {
    var _this;

    _classCallCheck(this, BitrateCapping);

    _this = _super.call(this, container);
    _this.options.bitrateCappingDisabled && _this.disable();
    return _this;
  }

  _createClass(BitrateCapping, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.stopListening();
      this.listenTo(this.playback, Events.WM_RESOURCE_READY, this._onResourceReady);
      this.listenTo(this.playback, Events.WM_RESOURCE_ERROR, this._onResourceError);
      this.listenTo(this.playback, Events.WM_RESOURCE_SELECTED, this._onResourceSelected);
    }
  }, {
    key: "disable",
    value: function disable() {
      _get(_getPrototypeOf(BitrateCapping.prototype), "disable", this).call(this);

      this._currentBitrate && this._capBitrate(BITRATE_UNLIMITED);

      this._stopPolling();
    }
  }, {
    key: "enable",
    value: function enable() {
      _get(_getPrototypeOf(BitrateCapping.prototype), "enable", this).call(this);

      this._bindPlaybackEvents();

      this.playback.isPlaying() && this._startPolling();
    }
  }, {
    key: "_bindPlaybackEvents",
    value: function _bindPlaybackEvents() {
      this._unbindPlaybackEvents();

      this.listenTo(this.playback, Events$1.PLAYBACK_PLAY, this._startPolling);
      this.listenTo(this.playback, Events$1.PLAYBACK_PAUSE, this._stopPolling);
      this.listenTo(this.playback, Events$1.PLAYBACK_STOP, this._stopPolling);
      this.listenTo(this.playback, Events$1.PLAYBACK_ENDED, this._stopPolling);
      this.listenTo(this.playback, Events$1.PLAYBACK_ERROR, this._stopPolling);
    }
  }, {
    key: "_unbindPlaybackEvents",
    value: function _unbindPlaybackEvents() {
      this.stopListening(this.playback, Events$1.PLAYBACK_PLAY, this._startPolling);
      this.stopListening(this.playback, Events$1.PLAYBACK_PAUSE, this._stopPolling);
      this.stopListening(this.playback, Events$1.PLAYBACK_STOP, this._stopPolling);
      this.stopListening(this.playback, Events$1.PLAYBACK_ENDED, this._stopPolling);
      this.stopListening(this.playback, Events$1.PLAYBACK_ERROR, this._stopPolling);
    }
  }, {
    key: "_buildLimitsUrl",
    value: function _buildLimitsUrl() {
      var url = new URL(this.host);
      var _this$resource$select = this.resource.selectedResource,
          selectedResource = _this$resource$select === void 0 ? {} : _this$resource$select;
      var pop = selectedResource.resourcePOP;

      if (pop) {
        url.search = new URLSearchParams({
          pop: pop
        });
      }

      return url;
    }
  }, {
    key: "_fetchLimits",
    value: function _fetchLimits() {
      var _this2 = this;

      Log$1.info(this.name, 'fetching bitrate capping');
      fetch(this._buildLimitsUrl()).then(checkStatus).then(extractJSON).then(function (_ref) {
        var b = _ref.b;
        return _this2._capBitrate(b);
      })["catch"](function (error) {
        return Log$1.warn(_this2.name, 'error fetching bitrate capping:', error);
      });
    }
  }, {
    key: "_capBitrate",
    value: function _capBitrate(bitrate) {
      if (this._currentBitrate === bitrate) {
        Log$1.info(this.name, 'no limit changes');
        return;
      }

      if (bitrate) {
        Log$1.warn(this.name, "capping bitrate to ".concat(bitrate));
      } else {
        Log$1.warn(this.name, 'reset bitrate to unlimited');
      }

      var level = this._getLevelFromBitrate(bitrate);

      if (level >= 0) {
        Log$1.warn(this.name, "capping level to ".concat(level));
      }

      this._currentBitrate = bitrate;

      this._capLevelIndex(level);

      this.container.trigger(Events.WM_BITRATE_CAP, bitrate);
    }
  }, {
    key: "_capLevelIndex",
    value: function _capLevelIndex(level) {
      this.isHlsjsPlayback && this._capHlsjsLevel(level);
    }
  }, {
    key: "_capHlsjsLevel",
    value: function _capHlsjsLevel(level) {
      this._destroyCapLevelController();

      this._updateHlsjsConfig(level);

      this._createCapLevelController();
    }
  }, {
    key: "_createCapLevelController",
    value: function _createCapLevelController() {
      var capLevelToPlayerSize = !this._currentBitrate && this.playback.options.playback.hlsjsConfig.capLevelToPlayerSize;

      if (capLevelToPlayerSize) {
        var hls = this.playback.playback._hls;
        var controller = new hls.config.capLevelController(hls);
        controller.onMediaAttaching(hls);
        controller.onManifestParsed(hls);

        this.playback.playback._hls.coreComponents.push(controller);
      }
    }
  }, {
    key: "_destroyCapLevelController",
    value: function _destroyCapLevelController() {
      var _this3 = this;

      this.playback.playback._hls.coreComponents = this.playback.playback._hls.coreComponents.filter(function (component) {
        var isCapLevelController = _this3._isHlsjsCapLevelController(component);

        if (isCapLevelController) {
          component.unregisterListeners();
          component.destroy();
        }

        return !isCapLevelController;
      });
    }
  }, {
    key: "_updateHlsjsConfig",
    value: function _updateHlsjsConfig(autoLevelCapping) {
      this.playback.playback._hls.autoLevelCapping = autoLevelCapping;
    }
  }, {
    key: "_isHlsjsCapLevelController",
    value: function _isHlsjsCapLevelController(component) {
      return component.constructor === this.playback.playback._hls.config.capLevelController;
    }
  }, {
    key: "_getLevelFromBitrate",
    value: function _getLevelFromBitrate(bitrate) {
      if (!bitrate) return LEVEL_UNLIMITED;
      var index;
      var levels = [];

      if (this.isHlsjsPlayback) {
        levels = this.playback.playback._hls.levels;
      }

      index = levels.reduce(function (acc, level, currentIndex) {
        return level.bitrate <= bitrate ? currentIndex : acc;
      }, 0);
      index > levels.length && (index = LEVEL_UNLIMITED);
      Log$1.debug(this.name, 'selected level:', levels[index]);
      return index;
    }
  }, {
    key: "_onResourceSelected",
    value: function _onResourceSelected(resource) {
      this._stopPolling();

      this.resource = resource;
    }
  }, {
    key: "_onResourceError",
    value: function _onResourceError() {
      Log$1.info(this.name, 'resource error: disabling');
      this.disable();
    }
  }, {
    key: "_onResourceReady",
    value: function _onResourceReady(video) {
      if (video.cdn === 'globo') {
        Log$1.info(this.name, ' video loaded, waiting for start');

        this._bindPlaybackEvents();
      } else {
        Log$1.info(this.name, 'cdn does not allow bitrate capping');
        this.disable();
      }
    }
  }, {
    key: "_startPolling",
    value: function _startPolling() {
      var _this4 = this;

      if (!this._pollTimerId) {
        Log$1.info(this.name, 'video playing, configuring polling');
        this._pollTimerId = setInterval(function () {
          return _this4._fetchLimits();
        }, POOLING_INTERVAL);

        this._fetchLimits();
      }
    }
  }, {
    key: "_stopPolling",
    value: function _stopPolling() {
      if (this._pollTimerId) {
        Log$1.info(this.name, 'polling canceled');
        clearInterval(this._pollTimerId);
        delete this._pollTimerId;
      }
    }
  }]);

  return BitrateCapping;
}(ContainerPlugin);

var getCurrentTime$2 = Utils$1.getCurrentTime;
var PING_INTERVAL = 60 * 1000;

var SimulcastPing = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(SimulcastPing, _ContainerPlugin);

  var _super = _createSuper(SimulcastPing);

  function SimulcastPing() {
    _classCallCheck(this, SimulcastPing);

    return _super.apply(this, arguments);
  }

  _createClass(SimulcastPing, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.bindPlaybackEvents);
    }
  }, {
    key: "bindPlaybackEvents",
    value: function bindPlaybackEvents(video) {
      if (!video.isLive) return;
      this.listenTo(this.playback, Events$1.PLAYBACK_STOP, this.stopTimer);
      this.listenTo(this.playback, Events$1.PLAYBACK_ERROR, this.stopTimer);
      this.listenTo(this.playback, Events$1.PLAYBACK_ENDED, this.stopTimer);
      this.listenToOnce(this.playback, Events$1.PLAYBACK_PLAY, this.onPlay);
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      this.startTimer();
      this.heartbeatTick();
    }
  }, {
    key: "heartbeatTick",
    value: function heartbeatTick() {
      if (!this.innerPlayback) return;
      this.container.trigger(Events.SIMULCAST_PING, getCurrentTime$2(this.innerPlayback));
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      this.heartbeat = setInterval(this.heartbeatTick.bind(this), this.pingInterval);
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      this.heartbeat && clearInterval(this.heartbeat);
    }
  }, {
    key: "restartTimer",
    value: function restartTimer() {
      this.stopTimer();
      this.startTimer();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopTimer();

      _get(_getPrototypeOf(SimulcastPing.prototype), "destroy", this).call(this);
    }
  }, {
    key: "name",
    get: function get() {
      return 'simulcast-ping';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "innerPlayback",
    get: function get() {
      return this.playback.playback;
    }
  }, {
    key: "pingInterval",
    get: function get() {
      return PING_INTERVAL;
    }
  }]);

  return SimulcastPing;
}(ContainerPlugin);

var WatchSession = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(WatchSession, _ContainerPlugin);

  var _super = _createSuper(WatchSession);

  _createClass(WatchSession, [{
    key: "name",
    get: function get() {
      return 'watch_session';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "dfp",
    get: function get() {
      return this.options.dfp;
    }
  }]);

  function WatchSession(container) {
    var _this;

    _classCallCheck(this, WatchSession);

    _this = _super.call(this, container);
    _this._isVideoFinished = false;
    return _this;
  }

  _createClass(WatchSession, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.dfp, Events.DFP_ALL_ADS_COMPLETED, this.onAllAdsCompleted);
      this.listenTo(this.container, Events$1.CONTAINER_ENDED, this.onVideoFinished);
    }
  }, {
    key: "onAllAdsCompleted",
    value: function onAllAdsCompleted() {
      this.sendEvent();
    }
  }, {
    key: "onVideoFinished",
    value: function onVideoFinished() {
      this._isVideoFinished = true;
      this.sendEvent();
    }
  }, {
    key: "sendEvent",
    value: function sendEvent() {
      var hasDFPConditionsFilled = this.dfp.isAllAdsCompleted || this.dfp.shouldSkipAd || this.dfp.error;
      hasDFPConditionsFilled && this._isVideoFinished && this.container.trigger(Events.WATCH_SESSION_END);
    }
  }]);

  return WatchSession;
}(ContainerPlugin);

var globocomHorizon = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t();}("undefined"!=typeof self?self:commonjsGlobal,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:r});},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=6)}([function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=o(n(10));function o(e){return e&&e.__esModule?e:{default:e}}var i={AVOID_COOKIE_USAGE:!1,EVENTS_BUFFER_SIZE:100,EVENTS_SENDER_INTERVAL:1e4,EVENTS_SENDER_MIN_INTERVAL:5e3,EVENTS_SENDER_MAX_INTERVAL:2e4,EVENTS_DISCARD_AFTER_MSECS:36e5,EVENTS_BULK_SIZE:10,HORIZON_CALLBACK_STACK_LIMIT:1e3,HORIZON_TRACK_IDENTIFICATION_RESOURCE:"id",HORIZON_TRACK_HOST:"horizon-track.globo.com",HORIZON_CLIENT_UUID:o(n(2)).default.getResource("clientInstanceUUID",(0, r.default)()),HORIZON_REQUEST_ENCODING:"base64",HORIZON_SCHEMAS_HOST:"horizon-schemas.globo.com",IDENTIFICATION_LOAD_RETRY_AFTER_MSECS:5e3,PACKAGE_VERSION:"1.10.0",SCHEMA_VALIDATOR_SCRIPT_URL:"s3.glbimg.com/cdn/libs/tv4/1.3.0/tv4.min.js",SCHEMA_VALIDATOR_SCRIPT_MAX_RETRIES:2,SCHEMA_LOAD_COLLECTION_RETRY_AFTER_MSECS:1e4,USE_HTTPS:!0},a={avoidCookieUsage:function(){i.AVOID_COOKIE_USAGE=!0;},useHTTPOnly:function(){i.USE_HTTPS=!1;},useQAConfiguration:function(){i.HORIZON_TRACK_HOST="horizon-track.qa.globoi.com",i.HORIZON_SCHEMAS_HOST="horizon-schemas.qa.globoi.com",i.HORIZON_REQUEST_ENCODING="json";}};t.default=Object.assign(i,a);},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r={COMPONENT_NOT_READY:"[Horizon] Component is not ready.",COMPONENT_UNAVAILABLE:"[Horizon] Class or function is required.",DUPLICATED_SCHEMA:"[Horizon] Duplicated schema.",ERROR_LOADING_RESOURCE:"[Horizon] Failed to load resource.",INVALID_AUTH_TOKEN:"[Horizon] Invalid authorization token.",INVALID_DATA:"[Horizon] Invalid data.",INVALID_DATE:"[Horizon] Invalid date-time RFC 3339 format.",INVALID_STRING_NUMERIC_STRING:"[Horizon] numericString should be string.",INVALID_EMPTY_NUMERIC_STRING:"[Horizon] numericString should be empty.",INVALID_NUMERIC_STRING:"[Horizon] Invalid number. Field with NumericString must to be number.",INVALID_ENVIRONMENT:"[Horizon] Invalid environment value.",INVALID_FORMAT:"[Horizon] Invalid event format.",INVALID_REQUEST:"[Horizon] Invalid request.",INVALID_TIMESTAMP:"[Horizon] Invalid timestamp.",INVALID_VERSION_FORMAT:"[Horizon] Invalid version format.",INVALID_RELATION_ID:"[Horizon] Invalid relation identification.",LIMIT_EXCEEDED:"[Horizon] Resource limit exceeded.",MUST_BE_DEFINED:"[Horizon] Parameter or argument must be defined",SCHEMA_VALIDATOR_ERROR_LOADING:"[Horizon] Could not load SchemaValidator.",UNSUPPORTED_TYPE:"[Horizon] Unsupported type.",UNSUPPORTED_TENANT:"[Horizon] Unsupported tenant.",UNSUPPORTED_ENCODER:"[Horizon] Unsupported encoder.",USE_MANAGER_ONLY_WHEN_AVOIDING_COOKIE:"[Horizon] Can not set or remove a logged user when AVOID_COOKIE_USAGE is not enabled."},o={mustBeDefined:function(e){throw new Error(r.MUST_BE_DEFINED+": "+e+".")}};t.default=Object.assign(r,o);},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){return window.horizonResources=window.horizonResources||{},window.horizonResources};t.default={getContext:r,getResource:function(e,t){var n=r();return n[e]=n[e]||t,n[e]}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});t.default={execAsync:function(e,t){setTimeout(function(){return e(t)},1);}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});t.default={request:function(e,t,n,r){var o=new XMLHttpRequest;o.open(e,t,!0),o.onload=function(){return o.status<400?n(JSON.parse(o.response)):r(o.response)},o.onerror=r,o.send();}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=c(n(3)),i=c(n(2)),a=c(n(1)),u=c(n(4)),s=c(n(0));function c(e){return e&&e.__esModule?e:{default:e}}var l=function(){return i.default.getResource("idManager",{loggedIDs:null,anonymousIDs:null,sessionIDs:null})},f=["GLBID","GST"],d={STATE_READY:"statusReady",STATE_NOT_READY:"statusNotReady",STATE_LOADING:"statusLoading",STATE_SCHEDULED:"statusScheduled",STATE_ERROR:"statusError"},h=function(){function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.state=n?d.STATE_READY:d.STATE_NOT_READY,this.url=t,this.bypass=n,this.callbacks={onReady:[],onError:[],onRetry:[],onLoad:[]};}return r(e,[{key:"onLoad",value:function(e){this.callbacks.onLoad.push(e);}},{key:"onRetry",value:function(e){this.callbacks.onRetry.push(e);}},{key:"onReady",value:function(e){if(this.state===d.STATE_READY)return e(this.getClientIDs());if(this.callbacks.onReady.length>s.default.HORIZON_CALLBACK_STACK_LIMIT)throw new Error(a.default.LIMIT_EXCEEDED+" IDManager callback stack.");return this.callbacks.onReady.push(e)}},{key:"onError",value:function(e){this.state===d.STATE_ERROR?e():this.callbacks.onError.push(e);}},{key:"getAsKeyValue",value:function(){if(!this.isReady())throw new Error(""+a.default.COMPONENT_NOT_READY);if(this.bypass)return "";var e=this.getClientIDs();return Object.keys(e).map(function(t){return encodeURIComponent(t)+"="+encodeURIComponent(e[t])}).join("&")}},{key:"getClientIDs",value:function(){var e=l();return Object.assign(e.loggedIDs||{},e.anonymousIDs||{},e.sessionIDs||{})}},{key:"isReady",value:function(){return this.state===d.STATE_READY}},{key:"retry",value:function(){var e=this;this.state=d.STATE_SCHEDULED,this.callbacks.onRetry.forEach(function(e){return e()}),setTimeout(function(){e.state=d.STATE_NOT_READY,e.load();},s.default.IDENTIFICATION_LOAD_RETRY_AFTER_MSECS);}},{key:"setLoggedUser",value:function(e,t){if(-1===f.indexOf(e))throw Error(a.default.INVALID_AUTH_TOKEN);var n=l();n.loggedIDs=Object.assign(n.loggedIDs||{},function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}({},e,t));}},{key:"setAnonymousUser",value:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=l();if(null==n.anonymousIDs||t){if(!("glb_uid"in e&&"glb_uid_public"in e))throw a.default.mustBeDefined("glb_uid and glb_uid_public");var r={glb_uid:e.glb_uid,glb_uid_public:e.glb_uid_public};n.anonymousIDs=Object.assign(n.anonymousIDs||{},r);}}},{key:"getAnonymousUser",value:function(){return l().anonymousIDs}},{key:"setSessionID",value:function(e){e.hsid&&(l().sessionIDs=Object.assign({},{hsid:e.hsid}));}},{key:"removeLoggedUser",value:function(){var e=l();f.forEach(function(t){e.loggedIDs[t]&&delete e.loggedIDs[t];});}},{key:"load",value:function(){var e=this;if(this.state===d.STATE_NOT_READY){this.state=d.STATE_LOADING,this.callbacks.onLoad.forEach(function(e){return e()});var t=s.default.USE_HTTPS?"https://":"http://";u.default.request("GET",""+t+this.url,function(t){e.setSessionID(t),e.setAnonymousUser(t,!1),e.state=d.STATE_READY,e.callbacks.onReady.forEach(function(t){return o.default.execAsync(t,e.getClientIDs())});},function(t){e.state=d.STATE_ERROR,e.callbacks.onError.forEach(function(e){return o.default.execAsync(e,t)}),e.retry();});}}}]),e}(),E=function(e){var t=l();if(!t.instance){var n=e||s.default.HORIZON_TRACK_HOST+"/"+s.default.HORIZON_TRACK_IDENTIFICATION_RESOURCE,r=!1===s.default.AVOID_COOKIE_USAGE;t.instance=new h(n,r);}return t.instance};t.default={getInstance:E,getContextManager:l,setLoggedUser:function(e,t){if(!s.default.AVOID_COOKIE_USAGE)throw Error(a.default.USE_MANAGER_ONLY_WHEN_AVOIDING_COOKIE);e&&0!==e.length||a.default.mustBeDefined("tokenName"),t&&0!==t.length||a.default.mustBeDefined("tokenValue"),E().setLoggedUser(e,t);},removeLoggedUser:function(){if(!s.default.AVOID_COOKIE_USAGE)throw Error(a.default.USE_MANAGER_ONLY_WHEN_AVOIDING_COOKIE);E().removeLoggedUser();},setAnonymousUser:function(e){E().setAnonymousUser(e);},getAnonymousUser:function(){return E().getAnonymousUser()}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.IDManager=t.Settings=t.HorizonClient=void 0,n(7);var r=a(n(9)),o=a(n(0)),i=a(n(5));function a(e){return e&&e.__esModule?e:{default:e}}var u={setLoggedUser:i.default.setLoggedUser,removeLoggedUser:i.default.removeLoggedUser,setAnonymousUser:i.default.setAnonymousUser,getAnonymousUser:i.default.getAnonymousUser};t.HorizonClient=r.default,t.Settings=o.default,t.IDManager=u;},function(e,t,n){n(8).polyfill();},function(e,t,n){function r(e,t){if(void 0===e||null===e)throw new TypeError("Cannot convert first argument to object");for(var n=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(void 0!==o&&null!==o)for(var i=Object.keys(Object(o)),a=0,u=i.length;a<u;a++){var s=i[a],c=Object.getOwnPropertyDescriptor(o,s);void 0!==c&&c.enumerable&&(n[s]=o[s]);}}return n}e.exports={assign:r,polyfill:function(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:r});}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=d(n(0)),a=d(n(13)),u=d(n(1)),s=d(n(15)),c=d(n(26)),l=d(n(27)),f=d(n(5));function d(e){return e&&e.__esModule?e:{default:e}}var h={READY:"stateReady",UNLOADED:"stateNotReady",LOADING:"stateLoading"},E=["web","instant-article","app"],v=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,r=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,d=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"web";if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.tenant=t||l.default.getTenant()||u.default.mustBeDefined("tenant"),this.deviceGroup=n||l.default.getDeviceGroup()||u.default.mustBeDefined("deviceGroup"),this.defaultContentType=o,-1===E.indexOf(d))throw Error(u.default.INVALID_ENVIRONMENT);this.environment=d,this.validator=a.default,this.clientVersion=i.default.PACKAGE_VERSION,this.state=h.UNLOADED,this.referer=document.referrer;var v=null,y=null,_=null;this.setSchemasProvider=function(e){v=e;},this.getSchemasProvider=function(){if(!v){var e=c.default.getInstance();r.setSchemasProvider(e);}return v},this.setEventBus=function(e){y=e;},this.getEventBus=function(){if(!y){var e=s.default.getInstance(r.tenant,r.deviceGroup,r.environment,r.getIdManager());r.setEventBus(e);}return y},this.setIdManager=function(e){_=e;},this.getIdManager=function(){if(!_){var e=f.default.getInstance();r.setIdManager(e);}return _},this.isReady=function(){return !!v&&(!!_&&(r.validator.isReady()&&v.isReady()&&_.isReady()))},window.addEventListener("beforeunload",function(){r.unload();});}return o(e,[{key:"useDefaultContentType",value:function(e){this.defaultContentType=e;}},{key:"setValidator",value:function(e){this.validator=e;}},{key:"setReferer",value:function(e){this.referer=e||document.referrer;}},{key:"unload",value:function(){this.flush();}},{key:"getScopeInfo",value:function(e){return {url:document.location.href,actionTs:+Date.now(),horizonClientVersion:this.clientVersion,horizonClientReferer:this.referer,horizonRelationId:e}}},{key:"validateBeforeEnqueue",value:function(e){var t=this.getSchemasProvider().get(e.id,e.version);this.validator.validateFor(e,t);}},{key:"onReady",value:function(e){this.validator.isReady()?this.getSchemasProvider().isReady()?this.getIdManager().isReady()?(this.state=h.READY,e()):(this.state=h.LOADING,this.getIdManager().onReady(e),this.getIdManager().load()):(this.state=h.LOADING,this.getSchemasProvider().onReady(e),this.getSchemasProvider().load()):(this.state=h.LOADING,this.validator.onReady(e),this.validator.load());}},{key:"flush",value:function(){var e=this;this.isReady()?this.getEventBus().flush():this.onReady(function(){return e.flush()});}},{key:"send",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(null!=n&&"string"!=typeof n)throw new Error(u.default.INVALID_RELATION_ID+" Wrong relationId type. It should be a String: actual type is "+(void 0===n?"undefined":r(n)));[].concat(e).forEach(function(e){t.validator.validateArgs(e),t.sendWithInfo(e,t.getScopeInfo(n));});}},{key:"sendWithInfo",value:function(e,t){var n=this;if(!this.isReady())return this.state===h.UNLOADED&&this.flush(),void this.onReady(function(){return n.sendWithInfo(e,t)});this.validateBeforeEnqueue(e);var r=Object.assign({},t,e);r.contentType||(this.defaultContentType||u.default.mustBeDefined("contentType"),r.contentType=this.defaultContentType),this.getEventBus().enqueue(r);}}]),e}();t.default=v;},function(e,t,n){var r=n(11),o=n(12);e.exports=function(e,t,n){var i=t&&n||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var a=(e=e||{}).random||(e.rng||r)();if(a[6]=15&a[6]|64,a[8]=63&a[8]|128,t)for(var u=0;u<16;++u)t[i+u]=a[u];return t||o(a)};},function(e,t){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var r=new Uint8Array(16);e.exports=function(){return n(r),r};}else {var o=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),o[t]=e>>>((3&t)<<3)&255;return o};}},function(e,t){for(var n=[],r=0;r<256;++r)n[r]=(r+256).toString(16).substr(1);e.exports=function(e,t){var r=t||0,o=n;return [o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],"-",o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]],o[e[r++]]].join("")};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=u(n(14)),i=u(n(1)),a=u(n(0));function u(e){return e&&e.__esModule?e:{default:e}}var s={ready:[]},c=["url"],l=function(){return !!window.tv4},f=function(e){return null===e?null:isNaN(e)&&!isNaN(Date.parse(e))?null:i.default.INVALID_DATE},d=function(e){return "string"!=typeof e?i.default.INVALID_STRING_NUMERIC_STRING:""===e.trim()?i.default.INVALID_EMPTY_NUMERIC_STRING:Number.isFinite(Number(e))?null:i.default.INVALID_NUMERIC_STRING};t.default={validateFor:function(e,t){if(!l())throw new Error(i.default.ERROR_LOADING_RESOURCE+" Validator is not ready.");if(!t)throw new Error(i.default.INVALID_DATA+" Argument: schema.");if(!/\d+\.\d+/.test(e.version))throw new Error(i.default.INVALID_VERSION_FORMAT);if(!tv4.validate(e.properties,t))throw new Error(i.default.INVALID_DATA+" "+e.id+" "+e.version+". "+tv4.error)},validateArgs:function(e){var t=Object.prototype.hasOwnProperty;if(!(e&&t.call(e,"id")&&t.call(e,"version")&&t.call(e,"properties")))throw new Error(i.default.INVALID_FORMAT+" Missing properties: "+JSON.stringify(e));if("string"!=typeof e.id||"string"!=typeof e.version||"object"!==r(e.properties))throw new Error(i.default.INVALID_FORMAT+" Wrong object type: "+JSON.stringify(e));if(c.filter(function(t){return e[t]&&"string"!=typeof e[t]}).length>0)throw new Error(i.default.INVALID_FORMAT+" Wrong object type: "+JSON.stringify(e));if(e.id.length<2||e.version.length<3)throw new Error(i.default.INVALID_FORMAT+" Invalid property size: "+JSON.stringify(e));var n=Object.assign({},e);delete n.id,delete n.version,delete n.properties,delete n.contentType;var o=Object.keys(n);if(o.length>0&&!o.every(function(e){return -1!==c.indexOf(e)}))throw new Error(i.default.INVALID_FORMAT+" Extra keys aren't allowed: "+JSON.stringify(n))},tv4IsValidData:f,tv4IsNumericString:d,isReady:l,onReady:function(e){if(l())return e();if(s.ready.length>a.default.HORIZON_CALLBACK_STACK_LIMIT)throw new Error(i.default.LIMIT_EXCEEDED+" Validator callback stack.");return s.ready.unshift(e)},load:function(){if(!o.default.isDefined("tv4")){var e=(a.default.USE_HTTPS?"https://":"http://")+a.default.SCHEMA_VALIDATOR_SCRIPT_URL;(0, o.default)([e],"tv4",{async:!0,numRetries:a.default.SCHEMA_VALIDATOR_SCRIPT_MAX_RETRIES,success:function(){tv4.addFormat("date-time",f),tv4.addFormat("numericString",d),s.ready.forEach(function(e){return e()});},error:function(e){throw new Error(i.default.SCHEMA_VALIDATOR_ERROR_LOADING+" "+e)}});}}};},function(e,t,n){var r,o,i;!function(n,a){o=[],void 0===(i="function"==typeof(r=a)?r.apply(t,o):r)||(e.exports=i);}(0,function(){var e=function(){},t={},n={},r={};function o(e,t){if(e){var o=r[e];if(n[e]=t,o)for(;o.length;)o[0](e,t),o.splice(0,1);}}function i(t,n){t.call&&(t={success:t}),n.length?(t.error||e)(n):(t.success||e)(t);}function a(t,n,r,o){var i,u,s=document,c=r.async,l=(r.numRetries||0)+1,f=r.before||e,d=t.replace(/^(css|img)!/,"");o=o||0,/(^css!|\.css$)/.test(t)?((u=s.createElement("link")).rel="stylesheet",u.href=d,(i="hideFocus"in u)&&u.relList&&(i=0,u.rel="preload",u.as="style")):/(^img!|\.(png|gif|jpg|svg)$)/.test(t)?(u=s.createElement("img")).src=d:((u=s.createElement("script")).src=t,u.async=void 0===c||c),u.onload=u.onerror=u.onbeforeload=function(e){var s=e.type[0];if(i)try{u.sheet.cssText.length||(s="e");}catch(e){18!=e.code&&(s="e");}if("e"==s){if((o+=1)<l)return a(t,n,r,o)}else if("preload"==u.rel&&"style"==u.as)return u.rel="stylesheet";n(t,s,e.defaultPrevented);},!1!==f(t,u)&&s.head.appendChild(u);}function u(e,n,r){var u,s;if(n&&n.trim&&(u=n),s=(u?r:n)||{},u){if(u in t)throw "LoadJS";t[u]=!0;}function c(t,n){!function(e,t,n){var r,o,i=(e=e.push?e:[e]).length,u=i,s=[];for(r=function(e,n,r){if("e"==n&&s.push(e),"b"==n){if(!r)return;s.push(e);}--i||t(s);},o=0;o<u;o++)a(e[o],r,n);}(e,function(e){i(s,e),t&&i({success:t,error:n},e),o(u,e);},s);}if(s.returnPromise)return new Promise(c);c();}return u.ready=function(e,t){return function(e,t){var o,i,a,u=[],s=(e=e.push?e:[e]).length,c=s;for(o=function(e,n){n.length&&u.push(e),--c||t(u);};s--;)i=e[s],(a=n[i])?o(i,a):(r[i]=r[i]||[]).push(o);}(e,function(e){i(t,e);}),u},u.done=function(e){o(e,[]);},u.reset=function(){t={},n={},r={};},u.isDefined=function(e){return e in t},u});},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();n(16);var o=f(n(2)),i=f(n(17)),a=f(n(0)),u=f(n(1)),s=f(n(22)),c=f(n(24)),l=f(n(25));function f(e){return e&&e.__esModule?e:{default:e}}var d=function(){return o.default.getResource("bus",{})},h=function(){function e(t,n,r,o,i){var f=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.currentTenant=t||u.default.mustBeDefined("tenant"),this.instanceID=n||u.default.mustBeDefined("instanceID"),this.deviceGroup=r||u.default.mustBeDefined("deviceGroup"),this.environment=o||u.default.mustBeDefined("environment"),this.queue=new c.default(a.default.EVENTS_BUFFER_SIZE),this.idManager=i,this.dispatchNumber=1,this.actionCounter=0,(new l.default).every(a.default.EVENTS_SENDER_INTERVAL).call(function(){f.queue=f.filterQueue();var e=f.prepareRequest();f.dispatch(e,a.default.HORIZON_REQUEST_ENCODING)||e.actions.forEach(function(e){return f.enqueue(e)});}).call(s.default.applyThrottlingPolicy).start();}return r(e,[{key:"setMaxQueueSize",value:function(e){this.queue=c.default.fromArray(this.queue.items,e);}},{key:"filterQueue",value:function(){var e=+Date.now()-a.default.EVENTS_DISCARD_AFTER_MSECS;return this.queue.filter(function(t){return t.actionTs>e})}},{key:"prepareRequest",value:function(){var e=this.queue.splice(0,a.default.EVENTS_BULK_SIZE);return this.actionCounter+=e.length,{horizonClientUUID:this.instanceID,horizonClientTenant:this.currentTenant,horizonClientTs:Date.now(),horizonClientType:"js",horizonClientDeviceGroup:this.deviceGroup,horizonDispatchNumber:this.dispatchNumber,horizonActionCounter:this.actionCounter,horizonEnvironment:this.environment,actions:e}}},{key:"isValidRequest",value:function(e){if(!e||e&&!e.actions)throw new Error(u.default.INVALID_REQUEST);return e.actions.length>0}},{key:"dispatch",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"json",n=a.default.USE_HTTPS?"https://":"http://",r=this.idManager.getAsKeyValue(),o=r?"?"+r:"",u=""+n+s.default.applyDestinationPolicy()+"/event/"+this.currentTenant+o,c=i.default.get(t);if(!this.isValidRequest(e))return !1;this.dispatchNumber+=1;var l=c(e);return navigator.sendBeacon(u,l)}},{key:"enqueue",value:function(e){if(!e.actionTs)throw new Error(u.default.INVALID_TIMESTAMP);this.queue.push(e);}},{key:"flush",value:function(){for(;this.queue.length>0;){this.queue=this.filterQueue();var e=this.prepareRequest();this.dispatch(e,a.default.HORIZON_REQUEST_ENCODING);}}},{key:"length",get:function(){return this.queue.length}}]),e}();t.default={getInstance:function(e,t,n,r){var o=d(),i=e+"-"+t;return o[i]||(o[i]=new h(e,a.default.HORIZON_CLIENT_UUID,t,n,r)),o[i]},reset:function(e,t){e&&0!==e.length||u.default.mustBeDefined("tenant"),t&&0!==t.length||u.default.mustBeDefined("deviceGroup");var n=e+"-"+t;delete d()[n];},getContextBus:d};},function(e,t){function n(e){return (n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r=function(e){return "string"==typeof e},o=function(e){return e instanceof Blob};(function(){if(function(){return "navigator"in this&&"sendBeacon"in this.navigator}.call(this))return;"navigator"in this||(this.navigator={});this.navigator.sendBeacon=function(e,t){var n=this.event&&this.event.type,i="unload"===n||"beforeunload"===n,a="XMLHttpRequest"in this?new XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP");a.open("POST",e,!i),a.withCredentials=!0,a.setRequestHeader("Accept","*/*"),r(t)?(a.setRequestHeader("Content-Type","text/plain;charset=UTF-8"),a.responseType="text/plain"):o(t)&&t.type&&a.setRequestHeader("Content-Type",t.type);try{a.send(t);}catch(e){return !1}return !0}.bind(this);}).call("object"===("undefined"==typeof window?"undefined":n(window))?window:{});},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=a(n(18)),o=a(n(21)),i=a(n(1));function a(e){return e&&e.__esModule?e:{default:e}}var u={base64:function(e){var t=new FormData;return t.append("data",r.default.encode(o.default.encode(JSON.stringify(e)))),t.append("encoding","base64"),t},json:function(e){return JSON.stringify(e)}};t.default={get:function(e){if(!(e in u))throw new Error(i.default.UNSUPPORTED_ENCODER+" Invalid "+e+" encoder.");return u[e]}};},function(e,t,n){(function(e,r){var o;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */!function(i){var u=("object"==typeof e&&e&&e.exports,"object"==typeof r&&r);u.global!==u&&u.window;var s=function(e){this.message=e;};(s.prototype=new Error).name="InvalidCharacterError";var c=function(e){throw new s(e)},l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",f=/[\t\n\f\r ]/g,d={encode:function(e){e=String(e),/[^\0-\xFF]/.test(e)&&c("The string to be encoded contains characters outside of the Latin1 range.");for(var t,n,r,o,i=e.length%3,a="",u=-1,s=e.length-i;++u<s;)t=e.charCodeAt(u)<<16,n=e.charCodeAt(++u)<<8,r=e.charCodeAt(++u),a+=l.charAt((o=t+n+r)>>18&63)+l.charAt(o>>12&63)+l.charAt(o>>6&63)+l.charAt(63&o);return 2==i?(t=e.charCodeAt(u)<<8,n=e.charCodeAt(++u),a+=l.charAt((o=t+n)>>10)+l.charAt(o>>4&63)+l.charAt(o<<2&63)+"="):1==i&&(o=e.charCodeAt(u),a+=l.charAt(o>>2)+l.charAt(o<<4&63)+"=="),a},decode:function(e){var t=(e=String(e).replace(f,"")).length;t%4==0&&(t=(e=e.replace(/==?$/,"")).length),(t%4==1||/[^+a-zA-Z0-9/]/.test(e))&&c("Invalid character: the string to be decoded is not correctly encoded.");for(var n,r,o=0,i="",a=-1;++a<t;)r=l.indexOf(e.charAt(a)),n=o%4?64*n+r:r,o++%4&&(i+=String.fromCharCode(255&n>>(-2*o&6)));return i},version:"0.1.0"};void 0===(o=function(){return d}.call(t,n,t,e))||(e.exports=o);}();}).call(t,n(19)(e),n(20));},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e};},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this");}catch(e){"object"==typeof window&&(n=window);}e.exports=n;},function(e,t,n){!function(e){var t,n,r,o=String.fromCharCode;function i(e){for(var t,n,r=[],o=0,i=e.length;o<i;)(t=e.charCodeAt(o++))>=55296&&t<=56319&&o<i?56320==(64512&(n=e.charCodeAt(o++)))?r.push(((1023&t)<<10)+(1023&n)+65536):(r.push(t),o--):r.push(t);return r}function a(e){if(e>=55296&&e<=57343)throw Error("Lone surrogate U+"+e.toString(16).toUpperCase()+" is not a scalar value")}function u(e,t){return o(e>>t&63|128)}function s(e){if(0==(4294967168&e))return o(e);var t="";return 0==(4294965248&e)?t=o(e>>6&31|192):0==(4294901760&e)?(a(e),t=o(e>>12&15|224),t+=u(e,6)):0==(4292870144&e)&&(t=o(e>>18&7|240),t+=u(e,12),t+=u(e,6)),t+=o(63&e|128)}function c(){if(r>=n)throw Error("Invalid byte index");var e=255&t[r];if(r++,128==(192&e))return 63&e;throw Error("Invalid continuation byte")}function l(){var e,o;if(r>n)throw Error("Invalid byte index");if(r==n)return !1;if(e=255&t[r],r++,0==(128&e))return e;if(192==(224&e)){if((o=(31&e)<<6|c())>=128)return o;throw Error("Invalid continuation byte")}if(224==(240&e)){if((o=(15&e)<<12|c()<<6|c())>=2048)return a(o),o;throw Error("Invalid continuation byte")}if(240==(248&e)&&(o=(7&e)<<18|c()<<12|c()<<6|c())>=65536&&o<=1114111)return o;throw Error("Invalid UTF-8 detected")}e.version="3.0.0",e.encode=function(e){for(var t=i(e),n=t.length,r=-1,o="";++r<n;)o+=s(t[r]);return o},e.decode=function(e){t=i(e),n=t.length,r=0;for(var a,u=[];!1!==(a=l());)u.push(a);return function(e){for(var t,n=e.length,r=-1,i="";++r<n;)(t=e[r])>65535&&(i+=o((t-=65536)>>>10&1023|55296),t=56320|1023&t),i+=o(t);return i}(u)};}(t);},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=i(n(23)),o=i(n(0));function i(e){return e&&e.__esModule?e:{default:e}}t.default={applyThrottlingPolicy:function(e){var t=o.default.EVENTS_SENDER_MIN_INTERVAL,n=o.default.EVENTS_SENDER_MAX_INTERVAL,i=Number(r.default.get("_hzt.interval"))||o.default.EVENTS_SENDER_INTERVAL;i<=n&&i>=t&&e.interval!==i&&e.reschedule(i);},applyDestinationPolicy:function(){return r.default.get("_hzt.host")||o.default.HORIZON_TRACK_HOST}};},function(e,t,n){var r,o;
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */!function(i){if(void 0===(o="function"==typeof(r=i)?r.call(t,n,t,e):r)||(e.exports=o),e.exports=i(),!!0);}(function(){function e(){for(var e=0,t={};e<arguments.length;e++){var n=arguments[e];for(var r in n)t[r]=n[r];}return t}return function t(n){function r(t,o,i){var a;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},r.defaults,i)).expires){var u=new Date;u.setMilliseconds(u.getMilliseconds()+864e5*i.expires),i.expires=u;}i.expires=i.expires?i.expires.toUTCString():"";try{a=JSON.stringify(o),/^[\{\[]/.test(a)&&(o=a);}catch(e){}o=n.write?n.write(o,t):encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),t=(t=(t=encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var c in i)i[c]&&(s+="; "+c,!0!==i[c]&&(s+="="+i[c]));return document.cookie=t+"="+o+s}t||(a={});for(var l=document.cookie?document.cookie.split("; "):[],f=/(%[0-9A-Z]{2})+/g,d=0;d<l.length;d++){var h=l[d].split("="),E=h.slice(1).join("=");this.json||'"'!==E.charAt(0)||(E=E.slice(1,-1));try{var v=h[0].replace(f,decodeURIComponent);if(E=n.read?n.read(E,v):n(E,v)||E.replace(f,decodeURIComponent),this.json)try{E=JSON.parse(E);}catch(e){}if(t===v){a=E;break}t||(a[v]=E);}catch(e){}}return a}}return r.set=r,r.get=function(e){return r.call(r,e)},r.getJSON=function(){return r.apply({json:!0},[].slice.call(arguments))},r.defaults={},r.remove=function(t,n){r(t,"",e(n,{expires:-1}));},r.withConverter=t,r}(function(){})});},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var o=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:100;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._queue=[],this.maxSize=t;}return r(e,[{key:"push",value:function(e){this._queue=[e].concat(function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}(this.slice(0,this.maxSize-1)));}},{key:"forEach",value:function(e){return this._queue.forEach(e)}},{key:"slice",value:function(e,t){return this._queue.slice(e,t)}},{key:"splice",value:function(e,t){return this._queue.splice(e,t)}},{key:"clear",value:function(){this._queue=[];}},{key:"filter",value:function(t){return e.fromArray(this._queue.filter(t),this.maxSize)}},{key:"length",get:function(){return this._queue.length}},{key:"items",get:function(){return JSON.parse(JSON.stringify(this._queue))}}],[{key:"fromArray",value:function(t,n){var r=new e(n);return t.forEach(function(e){return r.push(e)}),r}}]),e}();t.default=o;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var o=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.interval=0,this.tickIntervalId=0,this.callbacks=[];}return r(e,[{key:"tick",value:function(){var e=this;this.callbacks.forEach(function(t){return t(e)});}},{key:"start",value:function(){return this.tickIntervalId=setInterval(this.tick.bind(this),this.interval),this}},{key:"stop",value:function(){return clearInterval(this.tickIntervalId),this.tickIntervalId=0,this}},{key:"reschedule",value:function(e){return this.stop().every(e).start()}},{key:"every",value:function(e){return this.interval=e,this}},{key:"call",value:function(e){return this.callbacks.push(e),this}},{key:"isRunning",get:function(){return !!this.tickIntervalId}}]),e}();t.default=o;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=c(n(3)),i=c(n(2)),a=c(n(1)),u=c(n(0)),s=c(n(4));function c(e){return e&&e.__esModule?e:{default:e}}var l={STATE_READY:"statusReady",STATE_NOT_READY:"statusNotReady",STATE_LOADING:"statusLoading",STATE_SCHEDULED:"statusScheduled",STATE_ERROR:"statusError"},f=function(){return i.default.getResource("schemas",{data:{}})},d=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.url=t,this.state=l.STATE_NOT_READY,this.callbacks={onReady:[],onError:[],onRetry:[],onLoad:[]};}return r(e,[{key:"get",value:function(e,t){var n=e+"-"+t;if(!this.isReady())throw new Error(""+a.default.COMPONENT_NOT_READY);var r=f().data[n];if(!r)throw new Error(a.default.UNSUPPORTED_TYPE+": "+n);return r}},{key:"isReady",value:function(){return this.state===l.STATE_READY}},{key:"retry",value:function(){var e=this;this.state=l.STATE_SCHEDULED,this.callbacks.onRetry.forEach(function(e){return e()}),setTimeout(function(){e.state=l.STATE_NOT_READY,e.load();},u.default.SCHEMA_LOAD_COLLECTION_RETRY_AFTER_MSECS);}},{key:"onLoad",value:function(e){this.callbacks.onLoad.push(e);}},{key:"onRetry",value:function(e){this.callbacks.onRetry.push(e);}},{key:"onReady",value:function(e){if(this.state===l.STATE_READY)return e(f().data);if(this.callbacks.onReady.length>u.default.HORIZON_CALLBACK_STACK_LIMIT)throw new Error(a.default.LIMIT_EXCEEDED+" Schemas callback stack.");return this.callbacks.onReady.push(e)}},{key:"onError",value:function(e){this.state===l.STATE_ERROR?e():this.callbacks.onError.push(e);}},{key:"load",value:function(){var e=this,t=f();if(this.state===l.STATE_NOT_READY){this.state=l.STATE_LOADING,this.callbacks.onLoad.forEach(function(e){return e()});var n=u.default.USE_HTTPS?"https://":"http://";s.default.request("GET",""+n+this.url,function(n){t.data=Object.assign(t.data||{},n),e.state=l.STATE_READY,e.callbacks.onReady.forEach(function(e){return o.default.execAsync(e,t.data)});},function(t){e.state=l.STATE_ERROR,e.callbacks.onError.forEach(function(e){return o.default.execAsync(e,t)}),e.retry();});}}}]),e}();t.default={getInstance:function(e){var t=f();return t.provider||(t.provider=new d(e||u.default.HORIZON_SCHEMAS_HOST+"/schemas")),t.provider},getContextSchemas:f};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(e){return window.cdaaas&&window.cdaaas.SETTINGS?window.cdaaas.SETTINGS[e]:null},o=function(e){return window.utag_data?window.utag_data[e]:null};t.default={getTenant:function(){return r("SITE_ID")||o("ut.profile")||"unknown"},getDeviceGroup:function(){return r("MOBILE_GROUP")||o("platform")||"unknown"}};}])});
});

var HorizonClient = /*@__PURE__*/getDefaultExportFromCjs(globocomHorizon);

var HorizonClientSingleton = /*#__PURE__*/function () {
  function HorizonClientSingleton(environment) {
    var httpOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var tenant = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, HorizonClientSingleton);

    if (HorizonClientSingleton.instance) {
      return HorizonClientSingleton.instance;
    }

    this.initHorizonClient(environment, httpOnly, tenant);
  }

  _createClass(HorizonClientSingleton, [{
    key: "initHorizonClient",
    value: function initHorizonClient(environment, httpOnly, tenant) {
      var platform = Browser.isSmartTvEnvironment ? 'tv' : null;
      environment !== 'prod' && HorizonClient.Settings.useQAConfiguration();
      httpOnly && HorizonClient.Settings.useHTTPOnly();
      this.horizon = new HorizonClient.HorizonClient(tenant, platform);
      this.saveInstance();
    }
  }, {
    key: "saveInstance",
    value: function saveInstance() {
      HorizonClientSingleton.instance = this;
    }
  }, {
    key: "send",
    value: function send(data) {
      this.horizon.send(data);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.horizon.unload();
    }
  }]);

  return HorizonClientSingleton;
}();

var session$4 = Utils$1.session;
var unloadEvent$1 = _typeof(window.onbeforeunload) === 'object' ? 'beforeunload' : 'unload';

var SchemaFactory = function SchemaFactory(PlayerLayerClass) {
  return /*#__PURE__*/function (_PlayerLayerClass) {
    _inherits(BaseSchemaPlugin, _PlayerLayerClass);

    var _super = _createSuper(BaseSchemaPlugin);

    _createClass(BaseSchemaPlugin, [{
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.21"
        };
      }
    }, {
      key: "playerId",
      get: function get() {
        return Environment.playerId;
      }
    }, {
      key: "videoSessionId",
      get: function get() {
        return session$4.getVideoSessionId(this.options.playerId);
      }
    }, {
      key: "contentType",
      get: function get() {
        return 'monitoring';
      }
    }, {
      key: "basicData",
      get: function get() {
        return {
          id: this.id,
          version: this.version,
          contentType: this.contentType
        };
      }
    }]);

    function BaseSchemaPlugin(layer) {
      var _this;

      _classCallCheck(this, BaseSchemaPlugin);

      _this = _super.call(this, layer);
      _this[layer.type] = layer;
      var env = _this.options.env && _this.options.env.name || '';
      var httpOnly = _this.options.httpOnly;
      var tenant = _this.options.horizon && _this.options.horizon.tenant || (Browser.isSmartTvEnvironment ? 'player' : null);
      _this.horizon = new HorizonClientSingleton(env, httpOnly, tenant);

      _this.setupUnload();

      return _this;
    }

    _createClass(BaseSchemaPlugin, [{
      key: "setupUnload",
      value: function setupUnload() {
        this.boundOnEnd = this.onEnd.bind(this);
        window.addEventListener(unloadEvent$1, this.boundOnEnd);
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {}
    }, {
      key: "onUnload",
      value: function onUnload() {}
    }, {
      key: "onEnd",
      value: function onEnd() {
        this.onUnload();
        this.horizon.unload();
      }
    }, {
      key: "send",
      value: function send() {
        var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        try {
          this.horizon.send(_objectSpread2(_objectSpread2({}, this.basicData), {}, {
            properties: properties
          }));
        } catch (e) {
          Log$1.error(this.name, 'Error when trying to send data to Horizon', e);
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        window.removeEventListener(unloadEvent$1, this.boundOnEnd);
        this.stopListening();

        _get(_getPrototypeOf(BaseSchemaPlugin.prototype), "destroy", this).call(this);
      }
    }]);

    return BaseSchemaPlugin;
  }(PlayerLayerClass);
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$2;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = _freeGlobal || freeSelf$1 || Function('return this')();

var _root = root$1;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$2 = function() {
  return _root.Date.now();
};

var now_1 = now$2;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$3.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$3.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$4.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$3(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString$3;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$3(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$3;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$2(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2);
}

var isSymbol_1 = isSymbol$2;

/** Used as references for various `Number` constants. */
var NAN$2 = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim$2 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$2 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$2 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$2 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$2 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN$2;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$2, '');
  var isBinary = reIsBinary$2.test(value);
  return (isBinary || reIsOctal$2.test(value))
    ? freeParseInt$2(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$2.test(value) ? NAN$2 : +value);
}

var toNumber_1 = toNumber$2;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$2 = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin$2(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$1;

var emptyHandler = function emptyHandler() {
  return {};
};

var subjectHandler = function subjectHandler(subject) {
  return {
    subject: subject
  };
};

var valueAndSubjectHandler = function valueAndSubjectHandler(value, subject) {
  return {
    subject: subject,
    value: value
  };
};

var ignoreValueHandler = function ignoreValueHandler(_, subject) {
  return {
    subject: subject
  };
};

var getCurrentTime$3 = Utils$1.getCurrentTime;

var EventsInfo = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(EventsInfo, _SchemaFactory);

  var _super = _createSuper(EventsInfo);

  _createClass(EventsInfo, [{
    key: "name",
    get: function get() {
      return 'events-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-events';
    }
  }, {
    key: "version",
    get: function get() {
      return '2.1';
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this.core.mediaControl;
    }
  }, {
    key: "innerPlayback",
    get: function get() {
      return this.playback.playback;
    }
  }, {
    key: "playbackType",
    get: function get() {
      return this.container && this.container.getPlaybackType();
    }
  }, {
    key: "playHeadTimeLive",
    get: function get() {
      return this.innerPlayback && getCurrentTime$3(this.innerPlayback) || -1;
    }
  }, {
    key: "playHeadTimeVOD",
    get: function get() {
      return this.container && parseInt(this.container.getCurrentTime() * 1000, 10) || -1;
    }
  }, {
    key: "baseProperties",
    get: function get() {
      return {
        videoSessionId: this.videoSessionId
      };
    }
  }, {
    key: "coreEvents",
    get: function get() {
      var _ref4;

      return _ref4 = {}, _defineProperty(_ref4, Events$1.CORE_FULLSCREEN, function (value, subject) {
        return {
          subject: subject,
          value: value
        };
      }), _defineProperty(_ref4, Events$1.CORE_RESIZE, function (_ref, subject) {
        var width = _ref.width,
            height = _ref.height;
        return {
          value: "".concat(width, "x").concat(height),
          subject: subject
        };
      }), _defineProperty(_ref4, Events$1.CORE_SCREEN_ORIENTATION_CHANGED, function (_ref2, subject) {
        var orientation = _ref2.orientation;
        return {
          subject: subject,
          value: orientation
        };
      }), _defineProperty(_ref4, Events.WM_PIP_ADDED, emptyHandler), _defineProperty(_ref4, Events.WM_PIP_DISCARDED, emptyHandler), _defineProperty(_ref4, Events.WM_MASTER_ADDED, emptyHandler), _defineProperty(_ref4, Events.WM_MASTER_CHANGED, emptyHandler), _defineProperty(_ref4, Events.WM_PIPTOMASTER, emptyHandler), _defineProperty(_ref4, Events.WM_MASTERTOPIP, emptyHandler), _defineProperty(_ref4, Events.MEDIACONTROL_DOUBLE_TAP, function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$tapSide = _ref3.tapSide,
            tapSide = _ref3$tapSide === void 0 ? '' : _ref3$tapSide;

        return {
          value: tapSide
        };
      }), _defineProperty(_ref4, Events.WILL_SHOW_QUICK_SEEK_HINT, emptyHandler), _defineProperty(_ref4, Events.WILL_HIDE_QUICK_SEEK_HINT, emptyHandler), _defineProperty(_ref4, Events.START_DRAGGING_SEEKBAR, emptyHandler), _defineProperty(_ref4, Events.STOP_DRAGGING_SEEKBAR, emptyHandler), _ref4;
    }
  }, {
    key: "mediaControlEvents",
    get: function get() {
      var _ref5;

      return _ref5 = {}, _defineProperty(_ref5, Events.MEDIACONTROL_MODAL_SHOW, emptyHandler), _defineProperty(_ref5, Events.MEDIACONTROL_MODAL_HIDE, emptyHandler), _defineProperty(_ref5, Events.MEDIACONTROL_ITEMCLICKED, subjectHandler), _defineProperty(_ref5, Events$1.MEDIACONTROL_RENDERED, subjectHandler), _defineProperty(_ref5, Events.WM_VOLUME_SHOW, subjectHandler), _defineProperty(_ref5, Events.WM_VOLUME_HIDE, subjectHandler), _defineProperty(_ref5, Events.WM_SHARE_SHOW, subjectHandler), _defineProperty(_ref5, Events.WM_SHARE_HIDE, subjectHandler), _ref5;
    }
  }, {
    key: "containerEvents",
    get: function get() {
      var _events;

      var events = (_events = {}, _defineProperty(_events, Events$1.CONTAINER_CLICK, ignoreValueHandler), _defineProperty(_events, Events$1.CONTAINER_DESTROYED, ignoreValueHandler), _defineProperty(_events, Events$1.CONTAINER_DBLCLICK, ignoreValueHandler), _defineProperty(_events, Events$1.CONTAINER_VOLUME, function (value, subject) {
        return {
          value: Math.round(value),
          subject: subject
        };
      }), _defineProperty(_events, Events.WM_BITRATE_CAP, function (value, subject) {
        return {
          value: value.toFixed(2),
          subject: subject
        };
      }), _defineProperty(_events, Events.DFP_AD_LOADED, emptyHandler), _defineProperty(_events, Events.DFP_AD_CLOSED, emptyHandler), _defineProperty(_events, Events.DFP_AD_STARTED, emptyHandler), _defineProperty(_events, Events.DFP_AD_RESUME, emptyHandler), _defineProperty(_events, Events.DFP_AD_PAUSE, emptyHandler), _defineProperty(_events, Events.DFP_AD_CLICKED, emptyHandler), _defineProperty(_events, Events.DFP_AD_COMPLETED, emptyHandler), _defineProperty(_events, Events.DFP_AD_SKIPPED, emptyHandler), _defineProperty(_events, Events.DFP_AD_NOTSERVED, emptyHandler), _defineProperty(_events, Events.DFP_AD_METADATA, emptyHandler), _defineProperty(_events, Events.DFP_ALL_ADS_COMPLETED, emptyHandler), _defineProperty(_events, Events.DFP_CONTENT_PAUSE, emptyHandler), _defineProperty(_events, Events.DFP_CONTENT_RESUME, emptyHandler), _defineProperty(_events, Events.DFP_CONTENT_STARTED, emptyHandler), _defineProperty(_events, Events.DFP_CONTENT_ENDED, emptyHandler), _defineProperty(_events, Events.DFP_FINISHED, emptyHandler), _defineProperty(_events, Events.WM_MUTED, function (value, _, subject) {
        return {
          value: Math.round(value),
          subject: subject
        };
      }), _defineProperty(_events, Events.WM_UNMUTED, function (value, _, subject) {
        return {
          value: Math.round(value),
          subject: subject
        };
      }), _defineProperty(_events, Events.WM_SETTINGS_LEVEL_SELECTED, function (value, subject) {
        return {
          value: JSON.stringify(value),
          subject: subject
        };
      }), _defineProperty(_events, Events.WM_AUDIO_CHANGED, function (_ref6, subject) {
        var label = _ref6.label,
            language = _ref6.language,
            role = _ref6.role;
        return {
          subject: subject,
          value: JSON.stringify({
            label: label,
            lang: language,
            role: role
          })
        };
      }), _defineProperty(_events, Events.WM_AUDIO_AVAILABLE, function (value, subject) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_events, Events.WM_LOCATION_AVAILABLE, function (value, subject) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_events, Events.WM_SUBTITLE_CHANGED, function (value, subject) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_events, Events.SKIP_BUTTON_CLICKED, function () {
        var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref7$name = _ref7.name,
            name = _ref7$name === void 0 ? '' : _ref7$name;

        return {
          value: name
        };
      }), _defineProperty(_events, Events.SKIP_BUTTON_SHOW, function () {
        var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref8$name = _ref8.name,
            name = _ref8$name === void 0 ? '' : _ref8$name;

        return {
          value: name
        };
      }), _defineProperty(_events, Events.DID_CHANGE_CURRENT_PROGRAM, function (value, subject) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_events, Events.WILL_QUICK_SEEK, emptyHandler), _defineProperty(_events, Events.WILL_AUTO_SKIP_RECAP, emptyHandler), _defineProperty(_events, Events.WM_GA_UNTRACKED_EVENT, function () {
        var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref9$eventName = _ref9.eventName,
            eventName = _ref9$eventName === void 0 ? '' : _ref9$eventName;

        return {
          value: eventName
        };
      }), _defineProperty(_events, Events.SIMULCAST_PING, valueAndSubjectHandler), _defineProperty(_events, Events.WM_RESOURCE_REQUEST_STATS, function (_ref10) {
        var retries = _ref10.retries,
            usedFallback = _ref10.usedFallback;
        return {
          value: JSON.stringify({
            attempts: retries,
            fallback: usedFallback
          }),
          eventName: 'retry_history'
        };
      }), _events);
      return events;
    }
  }, {
    key: "playbackEvents",
    get: function get() {
      var _ref12;

      return _ref12 = {}, _defineProperty(_ref12, Events$1.PLAYBACK_READY, valueAndSubjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_BUFFERING, valueAndSubjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_BUFFERFULL, valueAndSubjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_LOADEDMETADATA, function (_ref11, subject) {
        var duration = _ref11.duration;
        return {
          subject: subject,
          value: Math.round(duration)
        };
      }), _defineProperty(_ref12, Events$1.PLAYBACK_HIGHDEFINITIONUPDATE, valueAndSubjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_BITRATE, function (value, subject) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_ref12, Events$1.PLAYBACK_DVR, valueAndSubjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_ENDED, subjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_PLAY_INTENT, subjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_PLAY, subjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_PAUSE, function (subject, value) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_ref12, Events$1.PLAYBACK_SEEK, subjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_SEEKED, subjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_STOP, subjectHandler), _defineProperty(_ref12, Events$1.PLAYBACK_LEVEL_SWITCH, function (value, subject) {
        return {
          subject: subject,
          value: JSON.stringify(value)
        };
      }), _defineProperty(_ref12, Events$1.PLAYBACK_SUBTITLE_AVAILABLE, subjectHandler), _defineProperty(_ref12, Events.WM_WROOM_WAITING, ignoreValueHandler), _defineProperty(_ref12, Events.WM_PLAY_REQUESTED_READY, ignoreValueHandler), _defineProperty(_ref12, Events.WILL_SELECT_FALLBACK_SOURCE, function (value) {
        return {
          value: JSON.stringify(value)
        };
      }), _defineProperty(_ref12, Events.WILL_CHANGE_SOURCE, function (value) {
        return {
          value: JSON.stringify(value)
        };
      }), _defineProperty(_ref12, Events.FALLBACK_SOURCE_SELECTED, function (value) {
        return {
          value: JSON.stringify(value)
        };
      }), _defineProperty(_ref12, Events.WILL_RENEW_RESOURCE, function (value) {
        return {
          value: JSON.stringify(value)
        };
      }), _ref12;
    }
  }]);

  function EventsInfo(core) {
    var _this;

    _classCallCheck(this, EventsInfo);

    _this = _super.call(this, core);
    _this.counter = 0;
    return _this;
  }

  _createClass(EventsInfo, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;

      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.listenTo(this.core, Events$1.CORE_READY, this.bindContainerEvents);
      Object.entries(this.coreEvents).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
            event = _ref14[0],
            handler = _ref14[1];

        _this2.subscribeEvent(_this2.core, event, handler);
      });
      Object.entries(this.mediaControlEvents).forEach(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
            event = _ref16[0],
            handler = _ref16[1];

        _this2.subscribeEvent(_this2.mediaControl, event, handler);
      });
    }
  }, {
    key: "onUnload",
    value: function onUnload() {
      this.sendEvent('user', 'DID_LEAVE');
    }
  }, {
    key: "playheadTime",
    value: function playheadTime() {
      if (!this.playbackType) return -1;
      return this.playbackType === Playback.LIVE ? this.playHeadTimeLive : this.playHeadTimeVOD;
    }
  }, {
    key: "handleEventArgs",
    value: function handleEventArgs(event, handler) {
      for (var _len = arguments.length, eventArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        eventArgs[_key - 2] = arguments[_key];
      }

      var _handler = handler.apply(void 0, eventArgs),
          subject = _handler.subject,
          value = _handler.value,
          eventName = _handler.eventName;

      this.sendEvent(subject, eventName || event, value);
    }
  }, {
    key: "subscribeEvent",
    value: function subscribeEvent(playerLayer, event, handler) {
      this.listenTo(playerLayer, event, debounce_1(this.handleEventArgs.bind(this, event, handler), 500, {
        'leading': true,
        'trailing': true
      }));
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      var _this3 = this;

      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.bindPlaybackEvents();
      Object.entries(this.containerEvents).forEach(function (_ref17) {
        var _ref18 = _slicedToArray(_ref17, 2),
            event = _ref18[0],
            handler = _ref18[1];

        _this3.subscribeEvent(_this3.container, event, handler);
      });
    }
  }, {
    key: "bindPlaybackEvents",
    value: function bindPlaybackEvents() {
      var _this4 = this;

      this.playback && this.stopListening(this.playback);
      this.playback = this.core.activePlayback;
      if (!this.playback) return;
      Object.entries(this.playbackEvents).forEach(function (_ref19) {
        var _ref20 = _slicedToArray(_ref19, 2),
            event = _ref20[0],
            handler = _ref20[1];

        _this4.subscribeEvent(_this4.playback, event, handler);
      });
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(subject, event, value) {
      this.send(Object.assign({}, this.baseProperties, {
        subject: subject ? subject : 'unknown'
      }, event && {
        event: event.toString()
      }, value && {
        value: value.toString()
      }, {
        playheadTime: this.playheadTime()
      }, {
        counter: parseInt(this.counter, 10)
      }));
      this.counter += 1;
    }
  }]);

  return EventsInfo;
}(SchemaFactory(CorePlugin));

var SessionInfoSchema = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(SessionInfoSchema, _SchemaFactory);

  var _super = _createSuper(SessionInfoSchema);

  function SessionInfoSchema() {
    _classCallCheck(this, SessionInfoSchema);

    return _super.apply(this, arguments);
  }

  _createClass(SessionInfoSchema, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenToOnce(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady() {
      var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.send(_objectSpread2(_objectSpread2(_objectSpread2({}, this.baseProperties), this.containerProperties()), this.videoProperties(video)));
    }
  }, {
    key: "containerProperties",
    value: function containerProperties() {
      return {
        playback: this.innerPlayback.name,
        muted: !this.container.playback.getVolume()
      };
    }
  }, {
    key: "liveProps",
    value: function liveProps(video) {
      return {
        duration: -1,
        dvr: this.container.isDvrEnabled(),
        signal: video.transmission.signal
      };
    }
  }, {
    key: "videoProperties",
    value: function videoProperties(video) {
      var videoProps = {
        videoId: video.id,
        programId: video.programId,
        channelId: video.channelId,
        kind: video.kind,
        encrypted: video.encrypted,
        subscriberOnly: video.isSubscriberOnly,
        adult: video.adult,
        cdn: video.cdn,
        duration: video.duration,
        downloadedSession: false
      };

      if (video.encrypted) {
        videoProps.drmProtocol = video.drm;
      }

      if (video.kind == 'live') {
        videoProps = _objectSpread2(_objectSpread2({}, videoProps), this.liveProps(video));
      }

      return videoProps;
    }
  }, {
    key: "name",
    get: function get() {
      return 'session-info-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-session-info';
    }
  }, {
    key: "version",
    get: function get() {
      return '2.3';
    }
  }, {
    key: "innerPlayback",
    get: function get() {
      return this.container.playback.playback;
    }
  }, {
    key: "startAt",
    get: function get() {
      return this.container.getPlaybackType() === 'live' ? this.options.liveStartTime : this.options.resumeAt;
    }
  }, {
    key: "baseProperties",
    get: function get() {
      var sessionData = {
        playerId: this.playerId,
        videoSessionId: this.videoSessionId,
        autoPlay: !!this.options.autoPlay,
        disableAds: !!this.options.skipDFP
      };
      if (this.startAt) sessionData.startAt = this.startAt;
      return sessionData;
    }
  }]);

  return SessionInfoSchema;
}(SchemaFactory(ContainerPlugin));

var API_VERSION$2 = Utils$1.API_VERSION;
var CANCELLING_TIMEOUT = 2000;

var EnvironmentWebInfo = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(EnvironmentWebInfo, _SchemaFactory);

  var _super = _createSuper(EnvironmentWebInfo);

  _createClass(EnvironmentWebInfo, [{
    key: "name",
    get: function get() {
      return 'environment-web-info-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-environment-web';
    }
  }, {
    key: "version",
    get: function get() {
      return '2.0';
    }
  }]);

  function EnvironmentWebInfo(core) {
    var _this;

    _classCallCheck(this, EnvironmentWebInfo);

    _this = _super.call(this, core);
    _this.chromecastStatus = _this.getChromecastStatus();
    return _this;
  }

  _createClass(EnvironmentWebInfo, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_READY, this.sendEvents);
    }
  }, {
    key: "getChromecastStatus",
    value: function getChromecastStatus() {
      return Promise.race([this.subscribe(this.listenTo.bind(this, this.core, Events.CHROMECAST_SCRIPT_ERROR)).then(function () {
        return 'script-load-error';
      }), this.subscribe(this.listenTo.bind(this, this.core, Events.CHROMECAST_API_ERROR)).then(function () {
        return 'api-error';
      }), this.subscribe(this.listenTo.bind(this, this.core, Events.CHROMECAST_INITIALIZE_ERROR)).then(function () {
        return 'initialize-error';
      }), this.subscribe(this.listenTo.bind(this, this.core, Events.CHROMECAST_AVAILABLE)).then(function () {
        return 'available';
      }), this.subscribe(this.listenTo.bind(this, this.core, Events.CHROMECAST_UNAVAILABLE)).then(function () {
        return 'unavailable';
      })]).then(function (castStatus) {
        return {
          castStatus: castStatus
        };
      })["catch"](function () {
        return {
          castStatus: 'not-informed'
        };
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(listenerPrototype) {
      return new Promise(function (resolve, reject) {
        listenerPrototype(function (value) {
          return resolve(value);
        });
        window.setTimeout(reject, CANCELLING_TIMEOUT);
      });
    }
  }, {
    key: "signals",
    value: function signals() {
      return [Promise.resolve({
        playerId: this.playerId,
        apiVersion: API_VERSION$2,
        browserVersion: Browser.data.fullVersion,
        browser: Browser.name,
        location: this.core.options.domain || document.location.hostname
      }), this.chromecastStatus];
    }
  }, {
    key: "sendEvents",
    value: function sendEvents() {
      var _this2 = this;

      return Promise.all(this.signals()).then(function (signals) {
        _this2.send(Object.assign.apply(Object, [{}].concat(_toConsumableArray(signals))));
      });
    }
  }]);

  return EnvironmentWebInfo;
}(SchemaFactory(CorePlugin));

var Video$2 = Models.Video;
var getDeviceType = Utils$1.getDeviceType;
var CANCELLING_TIMEOUT$1 = 2000;

var EnvironmentInfo = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(EnvironmentInfo, _SchemaFactory);

  var _super = _createSuper(EnvironmentInfo);

  _createClass(EnvironmentInfo, [{
    key: "name",
    get: function get() {
      return 'environment-info-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-environment-data';
    }
  }, {
    key: "version",
    get: function get() {
      return '3.0';
    }
  }]);

  function EnvironmentInfo(core) {
    var _this;

    _classCallCheck(this, EnvironmentInfo);

    _this = _super.call(this, core);
    _this.deviceInfo = _this.options.deviceInfo || {};
    return _this;
  }

  _createClass(EnvironmentInfo, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_READY, this.sendEvents);
    }
  }, {
    key: "initialSize",
    value: function initialSize() {
      return this.subscribe(this.listenTo.bind(this, this.core, Events$1.CORE_RESIZE)).then(function (_ref) {
        var width = _ref.width,
            height = _ref.height;
        return {
          initialSize: "".concat(width, "x").concat(height)
        };
      })["catch"](function () {
        return {
          initialSize: 'not-informed'
        };
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(listenerPrototype) {
      return new Promise(function (resolve, reject) {
        listenerPrototype(function (value) {
          return resolve(value);
        });
        window.setTimeout(reject, CANCELLING_TIMEOUT$1);
      });
    }
  }, {
    key: "signals",
    value: function signals() {
      return [Promise.resolve({
        playerId: this.playerId,
        os: this.deviceInfo.os || Browser.os.name,
        osVersion: this.osVersion,
        playerVersion: PLAYER_VERSION,
        playerType: Video$2.getPlayerType(),
        application: this.core.options.domain || document.location.hostname,
        deviceType: getDeviceType(),
        applicationVersion: this.core.options.applicationVersion || 'not-informed',
        networkType: 'None/web',
        deviceModel: this.deviceModel
      }), this.initialSize()];
    }
  }, {
    key: "sendEvents",
    value: function sendEvents() {
      var _this2 = this;

      return Promise.all(this.signals()).then(function (signals) {
        _this2.send(Object.assign.apply(Object, [{}].concat(_toConsumableArray(signals))));
      });
    }
  }, {
    key: "osVersion",
    get: function get() {
      var version = Browser.isSmartTvEnvironment ? this.deviceInfo.firmwareVersion : Browser.os.fullVersion;
      return version || 'other';
    }
  }, {
    key: "deviceModel",
    get: function get() {
      if (Browser.isSmartTvEnvironment) return this.deviceInfo.model || Browser.device.model || 'not-informed';
      return 'not-informed';
    }
  }]);

  return EnvironmentInfo;
}(SchemaFactory(CorePlugin));

var ErrorsInfo = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(ErrorsInfo, _SchemaFactory);

  var _super = _createSuper(ErrorsInfo);

  function ErrorsInfo() {
    _classCallCheck(this, ErrorsInfo);

    return _super.apply(this, arguments);
  }

  _createClass(ErrorsInfo, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core, Events$1.CORE_ACTIVE_CONTAINER_CHANGED, this.bindContainerEvents);
      this.listenTo(this.core, Events$1.CORE_READY, this.bindContainerEvents);
      this.listenToCoreErrors();
    }
  }, {
    key: "bindContainerEvents",
    value: function bindContainerEvents() {
      this.container && this.stopListening(this.container);
      this.container = this.core.activeContainer;
      if (!this.container) return;
      this.listenToContainerErrors();
    }
  }, {
    key: "listenToContainerErrors",
    value: function listenToContainerErrors() {
      var _this = this;

      this.listenTo(this.container, Events$1.CONTAINER_ERROR, this.sendEvents);
      this.listenTo(this.container, Events.DFP_AD_ERROR, function (error) {
        var adError = _this.formatAdErrors(error);

        _this.sendEvents(adError);
      });
      this.listenTo(this.container, Events.WM_VIDEO_METADATA_ERROR, this.sendEvents);
      this.listenTo(this.container, Events.WM_RESOURCE_ERROR, this.sendEvents);
    }
  }, {
    key: "listenToCoreErrors",
    value: function listenToCoreErrors() {
      this.listenTo(this.core, Events.CHROMECAST_API_ERROR, this.sendEvents);
      this.listenTo(this.core, Events.CHROMECAST_SCRIPT_ERROR, this.sendEvents);
      this.listenTo(this.core, Events.CHROMECAST_INITIALIZE_ERROR, this.sendEvents);
      this.listenTo(this.core, Events.CHROMECAST_LAUNCH_ERROR, this.sendEvents);
      this.listenTo(this.core, Events.CHROMECAST_MEDIA_LOAD_ERROR, this.sendEvents);
    }
  }, {
    key: "formatAdErrors",
    value: function formatAdErrors() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _typeof(error.message) === 'object' ? {
        code: error.message && error.message.getType && error.message.getType() || '',
        message: error.message && error.message.getMessage && error.message.getMessage(),
        level: 'unknown'
      } : error;
    }
  }, {
    key: "errorProperties",
    value: function errorProperties(error) {
      return {
        code: error.code || error.type || 'unknown',
        message: error.description || error.message || 'unknown',
        level: error.level || 'unknown'
      };
    }
  }, {
    key: "sendEvents",
    value: function sendEvents(error) {
      this.send(_objectSpread2(_objectSpread2({}, this.baseProperties), this.errorProperties(error)));
    }
  }, {
    key: "name",
    get: function get() {
      return 'errors-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-errors';
    }
  }, {
    key: "version",
    get: function get() {
      return '1.1';
    }
  }, {
    key: "mediaControl",
    get: function get() {
      return this.core.mediaControl;
    }
  }, {
    key: "baseProperties",
    get: function get() {
      return {
        playerId: this.playerId,
        videoSessionId: this.videoSessionId
      };
    }
  }]);

  return ErrorsInfo;
}(SchemaFactory(CorePlugin));

var AdConfig = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(AdConfig, _SchemaFactory);

  var _super = _createSuper(AdConfig);

  function AdConfig() {
    _classCallCheck(this, AdConfig);

    return _super.apply(this, arguments);
  }

  _createClass(AdConfig, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.container, Events.DFP_AD_LOADED, this.sendEvents);
    }
  }, {
    key: "adConfigProperties",
    value: function adConfigProperties(ad) {
      return _objectSpread2(_objectSpread2({}, this.adProperties(ad)), this.dfpProperties());
    }
  }, {
    key: "adProperties",
    value: function adProperties(ad) {
      return {
        adId: ad.getAdId(),
        linear: ad.isLinear(),
        position: this.getAdPosition(ad),
        skippable: ad.isSkippable(),
        duration: parseInt(ad.getDuration(), 10),
        timeOffset: parseInt(ad.getAdPodInfo().getTimeOffset(), 10)
      };
    }
  }, {
    key: "dfpProperties",
    value: function dfpProperties() {
      return {
        adUnit: this.dfp.adUnit,
        adCustomData: this.dfp.adCustomData,
        accountId: this.dfp.adAccountId,
        cmsId: this.dfp.adCmsId
      };
    }
  }, {
    key: "getAdPosition",
    value: function getAdPosition(ad) {
      if (!ad.isLinear()) return 'overlay';

      switch (ad.getAdPodInfo().getPodIndex()) {
        case 0:
          return 'pre-roll';

        case -1:
          return 'pos-roll';

        default:
          return 'mid-roll';
      }
    }
  }, {
    key: "sendEvents",
    value: function sendEvents(ad) {
      this.send(_objectSpread2(_objectSpread2({}, this.baseProperties), this.adConfigProperties(ad)));
    }
  }, {
    key: "name",
    get: function get() {
      return 'ad-config-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-ad-config';
    }
  }, {
    key: "version",
    get: function get() {
      return '2.0';
    }
  }, {
    key: "dfp",
    get: function get() {
      return this.container.options.dfp;
    }
  }, {
    key: "baseProperties",
    get: function get() {
      return {
        videoSessionId: this.videoSessionId
      };
    }
  }]);

  return AdConfig;
}(SchemaFactory(ContainerPlugin));

var PING_CONFIG = {
  live: 60 * 1000,
  "default": 15 * 1000,
  vodPercentual: 0.05
};

var NetworkMonitoringSchema = /*#__PURE__*/function (_SchemaFactory) {
  _inherits(NetworkMonitoringSchema, _SchemaFactory);

  var _super = _createSuper(NetworkMonitoringSchema);

  _createClass(NetworkMonitoringSchema, [{
    key: "name",
    get: function get() {
      return 'network-monitoring-schema';
    }
  }, {
    key: "id",
    get: function get() {
      return 'player-network-monitoring';
    }
  }, {
    key: "version",
    get: function get() {
      return '6.0';
    }
  }, {
    key: "currentTime",
    get: function get() {
      return new Date().getTime();
    }
  }, {
    key: "isBuffering",
    get: function get() {
      return this.lastBufferType === Events$1.PLAYBACK_BUFFERING;
    }
  }, {
    key: "bandwidthEstimate",
    get: function get() {
      var bandwidth = this.container.playback.bandwidthEstimate;
      return typeof bandwidth === 'number' && bandwidth >= 0 ? bandwidth : -1;
    }
  }]);

  function NetworkMonitoringSchema(container) {
    var _this;

    _classCallCheck(this, NetworkMonitoringSchema);

    _this = _super.call(this, container);
    _this.measurements = [];
    _this.counter = 0;
    _this.bufferingTime = 0;
    _this.decodedFrames = 0;
    _this.droppedFrames = 0;
    _this.lastBufferType = null;

    _this.updateMeasurements({});

    return _this;
  }

  _createClass(NetworkMonitoringSchema, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.container, Events.WM_STATS_REPORTED, this.onStatsReported);
      this.listenTo(this.container.playback, Events.FALLBACK_SOURCE_SELECTED, this.onFallbackSourceSelected);
      this.listenTo(this.container.playback, Events.WM_STREAMING_DATA_LOADED, this.onStreamingDataLoaded);
      this.listenTo(this.container.playback, Events.WM_RESOURCE_READY, this.onResourceReady);
      this.listenTo(this.container.playback, Events$1.PLAYBACK_BITRATE, this.updateMeasurements);
      this.listenTo(this.container.playback, Events$1.PLAYBACK_STOP, this.stopHeartbeat);
      this.listenTo(this.container.playback, Events$1.PLAYBACK_ERROR, this.stopHeartbeat);
      this.listenTo(this.container.playback, Events$1.PLAYBACK_ENDED, this.stopHeartbeat);
      this.listenTo(this.container.playback, Events$1.PLAYBACK_BUFFERING, this.onBuffering);
      this.listenTo(this.container.playback, Events$1.PLAYBACK_BUFFERFULL, this.onBufferFull);
    }
  }, {
    key: "onStatsReported",
    value: function onStatsReported(stats) {
      this.decodedFrames = stats.counters.decodedFrames;
      this.droppedFrames = stats.counters.droppedFrames;
    }
  }, {
    key: "onFallbackSourceSelected",
    value: function onFallbackSourceSelected(_ref) {
      var currentSrc = _ref.currentSrc;
      this.domainHost = this.getDomainFromURL(currentSrc);
    }
  }, {
    key: "onStreamingDataLoaded",
    value: function onStreamingDataLoaded(_ref2) {
      var host = _ref2.host;
      this.domainHost = host;
    }
  }, {
    key: "pingInterval",
    value: function pingInterval() {
      var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (video.kind == 'live') {
        return PING_CONFIG.live;
      }

      return Math.max(PING_CONFIG["default"], PING_CONFIG.vodPercentual * video.duration);
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady(video) {
      this.setCDNHost(video);
      this.setPoP(video);
      this.stopHeartbeat();
      this.heartbeat = setInterval(this.onHeartbeatTick.bind(this), this.pingInterval(video));
      this.onHeartbeatTick();
    }
  }, {
    key: "setCDNHost",
    value: function setCDNHost(_ref3) {
      var url = _ref3.selectedResource.url;
      this.domainHost = this.getDomainFromURL(url);
    }
  }, {
    key: "setPoP",
    value: function setPoP(_ref4) {
      var resourcePOP = _ref4.selectedResource.resourcePOP;
      this.pop = resourcePOP;
    }
  }, {
    key: "getDomainFromURL",
    value: function getDomainFromURL(url) {
      var regex = /:\/\/(?:www\.)?(.[^/]+)(.*)/;
      return url && regex.exec(url)[1];
    }
  }, {
    key: "updateMeasurements",
    value: function updateMeasurements(_ref5) {
      var _ref5$bitrate = _ref5.bitrate,
          bitrate = _ref5$bitrate === void 0 ? 0 : _ref5$bitrate;
      this.lastMeasurement = {
        nominalBitrate: parseInt(bitrate, 10),
        bandwidth: parseInt(this.bandwidthEstimate, 10),
        timestamp: this.currentTime
      };
      this.measurements.push(this.lastMeasurement);
    }
  }, {
    key: "increaseTotalBuffering",
    value: function increaseTotalBuffering() {
      if (this.isBuffering && this.bufferStartTime > 0) {
        this.bufferingTime += this.currentTime - this.bufferStartTime;
        this.bufferStartTime = this.currentTime;
      }
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      this.bufferStartTime = this.currentTime;
      this.increaseTotalBuffering();
      this.lastBufferType = Events$1.PLAYBACK_BUFFERING;
    }
  }, {
    key: "onBufferFull",
    value: function onBufferFull() {
      this.increaseTotalBuffering();
      this.bufferStartTime = 0;
      this.lastBufferType = Events$1.PLAYBACK_BUFFERFULL;
    }
  }, {
    key: "onHeartbeatTick",
    value: function onHeartbeatTick() {
      if (this.measurements.length == 0) {
        this.measurements.push(this.lastMeasurement);
      }

      this.increaseTotalBuffering();
      this.sendEvent();
      this.resetStateTimmingInfo();
      this.eraseMeasurements();
      this.updateCounter();
    }
  }, {
    key: "updateCounter",
    value: function updateCounter() {
      this.counter += 1;
    }
  }, {
    key: "resetStateTimmingInfo",
    value: function resetStateTimmingInfo() {
      this.bufferingTime = 0;
    }
  }, {
    key: "eraseMeasurements",
    value: function eraseMeasurements() {
      this.measurements = [];
    }
  }, {
    key: "onUnload",
    value: function onUnload() {
      this.sendEvent();
    }
  }, {
    key: "sendEvent",
    value: function sendEvent() {
      this.send({
        videoSessionId: this.videoSessionId,
        measurements: this.measurements,
        counter: this.counter,
        domainHost: this.domainHost || 'unknown',
        pop: this.pop || 'unknown',
        bufferingTime: this.bufferingTime,
        decodedFrames: this.decodedFrames,
        droppedFrames: this.droppedFrames
      });
    }
  }, {
    key: "stopHeartbeat",
    value: function stopHeartbeat() {
      this.heartbeat && clearInterval(this.heartbeat);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopHeartbeat();

      _get(_getPrototypeOf(NetworkMonitoringSchema.prototype), "destroy", this).call(this);
    }
  }]);

  return NetworkMonitoringSchema;
}(SchemaFactory(ContainerPlugin));

var plugins = {
  EnvironmentInfo: EnvironmentInfo,
  EnvironmentWebInfo: EnvironmentWebInfo,
  SessionInfoSchema: SessionInfoSchema,
  ErrorsInfo: ErrorsInfo,
  EventsInfo: EventsInfo,
  AdConfigSchema: AdConfig,
  NetworkMonitoring: NetworkMonitoringSchema
};

var _Object$entries$reduc = Object.entries(plugins).reduce(function (obj, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  obj[value.type] = obj[value.type] || {};
  obj[value.type][key] = value;
  return obj;
}, {}),
    core = _Object$entries$reduc.core,
    container = _Object$entries$reduc.container;

var stringToArray = function stringToArray(string) {
  var buffer = new ArrayBuffer(string.length * 2); // 2 bytes for each char

  var array = new Uint16Array(buffer);

  for (var i = 0, strLen = string.length; i < strLen; i++) {
    array[i] = string.charCodeAt(i);
  }

  return array;
};
var arrayToString = function arrayToString(array) {
  return String.fromCharCode.apply(null, new Uint16Array(array.buffer));
};
var base64EncodeUint8Array = function base64EncodeUint8Array(input) {
  var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var output = '';
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;

  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index

    chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

    enc1 = chr1 >> 2;
    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = 64;
      enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }

  return output;
};
var base64DecodeUint8Array = function base64DecodeUint8Array(input) {
  var raw = window.atob(input);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));
  var i = 0;

  for (i; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }

  return array;
};

/*
  The EME specification (https://dvcs.w3.org/hg/html-media/raw-file/tip/encrypted-media/encrypted-media.html)
  is supported starting OSX 10.10 and greater.
*/
var extractContentId = function extractContentId(initData) {
  // Return the right of the SKD
  return arrayToString(initData).match(/skd\:\/\/(.*)$/)[1]; // eslint-disable-line no-useless-escape
};
var concatInitDataIdAndCertificate = function concatInitDataIdAndCertificate(initData, receivedID, cert) {
  var id = typeof receivedID === 'string' ? stringToArray(receivedID) : receivedID; // layout is [initData][4 byte: idLength][idLength byte: id][4 byte:certLength][certLength byte: cert]

  var offset = 0;
  var buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);
  var dataView = new DataView(buffer);
  var initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
  initDataArray.set(initData);
  offset += initData.byteLength;
  dataView.setUint32(offset, id.byteLength, true);
  offset += 4;
  var idArray = new Uint16Array(buffer, offset, id.length);
  idArray.set(id);
  offset += idArray.byteLength;
  dataView.setUint32(offset, cert.byteLength, true);
  offset += 4;
  var certArray = new Uint8Array(buffer, offset, cert.byteLength);
  certArray.set(cert);
  return new Uint8Array(buffer, 0, buffer.byteLength);
};
var getKeySystem = function getKeySystem() {
  var isKeyTypeSupported = WebKitMediaKeys.isTypeSupported('com.apple.fps.1_0', 'video/mp4'); // eslint-disable-line no-undef

  return isKeyTypeSupported ? 'com.apple.fps.1_0' : null;
};

var HLSFairplayPlayback = /*#__PURE__*/function (_HTML5Video) {
  _inherits(HLSFairplayPlayback, _HTML5Video);

  var _super = _createSuper(HLSFairplayPlayback);

  _createClass(HLSFairplayPlayback, [{
    key: "name",
    get: function get() {
      return 'hls_fairplay_playback';
    }
  }, {
    key: "events",
    get: function get() {
      return _objectSpread2(_objectSpread2({}, _get(_getPrototypeOf(HLSFairplayPlayback.prototype), "events", this)), {}, {
        webkitneedkey: this.onNeedKey
      });
    }
  }]);

  function HLSFairplayPlayback() {
    var _this;

    _classCallCheck(this, HLSFairplayPlayback);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this._isReadyState = false;
    _this.certificate = null;

    _this.setupDRM(_this.options.fairplay || {});

    return _this;
  }

  _createClass(HLSFairplayPlayback, [{
    key: "_setup",
    value: function _setup() {
      this.setupDRM(this.options.fairplay || {});
    }
  }, {
    key: "setupDRM",
    value: function setupDRM(options) {
      this.certificateUrl = options.certificate;
      this.serverUrl = options.server;
      this.certificateUrl && this.loadCertificate();
    } // CERTIFICATE HANDLERS

  }, {
    key: "loadCertificate",
    value: function loadCertificate() {
      var _this2 = this;

      var request = new XMLHttpRequest();
      request.responseType = 'arraybuffer';
      request.addEventListener('load', function (event) {
        return _this2.onCertificateLoaded(event);
      }, false);
      request.addEventListener('error', function (event) {
        return _this2.onCertificateError(event);
      }, false);
      request.open('GET', this.certificateUrl, true);
      request.send();
    }
  }, {
    key: "onCertificateLoaded",
    value: function onCertificateLoaded(event) {
      var request = event.target;
      this.certificate = new Uint8Array(request.response);

      _get(_getPrototypeOf(HLSFairplayPlayback.prototype), "_ready", this).call(this);

      Log$1.info(this.name, 'Certificate loaded successfully');
    }
  }, {
    key: "onCertificateError",
    value: function onCertificateError(event) {
      var error = this.createError({
        code: 'certificateError',
        description: 'Failed to retrieve the server certificate',
        raw: event
      });
      this.trigger(Events$1.PLAYBACK_ERROR, error);
      Log$1.error(this.name, 'Failed to retrieve the server certificate', error);
    } // KEY HANDLERS

  }, {
    key: "onNeedKey",
    value: function onNeedKey(event) {
      var video = event.target;
      var initData = event.initData;
      var contentId = extractContentId(initData);
      initData = concatInitDataIdAndCertificate(initData, contentId, this.certificate);
      this.createMediaKeys(video);
      this.createKeySession(video, initData, contentId);
    }
  }, {
    key: "createMediaKeys",
    value: function createMediaKeys(video) {
      if (video.webkitKeys) return;
      var keySystem = getKeySystem();

      if (keySystem) {
        video.webkitSetMediaKeys(new WebKitMediaKeys(keySystem)); // eslint-disable-line no-undef
      } else {
        var error = this.createError({
          code: 'unsupportedKeySystem',
          description: 'Could not create MediaKeys. Key System not supported'
        });
        this.trigger(Events$1.PLAYBACK_ERROR, error);
        Log$1.error(this.name, 'Could not create MediaKeys. Key System not supported', error);
      }
    }
  }, {
    key: "createKeySession",
    value: function createKeySession(video, initData, contentId) {
      if (!video.webkitKeys) return;
      var keySession = video.webkitKeys.createSession('video/mp4', initData);

      if (keySession) {
        keySession.contentId = contentId;
        this.bindKeySessionEvents(keySession);
      } else {
        var error = this.createError({
          code: 'mediaKeysError',
          description: 'Could not create key session'
        });
        this.trigger(Events$1.PLAYBACK_ERROR, error);
        Log$1.error(this.name, 'Could not create key session', error);
      }
    }
  }, {
    key: "bindKeySessionEvents",
    value: function bindKeySessionEvents(keySession) {
      var _this3 = this;

      keySession.addEventListener('webkitkeymessage', function (event) {
        return _this3.licenseRequestReady(event);
      }, false);
      keySession.addEventListener('webkitkeyadded', function (event) {
        return _this3.onKeyAdded(event);
      }, false);
      keySession.addEventListener('webkitkeyerror', function (event) {
        return _this3.onKeyError(event);
      }, false);
    }
  }, {
    key: "onKeyAdded",
    value: function onKeyAdded(event) {
      Log$1.info(this.name, 'Decryption key was added to session', event);
    }
  }, {
    key: "onKeyError",
    value: function onKeyError(event) {
      var error = this.createError({
        code: 'decryptionKeyError',
        description: 'A decryption key error was encountered',
        level: 'WARN',
        raw: event
      });
      Log$1.warn(this.name, 'A decryption key error was encountered', error);
    } // LICENSE HANDLERS

  }, {
    key: "licenseRequestReady",
    value: function licenseRequestReady(event) {
      var _this4 = this;

      var session = event.target;
      var message = event.message;
      var request = new XMLHttpRequest();
      var params = "spc=".concat(encodeURIComponent(base64EncodeUint8Array(message)));
      request.responseType = 'text';
      request.session = session;
      request.addEventListener('load', function (event) {
        return _this4.onLicenseRequestLoaded(event);
      }, false);
      request.addEventListener('error', function (event) {
        return _this4.onLicenseRequestError(event);
      }, false);
      request.open('POST', this.serverUrl, true);
      request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      request.send(params);
      Log$1.info(this.name, 'License request ready');
    }
  }, {
    key: "onLicenseRequestLoaded",
    value: function onLicenseRequestLoaded(event) {
      var request = event.target;
      var session = request.session;
      var keyJSON = JSON.parse(request.responseText.trim());
      var key = base64DecodeUint8Array(keyJSON.ckc);
      session.update(key);
      Log$1.info(this.name, 'License loaded successfully');
    }
  }, {
    key: "onLicenseRequestError",
    value: function onLicenseRequestError(event) {
      var error = this.createError({
        code: 'licenseRequestError',
        description: 'The license request failed',
        raw: event
      });
      this.trigger(Events$1.PLAYBACK_ERROR, error);
      Log$1.error(this.name, 'The license request failed', error);
    }
  }]);

  return HLSFairplayPlayback;
}(HTML5Video);

HLSFairplayPlayback.canPlay = function (resource, mimeType, isEncrypted) {
  var resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || [];
  var isHls = resourceParts.length > 1 && resourceParts[1].toLowerCase() === 'm3u8' || mimeType === 'application/x-mpegURL' || mimeType === 'application/vnd.apple.mpegurl';
  return !!((Browser.isSafari || Browser.isiOS) && isHls && isEncrypted);
};

var hlsjsPlayback_external = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   module.exports = factory(require$$0, HLSJS) ;
}(commonjsGlobal, (function (core, HLSJS) {
  HLSJS = HLSJS && Object.prototype.hasOwnProperty.call(HLSJS, 'default') ? HLSJS['default'] : HLSJS;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var now = core.Utils.now,
      assign = core.Utils.assign,
      listContainsIgnoreCase = core.Utils.listContainsIgnoreCase;
  var AUTO = -1;
  core.Events.register('PLAYBACK_FRAGMENT_CHANGED');
  core.Events.register('PLAYBACK_FRAGMENT_PARSING_METADATA');

  var HlsjsPlayback = /*#__PURE__*/function (_HTML5Video) {
    _inherits(HlsjsPlayback, _HTML5Video);

    var _super = _createSuper(HlsjsPlayback);

    _createClass(HlsjsPlayback, [{
      key: "name",
      get: function get() {
        return 'hls';
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.11"
        };
      }
    }, {
      key: "levels",
      get: function get() {
        return this._levels || [];
      }
    }, {
      key: "currentLevel",
      get: function get() {
        if (this._currentLevel === null || this._currentLevel === undefined) return AUTO;else return this._currentLevel; //0 is a valid level ID
      },
      set: function set(id) {
        this._currentLevel = id;
        this.trigger(core.Events.PLAYBACK_LEVEL_SWITCH_START);
        if (this.options.playback.hlsUseNextLevel) this._hls.nextLevel = this._currentLevel;else this._hls.currentLevel = this._currentLevel;
      }
    }, {
      key: "isReady",
      get: function get() {
        return this._isReadyState;
      }
    }, {
      key: "_startTime",
      get: function get() {
        if (this._playbackType === core.Playback.LIVE && this._playlistType !== 'EVENT') return this._extrapolatedStartTime;
        return this._playableRegionStartTime;
      }
    }, {
      key: "_now",
      get: function get() {
        return now();
      } // the time in the video element which should represent the start of the sliding window
      // extrapolated to increase in real time (instead of jumping as the early segments are removed)

    }, {
      key: "_extrapolatedStartTime",
      get: function get() {
        if (!this._localStartTimeCorrelation) return this._playableRegionStartTime;
        var corr = this._localStartTimeCorrelation;
        var timePassed = this._now - corr.local;
        var extrapolatedWindowStartTime = (corr.remote + timePassed) / 1000; // cap at the end of the extrapolated window duration

        return Math.min(extrapolatedWindowStartTime, this._playableRegionStartTime + this._extrapolatedWindowDuration);
      } // the time in the video element which should represent the end of the content
      // extrapolated to increase in real time (instead of jumping as segments are added)

    }, {
      key: "_extrapolatedEndTime",
      get: function get() {
        var actualEndTime = this._playableRegionStartTime + this._playableRegionDuration;
        if (!this._localEndTimeCorrelation) return actualEndTime;
        var corr = this._localEndTimeCorrelation;
        var timePassed = this._now - corr.local;
        var extrapolatedEndTime = (corr.remote + timePassed) / 1000;
        return Math.max(actualEndTime - this._extrapolatedWindowDuration, Math.min(extrapolatedEndTime, actualEndTime));
      }
    }, {
      key: "_duration",
      get: function get() {
        return this._extrapolatedEndTime - this._startTime;
      } // Returns the duration (seconds) of the window that the extrapolated start time is allowed
      // to move in before being capped.
      // The extrapolated start time should never reach the cap at the end of the window as the
      // window should slide as chunks are removed from the start.
      // This also applies to the extrapolated end time in the same way.
      //
      // If chunks aren't being removed for some reason that the start time will reach and remain fixed at
      // playableRegionStartTime + extrapolatedWindowDuration
      //
      //                                <-- window duration -->
      // I.e   playableRegionStartTime |-----------------------|
      //                               | -->   .       .       .
      //                               .   --> | -->   .       .
      //                               .       .   --> | -->   .
      //                               .       .       .   --> |
      //                               .       .       .       .
      //                                 extrapolatedStartTime

    }, {
      key: "_extrapolatedWindowDuration",
      get: function get() {
        if (this._segmentTargetDuration === null) return 0;
        return this._extrapolatedWindowNumSegments * this._segmentTargetDuration;
      }
    }, {
      key: "bandwidthEstimate",
      get: function get() {
        return this._hls && this._hls.bandwidthEstimate;
      }
    }], [{
      key: "HLSJS",
      get: function get() {
        return HLSJS;
      }
    }]);

    function HlsjsPlayback() {
      var _this;

      _classCallCheck(this, HlsjsPlayback);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args)); // backwards compatibility (TODO: remove on 0.3.0)

      _this.options.playback = _objectSpread2(_objectSpread2({}, _this.options), _this.options.playback);
      _this._minDvrSize = typeof _this.options.hlsMinimumDvrSize === 'undefined' ? 60 : _this.options.hlsMinimumDvrSize; // The size of the start time extrapolation window measured as a multiple of segments.
      // Should be 2 or higher, or 0 to disable. Should only need to be increased above 2 if more than one segment is
      // removed from the start of the playlist at a time. E.g if the playlist is cached for 10 seconds and new chunks are
      // added/removed every 5.

      _this._extrapolatedWindowNumSegments = !_this.options.playback || typeof _this.options.playback.extrapolatedWindowNumSegments === 'undefined' ? 2 : _this.options.playback.extrapolatedWindowNumSegments;
      _this._playbackType = core.Playback.VOD;
      _this._lastTimeUpdate = {
        current: 0,
        total: 0
      };
      _this._lastDuration = null; // for hls streams which have dvr with a sliding window,
      // the content at the start of the playlist is removed as new
      // content is appended at the end.
      // this means the actual playable start time will increase as the
      // start content is deleted
      // For streams with dvr where the entire recording is kept from the
      // beginning this should stay as 0

      _this._playableRegionStartTime = 0; // {local, remote} remote is the time in the video element that should represent 0
      //                 local is the system time when the 'remote' measurment took place

      _this._localStartTimeCorrelation = null; // {local, remote} remote is the time in the video element that should represents the end
      //                 local is the system time when the 'remote' measurment took place

      _this._localEndTimeCorrelation = null; // if content is removed from the beginning then this empty area should
      // be ignored. "playableRegionDuration" excludes the empty area

      _this._playableRegionDuration = 0; // #EXT-X-PROGRAM-DATE-TIME

      _this._programDateTime = 0; // true when the actual duration is longer than hlsjs's live sync point
      // when this is false playableRegionDuration will be the actual duration
      // when this is true playableRegionDuration will exclude the time after the sync point

      _this._durationExcludesAfterLiveSyncPoint = false; // #EXT-X-TARGETDURATION

      _this._segmentTargetDuration = null; // #EXT-X-PLAYLIST-TYPE

      _this._playlistType = null;
      _this._recoverAttemptsRemaining = _this.options.hlsRecoverAttempts || 16;
      return _this;
    }

    _createClass(HlsjsPlayback, [{
      key: "_setup",
      value: function _setup() {
        var _this2 = this;

        this._ccIsSetup = false;
        this._ccTracksUpdated = false;
        this._hls && this._hls.destroy();
        this._hls = new HLSJS(assign({}, this.options.playback.hlsjsConfig));

        this._hls.once(HLSJS.Events.MEDIA_ATTACHED, function () {
          return _this2._hls.loadSource(_this2.options.src);
        });

        this._hls.on(HLSJS.Events.LEVEL_LOADED, function (evt, data) {
          return _this2._updatePlaybackType(evt, data);
        });

        this._hls.on(HLSJS.Events.LEVEL_UPDATED, function (evt, data) {
          return _this2._onLevelUpdated(evt, data);
        });

        this._hls.on(HLSJS.Events.LEVEL_SWITCHING, function (evt, data) {
          return _this2._onLevelSwitch(evt, data);
        });

        this._hls.on(HLSJS.Events.FRAG_CHANGED, function (evt, data) {
          return _this2._onFragmentChanged(evt, data);
        });

        this._hls.on(HLSJS.Events.FRAG_LOADED, function (evt, data) {
          return _this2._onFragmentLoaded(evt, data);
        });

        this._hls.on(HLSJS.Events.FRAG_PARSING_METADATA, function (evt, data) {
          return _this2._onFragmentParsingMetadata(evt, data);
        });

        this._hls.on(HLSJS.Events.ERROR, function (evt, data) {
          return _this2._onHLSJSError(evt, data);
        });

        this._hls.on(HLSJS.Events.SUBTITLE_TRACK_LOADED, function (evt, data) {
          return _this2._onSubtitleLoaded(evt, data);
        });

        this._hls.on(HLSJS.Events.SUBTITLE_TRACKS_UPDATED, function () {
          return _this2._ccTracksUpdated = true;
        });

        this._hls.attachMedia(this.el);
      }
    }, {
      key: "_onFragmentParsingMetadata",
      value: function _onFragmentParsingMetadata(evt, data) {
        this.trigger(core.Events.Custom.PLAYBACK_FRAGMENT_PARSING_METADATA, {
          evt: evt,
          data: data
        });
      }
    }, {
      key: "render",
      value: function render() {
        this._ready();

        return _get(_getPrototypeOf(HlsjsPlayback.prototype), "render", this).call(this);
      }
    }, {
      key: "_ready",
      value: function _ready() {
        this._isReadyState = true;
        this.trigger(core.Events.PLAYBACK_READY, this.name);
      }
    }, {
      key: "_recover",
      value: function _recover(evt, data, error) {
        if (!this._recoveredDecodingError) {
          this._recoveredDecodingError = true;

          this._hls.recoverMediaError();
        } else if (!this._recoveredAudioCodecError) {
          this._recoveredAudioCodecError = true;

          this._hls.swapAudioCodec();

          this._hls.recoverMediaError();
        } else {
          core.Log.error('hlsjs: failed to recover', {
            evt: evt,
            data: data
          });
          error.level = core.PlayerError.Levels.FATAL;
          var formattedError = this.createError(error);
          this.trigger(core.Events.PLAYBACK_ERROR, formattedError);
          this.stop();
        }
      } // override

    }, {
      key: "_setupSrc",
      value: function _setupSrc(srcUrl) {// eslint-disable-line no-unused-vars
        // this playback manages the src on the video element itself
      }
    }, {
      key: "_startTimeUpdateTimer",
      value: function _startTimeUpdateTimer() {
        var _this3 = this;

        if (this._timeUpdateTimer) return;
        this._timeUpdateTimer = setInterval(function () {
          _this3._onDurationChange();

          _this3._onTimeUpdate();
        }, 100);
      }
    }, {
      key: "_stopTimeUpdateTimer",
      value: function _stopTimeUpdateTimer() {
        if (!this._timeUpdateTimer) return;
        clearInterval(this._timeUpdateTimer);
        this._timeUpdateTimer = null;
      }
    }, {
      key: "getProgramDateTime",
      value: function getProgramDateTime() {
        return this._programDateTime;
      } // the duration on the video element itself should not be used
      // as this does not necesarily represent the duration of the stream
      // https://github.com/clappr/clappr/issues/668#issuecomment-157036678

    }, {
      key: "getDuration",
      value: function getDuration() {
        return this._duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        // e.g. can be < 0 if user pauses near the start
        // eventually they will then be kicked to the end by hlsjs if they run out of buffer
        // before the official start time
        return Math.max(0, this.el.currentTime - this._startTime);
      } // the time that "0" now represents relative to when playback started
      // for a stream with a sliding window this will increase as content is
      // removed from the beginning

    }, {
      key: "getStartTimeOffset",
      value: function getStartTimeOffset() {
        return this._startTime;
      }
    }, {
      key: "seekPercentage",
      value: function seekPercentage(percentage) {
        var seekTo = this._duration;
        if (percentage > 0) seekTo = this._duration * (percentage / 100);
        this.seek(seekTo);
      }
    }, {
      key: "seek",
      value: function seek(time) {
        if (time < 0) {
          core.Log.warn('Attempt to seek to a negative time. Resetting to live point. Use seekToLivePoint() to seek to the live point.');
          time = this.getDuration();
        } // assume live if time within 3 seconds of end of stream


        this.dvrEnabled && this._updateDvr(time < this.getDuration() - 3);
        time += this._startTime;
        this.el.currentTime = time;
      }
    }, {
      key: "seekToLivePoint",
      value: function seekToLivePoint() {
        this.seek(this.getDuration());
      }
    }, {
      key: "_updateDvr",
      value: function _updateDvr(status) {
        this.trigger(core.Events.PLAYBACK_DVR, status);
        this.trigger(core.Events.PLAYBACK_STATS_ADD, {
          'dvr': status
        });
      }
    }, {
      key: "_updateSettings",
      value: function _updateSettings() {
        if (this._playbackType === core.Playback.VOD) this.settings.left = ['playpause', 'position', 'duration'];else if (this.dvrEnabled) this.settings.left = ['playpause'];else this.settings.left = ['playstop'];
        this.settings.seekEnabled = this.isSeekEnabled();
        this.trigger(core.Events.PLAYBACK_SETTINGSUPDATE);
      }
    }, {
      key: "_onHLSJSError",
      value: function _onHLSJSError(evt, data) {
        var error = {
          code: "".concat(data.type, "_").concat(data.details),
          description: "".concat(this.name, " error: type: ").concat(data.type, ", details: ").concat(data.details),
          raw: data
        };
        var formattedError;
        if (data.response) error.description += ", response: ".concat(JSON.stringify(data.response)); // only report/handle errors if they are fatal
        // hlsjs should automatically handle non fatal errors

        if (data.fatal) {
          if (this._recoverAttemptsRemaining > 0) {
            this._recoverAttemptsRemaining -= 1;

            switch (data.type) {
              case HLSJS.ErrorTypes.NETWORK_ERROR:
                switch (data.details) {
                  // The following network errors cannot be recovered with HLS.startLoad()
                  // For more details, see https://github.com/video-dev/hls.js/blob/master/doc/design.md#error-detection-and-handling
                  // For "level load" fatal errors, see https://github.com/video-dev/hls.js/issues/1138
                  case HLSJS.ErrorDetails.MANIFEST_LOAD_ERROR:
                  case HLSJS.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                  case HLSJS.ErrorDetails.MANIFEST_PARSING_ERROR:
                  case HLSJS.ErrorDetails.LEVEL_LOAD_ERROR:
                  case HLSJS.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                    core.Log.error('hlsjs: unrecoverable network fatal error.', {
                      evt: evt,
                      data: data
                    });
                    formattedError = this.createError(error);
                    this.trigger(core.Events.PLAYBACK_ERROR, formattedError);
                    this.stop();
                    break;

                  default:
                    core.Log.warn('hlsjs: trying to recover from network error.', {
                      evt: evt,
                      data: data
                    });
                    error.level = core.PlayerError.Levels.WARN;

                    this._hls.startLoad();

                    break;
                }

                break;

              case HLSJS.ErrorTypes.MEDIA_ERROR:
                core.Log.warn('hlsjs: trying to recover from media error.', {
                  evt: evt,
                  data: data
                });
                error.level = core.PlayerError.Levels.WARN;

                this._recover(evt, data, error);

                break;

              default:
                core.Log.error('hlsjs: could not recover from error.', {
                  evt: evt,
                  data: data
                });
                formattedError = this.createError(error);
                this.trigger(core.Events.PLAYBACK_ERROR, formattedError);
                this.stop();
                break;
            }
          } else {
            core.Log.error('hlsjs: could not recover from error after maximum number of attempts.', {
              evt: evt,
              data: data
            });
            formattedError = this.createError(error);
            this.trigger(core.Events.PLAYBACK_ERROR, formattedError);
            this.stop();
          }
        } else {
          // Transforms HLSJS.ErrorDetails.KEY_LOAD_ERROR non-fatal error to
          // playback fatal error if triggerFatalErrorOnResourceDenied playback
          // option is set. HLSJS.ErrorTypes.KEY_SYSTEM_ERROR are fatal errors
          // and therefore already handled.
          if (this.options.playback.triggerFatalErrorOnResourceDenied && this._keyIsDenied(data)) {
            core.Log.error('hlsjs: could not load decrypt key.', {
              evt: evt,
              data: data
            });
            formattedError = this.createError(error);
            this.trigger(core.Events.PLAYBACK_ERROR, formattedError);
            this.stop();
            return;
          }

          error.level = core.PlayerError.Levels.WARN;
          core.Log.warn('hlsjs: non-fatal error occurred', {
            evt: evt,
            data: data
          });
        }
      }
    }, {
      key: "_keyIsDenied",
      value: function _keyIsDenied(data) {
        return data.type === HLSJS.ErrorTypes.NETWORK_ERROR && data.details === HLSJS.ErrorDetails.KEY_LOAD_ERROR && data.response && data.response.code >= 400;
      }
    }, {
      key: "_onTimeUpdate",
      value: function _onTimeUpdate() {
        var update = {
          current: this.getCurrentTime(),
          total: this.getDuration(),
          firstFragDateTime: this.getProgramDateTime()
        };
        var isSame = this._lastTimeUpdate && update.current === this._lastTimeUpdate.current && update.total === this._lastTimeUpdate.total;
        if (isSame) return;
        this._lastTimeUpdate = update;
        this.trigger(core.Events.PLAYBACK_TIMEUPDATE, update, this.name);
      }
    }, {
      key: "_onDurationChange",
      value: function _onDurationChange() {
        var duration = this.getDuration();
        if (this._lastDuration === duration) return;
        this._lastDuration = duration;

        _get(_getPrototypeOf(HlsjsPlayback.prototype), "_onDurationChange", this).call(this);
      }
    }, {
      key: "_onProgress",
      value: function _onProgress() {
        if (!this.el.buffered.length) return;
        var buffered = [];
        var bufferedPos = 0;

        for (var i = 0; i < this.el.buffered.length; i++) {
          buffered = [].concat(_toConsumableArray(buffered), [{
            // for a stream with sliding window dvr something that is buffered my slide off the start of the timeline
            start: Math.max(0, this.el.buffered.start(i) - this._playableRegionStartTime),
            end: Math.max(0, this.el.buffered.end(i) - this._playableRegionStartTime)
          }]);
          if (this.el.currentTime >= buffered[i].start && this.el.currentTime <= buffered[i].end) bufferedPos = i;
        }

        var progress = {
          start: buffered[bufferedPos].start,
          current: buffered[bufferedPos].end,
          total: this.getDuration()
        };
        this.trigger(core.Events.PLAYBACK_PROGRESS, progress, buffered);
      }
    }, {
      key: "play",
      value: function play() {
        if (!this._hls) this._setup();

        _get(_getPrototypeOf(HlsjsPlayback.prototype), "play", this).call(this);

        this._startTimeUpdateTimer();
      }
    }, {
      key: "pause",
      value: function pause() {
        if (!this._hls) return;
        this.el.pause();
        if (this.dvrEnabled) this._updateDvr(true);
      }
    }, {
      key: "stop",
      value: function stop() {
        this._stopTimeUpdateTimer();

        if (this._hls) {
          _get(_getPrototypeOf(HlsjsPlayback.prototype), "stop", this).call(this);

          this._hls.destroy();

          delete this._hls;
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this._stopTimeUpdateTimer();

        if (this._hls) {
          this._hls.destroy();

          delete this._hls;
        }

        _get(_getPrototypeOf(HlsjsPlayback.prototype), "destroy", this).call(this);
      }
    }, {
      key: "_updatePlaybackType",
      value: function _updatePlaybackType(evt, data) {
        this._playbackType = data.details.live ? core.Playback.LIVE : core.Playback.VOD;

        this._onLevelUpdated(evt, data); // Live stream subtitle tracks detection hack (may not immediately available)


        if (this._ccTracksUpdated && this._playbackType === core.Playback.LIVE && this.hasClosedCaptionsTracks) this._onSubtitleLoaded();
      }
    }, {
      key: "_fillLevels",
      value: function _fillLevels() {
        this._levels = this._hls.levels.map(function (level, index) {
          return {
            id: index,
            level: level,
            label: "".concat(level.bitrate / 1000, "Kbps")
          };
        });
        this.trigger(core.Events.PLAYBACK_LEVELS_AVAILABLE, this._levels);
      }
    }, {
      key: "_onLevelUpdated",
      value: function _onLevelUpdated(evt, data) {
        this._segmentTargetDuration = data.details.targetduration;
        this._playlistType = data.details.type || null;
        var startTimeChanged = false;
        var durationChanged = false;
        var fragments = data.details.fragments;
        var previousPlayableRegionStartTime = this._playableRegionStartTime;
        var previousPlayableRegionDuration = this._playableRegionDuration;
        if (fragments.length === 0) return; // #EXT-X-PROGRAM-DATE-TIME

        if (fragments[0].rawProgramDateTime) this._programDateTime = fragments[0].rawProgramDateTime;

        if (this._playableRegionStartTime !== fragments[0].start) {
          startTimeChanged = true;
          this._playableRegionStartTime = fragments[0].start;
        }

        if (startTimeChanged) {
          if (!this._localStartTimeCorrelation) {
            // set the correlation to map to middle of the extrapolation window
            this._localStartTimeCorrelation = {
              local: this._now,
              remote: (fragments[0].start + this._extrapolatedWindowDuration / 2) * 1000
            };
          } else {
            // check if the correlation still works
            var corr = this._localStartTimeCorrelation;
            var timePassed = this._now - corr.local; // this should point to a time within the extrapolation window

            var startTime = (corr.remote + timePassed) / 1000;

            if (startTime < fragments[0].start) {
              // our start time is now earlier than the first chunk
              // (maybe the chunk was removed early)
              // reset correlation so that it sits at the beginning of the first available chunk
              this._localStartTimeCorrelation = {
                local: this._now,
                remote: fragments[0].start * 1000
              };
            } else if (startTime > previousPlayableRegionStartTime + this._extrapolatedWindowDuration) {
              // start time was past the end of the old extrapolation window (so would have been capped)
              // see if now that time would be inside the window, and if it would be set the correlation
              // so that it resumes from the time it was at at the end of the old window
              // update the correlation so that the time starts counting again from the value it's on now
              this._localStartTimeCorrelation = {
                local: this._now,
                remote: Math.max(fragments[0].start, previousPlayableRegionStartTime + this._extrapolatedWindowDuration) * 1000
              };
            }
          }
        }

        var newDuration = data.details.totalduration; // if it's a live stream then shorten the duration to remove access
        // to the area after hlsjs's live sync point
        // seeks to areas after this point sometimes have issues

        if (this._playbackType === core.Playback.LIVE) {
          var fragmentTargetDuration = data.details.targetduration;
          var hlsjsConfig = this.options.playback.hlsjsConfig || {};
          var liveSyncDurationCount = hlsjsConfig.liveSyncDurationCount || HLSJS.DefaultConfig.liveSyncDurationCount;
          var hiddenAreaDuration = fragmentTargetDuration * liveSyncDurationCount;

          if (hiddenAreaDuration <= newDuration) {
            newDuration -= hiddenAreaDuration;
            this._durationExcludesAfterLiveSyncPoint = true;
          } else {
            this._durationExcludesAfterLiveSyncPoint = false;
          }
        }

        if (newDuration !== this._playableRegionDuration) {
          durationChanged = true;
          this._playableRegionDuration = newDuration;
        } // Note the end time is not the playableRegionDuration
        // The end time will always increase even if content is removed from the beginning


        var endTime = fragments[0].start + newDuration;
        var previousEndTime = previousPlayableRegionStartTime + previousPlayableRegionDuration;
        var endTimeChanged = endTime !== previousEndTime;

        if (endTimeChanged) {
          if (!this._localEndTimeCorrelation) {
            // set the correlation to map to the end
            this._localEndTimeCorrelation = {
              local: this._now,
              remote: endTime * 1000
            };
          } else {
            // check if the correlation still works
            var _corr = this._localEndTimeCorrelation;

            var _timePassed = this._now - _corr.local; // this should point to a time within the extrapolation window from the end


            var extrapolatedEndTime = (_corr.remote + _timePassed) / 1000;

            if (extrapolatedEndTime > endTime) {
              this._localEndTimeCorrelation = {
                local: this._now,
                remote: endTime * 1000
              };
            } else if (extrapolatedEndTime < endTime - this._extrapolatedWindowDuration) {
              // our extrapolated end time is now earlier than the extrapolation window from the actual end time
              // (maybe a chunk became available early)
              // reset correlation so that it sits at the beginning of the extrapolation window from the end time
              this._localEndTimeCorrelation = {
                local: this._now,
                remote: (endTime - this._extrapolatedWindowDuration) * 1000
              };
            } else if (extrapolatedEndTime > previousEndTime) {
              // end time was past the old end time (so would have been capped)
              // set the correlation so that it resumes from the time it was at at the end of the old window
              this._localEndTimeCorrelation = {
                local: this._now,
                remote: previousEndTime * 1000
              };
            }
          }
        } // now that the values have been updated call any methods that use on them so they get the updated values
        // immediately


        durationChanged && this._onDurationChange();
        startTimeChanged && this._onProgress();
      }
    }, {
      key: "_onFragmentChanged",
      value: function _onFragmentChanged(evt, data) {
        this.trigger(core.Events.Custom.PLAYBACK_FRAGMENT_CHANGED, data);
      }
    }, {
      key: "_onFragmentLoaded",
      value: function _onFragmentLoaded(evt, data) {
        this.trigger(core.Events.PLAYBACK_FRAGMENT_LOADED, data);
      }
    }, {
      key: "_onSubtitleLoaded",
      value: function _onSubtitleLoaded() {
        // This event may be triggered multiple times
        // Setup CC only once (disable CC by default)
        if (!this._ccIsSetup) {
          this.trigger(core.Events.PLAYBACK_SUBTITLE_AVAILABLE);
          var trackId = this._playbackType === core.Playback.LIVE ? -1 : this.closedCaptionsTrackId;
          this.closedCaptionsTrackId = trackId;
          this._ccIsSetup = true;
        }
      }
    }, {
      key: "_onLevelSwitch",
      value: function _onLevelSwitch(evt, data) {
        if (!this.levels.length) this._fillLevels();
        this.trigger(core.Events.PLAYBACK_LEVEL_SWITCH_END);
        this.trigger(core.Events.PLAYBACK_LEVEL_SWITCH, data);
        var currentLevel = this._hls.levels[data.level];

        if (currentLevel) {
          // TODO should highDefinition be private and maybe have a read only accessor if it's used somewhere
          this.highDefinition = currentLevel.height >= 720 || currentLevel.bitrate / 1000 >= 2000;
          this.trigger(core.Events.PLAYBACK_HIGHDEFINITIONUPDATE, this.highDefinition);
          this.trigger(core.Events.PLAYBACK_BITRATE, {
            height: currentLevel.height,
            width: currentLevel.width,
            bandwidth: currentLevel.bitrate,
            bitrate: currentLevel.bitrate,
            level: data.level
          });
        }
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return this._playbackType;
      }
    }, {
      key: "isSeekEnabled",
      value: function isSeekEnabled() {
        return this._playbackType === core.Playback.VOD || this.dvrEnabled;
      }
    }, {
      key: "dvrEnabled",
      get: function get() {
        // enabled when:
        // - the duration does not include content after hlsjs's live sync point
        // - the playable region duration is longer than the configured duration to enable dvr after
        // - the playback type is LIVE.
        return this._durationExcludesAfterLiveSyncPoint && this._duration >= this._minDvrSize && this.getPlaybackType() === core.Playback.LIVE;
      }
    }]);

    return HlsjsPlayback;
  }(core.HTML5Video);

  HlsjsPlayback.canPlay = function (resource, mimeType) {
    var resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || [];
    var isHls = resourceParts.length > 1 && resourceParts[1].toLowerCase() === 'm3u8' || listContainsIgnoreCase(mimeType, ['application/vnd.apple.mpegurl', 'application/x-mpegURL']);
    return !!(HLSJS.isSupported() && isHls);
  };

  return HlsjsPlayback;

})));
});

var dashShakaPlayback = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(require$$0);
})(window, function(__WEBPACK_EXTERNAL_MODULE_clappr__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/clappr-dash-shaka-playback.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/shaka-player/dist/shaka-player.compiled.js":
/*!*****************************************************************!*\
  !*** ./node_modules/shaka-player/dist/shaka-player.compiled.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
(function(){var innerGlobal=typeof window!="undefined"?window:global;var exportTo={};(function(window,global,module){/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var p;function ba(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var ca="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};
function da(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var ea=da(this);function fa(a,b){if(b)a:{for(var c=ea,d=a.split("."),e=0;e<d.length-1;e++){var f=d[e];if(!(f in c))break a;c=c[f];}d=d[d.length-1];e=c[d];f=b(e);f!=e&&null!=f&&ca(c,d,{configurable:!0,writable:!0,value:f});}}
fa("Symbol",function(a){function b(e){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c("jscomp_symbol_"+(e||"")+"_"+d++,e)}function c(e,f){this.a=e;ca(this,"description",{configurable:!0,writable:!0,value:f});}if(a)return a;c.prototype.toString=function(){return this.a};var d=0;return b});
fa("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=ea[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&ca(d.prototype,a,{configurable:!0,writable:!0,value:function(){return ha(ba(this))}});}return a});function ha(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}
function q(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:ba(a)}}function ia(a){if(!(a instanceof Array)){a=q(a);for(var b,c=[];!(b=a.next()).done;)c.push(b.value);a=c;}return a}var ja="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ka;
if("function"==typeof Object.setPrototypeOf)ka=Object.setPrototypeOf;else {var la;a:{var ma={ae:!0},na={};try{na.__proto__=ma;la=na.ae;break a}catch(a){}la=!1;}ka=la?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null;}var oa=ka;
function pa(a,b){a.prototype=ja(b.prototype);a.prototype.constructor=a;if(oa)oa(a,b);else for(var c in b)if("prototype"!=c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d);}else a[c]=b[c];a.Rf=b.prototype;}function qa(){this.j=!1;this.g=null;this.b=void 0;this.a=1;this.f=this.h=0;this.v=this.c=null;}function ra(a){if(a.j)throw new TypeError("Generator is already running");a.j=!0;}qa.prototype.m=function(a){this.b=a;};
function sa(a,b){a.c={Bd:b,Gd:!0};a.a=a.h||a.f;}qa.prototype["return"]=function(a){this.c={"return":a};this.a=this.f;};function t(a,b,c){a.a=c;return {value:b}}qa.prototype.u=function(a){this.a=a;};function w(a){a.a=0;}function x(a,b,c){a.h=b;void 0!=c&&(a.f=c);}function ta(a){a.h=0;a.f=2;}function ua(a,b){a.a=b;a.h=0;}function C(a){a.h=0;var b=a.c.Bd;a.c=null;return b}function va(a){a.v=[a.c];a.h=0;a.f=0;}
function wa(a,b){var c=a.v.splice(0)[0];(c=a.c=a.c||c)?c.Gd?a.a=a.h||a.f:void 0!=c.u&&a.f<c.u?(a.a=c.u,a.c=null):a.a=a.f:a.a=b;}function xa(a){this.a=new qa;this.b=a;}function za(a,b){ra(a.a);var c=a.a.g;if(c)return Ba(a,"return"in c?c["return"]:function(d){return {value:d,done:!0}},b,a.a["return"]);a.a["return"](b);return Da(a)}
function Ba(a,b,c,d){try{var e=b.call(a.a.g,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.a.j=!1,e;var f=e.value;}catch(g){return a.a.g=null,sa(a.a,g),Da(a)}a.a.g=null;d.call(a.a,f);return Da(a)}
function Da(a){for(;a.a.a;)try{var b=a.b(a.a);if(b)return a.a.j=!1,{value:b.value,done:!1}}catch(c){a.a.b=void 0,sa(a.a,c);}a.a.j=!1;if(a.a.c){b=a.a.c;a.a.c=null;if(b.Gd)throw b.Bd;return {value:b["return"],done:!0}}return {value:void 0,done:!0}}
function Ea(a){this.next=function(b){ra(a.a);a.a.g?b=Ba(a,a.a.g.next,b,a.a.m):(a.a.m(b),b=Da(a));return b};this["throw"]=function(b){ra(a.a);a.a.g?b=Ba(a,a.a.g["throw"],b,a.a.m):(sa(a.a,b),b=Da(a));return b};this["return"]=function(b){return za(a,b)};this[Symbol.iterator]=function(){return this};}function Fa(a,b){var c=new Ea(new xa(b));oa&&a.prototype&&oa(c,a.prototype);return c}
function Ia(a){function b(d){return a.next(d)}function c(d){return a["throw"](d)}return new Promise(function(d,e){function f(g){g.done?d(g.value):Promise.resolve(g.value).then(b,c).then(f,e);}f(a.next());})}function J(a){return Ia(new Ea(new xa(a)))}
fa("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];this.j=!1;var h=this.f();try{g(h.resolve,h.reject);}catch(k){h.reject(k);}}function c(){this.a=null;}function d(g){return g instanceof b?g:new b(function(h){h(g);})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g();});}this.a.push(g);};var e=ea.setTimeout;c.prototype.c=function(g){e(g,0);};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var k=
g[h];g[h]=null;try{k();}catch(l){this.f(l);}}}this.a=null;};c.prototype.f=function(g){this.c(function(){throw g;});};b.prototype.f=function(){function g(l){return function(m){k||(k=!0,l.call(h,m));}}var h=this,k=!1;return {resolve:g(this.H),reject:g(this.g)}};b.prototype.H=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.J(g);else {a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1;}h?this.D(g):this.h(g);}};
b.prototype.D=function(g){var h=void 0;try{h=g.then;}catch(k){this.g(k);return}"function"==typeof h?this.M(h,g):this.h(g);};b.prototype.g=function(g){this.m(2,g);};b.prototype.h=function(g){this.m(1,g);};b.prototype.m=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;2===this.b&&this.I();this.v();};b.prototype.I=function(){var g=this;e(function(){if(g.A()){var h=ea.console;"undefined"!==typeof h&&h.error(g.c);}},1);};b.prototype.A=
function(){if(this.j)return !1;var g=ea.CustomEvent,h=ea.Event,k=ea.dispatchEvent;if("undefined"===typeof k)return !0;"function"===typeof g?g=new g("unhandledrejection",{cancelable:!0}):"function"===typeof h?g=new h("unhandledrejection",{cancelable:!0}):(g=ea.document.createEvent("CustomEvent"),g.initCustomEvent("unhandledrejection",!1,!0,g));g.promise=this;g.reason=this.c;return k(g)};b.prototype.v=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null;}};var f=new c;
b.prototype.J=function(g){var h=this.f();g.ec(h.resolve,h.reject);};b.prototype.M=function(g,h){var k=this.f();try{g.call(h,k.resolve,k.reject);}catch(l){k.reject(l);}};b.prototype.then=function(g,h){function k(r,u){return "function"==typeof r?function(v){try{l(r(v));}catch(A){m(A);}}:u}var l,m,n=new b(function(r,u){l=r;m=u;});this.ec(k(g,l),k(h,m));return n};b.prototype["catch"]=function(g){return this.then(void 0,g)};b.prototype.ec=function(g,h){function k(){switch(l.b){case 1:g(l.c);break;case 2:h(l.c);
break;default:throw Error("Unexpected state: "+l.b);}}var l=this;null==this.a?f.b(k):this.a.push(k);this.j=!0;};b.resolve=d;b.reject=function(g){return new b(function(h,k){k(g);})};b.race=function(g){return new b(function(h,k){for(var l=q(g),m=l.next();!m.done;m=l.next())d(m.value).ec(h,k);})};b.all=function(g){var h=q(g),k=h.next();return k.done?d([]):new b(function(l,m){function n(v){return function(A){r[v]=A;u--;0==u&&l(r);}}var r=[],u=0;do r.push(void 0),u++,d(k.value).ec(n(r.length-1),m),k=h.next();
while(!k.done)})};return b});function Ja(a,b){return Object.prototype.hasOwnProperty.call(a,b)}
fa("WeakMap",function(a){function b(k){this.a=(h+=Math.random()+1).toString();if(k){k=q(k);for(var l;!(l=k.next()).done;)l=l.value,this.set(l[0],l[1]);}}function c(){}function d(k){var l=typeof k;return "object"===l&&null!==k||"function"===l}function e(k){if(!Ja(k,g)){var l=new c;ca(k,g,{value:l});}}function f(k){var l=Object[k];l&&(Object[k]=function(m){if(m instanceof c)return m;Object.isExtensible(m)&&e(m);return l(m)});}if(function(){if(!a||!Object.seal)return !1;try{var k=Object.seal({}),l=Object.seal({}),
m=new a([[k,2],[l,3]]);if(2!=m.get(k)||3!=m.get(l))return !1;m["delete"](k);m.set(l,4);return !m.has(k)&&4==m.get(l)}catch(n){return !1}}())return a;var g="$jscomp_hidden_"+Math.random();f("freeze");f("preventExtensions");f("seal");var h=0;b.prototype.set=function(k,l){if(!d(k))throw Error("Invalid WeakMap key");e(k);if(!Ja(k,g))throw Error("WeakMap key fail: "+k);k[g][this.a]=l;return this};b.prototype.get=function(k){return d(k)&&Ja(k,g)?k[g][this.a]:void 0};b.prototype.has=function(k){return d(k)&&
Ja(k,g)&&Ja(k[g],this.a)};b.prototype["delete"]=function(k){return d(k)&&Ja(k,g)&&Ja(k[g],this.a)?delete k[g][this.a]:!1};return b});
fa("Map",function(a){function b(){var h={};return h.Ga=h.next=h.head=h}function c(h,k){var l=h.a;return ha(function(){if(l){for(;l.head!=h.a;)l=l.Ga;for(;l.next!=l.head;)return l=l.next,{done:!1,value:k(l)};l=null;}return {done:!0,value:void 0}})}function d(h,k){var l=k&&typeof k;"object"==l||"function"==l?f.has(k)?l=f.get(k):(l=""+ ++g,f.set(k,l)):l="p_"+k;var m=h.b[l];if(m&&Ja(h.b,l))for(var n=0;n<m.length;n++){var r=m[n];if(k!==k&&r.key!==r.key||k===r.key)return {id:l,list:m,index:n,X:r}}return {id:l,
list:m,index:-1,X:void 0}}function e(h){this.b={};this.a=b();this.size=0;if(h){h=q(h);for(var k;!(k=h.next()).done;)k=k.value,this.set(k[0],k[1]);}}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return !1;try{var h=Object.seal({x:4}),k=new a(q([[h,"s"]]));if("s"!=k.get(h)||1!=k.size||k.get({x:4})||k.set({x:4},"t")!=k||2!=k.size)return !1;var l=k.entries(),m=l.next();if(m.done||m.value[0]!=h||"s"!=m.value[1])return !1;m=l.next();return m.done||4!=m.value[0].x||
"t"!=m.value[1]||!l.next().done?!1:!0}catch(n){return !1}}())return a;var f=new WeakMap;e.prototype.set=function(h,k){h=0===h?0:h;var l=d(this,h);l.list||(l.list=this.b[l.id]=[]);l.X?l.X.value=k:(l.X={next:this.a,Ga:this.a.Ga,head:this.a,key:h,value:k},l.list.push(l.X),this.a.Ga.next=l.X,this.a.Ga=l.X,this.size++);return this};e.prototype["delete"]=function(h){h=d(this,h);return h.X&&h.list?(h.list.splice(h.index,1),h.list.length||delete this.b[h.id],h.X.Ga.next=h.X.next,h.X.next.Ga=h.X.Ga,h.X.head=
null,this.size--,!0):!1};e.prototype.clear=function(){this.b={};this.a=this.a.Ga=b();this.size=0;};e.prototype.has=function(h){return !!d(this,h).X};e.prototype.get=function(h){return (h=d(this,h).X)&&h.value};e.prototype.entries=function(){return c(this,function(h){return [h.key,h.value]})};e.prototype.keys=function(){return c(this,function(h){return h.key})};e.prototype.values=function(){return c(this,function(h){return h.value})};e.prototype.forEach=function(h,k){for(var l=this.entries(),m;!(m=l.next()).done;)m=
m.value,h.call(k,m[1],m[0],this);};e.prototype[Symbol.iterator]=e.prototype.entries;var g=0;return e});
fa("Set",function(a){function b(c){this.a=new Map;if(c){c=q(c);for(var d;!(d=c.next()).done;)this.add(d.value);}this.size=this.a.size;}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return !1;try{var c=Object.seal({x:4}),d=new a(q([c]));if(!d.has(c)||1!=d.size||d.add(c)!=d||1!=d.size||d.add({x:4})!=d||2!=d.size)return !1;var e=d.entries(),f=e.next();if(f.done||f.value[0]!=c||f.value[1]!=c)return !1;f=e.next();return f.done||f.value[0]==c||4!=f.value[0].x||
f.value[1]!=f.value[0]?!1:e.next().done}catch(g){return !1}}())return a;b.prototype.add=function(c){c=0===c?0:c;this.a.set(c,c);this.size=this.a.size;return this};b.prototype["delete"]=function(c){c=this.a["delete"](c);this.size=this.a.size;return c};b.prototype.clear=function(){this.a.clear();this.size=0;};b.prototype.has=function(c){return this.a.has(c)};b.prototype.entries=function(){return this.a.entries()};b.prototype.values=function(){return this.a.values()};b.prototype.keys=b.prototype.values;
b.prototype[Symbol.iterator]=b.prototype.values;b.prototype.forEach=function(c,d){var e=this;this.a.forEach(function(f){return c.call(d,f,f,e)});};return b});function Ka(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return {Y:e,Yd:f}}return {Y:-1,Yd:void 0}}fa("Array.prototype.findIndex",function(a){return a?a:function(b,c){return Ka(this,b,c).Y}});
fa("Promise.prototype.finally",function(a){return a?a:function(b){return this.then(function(c){return Promise.resolve(b()).then(function(){return c})},function(c){return Promise.resolve(b()).then(function(){throw c;})})}});function La(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return {value:b(f,a[f]),done:!1}}d=!0;return {done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}
fa("Array.prototype.keys",function(a){return a?a:function(){return La(this,function(b){return b})}});fa("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});fa("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length,f=c||0;for(0>f&&(f=Math.max(f+e,0));f<e;f++){var g=d[f];if(g===b||Object.is(g,b))return !0}return !1}});
function Ma(a,b,c){if(null==a)throw new TypeError("The 'this' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""}fa("String.prototype.includes",function(a){return a?a:function(b,c){return -1!==Ma(this,b,"includes").indexOf(b,c||0)}});fa("Array.prototype.values",function(a){return a?a:function(){return La(this,function(b,c){return c})}});
fa("Array.from",function(a){return a?a:function(b,c,d){c=null!=c?c:function(h){return h};var e=[],f="undefined"!=typeof Symbol&&Symbol.iterator&&b[Symbol.iterator];if("function"==typeof f){b=f.call(b);for(var g=0;!(f=b.next()).done;)e.push(c.call(d,f.value,g++));}else for(f=b.length,g=0;g<f;g++)e.push(c.call(d,b[g],g));return e}});fa("Array.prototype.find",function(a){return a?a:function(b,c){return Ka(this,b,c).Yd}});fa("Math.log2",function(a){return a?a:function(b){return Math.log(b)/Math.LN2}});
var Na="function"==typeof Object.assign?Object.assign:function(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(d)for(var e in d)Ja(d,e)&&(a[e]=d[e]);}return a};fa("Object.assign",function(a){return a||Na});fa("Object.values",function(a){return a?a:function(b){var c=[],d;for(d in b)Ja(b,d)&&c.push(b[d]);return c}});
fa("String.prototype.startsWith",function(a){return a?a:function(b,c){for(var d=Ma(this,b,"startsWith"),e=d.length,f=b.length,g=Math.max(0,Math.min(c|0,d.length)),h=0;h<f&&g<e;)if(d[g++]!=b[h++])return !1;return h>=f}});var Oa=this||self;function K(a,b){var c=a.split("."),d=Oa;c[0]in d||"undefined"==typeof d.execScript||d.execScript("var "+c[0]);for(var e;c.length&&(e=c.shift());)c.length||void 0===b?d[e]&&d[e]!==Object.prototype[e]?d=d[e]:d=d[e]={}:d[e]=b;}function Pa(a){this.c=Math.exp(Math.log(.5)/a);this.b=this.a=0;}function Qa(a,b,c){var d=Math.pow(a.c,b);c=c*(1-d)+d*a.a;isNaN(c)||(a.a=c,a.b+=b);}function Ta(a){return a.a/(1-Math.pow(a.c,a.b))}function Ua(){this.b=new Pa(2);this.c=new Pa(5);this.a=0;}Ua.prototype.getBandwidthEstimate=function(a){return 128E3>this.a?a:Math.min(Ta(this.b),Ta(this.c))};function Va(){}function Wa(){}function Xa(){}function Ya(a,b){for(var c=[],d=1;d<arguments.length;++d)c[d-1]=arguments[d];Za.has(a)||(Za.add(a),Xa.apply(Va,ia(c)));}function $a(){}function ab(){}var Za=new Set;if(window.console&&window.console.log.bind){var bb={},cb=(bb[1]=console.error.bind(console),bb[2]=console.warn.bind(console),bb[3]=console.info.bind(console),bb[4]=console.log.bind(console),bb[5]=console.debug.bind(console),bb[6]=console.debug.bind(console),bb);Xa=cb[2];Wa=cb[1];}function db(a,b){for(var c=[],d=q(a),e=d.next();!e.done;e=d.next())c.push(b(e.value));return c}function eb(a,b){for(var c=q(a),d=c.next();!d.done;d=c.next())if(!b(d.value))return !1;return !0}
var gb=function fb(a){var c;return Fa(fb,function(d){1==d.a&&(c=0);if(3!=d.a)return c<a?t(d,c,3):d.u(0);c++;return d.u(2)})},ib=function hb(a){var c,d,e,f,g,h;return Fa(hb,function(k){1==k.a&&(c=-1,e=d=void 0,f=q(a),g=f.next());if(5!=k.a){if(g.done)return -1==c?k.u(0):t(k,{Y:c,Oe:d,item:e,next:void 0},0);h=g.value;return 0<=c?t(k,{Y:c,item:e,Oe:d,next:h},5):k.u(5)}c++;d=e;e=h;g=f.next();return k.u(2)})};function jb(){}function kb(a,b){if(!a&&!b)return !0;if(!a||!b||a.byteLength!=b.byteLength)return !1;if(lb(a)==lb(b)&&(a.byteOffset||0)==(b.byteOffset||0))return !0;for(var c=L(a),d=L(b),e=q(gb(a.byteLength)),f=e.next();!f.done;f=e.next())if(f=f.value,c[f]!=d[f])return !1;return !0}function lb(a){return a instanceof ArrayBuffer?a:a.buffer}function mb(a){return a instanceof ArrayBuffer?a:0==a.byteOffset&&a.byteLength==a.buffer.byteLength?a.buffer:(new Uint8Array(a)).buffer}
function L(a,b,c){c=void 0===c?Infinity:c;return nb(a,void 0===b?0:b,c,Uint8Array)}function ob(a,b,c){c=void 0===c?Infinity:c;return nb(a,void 0===b?0:b,c,DataView)}function nb(a,b,c,d){var e=(a.byteOffset||0)+a.byteLength;b=Math.max(0,Math.min((a.byteOffset||0)+b,e));return new d(lb(a),b,Math.min(b+Math.max(c,0),e)-b)}K("shaka.util.BufferUtils",jb);jb.toDataView=ob;jb.toUint8=L;jb.toArrayBuffer=mb;jb.equal=kb;function M(a,b,c,d){for(var e=[],f=3;f<arguments.length;++f)e[f-3]=arguments[f];this.severity=a;this.category=b;this.code=c;this.data=e;this.handled=!1;}M.prototype.toString=function(){return "shaka.util.Error "+JSON.stringify(this,null,"  ")};K("shaka.util.Error",M);M.Severity={RECOVERABLE:1,CRITICAL:2};M.Category={NETWORK:1,TEXT:2,MEDIA:3,MANIFEST:4,STREAMING:5,DRM:6,PLAYER:7,CAST:8,STORAGE:9,ADS:10};
M.Code={UNSUPPORTED_SCHEME:1E3,BAD_HTTP_STATUS:1001,HTTP_ERROR:1002,TIMEOUT:1003,MALFORMED_DATA_URI:1004,REQUEST_FILTER_ERROR:1006,RESPONSE_FILTER_ERROR:1007,MALFORMED_TEST_URI:1008,UNEXPECTED_TEST_REQUEST:1009,ATTEMPTS_EXHAUSTED:1010,INVALID_TEXT_HEADER:2E3,INVALID_TEXT_CUE:2001,UNABLE_TO_DETECT_ENCODING:2003,BAD_ENCODING:2004,INVALID_XML:2005,INVALID_MP4_TTML:2007,INVALID_MP4_VTT:2008,UNABLE_TO_EXTRACT_CUE_START_TIME:2009,BUFFER_READ_OUT_OF_BOUNDS:3E3,JS_INTEGER_OVERFLOW:3001,EBML_OVERFLOW:3002,
EBML_BAD_FLOATING_POINT_SIZE:3003,MP4_SIDX_WRONG_BOX_TYPE:3004,MP4_SIDX_INVALID_TIMESCALE:3005,MP4_SIDX_TYPE_NOT_SUPPORTED:3006,WEBM_CUES_ELEMENT_MISSING:3007,WEBM_EBML_HEADER_ELEMENT_MISSING:3008,WEBM_SEGMENT_ELEMENT_MISSING:3009,WEBM_INFO_ELEMENT_MISSING:3010,WEBM_DURATION_ELEMENT_MISSING:3011,WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING:3012,WEBM_CUE_TIME_ELEMENT_MISSING:3013,MEDIA_SOURCE_OPERATION_FAILED:3014,MEDIA_SOURCE_OPERATION_THREW:3015,VIDEO_ERROR:3016,QUOTA_EXCEEDED_ERROR:3017,TRANSMUXING_FAILED:3018,
UNABLE_TO_GUESS_MANIFEST_TYPE:4E3,DASH_INVALID_XML:4001,DASH_NO_SEGMENT_INFO:4002,DASH_EMPTY_ADAPTATION_SET:4003,DASH_EMPTY_PERIOD:4004,DASH_WEBM_MISSING_INIT:4005,DASH_UNSUPPORTED_CONTAINER:4006,DASH_PSSH_BAD_ENCODING:4007,DASH_NO_COMMON_KEY_SYSTEM:4008,DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED:4009,DASH_CONFLICTING_KEY_IDS:4010,RESTRICTIONS_CANNOT_BE_MET:4012,HLS_PLAYLIST_HEADER_MISSING:4015,INVALID_HLS_TAG:4016,HLS_INVALID_PLAYLIST_HIERARCHY:4017,DASH_DUPLICATE_REPRESENTATION_ID:4018,HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND:4020,
HLS_COULD_NOT_GUESS_MIME_TYPE:4021,HLS_MASTER_PLAYLIST_NOT_PROVIDED:4022,HLS_REQUIRED_ATTRIBUTE_MISSING:4023,HLS_REQUIRED_TAG_MISSING:4024,HLS_COULD_NOT_GUESS_CODECS:4025,HLS_KEYFORMATS_NOT_SUPPORTED:4026,DASH_UNSUPPORTED_XLINK_ACTUATE:4027,DASH_XLINK_DEPTH_LIMIT:4028,HLS_COULD_NOT_PARSE_SEGMENT_START_TIME:4030,CONTENT_UNSUPPORTED_BY_BROWSER:4032,CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM:4033,HLS_AES_128_ENCRYPTION_NOT_SUPPORTED:4034,HLS_INTERNAL_SKIP_STREAM:4035,NO_VARIANTS:4036,PERIOD_FLATTENING_FAILED:4037,
INCONSISTENT_DRM_ACROSS_PERIODS:4038,HLS_VARIABLE_NOT_FOUND:4039,STREAMING_ENGINE_STARTUP_INVALID_STATE:5006,NO_RECOGNIZED_KEY_SYSTEMS:6E3,REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE:6001,FAILED_TO_CREATE_CDM:6002,FAILED_TO_ATTACH_TO_VIDEO:6003,INVALID_SERVER_CERTIFICATE:6004,FAILED_TO_CREATE_SESSION:6005,FAILED_TO_GENERATE_LICENSE_REQUEST:6006,LICENSE_REQUEST_FAILED:6007,LICENSE_RESPONSE_REJECTED:6008,ENCRYPTED_CONTENT_WITHOUT_DRM_INFO:6010,NO_LICENSE_SERVER_GIVEN:6012,OFFLINE_SESSION_REMOVED:6013,EXPIRED:6014,
SERVER_CERTIFICATE_REQUIRED:6015,INIT_DATA_TRANSFORM_ERROR:6016,LOAD_INTERRUPTED:7E3,OPERATION_ABORTED:7001,NO_VIDEO_ELEMENT:7002,OBJECT_DESTROYED:7003,CAST_API_UNAVAILABLE:8E3,NO_CAST_RECEIVERS:8001,ALREADY_CASTING:8002,UNEXPECTED_CAST_ERROR:8003,CAST_CANCELED_BY_USER:8004,CAST_CONNECTION_TIMED_OUT:8005,CAST_RECEIVER_APP_UNAVAILABLE:8006,STORAGE_NOT_SUPPORTED:9E3,INDEXED_DB_ERROR:9001,DEPRECATED_OPERATION_ABORTED:9002,REQUESTED_ITEM_NOT_FOUND:9003,MALFORMED_OFFLINE_URI:9004,CANNOT_STORE_LIVE_OFFLINE:9005,
NO_INIT_DATA_FOR_OFFLINE:9007,LOCAL_PLAYER_INSTANCE_REQUIRED:9008,NEW_KEY_OPERATION_NOT_SUPPORTED:9011,KEY_NOT_FOUND:9012,MISSING_STORAGE_CELL:9013,CS_IMA_SDK_MISSING:1E4,CS_AD_MANAGER_NOT_INITIALIZED:10001,SS_IMA_SDK_MISSING:10002,SS_AD_MANAGER_NOT_INITIALIZED:10003,CURRENT_DAI_REQUEST_NOT_FINISHED:10004};/*
 @license
 Copyright 2008 The Closure Library Authors
 SPDX-License-Identifier: Apache-2.0
*/
var pb=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;/*
 @license
 Copyright 2006 The Closure Library Authors
 SPDX-License-Identifier: Apache-2.0
*/
function qb(a){var b;a instanceof qb?(rb(this,a.va),this.Za=a.Za,this.ua=a.ua,sb(this,a.qb),this.ja=a.ja,tb(this,a.a.clone()),this.Qa=a.Qa):a&&(b=String(a).match(pb))?(rb(this,b[1]||"",!0),this.Za=ub(b[2]||""),this.ua=ub(b[3]||"",!0),sb(this,b[4]),this.ja=ub(b[5]||"",!0),tb(this,b[6]||"",!0),this.Qa=ub(b[7]||"")):this.a=new vb(null);}p=qb.prototype;p.va="";p.Za="";p.ua="";p.qb=null;p.ja="";p.Qa="";
p.toString=function(){var a=[],b=this.va;b&&a.push(wb(b,xb,!0),":");if(b=this.ua){a.push("//");var c=this.Za;c&&a.push(wb(c,xb,!0),"@");a.push(encodeURIComponent(b).replace(/%25([0-9a-fA-F]{2})/g,"%$1"));b=this.qb;null!=b&&a.push(":",String(b));}if(b=this.ja)this.ua&&"/"!=b.charAt(0)&&a.push("/"),a.push(wb(b,"/"==b.charAt(0)?yb:zb,!0));(b=this.a.toString())&&a.push("?",b);(b=this.Qa)&&a.push("#",wb(b,Ab));return a.join("")};
p.resolve=function(a){var b=this.clone();"data"===b.va&&(b=new qb);var c=!!a.va;c?rb(b,a.va):c=!!a.Za;c?b.Za=a.Za:c=!!a.ua;c?b.ua=a.ua:c=null!=a.qb;var d=a.ja;if(c)sb(b,a.qb);else if(c=!!a.ja){if("/"!=d.charAt(0))if(this.ua&&!this.ja)d="/"+d;else {var e=b.ja.lastIndexOf("/");-1!=e&&(d=b.ja.substr(0,e+1)+d);}if(".."==d||"."==d)d="";else if(-1!=d.indexOf("./")||-1!=d.indexOf("/.")){e=0==d.lastIndexOf("/",0);d=d.split("/");for(var f=[],g=0;g<d.length;){var h=d[g++];"."==h?e&&g==d.length&&f.push(""):".."==
h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),e&&g==d.length&&f.push("")):(f.push(h),e=!0);}d=f.join("/");}}c?b.ja=d:c=""!==a.a.toString();c?tb(b,a.a.clone()):c=!!a.Qa;c&&(b.Qa=a.Qa);return b};p.clone=function(){return new qb(this)};function rb(a,b,c){a.va=c?ub(b,!0):b;a.va&&(a.va=a.va.replace(/:$/,""));}function sb(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.qb=b;}else a.qb=null;}function tb(a,b,c){b instanceof vb?a.a=b:(c||(b=wb(b,Bb)),a.a=new vb(b));}
function ub(a,b){return a?b?decodeURI(a):decodeURIComponent(a):""}function wb(a,b,c){return null!=a?(a=encodeURI(a).replace(b,Cb),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Cb(a){a=a.charCodeAt(0);return "%"+(a>>4&15).toString(16)+(a&15).toString(16)}var xb=/[#\/\?@]/g,zb=/[#\?:]/g,yb=/[#\?]/g,Bb=/[#\?@]/g,Ab=/#/g;function vb(a){this.a=a||null;}p=vb.prototype;p.ga=null;p.hc=null;
p.add=function(a,b){if(!this.ga&&(this.ga={},this.hc=0,this.a))for(var c=this.a.split("&"),d=0;d<c.length;d++){var e=c[d].indexOf("="),f=null;if(0<=e){var g=c[d].substring(0,e);f=c[d].substring(e+1);}else g=c[d];g=decodeURIComponent(g.replace(/\+/g," "));f=f||"";this.add(g,decodeURIComponent(f.replace(/\+/g," ")));}this.a=null;(c=this.ga.hasOwnProperty(a)&&this.ga[a])||(this.ga[a]=c=[]);c.push(b);this.hc++;return this};
p.toString=function(){if(this.a)return this.a;if(!this.ga)return "";var a=[],b;for(b in this.ga)for(var c=encodeURIComponent(b),d=this.ga[b],e=0;e<d.length;e++){var f=c;""!==d[e]&&(f+="="+encodeURIComponent(d[e]));a.push(f);}return this.a=a.join("&")};p.clone=function(){var a=new vb;a.a=this.a;if(this.ga){var b={},c;for(c in this.ga)b[c]=this.ga[c].concat();a.ga=b;a.hc=this.hc;}return a};function Db(a,b){this.a=a;this.b=b;}Db.prototype.toString=function(){return "v"+this.a+"."+this.b};function Eb(a,b){var c=new Db(4,0),d=Fb,e=d.a,f=c.b-e.b;(0<(c.a-e.a||f)?d.c:d.b)(d.a,c,a,b);}function Gb(a,b,c,d){Xa([c,"has been deprecated and will be removed in",b,". We are currently at version",a,". Additional information:",d].join(" "));}function Hb(a,b,c,d){Wa([c,"has been deprecated and has been removed in",b,". We are now at version",a,". Additional information:",d].join(""));}var Fb=null;function Ib(a,b){return a.concat(b)}function Jb(){}function Kb(a){return null!=a}function Lb(a){var b=Object.create(a.prototype||Object.prototype);try{var c=a.call(b);c||(Eb("Factories requiring new","Factories should be plain functions"),c=b);}catch(d){Eb("Factories requiring new","Factories should be plain functions"),c=new a;}return c}function Mb(a,b){if(0==b.length)return a;var c=b.map(function(d){return new qb(d)});return a.map(function(d){return new qb(d)}).map(function(d){return c.map(function(e){return d.resolve(e)})}).reduce(Ib,[]).map(function(d){return d.toString()})}function Nb(a,b){return {keySystem:a,licenseServerUri:"",distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,initData:b||[],keyIds:new Set}}
var Ob={Da:"video",fb:"audio",$:"text",vf:"image",mf:"application"};function Pb(){var a,b,c=new Promise(function(d,e){a=d;b=e;});c.resolve=a;c.reject=b;return c}Pb.prototype.resolve=function(){};Pb.prototype.reject=function(){};function Rb(a){this.b=a;this.a=void 0;}Rb.prototype.value=function(){void 0==this.a&&(this.a=this.b());return this.a};function Sb(){}function Tb(a){if(!a)return "";a=L(a);239==a[0]&&187==a[1]&&191==a[2]&&(a=a.subarray(3));a=Ub(a);a=escape(a);try{return decodeURIComponent(a)}catch(b){throw new M(2,2,2004);}}function Vb(a,b,c){if(!a)return "";if(!c&&0!=a.byteLength%2)throw new M(2,2,2004);var d=Math.floor(a.byteLength/2);c=new Uint16Array(d);a=ob(a);d=q(gb(d));for(var e=d.next();!e.done;e=d.next())e=e.value,c[e]=a.getUint16(2*e,b);return Ub(c)}
function Wb(a){function b(d){return c.byteLength<=d||32<=c[d]&&126>=c[d]}if(!a)return "";var c=L(a);if(239==c[0]&&187==c[1]&&191==c[2])return Tb(c);if(254==c[0]&&255==c[1])return Vb(c.subarray(2),!1);if(255==c[0]&&254==c[1])return Vb(c.subarray(2),!0);if(0==c[0]&&0==c[2])return Vb(a,!1);if(0==c[1]&&0==c[3])return Vb(a,!0);if(b(0)&&b(1)&&b(2)&&b(3))return Tb(a);throw new M(2,2,2003);}
function Xb(a){a=encodeURIComponent(a);var b=unescape(a);a=new Uint8Array(b.length);b=q(ib(b));for(var c=b.next();!c.done;c=b.next())c=c.value,a[c.Y]=c.item.charCodeAt(0);return mb(a)}function Yb(a,b){for(var c=new ArrayBuffer(2*a.length),d=new DataView(c),e=q(ib(a)),f=e.next();!f.done;f=e.next())f=f.value,d.setUint16(2*f.Y,f.item.charCodeAt(0),b);return c}function Ub(a){return Zb.value()(a)}K("shaka.util.StringUtils",Sb);Sb.resetFromCharCode=function(){Zb.a=void 0;};Sb.toUTF16=Yb;Sb.toUTF8=Xb;
Sb.fromBytesAutoDetect=Wb;Sb.fromUTF16=Vb;Sb.fromUTF8=Tb;var Zb=new Rb(function(){function a(c){try{var d=new Uint8Array(c);return 0<String.fromCharCode.apply(null,d).length}catch(e){return !1}}for(var b={Ja:65536};0<b.Ja;b={Ja:b.Ja},b.Ja/=2)if(a(b.Ja))return function(c){return function(d){for(var e="",f=0;f<d.length;f+=c.Ja)e+=String.fromCharCode.apply(null,d.subarray(f,f+c.Ja));return e}}(b);return null});function $b(){}function ac(a){a=Ub(L(a));return btoa(a)}function bc(a,b){b=void 0==b?!0:b;var c=ac(a).replace(/\+/g,"-").replace(/\//g,"_");return b?c:c.replace(/[=]*$/,"")}function cc(a){var b=window.atob(a.replace(/-/g,"+").replace(/_/g,"/"));a=new Uint8Array(b.length);b=q(ib(b));for(var c=b.next();!c.done;c=b.next())c=c.value,a[c.Y]=c.item.charCodeAt(0);return a}
function dc(a){var b=a.length/2,c=new Uint8Array(b);b=q(gb(b));for(var d=b.next();!d.done;d=b.next())d=d.value,c[d]=window.parseInt(a.substr(2*d,2),16);return c}function ec(a){var b=L(a);a="";b=q(b);for(var c=b.next();!c.done;c=b.next())c=c.value,c=c.toString(16),1==c.length&&(c="0"+c),a+=c;return a}
function fc(a){for(var b=[],c=0;c<arguments.length;++c)b[c]=arguments[c];var d=0,e=q(b);for(c=e.next();!c.done;c=e.next())d+=c.value.byteLength;d=new Uint8Array(d);e=0;b=q(b);for(c=b.next();!c.done;c=b.next())c=c.value,d.set(L(c),e),e+=c.byteLength;return d}K("shaka.util.Uint8ArrayUtils",$b);$b.concat=fc;$b.toHex=ec;$b.fromHex=dc;$b.fromBase64=cc;$b.toBase64=bc;$b.toStandardBase64=ac;
$b.equal=function(a,b){Eb("shaka.util.Uint8ArrayUtils.equal","Please use shaka.util.BufferUtils.equal instead.");return kb(a,b)};function gc(){var a=this;this.a=new muxjs.mp4.Transmuxer({keepOriginalTimestamps:!0});this.b=null;this.h=[];this.c=[];this.g=[];this.f=!1;this.a.on("data",function(b){a.c=b.captions;a.g=b.metadata;a.h.push(fc(b.initSegment,b.data));});this.a.on("done",function(){var b={data:fc.apply($b,ia(a.h)),captions:a.c,metadata:a.g};a.b.resolve(b);a.f=!1;});}gc.prototype.destroy=function(){this.a.dispose();this.a=null;return Promise.resolve()};
function hc(a,b){if(!window.muxjs||"mp2t"!=a.toLowerCase().split(";")[0].split("/")[1])return !1;if(b)return MediaSource.isTypeSupported(ic(b,a));var c=ic("audio",a),d=ic("video",a);return MediaSource.isTypeSupported(c)||MediaSource.isTypeSupported(d)}
function ic(a,b){var c=b.replace(/mp2t/i,"mp4");"audio"==a&&(c=c.replace("video","audio"));var d=/avc1\.(66|77|100)\.(\d+)/.exec(c);if(d){var e="avc1.",f=d[1],g=Number(d[2]);e=("66"==f?e+"4200":"77"==f?e+"4d00":e+"6400")+(g>>4).toString(16);e+=(g&15).toString(16);c=c.replace(d[0],e);}return c}function jc(a,b){a.f=!0;a.b=new Pb;a.h=[];a.c=[];a.g=[];var c=L(b);a.a.push(c);a.a.flush();a.f&&a.b.reject(new M(2,3,3018));return a.b}function kc(a){this.b=a;this.a=null;}kc.prototype.R=function(a){var b=this;this.stop();var c=!0,d=null;this.a=function(){window.clearTimeout(d);c=!1;};d=window.setTimeout(function(){c&&b.b();},1E3*a);return this};kc.prototype.stop=function(){this.a&&(this.a(),this.a=null);};function N(a){this.b=a;this.a=null;}N.prototype.Qb=function(){this.stop();this.b();return this};N.prototype.R=function(a){var b=this;this.stop();this.a=(new kc(function(){b.b();})).R(a);return this};N.prototype.ra=function(a){var b=this;this.stop();this.a=(new kc(function(){b.a.R(a);b.b();})).R(a);return this};N.prototype.stop=function(){this.a&&(this.a.stop(),this.a=null);};K("shaka.util.Timer",N);N.prototype.stop=N.prototype.stop;N.prototype.tickEvery=N.prototype.ra;N.prototype.tickAfter=N.prototype.R;
N.prototype.tickNow=N.prototype.Qb;function lc(a,b){var c=mc();this.j=null==a.maxAttempts?c.maxAttempts:a.maxAttempts;this.f=null==a.baseDelay?c.baseDelay:a.baseDelay;this.h=null==a.fuzzFactor?c.fuzzFactor:a.fuzzFactor;this.g=null==a.backoffFactor?c.backoffFactor:a.backoffFactor;this.a=0;this.b=this.f;if(this.c=void 0===b?!1:b)this.a=1;}
function nc(a){var b,c;return J(function(d){if(1==d.a){if(a.a>=a.j)if(a.c)a.a=1,a.b=a.f;else throw new M(2,7,1010);b=a.a;a.a++;if(0==b)return d["return"]();c=a.b*(1+(2*Math.random()-1)*a.h);return t(d,new Promise(function(e){(new N(e)).R(c/1E3);}),2)}a.b*=a.g;w(d);})}function mc(){return {maxAttempts:2,baseDelay:1E3,backoffFactor:2,fuzzFactor:.5,timeout:0}}function oc(a,b){this.promise=a;this.c=b;this.a=!1;}function pc(a){return new oc(Promise.reject(a),function(){return Promise.resolve()})}function qc(){var a=Promise.reject(new M(2,7,7001));a["catch"](function(){});return new oc(a,function(){return Promise.resolve()})}function rc(a){return new oc(Promise.resolve(a),function(){return Promise.resolve()})}function sc(a){return new oc(a,function(){return a["catch"](function(){})})}oc.prototype.abort=function(){this.a=!0;return this.c()};
function tc(a){return new oc(Promise.all(a.map(function(b){return b.promise})),function(){return Promise.all(a.map(function(b){return b.abort()}))})}oc.prototype["finally"]=function(a){this.promise.then(function(){return a(!0)},function(){return a(!1)});return this};
oc.prototype.U=function(a,b){function c(h){return function(k){if(e.a&&h)f.reject(g);else {var l=h?a:b;l?d=uc(l,k,f):(h?f.resolve:f.reject)(k);}}}function d(){f.reject(g);return e.abort()}var e=this,f=new Pb,g=new M(2,7,7001);this.promise.then(c(!0),c(!1));return new oc(f,function(){return d()})};
function uc(a,b,c){try{var d=a(b);if(d&&d.promise&&d.abort)return c.resolve(d.promise),function(){return d.abort()};c.resolve(d);return function(){return Promise.resolve(d).then(function(){},function(){})}}catch(e){return c.reject(e),function(){return Promise.resolve()}}}K("shaka.util.AbortableOperation",oc);oc.prototype.chain=oc.prototype.U;oc.prototype["finally"]=oc.prototype["finally"];oc.all=tc;oc.prototype.abort=oc.prototype.abort;oc.notAbortable=sc;oc.completed=rc;oc.aborted=qc;oc.failed=pc;function Q(a,b){b=void 0===b?{}:b;for(var c in b)Object.defineProperty(this,c,{value:b[c],writable:!0,enumerable:!0});this.defaultPrevented=this.cancelable=this.bubbles=!1;this.timeStamp=window.performance&&window.performance.now?window.performance.now():Date.now();this.type=a;this.isTrusted=!1;this.target=this.currentTarget=null;this.a=!1;}Q.prototype.preventDefault=function(){this.cancelable&&(this.defaultPrevented=!0);};Q.prototype.stopImmediatePropagation=function(){this.a=!0;};
Q.prototype.stopPropagation=function(){};K("shaka.util.FakeEvent",Q);function vc(){this.a={};}vc.prototype.push=function(a,b){this.a.hasOwnProperty(a)?this.a[a].push(b):this.a[a]=[b];};vc.prototype.get=function(a){return (a=this.a[a])?a.slice():null};vc.prototype.remove=function(a,b){a in this.a&&(this.a[a]=this.a[a].filter(function(c){return c!=b}));};function wc(a,b){for(var c in a.a)b(c,a.a[c]);}function xc(){this.Mc=new vc;this.$b=this;}xc.prototype.addEventListener=function(a,b){this.Mc.push(a,b);};xc.prototype.removeEventListener=function(a,b){this.Mc.remove(a,b);};xc.prototype.dispatchEvent=function(a){var b=this.Mc.get(a.type)||[];b=q(b);for(var c=b.next();!c.done;c=b.next()){c=c.value;a.target=this.$b;a.currentTarget=this.$b;try{c.handleEvent?c.handleEvent(a):c.call(this,a);}catch(d){}if(a.a)break}return a.defaultPrevented};function yc(a){function b(d){switch(typeof d){case "undefined":case "boolean":case "number":case "string":case "symbol":case "function":return d;default:if(!d||d.buffer&&d.buffer.constructor==ArrayBuffer)return d;if(c.has(d))return null;var e=d.constructor==Array;if(d.constructor!=Object&&!e)return null;c.add(d);var f=e?[]:{},g;for(g in d)f[g]=b(d[g]);e&&(f.length=d.length);return f}}var c=new Set;return b(a)}function zc(a){var b={},c;for(c in a)b[c]=a[c];return b}function Ac(a,b){return "number"===typeof a&&"number"===typeof b&&isNaN(a)&&isNaN(b)?!0:a===b}function Bc(a,b){var c=a.indexOf(b);-1<c&&a.splice(c,1);}function Cc(a,b,c){c||(c=Ac);if(a.length!=b.length)return !1;b=b.slice();var d={};a=q(a);for(var e=a.next();!e.done;d={Ac:d.Ac},e=a.next()){d.Ac=e.value;e=b.findIndex(function(f){return function(g){return c(f.Ac,g)}}(d));if(-1==e)return !1;b[e]=b[b.length-1];b.pop();}return 0==b.length}
function Dc(a,b,c){c||(c=Ac);if(a.length!=b.length)return !1;for(var d=0;d<a.length;d++)if(!c(a[d],b[d]))return !1;return !0}function Ec(){this.a=[];}function Fc(a,b){a.a.push(b["finally"](function(){Bc(a.a,b);}));}Ec.prototype.destroy=function(){for(var a=[],b=q(this.a),c=b.next();!c.done;c=b.next())c=c.value,c.promise["catch"](function(){}),a.push(c.abort());this.a=[];return Promise.all(a)};function Gc(a){xc.call(this);this.f=!1;this.g=new Ec;this.a=new Set;this.b=new Set;this.c=a||null;}pa(Gc,xc);function Hc(a,b,c){c=c||Ic;var d=Jc[a];if(!d||c>=d.priority)Jc[a]={priority:c,Ne:b};}p=Gc.prototype;p.Pe=function(a){this.a.add(a);};p.hf=function(a){this.a["delete"](a);};p.ge=function(){this.a.clear();};p.Qe=function(a){this.b.add(a);};p.jf=function(a){this.b["delete"](a);};p.he=function(){this.b.clear();};
function Kc(a,b){return {uris:a,method:"GET",body:null,headers:{},allowCrossSiteCredentials:!1,retryParameters:b,licenseRequestType:null,sessionId:null}}p.destroy=function(){this.f=!0;this.a.clear();this.b.clear();return this.g.destroy()};
p.request=function(a,b){var c=this,d=new Lc;if(this.f){var e=Promise.reject(new M(2,7,7001));e["catch"](function(){});return new Mc(e,function(){return Promise.resolve()},d)}b.method=b.method||"GET";b.headers=b.headers||{};b.retryParameters=b.retryParameters?yc(b.retryParameters):mc();b.uris=yc(b.uris);e=Nc(this,a,b);var f=e.U(function(){return Oc(c,a,b,new lc(b.retryParameters,!1),0,null,d)}),g=f.U(function(n){return Pc(c,a,n)}),h=Date.now(),k=0;e.promise.then(function(){k=Date.now()-h;},function(){});
var l=0;f.promise.then(function(){l=Date.now();},function(){});var m=g.U(function(n){var r=Date.now()-l,u=n.response;u.timeMs+=k;u.timeMs+=r;n.Fe||!c.c||u.fromCache||a!=Qc||c.c(u.timeMs,u.data.byteLength);return u},function(n){n&&(n.severity=2);throw n;});e=new Mc(m.promise,function(){return m.abort()},d);Fc(this.g,e);return e};
function Nc(a,b,c){var d=rc(void 0),e={};a=q(a.a);for(var f=a.next();!f.done;e={Ec:e.Ec},f=a.next())e.Ec=f.value,d=d.U(function(g){return function(){c.body&&(c.body=mb(c.body));return g.Ec(b,c)}}(e));return d.U(void 0,function(g){if(g instanceof M&&7001==g.code)throw g;throw new M(2,1,1006,g);})}
function Oc(a,b,c,d,e,f,g){var h=new qb(c.uris[e]),k=h.va,l=!1;k||(k=location.protocol,k=k.slice(0,-1),rb(h,k),c.uris[e]=h.toString());k=k.toLowerCase();var m=(k=Jc[k])?k.Ne:null;if(!m)return pc(new M(2,1,1E3,h));var n;return sc(nc(d)).U(function(){if(a.f)return qc();n=Date.now();return m(c.uris[e],c,b,function(r,u,v){a.c&&b==Qc&&(a.c(r,u),l=!0,g.a=v);})}).U(function(r){void 0==r.timeMs&&(r.timeMs=Date.now()-n);return {response:r,Fe:l}},function(r){if(a.f)return qc();if(r instanceof M){if(7001==r.code)throw r;
if(1010==r.code)throw f;if(1==r.severity){var u=new Q("retry",{error:r});a.dispatchEvent(u);e=(e+1)%c.uris.length;return Oc(a,b,c,d,e,r,g)}}throw r;})}
function Pc(a,b,c){var d=rc(void 0),e={};a=q(a.b);for(var f=a.next();!f.done;e={Fc:e.Fc},f=a.next())e.Fc=f.value,d=d.U(function(g){return function(){var h=c.response;h.data&&(h.data=mb(h.data));return g.Fc(b,h)}}(e));return d.U(function(){return c},function(g){var h=2;if(g instanceof M){if(7001==g.code)throw g;h=g.severity;}throw new M(h,1,1007,g);})}K("shaka.net.NetworkingEngine",Gc);Gc.prototype.request=Gc.prototype.request;Gc.prototype.destroy=Gc.prototype.destroy;Gc.makeRequest=Kc;
Gc.defaultRetryParameters=function(){return mc()};Gc.prototype.clearAllResponseFilters=Gc.prototype.he;Gc.prototype.unregisterResponseFilter=Gc.prototype.jf;Gc.prototype.registerResponseFilter=Gc.prototype.Qe;Gc.prototype.clearAllRequestFilters=Gc.prototype.ge;Gc.prototype.unregisterRequestFilter=Gc.prototype.hf;Gc.prototype.registerRequestFilter=Gc.prototype.Pe;Gc.unregisterScheme=function(a){delete Jc[a];};Gc.registerScheme=Hc;function Lc(){this.a=0;}Gc.NumBytesRemainingClass=Lc;
function Mc(a,b,c){oc.call(this,a,b);this.b=c;}pa(Mc,oc);Gc.PendingRequest=Mc;var Qc=1;Gc.RequestType={MANIFEST:0,SEGMENT:Qc,LICENSE:2,APP:3,TIMING:4};var Ic=3;Gc.PluginPriority={FALLBACK:1,PREFERRED:2,APPLICATION:Ic};var Jc={};function Rc(a){this.a=!1;this.b=new Pb;this.c=a;}Rc.prototype.destroy=function(){var a=this;if(this.a)return this.b;this.a=!0;return this.c().then(function(){a.b.resolve();},function(){a.b.resolve();})};function Sc(a,b){if(a.a){if(b instanceof M&&7003==b.code)throw b;throw new M(2,7,7003,b);}}function Tc(){this.a=new vc;}p=Tc.prototype;p.release=function(){this.Xa();this.a=null;};p.l=function(a,b,c,d){this.a&&(a=new Uc(a,b,c,d),this.a.push(b,a));};p.ha=function(a,b,c,d){function e(g){f.sa(a,b,e);c(g);}var f=this;this.l(a,b,e,d);};p.sa=function(a,b,c){if(this.a){var d=this.a.get(b)||[];d=q(d);for(var e=d.next();!e.done;e=d.next())e=e.value,e.target!=a||c!=e.listener&&c||(e.sa(),this.a.remove(b,e));}};
p.Xa=function(){if(this.a){var a=this.a,b=[],c;for(c in a.a)b.push.apply(b,ia(a.a[c]));a=q(b);for(b=a.next();!b.done;b=a.next())b.value.sa();this.a.a={};}};K("shaka.util.EventManager",Tc);Tc.prototype.removeAll=Tc.prototype.Xa;Tc.prototype.unlisten=Tc.prototype.sa;Tc.prototype.listenOnce=Tc.prototype.ha;Tc.prototype.listen=Tc.prototype.l;Tc.prototype.release=Tc.prototype.release;function Uc(a,b,c,d){this.target=a;this.type=b;this.listener=c;this.a=Vc(a,d);this.target.addEventListener(b,c,this.a);}
Uc.prototype.sa=function(){this.target.removeEventListener(this.type,this.listener,this.a);this.listener=this.target=null;this.a=!1;};function Vc(a,b){if(void 0==b)return !1;if("boolean"==typeof b)return b;var c=new Set(["passive","capture"]);Object.keys(b).filter(function(d){return !c.has(d)});return Wc(a)?b:b.capture||!1}
function Wc(a){var b=Xc;if(void 0==b){b=!1;try{var c={},d={get:function(){b=!0;return !1}};Object.defineProperty(c,"passive",d);Object.defineProperty(c,"capture",d);d=function(){};a.addEventListener("test",d,c);a.removeEventListener("test",d,c);}catch(e){b=!1;}Xc=b;}return b||!1}var Xc=void 0;function Yc(){}function Zc(a){a=Wb(a);return (new qb(a)).ua}function $c(a,b,c){function d(h){ob(f).setUint32(g,h.byteLength,!0);g+=4;f.set(L(h),g);g+=h.byteLength;}if(!c||!c.byteLength)throw new M(2,6,6015);var e;"string"==typeof b?e=Yb(b,!0):e=b;a=Wb(a);a=Yb(a,!0);var f=new Uint8Array(12+a.byteLength+e.byteLength+c.byteLength),g=0;d(a);d(e);d(c);return f}K("shaka.util.FairPlayUtils",Yc);Yc.initDataTransform=$c;Yc.defaultGetContentId=Zc;function ad(a){for(var b=new Map,c=q(Object.keys(a)),d=c.next();!d.done;d=c.next())d=d.value,b.set(d,a[d]);return b}function bd(a){var b={};a.forEach(function(c,d){b[d]=c;});return b}function cd(a,b){if(a||b){if(a&&!b||b&&!a)return !1}else return !0;if(a.size!=b.size)return !1;for(var c=q(a),d=c.next();!d.done;d=c.next()){var e=q(d.value);d=e.next().value;e=e.next().value;if(!b.has(d))return !1;d=b.get(d);if(d!=e||void 0==d)return !1}return !0}function dd(){}function ed(a,b){var c=a;b&&(c+='; codecs="'+b+'"');return c}function fd(a){var b=[a.mimeType];gd.forEach(function(c,d){var e=a[d];e&&b.push(c+'="'+e+'"');});return b.join(";")}function hd(a){a=a.split(".");var b=a[0];a.pop();return [b,a.join(".")]}var gd=(new Map).set("codecs","codecs").set("frameRate","framerate").set("bandwidth","bitrate").set("width","width").set("height","height").set("channelsCount","channels");function id(){return window.MediaSource&&MediaSource.isTypeSupported?!0:!1}function jd(a){return ""!=kd().canPlayType(a)}function ld(){return md("Tizen")}function nd(){return !!navigator.vendor&&navigator.vendor.includes("Apple")&&!ld()}function od(){if(!nd())return null;var a=navigator.userAgent.match(/Version\/(\d+)/);return a?parseInt(a[1],10):(a=navigator.userAgent.match(/OS (\d+)(?:_\d+)?/))?parseInt(a[1],10):null}function md(a){return (navigator.userAgent||"").includes(a)}
function kd(){if(pd)return pd;qd||(qd=new N(function(){pd=null;}));(pd=document.getElementsByTagName("video")[0]||document.getElementsByTagName("audio")[0])||(pd=document.createElement("video"));qd.R(1);return pd}var qd=null,pd=null;function rd(a,b){var c=this;b=void 0===b?1:b;this.s=a;this.m=new Set;this.a=this.h=null;this.M=!1;this.H=0;this.c=null;this.b=new Tc;this.f=new Map;this.v=[];this.j=new Pb;this.i=null;this.g=function(d){c.j.reject(d);a.onError(d);};this.ca=new Map;this.T=new Map;this.J=new N(function(){return sd(c)});this.A=!1;this.D=[];this.I=!1;this.W=(new N(function(){td(c);})).ra(b);this.j["catch"](function(){});this.F=new Rc(function(){return ud(c)});}rd.prototype.destroy=function(){return this.F.destroy()};
function ud(a){return J(function(b){switch(b.a){case 1:return a.b.release(),a.b=null,a.j.reject(),a.W.stop(),a.W=null,a.J.stop(),a.J=null,t(b,vd(a),2);case 2:if(!a.a){b.u(3);break}x(b,4);return t(b,a.a.setMediaKeys(null),6);case 6:ua(b,5);break;case 4:C(b);case 5:a.a=null;case 3:a.c=null,a.m.clear(),a.h=null,a.v=[],a.i=null,a.g=function(){},a.s=null,w(b);}})}rd.prototype.configure=function(a){this.i=a;};function wd(a,b,c){a.v=[];a.A=c;return xd(a,b)}
function yd(a,b,c){a.v=c;a.A=0<c.length;return xd(a,b)}function zd(a,b,c,d,e,f){var g=new Map;e={audioCapabilities:e,videoCapabilities:f,distinctiveIdentifier:"optional",persistentState:"required",sessionTypes:["persistent-license"],label:b};e.drmInfos=[{keySystem:b,licenseServerUri:c,distinctiveIdentifierRequired:!1,persistentStateRequired:!0,audioRobustness:"",videoRobustness:"",serverCertificate:d,initData:null,keyIds:null}];g.set(b,e);return Ad(a,g)}
function xd(a,b){var c=Bd(a);if(c)for(var d=q(b),e=d.next();!e.done;e=d.next())e=e.value,e.video&&(e.video.drmInfos=[c]),e.audio&&(e.audio.drmInfos=[c]);c=b.some(function(g){return g.video&&g.video.drmInfos.length||g.audio&&g.audio.drmInfos.length?!0:!1});c||(d=ad(a.i.servers),Cd(b,d));d=q(b);for(e=d.next();!e.done;e=d.next()){e=e.value;e=q((e.video?e.video.drmInfos:[]).concat(e.audio?e.audio.drmInfos:[]));for(var f=e.next();!f.done;f=e.next())Dd(f.value,ad(a.i.servers),ad(a.i.advanced||{}));}d=Ed(a,
b);if(!d.size)return a.M=!0,Promise.resolve();d=Ad(a,d);return c?d:d["catch"](function(){})}
rd.prototype.zb=function(a){var b=this,c,d;return J(function(e){if(1==e.a){if(!b.h)return b.b.ha(a,"encrypted",function(){b.g(new M(2,6,6010));}),e["return"]();b.a=a;b.b.ha(b.a,"play",function(){for(var f=q(b.D),g=f.next();!g.done;g=f.next())Fd(b,g.value);b.I=!0;b.D=[];});"webkitCurrentPlaybackTargetIsWireless"in b.a&&b.b.l(b.a,"webkitcurrentplaybacktargetiswirelesschanged",function(){return vd(b)});c=b.a.setMediaKeys(b.h);c=c["catch"](function(f){return Promise.reject(new M(2,6,6003,f.message))});
return t(e,c,2)}Sc(b.F);Gd(b);b.c.initData.length||b.v.length||(d=function(f){return Hd(b,f.initDataType,L(f.initData))},b.b.l(b.a,"encrypted",d));w(e);})};function Id(a){var b;return J(function(c){if(1==c.a){if(!(a.h&&a.c&&a.c.serverCertificate&&a.c.serverCertificate.length))return c.u(0);x(c,3);return t(c,a.h.setServerCertificate(a.c.serverCertificate),5)}if(3!=c.a)return ua(c,0);b=C(c);throw new M(2,6,6004,b.message);})}
function Jd(a,b){var c,d,e;return J(function(f){if(1==f.a)return t(f,Kd(a,b),2);c=f.b;if(!c)return f["return"]();d=[];if(e=a.f.get(c))e.Aa=new Pb,d.push(e.Aa);d.push(c.remove());return t(f,Promise.all(d),0)})}function Gd(a){for(var b=(a.c?a.c.initData:[])||[],c=q(b),d=c.next();!d.done;d=c.next())d=d.value,Hd(a,d.initDataType,d.initData);c=q(a.v);for(d=c.next();!d.done;d=c.next())Kd(a,d.value);b.length||a.v.length||a.j.resolve();return a.j}
function Hd(a,b,c){var d=a.f.values();d=q(d);for(var e=d.next();!e.done;e=d.next())if(kb(c,e.value.initData)&&!md("Tizen 2"))return;Ld(a,b,c);}function Md(a){return a?a.keySystem:""}function Nd(a,b){if(navigator.userAgent.match(/Edge\//))return !0;b=b.toLowerCase();if(ld()&&b.includes('codecs="ac-3"')){var c=b.replace("ac-3","ec-3");return a.m.has(b)||a.m.has(c)}return a.m.has(b)}function Od(a){a=a.f.keys();a=db(a,function(b){return b.sessionId});return Array.from(a)}
rd.prototype.Eb=function(){var a=Infinity,b=this.f.keys();b=q(b);for(var c=b.next();!c.done;c=b.next())c=c.value,isNaN(c.expiration)||(a=Math.min(a,c.expiration));return a};
function Ed(a,b){for(var c=new Set,d=q(b),e=d.next();!e.done;e=d.next()){e=e.value;var f=q((e.video?e.video.drmInfos:[]).concat(e.audio?e.audio.drmInfos:[]));for(e=f.next();!e.done;e=f.next())c.add(e.value);}d=q(c);for(e=d.next();!e.done;e=d.next())Dd(e.value,ad(a.i.servers),ad(a.i.advanced||{}));f=a.A?"required":"optional";var g=a.A?["persistent-license"]:["temporary"];d=new Map;c=q(c);for(e=c.next();!e.done;e=c.next())e=e.value,d.set(e.keySystem,{audioCapabilities:[],videoCapabilities:[],distinctiveIdentifier:"optional",
persistentState:f,sessionTypes:g,label:e.keySystem,drmInfos:[]});c=q(b);for(e=c.next();!e.done;e=c.next())for(e=e.value,f=q([e.audio,e.video]),e=f.next();!e.done;e=f.next())if(g=e.value){var h=Pd(g),k=null;"ac-3"==g.codecs.toLowerCase()&&ld()&&(k=Pd(g,"ec-3"));var l=q(g.drmInfos);for(e=l.next();!e.done;e=l.next()){var m=e.value;e=d.get(m.keySystem);e.drmInfos.push(m);m.distinctiveIdentifierRequired&&(e.distinctiveIdentifier="required");m.persistentStateRequired&&(e.persistentState="required");m="audio"==
g.type?m.audioRobustness:m.videoRobustness;var n={robustness:m||"",contentType:h};"audio"==g.type?e.audioCapabilities.push(n):e.videoCapabilities.push(n);k&&(m={robustness:m||"",contentType:k},"audio"==g.type?e.audioCapabilities.push(m):e.videoCapabilities.push(m));}}return d}function Pd(a,b){var c=ed(a.mimeType,b||a.codecs);return hc(c)?ic(a.type,c):c}
function Ad(a,b){var c,d,e,f,g,h,k,l,m,n,r,u,v,A,y,z,D,B,E,H,G,F;return J(function(I){switch(I.a){case 1:if(1==b.size&&b.has(""))throw new M(2,6,6E3);c=q(b.values());for(d=c.next();!d.done;d=c.next())e=d.value,0==e.audioCapabilities.length&&delete e.audioCapabilities,0==e.videoCapabilities.length&&delete e.videoCapabilities;g=q([!0,!1]);h=g.next();case 2:if(h.done){I.u(4);break}k=h.value;l=q(b.keys());m=l.next();case 5:if(m.done){I.u(7);break}n=m.value;r=b.get(n);u=r.drmInfos.some(function(O){return !!O.licenseServerUri});
if(u!=k){I.u(6);break}x(I,8);return t(I,navigator.requestMediaKeySystemAccess(n,[r]),10);case 10:f=I.b;I.u(7);break;case 8:C(I);case 9:Sc(a.F);case 6:m=l.next();I.u(5);break;case 7:if(f){I.u(4);break}h=g.next();I.u(2);break;case 4:if(!f)throw new M(2,6,6001);Sc(a.F);x(I,11);a.m.clear();v=f.getConfiguration();A=v.audioCapabilities||[];y=v.videoCapabilities||[];z=q(A);for(D=z.next();!D.done;D=z.next())B=D.value,a.m.add(B.contentType.toLowerCase());E=q(y);for(D=E.next();!D.done;D=E.next())H=D.value,
a.m.add(H.contentType.toLowerCase());a.c=Qd(f.keySystem,b.get(f.keySystem));if(!a.c.licenseServerUri)throw new M(2,6,6012,a.c.keySystem);return t(I,f.createMediaKeys(),13);case 13:return G=I.b,Sc(a.F),a.h=G,a.M=!0,t(I,Id(a),14);case 14:Sc(a.F);ua(I,0);break;case 11:F=C(I);Sc(a.F,F);a.c=null;a.m.clear();if(F instanceof M)throw F;throw new M(2,6,6002,F.message);}})}
function Bd(a){a=ad(a.i.clearKeys);if(0==a.size)return null;var b=[],c=[];a.forEach(function(e,f){var g=dc(f),h=dc(e);g={kty:"oct",kid:bc(g,!1),k:bc(h,!1)};b.push(g);c.push(g.kid);});a=JSON.stringify({keys:b});var d=JSON.stringify({kids:c});d=[{initData:L(Xb(d)),initDataType:"keyids"}];return {keySystem:"org.w3.clearkey",licenseServerUri:"data:application/json;base64,"+window.btoa(a),distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,
initData:d,keyIds:new Set(c)}}
function Kd(a,b){var c,d,e,f,g;return J(function(h){switch(h.a){case 1:try{c=a.h.createSession("persistent-license");}catch(k){return d=new M(2,6,6005,k.message),a.g(d),h["return"](Promise.reject(d))}a.b.l(c,"message",function(k){a.a&&a.i.delayLicenseRequestUntilPlayed&&a.a.paused&&!a.I?a.D.push(k):Fd(a,k);});a.b.l(c,"keystatuseschange",function(k){return Rd(a,k)});e={initData:null,loaded:!1,bd:Infinity,Aa:null};a.f.set(c,e);x(h,2);return t(h,c.load(b),4);case 4:f=h.b;Sc(a.F);if(!f)return a.f["delete"](c),
a.g(new M(2,6,6013)),h["return"](Promise.resolve());e.loaded=!0;Sd(a)&&a.j.resolve();return h["return"](c);case 2:g=C(h),Sc(a.F,g),a.f["delete"](c),a.g(new M(2,6,6005,g.message));case 3:return h["return"](Promise.resolve())}})}
function Ld(a,b,c){try{var d=a.A?a.h.createSession("persistent-license"):a.h.createSession();}catch(e){a.g(new M(2,6,6005,e.message));return}a.b.l(d,"message",function(e){a.a&&a.i.delayLicenseRequestUntilPlayed&&a.a.paused&&!a.I?a.D.push(e):Fd(a,e);});a.b.l(d,"keystatuseschange",function(e){return Rd(a,e)});a.f.set(d,{initData:c,loaded:!1,bd:Infinity,Aa:null});try{c=a.i.initDataTransform(c,b,a.c);}catch(e){b=e;e instanceof M||(b=new M(2,6,6016,e));a.g(b);return}a.i.logLicenseExchange&&bc(c);d.generateRequest(b,
c)["catch"](function(e){if(!a.F.a){a.f["delete"](d);var f=e.errorCode;if(f&&f.systemCode){var g=f.systemCode;0>g&&(g+=Math.pow(2,32));g="0x"+g.toString(16);}a.g(new M(2,6,6006,e.message,e,g));}});}function Td(a,b,c){"skd"==b&&(b=c.serverCertificate,c=Zc(a),a=$c(a,c,b));return a}
function Fd(a,b){var c,d,e,f,g,h,k,l,m,n,r,u,v,A;J(function(y){switch(y.a){case 1:return c=b.target,a.i.logLicenseExchange&&bc(b.message),d=a.f.get(c),e=a.c.licenseServerUri,f=a.i.advanced[a.c.keySystem],"individualization-request"==b.messageType&&f&&f.individualizationServer&&(e=f.individualizationServer),g=Kc([e],a.i.retryParameters),g.body=b.message,g.method="POST",g.licenseRequestType=b.messageType,g.sessionId=c.sessionId,"com.microsoft.playready"!=a.c.keySystem&&"com.chromecast.playready"!=a.c.keySystem||
Ud(g),h=Date.now(),x(y,2),l=a.s.nb.request(2,g),t(y,l.promise,4);case 4:k=y.b;ua(y,3);break;case 2:return m=C(y),n=new M(2,6,6007,m),a.g(n),d&&d.Aa&&d.Aa.reject(n),y["return"]();case 3:if(a.F.a)return y["return"]();a.H+=(Date.now()-h)/1E3;a.i.logLicenseExchange&&bc(k.data);x(y,5);return t(y,c.update(k.data),7);case 7:ua(y,6);break;case 5:return r=C(y),u=new M(2,6,6008,r.message),a.g(u),d&&d.Aa&&d.Aa.reject(u),y["return"]();case 6:v=new Q("drmsessionupdate"),a.s.onEvent(v),d&&(d.Aa&&d.Aa.resolve(),
A=new N(function(){d.loaded=!0;Sd(a)&&a.j.resolve();}),A.R(Vd)),w(y);}});}
function Ud(a){var b=Vb(a.body,!0,!0);if(b.includes("PlayReadyKeyMessage")){b=(new DOMParser).parseFromString(b,"application/xml");for(var c=q(b.getElementsByTagName("HttpHeader")),d=c.next();!d.done;d=c.next())d=d.value,a.headers[d.getElementsByTagName("name")[0].textContent]=d.getElementsByTagName("value")[0].textContent;a.body=cc(b.getElementsByTagName("Challenge")[0].textContent);}else a.headers["Content-Type"]="text/xml; charset=utf-8";}
function Rd(a,b){var c=b.target,d=a.f.get(c),e=!1;c.keyStatuses.forEach(function(g,h){if("string"==typeof h){var k=h;h=g;g=k;}if("com.microsoft.playready"==a.c.keySystem&&16==h.byteLength&&(md("Trident/")||navigator.userAgent.match(/Edge?\//))){k=ob(h);var l=k.getUint32(0,!0),m=k.getUint16(4,!0),n=k.getUint16(6,!0);k.setUint32(0,l,!1);k.setUint16(4,m,!1);k.setUint16(6,n,!1);}"com.microsoft.playready"==a.c.keySystem&&"status-pending"==g&&(g="usable");"status-pending"!=g&&(d.loaded=!0);"expired"==g&&
(e=!0);k=ec(h);a.ca.set(k,g);});var f=c.expiration-Date.now();(0>f||e&&1E3>f)&&d&&!d.Aa&&(a.f["delete"](c),c.close()["catch"](function(){}));Sd(a)&&(a.j.resolve(),a.J.R(Wd));}function sd(a){var b=a.ca,c=a.T;c.clear();b.forEach(function(d,e){return c.set(e,d)});b=Array.from(c.values());b.length&&b.every(function(d){return "expired"==d})&&a.g(new M(2,6,6014));a.s.oc(bd(c));}
function Xd(){var a,b,c,d,e,f,g,h;return J(function(k){return 1==k.a?(a="org.w3.clearkey com.widevine.alpha com.microsoft.playready com.apple.fps.3_0 com.apple.fps.2_0 com.apple.fps.1_0 com.apple.fps com.adobe.primetime".split(" "),b=[{contentType:'video/mp4; codecs="avc1.42E01E"'},{contentType:'video/webm; codecs="vp8"'}],c={videoCapabilities:b},d={videoCapabilities:b,persistentState:"required",sessionTypes:["persistent-license"]},e=[d,c],f=new Map,g=function(l){var m,n,r;return J(function(u){switch(u.a){case 1:return x(u,
2),t(u,navigator.requestMediaKeySystemAccess(l,e),4);case 4:return m=u.b,r=(n=m.getConfiguration().sessionTypes)?n.includes("persistent-license"):!1,md("Tizen 3")&&(r=!1),f.set(l,{persistentState:r}),t(u,m.createMediaKeys(),5);case 5:ua(u,0);break;case 2:C(u),f.set(l,null),w(u);}})},h=a.map(function(l){return g(l)}),t(k,Promise.all(h),2)):k["return"](bd(f))})}
function Yd(a){var b;return J(function(c){if(1==c.a)return b=new Promise(function(d,e){(new N(e)).R(Zd);}),x(c,2),t(c,Promise.race([Promise.all([a.close(),a.closed]),b]),4);if(2!=c.a)return ua(c,0);C(c);w(c);})}function vd(a){var b;return J(function(c){b=Array.from(a.f.keys());a.f.clear();return t(c,Promise.all(b.map(function(d){return J(function(e){if(1==e.a)return x(e,2),t(e,Yd(d),4);if(2!=e.a)return ua(e,0);C(e);w(e);})})),0)})}
function $d(a,b){var c=b.audio,d=b.video;if(c&&c.encrypted){var e=Pd(c);if(!Nd(a,e))return !1}if(d&&d.encrypted&&(e=Pd(d),!Nd(a,e)))return !1;var f=Md(a.c);c=(d?d.drmInfos:[]).concat(c?c.drmInfos:[]);return 0==c.length||c.some(function(g){return g.keySystem==f})}
function ae(a,b){if(!a.length)return b;if(!b.length)return a;for(var c=[],d=q(a),e=d.next();!e.done;e=d.next()){e=e.value;for(var f=q(b),g=f.next();!g.done;g=f.next())if(g=g.value,e.keySystem==g.keySystem){f=[];f=f.concat(e.initData||[]);f=f.concat(g.initData||[]);var h=e.keyIds&&g.keyIds?new Set(ia(e.keyIds).concat(ia(g.keyIds))):e.keyIds||g.keyIds;c.push({keySystem:e.keySystem,licenseServerUri:e.licenseServerUri||g.licenseServerUri,distinctiveIdentifierRequired:e.distinctiveIdentifierRequired||
g.distinctiveIdentifierRequired,persistentStateRequired:e.persistentStateRequired||g.persistentStateRequired,videoRobustness:e.videoRobustness||g.videoRobustness,audioRobustness:e.audioRobustness||g.audioRobustness,serverCertificate:e.serverCertificate||g.serverCertificate,initData:f,keyIds:h});break}}return c}function td(a){a.f.forEach(function(b,c){var d=b.bd,e=c.expiration;isNaN(e)&&(e=Infinity);e!=d&&(a.s.onExpirationUpdated(c.sessionId,e),b.bd=e);});}
function Sd(a){a=a.f.values();return eb(a,function(b){return b.loaded})}function Cd(a,b){var c=[];b.forEach(function(f,g){c.push({keySystem:g,licenseServerUri:f,distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,initData:[],keyIds:new Set});});for(var d=q(a),e=d.next();!e.done;e=d.next())e=e.value,e.video&&(e.video.drmInfos=c),e.audio&&(e.audio.drmInfos=c);}
function Qd(a,b){var c=[],d=[],e=[],f=new Set;be(b.drmInfos,c,d,e,f);return {keySystem:a,licenseServerUri:c[0],distinctiveIdentifierRequired:"required"==b.distinctiveIdentifier,persistentStateRequired:"required"==b.persistentState,audioRobustness:(b.audioCapabilities?b.audioCapabilities[0].robustness:"")||"",videoRobustness:(b.videoCapabilities?b.videoCapabilities[0].robustness:"")||"",serverCertificate:d[0],initData:e,keyIds:f}}
function be(a,b,c,d,e){var f={};a=q(a);for(var g=a.next();!g.done;f={na:f.na},g=a.next()){f.na=g.value;b.includes(f.na.licenseServerUri)||b.push(f.na.licenseServerUri);f.na.serverCertificate&&(c.some(function(l){return function(m){return kb(m,l.na.serverCertificate)}}(f))||c.push(f.na.serverCertificate));if(f.na.initData){g={};for(var h=q(f.na.initData),k=h.next();!k.done;g={Ub:g.Ub},k=h.next())g.Ub=k.value,d.some(function(l){return function(m){var n=l.Ub;return m.keyId&&m.keyId==n.keyId?!0:m.initDataType==
n.initDataType&&kb(m.initData,n.initData)}}(g))||d.push(g.Ub);}if(f.na.keyIds)for(g=q(f.na.keyIds),h=g.next();!h.done;h=g.next())e.add(h.value);}}
function Dd(a,b,c){if(a.keySystem&&("org.w3.clearkey"!=a.keySystem||!a.licenseServerUri)){b.size&&(b=b.get(a.keySystem)||"",a.licenseServerUri=b);a.keyIds||(a.keyIds=new Set);if(c=c.get(a.keySystem))a.distinctiveIdentifierRequired||(a.distinctiveIdentifierRequired=c.distinctiveIdentifierRequired),a.persistentStateRequired||(a.persistentStateRequired=c.persistentStateRequired),a.videoRobustness||(a.videoRobustness=c.videoRobustness),a.audioRobustness||(a.audioRobustness=c.audioRobustness),a.serverCertificate||
(a.serverCertificate=c.serverCertificate);window.cast&&window.cast.__platform__&&"com.microsoft.playready"==a.keySystem&&(a.keySystem="com.chromecast.playready");}}var Zd=1,Vd=5,Wd=.5,ce=new Rb(function(){return mb(new Uint8Array([0]))});function de(){this.a=new muxjs.mp4.CaptionParser;this.g=[];this.f={};}de.prototype.init=function(a){var b=muxjs.mp4.probe;a=L(a);this.g=b.videoTrackIds(a);this.f=b.timescale(a);this.a.init();};de.prototype.b=function(a,b){var c=L(a);(c=this.a.parse(c,this.g,this.f))&&c.captions&&b(c.captions);this.a.clearParsedCaptions();};de.prototype.c=function(){this.a.resetCaptionStream();};function ee(){}ee.prototype.init=function(){};ee.prototype.b=function(){};ee.prototype.c=function(){};function fe(a){return !a||1==a.length&&1E-6>a.end(0)-a.start(0)?null:a.length?a.end(a.length-1):null}function ge(a,b,c){c=void 0===c?0:c;return !a||!a.length||1==a.length&&1E-6>a.end(0)-a.start(0)||b>a.end(a.length-1)?!1:b+c>=a.start(0)}function he(a,b){if(!a||!a.length||1==a.length&&1E-6>a.end(0)-a.start(0))return 0;for(var c=0,d=q(ie(a)),e=d.next();!e.done;e=d.next()){var f=e.value;e=f.start;f=f.end;f>b&&(c+=f-Math.max(e,b));}return c}
function je(a,b){if(!a||!a.length||1==a.length&&1E-6>a.end(0)-a.start(0))return null;var c=navigator.userAgent.match(/Edge\//)||md("Trident/")||ld()||md("CrKey")?.5:.1,d=ie(a).findIndex(function(e,f,g){return e.start>b&&(0==f||g[f-1].end-b<=c)});return 0<=d?d:null}function ie(a){if(!a)return [];for(var b=[],c=q(gb(a.length)),d=c.next();!d.done;d=c.next())d=d.value,b.push({start:a.start(d),end:a.end(d)});return b}function ke(a,b,c){this.startTime=a;this.direction=le;this.endTime=b;this.payload=c;this.region=new me;this.position=null;this.positionAlign=ne;this.size=0;this.textAlign=oe;this.writingMode=pe;this.lineInterpretation=qe;this.line=null;this.lineHeight="";this.lineAlign=re;this.displayAlign=se;this.fontSize=this.border=this.backgroundImage=this.backgroundColor=this.color="";this.fontWeight=te;this.fontStyle=ue;this.linePadding=this.letterSpacing=this.fontFamily="";this.opacity=1;this.textDecoration=
[];this.wrapLine=!0;this.id="";this.nestedCues=[];this.spacer=!1;this.cellResolution={columns:32,rows:15};}ke.prototype.clone=function(){var a=new ke(0,0,""),b;for(b in this)a[b]=this[b],a[b]&&a[b].constructor==Array&&(a[b]=a[b].slice());return a};
function ve(a,b){if(a.startTime!=b.startTime||a.endTime!=b.endTime||a.payload!=b.payload)return !1;for(var c in a)if("startTime"!=c&&"endTime"!=c&&"payload"!=c)if("nestedCues"==c){if(!Dc(a.nestedCues,b.nestedCues,ve))return !1}else if("region"==c||"cellResolution"==c)for(var d in a[c]){if(a[c][d]!=b[c][d])return !1}else if(Array.isArray(a[c])){if(!Dc(a[c],b[c]))return !1}else if(a[c]!=b[c])return !1;return !0}K("shaka.text.Cue",ke);var ne="auto";
ke.positionAlign={LEFT:"line-left",RIGHT:"line-right",CENTER:"center",AUTO:ne};var oe="center",we={LEFT:"left",RIGHT:"right",CENTER:oe,START:"start",END:"end"};ke.textAlign=we;var se="after",xe={BEFORE:"before",CENTER:"center",AFTER:se};ke.displayAlign=xe;var le="ltr";ke.direction={HORIZONTAL_LEFT_TO_RIGHT:le,HORIZONTAL_RIGHT_TO_LEFT:"rtl"};var pe="horizontal-tb";ke.writingMode={HORIZONTAL_TOP_TO_BOTTOM:pe,VERTICAL_LEFT_TO_RIGHT:"vertical-lr",VERTICAL_RIGHT_TO_LEFT:"vertical-rl"};var qe=0;
ke.lineInterpretation={LINE_NUMBER:qe,PERCENTAGE:1};var re="start",ye={CENTER:"center",START:re,END:"end"};ke.lineAlign=ye;var te=400;ke.fontWeight={NORMAL:te,BOLD:700};var ue="normal",Ae={NORMAL:ue,ITALIC:"italic",OBLIQUE:"oblique"};ke.fontStyle=Ae;ke.textDecoration={UNDERLINE:"underline",LINE_THROUGH:"lineThrough",OVERLINE:"overline"};
function me(){this.id="";this.regionAnchorY=this.regionAnchorX=this.viewportAnchorY=this.viewportAnchorX=0;this.height=this.width=100;this.viewportAnchorUnits=this.widthUnits=this.heightUnits=Be;this.scroll=Ce;}K("shaka.text.CueRegion",me);var Be=1;me.units={PX:0,PERCENTAGE:Be,LINES:2};var Ce="";me.scrollMode={NONE:Ce,UP:"up"};function De(a){this.m=null;this.c=a;this.f=this.v=0;this.g=Infinity;this.b=this.a=null;this.j="";this.h=new Map;}function Ee(a){return Fe[a]||window.muxjs&&"application/cea-608"==a?!0:!1}De.prototype.destroy=function(){this.c=this.m=null;this.h.clear();return Promise.resolve()};
function Ge(a,b,c,d){var e,f,g;return J(function(h){if(1==h.a)return t(h,Promise.resolve(),2);if(!a.m||!a.c)return h["return"]();if(null==c||null==d)return a.m.parseInit(L(b)),h["return"]();e={periodStart:a.v,segmentStart:c,segmentEnd:d};f=a.m.parseMedia(L(b),e);g=f.filter(function(k){return k.startTime>=a.f&&k.startTime<a.g});a.c.append(g);null==a.a&&(a.a=Math.max(c,a.f));a.b=Math.min(d,a.g);w(h);})}
De.prototype.remove=function(a,b){var c=this;return J(function(d){if(1==d.a)return t(d,Promise.resolve(),2);!c.c||!c.c.remove(a,b)||null==c.a||b<=c.a||a>=c.b||(a<=c.a&&b>=c.b?c.a=c.b=null:a<=c.a&&b<c.b?c.a=b:a>c.a&&b>=c.b&&(c.b=a));w(d);})};function He(a,b,c){a.f=b;a.g=c;}function Ie(a,b,c){a.j=b;if(b=a.h.get(b))for(var d=q(b.keys()),e=d.next();!e.done;e=d.next())(e=b.get(e.value).filter(function(f){return f.endTime<=c}))&&a.c.append(e);}
function Je(a,b,c,d,e){var f=c+" "+d,g=new Map;b=q(b);for(var h=b.next();!h.done;h=b.next()){var k=h.value;h=k.stream;g.has(h)||g.set(h,new Map);g.get(h).has(f)||g.get(h).set(f,[]);k.startTime+=e;k.endTime+=e;k.startTime>=a.f&&k.startTime<a.g&&(k=new ke(k.startTime,k.endTime,k.text),g.get(h).get(f).push(k),h==a.j&&a.c.append([k]));}e=q(g.keys());for(f=e.next();!f.done;f=e.next())for(f=f.value,a.h.has(f)||a.h.set(f,new Map),b=q(g.get(f).keys()),h=b.next();!h.done;h=b.next())h=h.value,k=g.get(f).get(h),
a.h.get(f).set(h,k);a.a=null==a.a?Math.max(c,a.f):Math.min(a.a,Math.max(c,a.f));a.b=Math.max(a.b,Math.min(d,a.g));}K("shaka.text.TextEngine",De);De.prototype.destroy=De.prototype.destroy;De.unregisterParser=function(a){delete Fe[a];};De.registerParser=function(a,b){Fe[a]=b;};var Fe={};function Ke(a,b,c,d){var e=this;this.a=a;this.h=c;this.f={};this.c=null;this.H=d||function(){};this.g={};this.b=new Tc;this.m={};this.v=b;this.A=new Pb;this.j=Le(this,this.A);this.F=new Rc(function(){return Me(e)});this.D="";}function Le(a,b){var c=new MediaSource;a.b.ha(c,"sourceopen",function(){URL.revokeObjectURL(a.D);b.resolve();});a.D=Ne(c);a.a.src=a.D;return c}function Oe(a){var b=ed(a.mimeType,a.codecs),c=fd(a);return Ee(b)||MediaSource.isTypeSupported(c)||hc(b,a.type)}p=Ke.prototype;
p.destroy=function(){return this.F.destroy()};
function Me(a){var b,c,d,e,f,g,h,k;return J(function(l){if(1==l.a){b=[];for(c in a.g)for(d=a.g[c],e=d[0],a.g[c]=d.slice(0,1),e&&b.push(e.p["catch"](Jb)),f=q(d.slice(1)),g=f.next();!g.done;g=f.next())h=g.value,h.p.reject(new M(2,7,7003,void 0));a.c&&b.push(a.c.destroy());a.h&&b.push(a.h.destroy());for(k in a.m)b.push(a.m[k].destroy());return t(l,Promise.all(b),2)}a.b&&(a.b.release(),a.b=null);a.a&&(a.a.removeAttribute("src"),a.a.load(),a.a=null);a.j=null;a.c=null;a.h=null;a.f={};a.m={};a.v=null;a.g=
{};w(l);})}
p.init=function(a,b){var c=this,d,e,f,g,h,k,l;return J(function(m){if(1==m.a)return d=Ob,t(m,c.A,2);e={};f=q(a.keys());for(g=f.next();!g.done;e={ma:e.ma},g=f.next())e.ma=g.value,h=a.get(e.ma),k=ed(h.mimeType,h.codecs),e.ma==d.$?Pe(c,k):(!b&&MediaSource.isTypeSupported(k)||!hc(k,e.ma)||(c.m[e.ma]=new gc,k=ic(e.ma,k)),l=c.j.addSourceBuffer(k),c.b.l(l,"error",function(n){return function(){c.g[n.ma][0].p.reject(new M(2,3,3014,c.a.error?c.a.error.code:0));}}(e)),c.b.l(l,"updateend",function(n){return function(){return Qe(c,n.ma)}}(e)),
c.f[e.ma]=l,c.g[e.ma]=[]);w(m);})};function Pe(a,b){a.c||(a.c=new De(a.h));"application/cea-608"!=b&&(a.c.m=Lb(Fe[b]));}function Re(a){return a.j?"ended"==a.j.readyState:!0}function Se(a,b){if("text"==b)var c=a.c.a;else c=Te(a,b),c=!c||1==c.length&&1E-6>c.end(0)-c.start(0)?null:1==c.length&&0>c.start(0)?0:c.length?c.start(0):null;return c}function Ue(a,b){return "text"==b?a.c.b:fe(Te(a,b))}function Ve(a,b,c){if("text"==b)return a=a.c,null==a.b||a.b<c?0:a.b-Math.max(c,a.a);a=Te(a,b);return he(a,c)}
p.ic=function(){var a={total:ie(this.a.buffered),audio:ie(Te(this,"audio")),video:ie(Te(this,"video")),text:[]};if(this.c){var b=this.c.a,c=this.c.b;null!=b&&null!=c&&a.text.push({start:b,end:c});}return a};function Te(a,b){try{return a.f[b].buffered}catch(c){return null}}
function We(a,b,c,d,e,f){var g,h,k,l;return J(function(m){if(1==m.a){g=Ob;if(b==g.$)return t(m,Ge(a.c,c,d,e),0);if(a.m[b])return t(m,jc(a.m[b],c),10);f&&window.muxjs&&(a.c||Pe(a,"text/vtt"),null==d&&null==e?a.v.init(c):a.v.b(c,function(n){n.length&&Je(a.c,n,d,e,a.f[g.Da].timestampOffset);}));return t(m,Xe(a,b,function(){a.f[b].appendBuffer(c);}),0)}h=m.b;a.c||Pe(a,"text/vtt");h.metadata&&(k=a.f[b].timestampOffset,a.H(h.metadata,k,e));h.captions&&h.captions.length&&(l=a.f[g.Da].timestampOffset,Je(a.c,
h.captions,d,e,l));return t(m,Xe(a,b,function(){a.f[b].appendBuffer(h.data);}),0)})}function Ye(a,b){var c=Ue(a,"video")||0;Ie(a.c,b,c);}p.remove=function(a,b,c){var d=this,e;return J(function(f){e=Ob;return a==e.$?t(f,d.c.remove(b,c),0):t(f,Xe(d,a,function(){c<=b?Qe(d,a):d.f[a].remove(b,c);}),0)})};function Ze(a,b){var c;return J(function(d){c=Ob;return b==c.$?a.c?t(d,a.c.remove(0,Infinity),0):d["return"]():t(d,Xe(a,b,function(){var e=a.j.duration;0>=e?Qe(a,b):a.f[b].remove(0,e);}),0)})}
p.flush=function(a){var b=this,c;return J(function(d){c=Ob;return a==c.$?d["return"]():t(d,Xe(b,a,function(){b.a.currentTime-=.001;Qe(b,a);}),0)})};
function $e(a,b,c,d,e){var f;return J(function(g){f=Ob;return b==f.$?(a.c.v=c,He(a.c,d,e),g["return"]()):t(g,Promise.all([Xe(a,b,function(){var h=a.f[b].appendWindowStart,k=a.f[b].appendWindowEnd;a.f[b].abort();a.f[b].appendWindowStart=h;a.f[b].appendWindowEnd=k;Qe(a,b);}),Xe(a,b,function(){var h=c;0>h&&(h+=.001);a.f[b].timestampOffset=h;Qe(a,b);}),Xe(a,b,function(){a.f[b].appendWindowStart=0;a.f[b].appendWindowEnd=e;a.f[b].appendWindowStart=d;Qe(a,b);})]),0)})}
p.endOfStream=function(a){var b=this;return J(function(c){return t(c,af(b,function(){Re(b)||(a?b.j.endOfStream(a):b.j.endOfStream());}),0)})};p.za=function(a){var b=this;return J(function(c){return t(c,af(b,function(){b.j.duration=a;}),0)})};p.getDuration=function(){return this.j.duration};function Qe(a,b){var c=a.g[b][0];c&&(c.p.resolve(),bf(a,b));}function Xe(a,b,c){Sc(a.F);c={start:c,p:new Pb};a.g[b].push(c);1==a.g[b].length&&cf(a,b);return c.p}
function af(a,b){var c,d,e,f,g,h;return J(function(k){switch(k.a){case 1:Sc(a.F);c=[];d={};for(e in a.f)d.vb=new Pb,f={start:function(l){return function(){return l.vb.resolve()}}(d),p:d.vb},a.g[e].push(f),c.push(d.vb),1==a.g[e].length&&f.start(),d={vb:d.vb};x(k,2);return t(k,Promise.all(c),4);case 4:ua(k,3);break;case 2:throw g=C(k),g;case 3:try{b();}catch(l){throw new M(2,3,3015,l);}finally{for(h in a.f)bf(a,h);}w(k);}})}function bf(a,b){a.g[b].shift();cf(a,b);}
function cf(a,b){var c=a.g[b][0];if(c)try{c.start();}catch(d){"QuotaExceededError"==d.name?c.p.reject(new M(2,3,3017,b)):c.p.reject(new M(2,3,3015,d)),bf(a,b);}}var Ne=window.URL.createObjectURL;function df(a,b){a=R(a);b=R(b);return a.split("-")[0]==b.split("-")[0]}function ef(a,b){a=R(a);b=R(b);var c=a.split("-"),d=b.split("-");return c[0]==d[0]&&1==c.length&&2==d.length}function ff(a,b){a=R(a);b=R(b);var c=a.split("-"),d=b.split("-");return 2==c.length&&2==d.length&&c[0]==d[0]}function R(a){var b=a.split("-");a=b[0]||"";b=b[1]||"";a=a.toLowerCase();a=gf.get(a)||a;return (b=b.toUpperCase())?a+"-"+b:a}function hf(a,b){a=R(a);b=R(b);return b==a?4:ef(b,a)?3:ff(b,a)?2:ef(a,b)?1:0}
function jf(a){return a.language?R(a.language):a.audio&&a.audio.language?R(a.audio.language):a.video&&a.video.language?R(a.video.language):"und"}
function kf(a,b){for(var c=R(a),d=new Set,e=q(b),f=e.next();!f.done;f=e.next())d.add(R(f.value));e=q(d);for(f=e.next();!f.done;f=e.next())if(f=f.value,f==c)return f;e=q(d);for(f=e.next();!f.done;f=e.next())if(f=f.value,ef(f,c))return f;e=q(d);for(f=e.next();!f.done;f=e.next())if(f=f.value,ff(f,c))return f;d=q(d);for(f=d.next();!f.done;f=d.next())if(f=f.value,ef(c,f))return f;return null}
var gf=new Map([["aar","aa"],["abk","ab"],["afr","af"],["aka","ak"],["alb","sq"],["amh","am"],["ara","ar"],["arg","an"],["arm","hy"],["asm","as"],["ava","av"],["ave","ae"],["aym","ay"],["aze","az"],["bak","ba"],["bam","bm"],["baq","eu"],["bel","be"],["ben","bn"],["bih","bh"],["bis","bi"],["bod","bo"],["bos","bs"],["bre","br"],["bul","bg"],["bur","my"],["cat","ca"],["ces","cs"],["cha","ch"],["che","ce"],["chi","zh"],["chu","cu"],["chv","cv"],["cor","kw"],["cos","co"],["cre","cr"],["cym","cy"],["cze",
"cs"],["dan","da"],["deu","de"],["div","dv"],["dut","nl"],["dzo","dz"],["ell","el"],["eng","en"],["epo","eo"],["est","et"],["eus","eu"],["ewe","ee"],["fao","fo"],["fas","fa"],["fij","fj"],["fin","fi"],["fra","fr"],["fre","fr"],["fry","fy"],["ful","ff"],["geo","ka"],["ger","de"],["gla","gd"],["gle","ga"],["glg","gl"],["glv","gv"],["gre","el"],["grn","gn"],["guj","gu"],["hat","ht"],["hau","ha"],["heb","he"],["her","hz"],["hin","hi"],["hmo","ho"],["hrv","hr"],["hun","hu"],["hye","hy"],["ibo","ig"],["ice",
"is"],["ido","io"],["iii","ii"],["iku","iu"],["ile","ie"],["ina","ia"],["ind","id"],["ipk","ik"],["isl","is"],["ita","it"],["jav","jv"],["jpn","ja"],["kal","kl"],["kan","kn"],["kas","ks"],["kat","ka"],["kau","kr"],["kaz","kk"],["khm","km"],["kik","ki"],["kin","rw"],["kir","ky"],["kom","kv"],["kon","kg"],["kor","ko"],["kua","kj"],["kur","ku"],["lao","lo"],["lat","la"],["lav","lv"],["lim","li"],["lin","ln"],["lit","lt"],["ltz","lb"],["lub","lu"],["lug","lg"],["mac","mk"],["mah","mh"],["mal","ml"],["mao",
"mi"],["mar","mr"],["may","ms"],["mkd","mk"],["mlg","mg"],["mlt","mt"],["mon","mn"],["mri","mi"],["msa","ms"],["mya","my"],["nau","na"],["nav","nv"],["nbl","nr"],["nde","nd"],["ndo","ng"],["nep","ne"],["nld","nl"],["nno","nn"],["nob","nb"],["nor","no"],["nya","ny"],["oci","oc"],["oji","oj"],["ori","or"],["orm","om"],["oss","os"],["pan","pa"],["per","fa"],["pli","pi"],["pol","pl"],["por","pt"],["pus","ps"],["que","qu"],["roh","rm"],["ron","ro"],["rum","ro"],["run","rn"],["rus","ru"],["sag","sg"],["san",
"sa"],["sin","si"],["slk","sk"],["slo","sk"],["slv","sl"],["sme","se"],["smo","sm"],["sna","sn"],["snd","sd"],["som","so"],["sot","st"],["spa","es"],["sqi","sq"],["srd","sc"],["srp","sr"],["ssw","ss"],["sun","su"],["swa","sw"],["swe","sv"],["tah","ty"],["tam","ta"],["tat","tt"],["tel","te"],["tgk","tg"],["tgl","tl"],["tha","th"],["tib","bo"],["tir","ti"],["ton","to"],["tsn","tn"],["tso","ts"],["tuk","tk"],["tur","tr"],["twi","tw"],["uig","ug"],["ukr","uk"],["urd","ur"],["uzb","uz"],["ven","ve"],["vie",
"vi"],["vol","vo"],["wel","cy"],["wln","wa"],["wol","wo"],["xho","xh"],["yid","yi"],["yor","yo"],["zha","za"],["zho","zh"],["zul","zu"]]);function lf(a,b){function c(l){var m="";l.video&&(m=hd(l.video.codecs)[0]);var n="";l.audio&&(n=hd(l.audio.codecs)[0]);return m+"-"+n}var d=mf(a.variants,b),e=new vc;d=q(d);for(var f=d.next();!f.done;f=d.next()){f=f.value;var g=c(f);e.push(g,f);}var h=null,k=Infinity;wc(e,function(l,m){for(var n=0,r=0,u=q(m),v=u.next();!v.done;v=u.next())n+=v.value.bandwidth||0,++r;n/=r;n<k&&(h=l,k=n);});a.variants=a.variants.filter(function(l){return c(l)==h?!0:!1});}
function nf(a,b,c){function d(f,g,h){return f>=g&&f<=h}var e=a.video;return e&&e.width&&e.height&&(!d(e.width,b.minWidth,Math.min(b.maxWidth,c.width))||!d(e.height,b.minHeight,Math.min(b.maxHeight,c.height))||!d(e.width*e.height,b.minPixels,b.maxPixels))||a&&a.video&&a.video.frameRate&&!d(a.video.frameRate,b.minFrameRate,b.maxFrameRate)||!d(a.bandwidth,b.minBandwidth,b.maxBandwidth)?!1:!0}
function of(a,b,c){c.variants=c.variants.filter(function(d){if(a&&a.M&&!$d(a,d))return !1;var e=d.audio;d=d.video;return e&&!Oe(e)||d&&!Oe(d)||e&&b&&b.audio&&!pf(e,b.audio)||d&&b&&b.video&&!pf(d,b.video)?!1:!0});c.textStreams=c.textStreams.filter(function(d){return Ee(ed(d.mimeType,d.codecs))});}function pf(a,b){return a.mimeType!=b.mimeType||a.codecs.split(".")[0]!=b.codecs.split(".")[0]?!1:!0}
function qf(a){var b=a.audio,c=a.video,d=b?b.codecs:null,e=c?c.codecs:null,f=[];e&&f.push(e);d&&f.push(d);var g=[];c&&g.push(c.mimeType);b&&g.push(b.mimeType);g=g[0]||null;var h=[];b&&h.push(b.kind);c&&h.push(c.kind);h=h[0]||null;var k=new Set;if(b)for(var l=q(b.roles),m=l.next();!m.done;m=l.next())k.add(m.value);if(c)for(l=q(c.roles),m=l.next();!m.done;m=l.next())k.add(m.value);a={id:a.id,active:!1,type:"variant",bandwidth:a.bandwidth,language:a.language,label:null,kind:h,width:null,height:null,
frameRate:null,pixelAspectRatio:null,mimeType:g,codecs:f.join(", "),audioCodec:d,videoCodec:e,primary:a.primary,roles:Array.from(k),audioRoles:null,videoId:null,audioId:null,channelsCount:null,audioSamplingRate:null,audioBandwidth:null,videoBandwidth:null,originalVideoId:null,originalAudioId:null,originalTextId:null};c&&(a.videoId=c.id,a.originalVideoId=c.originalId,a.width=c.width||null,a.height=c.height||null,a.frameRate=c.frameRate||null,a.pixelAspectRatio=c.pixelAspectRatio||null,a.videoBandwidth=
c.bandwidth||null);b&&(a.audioId=b.id,a.originalAudioId=b.originalId,a.channelsCount=b.channelsCount,a.audioSamplingRate=b.audioSamplingRate,a.audioBandwidth=b.bandwidth||null,a.label=b.label,a.audioRoles=b.roles);return a}
function rf(a){return {id:a.id,active:!1,type:"text",bandwidth:0,language:a.language,label:a.label,kind:a.kind||null,width:null,height:null,frameRate:null,pixelAspectRatio:null,mimeType:a.mimeType,codecs:a.codecs||null,audioCodec:null,videoCodec:null,primary:a.primary,roles:a.roles,audioRoles:null,videoId:null,audioId:null,channelsCount:null,audioSamplingRate:null,audioBandwidth:null,videoBandwidth:null,originalVideoId:null,originalAudioId:null,originalTextId:a.originalId}}
function sf(a){a.__shaka_id||(a.__shaka_id=tf++);return a.__shaka_id}function uf(a){var b=vf(a);b.active=a.enabled;b.type="variant";b.originalAudioId=a.id;"main"==a.kind&&(b.primary=!0);a.kind&&(b.roles=[a.kind],b.audioRoles=[a.kind]);return b}
function vf(a){return {id:sf(a),active:!1,type:"",bandwidth:0,language:R(a.language),label:a.label,kind:a.kind,width:null,height:null,frameRate:null,pixelAspectRatio:null,mimeType:null,codecs:null,audioCodec:null,videoCodec:null,primary:!1,roles:[],audioRoles:null,videoId:null,audioId:null,channelsCount:null,audioSamplingRate:null,audioBandwidth:null,videoBandwidth:null,originalVideoId:null,originalAudioId:null,originalTextId:null}}
function wf(a){return a.allowedByApplication&&a.allowedByKeySystem}function xf(a){return a.filter(function(b){return wf(b)})}
function mf(a,b){var c=a.filter(function(g){return g.audio&&g.audio.channelsCount}),d=new Map;c=q(c);for(var e=c.next();!e.done;e=c.next()){e=e.value;var f=e.audio.channelsCount;d.has(f)||d.set(f,[]);d.get(f).push(e);}c=Array.from(d.keys());if(0==c.length)return a;e=c.filter(function(g){return g<=b});return e.length?d.get(Math.max.apply(Math,ia(e))):d.get(Math.min.apply(Math,ia(c)))}
function yf(a,b,c){var d=a,e=a.filter(function(h){return h.primary});e.length&&(d=e);var f=d.length?d[0].language:"";d=d.filter(function(h){return h.language==f});if(b){var g=kf(R(b),a.map(function(h){return h.language}));g&&(d=a.filter(function(h){return R(h.language)==g}));}if(c){if(a=zf(d,c),a.length)return a}else if(a=d.filter(function(h){return 0==h.roles.length}),a.length)return a;a=d.map(function(h){return h.roles}).reduce(Ib,[]);return a.length?zf(d,a[0]):d}
function zf(a,b){return a.filter(function(c){return c.roles.includes(b)})}var tf=0;function Af(){this.h=null;this.c=!1;this.a=new Ua;this.b=[];this.g=1;this.j=!1;this.i=this.f=null;}p=Af.prototype;p.stop=function(){this.h=null;this.c=!1;this.b=[];this.g=1;this.f=null;};p.init=function(a){this.h=a;};
p.chooseVariant=function(){var a=Bf(this.i.restrictions,this.b),b=this.a.getBandwidthEstimate(this.i.defaultBandwidthEstimate);this.b.length&&!a.length&&(a=Bf(null,this.b),a=[a[0]]);var c=a[0]||null;a=q(ib(a));for(var d=a.next();!d.done;d=a.next()){var e=d.value;d=e.item;var f=isNaN(this.g)?1:Math.abs(this.g);e=f*(e.next||{bandwidth:Infinity}).bandwidth/this.i.bandwidthUpgradeTarget;b>=f*d.bandwidth/this.i.bandwidthDowngradeTarget&&b<=e&&(c=d);}this.f=Date.now();return c};
p.enable=function(){this.c=!0;};p.disable=function(){this.c=!1;};p.segmentDownloaded=function(a,b){var c=this.a;if(!(16E3>b)){var d=8E3*b/a,e=a/1E3;c.a+=b;Qa(c.b,e,d);Qa(c.c,e,d);}if(null!=this.f&&this.c)a:{if(!this.j){if(!(128E3<=this.a.a))break a;this.j=!0;}else if(Date.now()-this.f<1E3*this.i.switchInterval)break a;c=this.chooseVariant();this.a.getBandwidthEstimate(this.i.defaultBandwidthEstimate);c&&this.h(c);}};p.getBandwidthEstimate=function(){return this.a.getBandwidthEstimate(this.i.defaultBandwidthEstimate)};
p.setVariants=function(a){this.b=a;};p.playbackRateChanged=function(a){this.g=a;};p.configure=function(a){this.i=a;};function Bf(a,b){a&&(b=b.filter(function(c){return nf(c,a,{width:Infinity,height:Infinity})}));return b.sort(function(c,d){return c.bandwidth-d.bandwidth})}K("shaka.abr.SimpleAbrManager",Af);Af.prototype.configure=Af.prototype.configure;Af.prototype.playbackRateChanged=Af.prototype.playbackRateChanged;Af.prototype.setVariants=Af.prototype.setVariants;
Af.prototype.getBandwidthEstimate=Af.prototype.getBandwidthEstimate;Af.prototype.segmentDownloaded=Af.prototype.segmentDownloaded;Af.prototype.disable=Af.prototype.disable;Af.prototype.enable=Af.prototype.enable;Af.prototype.chooseVariant=Af.prototype.chooseVariant;Af.prototype.init=Af.prototype.init;Af.prototype.stop=Af.prototype.stop;function Cf(a,b){this.a=a;this.b=new Set([a]);b=b||[];for(var c=q(b),d=c.next();!d.done;d=c.next())this.add(d.value);}Cf.prototype.add=function(a){return Df(this.a,a)?(this.b.add(a),!0):!1};function Df(a,b){var c;if(!(c=!!a.audio!=!!b.audio||!!a.video!=!!b.video||a.language!=b.language)&&(c=a.audio&&b.audio)){c=a.audio;var d=b.audio;c=!(c.channelsCount==d.channelsCount&&Ef(c,d)&&Ff(c.roles,d.roles));}!c&&(c=a.video&&b.video)&&(c=a.video,d=b.video,c=!(Ef(c,d)&&Ff(c.roles,d.roles)));return c?!1:!0}
Cf.prototype.values=function(){return this.b.values()};function Ef(a,b){if(a.mimeType!=b.mimeType)return !1;var c=a.codecs.split(",").map(function(g){return hd(g)[0]}),d=b.codecs.split(",").map(function(g){return hd(g)[0]});if(c.length!=d.length)return !1;c.sort();d.sort();for(var e=q(gb(c.length)),f=e.next();!f.done;f=e.next())if(f=f.value,c[f]!=d[f])return !1;return !0}
function Ff(a,b){var c=new Set(a),d=new Set(b);c["delete"]("main");d["delete"]("main");if(c.size!=d.size)return !1;c=q(c);for(var e=c.next();!e.done;e=c.next())if(!d.has(e.value))return !1;return !0}function Gf(a){this.a=a;this.b=new Hf(a.language,"",a.audio&&a.audio.channelsCount?a.audio.channelsCount:0,"");}Gf.prototype.create=function(a){var b=this,c=a.filter(function(d){return Df(b.a,d)});return c.length?new Cf(c[0],c):this.b.create(a)};function Hf(a,b,c,d){this.c=a;this.f=b;this.a=c;this.b=void 0===d?"":d;}
Hf.prototype.create=function(a){var b=[];b=If(a,this.c);var c=a.filter(function(d){return d.primary});b=b.length?b:c.length?c:a;a=Jf(b,this.f);a.length&&(b=a);this.a&&(a=mf(b,this.a),a.length&&(b=a));this.b&&(a=Kf(b,this.b),a.length&&(b=a));a=new Cf(b[0]);b=q(b);for(c=b.next();!c.done;c=b.next())c=c.value,Df(a.a,c)&&a.add(c);return a};function If(a,b){var c=R(b),d=kf(c,a.map(function(e){return jf(e)}));return d?a.filter(function(e){return d==jf(e)}):[]}
function Jf(a,b){return a.filter(function(c){return c.audio?b?c.audio.roles.includes(b):0==c.audio.roles.length:!1})}function Kf(a,b){return a.filter(function(c){return c.audio?c.audio.label.toLowerCase()==b.toLowerCase():!1})}function Lf(){this.a=Mf;this.b=(new Map).set(Mf,2).set(Nf,1);}function Of(a,b,c){a.b.set(Mf,c).set(Nf,b);}var Nf=0,Mf=1;function Pf(){}function Qf(a,b,c,d){var e,f,g,h;return J(function(k){if(1==k.a){if(d&&(e=Rf[d.toLowerCase()]))return k["return"](e);if(f=Sf(a))if(g=Tf[f])return k["return"](g);return d?k.u(2):t(k,Uf(a,b,c),3)}if(2!=k.a&&(d=k.b)&&(h=Rf[d]))return k["return"](h);throw new M(2,4,4E3,a);})}
function Uf(a,b,c){var d,e,f;return J(function(g){if(1==g.a)return d=Kc([a],c),d.method="HEAD",t(g,b.request(0,d).promise,2);e=g.b;f=e.headers["content-type"];return g["return"](f?f.toLowerCase().split(";").shift():"")})}function Sf(a){a=(new qb(a)).ja.split("/").pop().split(".");return 1==a.length?"":a.pop().toLowerCase()}K("shaka.media.ManifestParser",Pf);Pf.unregisterParserByMime=function(a){delete Rf[a];};Pf.registerParserByMime=function(a,b){Rf[a]=b;};
Pf.registerParserByExtension=function(a,b){Tf[a]=b;};var Rf={},Tf={};function Vf(a,b,c){this.c=a;this.b=b;this.a=c;}Vf.prototype.Hb=function(){return this.b};Vf.prototype.Db=function(){return this.a};function Wf(a,b){return a&&b?a.Hb()==b.Hb()&&a.Db()==b.Db()&&Dc(a.c(),b.c()):a==b}K("shaka.media.InitSegmentReference",Vf);Vf.prototype.getEndByte=Vf.prototype.Db;Vf.prototype.getStartByte=Vf.prototype.Hb;
function Xf(a,b,c,d,e,f,g,h,k){this.startTime=a;this.endTime=b;this.c=c;this.b=d;this.a=e;this.f=f;this.timestampOffset=g;this.appendWindowStart=h;this.appendWindowEnd=k;}Xf.prototype.Ae=function(){return this.startTime};Xf.prototype.ne=function(){return this.endTime};Xf.prototype.Hb=function(){return this.b};Xf.prototype.Db=function(){return this.a};K("shaka.media.SegmentReference",Xf);Xf.prototype.getEndByte=Xf.prototype.Db;Xf.prototype.getStartByte=Xf.prototype.Hb;Xf.prototype.getEndTime=Xf.prototype.ne;
Xf.prototype.getStartTime=Xf.prototype.Ae;function S(a,b,c){this.f=a;this.rc=b;this.h=this.g=Infinity;this.a=1;this.b=this.c=null;this.j=0;this.m=!0;this.v=0;this.A=void 0===c?!0:c;}p=S.prototype;p.getDuration=function(){return this.g};p.se=function(){return this.a};p.za=function(a){this.g=a;};p.ze=function(){return this.f};p.Td=function(a){this.j=a;};p.Pb=function(a){this.m=a;};p.pd=function(a){this.h=a;};p.bf=function(a){this.rc=a;};p.me=function(){return this.rc};
p.ob=function(a){if(0!=a.length){var b=a[a.length-1].endTime;this.Zc(a[0].startTime);this.a=a.reduce(function(c,d){return Math.max(c,d.endTime-d.startTime)},this.a);this.b=Math.max(this.b,b);null!=this.f&&this.A&&(this.f=(Date.now()+this.j)/1E3-this.b-this.a);}};p.Zc=function(a){this.c=null==this.c?a:Math.min(this.c,a);};p.Yc=function(a){this.a=Math.max(this.a,a);};p.offset=function(a){null!=this.c&&(this.c+=a);null!=this.b&&(this.b+=a);};p.S=function(){return Infinity==this.g&&!this.m};
p.Ua=function(){return Infinity!=this.g&&!this.m};p.Ra=function(){return Math.max(this.v,this.La()-this.h)};p.Ud=function(a){this.v=a;};p.La=function(){return this.S()||this.Ua()?Math.min(Math.max(0,(Date.now()+this.j)/1E3-this.a-this.f),this.g):this.g};p.Gb=function(a){var b=Math.max(this.c,this.v);return Infinity==this.h?b:Math.max(b,Math.min(this.La()-this.h+a,this.Fa()))};p.kb=function(){return this.Gb(0)};p.Fa=function(){return Math.max(0,this.La()-(this.S()||this.Ua()?this.rc:0))};
p.Xd=function(){return null==this.f||null!=this.b&&this.A?!1:!0};K("shaka.media.PresentationTimeline",S);S.prototype.usingPresentationStartTime=S.prototype.Xd;S.prototype.getSeekRangeEnd=S.prototype.Fa;S.prototype.getSeekRangeStart=S.prototype.kb;S.prototype.getSafeSeekRangeStart=S.prototype.Gb;S.prototype.getSegmentAvailabilityEnd=S.prototype.La;S.prototype.setUserSeekStart=S.prototype.Ud;S.prototype.getSegmentAvailabilityStart=S.prototype.Ra;S.prototype.isInProgress=S.prototype.Ua;
S.prototype.isLive=S.prototype.S;S.prototype.offset=S.prototype.offset;S.prototype.notifyMaxSegmentDuration=S.prototype.Yc;S.prototype.notifyMinSegmentStartTime=S.prototype.Zc;S.prototype.notifySegments=S.prototype.ob;S.prototype.getDelay=S.prototype.me;S.prototype.setDelay=S.prototype.bf;S.prototype.setSegmentAvailabilityDuration=S.prototype.pd;S.prototype.setStatic=S.prototype.Pb;S.prototype.setClockOffset=S.prototype.Td;S.prototype.getPresentationStartTime=S.prototype.ze;
S.prototype.setDuration=S.prototype.za;S.prototype.getMaxSegmentDuration=S.prototype.se;S.prototype.getDuration=S.prototype.getDuration;function Yf(a,b){this.g=a;this.h=Zf(a);this.a=a.a.currentTime;this.f=Date.now()/1E3;this.b=!1;this.j=b;this.c=function(){};}Yf.prototype.release=function(){this.g=null;this.c=function(){};};function $f(a,b){a.c=b;}function ag(a){this.a=a;}function Zf(a){if(a.a.paused||0==a.a.playbackRate||0==a.a.buffered.length)var b=!1;else a:{b=a.a.currentTime;a=q(ie(a.a.buffered));for(var c=a.next();!c.done;c=a.next())if(c=c.value,!(b<c.start-.1||b>c.end-.5)){b=!0;break a}b=!1;}return b}function bg(a,b,c,d,e){var f=this;this.a=a;this.A=b;this.i=c;this.v=e;this.b=new Tc;this.j=!1;this.m=a.readyState;this.f=!1;this.c=d;this.h=!1;this.b.l(a,"waiting",function(){return cg(f)});this.g=(new N(function(){cg(f);})).ra(.25);}bg.prototype.release=function(){this.b&&(this.b.release(),this.b=null);null!=this.g&&(this.g.stop(),this.g=null);this.c&&(this.c.release(),this.c=null);this.a=this.A=this.v=null;};bg.prototype.cd=function(){this.h=!0;cg(this);};
function cg(a){if(0!=a.a.readyState){if(a.a.seeking){if(!a.j)return}else a.j=!1;if(!a.a.paused){a.a.readyState!=a.m&&(a.f=!1,a.m=a.a.readyState);var b;if(!(b=!a.c)){b=a.c;var c=b.g,d=Zf(c),e=c.a.currentTime,f=Date.now()/1E3;if(b.a!=e||b.h!=d)b.f=f,b.a=e,b.h=d,b.b=!1;e=f-b.f;if(d=e>=b.j&&d&&!b.b)b.c(b.a,e),b.b=!0,b.a=c.a.currentTime;b=!d;}if(b){var g=a.i.smallGapLimit;e=a.a.currentTime;b=a.a.buffered;c=je(b,e);if(!(null==c||0==c&&!a.h||(d=b.start(c),d>=a.A.Fa()))){f=d-e;g=f<=g;var h=!1;.001>f||(g||
a.f||(a.f=!0,e=new Q("largegap",{currentTime:e,gapSize:f}),e.cancelable=!0,a.v(e),a.i.jumpLargeGaps&&!e.defaultPrevented&&(h=!0)),!g&&!h)||(0!=c&&b.end(c-1),a.a.currentTime=d);}}}}}function dg(a,b,c,d){b==HTMLMediaElement.HAVE_NOTHING||a.readyState>=b?d():(b=eg.get(b),c.ha(a,b,d));}var eg=new Map([[HTMLMediaElement.HAVE_METADATA,"loadedmetadata"],[HTMLMediaElement.HAVE_CURRENT_DATA,"loadeddata"],[HTMLMediaElement.HAVE_FUTURE_DATA,"canplay"],[HTMLMediaElement.HAVE_ENOUGH_DATA,"canplaythrough"]]);function fg(a,b,c){var d=this;this.a=a;this.g=b;this.f=c;this.h=!1;this.b=new Tc;this.c=new gg(a);dg(this.a,HTMLMediaElement.HAVE_METADATA,this.b,function(){hg(d,d.f);});}fg.prototype.release=function(){this.b&&(this.b.release(),this.b=null);null!=this.c&&(this.c.release(),this.c=null);this.g=function(){};this.a=null;};function ig(a){return a.h?a.a.currentTime:a.f}function jg(a,b){0<a.a.readyState?kg(a.c,b):dg(a.a,HTMLMediaElement.HAVE_METADATA,a.b,function(){hg(a,a.f);});}
function hg(a,b){.001>Math.abs(a.a.currentTime-b)?lg(a):(a.b.ha(a.a,"seeking",function(){lg(a);}),kg(a.c,0==a.a.currentTime?b:a.a.currentTime));}function lg(a){a.h=!0;a.b.l(a.a,"seeking",function(){return a.g()});}function gg(a){var b=this;this.b=a;this.h=10;this.g=this.f=this.c=0;this.a=new N(function(){0>=b.c?b.a.stop():b.b.currentTime!=b.f?b.a.stop():(b.b.currentTime=b.g,b.c--);});}gg.prototype.release=function(){this.a&&(this.a.stop(),this.a=null);this.b=null;};
function kg(a,b){a.f=a.b.currentTime;a.g=b;a.c=a.h;a.b.currentTime=b;a.a.ra(.1);}function mg(a){function b(){null==c.c?c.f=!0:(c.b.ha(c.a,"seeking",function(){c.f=!0;}),c.a.currentTime=Math.max(0,c.a.currentTime+c.c));}var c=this;this.a=a;this.f=!1;this.c=null;this.b=new Tc;dg(this.a,HTMLMediaElement.HAVE_CURRENT_DATA,this.b,function(){b();});}mg.prototype.release=function(){this.b&&(this.b.release(),this.b=null);this.a=null;};mg.prototype.m=function(a){this.c=this.f?this.c:a;};mg.prototype.g=function(){return (this.f?this.a.currentTime:this.c)||0};mg.prototype.v=function(){};
function ng(a,b,c,d,e,f){var g=this;this.c=a;this.a=b.presentationTimeline;this.D=b.minBufferTime||0;this.i=c;this.A=e;this.j=null;this.f=new bg(a,b.presentationTimeline,c,og(a,c),f);this.b=new fg(a,function(){a:{var h=g.f;h.j=!0;h.h=!1;h.f=!1;var k=ig(g.b);h=pg(g,k);if(.001<Math.abs(h-k)&&(k=Date.now()/1E3,!g.j||g.j<k-1)){g.j=k;jg(g.b,h);h=void 0;break a}g.A();h=void 0;}return h},qg(this,d));this.h=(new N(function(){if(0!=g.c.readyState&&!g.c.paused){var h=ig(g.b),k=g.a.kb(),l=g.a.Fa();3>l-k&&(k=
l-3);h<k&&(h=pg(g,h),g.c.currentTime=h);}})).ra(.25);}ng.prototype.release=function(){this.b&&(this.b.release(),this.b=null);this.f&&(this.f.release(),this.f=null);this.h&&(this.h.stop(),this.h=null);this.c=this.b=this.a=this.i=null;this.A=function(){};};ng.prototype.m=function(a){jg(this.b,a);};ng.prototype.g=function(){var a=ig(this.b);return 0<this.c.readyState&&!this.c.paused?rg(this,a):a};
function qg(a,b){null==b?b=Infinity>a.a.getDuration()?a.a.kb():a.a.Fa():0>b&&(b=a.a.Fa()+b);return sg(a,rg(a,b))}ng.prototype.v=function(){this.f.cd();};function sg(a,b){var c=a.a.getDuration();return b>=c?c-a.i.durationBackoff:b}function pg(a,b){var c=Math.max(a.D,a.i.rebufferingGoal),d=a.i.safeSeekOffset,e=a.a.kb(),f=a.a.Fa(),g=a.a.getDuration();3>f-e&&(e=f-3);var h=a.a.Gb(c),k=a.a.Gb(d);c=a.a.Gb(c+d);return b>=g?sg(a,b):b>f?f:b<e?ge(a.c.buffered,k)?k:c:b>=h||ge(a.c.buffered,b)?b:c}
function rg(a,b){var c=a.a.kb();if(b<c)return c;c=a.a.Fa();return b>c?c:b}function og(a,b){if(!b.stallEnabled)return null;var c=b.stallSkip,d=new Yf(new ag(a),b.stallThreshold);$f(d,function(){c?a.currentTime+=c:(a.pause(),a.play());});return d}function T(a){this.a=a;this.b=null;this.c=0;this.f=!1;}p=T.prototype;p.destroy=function(){Eb("shaka.media.SegmentIndex","Please use release() instead of destroy().");this.release();return Promise.resolve()};p.release=function(){this.f||(this.a=[],this.b&&this.b.stop(),this.b=null);};p.Ie=function(){this.f=!0;};p.find=function(a){for(var b=this.a.length-1;0<=b;--b){var c=this.a[b];if(a>=c.startTime&&a<c.endTime)return b+this.c}return this.a.length&&a<this.a[0].startTime?this.c:null};
p.get=function(a){if(0==this.a.length)return null;a-=this.c;return 0>a||a>=this.a.length?null:this.a[a]};p.offset=function(a){if(!this.f)for(var b=q(this.a),c=b.next();!c.done;c=b.next())c=c.value,c.startTime+=a,c.endTime+=a,c.timestampOffset+=a;};p.mb=function(a){if(!this.f){var b=this.a[this.a.length-1],c=[];c=this.a.length?a.filter(function(d){return d.startTime>=b.startTime}):a;b&&c.length&&c[0].startTime==b.startTime&&this.a.pop();this.a.push.apply(this.a,ia(c));}};
p.Pa=function(a){if(!this.f){var b=this.a.length;this.a=this.a.filter(function(c){return c.endTime>a});this.c+=b-this.a.length;}};p.Ka=function(a,b){if(!this.f){for(;this.a.length;)if(this.a[this.a.length-1].startTime>=b)this.a.pop();else break;for(;this.a.length;)if(this.a[0].endTime<=a)this.a.shift(),this.c++;else break;if(0!=this.a.length){var c=this.a[this.a.length-1];this.a[this.a.length-1]=new Xf(c.startTime,b,c.c,c.b,c.a,c.f,c.timestampOffset,c.appendWindowStart,c.appendWindowEnd);}}};
p.tc=function(a,b){var c=this;this.f||(this.b&&this.b.stop(),this.b=new N(function(){var d=b();c.a.push.apply(c.a,ia(d));0==c.a.length&&(c.b.stop(),c.b=null);}),this.b.ra(a));};T.prototype[Symbol.iterator]=function(){return this.jb(0)};T.prototype.jb=function(a){return new tg(this,this.find(a)||0)};function ug(a,b,c){return new T([new Xf(a,a+b,function(){return c},0,null,null,a,a,a+b)])}K("shaka.media.SegmentIndex",T);T.forSingleSegment=ug;T.prototype.getIteratorForTime=T.prototype.jb;
T.prototype.updateEvery=T.prototype.tc;T.prototype.fit=T.prototype.Ka;T.prototype.evict=T.prototype.Pa;T.prototype.merge=T.prototype.mb;T.prototype.offset=T.prototype.offset;T.prototype.get=T.prototype.get;T.prototype.find=T.prototype.find;T.prototype.markImmutable=T.prototype.Ie;T.prototype.release=T.prototype.release;T.prototype.destroy=T.prototype.destroy;function tg(a,b){this.b=a;this.a=b;}tg.prototype.seek=function(a){this.a=this.b.jb(a).a;return this.next().value};
tg.prototype.current=function(){return this.b.get(this.a-1)};tg.prototype.next=function(){var a=this.b.get(this.a++);return {value:a,done:!a}};K("shaka.media.SegmentIterator",tg);tg.prototype.next=tg.prototype.next;tg.prototype.current=tg.prototype.current;tg.prototype.seek=tg.prototype.seek;function vg(){T.call(this,[]);this.g=[];}pa(vg,T);p=vg.prototype;p.clone=function(){var a=new vg;a.g=this.g.slice();return a};
p.release=function(){for(var a=q(this.g),b=a.next();!b.done;b=a.next())b.value.release();this.g=[];};p.find=function(a){for(var b=0,c=q(this.g),d=c.next();!d.done;d=c.next()){d=d.value;var e=d.find(a);if(null!=e)return e+b;b+=d.c+d.a.length;}return null};p.get=function(a){for(var b=0,c=q(this.g),d=c.next();!d.done;d=c.next()){d=d.value;var e=d.get(a-b);if(e)return e;b+=d.c+d.a.length;}return null};p.offset=function(){};p.mb=function(){};p.Pa=function(){};p.Ka=function(){};p.tc=function(){};
K("shaka.media.MetaSegmentIndex",vg);vg.prototype.updateEvery=vg.prototype.tc;vg.prototype.fit=vg.prototype.Ka;vg.prototype.evict=vg.prototype.Pa;vg.prototype.merge=vg.prototype.mb;vg.prototype.offset=vg.prototype.offset;vg.prototype.get=vg.prototype.get;vg.prototype.find=vg.prototype.find;vg.prototype.release=vg.prototype.release;function wg(a){var b=this;this.a=a;this.f=!1;this.b=this.a.kc();this.c=new N(function(){b.a.Kd(.25*b.b);});}wg.prototype.release=function(){this.c&&(this.c.stop(),this.c=null);this.a=null;};wg.prototype.set=function(a){this.b=a;xg(this);};function xg(a){a.c.stop();var b=a.f?0:a.b;if(0<=b)try{a.a.kc()!=b&&a.a.od(b);return}catch(c){}a.c.ra(.25);0!=a.a.kc()&&a.a.od(0);}function yg(a){var b=this;this.c=a;this.a=new Set;this.b=(new N(function(){zg(b,!1);})).ra(.25);}yg.prototype.release=function(){this.b.stop();for(var a=q(this.a),b=a.next();!b.done;b=a.next())b.value.release();this.a.clear();};
function zg(a,b){for(var c=q(a.a),d=c.next();!d.done;d=c.next()){d=d.value;for(var e=a.c.currentTime,f=b,g=q(d.g.a),h=g.next();!h.done;h=g.next()){h=h.value;var k=d.f.get(h),l=e<h.startTime?Ag:e>h.endTime?Bg:Cg;d.f.set(h,l);for(var m=q(d.h),n=m.next();!n.done;n=m.next())n=n.value,n.bb==k&&n.ab==l&&n.Ta(h,f);}}}function Gg(a){var b=this;this.b=function(){};this.a=new Set;this.f=a;this.c=(new N(function(){for(var c=b.f(),d=q(b.a),e=d.next();!e.done;e=d.next())e=e.value,e.endTime<c.start&&b.a["delete"](e);})).ra(2);}Gg.prototype.release=function(){this.b=function(){};this.a.clear();this.c.stop();};function Hg(a,b){a.b=b;}function Ig(a){var b=this;this.g=a;this.f=new Map;this.a=function(){};this.b=function(){};this.c=function(){};this.h=[{bb:null,ab:Cg,Ta:function(c,d){return b.a(c,d)}},{bb:Ag,ab:Cg,Ta:function(c,d){return b.a(c,d)}},{bb:Bg,ab:Cg,Ta:function(c,d){return b.a(c,d)}},{bb:Cg,ab:Ag,Ta:function(c,d){return b.b(c,d)}},{bb:Cg,ab:Bg,Ta:function(c,d){return b.b(c,d)}},{bb:Ag,ab:Bg,Ta:function(c,d){return b.c(c,d)}},{bb:Bg,ab:Ag,Ta:function(c,d){return b.c(c,d)}}];}
Ig.prototype.release=function(){this.g=null;this.f.clear();this.a=function(){};this.b=function(){};this.c=function(){};};function Jg(a,b,c,d){a.a=b;a.b=c;a.c=d;}var Ag=1,Cg=2,Bg=3;function V(a,b){this.P=ob(a);this.a=b==Kg;this.C=0;}p=V.prototype;p.wa=function(){return this.C<this.P.byteLength};p.ye=function(){return this.C};p.oe=function(){return this.P.byteLength};p.qa=function(){try{var a=this.P.getUint8(this.C);this.C+=1;return a}catch(b){throw Lg();}};p.Mb=function(){try{var a=this.P.getUint16(this.C,this.a);this.C+=2;return a}catch(b){throw Lg();}};p.K=function(){try{var a=this.P.getUint32(this.C,this.a);this.C+=4;return a}catch(b){throw Lg();}};
p.Od=function(){try{var a=this.P.getInt32(this.C,this.a);this.C+=4;return a}catch(b){throw Lg();}};p.rb=function(){try{if(this.a){var a=this.P.getUint32(this.C,!0);var b=this.P.getUint32(this.C+4,!0);}else b=this.P.getUint32(this.C,!1),a=this.P.getUint32(this.C+4,!1);}catch(c){throw Lg();}if(2097151<b)throw new M(2,3,3001);this.C+=8;return b*Math.pow(2,32)+a};p.Wa=function(a){if(this.C+a>this.P.byteLength)throw Lg();var b=L(this.P,this.C,a);this.C+=a;return b};
p.skip=function(a){if(this.C+a>this.P.byteLength)throw Lg();this.C+=a;};p.Qd=function(a){if(this.C<a)throw Lg();this.C-=a;};p.seek=function(a){if(0>a||a>this.P.byteLength)throw Lg();this.C=a;};p.ed=function(){for(var a=this.C;this.wa()&&0!=this.P.getUint8(this.C);)this.C+=1;a=L(this.P,a,this.C-a);this.C+=1;return Tb(a)};function Lg(){return new M(2,3,3E3)}K("shaka.util.DataViewReader",V);V.prototype.readTerminatedString=V.prototype.ed;V.prototype.seek=V.prototype.seek;V.prototype.rewind=V.prototype.Qd;
V.prototype.skip=V.prototype.skip;V.prototype.readBytes=V.prototype.Wa;V.prototype.readUint64=V.prototype.rb;V.prototype.readInt32=V.prototype.Od;V.prototype.readUint32=V.prototype.K;V.prototype.readUint16=V.prototype.Mb;V.prototype.readUint8=V.prototype.qa;V.prototype.getLength=V.prototype.oe;V.prototype.getPosition=V.prototype.ye;V.prototype.hasMoreData=V.prototype.wa;var Kg=1;V.Endianness={BIG_ENDIAN:0,LITTLE_ENDIAN:Kg};function Mg(){this.c=[];this.b=[];this.a=!1;}p=Mg.prototype;p.box=function(a,b){var c=Ng(a);this.c[c]=Og;this.b[c]=b;return this};p.ea=function(a,b){var c=Ng(a);this.c[c]=Pg;this.b[c]=b;return this};p.stop=function(){this.a=!0;};p.parse=function(a,b){var c=new V(a,0);for(this.a=!1;c.wa()&&!this.a;)this.qc(0,c,b);};
p.qc=function(a,b,c){var d=b.C,e=b.K(),f=b.K();switch(e){case 0:e=b.P.byteLength-d;break;case 1:e=b.rb();}var g=this.b[f];if(g){var h=null,k=null;this.c[f]==Pg&&(k=b.K(),h=k>>>24,k&=16777215);f=d+e;c&&f>b.P.byteLength&&(f=b.P.byteLength);f-=b.C;b=0<f?b.Wa(f):new Uint8Array(0);b=new V(b,0);g({parser:this,partialOkay:c||!1,version:h,flags:k,reader:b,size:e,start:d+a});}else b.skip(Math.min(d+e-b.C,b.P.byteLength-b.C));};
function Qg(a){for(var b=null!=a.flags?12:8;a.reader.wa()&&!a.parser.a;)a.parser.qc(a.start+b,a.reader,a.partialOkay);}function Rg(a){var b=null!=a.flags?12:8,c=a.reader.K();c=q(gb(c));for(var d=c.next();!d.done&&(a.parser.qc(a.start+b,a.reader,a.partialOkay),!a.parser.a);d=c.next());}function Sg(a){return function(b){a(b.reader.Wa(b.reader.P.byteLength-b.reader.C));}}function Ng(a){var b=0;a=q(a);for(var c=a.next();!c.done;c=a.next())b=b<<8|c.value.charCodeAt(0);return b}
function Tg(a){return String.fromCharCode(a>>24&255,a>>16&255,a>>8&255,a&255)}K("shaka.util.Mp4Parser",Mg);Mg.typeToString=Tg;Mg.allData=Sg;Mg.sampleDescription=Rg;Mg.children=Qg;Mg.prototype.parseNext=Mg.prototype.qc;Mg.prototype.parse=Mg.prototype.parse;Mg.prototype.stop=Mg.prototype.stop;Mg.prototype.fullBox=Mg.prototype.ea;Mg.prototype.box=Mg.prototype.box;var Og=0,Pg=1;function Ug(a,b,c,d){a=Kc(a,d);if(0!=b||null!=c)a.headers.Range=c?"bytes="+b+"-"+c:"bytes="+b+"-";return a}function Vg(a,b){var c=this;this.s=b;this.o=a;this.i=null;this.f=1;this.c=this.b=null;this.a=new Map;this.h=!1;this.j=null;this.g=!1;this.F=new Rc(function(){return Wg(c)});}Vg.prototype.destroy=function(){return this.F.destroy()};function Wg(a){var b,c,d,e;return J(function(f){if(1==f.a){b=[];c=q(a.a.values());for(d=c.next();!d.done;d=c.next())e=d.value,Xg(e),b.push(Yg(e));return t(f,Promise.all(b),2)}a.a.clear();a.s=null;a.o=null;a.i=null;w(f);})}
Vg.prototype.configure=function(a){this.i=a;this.j=new lc({maxAttempts:Math.max(a.retryParameters.maxAttempts,2),baseDelay:a.retryParameters.baseDelay,backoffFactor:a.retryParameters.backoffFactor,fuzzFactor:a.retryParameters.fuzzFactor,timeout:0},!0);};Vg.prototype.start=function(){var a=this;return J(function(b){if(1==b.a)return t(b,Zg(a),2);Sc(a.F);a.h=!0;w(b);})};
function $g(a,b){var c,d,e,f,g,h;J(function(k){switch(k.a){case 1:return c=Ob,x(k,2),t(k,Ze(a.s.L,c.$),4);case 4:ua(k,3);break;case 2:if(d=C(k),a.s)a.s.onError(d);case 3:e=ed(b.mimeType,b.codecs);Pe(a.s.L,e);f=a.s.L.h;if(g=f.isTextVisible()||a.i.alwaysStreamText)h=ah(b),a.a.set(c.$,h),bh(a,h,0);w(k);}});}function ch(a){var b=a.a.get("text");b&&(Xg(b),Yg(b)["catch"](function(){}),a.a["delete"]("text"));a.c=null;}
function dh(a,b){var c=a.a.get("video");if(c){var d=c.stream;if(d)if(b){var e=d.trickModeVideo;e&&!c.Ya&&(eh(a,e,!1,0,!1),c.Ya=d);}else if(d=c.Ya)c.Ya=null,eh(a,d,!0,0,!1);}}function fh(a,b,c,d){c=void 0===c?!1:c;d=void 0===d?0:d;a.b=b;a.h&&(b.video&&eh(a,b.video,c,d,!1),b.audio&&eh(a,b.audio,c,d,!1));}function gh(a,b){a.c=b;a.h&&eh(a,b,!0,0,!1);}
function eh(a,b,c,d,e){var f=a.a.get(b.type);f||"text"!=b.type?f&&(f.Ya&&(b.trickModeVideo?(f.Ya=b,b=b.trickModeVideo):f.Ya=null),f.stream!=b||e)&&("text"==b.type&&Pe(a.s.L,ed(b.mimeType,b.codecs)),f.stream=b,f.la=null,c&&(f.Ab?f.wc=!0:f.Ma?(f.$a=!0,f.fc=d,f.wc=!0):(Xg(f),hh(a,f,!0,d)["catch"](function(g){if(a.s)a.s.onError(g);}))),ih(a,f)["catch"](function(g){if(a.s)a.s.onError(g);})):$g(a,b);}
function ih(a,b){var c,d;return J(function(e){if(1==e.a){if(!b.ia)return e["return"]();c=b.stream;d=b.ia;return c.segmentIndex?e.u(2):t(e,c.createSegmentIndex(),2)}if(b.ia!=d||b.stream!=c)return e["return"]();var f=a.s.jc();var g=Ue(a.s.L,b.type),h=b.stream.segmentIndex.find(b.pa?b.pa.endTime:f),k=null==h?null:b.stream.segmentIndex.get(h);h=k?k.a?k.a-k.b:null:null;k&&!h&&(h=(k.endTime-k.startTime)*(b.stream.bandwidth||0)/8);h?((k=k.f)&&(h+=(k.a?k.a-k.b:null)||0),k=a.s.getBandwidthEstimate(),f=8*h/
k<(g||0)-f-Math.max(a.o.minBufferTime||0,a.i.rebufferingGoal)||b.ia.b.a>h?!0:!1):f=!1;f&&b.ia.abort();w(e);})}function jh(a,b){b.Ab||b.$a||(b.Ma?(b.$a=!0,b.fc=0):null==Se(a.s.L,b.type)?null==b.Ia&&bh(a,b,0):(Xg(b),hh(a,b,!1,0)["catch"](function(c){if(a.s)a.s.onError(c);})));}
function Zg(a){var b,c,d,e,f,g,h,k,l,m;return J(function(n){if(1==n.a){b=Ob;if(!a.b)throw new M(2,5,5006);c=new Map;d=new Set;a.b.audio&&(c.set(b.fb,a.b.audio),d.add(a.b.audio));a.b.video&&(c.set(b.Da,a.b.video),d.add(a.b.video));a.c&&(c.set(b.$,a.c),d.add(a.c));e=a.s.L;f=a.i.forceTransmuxTS;return t(n,e.init(c,f),2)}Sc(a.F);var r=a.o.presentationTimeline.getDuration();Infinity>r?a.s.L.za(r):a.s.L.za(Math.pow(2,32));g=q(c.keys());for(h=g.next();!h.done;h=g.next())k=h.value,l=c.get(k),a.a.has(k)||
(m=ah(l),a.a.set(k,m),bh(a,m,0));w(n);})}function ah(a){return {stream:a,type:a.type,la:null,pa:null,mc:null,Wc:null,Vc:null,Uc:null,Ya:null,endOfStream:!1,Ma:!1,Ia:null,$a:!1,fc:0,wc:!1,Ab:!1,gd:!1,Ib:!1,ia:null}}
Vg.prototype.Kb=function(a){var b=this,c,d,e,f;return J(function(g){switch(g.a){case 1:Sc(b.F);if(a.Ma||null==a.Ia||a.Ab)return g["return"]();a.Ia=null;if(!a.$a){g.u(2);break}return t(g,hh(b,a,a.wc,a.fc),3);case 3:return g["return"]();case 2:if(a.stream.segmentIndex){g.u(4);break}c=a.stream;return t(g,a.stream.createSegmentIndex(),5);case 5:if(c!=a.stream)return null==a.Ia&&bh(b,a,0),g["return"]();case 4:try{d=kh(b,a),null!=d&&(bh(b,a,d),a.Ib=!1);}catch(h){return lh(b,h),g["return"]()}e=Array.from(b.a.values());
if(!b.h||!e.every(function(h){return h.endOfStream})){g.u(0);break}return t(g,b.s.L.endOfStream(),7);case 7:Sc(b.F),f=b.s.L.getDuration(),0!=f&&f<b.o.presentationTimeline.getDuration()&&b.o.presentationTimeline.za(f),w(g);}})};
function kh(a,b){if(mh(b))return Ye(a.s.L,b.stream.originalId||""),null;var c=a.s.jc(),d=b.pa?b.pa.endTime:c,e=Ve(a.s.L,b.type,c),f=Math.max(a.o.minBufferTime||0,a.i.rebufferingGoal,a.i.bufferingGoal)*a.f;if(d>=a.o.presentationTimeline.getDuration())return b.endOfStream=!0,"video"==b.type&&(c=a.a.get("text"))&&mh(c)&&(c.endOfStream=!0),null;b.endOfStream=!1;if(e>=f)return .5;e=Ue(a.s.L,b.type);e=nh(a,b,c,e);if(!e||!oh(a,e))return 1;f=Infinity;var g=Array.from(a.a.values());g=q(g);for(var h=g.next();!h.done;h=
g.next())h=h.value,mh(h)||(f=Math.min(f,h.pa?h.pa.endTime:c));if(d>=f+a.o.presentationTimeline.a)return 1;ph(a,b,c,e)["catch"](function(){});return null}function nh(a,b,c,d){if(b.la)return b.la.current();if(b.pa||d)return b.la=b.stream.segmentIndex.jb(b.pa?b.pa.endTime:d),b.la.next().value;b.la=b.stream.segmentIndex.jb(Math.max(c-a.i.inaccurateManifestTolerance,0));d=b.la.next().value;d&&oh(a,d)||(b.la=b.stream.segmentIndex.jb(c),d=b.la.next().value);return d}
function oh(a,b){var c=a.o.presentationTimeline,d=c.La();return b.endTime<c.Ra()||b.startTime>d?!1:!0}
function ph(a,b,c,d){var e,f,g,h,k,l,m,n,r;return J(function(u){switch(u.a){case 1:return e=Ob,f=b.stream,g=b.la,b.Ma=!0,h=qh(a,b,d),k=rh(a,b,d),x(u,2),t(u,Promise.all([h,k]),4);case 4:return l=u.b,Sc(a.F),a.g?u["return"]():b.$a?(b.Ma=!1,bh(a,b,0),u["return"]()):t(u,sh(a,b,c,f,d,l[1]),5);case 5:Sc(a.F);if(a.g)return u["return"]();b.pa=d;g.next();b.Ma=!1;b.gd=!1;m=a.s.L.ic();n=m[b.type];JSON.stringify(n);b.$a||a.s.cd();bh(a,b,0);ua(u,0);break;case 2:r=C(u);Sc(a.F,r);if(a.g)return u["return"]();b.Ma=
!1;b.type==e.$&&a.i.ignoreTextStreamFailures?a.a["delete"](e.$):7001==r.code?(b.Ma=!1,b.Ia=null,bh(a,b,0)):3017==r.code?th(a,b,r):(b.Ib=!0,r.severity=2,lh(a,r));w(u);}})}function th(a,b,c){if(!Array.from(a.a.values()).some(function(e){return e!=b&&e.gd})){var d=Math.round(100*a.f);if(20<d)a.f-=.2;else if(4<d)a.f-=.04;else {b.Ib=!0;a.g=!0;a.s.onError(c);return}b.gd=!0;}bh(a,b,4);}
function qh(a,b,c){var d,e,f,g,h,k,l;return J(function(m){d=[];e=Math.max(0,c.appendWindowStart-.1);f=c.appendWindowEnd+.01;g=c.timestampOffset;if(g!=b.Wc||e!=b.Vc||f!=b.Uc)h=function(){var n;return J(function(r){if(1==r.a)return x(r,2),b.Vc=e,b.Uc=f,b.Wc=g,t(r,$e(a.s.L,b.type,g,e,f),4);if(2!=r.a)return ua(r,0);n=C(r);b.Vc=null;b.Uc=null;b.Wc=null;throw n;})},d.push(h());!Wf(c.f,b.mc)&&(b.mc=c.f)&&(k=rh(a,b,c.f),l=function(){var n,r,u;return J(function(v){switch(v.a){case 1:return x(v,2),t(v,k,4);
case 4:return n=v.b,Sc(a.F),r=b.stream.closedCaptions&&0<b.stream.closedCaptions.size,t(v,We(a.s.L,b.type,n,null,null,r),5);case 5:ua(v,0);break;case 2:throw u=C(v),b.mc=null,u;}})},d.push(l()));return t(m,Promise.all(d),0)})}
function sh(a,b,c,d,e,f){var g;return J(function(h){if(1==h.a)return g=d.closedCaptions&&0<d.closedCaptions.size,null!=d.emsgSchemeIdUris&&0<d.emsgSchemeIdUris.length&&(new Mg).ea("emsg",function(k){var l=d.emsgSchemeIdUris,m=k.reader.ed(),n=k.reader.ed(),r=k.reader.K(),u=k.reader.K(),v=k.reader.K(),A=k.reader.K();k=k.reader.Wa(k.reader.P.byteLength-k.reader.C);var y=e.startTime+u/r;l.includes(m)&&("urn:mpeg:dash:event:2012"==m?a.s.Me():(l=new Q(uh,{detail:{startTime:y,endTime:y+v/r,schemeIdUri:m,
value:n,timescale:r,presentationTimeDelta:u,eventDuration:v,id:A,messageData:k}}),a.s.onEvent(l)));}).parse(f),t(h,vh(a,b,c),2);if(3!=h.a)return Sc(a.F),t(h,We(a.s.L,b.type,f,e.startTime,e.endTime,g),3);Sc(a.F);w(h);})}function vh(a,b,c){var d,e,f,g;return J(function(h){if(1==h.a){d=Math.max(a.i.bufferBehind,a.o.presentationTimeline.a);e=Se(a.s.L,b.type);if(null==e)return h["return"]();f=c-e;g=f-d;return .01>=g?h["return"]():t(h,a.s.L.remove(b.type,e,e+g),2)}Sc(a.F);w(h);})}
function mh(a){return a&&"text"==a.type&&"application/cea-608"==a.stream.mimeType}function rh(a,b,c){var d,e,f,g;return J(function(h){if(1==h.a)return d=Qc,e=Ug(c.c(),c.b,c.a,a.i.retryParameters),f=a.s.nb.request(d,e),b.ia=f,t(h,f.promise,2);g=h.b;b.ia=null;return h["return"](g.data)})}
function hh(a,b,c,d){var e,f;return J(function(g){if(1==g.a)return b.$a=!1,b.wc=!1,b.fc=0,b.Ab=!0,b.pa=null,b.mc=null,b.la=null,d?(e=a.s.jc(),f=a.s.L.getDuration(),t(g,a.s.L.remove(b.type,e+d,f),3)):t(g,Ze(a.s.L,b.type),4);if(3!=g.a)return Sc(a.F),c?t(g,a.s.L.flush(b.type),3):g.u(3);Sc(a.F);b.Ab=!1;b.endOfStream=!1;bh(a,b,0);w(g);})}
function bh(a,b,c){var d=b.type;if("text"!=d||a.a.has(d))b.Ia=(new kc(function(){var e;return J(function(f){if(1==f.a)return x(f,2),t(f,a.Kb(b),4);if(2!=f.a)return ua(f,0);e=C(f);if(a.s)a.s.onError(e);w(f);})})).R(c);}function Xg(a){null!=a.Ia&&(a.Ia.stop(),a.Ia=null);}function Yg(a){return J(function(b){return a.ia?t(b,a.ia.abort(),0):b.u(0)})}function lh(a,b){J(function(c){if(1==c.a)return t(c,nc(a.j),2);Sc(a.F);a.s.onError(b);b.handled||a.i.failureCallback(b);w(c);});}function wh(a,b){var c=xh(),d=this;this.h=b;this.c=a;this.f=c;this.j=null;this.g=[];this.b=this.a=null;this.m=Promise.resolve().then(function(){return yh(d)});this.F=new Rc(function(){return zh(d)});}wh.prototype.destroy=function(){return this.F.destroy()};function zh(a){var b,c,d;return J(function(e){if(1==e.a)return a.b&&a.b.abort(),Ah(a),t(e,a.m,2);a.a&&a.a.xa.Va();b=q(a.g);for(c=b.next();!c.done;c=b.next())d=c.value,d.xa.Va();a.a=null;a.g=[];a.h=null;w(e);})}
function Bh(a,b){var c={pb:function(){},nc:function(){},Va:function(){},onError:function(){},pc:function(){},Qf:function(){}};a.g.push({create:b,xa:c});a.b&&a.b.abort();Ah(a);return c}
function yh(a){return J(function(b){if(a.F.a)b=b.u(0);else {if(0==a.g.length||a.a&&!a.a.Sa)var c=!1;else {a.a&&(a.a.xa.Va(),a.a=null);c=a.g.shift();var d=c.create(a.f);d?(c.xa.pb(),a.a={node:d.node,payload:d.payload,Sa:d.Sa,xa:c.xa}):c.xa.pc();c=!0;}c?c=Promise.resolve():a.a?c=Ch(a):(a.h.Le(a.c),a.j=new Pb,c=a.j);b=t(b,c,1);}return b})}
function Ch(a){var b,c;return J(function(d){switch(d.a){case 1:return a.c=a.h.ue(a.c,a.f,a.a.node,a.a.payload),x(d,2),a.b=a.h.je(a.c,a.f,a.a.payload),t(d,a.b.promise,4);case 4:a.b=null;a.c==a.a.node&&(a.a.xa.nc(),a.a=null);ua(d,0);break;case 2:b=C(d);if(7001==b.code)a.a.xa.Va();else a.a.xa.onError(b);a.a=null;a.b=null;c=a;return t(d,a.h.handleError(a.f,b),5);case 5:c.c=d.b,w(d);}})}function Ah(a){a.j&&(a.j.resolve(),a.j=null);}function Dh(a){this.a=null;for(var b=q(Array.from(a.textTracks)),c=b.next();!c.done;c=b.next())c=c.value,c.mode="disabled","Shaka Player TextTrack"==c.label&&(this.a=c);this.a||(this.a=a.addTextTrack("subtitles","Shaka Player TextTrack"));this.a.mode="hidden";}p=Dh.prototype;p.remove=function(a,b){if(!this.a)return !1;Eh(this.a,function(c){return c.startTime<b&&c.endTime>a});return !0};
p.append=function(a){function b(g){return g.spacer?"\n":g.nestedCues.length?g.nestedCues.map(b).join(""):g.payload}var c=a.map(function(g){if(g.nestedCues.length){var h=g.clone();h.nestedCues=[];h.payload=b(g);return h}return g}),d=[];a=this.a.cues?Array.from(this.a.cues):[];var e={};c=q(c);for(var f=c.next();!f.done;e={cb:e.cb},f=c.next())e.cb=f.value,a.some(function(g){return function(h){return h.startTime==g.cb.startTime&&h.endTime==g.cb.endTime&&h.text==g.cb.payload?!0:!1}}(e))||(f=Fh(e.cb))&&
d.push(f);a=d.slice().sort(function(g,h){return g.startTime!=h.startTime?g.startTime-h.startTime:g.endTime!=h.endTime?g.endTime-h.startTime:"line"in VTTCue.prototype?d.indexOf(h)-d.indexOf(g):d.indexOf(g)-d.indexOf(h)});a=q(a);for(e=a.next();!e.done;e=a.next())this.a.addCue(e.value);};p.destroy=function(){this.a&&(Eh(this.a,function(){return !0}),this.a.mode="disabled");this.a=null;return Promise.resolve()};p.isTextVisible=function(){return "showing"==this.a.mode};
p.setTextVisibility=function(a){this.a.mode=a?"showing":"hidden";};
function Fh(a){if(a.startTime>=a.endTime)return null;var b=new VTTCue(a.startTime,a.endTime,a.payload);b.lineAlign=a.lineAlign;b.positionAlign=a.positionAlign;a.size&&(b.size=a.size);try{b.align=a.textAlign;}catch(c){}"center"==a.textAlign&&"center"!=b.align&&(b.align="middle");"vertical-lr"==a.writingMode?b.vertical="lr":"vertical-rl"==a.writingMode&&(b.vertical="rl");1==a.lineInterpretation&&(b.snapToLines=!1);null!=a.line&&(b.line=a.line);null!=a.position&&(b.position=a.position);return b}
function Eh(a,b){var c=a.mode;a.mode="showing"==c?"showing":"hidden";for(var d=q(Array.from(a.cues)),e=d.next();!e.done;e=d.next())(e=e.value)&&b(e)&&a.removeCue(e);a.mode=c;}K("shaka.text.SimpleTextDisplayer",Dh);Dh.prototype.setTextVisibility=Dh.prototype.setTextVisibility;Dh.prototype.isTextVisible=Dh.prototype.isTextVisible;Dh.prototype.destroy=Dh.prototype.destroy;Dh.prototype.append=Dh.prototype.append;Dh.prototype.remove=Dh.prototype.remove;function Gh(){}function Hh(a){for(;a.firstChild;)a.removeChild(a.firstChild);}K("shaka.util.Dom",Gh);Gh.removeAllChildren=Hh;function Ih(a,b){var c=this;this.h=!1;this.f=[];this.a=a;this.g=b;this.b=document.createElement("div");this.b.classList.add("shaka-text-container");this.b.style.textAlign="center";this.b.style.display="flex";this.b.style.flexDirection="column";this.b.style.alignItems="center";this.b.style.justifyContent="flex-end";this.g.appendChild(this.b);this.j=(new N(function(){Jh(c);})).ra(.25);this.c=new Map;}p=Ih.prototype;
p.append=function(a){var b=ia(this.f).concat(),c={};a=q(a);for(var d=a.next();!d.done;c={Sb:c.Sb},d=a.next())c.Sb=d.value,b.some(function(e){return function(f){return ve(f,e.Sb)}}(c))||this.f.push(c.Sb);Jh(this);};p.destroy=function(){this.g.removeChild(this.b);this.b=null;this.h=!1;this.f=[];this.j&&this.j.stop();this.c.clear();};p.remove=function(a,b){if(!this.b)return !1;this.f=this.f.filter(function(c){return c.startTime<a||c.endTime>=b});Jh(this);return !0};p.isTextVisible=function(){return this.h};
p.setTextVisibility=function(a){this.h=a;};
function Jh(a){function b(g){return a.f.includes(g)&&a.h&&g.startTime<=c&&g.endTime>=c}for(var c=a.a.currentTime,d=q(a.c.keys()),e=d.next();!e.done;e=d.next())if(e=e.value,!b(e)){var f=a.c.get(e);a.b.removeChild(f);a.c["delete"](e);}d=new Set(a.c.values());e=q(Array.from(a.b.childNodes));for(f=e.next();!f.done;f=e.next())f=f.value,d.has(f)||a.b.removeChild(f);d=a.f.filter(function(g){return b(g)&&!a.c.has(g)}).sort(function(g,h){return g.startTime!=h.startTime?g.startTime-h.startTime:g.endTime-h.endTime});
d=q(d);for(e=d.next();!e.done;e=d.next())Kh(a,a.b,e.value);}function Lh(a,b,c,d){var e=document.createElement("span");d&&e.classList.add("shaka-nested-cue");Mh(a,e,c,!0);b.appendChild(e);return e}function Kh(a,b,c){if(c.nestedCues.length){var d=document.createElement("p");d.style.width="100%";Mh(a,d,c,!1);for(var e=0;e<c.nestedCues.length;e++)Lh(a,d,c.nestedCues[e],!0);b.appendChild(d);a.c.set(c,d);}else a.c.set(c,Lh(a,b,c,!1));}
function Mh(a,b,c,d){var e=b.style,f=0==c.nestedCues.length;c.spacer?(e.flexBasis="100%",e.height="0"):(e.whiteSpace="pre-line",b.textContent=c.payload,f&&(e.backgroundColor=c.backgroundColor),e.border=c.border,e.color=c.color,e.direction=c.direction,e.opacity=c.opacity,e.paddingLeft=Nh(c.linePadding,c,a.g),e.paddingRight=Nh(c.linePadding,c,a.g),c.backgroundImage&&(e.backgroundImage="url('"+c.backgroundImage+"')",e.backgroundRepeat="no-repeat",e.backgroundSize="contain",e.backgroundPosition="center",
""==c.backgroundColor&&(e.backgroundColor="transparent")),c.backgroundImage&&c.region&&(b=c.region.widthUnits==Be?"%":"px",e.height=c.region.height+(c.region.heightUnits==Be?"%":"px"),e.width=c.region.width+b),e.justifyContent="before"==c.displayAlign?"flex-start":"center"==c.displayAlign?"center":"flex-end",f?e.display="inline-block":(e.display="flex",e.flexDirection="row",e.flexWrap="wrap",e.margin="0",e.alignItems=e.justifyContent,e.justifyContent="center"),d&&(e.maxWidth="100%"),e.fontFamily=
c.fontFamily,e.fontWeight=c.fontWeight.toString(),e.fontStyle=c.fontStyle,e.letterSpacing=c.letterSpacing,e.fontSize=Nh(c.fontSize,c,a.g),c.line?1==c.lineInterpretation&&(e.position="absolute",c.writingMode==pe?c.lineAlign==re?e.top=c.line+"%":"end"==c.lineAlign&&(e.bottom=c.line+"%"):"vertical-lr"==c.writingMode?c.lineAlign==re?e.left=c.line+"%":"end"==c.lineAlign&&(e.right=c.line+"%"):c.lineAlign==re?e.right=c.line+"%":"end"==c.lineAlign&&(e.left=c.line+"%")):c.region&&c.region.id&&!f&&(a=c.region.widthUnits==
Be?"%":"px",d=c.region.viewportAnchorUnits==Be?"%":"px",e.height=c.region.height+(c.region.heightUnits==Be?"%":"px"),e.width=c.region.width+a,e.position="absolute",e.top=c.region.viewportAnchorY+d,e.left=c.region.viewportAnchorX+d),e.lineHeight=c.lineHeight,c.position&&(c.writingMode==pe?e.paddingLeft=c.position:e.paddingTop=c.position),"line-left"==c.positionAlign?e.cssFloat="left":"line-right"==c.positionAlign&&(e.cssFloat="right"),e.textAlign=c.textAlign,e.textDecoration=c.textDecoration.join(" "),
e.writingMode=c.writingMode,c.size&&(c.writingMode==pe?e.width=c.size+"%":e.height=c.size+"%"));}function Nh(a,b,c){var d=(d=(new RegExp(/(\d*\.?\d+)([a-z]+|%+)/)).exec(a))?{value:Number(d[1]),gf:d[2]}:null;if(!d)return a;var e=d.value;switch(d.gf){case "%":return e/100*c.clientHeight/b.cellResolution.rows+"px";case "c":return c.clientHeight*e/b.cellResolution.rows+"px";default:return a}}K("shaka.text.UITextDisplayer",Ih);Ih.prototype.setTextVisibility=Ih.prototype.setTextVisibility;
Ih.prototype.isTextVisible=Ih.prototype.isTextVisible;Ih.prototype.remove=Ih.prototype.remove;Ih.prototype.destroy=Ih.prototype.destroy;Ih.prototype.append=Ih.prototype.append;function Oh(){}
function Ph(a,b,c,d,e){var f=e in d,g=!0,h;for(h in b){var k=e+"."+h,l=f?d[e]:c[h];f||h in c?void 0===b[h]?void 0===l||f?delete a[h]:a[h]=yc(l):l.constructor==Object&&b[h]&&b[h].constructor==Object?(a[h]||(a[h]=yc(l)),k=Ph(a[h],b[h],l,d,k),g=g&&k):typeof b[h]!=typeof l||null==b[h]||"function"!=typeof b[h]&&b[h].constructor!=l.constructor?(Wa("Invalid config, wrong type for "+k),g=!1):("function"==typeof c[h]&&c[h].length!=b[h].length&&Xa("Unexpected number of arguments for "+k),a[h]=b[h]):(Wa("Invalid config, unrecognized key "+
k),g=!1);}return g}function Qh(a,b){for(var c={},d=c,e=0,f=0;;){e=a.indexOf(".",e);if(0>e)break;if(0==e||"\\"!=a[e-1])f=a.substring(f,e).replace(/\\\./g,"."),d[f]={},d=d[f],f=e+1;e+=1;}d[a.substring(f).replace(/\\\./g,".")]=b;return c}K("shaka.util.ConfigUtils",Oh);Oh.convertToConfigObject=Qh;Oh.mergeConfigObjects=Ph;function Rh(){}
function Sh(){var a=1E6,b=Infinity;navigator.connection&&(navigator.connection.downlink&&(a=1E6*navigator.connection.downlink),navigator.connection.saveData&&(b=360));var c={retryParameters:mc(),servers:{},clearKeys:{},advanced:{},delayLicenseRequestUntilPlayed:!1,initDataTransform:Td,logLicenseExchange:!1,updateExpirationTime:1},d={retryParameters:mc(),availabilityWindowOverride:NaN,disableAudio:!1,disableVideo:!1,disableText:!1,defaultPresentationDelay:0,dash:{clockSyncUri:"",ignoreDrmInfo:!1,xlinkFailGracefully:!1,
ignoreMinBufferTime:!1,autoCorrectDrift:!0,initialSegmentLimit:1E3,ignoreSuggestedPresentationDelay:!1,ignoreEmptyAdaptationSet:!1},hls:{ignoreTextStreamFailures:!1,useFullSegmentsForStartTime:!1}},e={retryParameters:mc(),failureCallback:function(h){return [h]},rebufferingGoal:2,bufferingGoal:10,bufferBehind:30,ignoreTextStreamFailures:!1,alwaysStreamText:!1,startAtSegmentBoundary:!1,smallGapLimit:.5,jumpLargeGaps:!1,durationBackoff:1,forceTransmuxTS:!1,safeSeekOffset:5,stallEnabled:!0,stallThreshold:1,
stallSkip:.1,useNativeHlsOnSafari:!0,inaccurateManifestTolerance:2};if(md("Web0S")||ld()||md("CrKey"))e.stallSkip=0;var f={trackSelectionCallback:function(h){return J(function(k){return k["return"](h)})},progressCallback:function(h,k){return [h,k]},usePersistentLicense:!0},g={drm:c,manifest:d,streaming:e,offline:f,abrFactory:function(){return new Af},abr:{enabled:!0,defaultBandwidthEstimate:a,switchInterval:8,bandwidthUpgradeTarget:.85,bandwidthDowngradeTarget:.95,restrictions:{minWidth:0,maxWidth:Infinity,
minHeight:0,maxHeight:b,minPixels:0,maxPixels:Infinity,minFrameRate:0,maxFrameRate:Infinity,minBandwidth:0,maxBandwidth:Infinity}},preferredAudioLanguage:"",preferredTextLanguage:"",preferredVariantRole:"",preferredTextRole:"",preferredAudioChannelCount:2,restrictions:{minWidth:0,maxWidth:Infinity,minHeight:0,maxHeight:Infinity,minPixels:0,maxPixels:Infinity,minFrameRate:0,maxFrameRate:Infinity,minBandwidth:0,maxBandwidth:Infinity},playRangeStart:0,playRangeEnd:Infinity,textDisplayFactory:function(){return null}};
f.trackSelectionCallback=function(h){return J(function(k){return k["return"](Th(h,g.preferredAudioLanguage))})};return g}function Uh(a,b,c){var d={".drm.servers":"",".drm.clearKeys":"",".drm.advanced":{distinctiveIdentifierRequired:!1,persistentStateRequired:!1,videoRobustness:"",audioRobustness:"",serverCertificate:new Uint8Array(0),individualizationServer:""}};return Ph(a,b,c||Sh(),d,"")}
function Th(a,b){var c=a.filter(function(h){return "variant"==h.type}),d=[],e=kf(b,c.map(function(h){return h.language}));e&&(d=c.filter(function(h){return R(h.language)==e}));0==d.length&&(d=c.filter(function(h){return h.primary}));0==d.length&&(c.map(function(h){return h.language}),d=c);var f=d.filter(function(h){return h.height&&480>=h.height});f.length&&(f.sort(function(h,k){return k.height-h.height}),d=f.filter(function(h){return h.height==f[0].height}));c=[];if(d.length){var g=Math.floor(d.length/
2);d.sort(function(h,k){return h.bandwidth-k.bandwidth});c.push(d[g]);}d=q(a);for(g=d.next();!g.done;g=d.next())g=g.value,"text"==g.type&&c.push(g);return c}K("shaka.util.PlayerConfiguration",Rh);Rh.mergeConfigObjects=Uh;function Vh(){this.a=null;this.b=[];}function Wh(a,b){if(null==a.a)a.a={timestamp:Date.now()/1E3,state:b,duration:0};else {var c=Date.now()/1E3;a.a.duration=c-a.a.timestamp;a.a.state!=b&&(a.b.push(a.a),a.a={timestamp:c,state:b,duration:0});}}function Xh(a,b){var c=0;a.a&&a.a.state==b&&(c+=a.a.duration);for(var d=q(a.b),e=d.next();!e.done;e=d.next())e=e.value,c+=e.state==b?e.duration:0;return c}
function Yh(a){function b(f){return {timestamp:f.timestamp,state:f.state,duration:f.duration}}for(var c=[],d=q(a.b),e=d.next();!e.done;e=d.next())c.push(b(e.value));a.a&&c.push(b(a.a));return c}function Zh(){this.b=this.c=null;this.a=[];}function $h(a,b,c){a.c!=b&&(a.c=b,a.a.push({timestamp:Date.now()/1E3,id:b.id,type:"variant",fromAdaptation:c,bandwidth:b.bandwidth}));}function ai(a,b,c){a.b!=b&&(a.b=b,a.a.push({timestamp:Date.now()/1E3,id:b.id,type:"text",fromAdaptation:c,bandwidth:null}));}function bi(){this.g=this.h=this.A=this.m=this.D=this.c=this.v=this.f=this.H=this.I=this.J=this.j=this.M=NaN;this.b=new Vh;this.a=new Zh;}function W(a,b){xc.call(this);var c=this;this.g=ci;this.cc=this.a=null;this.T=!1;this.b=new Tc;this.Ic=this.j=this.xb=this.o=this.ac=this.m=this.c=this.bc=this.D=this.Yb=this.A=this.Ba=this.v=this.H=this.h=this.N=null;this.vd=1E9;this.i=di(this);this.xc={width:Infinity,height:Infinity};this.f=null;this.yb=new Hf(this.i.preferredAudioLanguage,this.i.preferredVariantRole,this.i.preferredAudioChannelCount);this.ca=this.i.preferredTextLanguage;this.Zb=this.i.preferredTextRole;this.Jc=[];b&&b(this);this.N=
ei(this);this.I=null;fi&&(this.I=Lb(fi));this.b.l(window,"online",function(){c.hd();});this.da={name:"detach"};this.Ea={name:"attach"};this.M={name:"unload"};this.Oc={name:"manifest-parser"};this.Nc={name:"manifest"};this.ta={name:"media-source"};this.Kc={name:"drm-engine"};this.J={name:"load"};this.Pc={name:"src-equals-drm-engine"};this.Ca={name:"src-equals"};var d=new Map;d.set(this.Ea,function(e,f){return sc(gi(c,e,f))});d.set(this.da,function(e){e.B&&(c.b.sa(e.B,"error"),e.B=null);c.a=null;e=Promise.resolve();
return sc(e)});d.set(this.M,function(e){return sc(hi(c,e))});d.set(this.ta,function(e){e=ii(c,e);return sc(e)});d.set(this.Oc,function(e,f){var g=ji(c,e,f);return sc(g)});d.set(this.Nc,function(e){return ki(c,e)});d.set(this.Kc,function(){var e=li(c);return sc(e)});d.set(this.J,function(e,f){return sc(mi(c,e,f))});d.set(this.Pc,function(e){e=ni(c,e);return sc(e)});d.set(this.Ca,function(e,f){return oi(c,e,f)});this.W=new wh(this.da,{ue:function(e,f,g,h){var k=null;e==c.da&&(k=g==c.da?c.da:c.Ea);e==
c.Ea&&(k=g==c.da||f.B!=h.B?c.da:g==c.Ea?c.Ea:g==c.ta||g==c.J?c.ta:g==c.Ca?c.Pc:null);e==c.ta&&(k=g==c.J&&f.B==h.B?c.Oc:c.M);e==c.Oc&&(k=pi(c.J,c.Nc,c.M,g,f,h));e==c.Nc&&(k=pi(c.J,c.Kc,c.M,g,f,h));e==c.Kc&&(k=pi(c.J,c.J,c.M,g,f,h));e==c.Pc&&(k=g==c.Ca&&f.B==h.B?c.Ca:c.M);if(e==c.J||e==c.Ca)k=c.M;e==c.M&&(k=h.B&&f.B==h.B?c.Ea:c.da);return k},je:function(e,f,g){c.dispatchEvent(qi(ri,{state:e.name}));return d.get(e)(f,g)},handleError:function(e){return J(function(f){return 1==f.a?t(f,hi(c,e),2):f["return"](e.B?
c.Ea:c.da)})},Le:function(e){c.dispatchEvent(qi(si,{state:e.name}));}});a&&this.zb(a,!0);}pa(W,xc);function qi(a,b){return new Q(a,b)}p=W.prototype;
p.destroy=function(){var a=this,b;return J(function(c){switch(c.a){case 1:if(a.g==ti)return c["return"]();a.g=ti;b=Bh(a.W,function(){return {node:a.da,payload:xh(),Sa:!1}});return t(c,new Promise(function(d){b.pb=function(){};b.nc=function(){d();};b.Va=function(){d();};b.onError=function(){d();};b.pc=function(){d();};}),2);case 2:return t(c,a.W.destroy(),3);case 3:a.b&&(a.b.release(),a.b=null);a.Ic=null;a.j=null;a.i=null;a.f=null;a.cc=null;if(!a.N){c.u(0);break}return t(c,a.N.destroy(),5);case 5:a.N=null,
w(c);}})};p.zb=function(a,b){b=void 0===b?!0:b;if(this.g==ti)return Promise.reject(ui());var c=xh();c.B=a;id()||(b=!1);var d=b?this.ta:this.Ea,e=Bh(this.W,function(){return {node:d,payload:c,Sa:!1}});e.pb=function(){};return vi(e)};p.detach=function(){var a=this;if(this.g==ti)return Promise.reject(ui());var b=Bh(this.W,function(){return {node:a.da,payload:xh(),Sa:!1}});b.pb=function(){};return vi(b)};
p.td=function(a){var b=this;a=void 0===a?!0:a;if(this.g==ti)return Promise.reject(ui());id()||(a=!1);var c=xh(),d=Bh(this.W,function(e){var f=e.B&&a?b.ta:e.B?b.Ea:b.da;c.B=e.B;return {node:f,payload:c,Sa:!1}});d.pb=function(){};return vi(d)};
p.load=function(a,b,c){var d=this;if(this.g==ti)return Promise.reject(ui());this.dispatchEvent(qi(wi));var e=xh();e.uri=a;e.qd=Date.now()/1E3;c&&(e.mimeType=c);void 0!==b&&(e.startTime=b);var f=xi(this,e)?this.Ca:this.J,g=Bh(this.W,function(h){if(null==h.B)return null;e.B=h.B;return {node:f,payload:e,Sa:!0}});this.f=new bi;g.pb=function(){};return new Promise(function(h,k){g.pc=function(){return k(new M(2,7,7002))};g.nc=function(){h();d.dispatchEvent(qi(yi));};g.Va=function(){return k(ui())};g.onError=
function(l){return k(l)};})};
function xi(a,b){if(!id())return !0;var c=b.mimeType,d=b.uri||"";c||(c={mp4:"video/mp4",m4v:"video/mp4",m4a:"audio/mp4",webm:"video/webm",weba:"audio/webm",mkv:"video/webm",ts:"video/mp2t",ogv:"video/ogg",ogg:"audio/ogg",mpg:"video/mpeg",mpeg:"video/mpeg",m3u8:"application/x-mpegurl",mp3:"audio/mpeg",aac:"audio/aac",flac:"audio/flac",wav:"audio/wav"}[Sf(d)]);return c?""==(b.B||kd()).canPlayType(c)?!1:id()&&(c in Rf||Sf(d)in Tf)?nd()&&a.i.streaming.useNativeHlsOnSafari:!0:!1}
function gi(a,b,c){null==b.B&&(b.B=c.B,a.b.l(b.B,"error",function(){var d=zi(a);d&&Ai(a,d);}));a.a=b.B;return Promise.resolve()}
function hi(a,b){var c,d,e,f,g,h,k,l,m;return J(function(n){switch(n.a){case 1:return a.g!=ti&&(a.g=ci),c=a.Jc.map(function(r){return r()}),a.Jc=[],t(n,Promise.all(c),2);case 2:a.dispatchEvent(qi(Bi));b.mimeType=null;b.startTime=null;b.uri=null;b.B&&(a.b.sa(b.B,"loadedmetadata"),a.b.sa(b.B,"playing"),a.b.sa(b.B,"pause"),a.b.sa(b.B,"ended"),a.b.sa(b.B,"ratechange"));a.Ba&&(a.Ba.release(),a.Ba=null);a.Yb&&(a.Yb.stop(),a.Yb=null);if(!a.m){n.u(3);break}return t(n,a.m.stop(),4);case 4:a.m=null,a.ac=null;
case 3:if(!a.j){n.u(5);break}return t(n,a.j.stop(),5);case 5:if(!a.c){n.u(7);break}return t(n,a.c.destroy(),8);case 8:a.c=null;case 7:a.A&&(a.A.release(),a.A=null);a.v&&(a.v.release(),a.v=null);if(!a.H){n.u(9);break}return t(n,a.H.destroy(),10);case 10:a.H=null;case 9:if(a.I)a.I.onAssetUnload();if(!b.B||!b.B.src){n.u(11);break}return t(n,new Promise(function(r){return (new N(r)).R(.1)}),12);case 12:b.B.removeAttribute("src"),b.B.load();case 11:if(!a.h){n.u(13);break}return t(n,a.h.destroy(),14);case 14:a.h=
null;case 13:a.xb=null;a.D=null;if(a.o){d=q(a.o.variants);for(e=d.next();!e.done;e=d.next())for(f=e.value,g=q([f.audio,f.video]),h=g.next();!h.done;h=g.next())(k=h.value)&&k.segmentIndex&&k.segmentIndex.release();l=q(a.o.textStreams);for(h=l.next();!h.done;h=l.next())m=h.value,m.segmentIndex&&m.segmentIndex.release();}a.o=null;a.f=new bi;a.Lc=null;Ci(a);w(n);}})}
function ii(a,b){var c,d,e,f;return J(function(g){if(1==g.a)return c=window.muxjs?new de:new ee,d=a.i.textDisplayFactory,e=Lb(d),a.Lc=d,f=Di(b.B,c,e,function(h,k,l){h=q(h);for(var m=h.next();!m.done;m=h.next())if(m=m.value,m.data&&m.cueTime&&m.frames){for(var n=m.cueTime+k,r=l,u=q(m.frames),v=u.next();!v.done;v=u.next())Ei(a,n,r,"ID3",v.value);if(a.I)a.I.onHlsTimedMetadata(m,n);}}),t(g,f.A,2);a.H=f;w(g);})}
function ji(a,b,c){var d,e,f,g;return J(function(h){if(1==h.a)return b.mimeType=c.mimeType,b.uri=c.uri,d=b.uri,e=a.N,a.xb=d,f=a,t(h,Qf(d,e,a.i.manifest.retryParameters,b.mimeType),2);f.ac=h.b;a.m=Lb(a.ac);g=yc(a.i.manifest);c.B&&"AUDIO"===c.B.nodeName&&(g.disableVideo=!0);a.m.configure(g);w(h);})}
function ki(a,b){var c=b.uri,d=a.N;a.bc=new Gg(function(){return a.jd()});Hg(a.bc,function(g){Fi(a,Gi,g);if(a.I)a.I.onDashTimedMetadata(g);});var e={networkingEngine:d,filter:function(g){return J(function(h){return h["return"](a.gb(g))})},makeTextStreamsForClosedCaptions:function(g){return Hi(a,g)},onTimelineRegionAdded:function(g){var h=a.bc;a:{var k=q(h.a);for(var l=k.next();!l.done;l=k.next())if(l=l.value,l.schemeIdUri==g.schemeIdUri&&l.id==g.id&&l.startTime==g.startTime&&l.endTime==g.endTime){k=
l;break a}k=null;}null==k&&(h.a.add(g),h.b(g));},onEvent:function(g){return a.dispatchEvent(g)},onError:function(g){return Ai(a,g)}},f=Date.now()/1E3;return new oc(function(){var g,h,k,l;return J(function(m){if(1==m.a)return g=a,t(m,a.m.start(c,e),2);g.o=m.b;h=qi(Ii);a.dispatchEvent(h);if(0==a.o.variants.length)throw new M(2,4,4036);Ji(a.o);k=Date.now()/1E3;l=k-f;a.f.v=l;w(m);})}(),function(){return a.m.stop()})}
function li(a){var b,c;return J(function(d){if(1==d.a)return b=Date.now()/1E3,c=!0,a.h=Ki(a,{nb:a.N,onError:function(e){Ai(a,e);},oc:function(e){Li(a,e);},onExpirationUpdated:function(e,f){Mi(a,e,f);},onEvent:function(e){a.dispatchEvent(e);e.type==Ni&&c&&(c=!1,a.f.c=Date.now()/1E3-b);}}),a.h.configure(a.i.drm),t(d,yd(a.h,a.o.variants,a.o.offlineSessionIds),2);a.gb(a.o);w(d);})}
function mi(a,b,c){var d,e,f,g,h,k,l,m,n,r;return J(function(u){switch(u.a){case 1:return b.startTime=c.startTime,d=b.B,e=b.uri,a.xb=e,a.A=new wg({kc:function(){return b.B.playbackRate},od:function(v){b.B.playbackRate=v;},Kd:function(v){b.B.currentTime+=v;}}),f=function(){return Oi(a)},g=function(){return Pi(a)},a.b.l(d,"playing",f),a.b.l(d,"pause",f),a.b.l(d,"ended",f),a.b.l(d,"ratechange",g),h=a.i.abrFactory,a.j&&a.Ic==h||(a.Ic=h,a.j=Lb(h),"function"!=typeof a.j.playbackRateChanged&&(Eb("AbrManager",
"Please use an AbrManager with playbackRateChanged function."),a.j.playbackRateChanged=function(){}),a.j.configure(a.i.abr)),a.yb=new Hf(a.i.preferredAudioLanguage,a.i.preferredVariantRole,a.i.preferredAudioChannelCount),a.ca=a.i.preferredTextLanguage,Qi(a.o.presentationTimeline,a.i.playRangeStart,a.i.playRangeEnd),t(u,a.h.zb(d),2);case 2:a.j.init(function(v,A,y){A=void 0===A?!1:A;y=void 0===y?0:y;a.c&&v!=a.c.b&&($h(a.f.a,v,!0),fh(a.c,v,A,y),Ri(a));});a.v=Si(a,b.startTime);a.Ba=Ti(a);k=Math.max(a.o.minBufferTime,
a.i.streaming.rebufferingGoal);Ui(a,k);lf(a.o,a.i.preferredAudioChannelCount);a.c=Vi(a);a.c.configure(a.i.streaming);a.g=Wi;a.dispatchEvent(qi(Xi));l=Yi(a)?a.j.chooseVariant():null;$h(a.f.a,l,!0);fh(a.c,l,!1,0);(m=yf(a.o.textStreams,a.ca,a.Zb)[0]||null)&&ai(a.f.a,m,!0);m?(l.audio&&Zi(a,l.audio,m)&&(a.T=!0),a.T&&a.H.h.setTextVisibility(!0),$i(a)):a.T=!1;m&&(a.i.streaming.alwaysStreamText||a.Tc())&&gh(a.c,m);if(!a.i.streaming.startAtSegmentBoundary){u.u(3);break}n=a.v.g();return t(u,aj(l,n),4);case 4:r=
u.b,a.v.m(r);case 3:return t(u,a.c.start(),5);case 5:a.i.abr.enabled&&(a.j.enable(),bj(a)),a.gb(a.o),cj(a),Ri(a),Yi(a),a.o.variants.some(function(v){return v.primary}),a.b.ha(d,"loadedmetadata",function(){a.f.f=Date.now()/1E3-c.qd;}),w(u);}})}
function ni(a,b){var c,d,e,f;return J(function(g){return 1==g.a?(c=Ob,d=Date.now()/1E3,e=!0,a.h=Ki(a,{nb:a.N,onError:function(h){Ai(a,h);},oc:function(h){Li(a,h);},onExpirationUpdated:function(h,k){Mi(a,h,k);},onEvent:function(h){a.dispatchEvent(h);h.type==Ni&&e&&(e=!1,a.f.c=Date.now()/1E3-d);}}),a.h.configure(a.i.drm),f={id:0,language:"und",primary:!1,audio:null,video:{id:0,originalId:null,createSegmentIndex:function(){return Promise.resolve()},segmentIndex:null,mimeType:"video/mp4",codecs:"",encrypted:!0,
drmInfos:[],keyIds:new Set,language:"und",label:null,type:c.Da,primary:!1,trickModeVideo:null,emsgSchemeIdUris:null,roles:[],channelsCount:null,audioSamplingRate:null,closedCaptions:null},bandwidth:100,allowedByApplication:!0,allowedByKeySystem:!0},t(g,yd(a.h,[f],[]),2)):t(g,a.h.zb(b.B),0)})}
function oi(a,b,c){function d(){return Oi(a)}b.uri=c.uri;b.startTime=c.startTime;a.xb=b.uri;a.v=new mg(b.B);null!=b.startTime&&a.v.m(b.startTime);a.A=new wg({kc:function(){return b.B.playbackRate},od:function(g){b.B.playbackRate=g;},Kd:function(g){b.B.currentTime+=g;}});Ui(a,a.i.streaming.rebufferingGoal);a.b.l(b.B,"playing",d);a.b.l(b.B,"pause",d);a.b.l(b.B,"ended",d);a.b.l(b.B,"ratechange",function(){return Pi(a)});"none"!=a.a.preload&&a.b.ha(a.a,"loadedmetadata",function(){a.f.f=Date.now()/1E3-c.qd;});
a.a.audioTracks&&(a.b.l(a.a.audioTracks,"addtrack",function(){return cj(a)}),a.b.l(a.a.audioTracks,"removetrack",function(){return cj(a)}),a.b.l(a.a.audioTracks,"change",function(){return cj(a)}));a.a.textTracks&&(a.b.l(a.a.textTracks,"addtrack",function(g){cj(a);dj(a,g);}),a.b.l(a.a.textTracks,"removetrack",function(){return cj(a)}),a.b.l(a.a.textTracks,"change",function(){return cj(a)}));b.B.src=b.uri;(ld()||md("Web0S"))&&b.B.load();a.g=ej;a.dispatchEvent(qi(Xi));var e=new Pb;dg(a.a,HTMLMediaElement.HAVE_METADATA,
a.b,function(){e.resolve();});var f=!1;a.Jc.push(function(){f=!0;});dg(a.a,HTMLMediaElement.HAVE_CURRENT_DATA,a.b,function(){var g;return J(function(h){if(1==h.a){if(f)return h["return"]();fj(a);g=gj(a);return g.find(function(k){return "disabled"!=k.mode})?h.u(2):t(h,new Promise(function(k){a.b.ha(a.a.textTracks,"change",k);(new N(k)).R(1);}),2)}if(f)return h["return"]();hj(a);w(h);})});a.a.error?e.reject(zi(a)):"none"==a.a.preload&&(Xa('With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.'),
e.resolve());a.b.ha(a.a,"error",function(){e.reject(zi(a));});return new oc(e,function(){e.reject(new M(2,7,7001));return Promise.resolve()})}function fj(a){var b=a.i.preferredAudioLanguage;if(""!=b){a.kd(b);var c=a.i.preferredVariantRole;""!=c&&a.kd(b,c);}}function hj(a){var b=a.i.preferredTextLanguage;if(""!=b){a.ld(b);var c=a.i.preferredTextRole;""!=c&&a.ld(b,c);}}
function dj(a,b){var c=b.track;"metadata"==c.kind&&(c.mode="hidden",a.b.l(c,"cuechange",function(){if(c.activeCues)for(var d=q(c.activeCues),e=d.next();!e.done;e=d.next())if(e=e.value,Ei(a,e.startTime,e.endTime,e.type,e.value),a.I)a.I.onCueMetadataChange(e.value);}),(new N(function(){var d=ij(a);d=q(d);for(var e=d.next();!e.done;e=d.next())e.value.mode="hidden";})).Qb().R(.5));}function Ei(a,b,c,d,e){a.dispatchEvent(qi(jj,{startTime:b,endTime:c,Of:d,payload:e}));}
function Ji(a){function b(c){return c.video&&c.audio||c.video&&c.video.codecs.includes(",")}a.variants.some(b)&&(a.variants=a.variants.filter(b));}function Ki(a,b){return new rd(b,a.i.drm.updateExpirationTime)}function ei(a){return new Gc(function(b,c){a.j&&a.j.segmentDownloaded(b,c);})}
function Si(a,b){return new ng(a.a,a.o,a.i.streaming,b,function(){a.Ba&&zg(a.Ba,!0);if(a.c)for(var c=a.c,d=c.s.jc(),e=c.i.smallGapLimit,f=q(c.a.keys()),g=f.next();!g.done;g=f.next()){g=g.value;var h=c.a.get(g);h.la=null;var k=c.s.L;"text"==g?(k=k.c,k=null==k.a||null==k.b?!1:d>=k.a&&d<k.b):(k=Te(k,g),k=ge(k,d,e));k||(null!=Ue(c.s.L,g)&&jh(c,h),h.ia&&(h.ia.abort(),h.ia=null),"text"===g&&c.s.L.v.c());}a.D&&kj(a);},function(c){return a.dispatchEvent(c)})}
function Ti(a){var b=new Ig(a.bc);Jg(b,function(d){Fi(a,lj,d);},function(d){Fi(a,mj,d);},function(d,e){e||(Fi(a,lj,d),Fi(a,mj,d));});var c=new yg(a.a);c.a.add(b);return c}function Ui(a,b){a.D=new Lf;a.D.a=Nf;Of(a.D,b,Math.min(.5,b/2));Ci(a);a.Yb=(new N(function(){kj(a);})).ra(.25);}
function kj(a){switch(a.g){case ej:if(a.a.ended)var b=!0;else {var c=fe(a.a.buffered);b=null!=c&&c>=a.a.duration-1;}break;case Wi:a:if(a.a.ended||Re(a.H))b=!0;else {if(a.o.presentationTimeline.S()){c=a.o.presentationTimeline.La();var d=fe(a.a.buffered);if(null!=d&&d>=c){b=!0;break a}}b=!1;}break;default:b=!1;}d=he(a.a.buffered,a.a.currentTime);c=a.D;var e=b,f=c.b.get(c.a);b=c.a;d=e||d>=f?Mf:Nf;c.a=d;b!=d&&Ci(a);}function Di(a,b,c,d){return new Ke(a,b,c,d)}
function Vi(a){return new Vg(a.o,{jc:function(){return a.v.g()},getBandwidthEstimate:function(){return a.j.getBandwidthEstimate()},L:a.H,nb:a.N,onError:function(b){return Ai(a,b)},onEvent:function(b){return a.dispatchEvent(b)},Me:function(){a.m&&a.m.update&&a.m.update();},cd:function(){a.v&&a.v.v();kj(a);}})}
p.configure=function(a,b){2==arguments.length&&"string"==typeof a&&(a=Qh(a,b));a.manifest&&a.manifest.dash&&"defaultPresentationDelay"in a.manifest.dash&&(Eb("manifest.dash.defaultPresentationDelay configuration","Please Use manifest.defaultPresentationDelay instead."),a.manifest.defaultPresentationDelay=a.manifest.dash.defaultPresentationDelay,delete a.manifest.dash.defaultPresentationDelay);var c=Uh(this.i,a,di(this));nj(this);return c};
function nj(a){if(a.m){var b=yc(a.i.manifest);a.a&&"AUDIO"===a.a.nodeName&&(b.disableVideo=!0);a.m.configure(b);}a.h&&a.h.configure(a.i.drm);if(a.c){a.c.configure(a.i.streaming);try{a.gb(a.o);}catch(f){Ai(a,f);}a.j&&Yi(a);b=a.c.b;!b||b.allowedByApplication&&b.allowedByKeySystem||oj(a);}if(a.H&&(b=a.i.textDisplayFactory,a.Lc!=b)){var c=Lb(b),d=a.H,e=d.h;d.h=c;e&&(c.setTextVisibility(e.isTextVisible()),e.destroy());d.c&&(d.c.c=c);a.Lc=b;a.c&&(b=a.c,(c=b.a.get("text"))&&eh(b,c.stream,!0,0,!0));}a.j&&(a.j.configure(a.i.abr),
a.i.abr.enabled?a.j.enable():a.j.disable(),bj(a));a.D&&(b=a.i.streaming.rebufferingGoal,a.o&&(b=Math.max(b,a.o.minBufferTime)),Of(a.D,b,Math.min(.5,b/2)));}p.getConfiguration=function(){var a=di(this);Uh(a,this.i,di(this));return a};p.Ve=function(){for(var a in this.i)delete this.i[a];Uh(this.i,di(this),di(this));nj(this);};p.pe=function(){return this.g};p.te=function(){return this.a};p.Fb=function(){return this.N};p.Qc=function(){return this.xb};
p.Dd=function(){Ya("getAdManager","Shaka Player's ad features are currently in BETA and are NOT yet covered by semantic versioning compatibility guarantees.  The API may change at any time!");return this.I};p.S=function(){return this.o?this.o.presentationTimeline.S():this.a&&this.a.src?Infinity==this.a.duration:!1};p.Ua=function(){return this.o?this.o.presentationTimeline.Ua():!1};
p.Ge=function(){if(this.o){var a=this.o.variants;return a.length?!a[0].video:!1}return this.a&&this.a.src?this.a.videoTracks?0==this.a.videoTracks.length:0==this.a.videoHeight:!1};p.jd=function(){if(this.o){var a=this.o.presentationTimeline;return {start:a.kb(),end:a.Fa()}}return this.a&&this.a.src&&(a=this.a.seekable,a.length)?{start:a.start(0),end:a.end(a.length-1)}:{start:0,end:0}};p.keySystem=function(){return Md(this.drmInfo())};p.drmInfo=function(){return this.h?this.h.c:null};
p.Eb=function(){return this.h?this.h.Eb():Infinity};p.Sc=function(){return this.D?this.D.a==Nf:!1};p.ve=function(){return this.a?this.A?this.A.b:1:0};p.ff=function(a){0==a?Xa("A trick play rate of 0 is unsupported!"):(this.a.paused&&this.a.play(),this.A.set(a),this.g==Wi&&(this.j.playbackRateChanged(a),dh(this.c,1<Math.abs(a))));};p.ee=function(){this.g==ej&&this.A.set(1);this.g==Wi&&(this.A.set(1),this.j.playbackRateChanged(1),dh(this.c,!1));};
p.Rc=function(){if(this.o){for(var a=this.c?this.c.b:null,b=[],c=q(this.o.variants),d=c.next();!d.done;d=c.next())if(d=d.value,wf(d)){var e=qf(d);e.active=d==a;b.push(e);}return b}return this.a&&this.a.audioTracks?Array.from(this.a.audioTracks).map(function(f){return uf(f)}):[]};
p.lc=function(){if(this.o){for(var a=this.c?this.c.c:null,b=[],c=q(this.o.textStreams),d=c.next();!d.done;d=c.next()){d=d.value;var e=rf(d);e.active=d==a;b.push(e);}return b}return this.a&&this.a.src&&this.a.textTracks?gj(this).map(function(f){var g=vf(f);g.active="disabled"!=f.mode;g.type="text";g.originalTextId=f.id;"captions"==f.kind&&(g.mimeType="application/cea-608");f.kind&&(g.roles=[f.kind]);return g}):[]};
p.Sd=function(a){if(this.o&&this.c){var b=this.o.textStreams.find(function(d){return d.id==a.id});b&&b!=this.c.c&&(ai(this.f.a,b,!1),gh(this.c,b),pj(this),this.ca=b.language);}else if(this.a&&this.a.src&&this.a.textTracks){b=gj(this);b=q(b);for(var c=b.next();!c.done;c=b.next())c=c.value,sf(c)==a.id?c.mode=this.T?"showing":"hidden":c.mode="disabled";pj(this);}};
p.We=function(a,b,c){b=void 0===b?!1:b;c=void 0===c?0:c;if(this.o&&this.c){this.i.abr.enabled&&Xa("Changing tracks while abr manager is enabled will likely result in the selected track being overriden. Consider disabling abr before calling selectVariantTrack().");var d=this.o.variants.find(function(e){return e.id==a.id});d&&wf(d)&&d!=this.c.b&&($h(this.f.a,d,!1),fh(this.c,d,b,c),qj(this),this.yb=new Gf(d),Yi(this));}else if(this.a&&this.a.audioTracks){b=Array.from(this.a.audioTracks);b=q(b);for(c=
b.next();!c.done;c=b.next())c=c.value,sf(c)==a.id&&(c.enabled=!0);qj(this);}};p.le=function(){return rj(this.Rc())};p.De=function(){return rj(this.lc())};p.ke=function(){return Array.from(sj(this.Rc()))};p.Ce=function(){return Array.from(sj(this.lc()))};
p.kd=function(a,b){if(this.o&&this.v)this.yb=new Hf(a,b||"",0,""),oj(this);else if(this.a&&this.a.audioTracks){var c=Array.from(this.a.audioTracks),d=R(a),e=null,f=null;c=q(c);for(var g=c.next();!g.done;g=c.next()){g=g.value;var h=uf(g);R(h.language)==d&&(e=g,b?h.roles.includes(b)&&(f=g):0==h.roles.length&&(f=g));}f?(f.enabled=!0,qj(this)):e&&(e.enabled=!0,qj(this));}};
p.ld=function(a,b){if(this.o&&this.v){this.ca=a;this.Zb=b||"";var c=yf(this.o.textStreams,this.ca,this.Zb)[0]||null;c&&c!=this.c.c&&(ai(this.f.a,c,!1),this.i.streaming.alwaysStreamText||this.Tc())&&(gh(this.c,c),pj(this));}else {var d=R(a);(c=this.lc().find(function(e){return R(e.language)==d&&(!b||e.roles.includes(b))}))&&this.Sd(c);}};
p.Xe=function(a){if(this.o&&this.v){for(var b=null,c=q(this.o.variants),d=c.next();!d.done;d=c.next())if(d=d.value,d.audio.label==a){b=d;break}null!=b&&(this.yb=new Hf(b.language,"",0,a),oj(this));}};p.Tc=function(){var a=this.T;return this.H?this.H.h.isTextVisible():this.a&&this.a.src&&this.a.textTracks?gj(this).some(function(b){return "showing"==b.mode}):a};
function gj(a){return Array.from(a.a.textTracks).filter(function(b){return "metadata"!=b.kind&&"chapters"!=b.kind&&"Shaka Player TextTrack"!=b.label})}function ij(a){return Array.from(a.a.textTracks).filter(function(b){return "metadata"==b.kind})}
p.cf=function(a){a=!!a;if(this.T!=a){this.T=a;if(this.g==Wi)this.H.h.setTextVisibility(a),this.i.streaming.alwaysStreamText||(a?this.c.c||(a=yf(this.o.textStreams,this.ca,this.Zb),0<a.length&&(gh(this.c,a[0]),pj(this))):ch(this.c));else if(this.a&&this.a.src&&this.a.textTracks){var b=gj(this);b=q(b);for(var c=b.next();!c.done;c=b.next())c=c.value,"disabled"!=c.mode&&(c.mode=a?"showing":"hidden");}$i(this);}};
p.xe=function(){if(!this.S())return null;var a=this.W.f,b=0;if(this.v)b=this.v.g();else if(a){if(null==a.startTime)return new Date;b=a.startTime;}return this.o?new Date(1E3*(this.o.presentationTimeline.f+b)):this.a&&this.a.getStartDate?(a=this.a.getStartDate(),isNaN(a.getTime())?null:new Date(a.getTime()+1E3*b)):null};
p.Ed=function(){if(!this.S())return null;if(this.o)return new Date(1E3*this.o.presentationTimeline.f);if(this.a&&this.a.getStartDate){var a=this.a.getStartDate();return isNaN(a.getTime())?null:a}return null};p.ic=function(){if(this.g==Wi)return this.H.ic();var a={total:[],audio:[],video:[],text:[]};this.g==ej&&(a.total=ie(this.a.buffered));return a};
p.getStats=function(){if(this.g!=Wi&&this.g!=ej)return {width:NaN,height:NaN,streamBandwidth:NaN,decodedFrames:NaN,droppedFrames:NaN,corruptedFrames:NaN,estimatedBandwidth:NaN,loadLatency:NaN,manifestTimeSeconds:NaN,drmTimeSeconds:NaN,playTime:NaN,pauseTime:NaN,bufferingTime:NaN,licenseTime:NaN,liveLatency:NaN,maxSegmentDuration:NaN,switchHistory:[],stateHistory:[]};Oi(this);var a=this.a;if(a.getVideoPlaybackQuality){a=a.getVideoPlaybackQuality();var b=this.f,c=Number(a.totalVideoFrames);b.J=Number(a.droppedVideoFrames);
b.I=c;this.f.H=Number(a.corruptedVideoFrames);}this.h?(a=this.h,a=a.H?a.H:NaN):a=NaN;this.f.D=a;if(this.g==Wi){if(a=this.c.b)this.f.h=(this.A?this.A.b:1)*a.bandwidth;a&&a.video&&(b=this.f,c=a.video.height||NaN,b.M=a.video.width||NaN,b.j=c);this.S()&&(a=this.Ed().valueOf()+1E3*this.jd().end,this.f.m=(Date.now()-a)/1E3);this.o&&this.o.presentationTimeline&&(this.f.A=this.o.presentationTimeline.a);a=this.j.getBandwidthEstimate();this.f.g=a;}var d=this.f;a=d.M;b=d.j;c=d.h;var e=d.I,f=d.J,g=d.H,h=d.g,k=
d.f,l=d.v,m=d.c,n=Xh(d.b,"playing"),r=Xh(d.b,"paused"),u=Xh(d.b,"buffering"),v=d.D,A=d.m,y=d.A,z=Yh(d.b),D=[];d=q(d.a.a);for(var B=d.next();!B.done;B=d.next())B=B.value,D.push({timestamp:B.timestamp,id:B.id,type:B.type,fromAdaptation:B.fromAdaptation,bandwidth:B.bandwidth});return {width:a,height:b,streamBandwidth:c,decodedFrames:e,droppedFrames:f,corruptedFrames:g,estimatedBandwidth:h,loadLatency:k,manifestTimeSeconds:l,drmTimeSeconds:m,playTime:n,pauseTime:r,bufferingTime:u,licenseTime:v,liveLatency:A,
maxSegmentDuration:y,stateHistory:z,switchHistory:D}};
p.addTextTrack=function(a,b,c,d,e,f){if(this.g==ej)throw Error("State error!");if(this.g!=Wi)throw Error("State error!");var g=this.o.presentationTimeline.getDuration();if(Infinity==g)throw new M(1,4,4033);a={id:this.vd++,originalId:null,createSegmentIndex:function(){return Promise.resolve()},segmentIndex:ug(0,g,[a]),mimeType:d,codecs:e||"",kind:c,encrypted:!1,drmInfos:[],keyIds:new Set,language:b,label:f||null,type:"text",primary:!1,trickModeVideo:null,emsgSchemeIdUris:null,roles:[],channelsCount:null,
audioSamplingRate:null,closedCaptions:null};this.o.textStreams.push(a);cj(this);return rf(a)};p.nd=function(a,b){this.xc.width=a;this.xc.height=b;};p.hd=function(){if(this.g==Wi){var a=this.c;if(a.F.a)a=!1;else if(a.g)a=!1;else {for(var b=q(a.a.values()),c=b.next();!c.done;c=b.next())c=c.value,c.Ib&&(c.Ib=!1,bh(a,c,.1));a=!0;}}else a=!1;return a};
p.qe=function(){Xa("Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for.");return this.o};p.re=function(){return this.ac};
function di(a){var b=Sh();b.streaming.failureCallback=function(c){var d=[1001,1002,1003];a.S()&&d.includes(c.code)&&(c.severity=1,a.hd());};b.textDisplayFactory=function(){return a.cc?new Ih(a.a,a.cc):new Dh(a.a)};return b}p.Vd=function(a){this.cc=a;};
function Hi(a,b){for(var c=new Set,d=q(b.textStreams),e=d.next();!e.done;e=d.next())e=e.value,"application/cea-608"==e.mimeType&&c.add(e.originalId);d=q(b.variants);for(e=d.next();!e.done;e=d.next())if((e=e.value.video)&&e.closedCaptions)for(var f=q(e.closedCaptions.keys()),g=f.next();!g.done;g=f.next())if(g=g.value,!c.has(g)){var h=new vg;h={id:a.vd++,originalId:g,createSegmentIndex:function(){return Promise.resolve()},segmentIndex:h,mimeType:"application/cea-608",codecs:"",kind:"caption",encrypted:!1,
drmInfos:[],keyIds:new Set,language:e.closedCaptions.get(g),label:null,type:"text",primary:!1,trickModeVideo:null,emsgSchemeIdUris:null,roles:e.roles,channelsCount:null,audioSamplingRate:null,closedCaptions:null};b.textStreams.push(h);c.add(g);}}
p.gb=function(a){of(this.h,this.c?this.c.b:null,a);if(!a.variants.some(wf))throw new M(2,4,4032);for(var b=this.i.restrictions,c=this.xc,d=!1,e=q(a.variants),f=e.next();!f.done;f=e.next()){f=f.value;var g=f.allowedByApplication;f.allowedByApplication=nf(f,b,c);g!=f.allowedByApplication&&(d=!0);}d&&this.c&&cj(this);if(b=this.h?this.h.c:null)for(c=q(a.variants),d=c.next();!d.done;d=c.next())for(d=d.value,d=q((d.video?d.video.drmInfos:[]).concat(d.audio?d.audio.drmInfos:[])),e=d.next();!e.done;e=d.next())if(e=
e.value,e.keySystem==b.keySystem)for(e=q(e.initData||[]),f=e.next();!f.done;f=e.next())f=f.value,Hd(this.h,f.initDataType,f.initData);tj(this,a);};
function aj(a,b){var c,d,e,f,g;return J(function(h){if(1==h.a)return c=a.audio,d=a.video,e=function(k,l){var m,n;return J(function(r){if(1==r.a)return k?t(r,k.createSegmentIndex(),2):r["return"](null);m=k.segmentIndex[Symbol.iterator]().seek(l);if(!m)return r["return"](null);n=m.startTime;return r["return"](n)})},t(h,e(c,b),2);if(3!=h.a)return f=h.b,t(h,e(d,b),3);g=h.b;return null!=g&&null!=f?h["return"](Math.max(g,f)):null!=g?h["return"](g):null!=f?h["return"](f):h["return"](b)})}
function Ci(a){var b=a.Sc();if(a.f&&a.D&&a.v){var c=a.A;c.f=b;xg(c);Oi(a);}a.dispatchEvent(qi(uj,{buffering:b}));}function Pi(a){var b=a.a.playbackRate;0!=b&&(a.A&&a.A.set(b),b=qi(vj),a.dispatchEvent(b));}function Oi(a){if(a.f&&a.D){var b=a.f.b;a.D.a==Nf?Wh(b,"buffering"):a.a.paused?Wh(b,"paused"):a.a.ended?Wh(b,"ended"):Wh(b,"playing");}}
function Yi(a){try{tj(a,a.o);}catch(c){return Ai(a,c),!1}var b=a.o.variants.filter(function(c){return wf(c)});b=a.yb.create(b);a.j.setVariants(Array.from(b.values()));return !0}function oj(a){var b;if(b=Yi(a)?a.j.chooseVariant():null){if(b==a.c.b)return;$h(a.f.a,b,!0);fh(a.c,b,!0,0);qj(a);}Ri(a);}function Zi(a,b,c){a=R(a.i.preferredTextLanguage);b=R(b.language);c=R(c.language);return df(c,a)&&!df(b,c)}function Ri(a){var b=qi(wj);xj(a,b);}function cj(a){var b=qi(yj);xj(a,b);}
function qj(a){var b=qi(zj);xj(a,b);}function pj(a){var b=qi(Aj);xj(a,b);}function $i(a){var b=qi(Bj);xj(a,b);}function bj(a){var b=qi(Cj,{Pf:a.i.abr.enabled});xj(a,b);}function Ai(a,b){if(a.g!=ti){var c=qi(Dj,{detail:b});a.dispatchEvent(c);c.defaultPrevented&&(b.handled=!0);}}function Fi(a,b,c){a.dispatchEvent(qi(b,{detail:{schemeIdUri:c.schemeIdUri,value:c.value,startTime:c.startTime,endTime:c.endTime,id:c.id,eventElement:c.eventElement}}));}
function zi(a){if(!a.a.error)return null;var b=a.a.error.code;if(1==b)return null;var c=a.a.error.msExtendedCode;c&&(0>c&&(c+=Math.pow(2,32)),c=c.toString(16));return new M(2,3,3016,b,c,a.a.error.message)}
function Li(a,b){if(a.c){var c=Object.keys(b),d=1==c.length&&"00"==c[0],e=!1;if(c.length){c=q(a.o.variants);for(var f=c.next();!f.done;f=c.next()){f=f.value;var g=[];f.audio&&g.push(f.audio);f.video&&g.push(f.video);g=q(g);for(var h=g.next();!h.done;h=g.next()){var k=h.value;h=f.allowedByKeySystem;if(k.keyIds.size){f.allowedByKeySystem=!0;k=q(k.keyIds);for(var l=k.next();!l.done;l=k.next())l=l.value,l=b[d?"00":l],f.allowedByKeySystem=f.allowedByKeySystem&&!!l&&!Ej.includes(l);}h!=f.allowedByKeySystem&&
(e=!0);}}}e&&Yi(a);(d=a.c.b)&&!d.allowedByKeySystem&&oj(a);e&&cj(a);}}function Mi(a,b,c){if(a.m&&a.m.onExpirationUpdated)a.m.onExpirationUpdated(b,c);b=qi(Fj);a.dispatchEvent(b);}function Qi(a,b,c){0<b&&(a.S()||a.Ud(b));b=a.getDuration();c<b&&(a.S()||a.za(c));}
function tj(a,b){var c=a.h?bd(a.h.T):{},d=Object.keys(c);d=d.length&&"00"==d[0];for(var e=!1,f=!1,g=new Set,h=new Set,k=q(b.variants),l=k.next();!l.done;l=k.next()){l=l.value;var m=[];l.audio&&m.push(l.audio);l.video&&m.push(l.video);m=q(m);for(var n=m.next();!n.done;n=m.next())if(n=n.value,n.keyIds.size){n=q(n.keyIds);for(var r=n.next();!r.done;r=n.next()){r=r.value;var u=c[d?"00":r];u?Ej.includes(u)&&h.add(u):g.add(r);}}l.allowedByApplication?l.allowedByKeySystem&&(e=!0):f=!0;}if(!e)throw c={hasAppRestrictions:f,
missingKeys:Array.from(g),restrictedKeyStatuses:Array.from(h)},new M(2,4,4012,c);}function xj(a,b){J(function(c){if(1==c.a)return t(c,Promise.resolve(),2);a.g!=ti&&a.dispatchEvent(b);w(c);});}function sj(a){var b=new Set;a=q(a);for(var c=a.next();!c.done;c=a.next())c=c.value,c.language?b.add(R(c.language)):b.add("und");return b}
function rj(a){var b=new Map;a=q(a);for(var c=a.next();!c.done;c=a.next()){var d=c.value;c="und";var e=[];d.language&&(c=R(d.language));"variant"==d.type?e=d.audioRoles:e=d.roles;e&&e.length||(e=[""]);b.has(c)||b.set(c,new Set);d=q(e);for(e=d.next();!e.done;e=d.next())e=e.value,b.get(c).add(e);}var f=[];b.forEach(function(g,h){for(var k=q(g),l=k.next();!l.done;l=k.next())f.push({language:h,role:l.value});});return f}function ui(){return new M(2,7,7E3)}
function pi(a,b,c,d,e,f){return d==a&&e.B==f.B&&e.uri==f.uri&&e.mimeType==f.mimeType?b:c}function xh(){return {B:null,mimeType:null,startTime:null,qd:NaN,uri:null}}function vi(a){return new Promise(function(b,c){a.Va=function(){return c(ui())};a.nc=function(){return b()};a.onError=function(d){return c(d)};a.pc=function(){return c(ui())};})}K("shaka.Player",W);W.prototype.setVideoContainer=W.prototype.Vd;W.prototype.getManifestParserFactory=W.prototype.re;W.prototype.getManifest=W.prototype.qe;
W.prototype.retryStreaming=W.prototype.hd;W.prototype.setMaxHardwareResolution=W.prototype.nd;W.prototype.addTextTrack=W.prototype.addTextTrack;W.prototype.getStats=W.prototype.getStats;W.prototype.getBufferedInfo=W.prototype.ic;W.prototype.getPresentationStartTimeAsDate=W.prototype.Ed;W.prototype.getPlayheadTimeAsDate=W.prototype.xe;W.prototype.setTextTrackVisibility=W.prototype.cf;W.prototype.isTextTrackVisible=W.prototype.Tc;W.prototype.selectVariantsByLabel=W.prototype.Xe;
W.prototype.selectTextLanguage=W.prototype.ld;W.prototype.selectAudioLanguage=W.prototype.kd;W.prototype.getTextLanguages=W.prototype.Ce;W.prototype.getAudioLanguages=W.prototype.ke;W.prototype.getTextLanguagesAndRoles=W.prototype.De;W.prototype.getAudioLanguagesAndRoles=W.prototype.le;W.prototype.selectVariantTrack=W.prototype.We;W.prototype.selectTextTrack=W.prototype.Sd;W.prototype.getTextTracks=W.prototype.lc;W.prototype.getVariantTracks=W.prototype.Rc;W.prototype.cancelTrickPlay=W.prototype.ee;
W.prototype.trickPlay=W.prototype.ff;W.prototype.getPlaybackRate=W.prototype.ve;W.prototype.isBuffering=W.prototype.Sc;W.prototype.getExpiration=W.prototype.Eb;W.prototype.drmInfo=W.prototype.drmInfo;W.prototype.keySystem=W.prototype.keySystem;W.prototype.seekRange=W.prototype.jd;W.prototype.isAudioOnly=W.prototype.Ge;W.prototype.isInProgress=W.prototype.Ua;W.prototype.isLive=W.prototype.S;W.prototype.getAdManager=W.prototype.Dd;W.prototype.getAssetUri=W.prototype.Qc;
W.prototype.getNetworkingEngine=W.prototype.Fb;W.prototype.getMediaElement=W.prototype.te;W.prototype.getLoadMode=W.prototype.pe;W.prototype.resetConfiguration=W.prototype.Ve;W.prototype.getConfiguration=W.prototype.getConfiguration;W.prototype.configure=W.prototype.configure;W.prototype.load=W.prototype.load;W.prototype.unload=W.prototype.td;W.prototype.detach=W.prototype.detach;W.prototype.attach=W.prototype.zb;
W.probeSupport=function(){var a,b,c,d,e,f;return J(function(g){if(1==g.a)return t(g,Xd(),2);a=g.b;var h={};if(id()){for(var k in Rf)h[k]=!0;for(var l in Tf)h[l]=!0;}k={mpd:"application/dash+xml",m3u8:"application/x-mpegurl",ism:"application/vnd.ms-sstr+xml"};l=q(["application/dash+xml","application/x-mpegurl","application/vnd.apple.mpegurl","application/vnd.ms-sstr+xml"]);for(var m=l.next();!m.done;m=l.next())m=m.value,h[m]=id()?!!Rf[m]:jd(m);for(var n in k)h[n]=id()?!!Tf[n]:jd(k[n]);b=h;h={};n=q('video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="opus",audio/mp4; codecs="flac",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(","));
for(k=n.next();!k.done;k=n.next())k=k.value,h[k]=id()?Ee(k)?!0:MediaSource.isTypeSupported(k)||hc(k):jd(k),l=k.split(";")[0],h[l]=h[l]||h[k];c=h;d={manifest:b,media:c,drm:a};e=Gj;for(f in e)d[f]=e[f]();return g["return"](d)})};
W.isBrowserSupported=function(){if(!(window.Promise&&window.Uint8Array&&Array.prototype.forEach))return !1;var a=od();return a&&12>a||!(window.MediaKeys&&window.navigator&&window.navigator.requestMediaKeySystemAccess&&window.MediaKeySystemAccess&&window.MediaKeySystemAccess.prototype.getConfiguration)?!1:id()?!0:jd("application/x-mpegurl")};W.setAdManagerFactory=function(a){fi=a;};W.registerSupportPlugin=function(a,b){Gj[a]=b;};W.prototype.destroy=W.prototype.destroy;
var Cj="abrstatuschanged",wj="adaptation",uj="buffering",Ni="drmsessionupdate",uh="emsg",Dj="error",Fj="expirationupdated",yi="loaded",wi="loading",Ii="manifestparsed",jj="metadata",ri="onstatechange",si="onstateidle",vj="ratechange",Xi="streaming",Aj="textchanged",Bj="texttrackvisibility",Gi="timelineregionadded",lj="timelineregionenter",mj="timelineregionexit",yj="trackschanged",Bi="unloading",zj="variantchanged",Hj={nf:Cj,pf:wj,qf:uj,rf:Ni,tf:uh,Error:Dj,uf:Fj,wf:"largegap",xf:yi,yf:wi,zf:Ii,Metadata:jj,
Af:ri,Bf:si,Cf:vj,Df:Xi,Ef:Aj,Ff:Bj,Gf:Gi,Hf:lj,If:mj,Jf:yj,Kf:Bi,Lf:zj},ti=0,ci=1,Wi=2,ej=3;W.LoadMode={DESTROYED:ti,NOT_LOADED:ci,MEDIA_SOURCE:Wi,SRC_EQUALS:ej};W.version="v3.0.7";var Ij=["3","0"];Fb=new function(a){this.a=a;this.c=Gb;this.b=Hb;}(new Db(Number(Ij[0]),Number(Ij[1])));var Ej=["output-restricted","internal-error"],Gj={},fi=null;function Jj(){this.a=[];this.f=this.b=this.c=0;}function X(a,b){var c=this;this.c=a;this.a=b;this.f=!1;this.g=this.a.getVolume();this.b=new Tc;this.b.l(this.a,google.ima.AdEvent.Type.PAUSED,function(){c.f=!0;});this.b.l(this.a,google.ima.AdEvent.Type.RESUMED,function(){c.f=!1;});}p=X.prototype;p.getDuration=function(){return this.c.getDuration()};p.getRemainingTime=function(){return this.a.getRemainingTime()};p.isPaused=function(){return this.f};p.isSkippable=function(){return 0<=this.c.getSkipTimeOffset()};
p.getTimeUntilSkippable=function(){var a=this.c.getSkipTimeOffset();a=this.getRemainingTime()-a;return Math.max(a,0)};p.canSkipNow=function(){return this.a.getAdSkippableState()};p.skip=function(){return this.a.skip()};p.pause=function(){return this.a.pause()};p.play=function(){return this.a.resume()};p.getVolume=function(){return this.a.getVolume()};p.setVolume=function(a){return this.a.setVolume(a)};p.isMuted=function(){return 0==this.a.getVolume()};
p.resize=function(a,b){this.a.resize(a,b,document.fullscreenElement?google.ima.ViewMode.FULLSCREEN:google.ima.ViewMode.NORMAL);};p.setMuted=function(a){a?(this.g=this.getVolume(),this.setVolume(0)):this.setVolume(this.g);};p.getSequenceLength=function(){var a=this.c.getAdPodInfo();return null==a?1:a.getTotalAds()};p.getPositionInSequence=function(){var a=this.c.getAdPodInfo();return null==a?1:a.getAdPosition()};p.release=function(){this.a=this.c=null;};K("shaka.ads.ClientSideAd",X);
X.prototype.release=X.prototype.release;X.prototype.getPositionInSequence=X.prototype.getPositionInSequence;X.prototype.getSequenceLength=X.prototype.getSequenceLength;X.prototype.setMuted=X.prototype.setMuted;X.prototype.resize=X.prototype.resize;X.prototype.isMuted=X.prototype.isMuted;X.prototype.setVolume=X.prototype.setVolume;X.prototype.getVolume=X.prototype.getVolume;X.prototype.play=X.prototype.play;X.prototype.pause=X.prototype.pause;X.prototype.skip=X.prototype.skip;
X.prototype.canSkipNow=X.prototype.canSkipNow;X.prototype.getTimeUntilSkippable=X.prototype.getTimeUntilSkippable;X.prototype.isSkippable=X.prototype.isSkippable;X.prototype.isPaused=X.prototype.isPaused;X.prototype.getRemainingTime=X.prototype.getRemainingTime;X.prototype.getDuration=X.prototype.getDuration;function Kj(a,b,c,d){var e=this;this.h=a;this.a=b;this.m=NaN;this.f=d;this.j=null;this.b=new Tc;google.ima.settings.setLocale(c);a=new google.ima.AdDisplayContainer(this.h,this.a);a.initialize();this.g=new google.ima.AdsLoader(a);this.g.getSettings().setPlayerType("shaka-player");this.g.getSettings().setPlayerVersion("v3.0.7");this.c=null;this.b.ha(this.g,google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,function(f){Lj(e,f);});this.b.l(this.g,google.ima.AdEvent.Type.AD_ERROR,function(f){Mj(e,
f);});this.a.onended=function(){e.g.contentComplete();};}Kj.prototype.stop=function(){this.c&&this.c.stop();this.h&&Hh(this.h);};function Mj(a,b){b.getError();Nj(a,null);a.f(new Q("ad-cue-points-changed",{cuepoints:[]}));}
function Lj(a,b){a.f(new Q("ads-loaded",{loadTime:Date.now()/1E3-a.m}));a.c=b.getAdsManager(a.a);a.f(new Q("ima-ad-manager-loaded",{imaAdsManager:a.c}));var c=a.c.getCuePoints();if(c.length){var d=[];c=q(c);for(var e=c.next();!e.done;e=c.next())d.push(new Oj(e.value));a.f(new Q("ad-cue-points-changed",{cuepoints:d}));}Pj(a);try{a.c.init(a.a.offsetWidth,a.a.offsetHeight,document.fullscreenElement?google.ima.ViewMode.FULLSCREEN:google.ima.ViewMode.NORMAL),a.b.l(a.a,"loadeddata",function(){a.c.resize(a.a.offsetWidth,
a.a.offsetHeight,document.fullscreenElement?google.ima.ViewMode.FULLSCREEN:google.ima.ViewMode.NORMAL);}),a.c.start();}catch(f){Nj(a,null);}}
function Pj(a){a.b.l(a.c,google.ima.AdErrorEvent.Type.AD_ERROR,function(b){Mj(a,b);});a.b.l(a.c,google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,function(b){Qj(a,b);});a.b.l(a.c,google.ima.AdEvent.Type.STARTED,function(b){Qj(a,b);});a.b.l(a.c,google.ima.AdEvent.Type.FIRST_QUARTILE,function(b){a.f(new Q("ad-first-quartile",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.MIDPOINT,function(b){a.f(new Q("ad-midpoint",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.THIRD_QUARTILE,function(b){a.f(new Q("ad-third-quartile",
{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.COMPLETE,function(b){a.f(new Q("ad-complete",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,function(b){Nj(a,b);});a.b.l(a.c,google.ima.AdEvent.Type.ALL_ADS_COMPLETED,function(b){Nj(a,b);});a.b.l(a.c,google.ima.AdEvent.Type.SKIPPED,function(b){a.f(new Q("ad-skipped",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.VOLUME_CHANGED,function(b){a.f(new Q("ad-volume-changed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.VOLUME_MUTED,
function(b){a.f(new Q("ad-muted",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.PAUSED,function(b){a.j.f=!0;a.f(new Q("ad-paused",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.RESUMED,function(b){a.j.f=!1;a.f(new Q("ad-resumed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED,function(b){a.f(new Q("ad-skip-state-changed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.CLICK,function(){a.f(new Q("ad-clicked"));});a.b.l(a.c,google.ima.AdEvent.Type.AD_PROGRESS,
function(b){a.f(new Q("ad-progress",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.AD_BUFFERING,function(b){a.f(new Q("ad-buffering",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.IMPRESSION,function(b){a.f(new Q("ad-impression",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.DURATION_CHANGE,function(b){a.f(new Q("ad-duration-changed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.USER_CLOSE,function(b){a.f(new Q("ad-closed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.LOADED,
function(b){a.f(new Q("ad-loaded",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.ALL_ADS_COMPLETED,function(b){a.f(new Q("all-ads-completed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.LINEAR_CHANGED,function(b){a.f(new Q("ad-linear-changed",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.AD_METADATA,function(b){a.f(new Q("ad-metadata",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.LOG,function(b){a.f(new Q("ad-recoverable-error",{originalEvent:b}));});a.b.l(a.c,
google.ima.AdEvent.Type.AD_BREAK_READY,function(b){a.f(new Q("ad-break-ready",{originalEvent:b}));});a.b.l(a.c,google.ima.AdEvent.Type.INTERACTION,function(b){a.f(new Q("ad-interaction",{originalEvent:b}));});}function Qj(a,b){var c=b.getAd();a.j=new X(c,a.c);a.f(new Q("ad-started",{ad:a.j,sdkAdObject:c,originalEvent:b}));a.h.setAttribute("ad-active","true");a.a.pause();}function Nj(a,b){a.f(new Q("ad-stopped",{originalEvent:b}));a.h.removeAttribute("ad-active");a.a.play();}function Y(a,b){this.c=a;this.b=null;this.a=b;}p=Y.prototype;p.getDuration=function(){return this.b?this.b.duration:-1};p.getRemainingTime=function(){return this.b?this.b.duration-this.b.currentTime:-1};p.isPaused=function(){return this.a.paused};p.isSkippable=function(){return this.c.isSkippable()};p.getTimeUntilSkippable=function(){var a=this.c.getSkipTimeOffset();a=this.getRemainingTime()-a;return Math.max(a,0)};p.canSkipNow=function(){return 0==this.getTimeUntilSkippable()};
p.skip=function(){this.a.currentTime+=this.getRemainingTime();};p.pause=function(){return this.a.pause()};p.play=function(){return this.a.play()};p.getVolume=function(){return this.a.volume};p.setVolume=function(a){this.a.volume=a;};p.isMuted=function(){return this.a.muted};p.resize=function(){};p.setMuted=function(a){this.a.muted=a;};p.getSequenceLength=function(){var a=this.c.getAdPodInfo();return null==a?1:a.getTotalAds()};
p.getPositionInSequence=function(){var a=this.c.getAdPodInfo();return null==a?1:a.getAdPosition()};p.release=function(){this.a=this.b=this.c=null;};K("shaka.ads.ServerSideAd",Y);Y.prototype.release=Y.prototype.release;Y.prototype.getPositionInSequence=Y.prototype.getPositionInSequence;Y.prototype.getSequenceLength=Y.prototype.getSequenceLength;Y.prototype.setMuted=Y.prototype.setMuted;Y.prototype.resize=Y.prototype.resize;Y.prototype.isMuted=Y.prototype.isMuted;Y.prototype.setVolume=Y.prototype.setVolume;
Y.prototype.getVolume=Y.prototype.getVolume;Y.prototype.play=Y.prototype.play;Y.prototype.pause=Y.prototype.pause;Y.prototype.skip=Y.prototype.skip;Y.prototype.canSkipNow=Y.prototype.canSkipNow;Y.prototype.getTimeUntilSkippable=Y.prototype.getTimeUntilSkippable;Y.prototype.isSkippable=Y.prototype.isSkippable;Y.prototype.isPaused=Y.prototype.isPaused;Y.prototype.getRemainingTime=Y.prototype.getRemainingTime;Y.prototype.getDuration=Y.prototype.getDuration;function Rj(a,b,c,d){var e=this;this.v=a;this.a=b;this.g=null;this.H=NaN;this.f=d;this.D=!1;this.A=this.h=this.j=null;this.m="";this.b=new Tc;a=new google.ima.dai.api.UiSettings;a.setLocale(c);this.c=new google.ima.dai.api.StreamManager(this.a,this.v,a);this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.LOADED,function(f){Sj(e,f);});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.ERROR,function(){e.m.length?e.g.resolve(e.m):e.g.reject("IMA Stream request returned an error and there was no backup asset uri provided.");
e.g=null;});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED,function(){});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.STARTED,function(f){f=f.getAd();e.h=new Y(f,e.a);e.A&&(e.h.b=e.A);e.f(new Q("ad-started",{ad:e.h}));e.v.setAttribute("ad-active","true");});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED,function(){e.v.removeAttribute("ad-active");var f=e.a.currentTime;e.j&&e.j>f&&(e.a.currentTime=e.j,e.j=null);});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.AD_PROGRESS,
function(f){e.A=f.getStreamData().adProgressData;e.h&&(e.h.b=e.A);});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE,function(){e.f(new Q("ad-first-quartile"));});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.MIDPOINT,function(){e.f(new Q("ad-midpoint"));});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE,function(){e.f(new Q("ad-third-quartile"));});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.COMPLETE,function(){e.f(new Q("ad-complete"));e.f(new Q("ad-stopped"));
e.v.removeAttribute("ad-active");e.h=null;});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.SKIPPED,function(){e.f(new Q("ad-skipped"));e.f(new Q("ad-stopped"));});this.b.l(this.c,google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED,function(f){var g=f.getStreamData();f=[];g=q(g.cuepoints);for(var h=g.next();!h.done;h=g.next())h=h.value,f.push(new Oj(h.start,h.end));e.f(new Q("ad-cue-points-changed",{cuepoints:f}));});}Rj.prototype.stop=function(){this.c.reset();this.m="";this.j=null;};
Rj.prototype.onCueMetadataChange=function(a){if(a.key&&a.data){var b={};b[a.key]=a.data;this.c.onTimedMetadata(b);}};function Sj(a,b){a.f(new Q("ads-loaded",{loadTime:Date.now()/1E3-a.H}));var c=b.getStreamData().url;a.g.resolve(c);a.g=null;a.D||a.b.l(a.a,"seeked",function(){var d=a.a.currentTime;if(0!=d){a.c.streamTimeForContentTime(d);var e=a.c.previousCuePointForStreamTime(d);e&&!e.played&&(a.j=d,a.a.currentTime=e.start);}});}function Z(){xc.call(this);this.a=this.b=null;this.f=new Jj;this.c=navigator.language;}pa(Z,xc);p=Z.prototype;p.setLocale=function(a){this.c=a;};p.initClientSide=function(a,b){var c=this;if(!window.google||!google.ima||!google.ima.AdsLoader)throw new M(2,10,1E4);this.b=new Kj(a,b,this.c,function(d){if(d&&d.type)switch(d.type){case "ads-loaded":c.f.a.push(d.loadTime);break;case "ad-started":c.f.c++;break;case "ad-complete":c.f.b++;break;case "ad-skipped":c.f.f++;}c.dispatchEvent(d);});};
p.onAssetUnload=function(){this.b&&this.b.stop();this.dispatchEvent(new Q("ad-stopped"));this.f=new Jj;};p.requestClientSideAds=function(a){if(!this.b)throw new M(1,10,10001);var b=this.b;b.m=Date.now()/1E3;b.g.requestAds(a);};
p.initServerSide=function(a,b){var c=this;if(!window.google||!google.ima||!google.ima.dai)throw new M(2,10,10002);this.a=new Rj(a,b,this.c,function(d){if(d&&d.type)switch(d.type){case "ads-loaded":c.f.a.push(d.loadTime);break;case "ad-started":c.f.c++;break;case "ad-complete":c.f.b++;break;case "ad-skipped":c.f.f++;}c.dispatchEvent(d);});};
p.requestServerSideStream=function(a,b){b=void 0===b?"":b;if(!this.a)throw new M(1,10,10003);a.adTagParameters||(a.adTagParameters={});var c=a.adTagParameters;(c.mpt||c.mpv)&&Xa('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.');a.adTagParameters.mpt="Shaka Player";a.adTagParameters.mpv="v3.0.7";c=this.a;var d=b;c.g?c=Promise.reject(new M(1,10,10004)):(a instanceof google.ima.dai.api.LiveStreamRequest&&
(c.D=!0),c.g=new Pb,c.c.requestStream(a),c.m=d||"",c.H=Date.now()/1E3,c=c.g);return c};p.replaceServerSideAdTagParameters=function(a){if(!this.a)throw new M(1,10,10003);(a.mpt||a.mpv)&&Xa('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.');a.mpt="Shaka Player";a.mpv="v3.0.7";this.a.c.replaceAdTagParameters(a);};
p.getStats=function(){var a=this.f;return {loadTimes:a.a,started:a.c,playedCompletely:a.b,skipped:a.f}};p.onDashTimedMetadata=function(a){if(this.a&&"urn:google:dai:2018"==a.schemeIdUri){var b=a.schemeIdUri,c=a.eventElement?a.eventElement.getAttribute("messageData"):null;this.a.c.processMetadata(b,c,a.startTime);}};p.onHlsTimedMetadata=function(a,b){this.a&&this.a.c.processMetadata("ID3",a.data,b);};p.onCueMetadataChange=function(a){if(this.a)this.a.onCueMetadataChange(a);};K("shaka.ads.AdManager",Z);
Z.prototype.onCueMetadataChange=Z.prototype.onCueMetadataChange;Z.prototype.onHlsTimedMetadata=Z.prototype.onHlsTimedMetadata;Z.prototype.onDashTimedMetadata=Z.prototype.onDashTimedMetadata;Z.prototype.getStats=Z.prototype.getStats;Z.prototype.replaceServerSideAdTagParameters=Z.prototype.replaceServerSideAdTagParameters;Z.prototype.requestServerSideStream=Z.prototype.requestServerSideStream;Z.prototype.initServerSide=Z.prototype.initServerSide;Z.prototype.requestClientSideAds=Z.prototype.requestClientSideAds;
Z.prototype.onAssetUnload=Z.prototype.onAssetUnload;Z.prototype.initClientSide=Z.prototype.initClientSide;Z.prototype.setLocale=Z.prototype.setLocale;function Oj(a,b){this.start=a;this.end=void 0===b?null:b;}Z.ADS_LOADED="ads-loaded";Z.AD_STARTED="ad-started";Z.AD_FIRST_QUARTILE="ad-first-quartile";Z.AD_MIDPOINT="ad-midpoint";Z.AD_THIRD_QUARTILE="ad-third-quartile";Z.AD_COMPLETE="ad-complete";Z.AD_STOPPED="ad-stopped";Z.AD_SKIPPED="ad-skipped";Z.AD_VOLUME_CHANGED="ad-volume-changed";Z.AD_MUTED="ad-muted";
Z.AD_PAUSED="ad-paused";Z.AD_RESUMED="ad-resumed";Z.AD_SKIP_STATE_CHANGED="ad-skip-state-changed";Z.CUEPOINTS_CHANGED="ad-cue-points-changed";Z.IMA_AD_MANAGER_LOADED="ima-ad-manager-loaded";Z.AD_CLICKED="ad-clicked";Z.AD_PROGRESS="ad-progress";Z.AD_BUFFERING="ad-buffering";Z.AD_IMPRESSION="ad-impression";Z.AD_DURATION_CHANGED="ad-duration-changed";Z.AD_CLOSED="ad-closed";Z.AD_LOADED="ad-loaded";Z.ALL_ADS_COMPLETED="all-ads-completed";Z.AD_LINEAR_CHANGED="ad-linear-changed";Z.AD_METADATA="ad-metadata";
Z.AD_RECOVERABLE_ERROR="ad-recoverable-error";Z.AD_BREAK_READY="ad-break-ready";Z.AD_INTERACTION="ad-interaction";fi=function(){return new Z};function Tj(a){return JSON.stringify(a,function(b,c){if("function"!=typeof c){if(c instanceof Event||c instanceof Q){var d={};for(f in c){var e=c[f];e&&"object"==typeof e?"detail"==f&&(d[f]=e):f in Event||(d[f]=e);}return d}if(c instanceof Error){var f=new Set(["name","message","stack"]);for(d in c)f.add(d);e=q(Object.getOwnPropertyNames(c));for(d=e.next();!d.done;d=e.next())f.add(d.value);e={};f=q(f);for(d=f.next();!d.done;d=f.next())d=d.value,e[d]=c[d];f={__type__:"Error",contents:e};}else if(c instanceof
TimeRanges)for(f={__type__:"TimeRanges",length:c.length,start:[],end:[]},d=q(ie(c)),e=d.next();!e.done;e=d.next()){e=e.value;var g=e.end;f.start.push(e.start);f.end.push(g);}else f=c instanceof Uint8Array?{__type__:"Uint8Array",entries:Array.from(c)}:"number"==typeof c?isNaN(c)?"NaN":isFinite(c)?c:0>c?"-Infinity":"Infinity":c;return f}})}
function Uj(a){return JSON.parse(a,function(b,c){if("NaN"==c)var d=NaN;else if("-Infinity"==c)d=-Infinity;else if("Infinity"==c)d=Infinity;else if(c&&"object"==typeof c&&"TimeRanges"==c.__type__)d=Vj(c);else if(c&&"object"==typeof c&&"Uint8Array"==c.__type__)d=new Uint8Array(c.entries);else if(c&&"object"==typeof c&&"Error"==c.__type__){d=c.contents;var e=Error(d.message),f;for(f in d)e[f]=d[f];d=e;}else d=c;return d})}
function Vj(a){return {length:a.length,start:function(b){return a.start[b]},end:function(b){return a.end[b]}}}
var Wj="ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "),Xj="buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "),Yj=["loop","playbackRate"],Zj=["pause","play"],ak={getAssetUri:2,getAudioLanguages:2,getAudioLanguagesAndRoles:2,getBufferedInfo:2,getConfiguration:2,getExpiration:2,getPlaybackRate:2,getTextLanguages:2,getTextLanguagesAndRoles:2,getTextTracks:2,getStats:5,getVariantTracks:2,isAudioOnly:10,
isBuffering:1,isInProgress:1,isLive:10,isTextTrackVisible:1,keySystem:10,seekRange:1,getLoadMode:10},bk={getPlayheadTimeAsDate:1,getPresentationStartTimeAsDate:20},ck=[["getConfiguration","configure"]],dk=[["isTextTrackVisible","setTextTrackVisibility"]],ek="addTextTrack cancelTrickPlay configure resetConfiguration retryStreaming selectAudioLanguage selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel setTextTrackVisibility trickPlay".split(" "),fk=["attach","detach","load",
"unload"];function gk(a,b,c,d,e,f){var g=this;this.T=a;this.f=new N(b);this.W=c;this.m=!1;this.D=d;this.M=e;this.I=f;this.b=this.h=!1;this.J="";this.j=null;this.v=function(){return hk(g)};this.A=function(h,k){var l=Uj(k);switch(l.type){case "event":var m=l.targetName;l=l.event;l=new Q(l.type,l);g.D(m,l);break;case "update":m=l.update;for(var n in m){l=g.a[n]||{};for(var r in m[n])l[r]=m[n][r];}g.m&&(g.W(),g.m=!1);break;case "asyncComplete":if(n=l.id,l=l.error,r=g.c[n],delete g.c[n],r)if(l){n=new M(l.severity,
l.category,l.code);for(m in l)n[m]=l[m];r.reject(n);}else r.resolve();}};this.a={video:{},player:{}};this.H=0;this.c={};this.g=null;ik.add(this);}p=gk.prototype;p.destroy=function(){ik["delete"](this);jk(this);kk&&lk(this);this.f&&(this.f.stop(),this.f=null);this.M=this.D=null;this.b=this.h=!1;this.A=this.v=this.g=this.c=this.a=this.j=null;return Promise.resolve()};p.fa=function(){return this.b};p.fd=function(){return this.J};
p.init=function(){if(window.chrome&&chrome.cast&&chrome.cast.isAvailable&&this.T.length){this.h=!0;this.f.Qb();var a=new chrome.cast.SessionRequest(this.T);a=new chrome.cast.ApiConfig(a,function(b){for(var c=q(ik),d=c.next();!d.done;d=c.next())mk(d.value,b);},function(b){for(var c=q(ik),d=c.next();!d.done;d=c.next())d=d.value,nk="available"==b,d.f.Qb();},"origin_scoped");chrome.cast.initialize(a,function(){},function(){});nk&&this.f.R(ok);(a=kk)&&a.status!=chrome.cast.SessionStatus.STOPPED?mk(this,
a):kk=null;}};p.md=function(a){this.j=a;this.b&&pk(this,{type:"appData",appData:this.j});};p.cast=function(a){var b=this;return J(function(c){if(!b.h)throw new M(1,8,8E3);if(!nk)throw new M(1,8,8001);if(b.b)throw new M(1,8,8002);b.g=new Pb;chrome.cast.requestSession(function(d){return qk(b,a,d)},function(d){return rk(b,d)});return t(c,b.g,0)})};function sk(a){if(a.b){var b=a.I();chrome.cast.requestSession(function(c){return qk(a,b,c)},function(c){return rk(a,c)});}}
p.hb=function(){if(this.b){jk(this);if(kk){lk(this);try{kk.stop(function(){},function(){});}catch(a){}kk=null;}hk(this);}};
p.get=function(a,b){var c=this;if("video"==a){if(Zj.includes(b))return function(d){for(var e=[],f=0;f<arguments.length;++f)e[f]=arguments[f];return c.Pd.apply(c,[a,b].concat(ia(e)))}}else if("player"==a){if(bk[b]&&!this.get("player","isLive")())return function(){};if(ek.includes(b))return function(d){for(var e=[],f=0;f<arguments.length;++f)e[f]=arguments[f];return c.Pd.apply(c,[a,b].concat(ia(e)))};if(fk.includes(b))return function(d){for(var e=[],f=0;f<arguments.length;++f)e[f]=arguments[f];return c.Se.apply(c,
[a,b].concat(ia(e)))};if(ak[b])return function(){return c.a[a][b]}}return this.a[a][b]};p.set=function(a,b,c){this.a[a][b]=c;pk(this,{type:"set",targetName:a,property:b,value:c});};function qk(a,b,c){kk=c;c.addUpdateListener(a.v);c.addMessageListener("urn:x-cast:com.google.shaka.v2",a.A);hk(a);pk(a,{type:"init",initState:b,appData:a.j});a.g.resolve();}
function rk(a,b){var c=8003;switch(b.code){case "cancel":c=8004;break;case "timeout":c=8005;break;case "receiver_unavailable":c=8006;}a.g.reject(new M(2,8,c,b));}p.Pd=function(a,b,c){for(var d=[],e=2;e<arguments.length;++e)d[e-2]=arguments[e];pk(this,{type:"call",targetName:a,methodName:b,args:d});};p.Se=function(a,b,c){for(var d=[],e=2;e<arguments.length;++e)d[e-2]=arguments[e];e=new Pb;var f=this.H.toString();this.H++;this.c[f]=e;try{pk(this,{type:"asyncCall",targetName:a,methodName:b,args:d,id:f});}catch(g){e.reject(g);}return e};
function mk(a,b){var c=a.I();a.g=new Pb;a.m=!0;qk(a,c,b);}function lk(a){var b=kk;b.removeUpdateListener(a.v);b.removeMessageListener("urn:x-cast:com.google.shaka.v2",a.A);}function hk(a){var b=kk?"connected"==kk.status:!1;if(a.b&&!b){a.M();for(var c in a.a)a.a[c]={};jk(a);}a.b=b;a.J=b?kk.receiver.friendlyName:"";a.f.Qb();}function jk(a){for(var b in a.c){var c=a.c[b];delete a.c[b];c.reject(new M(1,7,7E3));}}
function pk(a,b){var c=Tj(b),d=kk;try{d.sendMessage("urn:x-cast:com.google.shaka.v2",c,function(){},$a);}catch(e){throw c=new M(2,8,8005,e),d=new Q("error",{detail:c}),a.D("player",d),a.hb(),c;}}var ok=.02,nk=!1,kk=null,ik=new Set;window.__onGCastApiAvailable=function(a){if(a){a=q(ik);for(var b=a.next();!b.done;b=a.next())b.value.init();}};function tk(a,b,c){xc.call(this);var d=this;this.f=a;this.c=b;this.b=this.j=this.g=this.m=this.h=null;this.A=c;this.v=new Map;this.a=new gk(c,function(){return uk(d)},function(){return vk(d)},function(e,f){return wk(d,e,f)},function(){return xk(d)},function(){return yk(d)});zk(this);}pa(tk,xc);p=tk.prototype;
p.destroy=function(a){a&&this.a.hb();this.b&&(this.b.release(),this.b=null);a=[];this.c&&(a.push(this.c.destroy()),this.c=null);this.a&&(a.push(this.a.destroy()),this.a=null);this.m=this.h=this.f=null;return Promise.all(a)};p.Ee=function(){return this.h};p.we=function(){return this.m};p.de=function(){return this.a.h&&nk};p.fa=function(){return this.a.fa()};p.fd=function(){return this.a.fd()};
p.cast=function(){var a=this,b;return J(function(c){return 1==c.a?(b=yk(a),t(c,a.a.cast(b),2)):a.c?t(c,a.c.td(),0):c["return"]()})};p.md=function(a){this.a.md(a);};p.df=function(){sk(this.a);};p.hb=function(){this.a.hb();};
p.fe=function(a){var b=this;return J(function(c){if(1==c.a){if(a==b.A)return c["return"]();b.A=a;b.a.hb();return t(c,b.a.destroy(),2)}b.a=null;b.a=new gk(a,function(){return uk(b)},function(){return vk(b)},function(d,e){return wk(b,d,e)},function(){return xk(b)},function(){return yk(b)});b.a.init();w(c);})};
function zk(a){a.a.init();a.b=new Tc;for(var b=q(Wj),c=b.next();!c.done;c=b.next())a.b.l(a.f,c.value,function(f){a.a.fa()||(f=new Q(f.type,f),a.g.dispatchEvent(f));});for(var d in Hj)a.b.l(a.c,Hj[d],function(f){a.a.fa()||a.j.dispatchEvent(f);});a.h={};b={};for(var e in a.f)b.tb=e,Object.defineProperty(a.h,b.tb,{configurable:!1,enumerable:!0,get:function(f){return function(){return Ak(a,f.tb)}}(b),set:function(f){return function(g){var h=f.tb;a.a.fa()?a.a.set("video",h,g):a.f[h]=g;}}(b)}),b={tb:b.tb};
a.m={};Bk(a,function(f){Object.defineProperty(a.m,f,{configurable:!1,enumerable:!0,get:function(){return Ck(a,f)}});});Dk(a);a.g=new xc;a.g.$b=a.h;a.j=new xc;a.j.$b=a.m;}function Dk(a){var b=new Map;Bk(a,function(c,d){if(b.has(d)){var e=b.get(d);c.length<e.length?a.v.set(c,e):a.v.set(e,c);}else b.set(d,c);});}
function Bk(a,b){function c(l){return "constructor"==l||"function"!=typeof d[l]?!1:!e.has(l)}var d=a.c,e=new Set;for(f in d)c(f)&&(e.add(f),b(f,d[f]));var f=Object.getPrototypeOf(d);for(var g=Object.getPrototypeOf({});f&&f!=g;){for(var h=q(Object.getOwnPropertyNames(f)),k=h.next();!k.done;k=h.next())k=k.value,c(k)&&(e.add(k),b(k,d[k]));f=Object.getPrototypeOf(f);}}
function yk(a){var b={video:{},player:{},playerAfterLoad:{},manifest:a.c.Qc(),startTime:null};a.f.pause();for(var c=q(Yj),d=c.next();!d.done;d=c.next())d=d.value,b.video[d]=a.f[d];a.f.ended||(b.startTime=a.f.currentTime);c=q(ck);for(d=c.next();!d.done;d=c.next()){var e=d.value;d=e[1];e=a.c[e[0]]();b.player[d]=e;}c=q(dk);for(d=c.next();!d.done;d=c.next())e=d.value,d=e[1],e=a.c[e[0]](),b.playerAfterLoad[d]=e;return b}function uk(a){var b=new Q("caststatuschanged");a.dispatchEvent(b);}
function vk(a){var b=new Q(a.h.paused?"pause":"play");a.g.dispatchEvent(b);}
function xk(a){for(var b=q(ck),c=b.next();!c.done;c=b.next()){var d=c.value;c=d[1];d=a.a.get("player",d[0])();a.c[c](d);}var e=a.a.get("player","getAssetUri")();c=a.a.get("video","ended");b=Promise.resolve();var f=a.f.autoplay;d=null;c||(d=a.a.get("video","currentTime"));e&&(a.f.autoplay=!1,b=a.c.load(e,d));var g={};c=q(Yj);for(d=c.next();!d.done;d=c.next())d=d.value,g[d]=a.a.get("video",d);b.then(function(){if(a.f){for(var h=q(Yj),k=h.next();!k.done;k=h.next())k=k.value,a.f[k]=g[k];h=q(dk);for(k=
h.next();!k.done;k=h.next()){var l=k.value;k=l[1];l=a.a.get("player",l[0])();a.c[k](l);}a.f.autoplay=f;e&&a.f.play();}},function(h){h=new Q(Dj,{detail:h});a.c.dispatchEvent(h);});}
function Ak(a,b){if("addEventListener"==b)return function(d,e,f){return a.g.addEventListener(d,e,f)};if("removeEventListener"==b)return function(d,e,f){return a.g.removeEventListener(d,e,f)};if(a.a.fa()&&0==Object.keys(a.a.a.video).length){var c=a.f[b];if("function"!=typeof c)return c}return a.a.fa()?a.a.get("video",b):(c=a.f[b],"function"==typeof c&&(c=c.bind(a.f)),c)}
function Ck(a,b){a.v.has(b)&&(b=a.v.get(b));if("addEventListener"==b)return function(c,d,e){return a.j.addEventListener(c,d,e)};if("removeEventListener"==b)return function(c,d,e){return a.j.removeEventListener(c,d,e)};if("getMediaElement"==b)return function(){return a.h};if("getSharedConfiguration"==b)return a.a.get("player","getConfiguration");if("getNetworkingEngine"==b)return function(){return a.c.Fb()};if("getAdManager"==b)return function(){return a.c.Dd()};if("setVideoContainer"==b)return function(c){return a.c.Vd(c)};
if(a.a.fa()){if("getManifest"==b||"drmInfo"==b)return function(){Xa(b+"() does not work while casting!");return null};if("attach"==b||"detach"==b)return function(){Xa(b+"() does not work while casting!");return Promise.resolve()}}return a.a.fa()&&0==Object.keys(a.a.a.video).length&&ak[b]||!a.a.fa()?a.c[b].bind(a.c):a.a.get("player",b)}function wk(a,b,c){a.a.fa()&&("video"==b?a.g.dispatchEvent(c):"player"==b&&a.j.dispatchEvent(c));}K("shaka.cast.CastProxy",tk);tk.prototype.changeReceiverId=tk.prototype.fe;
tk.prototype.forceDisconnect=tk.prototype.hb;tk.prototype.suggestDisconnect=tk.prototype.df;tk.prototype.setAppData=tk.prototype.md;tk.prototype.cast=tk.prototype.cast;tk.prototype.receiverName=tk.prototype.fd;tk.prototype.isCasting=tk.prototype.fa;tk.prototype.canCast=tk.prototype.de;tk.prototype.getPlayer=tk.prototype.we;tk.prototype.getVideo=tk.prototype.Ee;tk.prototype.destroy=tk.prototype.destroy;function Ek(a,b,c,d){xc.call(this);var e=this;this.a=a;this.c=b;this.b=new Tc;this.J={video:a,player:b};this.D=c||function(){};this.M=d||function(f){return f};this.f=null;this.H=!1;this.j=!0;this.h=0;this.A=!1;this.v=!0;this.m=this.g=null;this.I=new N(function(){Fk(e);});Gk(this);}pa(Ek,xc);p=Ek.prototype;p.isConnected=function(){return this.H};p.He=function(){return this.j};p.$e=function(a){this.f=a;};p.ie=function(){this.f=null;};
p.af=function(a){this.f||(this.f={metadataType:cast.receiver.media.MetadataType.GENERIC});this.f.title=a;};p.Ze=function(a){this.f||(this.f={metadataType:cast.receiver.media.MetadataType.GENERIC});this.f.images=[{url:a}];};p.Ye=function(a){this.f||(this.f={});this.f.artist=a;this.f.metadataType=cast.receiver.media.MetadataType.MUSIC_TRACK;};
p.destroy=function(){var a=this,b,c;return J(function(d){if(1==d.a)return a.b&&(a.b.release(),a.b=null),b=[],a.c&&(b.push(a.c.destroy()),a.c=null),a.I&&(a.I.stop(),a.I=null),a.a=null,a.J=null,a.D=null,a.H=!1,a.j=!0,a.g=null,a.m=null,t(d,Promise.all(b),2);c=cast.receiver.CastReceiverManager.getInstance();c.stop();w(d);})};
function Gk(a){var b=cast.receiver.CastReceiverManager.getInstance();b.onSenderConnected=function(){return Hk(a)};b.onSenderDisconnected=function(){return Hk(a)};b.onSystemVolumeChanged=function(){var e=cast.receiver.CastReceiverManager.getInstance().getSystemVolume();e&&Ik(a,{type:"update",update:{video:{volume:e.level,muted:e.muted}}},a.g);Ik(a,{type:"event",targetName:"video",event:{type:"volumechange"}},a.g);};a.m=b.getCastMessageBus("urn:x-cast:com.google.cast.media");a.m.onMessage=function(e){return Jk(a,
e)};a.g=b.getCastMessageBus("urn:x-cast:com.google.shaka.v2");a.g.onMessage=function(e){return Kk(a,e)};b.start();b=q(Wj);for(var c=b.next();!c.done;c=b.next())a.b.l(a.a,c.value,function(e){return Lk(a,"video",e)});for(var d in Hj)a.b.l(a.c,Hj[d],function(e){return Lk(a,"player",e)});cast.__platform__&&cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160')?a.c.nd(3840,2160):a.c.nd(1920,1080);a.b.l(a.a,"loadeddata",function(){a.A=!0;});a.b.l(a.c,"loading",function(){a.j=
!1;Mk(a);});a.b.l(a.a,"playing",function(){a.j=!1;Mk(a);});a.b.l(a.a,"pause",function(){Mk(a);});a.b.l(a.c,"unloading",function(){a.j=!0;Mk(a);});a.b.l(a.a,"ended",function(){(new N(function(){a.a&&a.a.ended&&(a.j=!0,Mk(a));})).R(Nk);});}function Hk(a){a.h=0;a.v=!0;a.H=0!=cast.receiver.CastReceiverManager.getInstance().getSenders().length;Mk(a);}
function Mk(a){var b;J(function(c){if(1==c.a)return t(c,Promise.resolve(),2);if(!a.c)return c["return"]();b=new Q("caststatuschanged");a.dispatchEvent(b);Ok(a)||Pk(a);w(c);});}
function Qk(a,b,c){var d,e,f,g,h,k,l,m,n,r;J(function(u){switch(u.a){case 1:for(d in b.player)e=b.player[d],a.c[d](e);a.D(c);f=a.a.autoplay;return b.manifest?(a.a.autoplay=!1,x(u,5),t(u,a.c.load(b.manifest,b.startTime),7)):t(u,Promise.resolve(),3);case 7:ua(u,3);break;case 5:return g=C(u),h=Dj,k=new Q(h,{detail:g}),a.c.dispatchEvent(k),u["return"]();case 3:if(!a.c)return u["return"]();for(l in b.video)m=b.video[l],a.a[l]=m;for(n in b.playerAfterLoad)r=b.playerAfterLoad[n],a.c[n](r);a.a.autoplay=f;
b.manifest&&(a.a.play(),Pk(a));w(u);}});}function Lk(a,b,c){a.c&&(Fk(a),Ik(a,{type:"event",targetName:b,event:c},a.g));}
function Fk(a){a.I.R(Rk);for(var b={video:{},player:{}},c=q(Xj),d=c.next();!d.done;d=c.next())d=d.value,b.video[d]=a.a[d];if(a.c.S())for(var e in bk)0==a.h%bk[e]&&(b.player[e]=a.c[e]());for(var f in ak)0==a.h%ak[f]&&(b.player[f]=a.c[f]());if(c=cast.receiver.CastReceiverManager.getInstance().getSystemVolume())b.video.volume=c.level,b.video.muted=c.muted;a.A&&(a.h+=1);Ik(a,{type:"update",update:b},a.g);Ok(a);}function Ok(a){return a.v&&(a.a.duration||a.c.S())?(Sk(a),a.v=!1,!0):!1}
function Sk(a,b){var c={contentId:a.c.Qc(),streamType:a.c.S()?"LIVE":"BUFFERED",contentType:""};a.c.S()||(c.duration=a.a.duration);a.f&&(c.metadata=a.f);Pk(a,void 0===b?0:b,c);}
function Kk(a,b){var c=Uj(b.data);switch(c.type){case "init":a.h=0;a.A=!1;a.v=!0;Qk(a,c.initState,c.appData);Fk(a);break;case "appData":a.D(c.appData);break;case "set":var d=c.targetName,e=c.property;c=c.value;if("video"==d){var f=cast.receiver.CastReceiverManager.getInstance();if("volume"==e){f.setSystemVolumeLevel(c);break}else if("muted"==e){f.setSystemVolumeMuted(c);break}}a.J[d][e]=c;break;case "call":d=a.J[c.targetName];d[c.methodName].apply(d,c.args);break;case "asyncCall":d=c.targetName;e=
c.methodName;"player"==d&&"load"==e&&(a.h=0,a.A=!1);var g=c.id,h=b.senderId;f=a.J[d];c=f[e].apply(f,c.args);"player"==d&&"load"==e&&(c=c.then(function(){a.v=!0;}));c.then(function(){return Tk(a,h,g,null)},function(k){return Tk(a,h,g,k)});}}
function Jk(a,b){var c=Uj(b.data);switch(c.type){case "PLAY":a.a.play();Pk(a);break;case "PAUSE":a.a.pause();Pk(a);break;case "SEEK":var d=c.currentTime,e=c.resumeState;null!=d&&(a.a.currentTime=Number(d));e&&"PLAYBACK_START"==e?(a.a.play(),Pk(a)):e&&"PLAYBACK_PAUSE"==e&&(a.a.pause(),Pk(a));break;case "STOP":a.c.td().then(function(){a.c&&Pk(a);});break;case "GET_STATUS":Sk(a,Number(c.requestId));break;case "VOLUME":e=c.volume;d=e.level;e=e.muted;var f=a.a.volume,g=a.a.muted;null!=d&&(a.a.volume=Number(d));
null!=e&&(a.a.muted=e);f==a.a.volume&&g==a.a.muted||Pk(a);break;case "LOAD":a.h=0;a.A=!1;a.v=!1;d=c.media;e=c.currentTime;f=a.M(d.contentId);g=c.autoplay||!0;a.D(d.customData);g&&(a.a.autoplay=!0);a.c.load(f,e).then(function(){a.c&&Sk(a);})["catch"](function(h){var k="LOAD_FAILED";7==h.category&&7E3==h.code&&(k="LOAD_CANCELLED");Ik(a,{requestId:Number(c.requestId),type:k},a.m);});break;default:Ik(a,{requestId:Number(c.requestId),type:"INVALID_REQUEST",reason:"INVALID_COMMAND"},a.m);}}
function Tk(a,b,c,d){a.c&&Ik(a,{type:"asyncComplete",id:c,error:d},a.g,b);}function Ik(a,b,c,d){a.H&&(a=Tj(b),d?c.getCastChannel(d).send(a):c.broadcast(a));}function Pk(a,b,c){c=void 0===c?null:c;var d={mediaSessionId:0,playbackRate:a.a.playbackRate,playerState:a.j?Uk:a.c.Sc()?Vk:a.a.paused?Wk:Xk,currentTime:a.a.currentTime,supportedMediaCommands:63,volume:{level:a.a.volume,muted:a.a.muted}};c&&(d.media=c);Ik(a,{requestId:void 0===b?0:b,type:"MEDIA_STATUS",status:[d]},a.m);}
K("shaka.cast.CastReceiver",Ek);Ek.prototype.destroy=Ek.prototype.destroy;Ek.prototype.setContentArtist=Ek.prototype.Ye;Ek.prototype.setContentImage=Ek.prototype.Ze;Ek.prototype.setContentTitle=Ek.prototype.af;Ek.prototype.clearContentMetadata=Ek.prototype.ie;Ek.prototype.setContentMetadata=Ek.prototype.$e;Ek.prototype.isIdle=Ek.prototype.He;Ek.prototype.isConnected=Ek.prototype.isConnected;var Rk=.5,Nk=5,Uk="IDLE",Xk="PLAYING",Vk="BUFFERING",Wk="PAUSED";function Yk(a){var b=this;this.a=[];this.b=[];this.data=[];(new Mg).box("moov",Qg).ea("pssh",function(c){if(!(1<c.version)){var d=L(c.reader.P,-12,c.size);b.data.push(d);b.a.push(ec(c.reader.Wa(16)));if(0<c.version){d=c.reader.K();d=q(gb(d));for(var e=d.next();!e.done;e=d.next())e=ec(c.reader.Wa(16)),b.b.push(e);}}}).parse(a);}
function Zk(a){if(!a)return a;var b=new Yk(a);if(1>=b.data.length)return a;a=[];var c={};b=q(b.data);for(var d=b.next();!d.done;c={Tb:c.Tb},d=b.next())c.Tb=d.value,a.some(function(e){return function(f){return kb(f,e.Tb)}}(c))||a.push(c.Tb);return fc.apply($b,ia(a))}function $k(a,b){var c=al(a,b);return 1!=c.length?null:c[0]}function bl(a,b,c){a=cl(a,b,c);return 1!=a.length?null:a[0]}function al(a,b){return Array.from(a.childNodes).filter(function(c){return c instanceof Element&&c.tagName==b})}function cl(a,b,c){return Array.from(a.childNodes).filter(function(d){return d instanceof Element&&d.localName==c&&d.namespaceURI==b})}function dl(a,b,c){return a.hasAttributeNS(b,c)?a.getAttributeNS(b,c):null}
function kl(a){return Array.from(a.childNodes).every(function(b){return b.nodeType==Node.TEXT_NODE||b.nodeType==Node.CDATA_SECTION_NODE})?a.textContent.trim():null}function ll(a,b,c,d){d=void 0===d?null:d;var e=null;a=a.getAttribute(b);null!=a&&(e=c(a));return null==e?d:e}function ml(a){if(!a)return null;/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a)&&(a+="Z");a=Date.parse(a);return isNaN(a)?null:Math.floor(a/1E3)}
function nl(a){if(!a)return null;a=/^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$/.exec(a);if(!a)return null;a=31536E3*Number(a[1]||null)+2592E3*Number(a[2]||null)+86400*Number(a[3]||null)+3600*Number(a[4]||null)+60*Number(a[5]||null)+Number(a[6]||null);return isFinite(a)?a:null}function ol(a){var b=/([0-9]+)-([0-9]+)/.exec(a);if(!b)return null;a=Number(b[1]);if(!isFinite(a))return null;b=Number(b[2]);return isFinite(b)?{start:a,end:b}:null}
function pl(a){a=Number(a);return 0===a%1?a:null}function ql(a){a=Number(a);return 0===a%1&&0<a?a:null}function rl(a){a=Number(a);return 0===a%1&&0<=a?a:null}function sl(a){var b;a=(b=a.match(/^(\d+)\/(\d+)$/))?Number(b[1])/Number(b[2]):Number(a);return isNaN(a)?null:a}function tl(a,b){var c=new DOMParser,d=null,e=null;try{e=c.parseFromString(a,"text/xml");}catch(f){}e&&e.documentElement.tagName==b&&(d=e.documentElement);return d&&0<d.getElementsByTagName("parsererror").length?null:d}
function ul(a,b){try{var c=Tb(a);return tl(c,b)}catch(d){return null}}function vl(a,b){var c=wl(a),d=null,e=[],f=[],g=new Set(c.map(function(k){return k.keyId}));g["delete"](null);if(1<g.size)throw new M(2,4,4010);b||(f=c.filter(function(k){return "urn:mpeg:dash:mp4protection:2011"==k.Rd?(d=k.init||d,!1):!0}),f.length&&(e=xl(d,f),0==e.length&&(e=[Nb("",d)])));if(c.length&&(b||!f.length))for(e=[],c=q(yl.values()),f=c.next();!f.done;f=c.next())f=f.value,"org.w3.clearkey"!=f&&e.push(Nb(f,d));if(g=Array.from(g)[0]||null)for(c=q(e),f=c.next();!f.done;f=c.next()){f=q(f.value.initData);
for(var h=f.next();!h.done;h=f.next())h.value.keyId=g;}return {yd:g,Mf:d,drmInfos:e,Cd:!0}}function zl(a,b,c){var d=vl(a,c);if(b.Cd){a=1==b.drmInfos.length&&!b.drmInfos[0].keySystem;c=0==d.drmInfos.length;if(0==b.drmInfos.length||a&&!c)b.drmInfos=d.drmInfos;b.Cd=!1;}else if(0<d.drmInfos.length&&(b.drmInfos=b.drmInfos.filter(function(e){return d.drmInfos.some(function(f){return f.keySystem==e.keySystem})}),0==b.drmInfos.length))throw new M(2,4,4008);return d.yd||b.yd}
function Al(a){var b=0,c=ob(a),d=c.getUint32(b,!0);if(d!=a.byteLength)return [];a:{a=b+4+2;for(b=[];a<c.byteLength-1;){d=c.getUint16(a,!0);a+=2;var e=c.getUint16(a,!0);a+=2;if(0!=(e&1)||e+a>c.byteLength){c=[];break a}var f=L(c,a,e);b.push({type:d,value:f});a+=e;}c=b;}return c}
function Bl(a){a=q(a.getElementsByTagName("DATA"));for(var b=a.next();!b.done;b=a.next()){b=q(b.value.childNodes);for(var c=b.next();!c.done;c=b.next())if(c=c.value,c instanceof Element&&"LA_URL"==c.tagName)return c.textContent}return ""}
function xl(a,b){for(var c=[],d=q(b),e=d.next();!e.done;e=d.next()){e=e.value;var f=yl.get(e.Rd);if(f){var g;if(g=bl(e.node,"urn:microsoft:playready","pro")){g=cc(g.textContent);var h=new Uint8Array([154,4,240,121,152,64,66,134,171,146,230,91,224,136,95,149]),k=g.length,l=h.length+16+k,m=new Uint8Array(l),n=ob(m),r=0;n.setUint32(r,l);r+=4;n.setUint32(r,1886614376);r+=4;n.setUint32(r,0);r+=4;m.set(h,r);r+=h.length;n.setUint32(r,k);r+=4;m.set(g,r);g=[{initData:m,initDataType:"cenc",keyId:e.keyId}];}else g=
null;g=Nb(f,e.init||a||g);if(f=Cl.get(f))g.licenseServerUri=f(e);c.push(g);}}return c}function wl(a){var b=[];a=q(a);for(var c=a.next();!c.done;c=a.next())(c=Dl(c.value))&&b.push(c);return b}
function Dl(a){var b=a.getAttribute("schemeIdUri"),c=dl(a,"urn:mpeg:cenc:2013","default_KID"),d=cl(a,"urn:mpeg:cenc:2013","pssh").map(kl);if(!b)return null;b=b.toLowerCase();if(c&&(c=c.replace(/-/g,"").toLowerCase(),c.includes(" ")))throw new M(2,4,4009);var e=[];try{e=d.map(function(f){return {initDataType:"cenc",initData:cc(f),keyId:null}});}catch(f){throw new M(2,4,4007);}return {node:a,Rd:b,keyId:c,init:0<e.length?e:null}}
var yl=(new Map).set("urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b","org.w3.clearkey").set("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed","com.widevine.alpha").set("urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95","com.microsoft.playready").set("urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95","com.microsoft.playready").set("urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb","com.adobe.primetime"),Cl=(new Map).set("com.widevine.alpha",function(a){return (a=bl(a.node,"urn:microsoft","laurl"))?a.getAttribute("licenseUrl")||
"":""}).set("com.microsoft.playready",function(a){a=bl(a.node,"urn:microsoft:playready","pro");if(!a)return "";a=cc(a.textContent);a=Al(a).filter(function(b){return 1===b.type})[0];if(!a)return "";a=Vb(a.value,!0);return (a=tl(a,"WRMHEADER"))?Bl(a):""});function El(a,b,c,d,e){var f={RepresentationID:b,Number:c,Bandwidth:d,Time:e};return a.replace(/\$(RepresentationID|Number|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g,function(g,h,k,l){if("$$"==g)return "$";var m=f[h];if(null==m)return g;"RepresentationID"==h&&k&&(k=void 0);"Time"==h&&(m=Math.round(m));switch(l){case void 0:case "d":case "i":case "u":g=m.toString();break;case "o":g=m.toString(8);break;case "x":g=m.toString(16);break;case "X":g=m.toString(16).toUpperCase();break;default:g=m.toString();}k=
window.parseInt(k,10)||1;return Array(Math.max(0,k-g.length)+1).join("0")+g})}
function Fl(a,b){var c=Gl(a,b,"timescale"),d=1;c&&(d=ql(c)||1);c=Gl(a,b,"duration");(c=ql(c||""))&&(c/=d);var e=Gl(a,b,"startNumber"),f=Number(Gl(a,b,"presentationTimeOffset"))||0,g=rl(e||"");if(null==e||null==g)g=1;var h=Hl(a,b,"SegmentTimeline");e=null;if(h){e=d;var k=a.O.duration||Infinity,l=al(h,"S");h=[];var m=-f;l=q(ib(l));for(var n=l.next();!n.done;n=l.next()){n=n.value;var r=n.item,u=n.next,v=ll(r,"t",rl);n=ll(r,"d",rl);var A=ll(r,"r",pl);null!=v&&(v-=f);if(!n)break;r=null!=v?v:m;v=A||0;if(0>
v)if(u){u=ll(u,"t",rl);if(null==u)break;else if(r>=u)break;v=Math.ceil((u-r)/n)-1;}else {if(Infinity==k)break;else if(r/e>=k)break;v=Math.ceil((k*e-r)/n)-1;}0<h.length&&r!=m&&(h[h.length-1].end=r/e);u=q(gb(v+1));for(v=u.next();!v.done;v=u.next())m=r+n,h.push({start:r/e,end:m/e,kf:r}),r=m;}e=h;}return {timescale:d,Z:c,sb:g,Ha:f/d||0,ud:f,timeline:e}}function Gl(a,b,c){return [b(a.G),b(a.aa),b(a.ka)].filter(Kb).map(function(d){return d.getAttribute(c)}).reduce(function(d,e){return d||e})}
function Hl(a,b,c){return [b(a.G),b(a.aa),b(a.ka)].filter(Kb).map(function(d){return $k(d,c)}).reduce(function(d,e){return d||e})}
function Il(a,b,c,d,e,f){for(var g=dl(a,"http://www.w3.org/1999/xlink","href"),h=dl(a,"http://www.w3.org/1999/xlink","actuate")||"onRequest",k=q(Array.from(a.attributes)),l=k.next();!l.done;l=k.next())l=l.value,"http://www.w3.org/1999/xlink"==l.namespaceURI&&a.removeAttributeNS(l.namespaceURI,l.localName);if(5<=f)return pc(new M(2,4,4028));if("onLoad"!=h)return pc(new M(2,4,4027));var m=Mb([d],[g]);return e.request(0,Kc(m,b)).U(function(n){n=ul(n.data,a.tagName);if(!n)return pc(new M(2,4,4001,g));
for(;a.childNodes.length;)a.removeChild(a.childNodes[0]);for(;n.childNodes.length;){var r=n.childNodes[0];n.removeChild(r);a.appendChild(r);}n=q(Array.from(n.attributes));for(r=n.next();!r.done;r=n.next())a.setAttributeNode(r.value.cloneNode(!1));return Jl(a,b,c,m[0],e,f+1)})}
function Jl(a,b,c,d,e,f){f=void 0===f?0:f;if(dl(a,"http://www.w3.org/1999/xlink","href")){var g=Il(a,b,c,d,e,f);c&&(g=g.U(void 0,function(){return Jl(a,b,c,d,e,f)}));return g}g=[];for(var h=q(Array.from(a.childNodes)),k=h.next();!k.done;k=h.next())k=k.value,k instanceof Element&&("urn:mpeg:dash:resolve-to-zero:2013"==dl(k,"http://www.w3.org/1999/xlink","href")?a.removeChild(k):"SegmentTimeline"!=k.tagName&&g.push(Jl(k,b,c,d,e,f)));return tc(g).U(function(){return a})}function Kl(a,b,c,d,e,f,g){var h,k=(new Mg).ea("sidx",function(l){h=Ll(b,d,e,f,g,c,l);});a&&k.parse(a);if(h)return h;throw new M(2,3,3004);}
function Ll(a,b,c,d,e,f,g){var h=[];g.reader.skip(4);var k=g.reader.K();if(0==k)throw new M(2,3,3005);if(0==g.version){var l=g.reader.K();var m=g.reader.K();}else l=g.reader.rb(),m=g.reader.rb();g.reader.skip(2);var n=g.reader.Mb();a=a+g.size+m;n=q(gb(n));for(m=n.next();!m.done;m=n.next()){var r=g.reader.K();m=(r&2147483648)>>>31;r&=2147483647;var u=g.reader.K();g.reader.skip(4);if(1==m)throw new M(2,3,3006);h.push(new Xf(l/k+c,(l+u)/k+c,function(){return f},a,a+r-1,b,c,d,e));l+=u;a+=r;}g.parser.stop();
return h}function Ml(a){this.b=ob(a);this.a=new V(this.b,0);}Ml.prototype.wa=function(){return this.a.wa()};
function Nl(a){var b=Ol(a);if(7<b.length)throw new M(2,3,3002);var c=0;b=q(b);for(var d=b.next();!d.done;d=b.next())c=256*c+d.value;b=Ol(a);a:{d=q(Pl);for(var e=d.next();!e.done;e=d.next())if(kb(b,new Uint8Array(e.value))){d=!0;break a}d=!1;}if(d)b=a.b.byteLength-a.a.C;else {if(8==b.length&&b[1]&224)throw new M(2,3,3001);d=0;e=q(ib(b));for(var f=e.next();!f.done;f=e.next()){f=f.value;var g=f.item;d=0==f.Y?g&(1<<8-b.length)-1:256*d+g;}b=d;}b=a.a.C+b<=a.b.byteLength?b:a.b.byteLength-a.a.C;d=ob(a.b,a.a.C,
b);a.a.skip(b);return new Ql(c,d)}function Ol(a){var b=a.a.C,c=a.a.qa();if(0==c)throw new M(2,3,3002);c=8-Math.floor(Math.log2(c));a.a.skip(c-1);return L(a.b,b,c)}var Pl=[[255],[127,255],[63,255,255],[31,255,255,255],[15,255,255,255,255],[7,255,255,255,255,255],[3,255,255,255,255,255,255],[1,255,255,255,255,255,255,255]];function Ql(a,b){this.id=a;this.a=b;}
function Rl(a){if(8<a.a.byteLength)throw new M(2,3,3002);if(8==a.a.byteLength&&a.a.getUint8(0)&224)throw new M(2,3,3001);for(var b=0,c=q(gb(a.a.byteLength)),d=c.next();!d.done;d=c.next())d=a.a.getUint8(d.value),b=256*b+d;return b}function Sl(a,b,c,d,e,f,g,h,k){function l(){return e}var m=[];a=new Ml(a.a);for(var n=null,r=null;a.wa();){var u=Nl(a);if(187==u.id){var v=Tl(u);v&&(u=c*v.lf,v=b+v.Re,null!=n&&m.push(new Xf(n+g,u+g,l,r,v-1,f,g,h,k)),n=u,r=v);}}null!=n&&m.push(new Xf(n+g,d+g,l,r,null,f,g,h,k));return m}
function Tl(a){var b=new Ml(a.a);a=Nl(b);if(179!=a.id)throw new M(2,3,3013);a=Rl(a);b=Nl(b);if(183!=b.id)throw new M(2,3,3012);b=new Ml(b.a);for(var c=0;b.wa();){var d=Nl(b);if(241==d.id){c=Rl(d);break}}return {lf:a,Re:c}}function Ul(a,b){var c=Hl(a,b,"Initialization");if(!c)return null;var d=a.G.oa,e=c.getAttribute("sourceURL");e&&(d=Mb(a.G.oa,[e]));e=0;var f=null;if(c=ll(c,"range",ol))e=c.start,f=c.end;return new Vf(function(){return d},e,f)}
function Vl(a,b){var c=Number(Gl(a,Wl,"presentationTimeOffset"))||0,d=Gl(a,Wl,"timescale"),e=1;d&&(e=ql(d)||1);var f=c/e||0,g=Ul(a,Wl);Xl(a,g);var h=zc(a);return {ib:function(){var k=Hl(h,Wl,"RepresentationIndex"),l=h.G.oa;k&&(k=k.getAttribute("sourceURL"))&&(l=Mb(h.G.oa,[k]));k=Yl(h);return Zl(h,b,g,l,k.start,k.end,f)}}}
function Zl(a,b,c,d,e,f,g){var h,k,l,m,n,r,u,v,A,y,z,D,B,E,H;return J(function(G){var F;if(1==G.a)return h=a.presentationTimeline,k=!a.Oa||!a.O.Hd,l=a.O.start,m=a.O.duration,n=a.G.mimeType.split("/")[1],r=b,u=null,v=[r(d,e,f),"webm"==n?r(c.c(),c.b,c.a):null],r=null,t(G,Promise.all(v),2);A=G.b;y=A[0];z=A[1]||null;D=null;B=l-g;E=l;H=m?l+m:Infinity;if("mp4"==n)var I=Kl(y,e,d,c,B,E,H);else {I=new Ml(z);if(440786851!=Nl(I).id)throw new M(2,3,3008);var O=Nl(I);if(408125543!=O.id)throw new M(2,3,3009);I=
O.a.byteOffset;O=new Ml(O.a);for(F=null;O.wa();){var U=Nl(O);if(357149030==U.id){F=U;break}}if(!F)throw new M(2,3,3010);F=new Ml(F.a);U=1E6;for(O=null;F.wa();){var P=Nl(F);if(2807729==P.id)U=Rl(P);else if(17545==P.id)if(4==P.a.byteLength)O=P.a.getFloat32(0);else if(8==P.a.byteLength)O=P.a.getFloat64(0);else throw new M(2,3,3003);}if(null==O)throw new M(2,3,3011);F=U/1E9;F={ef:F,duration:O*F};O=F.ef;F=F.duration;U=Nl(new Ml(y));if(475249515!=U.id)throw new M(2,3,3007);I=Sl(U,I,O,F,d,c,B,E,H);}D=I;h.ob(D);
u=new T(D);k&&u.Ka(E,H);return G["return"](u)})}function Wl(a){return a.Nb}function Yl(a){var b=Hl(a,Wl,"RepresentationIndex");a=Gl(a,Wl,"indexRange");a=ol(a||"");b&&(a=ll(b,"range",ol,a));return a}function Xl(a,b){$l(a,b);if(!Yl(a))throw new M(2,4,4002);}function $l(a,b){var c=a.G.mimeType.split("/")[1];if("text"!=a.G.contentType&&"mp4"!=c&&"webm"!=c)throw new M(2,4,4006);if("webm"==c&&!b)throw new M(2,4,4005);}function am(a,b){var c=Ul(a,bm),d=cm(a);if(!d.Z&&!d.timeline&&1<d.lb.length)throw new M(2,4,4002);if(!d.Z&&!a.O.duration&&!d.timeline&&1==d.lb.length)throw new M(2,4,4002);if(d.timeline&&0==d.timeline.length)throw new M(2,4,4002);var e=null,f=null;a.ka.id&&a.G.id&&(f=a.ka.id+","+a.G.id,e=b[f]);c=dm(a.O.start,a.O.duration,a.G.oa,d,c);e?(e.mb(c),e.Pa(a.presentationTimeline.Ra())):(a.presentationTimeline.ob(c),e=new T(c),f&&a.Oa&&(b[f]=e));a.Oa&&a.O.Hd||e.Ka(a.O.start,a.O.duration?a.O.start+a.O.duration:
Infinity);return {ib:function(){return Promise.resolve(e)}}}function bm(a){return a.Na}function cm(a){var b=em(a);a=Fl(a,bm);var c=a.sb;0==c&&(c=1);var d=0;a.Z?d=a.Z*(c-1):a.timeline&&0<a.timeline.length&&(d=a.timeline[0].start);return {Z:a.Z,startTime:d,sb:c,Ha:a.Ha,timeline:a.timeline,lb:b}}
function dm(a,b,c,d,e){var f=d.lb.length;d.timeline&&d.timeline.length!=d.lb.length&&(f=Math.min(d.timeline.length,d.lb.length));var g=a-d.Ha,h=b?a+b:Infinity,k=[],l=d.startTime,m={};f=q(gb(f));for(var n=f.next();!n.done;m={Cc:m.Cc},n=f.next()){n=n.value;var r=d.lb[n];m.Cc=Mb(c,[r.Ke]);var u=void 0;u=null!=d.Z?l+d.Z:d.timeline?d.timeline[n].end:l+b;k.push(new Xf(a+l,a+u,function(v){return function(){return v.Cc}}(m),r.start,r.end,e,g,a,h));l=u;}return k}
function em(a){return [a.G.Na,a.aa.Na,a.ka.Na].filter(Kb).map(function(b){return al(b,"SegmentURL")}).reduce(function(b,c){return 0<b.length?b:c}).map(function(b){b.getAttribute("indexRange")&&!a.Fd&&(a.Fd=!0);var c=b.getAttribute("media");b=ll(b,"mediaRange",ol,{start:0,end:null});return {Ke:c,start:b.start,end:b.end}})}function fm(a,b,c,d,e){var f=gm(a),g=hm(a);im(g);var h=zc(a);if(g.Jb)return $l(a,f),{ib:function(){var u=El(g.Jb,h.G.id,null,h.bandwidth||null,null);u=Mb(h.G.oa,[u]);return Zl(h,b,f,u,0,null,g.Ha)}};if(g.Z)return d||(a.presentationTimeline.Yc(g.Z),a.presentationTimeline.Zc(a.O.start)),{ib:function(){return jm(h,g,e,f)}};var k=null;d=null;a.ka.id&&a.G.id&&(d=a.ka.id+","+a.G.id,k=c[d]);var l=km(h,g,f),m=a.O.start,n=a.O.duration?a.O.start+a.O.duration:Infinity,r=Infinity!=n;k?(r&&(new T(l)).Ka(m,n),
k.mb(l),k.Pa(a.presentationTimeline.Ra())):(a.presentationTimeline.ob(l),k=new T(l),d&&a.Oa&&(c[d]=k));r&&k.Ka(m,n);return {ib:function(){return Promise.resolve(k)}}}function lm(a){return a.Ob}function hm(a){var b=Fl(a,lm),c=Gl(a,lm,"media");a=Gl(a,lm,"index");return {Z:b.Z,timescale:b.timescale,sb:b.sb,Ha:b.Ha,ud:b.ud,timeline:b.timeline,Xc:c,Jb:a}}
function im(a){var b=a.Jb?1:0;b+=a.timeline?1:0;b+=a.Z?1:0;if(0==b)throw new M(2,4,4002);1!=b&&(a.Jb&&(a.timeline=null),a.Z=null);if(!a.Jb&&!a.Xc)throw new M(2,4,4002);}
function jm(a,b,c,d){function e(G){var F=(G-n)*m,I=F+b.Ha;F+=h;return new Xf(F,Math.min(F+m,l),function(){var O=El(u,A,G,v,I*r);return Mb(y,[O])},0,null,d,z,h,l)}function f(){var G=[Math.max(g.Ra(),h),Math.min(g.La(),l)].map(function(F){return F-h});return [Math.ceil(G[0]/m),Math.ceil(G[1]/m)-1].map(function(F){return F+n})}var g=a.presentationTimeline,h=a.O.start,k=a.O.duration,l=k?h+k:Infinity,m=b.Z,n=b.sb,r=b.timescale,u=b.Xc,v=a.bandwidth||null,A=a.G.id,y=a.G.oa,z=h-b.Ha,D=f();k=D[1];var B=[];
for(a=a.Oa?Math.max(D[0],D[1]-c+1):D[0];a<=k;++a)c=e(a),B.push(c);var E=new T(B);if(g.La()<l){var H=k+1;E.tc(m,function(){E.Pa(g.Ra());var G=q(f());G.next();G=G.next().value;for(var F=[];H<=G;){var I=e(H);F.push(I);H++;}return F});}return Promise.resolve(E)}
function km(a,b,c){var d=a.O.start,e=a.O.duration,f=d-b.Ha;e=e?d+e:Infinity;for(var g=[],h={},k=q(ib(b.timeline)),l=k.next();!l.done;h={Bc:h.Bc,Dc:h.Dc,Gc:h.Gc,yc:h.yc,Hc:h.Hc,zc:h.zc},l=k.next()){l=l.value;var m=l.item,n=m.start,r=m.kf;m=m.end;h.Gc=l.Y+b.sb;h.Hc=r+b.ud;h.Dc=a.G.id;h.yc=a.bandwidth||null;h.Bc=b.Xc;h.zc=a.G.oa;g.push(new Xf(d+n,d+m,function(u){return function(){var v=El(u.Bc,u.Dc,u.Gc,u.yc||null,u.Hc);return Mb(u.zc,[v]).map(function(A){return A.toString()})}}(h),0,null,c,f,d,e));}return g}
function gm(a){var b=Gl(a,lm,"initialization");if(!b)return null;var c=a.G.id,d=a.bandwidth||null,e=a.G.oa;return new Vf(function(){var f=El(b,c,null,d,null);return Mb(e,[f])},0,null)}function mm(){this.f=[];this.a=[];this.b=[];this.c=[];this.g=new Set;}mm.prototype.release=function(){for(var a=q(this.a.concat(this.b,this.c)),b=a.next();!b.done;b=a.next())b=b.value,b.segmentIndex&&b.segmentIndex.release();this.a=[];this.b=[];this.c=[];this.f=[];};
function nm(a,b,c){var d,e,f,g,h,k,l,m,n,r,u,v,A,y,z,D,B,E,H,G,F,I,O,U,P,Ga,aa,Ca,ya,Ra;return J(function(Ha){switch(Ha.a){case 1:d=Ob;om(b);pm(b);qm(b);if(!c&&1==b.length){e=b[0];a.a=e.dc;a.b=e.vc;a.c=e.textStreams;Ha.u(2);break}f=-1;g=q(ib(b));for(h=g.next();!h.done;h=g.next())l=k=h.value,m=l.Y,n=l.item,a.g.has(n.id)||(a.g.add(n.id),-1==f&&(f=m));if(-1==f)return Ha["return"]();r=b.map(function(Aa){return Aa.dc});u=b.map(function(Aa){return Aa.vc});v=b.map(function(Aa){return Aa.textStreams});A=
q(v);for(y=A.next();!y.done;y=A.next())z=y.value,z.push(rm());return t(Ha,sm(a.a,r,f,tm,um),3);case 3:return t(Ha,sm(a.b,u,f,tm,um),4);case 4:return t(Ha,sm(a.c,v,f,tm,um),2);case 2:D=0;B=[];if(a.b.length&&a.a.length)for(O=q(a.a),U=O.next();!U.done;U=O.next())for(P=U.value,Ga=q(a.b),aa=Ga.next();!aa.done;aa=Ga.next())Ca=aa.value,ya=ae(P.drmInfos,Ca.drmInfos),P.drmInfos.length&&Ca.drmInfos.length&&!ya.length||(Ra=D++,B.push({id:Ra,language:P.language,primary:P.primary,audio:P,video:Ca,bandwidth:(P.bandwidth||
0)+(Ca.bandwidth||0),drmInfos:ya,allowedByApplication:!0,allowedByKeySystem:!0}));else for(E=a.b.concat(a.a),H=q(E),G=H.next();!G.done;G=H.next())F=G.value,I=D++,B.push({id:I,language:F.language,primary:F.primary,audio:F.type==d.fb?F:null,video:F.type==d.Da?F:null,bandwidth:F.bandwidth||0,drmInfos:F.drmInfos,allowedByApplication:!0,allowedByKeySystem:!0});a.f=B;w(Ha);}})}
function om(a){a=q(a);for(var b=a.next();!b.done;b=a.next()){b=b.value;for(var c=[],d=q(b.dc),e=d.next();!e.done;e=d.next()){e=e.value;for(var f=!1,g=q(c),h=g.next();!h.done;h=g.next())h=h.value,e.id!=h.id&&e.channelsCount==h.channelsCount&&e.language==h.language&&e.bandwidth==h.bandwidth&&e.label==h.label&&e.codecs==h.codecs&&e.mimeType==h.mimeType&&Cc(e.roles,h.roles)&&e.audioSamplingRate==h.audioSamplingRate&&e.primary==h.primary&&(f=!0);f||c.push(e);}b.dc=c;}}
function qm(a){a=q(a);for(var b=a.next();!b.done;b=a.next()){b=b.value;for(var c=[],d=q(b.textStreams),e=d.next();!e.done;e=d.next()){e=e.value;for(var f=!1,g=q(c),h=g.next();!h.done;h=g.next())h=h.value,e.id!=h.id&&e.language==h.language&&e.label==h.label&&e.codecs==h.codecs&&e.mimeType==h.mimeType&&Cc(e.roles,h.roles)&&(f=!0);f||c.push(e);}b.textStreams=c;}}
function pm(a){a=q(a);for(var b=a.next();!b.done;b=a.next()){b=b.value;for(var c=[],d=q(b.vc),e=d.next();!e.done;e=d.next()){e=e.value;for(var f=!1,g=q(c),h=g.next();!h.done;h=g.next())h=h.value,e.id!=h.id&&e.width==h.width&&e.frameRate==h.frameRate&&e.codecs==h.codecs&&e.mimeType==h.mimeType&&e.label==h.label&&Cc(e.roles,h.roles)&&cd(e.closedCaptions,h.closedCaptions)&&e.bandwidth==h.bandwidth&&(f=!0);f||c.push(e);}b.vc=c;}}
function vm(a){var b,c,d,e,f,g,h,k,l,m,n,r,u,v,A,y,z,D,B,E,H,G;return J(function(F){switch(F.a){case 1:b=Ob;if(1==a.length)return F["return"](a[0]);c=a.map(function(I){return I.filter(function(O){return O.type==b.fb})});d=a.map(function(I){return I.filter(function(O){return O.type==b.Da})});e=a.map(function(I){return I.filter(function(O){return O.type==b.$})});f=q(e);for(g=f.next();!g.done;g=f.next())h=g.value,h.push({id:0,originalId:"",primary:!1,type:"text",mimeType:"",codecs:"",language:"",label:null,
width:null,height:null,encrypted:!1,keyIds:new Set,segments:[],variantIds:[],roles:[],channelsCount:null,audioSamplingRate:null,closedCaptions:null});return t(F,sm([],c,0,wm,xm),2);case 2:return k=F.b,t(F,sm([],d,0,wm,xm),3);case 3:return l=F.b,t(F,sm([],e,0,wm,xm),4);case 4:m=F.b;n=0;if(l.length&&k.length)for(y=q(k),z=y.next();!z.done;z=y.next())for(D=z.value,B=q(l),E=B.next();!E.done;E=B.next())H=E.value,G=n++,H.variantIds.push(G),D.variantIds.push(G);else for(r=l.concat(k),u=q(r),v=u.next();!v.done;v=
u.next())A=v.value,A.variantIds=[n++];return F["return"](l.concat(k,m))}})}
function sm(a,b,c,d,e){var f,g,h,k,l,m,n,r,u,v,A,y,z,D,B,E,H,G,F,I,O,U,P,Ga;return J(function(aa){switch(aa.a){case 1:f=Ob;g=[];h=q(ib(b));for(k=h.next();!k.done;k=h.next())m=l=k.value,n=m.Y,r=m.item,n>=c?g.push(new Set(r)):g.push(new Set);u=q(a);v=u.next();case 2:if(v.done){aa.u(4);break}A=v.value;return t(aa,ym(A,b,c,e,g),5);case 5:y=aa.b;if(!y)throw new M(2,4,4037);v=u.next();aa.u(2);break;case 4:z=q(g),D=z.next();case 6:if(D.done){aa.u(8);break}B=D.value;E=q(B);H=E.next();case 9:if(H.done){D=
z.next();aa.u(6);break}G=H.value;return t(aa,zm(G,b,d,e,g),12);case 12:(F=aa.b)&&a.push(F);H=E.next();aa.u(9);break;case 8:I=q(g);for(D=I.next();!D.done;D=I.next())for(O=D.value,U={},P=q(O),H=P.next();!H.done;U={eb:U.eb},H=P.next())if(U.eb=H.value,U.eb.type!=f.$||U.eb.language)if(Ga=a.some(function(Ca){return function(ya){return ya.mimeType==Ca.eb.mimeType&&hd(ya.codecs)[0]==hd(Ca.eb.codecs)[0]}}(U)))throw new M(2,4,4037);return aa["return"](a)}})}
function ym(a,b,c,d,e){var f;return J(function(g){if(1==g.a)return (f=Am(b,a))?t(g,Promise.all(f.map(function(h){return h.createSegmentIndex()})),2):g["return"](!1);Bm(a,f,c,d,e);return g["return"](!0)})}function zm(a,b,c,d,e){var f,g;return J(function(h){if(1==h.a)return f=c(a),(g=Am(b,f))?f.createSegmentIndex?t(h,Promise.all(g.map(function(k){return k.createSegmentIndex()})),2):h.u(2):h["return"](null);Bm(f,g,0,d,e);return h["return"](f)})}
function Bm(a,b,c,d,e){b=q(ib(b));for(var f=b.next();!f.done;f=b.next()){var g=f.value;f=g.Y;g=g.item;if(f>=c){d(a,g);var h=!0;"audio"==a.type&&0==hf(a.language,g.language)&&(h=!1);h&&e[f]["delete"](g);}}}function tm(a){a=Object.assign({},a);a.originalId=null;a.createSegmentIndex=function(){return Promise.resolve()};a.segmentIndex=new vg;a.emsgSchemeIdUris=[];a.keyIds=new Set;a.closedCaptions=null;a.trickModeVideo=null;return a}
function wm(a){a=Object.assign({},a);a.keyIds=new Set;a.segments=[];a.variantIds=[];a.closedCaptions=null;return a}
function um(a,b){a.roles=Array.from(new Set(a.roles.concat(b.roles)));b.emsgSchemeIdUris&&(a.emsgSchemeIdUris=Array.from(new Set(a.emsgSchemeIdUris.concat(b.emsgSchemeIdUris))));var c=b.keyIds;c=new Set(ia(a.keyIds).concat(ia(c)));a.keyIds=c;null==a.originalId?a.originalId=b.originalId:a.originalId+=","+(b.originalId||"");c=ae(a.drmInfos,b.drmInfos);if(b.drmInfos.length&&a.drmInfos.length&&!c.length)throw new M(2,4,4038);a.drmInfos=c;a.encrypted=a.encrypted||b.encrypted;if(b.closedCaptions){a.closedCaptions||
(a.closedCaptions=new Map);c=q(b.closedCaptions);for(var d=c.next();!d.done;d=c.next()){var e=q(d.value);d=e.next().value;e=e.next().value;a.closedCaptions.set(d,e);}}a.segmentIndex.g.push(b.segmentIndex);b.trickModeVideo?(a.trickModeVideo||(a.trickModeVideo=tm(b.trickModeVideo),a.trickModeVideo.segmentIndex=a.segmentIndex.clone()),um(a.trickModeVideo,b.trickModeVideo)):a.trickModeVideo&&um(a.trickModeVideo,b);}
function xm(a,b){a.roles=Array.from(new Set(a.roles.concat(b.roles)));var c=b.keyIds;c=new Set(ia(a.keyIds).concat(ia(c)));a.keyIds=c;a.encrypted=a.encrypted&&b.encrypted;a.segments.push.apply(a.segments,ia(b.segments));if(b.closedCaptions){a.closedCaptions||(a.closedCaptions=new Map);c=q(b.closedCaptions);for(var d=c.next();!d.done;d=c.next()){var e=q(d.value);d=e.next().value;e=e.next().value;a.closedCaptions.set(d,e);}}}
function Am(a,b){for(var c=[],d=q(a),e=d.next();!e.done;e=d.next()){var f=b,g={audio:Cm,video:Cm,text:Dm}[f.type],h={audio:Em,video:Fm,text:Gm}[f.type],k=null;e=q(e.value);for(var l=e.next();!l.done;l=e.next())l=l.value,!g(f,l)||k&&!h(f,k,l)||(k=l);f=k;if(!f)return null;c.push(f);}return c}function Cm(a,b){var c;if(!(c=b.mimeType!=a.mimeType||hd(b.codecs)[0]!=hd(a.codecs)[0])&&(c=a.drmInfos)){c=a.drmInfos;var d=b.drmInfos;c=!(c.length&&d.length?0<ae(c,d).length:1);}return c?!1:!0}
function Dm(a,b){return a.language?b.language?0==hf(a.language,b.language)||b.kind!=a.kind?!1:!0:!0:!1}
function Em(a,b,c){if(a.id==c.id)return !0;var d=hf(a.language,b.language),e=hf(a.language,c.language);if(e>d)return !0;if(e<d)return !1;if(!b.primary&&c.primary)return !0;if(b.primary&&!c.primary)return !1;if(a.roles.length)return d=b.roles.filter(function(f){return a.roles.includes(f)}),e=c.roles.filter(function(f){return a.roles.includes(f)}),e.length>d.length?!0:e.length<d.length?!1:c.roles.length<b.roles.length;if(!c.roles.length&&b.roles.length)return !0;if(c.roles.length&&!b.roles.length)return !1;
d=Hm(a.channelsCount,b.channelsCount,c.channelsCount);if(d==Im)return !0;if(d==Jm)return !1;d=Hm(a.audioSamplingRate,b.audioSamplingRate,c.audioSamplingRate);return d==Im?!0:d==Jm?!1:a.bandwidth&&Km(a.bandwidth,b.bandwidth,c.bandwidth)==Im?!0:!1}
function Fm(a,b,c){if(a.id==c.id)return !0;var d=Hm(a.width*a.height,b.width*b.height,c.width*c.height);if(d==Im)return !0;if(d==Jm)return !1;if(a.frameRate){d=Hm(a.frameRate,b.frameRate,c.frameRate);if(d==Im)return !0;if(d==Jm)return !1}return a.bandwidth&&Km(a.bandwidth,b.bandwidth,c.bandwidth)==Im?!0:!1}
function Gm(a,b,c){if(a.id==c.id)return !0;var d=hf(a.language,b.language),e=hf(a.language,c.language);if(e>d)return !0;if(e<d)return !1;if(!b.primary&&c.primary)return !0;if(b.primary&&!c.primary)return !1;if(a.roles.length){d=b.roles.filter(function(f){return a.roles.includes(f)});e=c.roles.filter(function(f){return a.roles.includes(f)});if(e.length>d.length)return !0;if(e.length<d.length)return !1}else {if(!c.roles.length&&b.roles.length)return !0;if(c.roles.length&&!b.roles.length)return !1}return c.mimeType!=
a.mimeType||c.codecs!=a.codecs||b.mimeType==a.mimeType&&b.codecs==a.codecs?!1:!0}function rm(){return {id:0,originalId:"",createSegmentIndex:function(){return Promise.resolve()},segmentIndex:new T([]),mimeType:"",codecs:"",encrypted:!1,drmInfos:[],keyIds:new Set,language:"",label:null,type:"text",primary:!1,trickModeVideo:null,emsgSchemeIdUris:null,roles:[],channelsCount:null,audioSamplingRate:null,closedCaptions:null}}
function Hm(a,b,c){if(b==a&&a!=c)return Jm;if(c==a&&a!=b)return Im;if(b>a){if(c<=a||c-a<b-a)return Im;if(c-a>b-a)return Jm}else {if(c>a)return Jm;if(a-c<a-b)return Im;if(a-c>a-b)return Jm}return Lm}function Km(a,b,c){b=Math.abs(a-b);a=Math.abs(a-c);return a<b?Im:b<a?Jm:Lm}var Im=1,Lm=0,Jm=-1;function Mm(){var a=this;this.s=this.i=null;this.b=[];this.o=null;this.m=1;this.f={};this.a=new mm;this.h=0;this.j=new Pa(5);this.g=new N(function(){a.Kb();});this.c=new Ec;}p=Mm.prototype;p.configure=function(a){this.i=a;};p.start=function(a,b){var c=this,d;return J(function(e){if(1==e.a)return c.b=[a],c.s=b,t(e,Nm(c),2);d=e.b;c.s&&Om(c,d);if(!c.s)throw new M(2,7,7001);return e["return"](c.o)})};
p.stop=function(){for(var a=q(Object.values(this.f)),b=a.next();!b.done;b=a.next())b.value.release();this.a&&this.a.release();this.i=this.s=null;this.b=[];this.o=null;this.f={};this.a=null;null!=this.g&&(this.g.stop(),this.g=null);return this.c.destroy()};p.update=function(){var a=this,b;return J(function(c){if(1==c.a)return x(c,2),t(c,Nm(a),4);if(2!=c.a)return ua(c,0);b=C(c);if(!a.s||!b)return c["return"]();a.s.onError(b);w(c);})};p.onExpirationUpdated=function(){};
function Nm(a){var b,c,d,e,f,g,h;return J(function(k){if(1==k.a)return b=Kc(a.b,a.i.retryParameters),c=a.s.networkingEngine,d=Date.now(),e=c.request(0,b),Fc(a.c,e),t(k,e.promise,2);if(3!=k.a){f=k.b;if(!a.s)return k["return"](0);f.uri&&!a.b.includes(f.uri)&&a.b.unshift(f.uri);return t(k,Pm(a,f.data,f.uri),3)}g=Date.now();h=(g-d)/1E3;Qa(a.j,1,h);return k["return"](h)})}
function Pm(a,b,c){var d,e,f,g;return J(function(h){if(1==h.a){d=ul(b,"MPD");if(!d)throw new M(2,4,4001,c);e=a.i.dash.xlinkFailGracefully;f=Jl(d,a.i.retryParameters,e,c,a.s.networkingEngine);Fc(a.c,f);return t(h,f.promise,2)}g=h.b;return h["return"](Qm(a,g,c))})}
function Qm(a,b,c){var d,e,f,g,h,k,l,m,n,r,u,v,A,y,z,D,B,E,H,G,F,I,O;return J(function(U){switch(U.a){case 1:d=[c];e=al(b,"Location").map(kl).filter(Kb);0<e.length&&(f=Mb(d,e),d=a.b=f);g=al(b,"BaseURL").map(kl);h=Mb(d,g);k=a.i.dash.ignoreMinBufferTime;l=0;k||(l=ll(b,"minBufferTime",nl)||0);a.h=ll(b,"minimumUpdatePeriod",nl,-1);m=ll(b,"availabilityStartTime",ml);n=ll(b,"timeShiftBufferDepth",nl);r=a.i.dash.ignoreSuggestedPresentationDelay;u=null;r||(u=ll(b,"suggestedPresentationDelay",nl));v=ll(b,
"maxSegmentDuration",nl);A=b.getAttribute("type")||"static";a.o?y=a.o.presentationTimeline:(z=a.i.defaultPresentationDelay||1.5*l,D=null!=u?u:z,y=new S(m,D,a.i.dash.autoCorrectDrift));B={Oa:"static"!=A,presentationTimeline:y,ka:null,O:null,aa:null,G:null,bandwidth:0,Fd:!1};var P=ll(b,"mediaPresentationDuration",nl),Ga=[],aa=0,Ca=al(b,"Period");Ca=q(ib(Ca));for(var ya=Ca.next();!ya.done;ya=Ca.next()){var Ra=ya.value;ya=Ra.item;Ra=Ra.next;aa=ll(ya,"start",nl,aa);var Ha=ll(ya,"duration",nl),Aa=null;
if(Ra){var Qb=ll(Ra,"start",nl);null!=Qb&&(Aa=Qb-aa);}else null!=P&&(Aa=P-aa);null==Aa&&(Aa=Ha);ya=Rm(a,B,h,{start:aa,duration:Aa,node:ya,Hd:null==Aa||!Ra});Ga.push(ya);if(null==Aa){aa=null;break}aa+=Aa;}E=null!=P?{periods:Ga,duration:P,zd:!1}:{periods:Ga,duration:aa,zd:!0};H=E.duration;G=E.periods;y.Pb("static"==A);"static"!=A&&E.zd||y.za(H||Infinity);(F=y.S())&&!isNaN(a.i.availabilityWindowOverride)&&(n=a.i.availabilityWindowOverride);null==n&&(n=Infinity);y.pd(n);y.Yc(v||1);return t(U,nm(a.a,G,B.Oa),
2);case 2:if(a.o){a.o.variants=a.a.f;a.o.textStreams=a.a.c;U.u(3);break}a.o={presentationTimeline:y,variants:a.a.f,textStreams:a.a.c,offlineSessionIds:[],minBufferTime:l||0};if(!y.Xd()){U.u(3);break}I=al(b,"UTCTiming");return t(U,Sm(a,h,I),5);case 5:O=U.b;if(!a.s)return U["return"]();y.Td(O);case 3:return a.s.makeTextStreamsForClosedCaptions(a.o),t(U,a.s.filter(a.o),0)}})}
function Rm(a,b,c,d){b.ka=Tm(d.node,null,c);b.O=d;b.ka.id||(b.ka.id="__shaka_period_"+d.start);c=al(d.node,"EventStream");c=q(c);for(var e=c.next();!e.done;e=c.next())Um(a,d.start,d.duration,e.value);c=al(d.node,"AdaptationSet").map(function(m){return Vm(a,b,m)}).filter(Kb);if(b.Oa){d=[];e=q(c);for(var f=e.next();!f.done;f=e.next()){f=q(f.value.Ue);for(var g=f.next();!g.done;g=f.next())d.push(g.value);}if(d.length!=(new Set(d)).size)throw new M(2,4,4018);}d=c.filter(function(m){return !m.sd});c=c.filter(function(m){return m.sd});
c=q(c);for(e=c.next();!e.done;e=c.next()){e=e.value;f=e.sd.split(" ");g=q(d);for(var h=g.next();!h.done;h=g.next()){var k=h.value;if(f.includes(k.id)){h={};k=q(k.streams);for(var l=k.next();!l.done;h={Rb:h.Rb,Xb:h.Xb},l=k.next())h.Xb=l.value,h.Rb=dd,h.Xb.trickModeVideo=e.streams.find(function(m){return function(n){return m.Rb.a(m.Xb.codecs)==m.Rb.a(n.codecs)}}(h));}}}e=a.i.disableAudio?[]:Wm(d,"audio");f=a.i.disableVideo?[]:Wm(d,"video");c=a.i.disableText?[]:Wm(d,"text");if(!f.length&&!e.length)throw new M(2,
4,4004);d=[];e=q(e);for(g=e.next();!g.done;g=e.next())d.push.apply(d,ia(g.value.streams));e=[];f=q(f);for(g=f.next();!g.done;g=f.next())e.push.apply(e,ia(g.value.streams));f=[];c=q(c);for(g=c.next();!g.done;g=c.next())f.push.apply(f,ia(g.value.streams));return {id:b.ka.id,dc:d,vc:e,textStreams:f}}function Wm(a,b){return a.filter(function(c){return c.contentType==b})}
function Vm(a,b,c){b.aa=Tm(c,b.ka,null);if("image"==b.aa.contentType)return null;var d=!1,e=al(c,"Role"),f=e.map(function(B){return B.getAttribute("value")}).filter(Kb),g=void 0,h="text"==b.aa.contentType;h&&(g="subtitle");e=q(e);for(var k=e.next();!k.done;k=e.next()){k=k.value;var l=k.getAttribute("schemeIdUri");if(null==l||"urn:mpeg:dash:role:2011"==l)switch(k=k.getAttribute("value"),k){case "main":d=!0;break;case "caption":case "subtitle":g=k;}}l=al(c,"EssentialProperty");e=null;k=!1;l=q(l);for(var m=
l.next();!m.done;m=l.next())m=m.value,"http://dashif.org/guidelines/trickmode"==m.getAttribute("schemeIdUri")?e=m.getAttribute("value"):k=!0;l=al(c,"Accessibility");var n=new Map;l=q(l);for(m=l.next();!m.done;m=l.next()){var r=m.value;m=r.getAttribute("schemeIdUri");r=r.getAttribute("value");if("urn:scte:dash:cc:cea-608:2015"==m||"urn:scte:dash:cc:cea-708:2015"==m)if(m=1,null!=r){r=q(r.split(";"));for(var u=r.next();!u.done;u=r.next()){var v=u.value,A=u=void 0;v.includes("=")?(v=v.split("="),u=v[0].startsWith("CC")?
v[0]:"CC"+v[0],A=v[1].split(",")[0].split(":").pop()):(u="CC"+m,m+=2,A=v);n.set(u,R(A));}}else n.set("CC1","und");else "urn:mpeg:dash:role:2011"==m&&null!=r&&(f.push(r),"captions"==r&&(g="caption"));}if(k)return null;k=al(c,"ContentProtection");var y=vl(k,a.i.dash.ignoreDrmInfo),z=R(c.getAttribute("lang")||"und"),D=c.getAttribute("label");(k=al(c,"Label"))&&k.length&&(k=k[0],k.textContent&&(D=k.textContent));k=al(c,"Representation");c=k.map(function(B){return Xm(a,b,y,g,z,D,d,f,n,B)}).filter(function(B){return !!B});
if(0==c.length){if(a.i.dash.ignoreEmptyAdaptationSet||h)return null;throw new M(2,4,4003);}if(!b.aa.contentType||"application"==b.aa.contentType)for(b.aa.contentType=Ym(c[0].mimeType,c[0].codecs),h=q(c),l=h.next();!l.done;l=h.next())l.value.type=b.aa.contentType;h=q(c);for(l=h.next();!l.done;l=h.next())for(l=l.value,m=q(y.drmInfos),r=m.next();!r.done;r=m.next())r=r.value,r.keyIds=r.keyIds&&l.keyIds?new Set(ia(r.keyIds).concat(ia(l.keyIds))):r.keyIds||l.keyIds;h=k.map(function(B){return B.getAttribute("id")}).filter(Kb);
return {id:b.aa.id||"__fake__"+a.m++,contentType:b.aa.contentType,language:z,Nf:d,streams:c,drmInfos:y.drmInfos,sd:e,Ue:h}}
function Xm(a,b,c,d,e,f,g,h,k,l){b.G=Tm(l,b.aa,null);if(!Zm(b.G))return null;var m=b.O.start;b.bandwidth=ll(l,"bandwidth",ql)||0;var n=b.G.contentType;n="text"==n||"application"==n;try{var r=function(z,D,B){return $m(a,z,D,B)};if(b.G.Nb)var u=Vl(b,r);else if(b.G.Na)u=am(b,a.f);else if(b.G.Ob)u=fm(b,r,a.f,!!a.o,a.i.dash.initialSegmentLimit);else {var v=b.G.oa,A=b.O.duration||0;u={ib:function(){return Promise.resolve(ug(m,A,v))}};}}catch(z){if(n&&4002==z.code)return null;throw z;}n=al(l,"ContentProtection");
n=zl(n,c,a.i.dash.ignoreDrmInfo);n=new Set(n?[n]:[]);al(l,"SupplementalProperty").some(function(z){return "tag:dolby.com,2018:dash:EC3_ExtensionType:2018"==z.getAttribute("schemeIdUri")&&"JOC"==z.getAttribute("value")})&&(b.G.mimeType="audio/eac3-joc");var y={id:a.m++,originalId:b.G.id,createSegmentIndex:function(){var z;return J(function(D){if(1==D.a){if(y.segmentIndex)return D.u(0);z=y;return t(D,u.ib(),3)}z.segmentIndex=D.b;w(D);})},segmentIndex:null,mimeType:b.G.mimeType,codecs:b.G.codecs,frameRate:b.G.frameRate,
pixelAspectRatio:b.G.pixelAspectRatio,bandwidth:b.bandwidth,width:b.G.width,height:b.G.height,kind:d,encrypted:0<c.drmInfos.length,drmInfos:c.drmInfos,keyIds:n,language:e,label:f,type:b.aa.contentType,primary:g,trickModeVideo:null,emsgSchemeIdUris:b.G.emsgSchemeIdUris,roles:h,channelsCount:b.G.$c,audioSamplingRate:b.G.audioSamplingRate,closedCaptions:k};return y}
p.Kb=function(){var a=this,b,c;return J(function(d){switch(d.a){case 1:return b=0,x(d,2),t(d,Nm(a),4);case 4:b=d.b;ua(d,3);break;case 2:c=C(d),a.s&&(c.severity=1,a.s.onError(c));case 3:if(!a.s)return d["return"]();Om(a,b);w(d);}})};function Om(a,b){0>a.h||a.g.R(Math.max(3,a.h-b,Ta(a.j)));}
function Tm(a,b,c){b=b||{contentType:"",mimeType:"",codecs:"",emsgSchemeIdUris:[],frameRate:void 0,pixelAspectRatio:void 0,$c:null,audioSamplingRate:null};c=c||b.oa;var d=al(a,"BaseURL").map(kl),e=a.getAttribute("contentType")||b.contentType,f=a.getAttribute("mimeType")||b.mimeType,g=a.getAttribute("codecs")||b.codecs,h=ll(a,"frameRate",sl)||b.frameRate,k=a.getAttribute("sar")||b.pixelAspectRatio,l=al(a,"InbandEventStream"),m=b.emsgSchemeIdUris.slice();l=q(l);for(var n=l.next();!n.done;n=l.next())n=
n.value.getAttribute("schemeIdUri"),m.includes(n)||m.push(n);l=al(a,"AudioChannelConfiguration");l=an(l)||b.$c;n=ll(a,"audioSamplingRate",rl)||b.audioSamplingRate;e||(e=Ym(f,g));return {oa:Mb(c,d),Nb:$k(a,"SegmentBase")||b.Nb,Na:$k(a,"SegmentList")||b.Na,Ob:$k(a,"SegmentTemplate")||b.Ob,width:ll(a,"width",rl)||b.width,height:ll(a,"height",rl)||b.height,contentType:e,mimeType:f,codecs:g,frameRate:h,pixelAspectRatio:k,emsgSchemeIdUris:m,id:a.getAttribute("id"),$c:l,audioSamplingRate:n}}
function an(a){a=q(a);for(var b=a.next();!b.done;b=a.next()){var c=b.value;if(b=c.getAttribute("schemeIdUri"))if(c=c.getAttribute("value"))switch(b){case "urn:mpeg:dash:outputChannelPositionList:2012":return c.trim().split(/ +/).length;case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":case "urn:dts:dash:audio_channel_configuration:2012":b=parseInt(c,10);if(!b)continue;return b;case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":case "urn:dolby:dash:audio_channel_configuration:2011":if(b=
parseInt(c,16)){for(a=0;b;)b&1&&++a,b>>=1;return a}}}return null}function Zm(a){var b=a.Nb?1:0;b+=a.Na?1:0;b+=a.Ob?1:0;if(0==b)return "text"==a.contentType||"application"==a.contentType?!0:!1;1!=b&&(a.Nb&&(a.Na=null),a.Ob=null);return !0}
function bn(a,b,c,d){var e,f,g,h,k,l;return J(function(m){if(1==m.a)return e=Mb(b,[c]),f=Kc(e,a.i.retryParameters),f.method=d,g=a.s.networkingEngine.request(4,f),Fc(a.c,g),t(m,g.promise,2);h=m.b;if("HEAD"==d){if(!h.headers||!h.headers.date)return m["return"](0);k=h.headers.date;}else k=Tb(h.data);l=Date.parse(k);return isNaN(l)?m["return"](0):m["return"](l-Date.now())})}
function Sm(a,b,c){var d,e,f,g,h,k,l,m;return J(function(n){switch(n.a){case 1:d=c.map(function(r){return {scheme:r.getAttribute("schemeIdUri"),value:r.getAttribute("value")}}),e=a.i.dash.clockSyncUri,!d.length&&e&&d.push({scheme:"urn:mpeg:dash:utc:http-head:2014",value:e}),f=q(d),g=f.next();case 2:if(g.done){n.u(4);break}h=g.value;x(n,5);k=h.scheme;l=h.value;switch(k){case "urn:mpeg:dash:utc:http-head:2014":case "urn:mpeg:dash:utc:http-head:2012":return n.u(7);case "urn:mpeg:dash:utc:http-xsdate:2014":case "urn:mpeg:dash:utc:http-iso:2014":case "urn:mpeg:dash:utc:http-xsdate:2012":case "urn:mpeg:dash:utc:http-iso:2012":return n.u(8);
case "urn:mpeg:dash:utc:direct:2014":case "urn:mpeg:dash:utc:direct:2012":return m=Date.parse(l),n["return"](isNaN(m)?0:m-Date.now());case "urn:mpeg:dash:utc:http-ntp:2014":case "urn:mpeg:dash:utc:ntp:2014":case "urn:mpeg:dash:utc:sntp:2014":Xa("NTP UTCTiming scheme is not supported");break;default:Xa("Unrecognized scheme in UTCTiming element",k);}n.u(9);break;case 7:return t(n,bn(a,b,l,"HEAD"),10);case 10:return n["return"](n.b);case 8:return t(n,bn(a,b,l,"GET"),11);case 11:return n["return"](n.b);
case 9:ua(n,3);break;case 5:C(n);case 3:g=f.next();n.u(2);break;case 4:return Xa("A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!"),n["return"](0)}})}
function Um(a,b,c,d){var e=d.getAttribute("schemeIdUri")||"",f=d.getAttribute("value")||"",g=ll(d,"timescale",rl)||1;d=q(al(d,"Event"));for(var h=d.next();!h.done;h=d.next()){h=h.value;var k=ll(h,"presentationTime",rl)||0,l=ll(h,"duration",rl)||0;k=k/g+b;l=k+l/g;null!=c&&(k=Math.min(k,b+c),l=Math.min(l,b+c));h={schemeIdUri:e,value:f,startTime:k,endTime:l,id:h.getAttribute("id")||"",eventElement:h};a.s.onTimelineRegionAdded(h);}}
function $m(a,b,c,d){var e,f,g,h,k;return J(function(l){if(1==l.a)return e=Qc,f=Ug(b,c,d,a.i.retryParameters),g=a.s.networkingEngine,h=g.request(e,f),Fc(a.c,h),t(l,h.promise,2);k=l.b;return l["return"](k.data)})}function Ym(a,b){return Ee(ed(a,b))?"text":a.split("/")[0]}K("shaka.dash.DashParser",Mm);Tf.mpd=function(){return new Mm};Rf["application/dash+xml"]=function(){return new Mm};Rf["video/vnd.mpeg.dash.mpd"]=function(){return new Mm};function cn(a,b,c,d){this.a=a;this.type=b;this.V=c;this.segments=d||null;}function dn(a,b,c,d){this.id=a;this.name=b;this.a=c;this.value=void 0===d?null:d;}dn.prototype.toString=function(){function a(d){return d.name+"="+(isNaN(Number(d.value))?'"'+d.value+'"':d.value)}var b="#"+this.name,c=this.a?this.a.map(a):[];this.value&&c.unshift(this.value);0<c.length&&(b+=":"+c.join(","));return b};
dn.prototype.getAttribute=function(a){var b=this.a.filter(function(c){return c.name==a});return b.length?b[0]:null};function en(a,b,c){return (a=a.getAttribute(b))?a.value:c||null}function fn(a,b){var c=a.getAttribute(b);if(!c)throw new M(2,4,4023,b);return c.value}function gn(a,b){this.V=b;this.a=a;}function hn(a,b){this.name=a;this.value=b;}function jn(a,b){return a.filter(function(c){return c.name==b})}function kn(a,b){return a.filter(function(c){return fn(c,"TYPE")==b})}function ln(a,b){var c=jn(a,b);return c.length?c[0]:null}function mn(a,b,c){c=void 0===c?0:c;return (a=ln(a,b))?Number(a.value):c}function nn(a){this.b=a;this.a=0;}function on(a){pn(a,/[ \t]+/gm);}function pn(a,b){b.lastIndex=a.a;var c=b.exec(a.b);c=null==c?null:{position:c.index,length:c[0].length,results:c};if(a.a==a.b.length||null==c||c.position!=a.a)return null;a.a+=c.length;return c.results}function qn(a){return a.a==a.b.length?null:(a=pn(a,/[^ \t\n]*/gm))?a[0]:null}function rn(){this.a=0;}
function sn(a,b,c){b=Tb(b);b=b.replace(/\r\n|\r(?=[^\n]|$)/gm,"\n").trim();var d=b.split(/\n+/m);if(!/^#EXTM3U($|[ \t\n])/m.test(d[0]))throw new M(2,4,4015);b=0;for(var e=!0,f=q(d),g=f.next();!g.done;g=f.next())if(g=g.value,/^#(?!EXT)/m.test(g)||e)e=!1;else if(g=tn(a.a++,g),--a.a,un.includes(g.name)){b=1;break}else "EXT-X-STREAM-INF"==g.name&&(e=!0);f=[];e=!0;g=q(ib(d));for(var h=g.next();!h.done;h=g.next()){var k=h.value;h=k.Y;var l=k.item;k=k.next;if(/^#(?!EXT)/m.test(l)||e)e=!1;else {l=tn(a.a++,
l);if(vn.includes(l.name)){if(1!=b)throw new M(2,4,4017);l=d.splice(h,d.length-h);d=c;e=[];g=[];h=null;l=q(l);for(k=l.next();!k.done;k=l.next())k=k.value,/^(#EXT)/.test(k)?(k=tn(a.a++,k),un.includes(k.name)?f.push(k):"EXT-X-MAP"==k.name?h=k:g.push(k)):/^#(?!EXT)/m.test(k)||(k=Mb([d],[k.trim()])[0],h&&g.push(h),e.push(new gn(k,g)),g=[]);return new cn(c,b,f,e)}f.push(l);"EXT-X-STREAM-INF"==l.name&&(l.a.push(new hn("URI",k)),e=!0);}}return new cn(c,b,f)}
function tn(a,b){var c=b.match(/^#(EXT[^:]*)(?::(.*))?$/);if(!c)throw new M(2,4,4016,b);var d=c[1],e=c[2];c=[];var f;if(e){e=new nn(e);var g;(g=pn(e,/^([^,=]+)(?:,|$)/g))&&(f=g[1]);for(var h=/([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g;g=pn(e,h);)c.push(new hn(g[1],g[2]||g[3]));}return new dn(a,d,c,f)}var un="EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST".split(" "),vn="EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP".split(" ");function wn(){}function xn(a){try{var b=yn(a);return rc({uri:a,Nd:a,data:b.data,headers:{"content-type":b.contentType}})}catch(c){return pc(c)}}function yn(a){var b=a.split(":");if(2>b.length||"data"!=b[0])throw new M(2,1,1004,a);b=b.slice(1).join(":").split(",");if(2>b.length)throw new M(2,1,1004,a);var c=b[0];a=window.decodeURIComponent(b.slice(1).join(","));b=c.split(";");c=b[0];var d=!1;1<b.length&&"base64"==b[b.length-1]&&(d=!0,b.pop());var e;d?e=cc(a):e=Xb(a);return {data:e,contentType:c}}
K("shaka.net.DataUriPlugin",wn);wn.parse=xn;Hc("data",xn);function zn(){var a=this;this.i=this.s=null;this.Ca=1;this.j=new Map;this.g=new Map;this.ta=new Set;this.a=new Map;this.b=null;this.J="";this.H=new rn;this.ca=0;this.h=new N(function(){a.Kb();});this.c=An;this.o=null;this.M=0;this.T=Infinity;this.m=new Ec;this.W=[];this.A=new Map;this.Ba=!1;this.f=new Map;this.D=null;this.I=new Map;this.v=new Map;}p=zn.prototype;p.configure=function(a){this.i=a;};
p.start=function(a,b){var c=this,d,e;return J(function(f){if(1==f.a)return c.s=b,t(f,Bn(c,Kc([a],c.i.retryParameters),0),2);if(3!=f.a)return d=f.b,c.J=d.uri,t(f,Cn(c,d.data),3);e=c.ca;0<e&&c.h.R(e);return f["return"](c.o)})};p.stop=function(){this.h&&(this.h.stop(),this.h=null);var a=[];this.m&&(a.push(this.m.destroy()),this.m=null);this.i=this.s=null;this.ta.clear();this.o=null;this.a.clear();this.g.clear();this.f.clear();this.j.clear();return Promise.all(a)};
p.update=function(){var a=this,b,c,d;return J(function(e){if(1==e.a){if(a.c==An)return e["return"]();b=[];a.D=null;c=Array.from(a.a.values());return c.length?t(e,Dn(a,c[0]),2):e.u(2)}for(d=1;d<c.length;d++)b.push(Dn(a,c[d]));return t(e,Promise.all(b),0)})};
function Dn(a,b){var c,d,e,f,g,h,k,l,m,n;return J(function(r){if(1==r.a)return c=En,d=b.be,t(r,Bn(a,Kc([d],a.i.retryParameters),0),2);if(3!=r.a){e=r.b;f=sn(a.H,e.data,e.uri);if(1!=f.type)throw new M(2,4,4017);g=jn(f.V,"EXT-X-DEFINE");h=Fn(a,g);k=b.stream;return t(r,Gn(a,b.uc,f,k.mimeType,b.Id,h),3)}l=r.b;k.segmentIndex.mb(l);l.length&&k.segmentIndex.Pa(l[0].startTime);m=l[l.length-1];if(n=ln(f.V,"EXT-X-ENDLIST"))Hn(a,c.$d),a.b.za(m.endTime);w(r);})}p.onExpirationUpdated=function(){};
function Cn(a,b){var c,d,e,f,g,h,k,l,m,n,r,u,v,A,y;return J(function(z){switch(z.a){case 1:c=sn(a.H,b,a.J);if(0!=c.type)throw new M(2,4,4022);d=jn(c.V,"EXT-X-DEFINE");for(var D=q(d),B=D.next();!B.done;B=D.next()){var E=B.value;B=en(E,"NAME");E=en(E,"VALUE");B&&E&&(a.j.has(B)||a.j.set(B,E));}e=jn(c.V,"EXT-X-MEDIA");f=jn(c.V,"EXT-X-STREAM-INF");D=q(f);for(B=D.next();!B.done;B=D.next()){var H=B.value;E=en(H,"AUDIO");B=en(H,"VIDEO");var G=en(H,"SUBTITLES");H=In(a,H);if(G){var F=Jn("text",H);a.f.set(G,
F);Bc(H,F);}E&&(G=Kn("audio",H),a.f.set(E,G));B&&(E=Kn("video",H),a.f.set(B,E));}return t(z,Ln(a,e),2);case 2:D=kn(e,"CLOSED-CAPTIONS");D=q(D);for(B=D.next();!B.done;B=D.next())G=B.value,B=Mn(G),E=fn(G,"GROUP-ID"),G=fn(G,"INSTREAM-ID"),a.A.get(E)||a.A.set(E,new Map),a.A.get(E).set(G,B);return t(z,Nn(a,f),3);case 3:return g=z.b,t(z,On(a,e),4);case 4:h=z.b;if(!a.s)throw new M(2,7,7001);if(a.Ba&&0==g.length)throw new M(2,4,4034);l=k=Infinity;m=q(a.a.values());for(n=m.next();!n.done;n=m.next())r=n.value,
k=Math.min(k,r.Jd),"text"!=r.stream.type&&(l=Math.min(l,r.Je-r.Jd));a.c!=An?(a.b=new S(0,a.i.defaultPresentationDelay||3*a.M),a.b.Pb(!1)):(a.b=new S(null,0),a.b.Pb(!0));Pn(a);if(a.c!=An)a.ca=a.T,u=En,a.c==u.Zd&&(v=a.b.rc,isNaN(a.i.availabilityWindowOverride)||(v=a.i.availabilityWindowOverride),a.b.pd(v));else for(a.b.za(l),a.b.offset(-k),A=q(a.a.values()),n=A.next();!n.done;n=A.next())y=n.value,y.stream.segmentIndex.offset(-k),y.stream.segmentIndex.Ka(0,l);a.o={presentationTimeline:a.b,variants:g,
textStreams:h,offlineSessionIds:[],minBufferTime:0};a.s.makeTextStreamsForClosedCaptions(a.o);return t(z,a.s.filter(a.o),0)}})}function Fn(a,b){for(var c=new Map,d=q(b),e=d.next();!e.done;e=d.next()){var f=e.value;e=en(f,"NAME");var g=en(f,"VALUE");f=en(f,"IMPORT");e&&g&&c.set(e,g);f&&(e=a.j.get(f))&&c.set(f,e);}return c}
function On(a,b){var c,d,e,f,g,h,k,l,m,n,r,u;return J(function(v){if(1==v.a)return c=kn(b,"SUBTITLES"),d=c.map(function(A){var y,z,D;return J(function(B){if(1==B.a){if(y=a.i.disableText)return B["return"](null);x(B,2);return t(B,Qn(a,A),4)}if(2!=B.a)return z=B.b,B["return"](z.stream);D=C(B);if(a.i.hls.ignoreTextStreamFailures)return B["return"](null);throw D;})}),t(v,Promise.all(d),2);e=v.b;f=q(c);for(g=f.next();!g.done;g=f.next())if(h=g.value,k=fn(h,"GROUP-ID"),l=a.f.get(k))if(m=a.g.get(k))for(n=
q(m),r=n.next();!r.done;r=n.next())u=r.value,u.stream.codecs=l;return v["return"](e.filter(function(A){return A}))})}function Ln(a,b){var c;return J(function(d){if(1==d.a)return b=b.filter(function(e){var f=en(e,"URI")||"";return "SUBTITLES"!=en(e,"TYPE")&&""!=f}),b.length?t(d,Qn(a,b[0]),2):d.u(2);c=b.slice(1).map(function(e){return Qn(a,e)});return t(d,Promise.all(c),0)})}
function Nn(a,b){var c,d,e;return J(function(f){if(1==f.a)return c=b.map(function(g){var h,k,l,m,n,r,u;return J(function(v){return 1==v.a?(h=en(g,"FRAME-RATE"),k=Number(fn(g,"BANDWIDTH")),l=en(g,"RESOLUTION"),m=q(l?l.split("x"):[null,null]),n=m.next().value,r=m.next().value,t(v,Rn(a,g,l,h),2)):(u=v.b)?v["return"](Sn(a,u.audio,u.video,k,n,r,h)):v["return"]([])})}),t(f,Promise.all(c),2);d=f.b;e=d.reduce(Ib,[]);e=e.filter(function(g){return null!=g});return f["return"](e)})}
function Rn(a,b,c,d){var e,f,g,h,k,l,m,n,r,u,v,A,y,z;return J(function(D){if(1==D.a)return e=Ob,f=In(a,b),g=en(b,"AUDIO"),h=en(b,"VIDEO"),l=(k=g||h)&&a.g.has(k)?a.g.get(k):[],m={audio:g?l:[],video:h?l:[]},r=!1,u=fn(b,"URI"),v=m.audio.find(function(B){return B&&B.uc==u}),A=Jn(e.Da,f),y=c||d||A,1!=f.length||y?!l.length&&1<f.length?(n=e.Da,f=[f.join(",")]):m.audio.length&&v?(n=e.fb,r=!0):n=m.video.length?e.fb:e.Da:n=e.fb,r?D.u(2):t(D,Tn(a,b,f,n),3);2!=D.a&&(z=D.b);if(z)m[z.stream.type]=[z];else if(null===
z)return D["return"](null);Un(m);return D["return"](m)})}function In(a,b){var c=[];a.i.disableVideo||c.push("avc1.42E01E");a.i.disableAudio||c.push("mp4a.40.2");var d=en(b,"CODECS",c.join(",")).split(/\s*,\s*/);c=new Set;var e=[];d=q(d);for(var f=d.next();!f.done;f=d.next()){f=f.value;var g=hd(f)[0];c.has(g)||(e.push(f),c.add(g));}return e}function Mn(a){a=en(a,"LANGUAGE")||"und";return R(a)}
function Un(a){a=q(a.audio.concat(a.video));for(var b=a.next();!b.done;b=a.next())if(b=b.value){var c=b.stream.codecs.split(",");c=c.filter(function(d){return "mp4a.40.34"!=d});b.stream.codecs=c.join(",");}}
function Sn(a,b,c,d,e,f,g){for(var h=q(c),k=h.next();!k.done;k=h.next()){k=k.value.stream;var l=f,m=g;k&&(k.width=Number(e)||void 0,k.height=Number(l)||void 0,k.frameRate=Number(m)||void 0);}e=a.i.disableAudio;if(!b.length||e)b=[null];e=a.i.disableVideo;if(!c.length||e)c=[null];e=[];b=q(b);for(f=b.next();!f.done;f=b.next())for(f=f.value,g=q(c),h=g.next();!h.done;h=g.next()){var n=h.value;h=f?f.stream:null;k=n?n.stream:null;l=f?f.stream.drmInfos:null;m=n?n.stream.drmInfos:null;n=(n?n.uc:"")+" - "+(f?
f.uc:"");h&&k&&!(l.length&&m.length?0<ae(l,m).length:1)||a.ta.has(n)||(h={id:a.Ca++,language:h?h.language:"und",primary:!!h&&h.primary||!!k&&k.primary,audio:h,video:k,bandwidth:d,allowedByApplication:!0,allowedByKeySystem:!0},e.push(h),a.ta.add(n));}return e}
function Qn(a,b){var c,d,e,f,g,h,k,l,m,n,r;return J(function(u){if(1==u.a){c=fn(b,"GROUP-ID");d="";var v=fn(b,"TYPE").toLowerCase();"subtitles"==v&&(v="text");e=v;"text"!=e&&c&&a.f.has(c)&&(d=a.f.get(c));f=Vn(fn(b,"URI"),a.j);if(a.a.has(f))return u["return"](a.a.get(f));g=Mn(b);h=en(b,"NAME");k=b.getAttribute("DEFAULT");l="YES"==k;v="audio"==e?(v=en(b,"CHANNELS"))?parseInt(v.split("/")[0],10):null:null;m=v;n=en(b,"CHARACTERISTICS");return t(u,Wn(a,f,d,e,g,l,h,m,null,n),2)}r=u.b;a.g.has(c)?a.g.get(c).push(r):
a.g.set(c,[r]);if(null==r)return u["return"](null);if(a.a.has(f))return u["return"](a.a.get(f));a.a.set(f,r);return u["return"](r)})}
function Tn(a,b,c,d){var e,f,g,h;return J(function(k){if(1==k.a){e=Vn(fn(b,"URI"),a.j);if(a.a.has(e))return k["return"](a.a.get(e));var l=en(b,"CLOSED-CAPTIONS");f="video"==d&&l&&"NONE"!=l?a.A.get(l):null;g=Kn(d,c);return t(k,Wn(a,e,g,d,"und",!1,null,null,f,null),2)}h=k.b;if(null==h)return k["return"](null);if(a.a.has(e))return k["return"](a.a.get(e));a.a.set(e,h);return k["return"](h)})}
function Wn(a,b,c,d,e,f,g,h,k,l){var m,n,r,u,v,A,y,z,D,B,E,H,G,F,I,O,U,P,Ga,aa,Ca,ya,Ra,Ha,Aa,Qb,Dg,el,fl,gl,hl,Eg,Fg,ze,il,jl;return J(function(Sa){switch(Sa.a){case 1:return m=Mb([a.J],[b])[0],t(Sa,Bn(a,Kc([m],a.i.retryParameters),0),2);case 2:n=Sa.b;m=n.uri;r=sn(a.H,n.data,m);if(1!=r.type)throw new M(2,4,4017);u=[];if(r.segments)for(v=q(r.segments),A=v.next();!A.done;A=v.next())y=A.value,z=jn(y.V,"EXT-X-KEY"),u.push.apply(u,ia(z));D=!1;B=[];E=new Set;H=q(u);for(G=H.next();!G.done;G=H.next())if(F=
G.value,I=fn(F,"METHOD"),"NONE"!=I){D=!0;if("AES-128"==I)return a.Ba=!0,Sa["return"](null);O=fn(F,"KEYFORMAT");if(P=(U=Xn[O])?U(F):null){if(P.keyIds)for(Ga=q(P.keyIds),aa=Ga.next();!aa.done;aa=Ga.next())Ca=aa.value,E.add(Ca);B.push(P);}}if(D&&!B.length)throw new M(2,4,4026);ya=jn(r.V,"EXT-X-DEFINE");Ra=Fn(a,ya);Yn(a,r);return t(Sa,Zn(a,d,c,r,Ra),3);case 3:return Ha=Sa.b,$n.includes(Ha)&&(c=""),Aa=new Map,x(Sa,4),t(Sa,Gn(a,b,r,Ha,Aa,Ra),6);case 6:Qb=Sa.b;ua(Sa,5);break;case 4:Dg=C(Sa);if(4035==Dg.code)return Xa("Skipping unsupported HLS stream",
Ha,b),Sa["return"](null);throw Dg;case 5:el=Qb[0].startTime;fl=Qb[Qb.length-1].endTime;gl=new T(Qb);hl="text"==d?"subtitle":void 0;Eg=[];if(l)for(Fg=q(l.split(",")),ze=Fg.next();!ze.done;ze=Fg.next())il=ze.value,Eg.push(il);jl={id:a.Ca++,originalId:g,createSegmentIndex:function(){return Promise.resolve()},segmentIndex:gl,mimeType:Ha,codecs:c,kind:hl,encrypted:D,drmInfos:B,keyIds:E,language:e,label:g,type:d,primary:f,trickModeVideo:null,emsgSchemeIdUris:null,frameRate:void 0,pixelAspectRatio:void 0,
width:void 0,height:void 0,bandwidth:void 0,roles:Eg,channelsCount:h,audioSamplingRate:null,closedCaptions:k};return Sa["return"]({stream:jl,uc:b,be:m,Jd:el,Je:fl,Id:Aa})}})}function Yn(a,b){var c=ln(b.V,"EXT-X-PLAYLIST-TYPE"),d=ln(b.V,"EXT-X-ENDLIST");d=c&&"VOD"==c.value||d;c=c&&"EVENT"==c.value&&!d;c=!d&&!c;d?Hn(a,An):(c?Hn(a,ao):Hn(a,bo),d=co(b.V,"EXT-X-TARGETDURATION"),d=Number(d.value),a.M=Math.max(d,a.M),a.T=Math.min(d,a.T));}
function eo(a,b,c,d){c=ln(c,"EXT-X-MAP");if(!c)return null;var e=fn(c,"URI");d=Vn(Mb([b],[e])[0],d);b=[d,en(c,"BYTERANGE","")].join("-");a.I.has(b)||(c=fo(d,c),a.I.set(b,c));return a.I.get(b)}function fo(a,b){var c=0,d=null,e=en(b,"BYTERANGE");e&&(c=e.split("@"),d=Number(c[0]),c=Number(c[1]),d=c+d-1);return new Vf(function(){return [a]},c,d)}
function go(a,b,c,d,e,f){var g=c.V,h=Vn(c.a,f);c=co(g,"EXTINF").value.split(",");c=d+Number(c[0]);f=0;var k=null;if(g=ln(g,"EXT-X-BYTERANGE"))f=g.value.split("@"),g=Number(f[0]),f=f[1]?Number(f[1]):b.a+1,k=f+g-1;return new Xf(d,c,function(){return [h]},f,k,a,e,0,Infinity)}function Pn(a){if(a.b){for(var b=q(a.W),c=b.next();!c.done;c=b.next())a.b.ob(c.value);a.W=[];}}
function Gn(a,b,c,d,e,f){var g,h,k,l,m,n,r,u,v,A,y,z,D,B,E,H,G,F,I,O,U;return J(function(P){switch(P.a){case 1:g=c.segments;k=mn(c.V,"EXT-X-MEDIA-SEQUENCE",0);if(a.c!=An&&e.has(k)){l=e.get(k);P.u(2);break}if(null!=a.D){P.u(3);break}h=eo(a,c.a,g[0].V,f);m=a;return t(P,ho(a,b,h,d,k,!1,g[0],f),4);case 4:m.D=P.b;case 3:l=a.D;case 2:n=g[0].a,ab(n.split("/").pop()),r=mn(c.V,"EXT-X-DISCONTINUITY-SEQUENCE"),u=a.v.get(r)||0,v=[],A=function(Ga){return ib(Ga)},y=q(A(g)),z=y.next();case 5:if(z.done){P.u(7);break}B=
D=z.value;E=B.Y;H=B.item;G=v[v.length-1];F=0==E?l:G.endTime;I=k+E;e.set(I,F);h=eo(a,c.a,H.V,f);O=ln(H.V,"EXT-X-DISCONTINUITY");if(!O){P.u(8);break}r++;return t(P,io(a,r,b,h,d,I,H,f,F),9);case 9:u=P.b;case 8:U=go(h,G,H,F,u,f);v.push(U);z=y.next();P.u(5);break;case 7:return a.W.push(v),Pn(a),P["return"](v)}})}
function io(a,b,c,d,e,f,g,h,k){var l,m;return J(function(n){if(1==n.a)return l=0,a.v.has(b)?(l=a.v.get(b),n.u(2)):t(n,ho(a,c,d,e,f,!0,g,h),3);2!=n.a&&(m=n.b,l=k-m,a.v.set(b,l));return n["return"](l)})}
function jo(a,b){var c,d,e,f,g,h;return J(function(k){switch(k.a){case 1:c=Qc;d=Ug(b.c(),b.b,b.a,a.i.retryParameters);if(a.i.hls.useFullSegmentsForStartTime)return k["return"](Bn(a,d,c));e=Ug(b.c(),b.b,b.b+2048-1,a.i.retryParameters);x(k,2);return t(k,Bn(a,e,c),4);case 4:return f=k.b,k["return"](f);case 2:g=C(k);if(7001==g.code)throw g;Xa("Unable to fetch a partial HLS segment! Falling back to a full segment request, which is expensive!  Your server should support Range requests and CORS preflights.",
e.uris[0]);return t(k,Bn(a,d,c),5);case 5:return h=k.b,k["return"](h)}})}
function ho(a,b,c,d,e,f,g,h){var k,l,m,n,r,u,v,A;return J(function(y){switch(y.a){case 1:k=go(c,null,g,0,0,h);if(a.o&&!f&&(l=a.a.get(b),m=l.Id.get(e),void 0!=m))return y["return"](m);d=d.toLowerCase();if($n.includes(d))throw Xa("Raw formats are not yet supported.  Skipping "+d),new M(1,4,4035);if("video/webm"==d)throw Xa("WebM in HLS is not yet supported.  Skipping."),new M(1,4,4035);if("video/mp4"!=d&&"audio/mp4"!=d){y.u(2);break}n=[jo(a,k)];c&&n.push(jo(a,c));return t(y,Promise.all(n),3);case 3:return r=
y.b,u=r[0],v=r[1]||r[0],y["return"](ko(b,u.uri,u.data,v.data));case 2:if("video/mp2t"!=d){y.u(4);break}return t(y,jo(a,k),5);case 5:return A=y.b,y["return"](lo(b,A.uri,A.data));case 4:throw new M(2,4,4030,b);}})}
function ko(a,b,c,d){var e=0;(new Mg).box("moov",Qg).box("trak",Qg).box("mdia",Qg).ea("mdhd",function(h){h.reader.skip(0==h.version?8:16);e=h.reader.K();h.parser.stop();}).parse(d,!0);if(!e)throw new M(2,4,4030,a,b);var f=0,g=!1;(new Mg).box("moof",Qg).box("traf",Qg).ea("tfdt",function(h){f=(0==h.version?h.reader.K():h.reader.rb())/e;g=!0;h.parser.stop();}).parse(c,!0);if(!g)throw new M(2,4,4030,a,b);return f}
function lo(a,b,c){function d(){f.seek(g+188);h=f.qa();71!=h&&(f.seek(g+192),h=f.qa());71!=h&&(f.seek(g+204),h=f.qa());71!=h&&e();f.Qd(1);}function e(){throw new M(2,4,4030,a,b);}for(var f=new V(c,0),g=0,h=0;;)if(g=f.C,h=f.qa(),71!=h&&e(),c=f.Mb(),8191==(c&8191))d();else if(c&16384)if(c=(f.qa()&48)>>4,0!=c&&2!=c||e(),3==c&&(c=f.qa(),f.skip(c)),1!=f.K()>>8)d();else {f.skip(3);c=f.qa()>>6;0!=c&&1!=c||e();0==f.qa()&&e();c=f.qa();var k=f.Mb(),l=f.Mb();return (1073741824*((c&14)>>1)+((k&65534)<<14|(l&65534)>>
1))/9E4}else d();}function Kn(a,b){if(1==b.length)return b[0];var c=Jn(a,b);if(null!=c)return c;throw new M(2,4,4025,b);}function Jn(a,b){for(var c=q(mo[a]),d=c.next();!d.done;d=c.next()){d=d.value;for(var e=q(b),f=e.next();!f.done;f=e.next())if(f=f.value,d.test(f.trim()))return f.trim()}return "text"==a?"":null}
function Vn(a,b){var c=String(a).replace(/%7B/g,"{").replace(/%7D/g,"}"),d=c.match(/{\$\w*}/g);if(d){d=q(d);for(var e=d.next();!e.done;e=d.next()){e=e.value;var f=e.slice(2,e.length-1),g=b.get(f);if(g)c=c.replace(e,g);else throw new M(2,4,4039,f);}}return c}
function Zn(a,b,c,d,e){var f,g,h,k,l,m,n,r,u,v;return J(function(A){if(1==A.a){f=Ob;g=Qc;h=Vn(d.segments[0].a,e);k=new qb(h);l=k.ja.split(".").pop();m=no[b];if(n=m[l])return A["return"](n);if(b==f.$)return c&&"vtt"!=c&&"wvtt"!=c?A["return"]("application/mp4"):A["return"]("text/vtt");r=Kc([h],a.i.retryParameters);r.method="HEAD";return t(A,Bn(a,r,g),2)}u=A.b;v=u.headers["content-type"];if(!v)throw new M(2,4,4021,l);return A["return"](v.split(";")[0])})}
function co(a,b){var c=ln(a,b);if(!c)throw new M(2,4,4024,b);return c}p.Kb=function(){var a=this,b,c;return J(function(d){if(1==d.a){if(!a.s)return d["return"]();x(d,2);return t(d,a.update(),4)}if(2!=d.a)return b=a.ca,a.h.R(b),ua(d,0);c=C(d);if(!a.s)return d["return"]();c.severity=1;a.s.onError(c);a.h.R(.1);w(d);})};function Hn(a,b){a.c=b;a.b&&a.b.Pb(a.c==An);a.c!=An||a.h.stop();}function Bn(a,b,c){if(!a.m)throw new M(2,7,7001);b=a.s.networkingEngine.request(c,b);Fc(a.m,b);return b.promise}
K("shaka.hls.HlsParser",zn);
var mo={audio:[/^vorbis$/,/^opus$/,/^flac$/,/^mp4a/,/^[ae]c-3$/],video:[/^avc/,/^hev/,/^hvc/,/^vp0?[89]/,/^av1$/],text:[/^vtt$/,/^wvtt/,/^stpp/]},$n=["audio/aac","audio/ac3","audio/ec3","audio/mpeg"],no={audio:{mp4:"audio/mp4",mp4a:"audio/mp4",m4s:"audio/mp4",m4i:"audio/mp4",m4a:"audio/mp4",cmfa:"audio/mp4",ts:"video/mp2t",aac:"audio/aac",ac3:"audio/ac3",ec3:"audio/ec3",mp3:"audio/mpeg"},video:{mp4:"video/mp4",mp4v:"video/mp4",m4s:"video/mp4",m4i:"video/mp4",m4v:"video/mp4",cmfv:"video/mp4",ts:"video/mp2t"},
text:{mp4:"application/mp4",m4s:"application/mp4",m4i:"application/mp4",cmft:"application/mp4",vtt:"text/vtt",ttml:"application/ttml+xml"}},Xn={"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed":function(a){var b=fn(a,"METHOD");if(!["SAMPLE-AES","SAMPLE-AES-CTR"].includes(b))return null;b=fn(a,"URI");b=yn(b);b=L(b.data);b=Nb("com.widevine.alpha",[{initDataType:"cenc",initData:b}]);if(a=en(a,"KEYID"))b.keyIds=new Set([a.toLowerCase().substr(2)]);return b}},An="VOD",bo="EVENT",ao="LIVE",En={$d:An,sf:bo,
Zd:ao};Tf.m3u8=function(){return new zn};Rf["application/x-mpegurl"]=function(){return new zn};Rf["application/vnd.apple.mpegurl"]=function(){return new zn};function oo(a,b,c,d,e,f){if(200<=c&&299>=c&&202!=c)return {uri:e||d,Nd:d,data:b,headers:a,fromCache:!!a["x-shaka-from-cache"]};e=null;try{e=Wb(b);}catch(g){}throw new M(401==c||403==c?2:1,1,1001,d,c,e,a,f);}function po(){}function qo(a,b,c,d){var e=new ro;ad(b.headers).forEach(function(k,l){e.append(l,k);});var f=new so,g={wd:!1,Wd:!1};a=to(a,c,{body:b.body||void 0,headers:e,method:b.method,signal:f.signal,credentials:b.allowCrossSiteCredentials?"include":void 0},g,d);a=new oc(a,function(){g.wd=!0;f.abort();return Promise.resolve()});if(b=b.retryParameters.timeout){var h=new N(function(){g.Wd=!0;f.abort();});h.R(b/1E3);a["finally"](function(){h.stop();});}return a}
function to(a,b,c,d,e){var f,g,h,k,l,m,n,r,u,v,A,y,z,D;return J(function(B){switch(B.a){case 1:return f=uo,g=vo,m=l=0,n=Date.now(),x(B,2),t(B,f(a,c),4);case 4:return h=B.b,r=h.clone().body.getReader(),v=(u=h.headers.get("Content-Length"))?parseInt(u,10):0,A=function(E){function H(){var G,F;return J(function(I){switch(I.a){case 1:return x(I,2),t(I,r.read(),4);case 4:G=I.b;ua(I,3);break;case 2:return C(I),I["return"]();case 3:G.done||(l+=G.value.byteLength);F=Date.now();if(100<F-n||G.done)e(F-n,l-m,
v-l),m=l,n=F;G.done?E.close():(E.enqueue(G.value),H());w(I);}})}H();},new g({start:A}),t(B,h.arrayBuffer(),5);case 5:k=B.b;ua(B,3);break;case 2:y=C(B);if(d.wd)throw new M(1,1,7001,a,b);if(d.Wd)throw new M(1,1,1003,a,b);throw new M(1,1,1002,a,y,b);case 3:return z={},D=h.headers,D.forEach(function(E,H){z[H.trim()]=E;}),B["return"](oo(z,k,h.status,a,h.url,b))}})}
function wo(){if(window.ReadableStream)try{new ReadableStream({});}catch(a){return !1}else return !1;return !(!window.fetch||!window.AbortController)}K("shaka.net.HttpFetchPlugin",po);po.isSupported=wo;po.parse=qo;var uo=window.fetch,so=window.AbortController,vo=window.ReadableStream,ro=window.Headers;wo()&&(Hc("http",qo,2),Hc("https",qo,2));function xo(){}
function yo(a,b,c,d){var e=new zo,f=Date.now(),g=0,h=new Promise(function(k,l){e.open(b.method,a,!0);e.responseType="arraybuffer";e.timeout=b.retryParameters.timeout;e.withCredentials=b.allowCrossSiteCredentials;e.onabort=function(){l(new M(1,1,7001,a,c));};e.onload=function(n){n=n.target;var r=n.getAllResponseHeaders().trim().split("\r\n"),u={};r=q(r);for(var v=r.next();!v.done;v=r.next())v=v.value.split(": "),u[v[0].toLowerCase()]=v.slice(1).join(": ");try{var A=oo(u,n.response,n.status,a,n.responseURL,
c);k(A);}catch(y){l(y);}};e.onerror=function(n){l(new M(1,1,1002,a,n,c));};e.ontimeout=function(){l(new M(1,1,1003,a,c));};e.onprogress=function(n){var r=Date.now();if(100<r-f||n.lengthComputable&&n.loaded==n.total)d(r-f,n.loaded-g,n.total-n.loaded),g=n.loaded,f=r;};for(var m in b.headers)e.setRequestHeader(m.toLowerCase(),b.headers[m]);e.send(b.body);});return new oc(h,function(){e.abort();return Promise.resolve()})}K("shaka.net.HttpXHRPlugin",xo);xo.parse=yo;var zo=window.XMLHttpRequest;
Hc("http",yo,1);Hc("https",yo,1);function Ao(){this.a=this.f=this.b=0;this.c=new Map;this.g=0;}function Bo(a,b){a.b+=b;var c=a.g;a.g++;a.c.set(c,b);return c}Ao.prototype.close=function(a,b){if(this.c.has(a)){var c=this.c.get(a);this.c["delete"](a);this.f+=c;this.a+=b;}};function Co(a){var b=this;this.N=a;this.a=new Map;this.F=new Rc(function(){var c=Array.from(b.a.values());return Promise.all(c.map(function(d){return d["catch"](function(){})}))});this.b=[];this.Md=function(){};this.Ld=function(){};this.Cb=new Ao;}Co.prototype.destroy=function(){return this.F.destroy()};function Do(a,b,c){a.Md=b;a.Ld=c;}function Eo(a){var b=a.b.map(function(c){return c()});a.b=[];return Promise.all(b)}
function Fo(a,b,c,d,e,f){Sc(a.F);var g=Bo(a.Cb,d);d=(a.a.get(b)||Promise.resolve()).then(function(){var h,k,l,m,n,r,u;return J(function(v){if(1==v.a)return t(v,Go(a,c),2);h=v.b;if(a.F.a)throw new M(2,9,7001);if(e)for(m in k=L(h),l=new Yk(k),l.data)n=Number(m),r=l.data[n],u=l.a[n],a.Ld(r,u);a.Cb.close(g,h.byteLength);var A=a.Cb;a.Md(0==A.b?0:A.f/A.b,a.Cb.a);return v["return"](f(h))})});a.a.set(b,d);return d}
function Ho(a,b,c){Sc(a.F);var d=(a.a.get(b)||Promise.resolve()).then(function(){return J(function(e){return t(e,c(),0)})});a.a.set(b,d);}function Io(a){return J(function(b){return 1==b.a?t(b,Promise.all(a.a.values()),2):b["return"](a.Cb.a)})}function Go(a,b){var c,d,e,f;return J(function(g){if(1==g.a)return c=Qc,d=a.N.request(c,b),e=function(){return d.abort()},a.b.push(e),t(g,d.promise,2);f=g.b;Bc(a.b,e);return g["return"](f.data)})}function Jo(a,b){var c=this;this.c=a;this.b=a.objectStore(b);this.a=new Pb;a.onabort=function(d){d.preventDefault();c.a.reject();};a.onerror=function(d){d.preventDefault();c.a.reject();};a.oncomplete=function(){c.a.resolve();};}Jo.prototype.abort=function(){var a=this;return J(function(b){if(1==b.a){try{a.c.abort();}catch(c){}x(b,2);return t(b,a.a,4)}if(2!=b.a)return ua(b,0);C(b);w(b);})};
function Ko(a,b){return new Promise(function(c,d){var e=a.b.openCursor();e.onerror=d;e.onsuccess=function(){var f;return J(function(g){if(1==g.a){if(null==e.result)return c(),g["return"]();f=e.result;return t(g,b(f.key,f.value,f),2)}f["continue"]();w(g);})};})}Jo.prototype.store=function(){return this.b};Jo.prototype.promise=function(){return this.a};function Lo(a){this.b=a;this.a=[];}Lo.prototype.destroy=function(){return Promise.all(this.a.map(function(a){return a.abort()}))};function Mo(a,b){return No(a,b,"readwrite")}function No(a,b,c){c=a.b.transaction([b],c);var d=new Jo(c,b);a.a.push(d);d.promise().then(function(){Bc(a.a,d);},function(){Bc(a.a,d);});return d}function Oo(a,b,c){this.b=new Lo(a);this.c=b;this.a=c;}p=Oo.prototype;p.destroy=function(){return this.b.destroy()};p.hasFixedKeySpace=function(){return !0};p.addSegments=function(){return Po(this.c)};p.removeSegments=function(a,b){return Qo(this,this.c,a,b)};p.getSegments=function(a){var b=this,c;return J(function(d){if(1==d.a)return t(d,Ro(b,b.c,a),2);c=d.b;return d["return"](c.map(function(e){return b.xd(e)}))})};p.addManifests=function(){return Po(this.a)};
p.updateManifestExpiration=function(a,b){var c=Mo(this.b,this.a),d=c.store();d.get(a).onsuccess=function(e){if(e=e.target.result)e.expiration=b,d.put(e,a);};return c.promise()};p.removeManifests=function(a,b){return Qo(this,this.a,a,b)};p.getManifests=function(a){var b=this,c;return J(function(d){if(1==d.a)return t(d,Ro(b,b.a,a),2);c=d.b;return d["return"](Promise.all(c.map(function(e){return b.Bb(e)})))})};
p.getAllManifests=function(){var a=this,b,c;return J(function(d){return 1==d.a?(b=No(a.b,a.a,"readonly"),c=new Map,t(d,Ko(b,function(e,f){var g;return J(function(h){if(1==h.a)return t(h,a.Bb(f),2);g=h.b;c.set(e,g);w(h);})}),2)):3!=d.a?t(d,b.promise(),3):d["return"](c)})};p.xd=function(a){return a};p.Bb=function(a){return Promise.resolve(a)};function Po(a){return Promise.reject(new M(2,9,9011,"Cannot add new value to "+a))}
p.add=function(a,b){var c=this,d,e,f,g,h,k,l;return J(function(m){if(1==m.a){d=Mo(c.b,a);e=d.store();f=[];g={};h=q(b);for(k=h.next();!k.done;g={Wb:g.Wb},k=h.next())l=k.value,g.Wb=e.add(l),g.Wb.onsuccess=function(n){return function(){f.push(n.Wb.result);}}(g);return t(m,d.promise(),2)}return m["return"](f)})};
function Qo(a,b,c,d){a=Mo(a.b,b);b=a.store();var e={};c=q(c);for(var f=c.next();!f.done;e={Vb:e.Vb},f=c.next())e.Vb=f.value,b["delete"](e.Vb).onsuccess=function(g){return function(){return d(g.Vb)}}(e);return a.promise()}
function Ro(a,b,c){var d,e,f,g,h,k,l;return J(function(m){if(1==m.a){d=No(a.b,b,"readonly");e=d.store();f={};g=[];h={};k=q(c);for(l=k.next();!l.done;h={wb:h.wb,ub:h.ub},l=k.next())h.ub=l.value,h.wb=e.get(h.ub),h.wb.onsuccess=function(n){return function(){void 0==n.wb.result&&g.push(n.ub);f[n.ub]=n.wb.result;}}(h);return t(m,d.promise(),2)}if(g.length)throw new M(2,9,9012,"Could not find values for "+g);return m["return"](c.map(function(n){return f[n]}))})}function So(a){this.a=new Lo(a);}So.prototype.destroy=function(){return this.a.destroy()};So.prototype.getAll=function(){var a=this,b,c;return J(function(d){return 1==d.a?(b=No(a.a,"session-ids","readonly"),c=[],t(d,Ko(b,function(e,f){c.push(f);}),2)):3!=d.a?t(d,b.promise(),3):d["return"](c)})};So.prototype.add=function(a){var b=Mo(this.a,"session-ids"),c=b.store();a=q(a);for(var d=a.next();!d.done;d=a.next())c.add(d.value);return b.promise()};
So.prototype.remove=function(a){var b=this,c;return J(function(d){return 1==d.a?(c=Mo(b.a,"session-ids"),t(d,Ko(c,function(e,f,g){a.includes(f.sessionId)&&g["delete"]();}),2)):t(d,c.promise(),0)})};function To(){this.a=new Map;}To.prototype.destroy=function(){for(var a=[],b=q(this.a.values()),c=b.next();!c.done;c=b.next())a.push(c.value.destroy());this.a.clear();return Promise.all(a)};To.prototype.init=function(){var a=this;Uo.forEach(function(e,f){var g=e();g&&a.a.set(f,g);});for(var b=[],c=q(this.a.values()),d=c.next();!d.done;d=c.next())b.push(d.value.init());return Promise.all(b)};
function Vo(a){var b=null;a.a.forEach(function(c,d){c.getCells().forEach(function(e,f){e.hasFixedKeySpace()||b||(b={path:{ya:d,ba:f},ba:e});});});if(b)return b;throw new M(2,9,9013,"Could not find a cell that supports add-operations");}function Wo(a,b){a.a.forEach(function(c,d){c.getCells().forEach(function(e,f){b({ya:d,ba:f},e);});});}
function Xo(a,b,c){a=a.a.get(b);if(!a)throw new M(2,9,9013,"Could not find mechanism with name "+b);b=a.getCells().get(c);if(!b)throw new M(2,9,9013,"Could not find cell with name "+c);return b}function Yo(a,b){a.a.forEach(function(c){b(c.getEmeSessionCell());});}function Zo(a){var b=Array.from(a.a.keys());if(!b.length)throw new M(2,9,9E3,"No supported storage mechanisms found");return a.a.get(b[0]).getEmeSessionCell()}
function $o(a){var b,c,d;return J(function(e){return 1==e.a?(b=Array.from(a.a.values()),c=0<b.length,c||(d=Uo,d.forEach(function(f){(f=f())&&b.push(f);})),t(e,Promise.all(b.map(function(f){return f.erase()})),2)):c?e.u(0):t(e,Promise.all(b.map(function(f){return f.destroy()})),0)})}function ap(a,b){Uo.set(a,b);}K("shaka.offline.StorageMuxer",To);To.unregister=function(a){Uo["delete"](a);};To.register=ap;To.prototype.destroy=To.prototype.destroy;var Uo=new Map;function bp(){Oo.apply(this,arguments);}pa(bp,Oo);bp.prototype.updateManifestExpiration=function(a,b){var c=this,d,e,f;return J(function(g){d=Mo(c.b,c.a);e=d.store();f=new Pb;e.get(a).onsuccess=function(h){(h=h.target.result)?(h.expiration=b,e.put(h),f.resolve()):f.reject(new M(2,9,9012,"Could not find values for "+a));};return t(g,Promise.all([d.promise(),f]),0)})};
bp.prototype.Bb=function(a){var b,c,d,e,f,g;return J(function(h){if(1==h.a){b=[];for(c=0;c<a.periods.length;++c)d=c==a.periods.length-1?a.duration:a.periods[c+1].startTime,e=d-a.periods[c].startTime,f=cp(a.periods[c],e),b.push(f);return t(h,vm(b),2)}g=h.b;return h["return"]({creationTime:0,originalManifestUri:a.originalManifestUri,duration:a.duration,size:a.size,expiration:null==a.expiration?Infinity:a.expiration,streams:g,sessionIds:a.sessionIds,drmInfo:a.drmInfo,appMetadata:a.appMetadata})})};
function cp(a,b){dp(a);for(var c=q(a.streams),d=c.next();!d.done;d=c.next());return a.streams.map(function(e){return ep(e,a.startTime,b)})}
function ep(a,b,c){var d=a.initSegmentUri?fp(a.initSegmentUri):null,e=b+a.presentationTimeOffset,f=b+c;return {id:a.id,originalId:null,primary:a.primary,type:a.contentType,mimeType:a.mimeType,codecs:a.codecs,frameRate:a.frameRate,pixelAspectRatio:void 0,kind:a.kind,language:a.language,label:a.label,width:a.width,height:a.height,initSegmentKey:d,encrypted:a.encrypted,keyIds:new Set([a.keyId]),segments:a.segments.map(function(g){var h=fp(g.uri);return {startTime:b+g.startTime,endTime:b+g.endTime,dataKey:h,
initSegmentKey:d,appendWindowStart:b,appendWindowEnd:f,timestampOffset:e}}),variantIds:a.variantIds,roles:[],audioSamplingRate:null,channelsCount:null,closedCaptions:null}}bp.prototype.xd=function(a){return {data:a.data}};function fp(a){var b;if((b=/^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(a))||(b=/^offline:segment\/([0-9]+)$/.exec(a)))return Number(b[1]);throw new M(2,9,9004,"Could not parse uri "+a);}
function dp(a){var b=a.streams.filter(function(h){return "audio"==h.contentType});a=a.streams.filter(function(h){return "video"==h.contentType});if(!b.every(function(h){return h.variantIds})||!a.every(function(h){return h.variantIds})){for(var c=q(b),d=c.next();!d.done;d=c.next())d.value.variantIds=[];c=q(a);for(d=c.next();!d.done;d=c.next())d.value.variantIds=[];c=0;if(a.length&&!b.length){var e=c++,f=q(a);for(d=f.next();!d.done;d=f.next())d.value.variantIds.push(e);}if(!a.length&&b.length)for(e=c++,
f=q(b),d=f.next();!d.done;d=f.next())d.value.variantIds.push(e);if(a.length&&b.length)for(b=q(b),d=b.next();!d.done;d=b.next())for(d=d.value,e=q(a),f=e.next();!f.done;f=e.next()){f=f.value;var g=c++;d.variantIds.push(g);f.variantIds.push(g);}}}function gp(){Oo.apply(this,arguments);}pa(gp,Oo);
gp.prototype.Bb=function(a){var b,c,d,e,f,g;return J(function(h){if(1==h.a){b=[];for(c=0;c<a.periods.length;++c){d=c==a.periods.length-1?a.duration:a.periods[c+1].startTime;e=d-a.periods[c].startTime;for(var k=a.periods[c],l=[],m=q(k.streams),n=m.next();!n.done;n=m.next())n=n.value,0!=n.variantIds.length&&l.push(hp(n,k.startTime,k.startTime+e));f=l;b.push(f);}return t(h,vm(b),2)}g=h.b;return h["return"]({appMetadata:a.appMetadata,creationTime:0,drmInfo:a.drmInfo,duration:a.duration,expiration:null==
a.expiration?Infinity:a.expiration,originalManifestUri:a.originalManifestUri,sessionIds:a.sessionIds,size:a.size,streams:g})})};
function hp(a,b,c){return {id:a.id,originalId:a.originalId,primary:a.primary,type:a.contentType,mimeType:a.mimeType,codecs:a.codecs,frameRate:a.frameRate,pixelAspectRatio:a.pixelAspectRatio,kind:a.kind,language:a.language,label:a.label,width:a.width,height:a.height,encrypted:a.encrypted,keyIds:new Set([a.keyId]),segments:a.segments.map(function(d){return {startTime:b+d.startTime,endTime:b+d.endTime,initSegmentKey:a.initSegmentKey,appendWindowStart:b,appendWindowEnd:c,timestampOffset:b-a.presentationTimeOffset,
dataKey:d.dataKey}}),variantIds:a.variantIds,roles:[],audioSamplingRate:null,channelsCount:null,closedCaptions:null}}function ip(){Oo.apply(this,arguments);}pa(ip,Oo);ip.prototype.hasFixedKeySpace=function(){return !1};ip.prototype.addSegments=function(a){return this.add(this.c,a)};ip.prototype.addManifests=function(a){return this.add(this.a,a)};ip.prototype.Bb=function(a){null==a.expiration&&(a.expiration=Infinity);return Promise.resolve(a)};function jp(){this.h=this.f=this.c=this.b=this.a=this.g=null;}p=jp.prototype;
p.init=function(){var a=this,b=new Pb,c=window.indexedDB.open("shaka_offline_db",5);c.onsuccess=function(){var d=c.result;a.g=d;var e=d.objectStoreNames;e=e.contains("manifest")&&e.contains("segment")?new bp(d,"segment","manifest"):null;a.a=e;e=d.objectStoreNames;e=e.contains("manifest-v2")&&e.contains("segment-v2")?new gp(d,"segment-v2","manifest-v2"):null;a.b=e;e=d.objectStoreNames;e=e.contains("manifest-v3")&&e.contains("segment-v3")?new gp(d,"segment-v3","manifest-v3"):null;a.c=e;e=d.objectStoreNames;
e=e.contains("manifest-v5")&&e.contains("segment-v5")?new ip(d,"segment-v5","manifest-v5"):null;a.f=e;d=d.objectStoreNames.contains("session-ids")?new So(d):null;a.h=d;b.resolve();};c.onupgradeneeded=function(){for(var d=c.result,e=q(["segment-v5","manifest-v5","session-ids"]),f=e.next();!f.done;f=e.next())f=f.value,d.objectStoreNames.contains(f)||d.createObjectStore(f,{autoIncrement:!0});};c.onerror=function(d){b.reject(new M(2,9,9001,c.error));d.preventDefault();};return b};
p.destroy=function(){var a=this;return J(function(b){switch(b.a){case 1:if(!a.a){b.u(2);break}return t(b,a.a.destroy(),2);case 2:if(!a.b){b.u(4);break}return t(b,a.b.destroy(),4);case 4:if(!a.c){b.u(6);break}return t(b,a.c.destroy(),6);case 6:if(!a.f){b.u(8);break}return t(b,a.f.destroy(),8);case 8:if(!a.h){b.u(10);break}return t(b,a.h.destroy(),10);case 10:a.g&&a.g.close(),w(b);}})};
p.getCells=function(){var a=new Map;this.a&&a.set("v1",this.a);this.b&&a.set("v2",this.b);this.c&&a.set("v3",this.c);this.f&&a.set("v5",this.f);return a};p.getEmeSessionCell=function(){return this.h};
p.erase=function(){var a=this;return J(function(b){switch(b.a){case 1:if(!a.a){b.u(2);break}return t(b,a.a.destroy(),2);case 2:if(!a.b){b.u(4);break}return t(b,a.b.destroy(),4);case 4:if(!a.c){b.u(6);break}return t(b,a.c.destroy(),6);case 6:if(!a.f){b.u(8);break}return t(b,a.f.destroy(),8);case 8:return a.g&&a.g.close(),t(b,kp(),10);case 10:return a.g=null,a.a=null,a.b=null,a.c=null,a.f=null,t(b,a.init(),0)}})};
function kp(){var a=new Pb,b=window.indexedDB.deleteDatabase("shaka_offline_db");b.onblocked=function(){};b.onsuccess=function(){a.resolve();};b.onerror=function(c){a.reject(new M(2,9,9001,b.error));c.preventDefault();};return a}ap("idb",function(){return md("CrKey")||!window.indexedDB?null:new jp});function lp(a,b,c,d){this.a=a;this.g=b;this.f=c;this.c=d;this.b=["offline:",a,"/",b,"/",c,"/",d].join("");}lp.prototype.ya=function(){return this.g};lp.prototype.ba=function(){return this.f};lp.prototype.key=function(){return this.c};lp.prototype.toString=function(){return this.b};
function mp(a){a=/^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(a);if(null==a)return null;var b=a[1];if("manifest"!=b&&"segment"!=b)return null;var c=a[2];if(!c)return null;var d=a[3];return d&&null!=b?new lp(b,c,d,Number(a[4])):null}function np(a,b){this.b=a;this.a=b;}
function op(a,b){var c=new S(null,0);c.za(b.duration);var d=b.streams.filter(function(k){return "audio"==k.type}),e=b.streams.filter(function(k){return "video"==k.type});d=pp(a,d,e,c);e=b.streams.filter(function(k){return "text"==k.type}).map(function(k){return qp(a,k,c)});var f=b.drmInfo?[b.drmInfo]:[];if(b.drmInfo)for(var g=q(d.values()),h=g.next();!h.done;h=g.next())h=h.value,h.audio&&h.audio.encrypted&&(h.audio.drmInfos=f),h.video&&h.video.encrypted&&(h.video.drmInfos=f);return {presentationTimeline:c,
minBufferTime:2,offlineSessionIds:b.sessionIds,variants:Array.from(d.values()),textStreams:e}}
function pp(a,b,c,d){for(var e=new Set,f=q(b),g=f.next();!g.done;g=f.next()){var h=q(g.value.variantIds);for(g=h.next();!g.done;g=h.next())e.add(g.value);}f=q(c);for(g=f.next();!g.done;g=f.next())for(h=q(g.value.variantIds),g=h.next();!g.done;g=h.next())e.add(g.value);f=new Map;e=q(e);for(g=e.next();!g.done;g=e.next())g=g.value,f.set(g,{id:g,language:"",primary:!1,audio:null,video:null,bandwidth:0,allowedByApplication:!0,allowedByKeySystem:!0});b=q(b);for(e=b.next();!e.done;e=b.next())for(e=e.value,
g=qp(a,e,d),h=q(e.variantIds),e=h.next();!e.done;e=h.next())e=f.get(e.value),e.language=g.language,e.primary=e.primary||g.primary,e.audio=g;c=q(c);for(b=c.next();!b.done;b=c.next())for(e=b.value,b=qp(a,e,d),g=q(e.variantIds),e=g.next();!e.done;e=g.next())e=f.get(e.value),e.primary=e.primary||b.primary,e.video=b;return f}
function qp(a,b,c){var d=b.segments.map(function(e){return rp(a,e)});c.ob(d);return {id:b.id,originalId:b.originalId,createSegmentIndex:function(){return Promise.resolve()},segmentIndex:new T(d),mimeType:b.mimeType,codecs:b.codecs,width:b.width||void 0,height:b.height||void 0,frameRate:b.frameRate,pixelAspectRatio:b.pixelAspectRatio,kind:b.kind,encrypted:b.encrypted,drmInfos:[],keyIds:b.keyIds,language:b.language,label:b.label,type:b.type,primary:b.primary,trickModeVideo:null,emsgSchemeIdUris:null,
roles:b.roles,channelsCount:b.channelsCount,audioSamplingRate:b.audioSamplingRate,closedCaptions:b.closedCaptions}}function rp(a,b){var c=new lp("segment",a.b,a.a,b.dataKey);return new Xf(b.startTime,b.endTime,function(){return [c.toString()]},0,null,null!=b.initSegmentKey?sp(a,b.initSegmentKey):null,b.timestampOffset,b.appendWindowStart,b.appendWindowEnd)}function sp(a,b){var c=new lp("segment",a.b,a.a,b);return new Vf(function(){return [c.toString()]},0,null)}function tp(){this.a=null;}p=tp.prototype;p.configure=function(){};
p.start=function(a,b){var c=this,d,e,f,g,h,k,l;return J(function(m){switch(m.a){case 1:d=mp(a);c.a=d;if(null==d||"manifest"!=d.a)throw new M(2,1,9004,a);e=new To;ta(m);return t(m,e.init(),4);case 4:return t(m,Xo(e,d.ya(),d.ba()),5);case 5:return f=m.b,t(m,f.getManifests([d.key()]),6);case 6:return g=m.b,h=g[0],k=new np(d.ya(),d.ba()),l=op(k,h),b.makeTextStreamsForClosedCaptions(l),m["return"](l);case 2:return va(m),t(m,e.destroy(),7);case 7:wa(m,0);}})};p.stop=function(){return Promise.resolve()};
p.update=function(){};p.onExpirationUpdated=function(a,b){var c=this,d,e,f,g,h,k,l;return J(function(m){switch(m.a){case 1:return d=c.a,e=new To,x(m,2,3),t(m,e.init(),5);case 5:return t(m,Xo(e,d.ya(),d.ba()),6);case 6:return f=m.b,t(m,f.getManifests([d.key()]),7);case 7:g=m.b;h=g[0];k=h.sessionIds.includes(a);l=void 0==h.expiration||h.expiration>b;if(!k||!l){m.u(3);break}return t(m,f.updateManifestExpiration(d.key(),b),3);case 3:return va(m),t(m,e.destroy(),10);case 10:wa(m,0);break;case 2:C(m),m.u(3);}})};
Rf["application/x-offline-manifest"]=function(){return new tp};function up(){}function vp(a){var b=mp(a);b&&"manifest"==b.a?(a={uri:a,Nd:a,data:new ArrayBuffer(0),headers:{"content-type":"application/x-offline-manifest"}},a=rc(a)):a=b&&"segment"==b.a?wp(b.key(),b):pc(new M(2,1,9004,a));return a}
function wp(a,b){var c=new To;return rc(void 0).U(function(){return c.init()}).U(function(){return Xo(c,b.ya(),b.ba())}).U(function(d){return d.getSegments([b.key()])}).U(function(d){return {uri:b,data:d[0].data,headers:{}}})["finally"](function(){return c.destroy()})}K("shaka.offline.OfflineScheme",up);up.plugin=vp;Hc("offline",vp);function xp(a,b,c){var d,e,f,g,h,k;return J(function(l){switch(l.a){case 1:d=[];for(var m=[],n=q(c),r=n.next();!r.done;r=n.next()){r=r.value;for(var u=!1,v=q(m),A=v.next();!A.done;A=v.next())if(A=A.value,yp(A.info,r)){A.sessionIds.push(r.sessionId);u=!0;break}u||m.push({info:r,sessionIds:[r.sessionId]});}e=q(m);f=e.next();case 2:if(f.done){l.u(4);break}g=f.value;h=zp(a,b,g);return t(l,h,5);case 5:k=l.b;d=d.concat(k);f=e.next();l.u(2);break;case 4:return l["return"](d)}})}
function zp(a,b,c){var d,e;return J(function(f){switch(f.a){case 1:return d=new rd({nb:b,onError:function(){},oc:function(){},onExpirationUpdated:function(){},onEvent:function(){}}),x(f,2),d.configure(a),t(f,zd(d,c.info.keySystem,c.info.licenseUri,c.info.serverCertificate,c.info.audioCapabilities,c.info.videoCapabilities),4);case 4:ua(f,3);break;case 2:return C(f),t(f,d.destroy(),5);case 5:return f["return"]([]);case 3:return x(f,6),t(f,Id(d),8);case 8:ua(f,7);break;case 6:return C(f),t(f,d.destroy(),
9);case 9:return f["return"]([]);case 7:return e=[],t(f,Promise.all(c.sessionIds.map(function(g){return J(function(h){if(1==h.a)return x(h,2),t(h,Jd(d,g),4);if(2!=h.a)return e.push(g),ua(h,0);C(h);w(h);})})),10);case 10:return t(f,d.destroy(),11);case 11:return f["return"](e)}})}
function yp(a,b){function c(d,e){return d.robustness==e.robustness&&d.contentType==e.contentType}return a.keySystem==b.keySystem&&a.licenseUri==b.licenseUri&&Cc(a.audioCapabilities,b.audioCapabilities,c)&&Cc(a.videoCapabilities,b.videoCapabilities,c)}function Ap(a,b,c){var d=b.presentationTimeline.getDuration();b=Bp(b);return {offlineUri:null,originalManifestUri:a,duration:d,size:0,expiration:Infinity,tracks:b,appMetadata:c}}function Cp(a,b){var c=op(new np(a.ya(),a.ba()),b),d=b.appMetadata||{};c=Bp(c);return {offlineUri:a.toString(),originalManifestUri:b.originalManifestUri,duration:b.duration,size:b.size,expiration:b.expiration,tracks:c,appMetadata:d}}
function Bp(a){var b=[],c=xf(a.variants);c=q(c);for(var d=c.next();!d.done;d=c.next())b.push(qf(d.value));a=q(a.textStreams);for(c=a.next();!c.done;c=a.next())b.push(rf(c.value));return b}function Dp(){this.a={};}function Ep(a,b,c){c=c.endTime-c.startTime;return Fp(a,b)*c}function Fp(a,b){var c=a.a[b];null==c&&(c=0);return c}function Gp(a,b,c){a.variants=a.variants.filter(function(d){return nf(d,b,c)});}function Hp(a){a.variants=a.variants.filter(function(b){var c=!0;b.audio&&(c=c&&Oe(b.audio));b.video&&(c=c&&Oe(b.video));return c});}function Ip(a,b){a.variants=a.variants.filter(function(c){return $d(b,c)});}function Jp(a){var b=this;if(a&&a.constructor!=W)throw new M(2,9,9008);this.N=this.i=null;a?(this.i=a.i,this.N=a.Fb()):(this.i=Sh(),this.N=new Gc);this.sc=[];this.Lb=[];this.dd=[];this.a=new Map;this.a.set(null,Promise.resolve(null));this.b=new Map;var c=!a;this.F=new Rc(function(){var d,e,f,g,h;return J(function(k){switch(k.a){case 1:return t(k,Promise.all(b.dd.map(function(l){return Eo(l)})),2);case 2:d=function(){};e=[];f=q(b.Lb);for(g=f.next();!g.done;g=f.next())h=g.value,e.push(h.then(d,d));
return t(k,Promise.all(e),3);case 3:if(!c){k.u(4);break}return t(k,b.N.destroy(),4);case 4:b.i=null,b.N=null,w(k);}})});}function Kp(){if(id())a:{var a=q(Uo.values());for(var b=a.next();!b.done;b=a.next())if(b=b.value,b=b()){b.destroy();a=!0;break a}a=!1;}else a=!1;return a}p=Jp.prototype;p.destroy=function(){return this.F.destroy()};
p.configure=function(a,b){2==arguments.length&&"string"==typeof a&&(a=Qh(a,b));a.manifest&&a.manifest.dash&&"defaultPresentationDelay"in a.manifest.dash&&(Eb("manifest.dash.defaultPresentationDelay configuration","Please Use manifest.defaultPresentationDelay instead."),a.manifest.defaultPresentationDelay=a.manifest.dash.defaultPresentationDelay,delete a.manifest.dash.defaultPresentationDelay);return Uh(this.i,a)};p.getConfiguration=function(){var a=Sh();Uh(a,this.i,Sh());return a};p.Fb=function(){return this.N};
p.store=function(a,b,c){var d=this,e=this.getConfiguration(),f=new Co(this.N);this.dd.push(f);b=Lp(this,a,b||{},function(){var h;return J(function(k){if(1==k.a)return t(k,Qf(a,d.N,e.manifest.retryParameters,c||null),2);h=k.b;return k["return"](Lb(h))})},e,f);var g=new oc(b,function(){return Eo(f)});g["finally"](function(){Bc(d.dd,f);});g.then=function(h){Eb("shaka.offline.Storage.store.then","Storage operations now return a shaka.util.AbortableOperation, rather than a promise.  Please update to conform to this new API; you can use the |chain| method instead.");
return g.promise.then(h)};return Mp(this,g)};p.Be=function(){Eb("shaka.offline.Storage.getStoreInProgress","Multiple concurrent downloads are now supported.");return !1};
function Lp(a,b,c,d,e,f){var g,h,k,l,m,n,r,u,v,A,y;return J(function(z){switch(z.a){case 1:return Np(),h=g=null,k=new To,m=l=null,x(z,2,3),t(z,d(),5);case 5:return g=z.b,t(z,Op(a,b,g,e),6);case 6:n=z.b;Pp(a);r=!n.presentationTimeline.S()&&!n.presentationTimeline.Ua();if(!r)throw new M(2,9,9005,b);return t(z,Qp(a,n,function(D){m=m||D;},e),7);case 7:h=z.b;Pp(a);if(m)throw m;return t(z,a.gb(n,h,e),8);case 8:return t(z,k.init(),9);case 9:return Pp(a),t(z,Vo(k),10);case 10:return l=z.b,Pp(a),t(z,Rp(a,l.ba,
h,n,b,c,e,f),11);case 11:u=z.b;Pp(a);if(m)throw m;return t(z,l.ba.addManifests([u]),12);case 12:return v=z.b,Pp(a),A=new lp("manifest",l.path.ya,l.path.ba,v[0]),z["return"](Cp(A,u));case 3:return va(z),a.sc=[],t(z,k.destroy(),13);case 13:if(!g){z.u(14);break}return t(z,g.stop(),14);case 14:if(!h){z.u(16);break}return t(z,h.destroy(),16);case 16:wa(z,0);break;case 2:y=C(z);if(!l){z.u(18);break}return t(z,l.ba.removeSegments(a.sc,function(){}),18);case 18:throw m||y;}})}
p.gb=function(a,b,c){var d,e,f,g,h,k,l,m,n,r,u,v,A,y,z;return J(function(D){if(1==D.a){d={width:Infinity,height:Infinity};Gp(a,c.restrictions,d);Hp(a);Ip(a,b);e=[];f=c.preferredAudioChannelCount;lf(a,f);g=q(a.variants);for(h=g.next();!h.done;h=g.next())k=h.value,e.push(qf(k));l=q(a.textStreams);for(m=l.next();!m.done;m=l.next())n=m.value,e.push(rf(n));return t(D,c.offline.trackSelectionCallback(e),2)}r=D.b;u=new Set;v=new Set;A=q(r);for(y=A.next();!y.done;y=A.next())z=y.value,"variant"==z.type&&u.add(z.id),
"text"==z.type&&v.add(z.id);a.variants=a.variants.filter(function(B){return u.has(B.id)});a.textStreams=a.textStreams.filter(function(B){return v.has(B.id)});Sp(a);w(D);})};
function Rp(a,b,c,d,e,f,g,h){var k,l,m,n,r,u,v,A,y,z,D,B;return J(function(E){switch(E.a){case 1:return k=Ap(e,d,f),l=g.offline.progressCallback,m=function(H,G){k.size=G;l(k,H);},n=function(H,G){v&&g.offline.usePersistentLicense&&A==G&&Hd(c,"cenc",H);},Do(h,m,n),r=d.variants.some(function(H){var G=H.audio&&H.audio.encrypted;return H.video&&H.video.encrypted||G}),u=d.variants.some(function(H){return (H.video?H.video.drmInfos:[]).concat(H.audio?H.audio.drmInfos:[]).some(function(G){return G.initData&&
G.initData.length})}),v=r&&!u,A=null,v&&(y=c.c,A=Tp.get(y.keySystem)),ta(E),D=z=Up(a,h,b,c,d,e,f,g),t(E,Io(h),4);case 4:D.size=E.b;z.expiration=c.Eb();B=Od(c);z.sessionIds=g.offline.usePersistentLicense?B:[];if(r&&g.offline.usePersistentLicense&&!B.length)throw new M(2,9,9007);return E["return"](z);case 2:return va(E),t(E,h.destroy(),5);case 5:wa(E,0);}})}p.remove=function(a){return Vp(this,Wp(this,a))};
function Wp(a,b){var c,d,e,f,g,h;return J(function(k){switch(k.a){case 1:Np();c=mp(b);if(null==c||"manifest"!=c.a)throw new M(2,9,9004,b);d=c;e=new To;ta(k);return t(k,e.init(),4);case 4:return t(k,Xo(e,d.ya(),d.ba()),5);case 5:return f=k.b,t(k,f.getManifests([d.key()]),6);case 6:return g=k.b,h=g[0],t(k,Promise.all([Xp(a,h,e),Yp(f,d,h)]),2);case 2:return va(k),t(k,e.destroy(),8);case 8:wa(k,0);}})}
function Zp(a,b){for(var c=[],d=q(a.streams),e=d.next();!e.done;e=d.next())e=e.value,b&&"video"==e.type?c.push({contentType:ed(e.mimeType,e.codecs),robustness:a.drmInfo.videoRobustness}):b||"audio"!=e.type||c.push({contentType:ed(e.mimeType,e.codecs),robustness:a.drmInfo.audioRobustness});return c}function Xp(a,b,c){return J(function(d){return t(d,$p(a.N,a.i.drm,c,b),0)})}
function Yp(a,b,c){function d(){}var e=aq(c);Cp(b,c);return Promise.all([a.removeSegments(e,d),a.removeManifests([b.key()],d)])}p.Te=function(){return Vp(this,bq(this))};
function bq(a){var b,c,d,e,f,g,h,k,l,m;return J(function(n){switch(n.a){case 1:return Np(),b=a.N,c=a.i.drm,d=new To,e=!1,ta(n),t(n,d.init(),4);case 4:f=[],Yo(d,function(r){return f.push(r)}),g=q(f),h=g.next();case 5:if(h.done){n.u(2);break}k=h.value;return t(n,k.getAll(),8);case 8:return l=n.b,t(n,xp(c,b,l),9);case 9:return m=n.b,t(n,k.remove(m),10);case 10:m.length!=l.length&&(e=!0);h=g.next();n.u(5);break;case 2:return va(n),t(n,d.destroy(),11);case 11:wa(n,3);break;case 3:return n["return"](!e)}})}
p.list=function(){return Vp(this,cq())};function cq(){var a,b,c;return J(function(d){switch(d.a){case 1:return Np(),a=[],b=new To,ta(d),t(d,b.init(),4);case 4:return c=Promise.resolve(),Wo(b,function(e,f){c=c.then(function(){var g;return J(function(h){if(1==h.a)return t(h,f.getAllManifests(),2);g=h.b;g.forEach(function(k,l){var m=Cp(new lp("manifest",e.ya,e.ba,l),k);a.push(m);});w(h);})});}),t(d,c,2);case 2:return va(d),t(d,b.destroy(),6);case 6:wa(d,3);break;case 3:return d["return"](a)}})}
function Op(a,b,c,d){var e,f,g,h,k;return J(function(l){if(1==l.a)return e=null,f=a.N,g={networkingEngine:f,filter:function(){return Promise.resolve()},makeTextStreamsForClosedCaptions:function(){},onTimelineRegionAdded:function(){},onEvent:function(){},onError:function(m){e=m;}},c.configure(d.manifest),Pp(a),t(l,c.start(b,g),2);if(3!=l.a)return h=l.b,Pp(a),k=dq(h),t(l,Promise.all(db(k,function(m){return m.createSegmentIndex()})),3);Pp(a);if(e)throw e;return l["return"](h)})}
function Qp(a,b,c,d){var e;return J(function(f){switch(f.a){case 1:return e=new rd({nb:a.N,onError:c,oc:function(){},onExpirationUpdated:function(){},onEvent:function(){}}),e.configure(d.drm),t(f,wd(e,b.variants,d.offline.usePersistentLicense),2);case 2:return t(f,Id(e),3);case 3:return t(f,Gd(e),4);case 4:return f["return"](e)}})}
function Up(a,b,c,d,e,f,g,h){for(var k=new Dp,l=q(e.variants),m=l.next();!m.done;m=l.next()){var n=k;m=m.value;var r=m.audio,u=m.video;r&&!u&&(n.a[r.id]=r.bandwidth||m.bandwidth);!r&&u&&(n.a[u.id]=u.bandwidth||m.bandwidth);if(r&&u){var v=r.bandwidth||393216,A=u.bandwidth||m.bandwidth-v;0>=A&&(A=m.bandwidth);n.a[r.id]=v;n.a[u.id]=A;}}l=q(e.textStreams);for(n=l.next();!n.done;n=l.next())k.a[n.value.id]=52;n=dq(e);l=new Map;n=q(n);for(m=n.next();!m.done;m=n.next())m=m.value,r=eq(a,b,c,k,e,m,h),l.set(m.id,
r);a=q(e.variants);for(m=a.next();!m.done;m=a.next())b=m.value,b.audio&&l.get(b.audio.id).variantIds.push(b.id),b.video&&l.get(b.video.id).variantIds.push(b.id);a=Array.from(l.values());h=h.offline.usePersistentLicense;(b=d.c)&&h&&(b.initData=[]);return {creationTime:Date.now(),originalManifestUri:f,duration:e.presentationTimeline.getDuration(),size:0,expiration:d.Eb(),streams:a,sessionIds:h?Od(d):[],drmInfo:b,appMetadata:g}}
function eq(a,b,c,d,e,f,g){var h={id:f.id,originalId:f.originalId,primary:f.primary,type:f.type,mimeType:f.mimeType,codecs:f.codecs,frameRate:f.frameRate,pixelAspectRatio:f.pixelAspectRatio,kind:f.kind,language:f.language,label:f.label,width:f.width||null,height:f.height||null,encrypted:f.encrypted,keyIds:f.keyIds,segments:[],variantIds:[],roles:f.roles,channelsCount:f.channelsCount,audioSamplingRate:f.audioSamplingRate,closedCaptions:f.closedCaptions},k=f.id;fq(f,e.presentationTimeline.Ra(),function(l){var m=
gq(a,b,k,f.id,c,d,l.f,g),n=hq(a,b,k,f.id,c,d,l,g);Ho(b,k,function(){var r,u;return J(function(v){if(1==v.a)return t(v,m,2);if(3!=v.a)return r=v.b,t(v,n,3);u=v.b;h.segments.push({initSegmentKey:r,startTime:l.startTime,endTime:l.endTime,appendWindowStart:l.appendWindowStart,appendWindowEnd:l.appendWindowEnd,timestampOffset:l.timestampOffset,dataKey:u});w(v);})});});return h}
function gq(a,b,c,d,e,f,g,h){if(a.a.has(g))return a.a.get(g);h=Ug(g.c(),g.b,g.a,h.streaming.retryParameters);b=Fo(b,c,h,.5*Fp(f,d),!0,function(k){var l;return J(function(m){if(1==m.a)return t(m,e.addSegments([{data:k}]),2);l=m.b;a.sc.push(l[0]);return m["return"](l[0])})});a.a.set(g,b);return b}
function hq(a,b,c,d,e,f,g,h){var k=[g.c()[0],g.b,g.a].join("-");if(a.b.has(k))return a.b.get(k);h=Ug(g.c(),g.b,g.a,h.streaming.retryParameters);b=Fo(b,c,h,Ep(f,d,g),!1,function(l){var m;return J(function(n){if(1==n.a)return t(n,e.addSegments([{data:l}]),2);m=n.b;a.sc.push(m[0]);return n["return"](m[0])})});a.b.set(k,b);return b}function fq(a,b,c){b=a.segmentIndex.find(b);if(null!=b)for(var d=a.segmentIndex.get(b);d;)c(d),d=a.segmentIndex.get(++b);}function Pp(a){if(a.F.a)throw new M(2,9,7001);}
function Np(){if(!Kp())throw new M(2,9,9E3);}function Vp(a,b){return J(function(c){if(1==c.a)return a.Lb.push(b),ta(c),t(c,b,4);if(2!=c.a)return c["return"](c.b);va(c);Bc(a.Lb,b);return wa(c,0)})}function Mp(a,b){var c=b.promise;a.Lb.push(c);return b["finally"](function(){Bc(a.Lb,c);})}
function aq(a){var b=[];a=q(a.streams);for(var c=a.next();!c.done;c=a.next()){c=q(c.value.segments);for(var d=c.next();!d.done;d=c.next())d=d.value,null!=d.initSegmentKey&&b.push(d.initSegmentKey),b.push(d.dataKey);}return b}
function $p(a,b,c,d){var e,f,g;return J(function(h){if(1==h.a){if(!d.drmInfo)return h["return"]();e=Zo(c);f=d.sessionIds.map(function(k){return {sessionId:k,keySystem:d.drmInfo.keySystem,licenseUri:d.drmInfo.licenseServerUri,serverCertificate:d.drmInfo.serverCertificate,audioCapabilities:Zp(d,!1),videoCapabilities:Zp(d,!0)}});return t(h,xp(b,a,f),2)}return 3!=h.a?(g=h.b,t(h,e.remove(g),3)):t(h,e.add(f.filter(function(k){return !g.includes(k.sessionId)})),0)})}
function dq(a){for(var b=new Set,c=q(a.textStreams),d=c.next();!d.done;d=c.next())b.add(d.value);a=q(a.variants);for(c=a.next();!c.done;c=a.next())c=c.value,c.audio&&b.add(c.audio),c.video&&b.add(c.video);return b}
function Sp(a){a.variants.map(function(f){return f.video});var b=new Set(a.variants.map(function(f){return f.audio}));a=a.textStreams;for(var c=q(b),d=c.next();!d.done;d=c.next()){d=q(b);for(var e=d.next();!e.done;e=d.next());}b=q(a);for(c=b.next();!c.done;c=b.next())for(c=q(a),d=c.next();!d.done;d=c.next());}K("shaka.offline.Storage",Jp);Jp.deleteAll=function(){var a;return J(function(b){return 1==b.a?(a=new To,ta(b),t(b,$o(a),2)):5!=b.a?(va(b),t(b,a.destroy(),5)):wa(b,0)})};Jp.prototype.list=Jp.prototype.list;
Jp.prototype.removeEmeSessions=Jp.prototype.Te;Jp.prototype.remove=Jp.prototype.remove;Jp.prototype.getStoreInProgress=Jp.prototype.Be;Jp.prototype.store=Jp.prototype.store;Jp.prototype.getNetworkingEngine=Jp.prototype.Fb;Jp.prototype.getConfiguration=Jp.prototype.getConfiguration;Jp.prototype.configure=Jp.prototype.configure;Jp.prototype.destroy=Jp.prototype.destroy;Jp.support=Kp;
var Tp=(new Map).set("org.w3.clearkey","1077efecc0b24d02ace33c1e52e2fb4b").set("com.widevine.alpha","edef8ba979d64acea3c827dcd51d21ed").set("com.microsoft.playready","9a04f07998404286ab92e65be0885f95").set("com.adobe.primetime","f239e769efa348509c16a903c6932efb");Gj.offline=Kp;function iq(){}function jq(a,b){for(var c={priority:b||0,ce:a},d=q(ib(kq)),e=d.next();!e.done;e=d.next()){e=e.value;var f=e.Y;if(e.item.priority<c.priority){kq.splice(f,0,c);return}}kq.push(c);}K("shaka.polyfill",iq);iq.register=jq;iq.installAll=function(){for(var a=q(kq),b=a.next();!b.done;b=a.next()){b=b.value;try{b.ce();}catch(c){Xa("Error installing polyfill!",c);}}};var kq=[];jq(function(){lq();},-1);function mq(a){var b=a.type.replace(/^(webkit|moz|MS)/,"").toLowerCase();if("function"===typeof Event)var c=new Event(b,a);else c=document.createEvent("Event"),c.initEvent(b,a.bubbles,a.cancelable);a.target.dispatchEvent(c);}
jq(function(){if(window.Document){var a=Element.prototype;a.requestFullscreen=a.requestFullscreen||a.mozRequestFullScreen||a.msRequestFullscreen||a.webkitRequestFullscreen;a=Document.prototype;a.exitFullscreen=a.exitFullscreen||a.mozCancelFullScreen||a.msExitFullscreen||a.webkitCancelFullScreen;"fullscreenElement"in document||(Object.defineProperty(document,"fullscreenElement",{get:function(){return document.mozFullScreenElement||document.msFullscreenElement||document.webkitCurrentFullScreenElement||
document.webkitFullscreenElement}}),Object.defineProperty(document,"fullscreenEnabled",{get:function(){return document.mozFullScreenEnabled||document.msFullscreenEnabled||document.webkitFullscreenEnabled}}));document.addEventListener("webkitfullscreenchange",mq);document.addEventListener("webkitfullscreenerror",mq);document.addEventListener("mozfullscreenchange",mq);document.addEventListener("mozfullscreenerror",mq);document.addEventListener("MSFullscreenChange",mq);document.addEventListener("MSFullscreenError",
mq);}});function nq(a,b,c){if("input"==a)switch(this.type){case "range":a="change";}HTMLInputElement.prototype.originalAddEventListener.call(this,a,b,c);}jq(function(){md("Trident/")&&!HTMLInputElement.prototype.originalAddEventListener&&(HTMLInputElement.prototype.originalAddEventListener=HTMLInputElement.prototype.addEventListener,HTMLInputElement.prototype.addEventListener=nq);});jq(function(){navigator.languages||Object.defineProperty(navigator,"languages",{get:function(){return navigator.language?[navigator.language]:["en"]}});});jq(function(){});function oq(){var a=MediaSource.prototype.addSourceBuffer;MediaSource.prototype.addSourceBuffer=function(b){for(var c=[],d=0;d<arguments.length;++d)c[d]=arguments[d];c=a.apply(this,c);c.abort=function(){};return c};}function pq(){var a=SourceBuffer.prototype.remove;SourceBuffer.prototype.remove=function(b,c){return a.call(this,b,c-.001)};}function qq(){var a=MediaSource.isTypeSupported;MediaSource.isTypeSupported=function(b){return "mp2t"==b.split(/ *; */)[0].split("/")[1].toLowerCase()?!1:a(b)};}
function rq(){var a=MediaSource.isTypeSupported;MediaSource.isTypeSupported=function(b){return "opus"!=hd(b)[0]&&a(b)};}function sq(){var a=MediaSource.isTypeSupported;MediaSource.isTypeSupported=function(b){var c=b.split(/ *; */);c.shift();return c.some(function(d){return d.startsWith("codecs=")})?cast.__platform__.canDisplayType(b):a(b)};}
jq(function(){var a=od();window.MediaSource&&(window.cast&&cast.__platform__&&cast.__platform__.canDisplayType?sq():a?(qq(),12>=a?(oq(),pq()):oq()):(md("Tizen 2")||md("Tizen 3")||md("Tizen 4"))&&rq());});function tq(a,b){try{var c=new uq(a,b);return Promise.resolve(c)}catch(d){return Promise.reject(d)}}function vq(a){var b=this.mediaKeys;b&&b!=a&&wq(b,null);delete this.mediaKeys;return (this.mediaKeys=a)?wq(a,this):Promise.resolve()}function xq(a){a=L(a.initData);if(ob(a).getUint32(0,!0)+4!=a.byteLength)throw new RangeError("Malformed FairPlay init data");a=Vb(a.subarray(4),!0);a=Xb(a);var b=new Event("encrypted");b.initDataType="skd";b.initData=mb(a);this.dispatchEvent(b);}
function uq(a,b){this.keySystem=a;if(a.startsWith("com.apple.fps"))for(var c=q(b),d=c.next();!d.done;d=c.next()){var e=d.value;if("required"==e.persistentState)d=null;else {d={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:e.initDataTypes,sessionTypes:["temporary"],label:e.label};var f=!1,g=!1;if(e.audioCapabilities)for(var h=q(e.audioCapabilities),k=h.next();!k.done;k=h.next())k=k.value,k.contentType&&(f=!0,WebKitMediaKeys.isTypeSupported(this.keySystem,
k.contentType.split(";")[0])&&(d.audioCapabilities.push(k),g=!0));if(e.videoCapabilities)for(e=q(e.videoCapabilities),k=e.next();!k.done;k=e.next())h=k.value,h.contentType&&(f=!0,WebKitMediaKeys.isTypeSupported(this.keySystem,h.contentType.split(";")[0])&&(d.videoCapabilities.push(h),g=!0));f||(g=WebKitMediaKeys.isTypeSupported(this.keySystem,"video/mp4"));d=g?d:null;}if(d){this.a=d;return}}c=Error("Unsupported keySystem");c.name="NotSupportedError";c.code=DOMException.NOT_SUPPORTED_ERR;throw c;}
uq.prototype.createMediaKeys=function(){var a=new yq(this.keySystem);return Promise.resolve(a)};uq.prototype.getConfiguration=function(){return this.a};function yq(a){this.a=new WebKitMediaKeys(a);this.b=new Tc;}yq.prototype.createSession=function(a){a=a||"temporary";if("temporary"!=a)throw new TypeError("Session type "+a+" is unsupported on this platform.");return new zq(this.a,a)};yq.prototype.setServerCertificate=function(){return Promise.resolve(!1)};
function wq(a,b){a.b.Xa();if(!b)return Promise.resolve();a.b.l(b,"webkitneedkey",xq);try{return dg(b,HTMLMediaElement.HAVE_METADATA,a.b,function(){b.webkitSetMediaKeys(a.a);}),Promise.resolve()}catch(c){return Promise.reject(c)}}function zq(a){xc.call(this);this.f=null;this.g=a;this.c=this.a=null;this.b=new Tc;this.sessionId="";this.expiration=NaN;this.closed=new Pb;this.keyStatuses=new Aq;}pa(zq,xc);p=zq.prototype;
p.generateRequest=function(a,b){var c=this;this.a=new Pb;try{var d=this.g.createSession("video/mp4",L(b));this.f=d;this.sessionId=d.sessionId||"";this.b.l(this.f,"webkitkeymessage",function(e){c.a&&(c.a.resolve(),c.a=null);e=new Q("message",{messageType:void 0==c.keyStatuses.a?"license-request":"license-renewal",message:mb(e.message)});c.dispatchEvent(e);});this.b.l(d,"webkitkeyadded",function(){c.c&&(Bq(c,"usable"),c.c.resolve(),c.c=null);});this.b.l(d,"webkitkeyerror",function(){var e=Error("EME PatchedMediaKeysApple key error");
e.errorCode=c.f.error;if(null!=c.a)c.a.reject(e),c.a=null;else if(null!=c.c)c.c.reject(e),c.c=null;else switch(c.f.error.code){case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:Bq(c,"output-not-allowed");break;default:Bq(c,"internal-error");}});Bq(this,"status-pending");}catch(e){this.a.reject(e);}return this.a};p.load=function(){return Promise.reject(Error("MediaKeySession.load not yet supported"))};p.update=function(a){this.c=new Pb;try{this.f.update(L(a));}catch(b){this.c.reject(b);}return this.c};
p.close=function(){try{this.f.close(),this.closed.resolve(),this.b.Xa();}catch(a){this.closed.reject(a);}return this.closed};p.remove=function(){return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"))};function Bq(a,b){var c=a.keyStatuses;c.size=void 0==b?0:1;c.a=b;c=new Q("keystatuseschange");a.dispatchEvent(c);}function Aq(){this.size=0;this.a=void 0;}p=Aq.prototype;p.forEach=function(a){this.a&&a(this.a,ce.value());};
p.get=function(a){if(this.has(a))return this.a};p.has=function(a){var b=ce.value();return this.a&&kb(a,b)?!0:!1};p.entries=function(){};p.keys=function(){};p.values=function(){};jq(function(){window.HTMLVideoElement&&window.WebKitMediaKeys&&(delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,HTMLMediaElement.prototype.setMediaKeys=vq,window.MediaKeys=yq,window.MediaKeySystemAccess=uq,navigator.requestMediaKeySystemAccess=tq);});function Cq(a,b){try{var c=new Dq(a,b);return Promise.resolve(c)}catch(d){return Promise.reject(d)}}function Eq(a){if(a.initData){var b=document.createEvent("CustomEvent");b.initCustomEvent("encrypted",!1,!1,null);b.initDataType="cenc";b.initData=mb(Zk(a.initData));this.dispatchEvent(b);}}
function Dq(a,b){this.keySystem=a;for(var c=!1,d=q(b),e=d.next();!e.done;e=d.next()){e=e.value;var f={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:e.initDataTypes,sessionTypes:["temporary"],label:e.label},g=!1;if(e.audioCapabilities)for(var h=q(e.audioCapabilities),k=h.next();!k.done;k=h.next())k=k.value,k.contentType&&(g=!0,MSMediaKeys.isTypeSupported(this.keySystem,k.contentType.split(";")[0])&&(f.audioCapabilities.push(k),c=
!0));if(e.videoCapabilities)for(h=q(e.videoCapabilities),k=h.next();!k.done;k=h.next())k=k.value,k.contentType&&(g=!0,MSMediaKeys.isTypeSupported(this.keySystem,k.contentType.split(";")[0])&&(f.videoCapabilities.push(k),c=!0));g||(c=MSMediaKeys.isTypeSupported(this.keySystem,"video/mp4"));"required"==e.persistentState&&(c=!1);if(c){this.a=f;return}}c=Error("Unsupported keySystem");c.name="NotSupportedError";c.code=DOMException.NOT_SUPPORTED_ERR;throw c;}
Dq.prototype.createMediaKeys=function(){var a=new Fq(this.keySystem);return Promise.resolve(a)};Dq.prototype.getConfiguration=function(){return this.a};function Gq(a){var b=this.mediaKeys;b&&b!=a&&Hq(b,null);delete this.mediaKeys;return (this.mediaKeys=a)?Hq(a,this):Promise.resolve()}function Fq(a){this.a=new MSMediaKeys(a);this.b=new Tc;}
Fq.prototype.createSession=function(a){a=a||"temporary";if("temporary"!=a)throw new TypeError("Session type "+a+" is unsupported on this platform.");return new Iq(this.a,a)};Fq.prototype.setServerCertificate=function(){return Promise.resolve(!1)};function Hq(a,b){a.b.Xa();if(!b)return Promise.resolve();a.b.l(b,"msneedkey",Eq);try{return dg(b,HTMLMediaElement.HAVE_METADATA,a.b,function(){b.msSetMediaKeys(a.a);}),Promise.resolve()}catch(c){return Promise.reject(c)}}
function Iq(a){xc.call(this);this.f=null;this.g=a;this.c=this.a=null;this.b=new Tc;this.sessionId="";this.expiration=NaN;this.closed=new Pb;this.keyStatuses=new Jq;}pa(Iq,xc);p=Iq.prototype;
p.generateRequest=function(a,b){var c=this;this.a=new Pb;try{this.f=this.g.createSession("video/mp4",L(b),null),this.b.l(this.f,"mskeymessage",function(d){c.a&&(c.a.resolve(),c.a=null);d=new Q("message",{messageType:void 0==c.keyStatuses.a?"license-request":"license-renewal",message:mb(d.message)});c.dispatchEvent(d);}),this.b.l(this.f,"mskeyadded",function(){c.a?(Kq(c,"usable"),c.a.resolve(),c.a=null):c.c&&(Kq(c,"usable"),c.c.resolve(),c.c=null);}),this.b.l(this.f,"mskeyerror",function(){var d=Error("EME PatchedMediaKeysMs key error");
d.errorCode=c.f.error;if(null!=c.a)c.a.reject(d),c.a=null;else if(null!=c.c)c.c.reject(d),c.c=null;else switch(c.f.error.code){case MSMediaKeyError.MS_MEDIA_KEYERR_OUTPUT:case MSMediaKeyError.MS_MEDIA_KEYERR_HARDWARECHANGE:Kq(c,"output-not-allowed");break;default:Kq(c,"internal-error");}}),Kq(this,"status-pending");}catch(d){this.a.reject(d);}return this.a};p.load=function(){return Promise.reject(Error("MediaKeySession.load not yet supported"))};p.update=function(a){this.c=new Pb;try{this.f.update(L(a));}catch(b){this.c.reject(b);}return this.c};
p.close=function(){try{this.f.close(),this.closed.resolve(),this.b.Xa();}catch(a){this.closed.reject(a);}return this.closed};p.remove=function(){return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"))};function Kq(a,b){var c=a.keyStatuses;c.size=void 0==b?0:1;c.a=b;c=new Q("keystatuseschange");a.dispatchEvent(c);}function Jq(){this.size=0;this.a=void 0;}p=Jq.prototype;p.forEach=function(a){this.a&&a(this.a,ce.value());};
p.get=function(a){if(this.has(a))return this.a};p.has=function(a){var b=ce.value();return this.a&&kb(a,b)?!0:!1};p.entries=function(){};p.keys=function(){};p.values=function(){};
jq(function(){!window.HTMLVideoElement||!window.MSMediaKeys||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration||(delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,window.MediaKeys=Fq,window.MediaKeySystemAccess=Dq,navigator.requestMediaKeySystemAccess=Cq,HTMLMediaElement.prototype.setMediaKeys=Gq);});function Lq(){return Promise.reject(Error("The key system specified is not supported."))}function Mq(a){return null==a?Promise.resolve():Promise.reject(Error("MediaKeys not supported."))}function Nq(){throw new TypeError("Illegal constructor.");}Nq.prototype.createSession=function(){};Nq.prototype.setServerCertificate=function(){};function Oq(){this.keySystem="";throw new TypeError("Illegal constructor.");}Oq.prototype.getConfiguration=function(){};Oq.prototype.createMediaKeys=function(){};
jq(function(){!window.HTMLVideoElement||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration||(navigator.requestMediaKeySystemAccess=Lq,delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,HTMLMediaElement.prototype.setMediaKeys=Mq,window.MediaKeys=Nq,window.MediaKeySystemAccess=Oq);},-10);function Pq(a){var b=Qq;return b?b+a.charAt(0).toUpperCase()+a.slice(1):a}function Rq(a,b){try{var c=new Sq(a,b);return Promise.resolve(c)}catch(d){return Promise.reject(d)}}function Tq(a){var b=this.mediaKeys;b&&b!=a&&Uq(b,null);delete this.mediaKeys;(this.mediaKeys=a)&&Uq(a,this);return Promise.resolve()}
function Sq(a,b){this.a=this.keySystem=a;var c=!1;"org.w3.clearkey"==a&&(this.a="webkit-org.w3.clearkey",c=!1);var d=!1;var e=document.getElementsByTagName("video");e=e.length?e[0]:document.createElement("video");for(var f=q(b),g=f.next();!g.done;g=f.next()){g=g.value;var h={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:g.initDataTypes,sessionTypes:["temporary"],label:g.label},k=!1;if(g.audioCapabilities)for(var l=q(g.audioCapabilities),
m=l.next();!m.done;m=l.next())m=m.value,m.contentType&&(k=!0,e.canPlayType(m.contentType.split(";")[0],this.a)&&(h.audioCapabilities.push(m),d=!0));if(g.videoCapabilities)for(l=q(g.videoCapabilities),m=l.next();!m.done;m=l.next())m=m.value,m.contentType&&(k=!0,e.canPlayType(m.contentType,this.a)&&(h.videoCapabilities.push(m),d=!0));k||(d=e.canPlayType("video/mp4",this.a)||e.canPlayType("video/webm",this.a));"required"==g.persistentState&&(c?(h.persistentState="required",h.sessionTypes=["persistent-license"]):
d=!1);if(d){this.b=h;return}}c="Unsupported keySystem";if("org.w3.clearkey"==a||"com.widevine.alpha"==a)c="None of the requested configurations were supported.";c=Error(c);c.name="NotSupportedError";c.code=DOMException.NOT_SUPPORTED_ERR;throw c;}Sq.prototype.createMediaKeys=function(){var a=new Vq(this.a);return Promise.resolve(a)};Sq.prototype.getConfiguration=function(){return this.b};function Vq(a){this.g=a;this.a=null;this.b=new Tc;this.c=[];this.f=new Map;}
function Uq(a,b){a.a=b;a.b.Xa();var c=Qq;b&&(a.b.l(b,c+"needkey",function(d){var e=document.createEvent("CustomEvent");e.initCustomEvent("encrypted",!1,!1,null);e.initDataType="cenc";e.initData=mb(d.initData);a.a.dispatchEvent(e);}),a.b.l(b,c+"keymessage",function(d){var e=Wq(a,d.sessionId);e&&(d=new Q("message",{messageType:void 0==e.keyStatuses.a?"licenserequest":"licenserenewal",message:d.message}),e.b&&(e.b.resolve(),e.b=null),e.dispatchEvent(d));}),a.b.l(b,c+"keyadded",function(d){if(d=Wq(a,d.sessionId))Xq(d,
"usable"),d.a&&d.a.resolve(),d.a=null;}),a.b.l(b,c+"keyerror",function(d){var e=Wq(a,d.sessionId);e&&e.handleError(d);}));}Vq.prototype.createSession=function(a){a=a||"temporary";if("temporary"!=a&&"persistent-license"!=a)throw new TypeError("Session type "+a+" is unsupported on this platform.");var b=this.a||document.createElement("video");b.src||(b.src="about:blank");a=new Yq(b,this.g,a);this.c.push(a);return a};Vq.prototype.setServerCertificate=function(){return Promise.resolve(!1)};
function Wq(a,b){var c=a.f.get(b);return c?c:(c=a.c.shift())?(c.sessionId=b,a.f.set(b,c),c):null}function Yq(a,b,c){xc.call(this);this.f=a;this.h=!1;this.a=this.b=null;this.c=b;this.g=c;this.sessionId="";this.expiration=NaN;this.closed=new Pb;this.keyStatuses=new Zq;}pa(Yq,xc);p=Yq.prototype;
p.handleError=function(a){var b=Error("EME v0.1b key error"),c=a.errorCode;c.systemCode=a.systemCode;b.errorCode=c;!a.sessionId&&this.b?(45==a.systemCode&&(b.message="Unsupported session type."),this.b.reject(b),this.b=null):a.sessionId&&this.a?(this.a.reject(b),this.a=null):(b=a.systemCode,a.errorCode.code==MediaKeyError.MEDIA_KEYERR_OUTPUT?Xq(this,"output-restricted"):1==b?Xq(this,"expired"):Xq(this,"internal-error"));};
function $q(a,b,c){if(a.h)return Promise.reject(Error("The session is already initialized."));a.h=!0;try{if("persistent-license"==a.g)if(c)var d=L(Xb("LOAD_SESSION|"+c));else {var e=Xb("PERSISTENT|");d=fc(e,b);}else d=L(b);}catch(g){return Promise.reject(g)}a.b=new Pb;var f=Pq("generateKeyRequest");try{a.f[f](a.c,d);}catch(g){if("InvalidStateError"!=g.name)return a.b=null,Promise.reject(g);(new N(function(){try{a.f[f](a.c,d);}catch(h){a.b.reject(h),a.b=null;}})).R(.01);}return a.b}
function ar(a,b,c){if(a.a)a.a.then(function(){return ar(a,b,c)})["catch"](function(){return ar(a,b,c)});else {a.a=b;if("webkit-org.w3.clearkey"==a.c){var d=Tb(c);var e=JSON.parse(d);"oct"!=e.keys[0].kty&&(a.a.reject(Error("Response is not a valid JSON Web Key Set.")),a.a=null);d=cc(e.keys[0].k);e=cc(e.keys[0].kid);}else d=L(c),e=null;var f=Pq("addKey");try{a.f[f](a.c,d,e,a.sessionId);}catch(g){a.a.reject(g),a.a=null;}}}
function Xq(a,b){var c=a.keyStatuses;c.size=void 0==b?0:1;c.a=b;c=new Q("keystatuseschange");a.dispatchEvent(c);}p.generateRequest=function(a,b){return $q(this,b,null)};p.load=function(a){return "persistent-license"==this.g?$q(this,null,a):Promise.reject(Error("Not a persistent session."))};p.update=function(a){var b=new Pb;ar(this,b,a);return b};
p.close=function(){if("persistent-license"!=this.g){if(!this.sessionId)return this.closed.reject(Error("The session is not callable.")),this.closed;var a=Pq("cancelKeyRequest");try{this.f[a](this.c,this.sessionId);}catch(b){}}this.closed.resolve();return this.closed};p.remove=function(){return "persistent-license"!=this.g?Promise.reject(Error("Not a persistent session.")):this.close()};function Zq(){this.size=0;this.a=void 0;}p=Zq.prototype;p.forEach=function(a){this.a&&a(this.a,ce.value());};p.get=function(a){if(this.has(a))return this.a};
p.has=function(a){var b=ce.value();return this.a&&kb(a,b)?!0:!1};p.entries=function(){};p.keys=function(){};p.values=function(){};var Qq="";
jq(function(){if(!(!window.HTMLVideoElement||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration)){if(HTMLMediaElement.prototype.webkitGenerateKeyRequest)Qq="webkit";else if(!HTMLMediaElement.prototype.generateKeyRequest)return;navigator.requestMediaKeySystemAccess=Rq;delete HTMLMediaElement.prototype.mediaKeys;HTMLMediaElement.prototype.mediaKeys=null;HTMLMediaElement.prototype.setMediaKeys=Tq;window.MediaKeys=Vq;window.MediaKeySystemAccess=Sq;}});function br(a){a=a.target;if("picture-in-picture"==a.webkitPresentationMode){document.pictureInPictureElement=a;var b=new Event("enterpictureinpicture");a.dispatchEvent(b);}else document.pictureInPictureElement==a&&(document.pictureInPictureElement=null),b=new Event("leavepictureinpicture"),a.dispatchEvent(b);}
function cr(){return this.webkitSupportsPresentationMode("picture-in-picture")?(this.webkitSetPresentationMode("picture-in-picture"),document.pictureInPictureElement=this,Promise.resolve()):Promise.reject(Error("PiP not allowed by video element"))}function dr(){var a=document.pictureInPictureElement;return a?(a.webkitSetPresentationMode("inline"),document.pictureInPictureElement=null,Promise.resolve()):Promise.reject(Error("No picture in picture element found"))}
function er(){return this.hasAttribute("disablePictureInPicture")?!0:!this.webkitSupportsPresentationMode("picture-in-picture")}function fr(a){a?this.setAttribute("disablePictureInPicture",""):this.removeAttribute("disablePictureInPicture");}
jq(function(){if(window.HTMLVideoElement){var a=HTMLVideoElement.prototype;a.requestPictureInPicture&&document.exitPictureInPicture||!a.webkitSupportsPresentationMode||(document.pictureInPictureEnabled=!0,document.pictureInPictureElement=null,a.requestPictureInPicture=cr,Object.defineProperty(a,"disablePictureInPicture",{get:er,set:fr,enumerable:!0,configurable:!0}),document.exitPictureInPicture=dr,document.addEventListener("webkitpresentationmodechanged",br,!0));}});jq(function(){if(window.HTMLMediaElement){var a=HTMLMediaElement.prototype.play;HTMLMediaElement.prototype.play=function(){var b=a.apply(this);b&&b["catch"](function(){});return b};}});function gr(){return {droppedVideoFrames:this.webkitDroppedFrameCount,totalVideoFrames:this.webkitDecodedFrameCount,corruptedVideoFrames:0,creationTime:NaN,totalFrameDelay:0}}jq(function(){if(window.HTMLVideoElement){var a=HTMLVideoElement.prototype;!a.getVideoPlaybackQuality&&"webkitDroppedFrameCount"in a&&(a.getVideoPlaybackQuality=gr);}});function hr(a,b,c){return new window.TextTrackCue(a,b,c)}function ir(a,b,c){return new window.TextTrackCue(a+"-"+b+"-"+c,a,b,c)}jq(function(){if(!window.VTTCue&&window.TextTrackCue){var a=null,b=TextTrackCue.length;if(3==b)a=hr;else if(6==b)a=ir;else {try{var c=!!hr(1,2,"");}catch(d){c=!1;}c&&(a=hr);}a&&(window.VTTCue=function(d,e,f){return a(d,e,f)});}});function jr(){}jr.prototype.parseInit=function(){};
jr.prototype.parseMedia=function(a,b){var c=Tb(a),d=[],e=new DOMParser,f=null;if(""==c)return d;try{f=e.parseFromString(c,"text/xml");}catch(B){throw new M(2,2,2005,"Failed to parse TTML.");}if(f){if(c=f.getElementsByTagName("parsererror")[0])throw new M(2,2,2005,c.textContent);if(e=f.getElementsByTagName("tt")[0]){var g=dl(e,"http://www.w3.org/ns/ttml#parameter","frameRate");var h=dl(e,"http://www.w3.org/ns/ttml#parameter","subFrameRate");var k=dl(e,"http://www.w3.org/ns/ttml#parameter","frameRateMultiplier");
var l=dl(e,"http://www.w3.org/ns/ttml#parameter","tickRate");var m=dl(e,"http://www.w3.org/ns/ttml#parameter","cellResolution");f=e.getAttribute("xml:space")||"default";c=dl(e,"http://www.w3.org/ns/ttml#styling","extent");}else throw new M(2,2,2005,"TTML does not contain <tt> tag.");if("default"!=f&&"preserve"!=f)throw new M(2,2,2005,"Invalid xml:space value: "+f);f="default"==f;g=new kr(g,h,k,l);m=m?(m=/^(\d+) (\d+)$/.exec(m))?{columns:parseInt(m[1],10),rows:parseInt(m[2],10)}:null:null;h=lr(e.getElementsByTagName("metadata")[0]);
k=lr(e.getElementsByTagName("styling")[0]);l=lr(e.getElementsByTagName("layout")[0]);for(var n=[],r=q(l),u=r.next();!u.done;u=r.next()){var v=u.value,A=c;u=new me;var y=v.getAttribute("xml:id");if(y){u.id=y;y=null;A&&(y=mr.exec(A)||nr.exec(A));A=y?Number(y[1]):null;y=y?Number(y[2]):null;var z,D;if(z=or(v,k,"extent"))z=(D=mr.exec(z))||nr.exec(z),null!=z&&(u.width=null!=A?100*Number(z[1])/A:Number(z[1]),u.height=null!=y?100*Number(z[2])/y:Number(z[2]),u.widthUnits=D||null!=A?Be:0,u.heightUnits=D||null!=
y?Be:0);if(v=or(v,k,"origin"))z=(D=mr.exec(v))||nr.exec(v),null!=z&&(u.viewportAnchorX=null!=A?100*Number(z[1])/A:Number(z[1]),u.viewportAnchorY=null!=y?100*Number(z[2])/y:Number(z[2]),u.viewportAnchorUnits=D||null!=A?Be:0);}else u=null;u&&n.push(u);}c=pr(e.getElementsByTagName("body")[0]);c=q(c);for(e=c.next();!e.done;e=c.next())(e=qr(e.value,b.periodStart,g,h,k,l,n,f,!1,m))&&d.push(e);}return d};
function lr(a){var b=[];if(!a)return b;for(var c=q(a.childNodes),d=c.next();!d.done;d=c.next())d=d.value,d.nodeType==Node.ELEMENT_NODE&&"br"!==d.nodeName&&(d=lr(d),b=b.concat(d));b.length||b.push(a);return b}function pr(a){if(!a)return [];var b=[];a=q(a.childNodes);for(var c=a.next();!c.done;c=a.next())c=c.value,c instanceof Element&&(c.hasAttribute("begin")?b.push(c):b=b.concat(pr(c)));return b}
function rr(a,b){for(var c="",d=q(a.childNodes),e=d.next();!e.done;e=d.next())e=e.value,"br"==e.nodeName&&a.childNodes[0]!==e?c+="\n":e.childNodes&&0<e.childNodes.length?c+=rr(e,b):b?(e=e.textContent.trim(),e=e.replace(/\s+/g," "),c+=e):c+=e.textContent;return c}
function qr(a,b,c,d,e,f,g,h,k,l){if(k&&"br"==a.nodeName)return a=new ke(0,0,""),a.spacer=!0,a;var m=/^[\s\n]*$/.test(a.textContent),n=a.nodeType==Node.ELEMENT_NODE&&!a.hasAttribute("begin")&&!a.hasAttribute("end");if(a.nodeType!=Node.ELEMENT_NODE||n&&m||n&&!k)return null;m=sr(a.getAttribute("begin"),c);n=sr(a.getAttribute("end"),c);var r=sr(a.getAttribute("dur"),c);null==n&&null!=r&&(n=m+r);if(!k&&(null==m||null==n))throw new M(2,2,2001);m=k&&null==m?0:m+b;n=k&&null==n?0:n+b;r="";k=[];if(Array.from(a.childNodes).some(function(y){return y.nodeType==
Node.TEXT_NODE&&/\S+/.test(y.textContent)}))r=rr(a,h);else for(var u=q(a.childNodes),v=u.next();!v.done;v=u.next())if(v=qr(v.value,b,c,d,e,f,g,h,!0,l))v.startTime=v.startTime||m,v.endTime=v.endTime||n,k.push(v);b=new ke(m,n,r);b.nestedCues=k;l&&(b.cellResolution=l);if((f=tr(a,"region",f,"")[0])&&f.getAttribute("xml:id")){var A=f.getAttribute("xml:id");b.region=g.filter(function(y){return y.id==A})[0];}d=tr(a,"backgroundImage",d,"#","http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt")[0];ur(b,a,
f,d,e);return b}
function ur(a,b,c,d,e){"rtl"==vr(b,c,e,"direction")&&(a.direction="rtl");var f=vr(b,c,e,"writingMode");"tb"==f||"tblr"==f?a.writingMode="vertical-lr":"tbrl"==f?a.writingMode="vertical-rl":"rltb"==f||"rl"==f?a.direction="rtl":f&&(a.direction=le);(f=vr(b,c,e,"textAlign"))?(a.positionAlign=wr[f],a.lineAlign=xr[f],a.textAlign=we[f.toUpperCase()]):a.textAlign="start";if(f=vr(b,c,e,"displayAlign"))a.displayAlign=xe[f.toUpperCase()];if(f=vr(b,c,e,"color"))a.color=f;if(f=vr(b,c,e,"backgroundColor"))a.backgroundColor=f;
if(f=vr(b,c,e,"border"))a.border=f;if(f=vr(b,c,e,"fontFamily"))a.fontFamily=f;(f=vr(b,c,e,"fontWeight"))&&"bold"==f&&(a.fontWeight=700);(f=vr(b,c,e,"wrapOption"))&&"noWrap"==f&&(a.wrapLine=!1);(f=vr(b,c,e,"lineHeight"))&&f.match(yr)&&(a.lineHeight=f);(f=vr(b,c,e,"fontSize"))&&(f.match(yr)||f.match(zr))&&(a.fontSize=f);if(f=vr(b,c,e,"fontStyle"))a.fontStyle=Ae[f.toUpperCase()];if(d){f=d.getAttribute("imagetype");var g=d.getAttribute("encoding");d=d.textContent.trim();"PNG"==f&&"Base64"==g&&d&&(a.backgroundImage=
"data:image/png;base64,"+d);}(d=vr(b,c,e,"letterSpacing"))&&d.match(yr)&&(a.letterSpacing=d);(d=vr(b,c,e,"linePadding"))&&d.match(yr)&&(a.linePadding=d);if(d=vr(b,c,e,"opacity"))a.opacity=parseFloat(d);(c=or(c,e,"textDecoration"))&&Ar(a,c);(b=Br(b,e,"textDecoration"))&&Ar(a,b);}
function Ar(a,b){for(var c=q(b.split(" ")),d=c.next();!d.done;d=c.next())switch(d.value){case "underline":a.textDecoration.includes("underline")||a.textDecoration.push("underline");break;case "noUnderline":a.textDecoration.includes("underline")&&Bc(a.textDecoration,"underline");break;case "lineThrough":a.textDecoration.includes("lineThrough")||a.textDecoration.push("lineThrough");break;case "noLineThrough":a.textDecoration.includes("lineThrough")&&Bc(a.textDecoration,"lineThrough");break;case "overline":a.textDecoration.includes("overline")||
a.textDecoration.push("overline");break;case "noOverline":a.textDecoration.includes("overline")&&Bc(a.textDecoration,"overline");}}function vr(a,b,c,d){return (a=Br(a,c,d))?a:or(b,c,d)}function or(a,b,c){if(!a)return null;var d=lr(a);d=q(d);for(var e=d.next();!e.done;e=d.next())if(e=dl(e.value,"http://www.w3.org/ns/ttml#styling",c))return e;return Cr(a,b,c)}function Br(a,b,c){var d=dl(a,"http://www.w3.org/ns/ttml#styling",c);return d?d:Cr(a,b,c)}
function Cr(a,b,c){a=tr(a,"style",b,"");for(var d=null,e=0;e<a.length;e++){var f=dl(a[e],"urn:ebu:tt:style",c);f||(f=dl(a[e],"http://www.w3.org/ns/ttml#styling",c));f||(f=Br(a[e],b,c));f&&(d=f);}return d}
function tr(a,b,c,d,e){var f=[];if(!a||1>c.length)return f;var g=a;for(a=null;g&&!(a=e?dl(g,e,b):g.getAttribute(b))&&(g=g.parentNode,g instanceof Element););if(b=a)for(b=q(b.split(" ")),e=b.next();!e.done;e=b.next())for(e=e.value,a=q(c),g=a.next();!g.done;g=a.next())if(g=g.value,d+g.getAttribute("xml:id")==e){f.push(g);break}return f}
function sr(a,b){var c=null;if(Dr.test(a)){c=Dr.exec(a);var d=Number(c[1]),e=Number(c[2]),f=Number(c[3]),g=Number(c[4]);g+=(Number(c[5])||0)/b.b;f+=g/b.frameRate;c=f+60*e+3600*d;}else Er.test(a)?c=Fr(Er,a):Gr.test(a)?c=Fr(Gr,a):Hr.test(a)?(c=Hr.exec(a),c=Number(c[1])/b.frameRate):Ir.test(a)?(c=Ir.exec(a),c=Number(c[1])/b.a):Jr.test(a)&&(c=Fr(Jr,a));return c}
function Fr(a,b){var c=a.exec(b);return null==c||""==c[0]?null:(Number(c[4])||0)/1E3+(Number(c[3])||0)+60*(Number(c[2])||0)+3600*(Number(c[1])||0)}K("shaka.text.TtmlTextParser",jr);jr.prototype.parseMedia=jr.prototype.parseMedia;jr.prototype.parseInit=jr.prototype.parseInit;function kr(a,b,c,d){this.frameRate=Number(a)||30;this.b=Number(b)||1;this.a=Number(d);0==this.a&&(this.a=a?this.frameRate*this.b:1);c&&(a=/^(\d+) (\d+)$/g.exec(c))&&(this.frameRate*=Number(a[1])/Number(a[2]));}
var mr=/^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/,zr=/^(\d{1,2}(?:\.\d+)?|100)%$/,yr=/^(\d+px|\d+em|\d*\.?\d+c)$/,nr=/^(\d+)px (\d+)px$/,Dr=/^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,Er=/^(?:(\d{2,}):)?(\d{2}):(\d{2})$/,Gr=/^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/,Hr=/^(\d*(?:\.\d*)?)f$/,Ir=/^(\d*(?:\.\d*)?)t$/,Jr=/^(?:(\d*(?:\.\d*)?)h)?(?:(\d*(?:\.\d*)?)m)?(?:(\d*(?:\.\d*)?)s)?(?:(\d*(?:\.\d*)?)ms)?$/,xr={left:re,center:"center",right:"end",start:re,end:"end"},wr=
{left:"line-left",center:"center",right:"line-right"};Fe["application/ttml+xml"]=function(){return new jr};function Kr(){this.m=new jr;}Kr.prototype.parseInit=function(a){var b=!1;(new Mg).box("moov",Qg).box("trak",Qg).box("mdia",Qg).box("minf",Qg).box("stbl",Qg).ea("stsd",Rg).box("stpp",function(c){b=!0;c.parser.stop();}).parse(a);if(!b)throw new M(2,2,2007);};Kr.prototype.parseMedia=function(a,b){var c=this,d=!1,e=[];(new Mg).box("mdat",Sg(function(f){d=!0;e=e.concat(c.m.parseMedia(f,b));})).parse(a,!1);if(!d)throw new M(2,2,2007);return e};K("shaka.text.Mp4TtmlParser",Kr);Kr.prototype.parseMedia=Kr.prototype.parseMedia;
Kr.prototype.parseInit=Kr.prototype.parseInit;Fe['application/mp4; codecs="stpp"']=function(){return new Kr};Fe['application/mp4; codecs="stpp.ttml.im1t"']=function(){return new Kr};Fe['application/mp4; codecs="stpp.TTML.im1t"']=function(){return new Kr};function Lr(){}Lr.prototype.parseInit=function(){};
Lr.prototype.parseMedia=function(a,b){var c=Tb(a);c=c.replace(/\r\n|\r(?=[^\n]|$)/gm,"\n");var d=c.split(/\n{2,}/m);if(!/^WEBVTT($|[ \t\n])/m.test(d[0]))throw new M(2,2,2E3);c=b.periodStart;if(d[0].includes("X-TIMESTAMP-MAP")){var e=d[0].match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m),f=d[0].match(/MPEGTS:(\d+)/m);if(e&&f){c=Mr(new nn(e[1]));if(null==c)throw new M(2,2,2E3);f=Number(f[1]);for(e=b.segmentStart;95443.7176888889<=e;)e-=95443.7176888889,f+=8589934592;c=b.periodStart+f/9E4-c;}}f=
[];e=q(d[0].split("\n"));for(var g=e.next();!g.done;g=e.next())if(g=g.value,/^Region:/.test(g)){g=new nn(g);var h=new me;qn(g);on(g);for(var k=qn(g);k;){var l=h,m=k;(k=/^id=(.*)$/.exec(m))?l.id=k[1]:(k=/^width=(\d{1,2}|100)%$/.exec(m))?l.width=Number(k[1]):(k=/^lines=(\d+)$/.exec(m))?(l.height=Number(k[1]),l.heightUnits=2):(k=/^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(m))?(l.regionAnchorX=Number(k[1]),l.regionAnchorY=Number(k[2])):(k=/^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(m))?
(l.viewportAnchorX=Number(k[1]),l.viewportAnchorY=Number(k[2])):/^scroll=up$/.exec(m)&&(l.scroll="up");on(g);k=qn(g);}f.push(h);}e=[];d=q(d.slice(1));for(g=d.next();!g.done;g=d.next()){l=g.value.split("\n");k=c;if(1==l.length&&!l[0]||/^NOTE($|[ \t])/.test(l[0])||"STYLE"==l[0])g=null;else {g=null;l[0].includes("--\x3e")||(g=l[0],l.splice(0,1));h=new nn(l[0]);m=Mr(h);var n=pn(h,/[ \t]+--\x3e[ \t]+/g),r=Mr(h);if(null==m||null==n||null==r)throw new M(2,2,2001);l=new ke(m+k,r+k,l.slice(1).join("\n").trim());
on(h);for(k=qn(h);k;)Nr(l,k,f),on(h),k=qn(h);null!=g&&(l.id=g);g=l;}g&&e.push(g);}return e};
function Nr(a,b,c){var d;if(d=/^align:(start|middle|center|end|left|right)$/.exec(b))b=d[1],"middle"==b?a.textAlign=oe:a.textAlign=we[b.toUpperCase()];else if(d=/^vertical:(lr|rl)$/.exec(b))a.writingMode="lr"==d[1]?"vertical-lr":"vertical-rl";else if(d=/^size:([\d.]+)%$/.exec(b))a.size=Number(d[1]);else if(d=/^position:([\d.]+)%(?:,(line-left|line-right|center|start|end))?$/.exec(b))a.position=Number(d[1]),d[2]&&(b=d[2],a.positionAlign="line-left"==b||"start"==b?"line-left":"line-right"==b||"end"==
b?"line-right":"center");else if(d=/^region:(.*)$/.exec(b)){if(b=Or(c,d[1]))a.region=b;}else if(c=/^line:([\d.]+)%(?:,(start|end|center))?$/.exec(b))a.lineInterpretation=1,a.line=Number(c[1]),c[2]&&(a.lineAlign=ye[c[2].toUpperCase()]);else if(c=/^line:(-?\d+)(?:,(start|end|center))?$/.exec(b))a.lineInterpretation=qe,a.line=Number(c[1]),c[2]&&(a.lineAlign=ye[c[2].toUpperCase()]);}function Or(a,b){var c=a.filter(function(d){return d.id==b});return c.length?c[0]:null}
function Mr(a){a=pn(a,/(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g);if(null==a)return null;var b=Number(a[2]),c=Number(a[3]);return 59<b||59<c?null:Number(a[4])/1E3+c+60*b+3600*(Number(a[1])||0)}K("shaka.text.VttTextParser",Lr);Lr.prototype.parseMedia=Lr.prototype.parseMedia;Lr.prototype.parseInit=Lr.prototype.parseInit;Fe["text/vtt"]=function(){return new Lr};Fe['text/vtt; codecs="vtt"']=function(){return new Lr};Fe['text/vtt; codecs="wvtt"']=function(){return new Lr};function Pr(){this.a=null;}Pr.prototype.parseInit=function(a){var b=this,c=!1;(new Mg).box("moov",Qg).box("trak",Qg).box("mdia",Qg).ea("mdhd",function(d){0==d.version?(d.reader.skip(4),d.reader.skip(4),b.a=d.reader.K(),d.reader.skip(4)):(d.reader.skip(8),d.reader.skip(8),b.a=d.reader.K(),d.reader.skip(8));d.reader.skip(4);}).box("minf",Qg).box("stbl",Qg).ea("stsd",Rg).box("wvtt",function(){c=!0;}).parse(a);if(!this.a)throw new M(2,2,2008);if(!c)throw new M(2,2,2008);};
Pr.prototype.parseMedia=function(a,b){if(!this.a)throw new M(2,2,2008);var c=0,d=[],e,f=[],g=!1,h=!1,k=!1,l=null;(new Mg).box("moof",Qg).box("traf",Qg).ea("tfdt",function(E){g=!0;c=0==E.version?E.reader.K():E.reader.rb();}).ea("tfhd",function(E){var H=E.flags;E=E.reader;E.skip(4);H&1&&E.skip(8);H&2&&E.skip(4);l=H&8?E.K():null;}).ea("trun",function(E){h=!0;var H=E.version,G=E.flags;E=E.reader;var F=E.K();G&1&&E.skip(4);G&4&&E.skip(4);var I=[];F=q(gb(F));for(var O=F.next();!O.done;O=F.next())O={duration:null,
sampleSize:null,rd:null},G&256&&(O.duration=E.K()),G&512&&(O.sampleSize=E.K()),G&1024&&E.skip(4),G&2048&&(O.rd=0==H?E.K():E.Od()),I.push(O);d=I;}).box("mdat",Sg(function(E){k=!0;e=E;})).parse(a,!1);if(!k&&!g&&!h)throw new M(2,2,2008);for(var m=c,n=new V(e,0),r=q(d),u=r.next();!u.done;u=r.next()){u=u.value;var v=u.duration||l,A=u.rd?c+u.rd:m;m=A+(v||0);var y=0;do{var z=n.K();y+=z;var D=n.K(),B=null;"vttc"==Tg(D)?8<z&&(B=n.Wa(z-8)):n.skip(z-8);v&&B&&(z=Qr(B,b.periodStart+A/this.a,b.periodStart+m/this.a),
f.push(z));}while(u.sampleSize&&y<u.sampleSize)}return f.filter(Kb)};function Qr(a,b,c){var d,e,f;(new Mg).box("payl",Sg(function(g){d=Tb(g);})).box("iden",Sg(function(g){e=Tb(g);})).box("sttg",Sg(function(g){f=Tb(g);})).parse(a);return d?Rr(d,e,f,b,c):null}function Rr(a,b,c,d,e){a=new ke(d,e,a);b&&(a.id=b);if(c)for(b=new nn(c),c=qn(b);c;)Nr(a,c,[]),on(b),c=qn(b);return a}K("shaka.text.Mp4VttParser",Pr);Pr.prototype.parseMedia=Pr.prototype.parseMedia;Pr.prototype.parseInit=Pr.prototype.parseInit;
Fe['application/mp4; codecs="wvtt"']=function(){return new Pr};/*
 @license
 EME Encryption Scheme Polyfill
 Copyright 2019 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
function Sr(){}var Tr;function Ur(){Tr?console.debug("EmeEncryptionSchemePolyfill: Already installed."):navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration?(Tr=navigator.requestMediaKeySystemAccess,console.debug("EmeEncryptionSchemePolyfill: Waiting to detect encryptionScheme support."),navigator.requestMediaKeySystemAccess=Vr):console.debug("EmeEncryptionSchemePolyfill: EME not found");}
function Vr(a,b){var c=this,d;return J(function(e){if(1==e.a)return console.assert(c==navigator,'bad "this" for requestMediaKeySystemAccess'),t(e,Tr.call(c,a,b),2);d=e.b;if(Wr(d))return console.debug("EmeEncryptionSchemePolyfill: Native encryptionScheme support found."),navigator.requestMediaKeySystemAccess=Tr,e["return"](d);console.debug("EmeEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support.");navigator.requestMediaKeySystemAccess=Xr;return e["return"](Xr.call(c,
a,b))})}
function Xr(a,b){var c=this,d,e,f,g,h,k,l,m,n,r;return J(function(u){if(1==u.a){console.assert(c==navigator,'bad "this" for requestMediaKeySystemAccess');d=Yr(a);e=[];f=q(b);for(g=f.next();!g.done;g=f.next())h=g.value,k=Zr(h.videoCapabilities,d),l=Zr(h.audioCapabilities,d),h.videoCapabilities&&h.videoCapabilities.length&&!k.length||h.audioCapabilities&&h.audioCapabilities.length&&!l.length||(m=Object.assign({},h),m.videoCapabilities=k,m.audioCapabilities=l,e.push(m));if(!e.length)throw n=Error("Unsupported keySystem or supportedConfigurations."),
n.name="NotSupportedError",n.code=DOMException.NOT_SUPPORTED_ERR,n;return t(u,Tr.call(c,a,e),2)}r=u.b;return u["return"](new $r(r,d))})}function Zr(a,b){return a?a.filter(function(c){return !c.encryptionScheme||c.encryptionScheme==b}):a}K("EmeEncryptionSchemePolyfill",Sr);Sr.install=Ur;function as(){}var bs;
function cs(){navigator.mediaCapabilities?(bs=navigator.mediaCapabilities.decodingInfo,console.debug("McEncryptionSchemePolyfill: Waiting to detect encryptionScheme support."),navigator.mediaCapabilities.decodingInfo=ds):console.debug("McEncryptionSchemePolyfill: MediaCapabilities not found");}
function ds(a){var b=this,c,d;return J(function(e){if(1==e.a)return console.assert(b==navigator.mediaCapabilities,'bad "this" for decodingInfo'),t(e,bs.call(b,a),2);c=e.b;if(!a.keySystemConfiguration)return e["return"](c);d=c.keySystemAccess;if(Wr(d))return console.debug("McEncryptionSchemePolyfill: Native encryptionScheme support found."),navigator.mediaCapabilities.decodingInfo=bs,e["return"](c);console.debug("McEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support.");
navigator.mediaCapabilities.decodingInfo=es;return e["return"](es.call(b,a))})}
function es(a){var b=this,c,d,e,f,g,h,k;return J(function(l){if(1==l.a)return console.assert(b==navigator.mediaCapabilities,'bad "this" for decodingInfo'),c=null,a.keySystemConfiguration&&(d=a.keySystemConfiguration,e=d.keySystem,f=d.audio&&d.audio.encryptionScheme,g=d.video&&d.video.encryptionScheme,c=Yr(e),h={powerEfficient:!1,smooth:!1,supported:!1,keySystemAccess:null,configuration:a},f&&f!=c||g&&g!=c)?l["return"](h):t(l,bs.call(b,a),2);k=l.b;k.keySystemAccess&&(k.keySystemAccess=new $r(k.keySystemAccess,
c));return l["return"](k)})}K("McEncryptionSchemePolyfill",as);as.install=cs;function $r(a,b){this.b=a;this.a=b;this.keySystem=a.keySystem;}$r.prototype.getConfiguration=function(){var a=this.b.getConfiguration();if(a.videoCapabilities)for(var b=q(a.videoCapabilities),c=b.next();!c.done;c=b.next())c.value.encryptionScheme=this.a;if(a.audioCapabilities)for(b=q(a.audioCapabilities),c=b.next();!c.done;c=b.next())c.value.encryptionScheme=this.a;return a};$r.prototype.createMediaKeys=function(){return this.b.createMediaKeys()};
function Yr(a){if(a.startsWith("com.widevine")||a.startsWith("com.microsoft")||a.startsWith("com.adobe")||a.startsWith("org.w3"))return "cenc";if(a.startsWith("com.apple"))return "cbcs-1-9";console.warn("EmeEncryptionSchemePolyfill: Unknown key system:",a,"Please contribute!");return null}function Wr(a){a=a.getConfiguration();var b=a.audioCapabilities&&a.audioCapabilities[0];return (a=a.videoCapabilities&&a.videoCapabilities[0]||b)&&void 0!==a.encryptionScheme?!0:!1}function fs(){}
function lq(){Ur();cs();}K("EncryptionSchemePolyfills",fs);fs.install=lq;"undefined"!==typeof module&&module.exports&&(module.exports=fs);}).call(exportTo,innerGlobal,innerGlobal,undefined);for(var k in exportTo.shaka)exports[k]=exportTo.shaka[k];})();


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")));

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/clappr-dash-shaka-playback.js":
/*!*******************************************!*\
  !*** ./src/clappr-dash-shaka-playback.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clappr = __webpack_require__(/*! clappr */ "clappr");

var _shakaPlayer = _interopRequireDefault(__webpack_require__(/*! shaka-player */ "./node_modules/shaka-player/dist/shaka-player.compiled.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SEND_STATS_INTERVAL_MS = 30 * 1e3;
var DEFAULT_LEVEL_AUTO = -1;

var DashShakaPlayback = /*#__PURE__*/function (_HTML5Video) {
  _inherits(DashShakaPlayback, _HTML5Video);

  var _super = _createSuper(DashShakaPlayback);

  _createClass(DashShakaPlayback, [{
    key: "getDuration",
    value: function getDuration() {
      return this._duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.shakaPlayerInstance) return 0;
      return this.shakaPlayerInstance.getMediaElement().currentTime - this.seekRange.start;
    }
  }, {
    key: "name",
    get: function get() {
      return 'dash_shaka_playback';
    }
  }, {
    key: "shakaVersion",
    get: function get() {
      return _shakaPlayer["default"].player.Player.version;
    }
  }, {
    key: "shakaPlayerInstance",
    get: function get() {
      return this._player;
    }
  }, {
    key: "levels",
    get: function get() {
      return this._levels;
    }
  }, {
    key: "seekRange",
    get: function get() {
      if (!this.shakaPlayerInstance) return {
        start: 0,
        end: 0
      };
      return this.shakaPlayerInstance.seekRange();
    }
  }, {
    key: "currentLevel",
    set: function set(id) {
      var _this2 = this;

      this._currentLevelId = id;
      var isAuto = this._currentLevelId === DEFAULT_LEVEL_AUTO;
      this.trigger(_clappr.Events.PLAYBACK_LEVEL_SWITCH_START);

      if (!isAuto) {
        this._player.configure({
          abr: {
            enabled: false
          }
        });

        this._pendingAdaptationEvent = true;
        this.selectTrack(this.videoTracks.filter(function (t) {
          return t.id === _this2._currentLevelId;
        })[0]);
      } else {
        this._player.configure({
          abr: {
            enabled: true
          }
        });

        this.trigger(_clappr.Events.PLAYBACK_LEVEL_SWITCH_END);
      }
    },
    get: function get() {
      return this._currentLevelId || DEFAULT_LEVEL_AUTO;
    }
  }, {
    key: "dvrEnabled",
    get: function get() {
      return this._duration >= this._minDvrSize && this.getPlaybackType() === 'live';
    }
  }, {
    key: "_duration",
    get: function get() {
      if (!this.shakaPlayerInstance) return 0;
      return this.seekRange.end - this.seekRange.start;
    }
  }, {
    key: "_startTime",
    get: function get() {
      return this.seekRange.start;
    }
  }, {
    key: "presentationStartTimeAsDate",
    get: function get() {
      if (!this.shakaPlayerInstance || !this.shakaPlayerInstance.getPresentationStartTimeAsDate()) return 0;
      return new Date(this.shakaPlayerInstance.getPresentationStartTimeAsDate().getTime() + this.seekRange.start * 1000);
    }
  }, {
    key: "bandwidthEstimate",
    get: function get() {
      if (!this.shakaPlayerInstance) return null;
      return this.shakaPlayerInstance.getStats().estimatedBandwidth;
    }
  }], [{
    key: "canPlay",
    value: function canPlay(resource) {
      var mimeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      _shakaPlayer["default"].polyfill.installAll();

      var browserSupported = _shakaPlayer["default"].Player.isBrowserSupported();

      var resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || [];
      return browserSupported && (resourceParts[1] === 'mpd' || mimeType.indexOf('application/dash+xml') > -1);
    }
  }, {
    key: "Events",
    get: function get() {
      return {
        SHAKA_READY: 'shaka:ready'
      };
    }
  }, {
    key: "shakaPlayer",
    get: function get() {
      return _shakaPlayer["default"];
    }
  }]);

  function DashShakaPlayback() {
    var _this;

    _classCallCheck(this, DashShakaPlayback);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this._levels = [];
    _this._pendingAdaptationEvent = false;
    _this._isShakaReadyState = false;
    _this._minDvrSize = typeof _this.options.shakaMinimumDvrSize === 'undefined' ? 60 : _this.options.shakaMinimumDvrSize;
    return _this;
  }

  _createClass(DashShakaPlayback, [{
    key: "getProgramDateTime",
    value: function getProgramDateTime() {
      return this.presentationStartTimeAsDate;
    }
  }, {
    key: "_updateDvr",
    value: function _updateDvr(status) {
      this.trigger(_clappr.Events.PLAYBACK_DVR, status);
      this.trigger(_clappr.Events.PLAYBACK_STATS_ADD, {
        'dvr': status
      });
    }
  }, {
    key: "seek",
    value: function seek(time) {
      if (time < 0) {
        _clappr.Log.warn('Attempt to seek to a negative time. Resetting to live point. Use seekToLivePoint() to seek to the live point.');

        time = this._duration;
      } // assume live if time within 3 seconds of end of stream


      this.dvrEnabled && this._updateDvr(time < this._duration - 3);
      time += this._startTime;
      this.el.currentTime = time;
    }
  }, {
    key: "pause",
    value: function pause() {
      this.el.pause();
      this.dvrEnabled && this._updateDvr(true);
    }
  }, {
    key: "play",
    value: function play() {
      if (!this._player) {
        this._setup();
      }

      if (!this.isReady) {
        this.once(DashShakaPlayback.Events.SHAKA_READY, this.play);
        return;
      }

      this._stopped = false;
      this._src = this.el.src;

      _get(_getPrototypeOf(DashShakaPlayback.prototype), "play", this).call(this);

      this._startTimeUpdateTimer();
    }
  }, {
    key: "_onPlaying",
    value: function _onPlaying() {
      /*
        The `_onPlaying` should not be called while buffering: https://github.com/google/shaka-player/issues/2230
        It will be executed on bufferfull.
      */
      if (this._isBuffering) return;
      return _get(_getPrototypeOf(DashShakaPlayback.prototype), "_onPlaying", this).call(this);
    }
  }, {
    key: "_onSeeking",
    value: function _onSeeking() {
      this._isSeeking = true;
      return _get(_getPrototypeOf(DashShakaPlayback.prototype), "_onSeeking", this).call(this);
    }
  }, {
    key: "_onSeeked",
    value: function _onSeeked() {
      /*
        The `_onSeeked` should not be called while buffering.
        It will be executed on bufferfull.
      */
      if (this._isBuffering) return;
      this._isSeeking = false;
      return _get(_getPrototypeOf(DashShakaPlayback.prototype), "_onSeeked", this).call(this);
    }
  }, {
    key: "_startTimeUpdateTimer",
    value: function _startTimeUpdateTimer() {
      var _this3 = this;

      this._stopTimeUpdateTimer();

      this._timeUpdateTimer = setInterval(function () {
        _this3._onTimeUpdate();
      }, 100);
    }
  }, {
    key: "_stopTimeUpdateTimer",
    value: function _stopTimeUpdateTimer() {
      this._timeUpdateTimer && clearInterval(this._timeUpdateTimer);
    } // skipping HTML5Video `_setupSrc` (on tag video)

  }, {
    key: "_setupSrc",
    value: function _setupSrc() {} // skipping ready event on video tag in favor of ready on shaka

  }, {
    key: "_ready",
    value: function _ready() {// override with no-op
    }
  }, {
    key: "_onShakaReady",
    value: function _onShakaReady() {
      this._isShakaReadyState = true;
      this.trigger(DashShakaPlayback.Events.SHAKA_READY);
      this.trigger(_clappr.Events.PLAYBACK_READY, this.name);
    }
  }, {
    key: "error",
    // skipping error handling on video tag in favor of error on shaka
    value: function error(event) {
      _clappr.Log.error('an error was raised by the video tag', event, this.el.error);
    }
  }, {
    key: "isHighDefinitionInUse",
    value: function isHighDefinitionInUse() {
      return !!this.highDefinition;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this4 = this;

      this._stopTimeUpdateTimer();

      clearInterval(this.sendStatsId);
      this._stopped = true;

      if (this._player) {
        this._sendStats();

        this._player.unload().then(function () {
          _get(_getPrototypeOf(DashShakaPlayback.prototype), "stop", _this4).call(_this4);

          _this4._player = null;
          _this4._isShakaReadyState = false;
        })["catch"](function () {
          _clappr.Log.error('shaka could not be unloaded');
        });
      } else {
        _get(_getPrototypeOf(DashShakaPlayback.prototype), "stop", this).call(this);
      }
    }
  }, {
    key: "getPlaybackType",
    value: function getPlaybackType() {
      return (this.isReady && this._player.isLive() ? 'live' : 'vod') || '';
    }
  }, {
    key: "selectTrack",
    value: function selectTrack(track) {
      if (track.type === 'text') {
        this._player.selectTextTrack(track);
      } else if (track.type === 'variant') {
        this._player.selectVariantTrack(track);

        if (track.mimeType.startsWith('video/')) {
          // we trigger the adaptation event here
          // because Shaka doesn't trigger its event on "manual" selection.
          this._onAdaptation();
        }
      } else {
        throw new Error('Unhandled track type:', track.type);
      }
    }
    /**
     * @override
     */

  }, {
    key: "_enableShakaTextTrack",
    value: function _enableShakaTextTrack(isEnable) {
      // Shaka player use only one TextTrack object with video element to handle all text tracks
      // It must be enabled or disabled in addition to call selectTextTrack()
      if (!this.el.textTracks) {
        return;
      }

      this._shakaTTVisible = isEnable;
      Array.from(this.el.textTracks).filter(function (track) {
        return track.kind === 'subtitles';
      }).forEach(function (track) {
        return track.mode = isEnable === true ? 'showing' : 'hidden';
      });
    }
  }, {
    key: "_checkForClosedCaptions",
    value: function _checkForClosedCaptions() {
      if (this._ccIsSetup) {
        return;
      }

      if (this.hasClosedCaptionsTracks) {
        this.trigger(_clappr.Events.PLAYBACK_SUBTITLE_AVAILABLE);
        var trackId = this.closedCaptionsTrackId;
        this.closedCaptionsTrackId = trackId;
      }

      this._ccIsSetup = true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;

      this._stopTimeUpdateTimer();

      clearInterval(this.sendStatsId);

      if (this._player) {
        this._player.destroy().then(function () {
          return _this5._destroy();
        })["catch"](function () {
          _this5._destroy();

          _clappr.Log.error('shaka could not be destroyed');
        });
      } else {
        this._destroy();
      }

      _get(_getPrototypeOf(DashShakaPlayback.prototype), "destroy", this).call(this);
    }
  }, {
    key: "_setup",
    value: function _setup() {
      var _this6 = this;

      this._isShakaReadyState = false;
      this._ccIsSetup = false;

      var runAllSteps = function runAllSteps() {
        _this6._player = _this6._createPlayer();

        _this6._setInitialConfig();

        _this6._loadSource();
      };

      this._player ? this._player.destroy().then(function () {
        return runAllSteps();
      }) : runAllSteps();
    }
  }, {
    key: "_createPlayer",
    value: function _createPlayer() {
      var player = new _shakaPlayer["default"].Player(this.el);
      player.addEventListener('error', this._onError.bind(this));
      player.addEventListener('adaptation', this._onAdaptation.bind(this));
      player.addEventListener('buffering', this._handleShakaBufferingEvents.bind(this));
      return player;
    }
  }, {
    key: "_setInitialConfig",
    value: function _setInitialConfig() {
      this._options.shakaConfiguration && this._player.configure(this._options.shakaConfiguration);
      this._options.shakaOnBeforeLoad && this._options.shakaOnBeforeLoad(this._player);
    }
  }, {
    key: "_loadSource",
    value: function _loadSource() {
      var _this7 = this;

      this._player.load(this._options.src).then(function () {
        return _this7._loaded();
      })["catch"](function (e) {
        return _this7._setupError(e);
      });
    }
  }, {
    key: "_onTimeUpdate",
    value: function _onTimeUpdate() {
      if (!this.shakaPlayerInstance) return;
      var update = {
        current: this.getCurrentTime(),
        total: this.getDuration(),
        firstFragDateTime: this.getProgramDateTime()
      };
      var isSame = this._lastTimeUpdate && update.current === this._lastTimeUpdate.current && update.total === this._lastTimeUpdate.total;
      if (isSame) return;
      this._lastTimeUpdate = update;
      this.trigger(_clappr.Events.PLAYBACK_TIMEUPDATE, update, this.name);
    } // skipping HTML5 `_handleBufferingEvents` in favor of shaka buffering events

  }, {
    key: "_handleBufferingEvents",
    value: function _handleBufferingEvents() {}
  }, {
    key: "_handleShakaBufferingEvents",
    value: function _handleShakaBufferingEvents(e) {
      if (this._stopped) return;
      this._isBuffering = e.buffering;
      this._isBuffering ? this._onBuffering() : this._onBufferfull();
    }
  }, {
    key: "_onBuffering",
    value: function _onBuffering() {
      this.trigger(_clappr.Events.PLAYBACK_BUFFERING);
    }
  }, {
    key: "_onBufferfull",
    value: function _onBufferfull() {
      this.trigger(_clappr.Events.PLAYBACK_BUFFERFULL);
      if (this._isSeeking) this._onSeeked();
      if (this.isPlaying()) this._onPlaying();
    }
  }, {
    key: "_loaded",
    value: function _loaded() {
      this._onShakaReady();

      this._startToSendStats();

      this._fillLevels();

      this._checkForClosedCaptions();
    }
  }, {
    key: "_fillLevels",
    value: function _fillLevels() {
      if (this._levels.length === 0) {
        this._levels = this.videoTracks.map(function (videoTrack) {
          return {
            id: videoTrack.id,
            label: "".concat(videoTrack.height, "p")
          };
        }).reverse();
        this.trigger(_clappr.Events.PLAYBACK_LEVELS_AVAILABLE, this.levels);
      }
    }
  }, {
    key: "_startToSendStats",
    value: function _startToSendStats() {
      var _this8 = this;

      var intervalMs = this._options.shakaSendStatsInterval || SEND_STATS_INTERVAL_MS;
      this.sendStatsId = setInterval(function () {
        return _this8._sendStats();
      }, intervalMs);
    }
  }, {
    key: "_sendStats",
    value: function _sendStats() {
      this.trigger(_clappr.Events.PLAYBACK_STATS_ADD, this._player.getStats());
    }
  }, {
    key: "_setupError",
    value: function _setupError(err) {
      this._onError(err);
    }
  }, {
    key: "_onError",
    value: function _onError(err) {
      var error = {
        shakaError: err,
        videoError: this.el.error
      };

      var _ref = error.shakaError.detail || error.shakaError,
          category = _ref.category,
          code = _ref.code,
          severity = _ref.severity;

      if (error.videoError || !code && !category) return _get(_getPrototypeOf(DashShakaPlayback.prototype), "_onError", this).call(this);
      var isCritical = severity === _shakaPlayer["default"].util.Error.Severity.CRITICAL;
      var errorData = {
        code: "".concat(category, "_").concat(code),
        description: "Category: ".concat(category, ", code: ").concat(code, ", severity: ").concat(severity),
        level: isCritical ? _clappr.PlayerError.Levels.FATAL : _clappr.PlayerError.Levels.WARN,
        raw: err
      };
      var formattedError = this.createError(errorData);

      _clappr.Log.error('Shaka error event:', formattedError);

      this.trigger(_clappr.Events.PLAYBACK_ERROR, formattedError);
    }
  }, {
    key: "_onAdaptation",
    value: function _onAdaptation() {
      var activeVideo = this.videoTracks.filter(function (t) {
        return t.active === true;
      })[0];

      this._fillLevels(); // update stats that may have changed before we trigger event
      // so that user can rely on stats data when handling event


      this._sendStats();

      if (this._pendingAdaptationEvent) {
        this.trigger(_clappr.Events.PLAYBACK_LEVEL_SWITCH_END);
        this._pendingAdaptationEvent = false;
      }

      _clappr.Log.debug('an adaptation has happened:', activeVideo);

      this.highDefinition = activeVideo.height >= 720;
      this.trigger(_clappr.Events.PLAYBACK_HIGHDEFINITIONUPDATE, this.highDefinition);
      this.trigger(_clappr.Events.PLAYBACK_BITRATE, {
        bandwidth: activeVideo.bandwidth,
        width: activeVideo.width,
        height: activeVideo.height,
        level: activeVideo.id,
        bitrate: activeVideo.videoBandwidth
      });
    }
  }, {
    key: "_updateSettings",
    value: function _updateSettings() {
      if (this.getPlaybackType() === 'vod') this.settings.left = ['playpause', 'position', 'duration'];else if (this.dvrEnabled) this.settings.left = ['playpause'];else this.settings.left = ['playstop'];
      this.settings.seekEnabled = this.isSeekEnabled();
      this.trigger(_clappr.Events.PLAYBACK_SETTINGSUPDATE);
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      this._isShakaReadyState = false;

      _clappr.Log.debug('shaka was destroyed');
    }
  }, {
    key: "isReady",
    get: function get() {
      return this._isShakaReadyState;
    }
  }, {
    key: "textTracks",
    get: function get() {
      return this.isReady && this._player.getTextTracks();
    }
  }, {
    key: "audioTracks",
    get: function get() {
      return this.isReady && this._player.getVariantTracks().filter(function (t) {
        return t.mimeType.startsWith('audio/');
      });
    }
  }, {
    key: "videoTracks",
    get: function get() {
      return this.isReady && this._player.getVariantTracks().filter(function (t) {
        return t.mimeType.startsWith('video/');
      });
    }
  }, {
    key: "closedCaptionsTracks",
    get: function get() {
      var id = 0;

      var trackId = function trackId() {
        return id++;
      };

      var tracks = this.textTracks || [];
      return tracks.filter(function (track) {
        return track.kind === 'subtitle';
      }).map(function (track) {
        return {
          id: trackId(),
          name: track.label || track.language,
          track: track
        };
      });
    }
    /**
     * @override
     */

  }, {
    key: "closedCaptionsTrackId",
    get: function get() {
      return _get(_getPrototypeOf(DashShakaPlayback.prototype), "closedCaptionsTrackId", this);
    }
    /**
     * @override
     */
    ,
    set: function set(trackId) {
      if (!this._player) {
        return;
      }

      var tracks = this.closedCaptionsTracks;
      var showingTrack; // Note: -1 is for hide all tracks

      if (trackId !== -1) {
        showingTrack = tracks.find(function (track) {
          return track.id === trackId;
        });

        if (!showingTrack) {
          _clappr.Log.warn("Track id \"".concat(trackId, "\" not found"));

          return;
        }

        if (this._shakaTTVisible && showingTrack.track.active === true) {
          _clappr.Log.info("Track id \"".concat(trackId, "\" already showing"));

          return;
        }
      }

      if (showingTrack) {
        this._player.selectTextTrack(showingTrack.track);

        this._player.setTextTrackVisibility(true);

        this._enableShakaTextTrack(true);
      } else {
        this._player.setTextTrackVisibility(false);

        this._enableShakaTextTrack(false);
      }

      this._ccTrackId = trackId;
      this.trigger(_clappr.Events.PLAYBACK_SUBTITLE_CHANGED, {
        id: trackId
      });
    }
  }]);

  return DashShakaPlayback;
}(_clappr.HTML5Video);

var _default = DashShakaPlayback;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "clappr":
/*!******************************************************************************************!*\
  !*** external {"amd":"clappr","commonjs":"clappr","commonjs2":"clappr","root":"Clappr"} ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_clappr__;

/***/ })

/******/ });
});

});

var DashShakaPlayback = /*@__PURE__*/getDefaultExportFromCjs(dashShakaPlayback);

var css_248z$u = "@font-face {\n  font-family: \"opensans-regular\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/opensans/regular.woff2\") format(\"woff2\"), url(\"//s3.glbimg.com/cdn/fonts/opensans/regular.woff\") format(\"woff\"), url(\"//s3.glbimg.com/cdn/fonts/opensans/regular.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n@font-face {\n  font-family: \"opensans-bold\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/opensans/bold.woff2\") format(\"woff2\"), url(\"//s3.glbimg.com/cdn/fonts/opensans/bold.woff\") format(\"woff\"), url(\"//s3.glbimg.com/cdn/fonts/opensans/bold.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n@font-face {\n  font-family: \"proximanova-regular\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/proximanova/regular.woff2\") format(\"woff2\"), url(\"//s3.glbimg.com/cdn/fonts/proximanova/regular.woff\") format(\"woff\"), url(\"//s3.glbimg.com/cdn/fonts/proximanova/regular.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n@font-face {\n  font-family: \"proximanova-bold\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/proximanova/bold.woff2\") format(\"woff2\"), url(\"//s3.glbimg.com/cdn/fonts/proximanova/bold.woff\") format(\"woff\"), url(\"//s3.glbimg.com/cdn/fonts/proximanova/bold.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n@font-face {\n  font-family: \"proximanova-xbold\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/proximanova/extrabold.woff2\") format(\"woff2\"), url(\"//s3.glbimg.com/cdn/fonts/proximanova/extrabold.woff\") format(\"woff\"), url(\"//s3.glbimg.com/cdn/fonts/proximanova/extrabold.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n@font-face {\n  font-family: \"clearsans-bold\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/clearsans/bold.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n@font-face {\n  font-family: \"clearsans-bolditalic\";\n  src: url(\"//s3.glbimg.com/cdn/fonts/clearsans/bolditalic.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: normal; }\n\n.clappr-player#wp3-player-0 {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transform: translate3d(0, 0, 0);\n  position: relative;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-style: normal;\n  font-weight: normal;\n  text-align: center;\n  overflow: hidden;\n  font-size: 100%;\n  font-family: \"lucida grande\", tahoma, verdana, arial, sans-serif;\n  text-shadow: none;\n  box-sizing: border-box;\n  display: block;\n  max-width: none;\n  box-sizing: inherit;\n  float: none;\n  -webkit-tap-highlight-color: transparent; }\n  .clappr-player#wp3-player-0:focus {\n    outline: 0; }\n  .clappr-player#wp3-player-0.fullscreen {\n    width: 100% !important;\n    height: 100% !important; }\n  .clappr-player#wp3-player-0.nocursor {\n    cursor: none; }\n";
styleInject(css_248z$u);

var css_248z$v = ".clappr-player#wp3-player-0 div, .clappr-player#wp3-player-0 span, .clappr-player#wp3-player-0 applet, .clappr-player#wp3-player-0 object, .clappr-player#wp3-player-0 iframe,\n.clappr-player#wp3-player-0 h1, .clappr-player#wp3-player-0 h2, .clappr-player#wp3-player-0 h3, .clappr-player#wp3-player-0 h4, .clappr-player#wp3-player-0 h5, .clappr-player#wp3-player-0 h6, .clappr-player#wp3-player-0 p, .clappr-player#wp3-player-0 blockquote, .clappr-player#wp3-player-0 pre,\n.clappr-player#wp3-player-0 a, .clappr-player#wp3-player-0 abbr, .clappr-player#wp3-player-0 acronym, .clappr-player#wp3-player-0 address, .clappr-player#wp3-player-0 big, .clappr-player#wp3-player-0 cite, .clappr-player#wp3-player-0 code,\n.clappr-player#wp3-player-0 del, .clappr-player#wp3-player-0 dfn, .clappr-player#wp3-player-0 em, .clappr-player#wp3-player-0 img, .clappr-player#wp3-player-0 ins, .clappr-player#wp3-player-0 kbd, .clappr-player#wp3-player-0 q, .clappr-player#wp3-player-0 s, .clappr-player#wp3-player-0 samp,\n.clappr-player#wp3-player-0 small, .clappr-player#wp3-player-0 strike, .clappr-player#wp3-player-0 strong, .clappr-player#wp3-player-0 sub, .clappr-player#wp3-player-0 sup, .clappr-player#wp3-player-0 tt, .clappr-player#wp3-player-0 var,\n.clappr-player#wp3-player-0 b, .clappr-player#wp3-player-0 u, .clappr-player#wp3-player-0 i, .clappr-player#wp3-player-0 center,\n.clappr-player#wp3-player-0 dl, .clappr-player#wp3-player-0 dt, .clappr-player#wp3-player-0 dd, .clappr-player#wp3-player-0 ol, .clappr-player#wp3-player-0 ul, .clappr-player#wp3-player-0 li,\n.clappr-player#wp3-player-0 fieldset, .clappr-player#wp3-player-0 form, .clappr-player#wp3-player-0 label, .clappr-player#wp3-player-0 legend,\n.clappr-player#wp3-player-0 table, .clappr-player#wp3-player-0 caption, .clappr-player#wp3-player-0 tbody, .clappr-player#wp3-player-0 tfoot, .clappr-player#wp3-player-0 thead, .clappr-player#wp3-player-0 tr, .clappr-player#wp3-player-0 th, .clappr-player#wp3-player-0 td,\n.clappr-player#wp3-player-0 article, .clappr-player#wp3-player-0 aside, .clappr-player#wp3-player-0 canvas, .clappr-player#wp3-player-0 details, .clappr-player#wp3-player-0 embed,\n.clappr-player#wp3-player-0 figure, .clappr-player#wp3-player-0 figcaption, .clappr-player#wp3-player-0 footer, .clappr-player#wp3-player-0 header, .clappr-player#wp3-player-0 hgroup,\n.clappr-player#wp3-player-0 menu, .clappr-player#wp3-player-0 nav, .clappr-player#wp3-player-0 output, .clappr-player#wp3-player-0 ruby, .clappr-player#wp3-player-0 section, .clappr-player#wp3-player-0 summary,\n.clappr-player#wp3-player-0 time, .clappr-player#wp3-player-0 mark, .clappr-player#wp3-player-0 audio, .clappr-player#wp3-player-0 video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font: inherit;\n  font-size: 100%;\n  vertical-align: baseline; }\n\n.clappr-player#wp3-player-0 table {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\n.clappr-player#wp3-player-0 caption, .clappr-player#wp3-player-0 th, .clappr-player#wp3-player-0 td {\n  text-align: left;\n  font-weight: normal;\n  vertical-align: middle; }\n\n.clappr-player#wp3-player-0 q, .clappr-player#wp3-player-0 blockquote {\n  quotes: none; }\n  .clappr-player#wp3-player-0 q:before, .clappr-player#wp3-player-0 q:after, .clappr-player#wp3-player-0 blockquote:before, .clappr-player#wp3-player-0 blockquote:after {\n    content: \"\";\n    content: none; }\n\n.clappr-player#wp3-player-0 a img {\n  border: none; }\n";
styleInject(css_248z$v);

var mediaControlPlugins = {
  PlayButton: PlayButton,
  TimeIndicator: TimeIndicator,
  LiveIndicator: LiveIndicator,
  LiveButton: LiveButton,
  Volume: Volume,
  Seekbar: Seekbar,
  FullscreenButton: FullscreenButton,
  Settings: Settings,
  BackButton: BackButton,
  VideoInfo: VideoInfo,
  Share: ShareButton,
  SkipRecap: SkipRecap,
  SkipIntro: SkipIntro,
  StartOver: StartOver,
  QuickSeek: QuickSeek,
  QuickSeekHint: QuickSeekHint,
  ChromecastSenderIndicator: ChromecastSenderIndicator,
  MediaControlPlaceHolder: MediaControlPlaceHolder
};

var Plugins = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
  DFP: DFP,
  DAI: DAI,
  GloboMediaControl: WebMediaControl
}, mediaControlPlugins), {}, {
  Pip: PipPlugin,
  TapToUnmute: TapToUnmute,
  ErrorScreen: ErrorScreen,
  Chromecast: ChromecastPlugin,
  ThumbPreview: ThumbPreview,
  SeekTime: SeekTime
}, core), {}, {
  Subtitle: Subtitle,
  Poster: Poster,
  Spinner: Spinner,
  StreamSense: StreamSense,
  Comscore: Comscore,
  WebmediaAPIHit: WebmediaAPIHit,
  Horizon: Horizon,
  WaitingRoom: WaitingRoom,
  PlayerStats: PlayerStats,
  GloboYouBora: GloboYouBora,
  GoogleAnalytics: GoogleAnalytics,
  BitrateCapping: BitrateCapping,
  Cuepoints: Cuepoints,
  EPG: EPGPlugin,
  ClickToPause: ClickToPausePlugin
}, container), {}, {
  Overlay: Overlay,
  DrawerHeader: DrawerHeader,
  SimulcastPing: SimulcastPing,
  WatchSession: WatchSession
});

var Playbacks = [DashShakaPlayback, hlsjsPlayback_external, HLSFairplayPlayback];

var mergePlugins = function mergePlugins(externalPlugins, pluginsWithState) {
  var plugins = {
    core: [WebMediaControl, PlayButton, BackButton, SkipRecap, SkipIntro, StartOver, TimeIndicator, LiveButton, LiveIndicator, Volume, Seekbar, QuickSeek, QuickSeekHint, ThumbPreview, FullscreenButton, Settings, VideoInfo, PipPlugin, TapToUnmute, ErrorScreen, ChromecastPlugin, ChromecastSenderIndicator, ShareButton, SeekTime].concat(_toConsumableArray(core)),
    container: [Subtitle, Poster, Spinner, StreamSense, Comscore, WebmediaAPIHit, Horizon, WaitingRoom, PlayerStats, GloboYouBora, GoogleAnalytics, BitrateCapping, Cuepoints, EPGPlugin, ClickToPausePlugin, SimulcastPing].concat(_toConsumableArray(container))
  };
  Object.keys(pluginsWithState).forEach(function (pluginType) {
    pluginsWithState[pluginType].forEach(function (p) {
      p.enabled && plugins[pluginType].push(p.plugin);
    });
  });

  if (externalPlugins) {
    plugins.core = Utils$1.mergePlugins(plugins.core, externalPlugins.core);
    plugins.playback = Utils$1.mergePlugins(plugins.playback, externalPlugins.playback);
    plugins.container = Utils$1.mergePlugins(plugins.container, externalPlugins.container);
  }

  return plugins;
};

var getPluginsWithState = function getPluginsWithState(options) {
  return {
    container: [],
    core: [{
      plugin: ChromecastPlugin,
      enabled: options.chromecast.enabled
    }, {
      plugin: ShareButton,
      enabled: options.sharePlugin.enabled
    }]
  };
};

var mergeMediaControlPlugins = function mergeMediaControlPlugins() {
  var externalMediaControlPlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mediaControlPlugins = ['play_button', 'time_indicator', 'live_indicator', 'live_button', 'volume', 'seekbar', 'seekbar_info', 'fullscreen_button', 'settings', 'back_button', 'video_info', 'share', 'skip_recap', 'skip_intro', 'start_over', 'quick_seek', 'quick_seek_hint', 'chromecast_sender_indicator', 'media_control_placeholder'];
  var filteredPlugin = externalMediaControlPlugins.filter(function (pluginName) {
    return pluginName && mediaControlPlugins.indexOf(pluginName) === -1;
  });
  return mediaControlPlugins.concat(filteredPlugin);
};

var main = {
  Plugins: Plugins,
  Playbacks: Playbacks,
  mergePlugins: mergePlugins,
  mergeMediaControlPlugins: mergeMediaControlPlugins,
  getPluginsWithState: getPluginsWithState,
  Errors: Errors$1,
  playerStyle: css_248z$u,
  resetStyle: css_248z$v,
  DrawerBottom: DrawerBottom,
  DrawerBottomHeader: DrawerBottomHeader,
  MediaControlPlugin: MediaControlPlugin
};

export default main;
export { audio_config as AudioConfig, BitrateCapping, ChromecastPlugin as Chromecast, ChromecastSenderIndicator, ClickToPausePlugin as ClickToPause, Comscore, CuepointMarkers, Cuepoints, DAI, DFP, DashShakaPlayback, DrawerBottom, DrawerBottomHeader, EPGPlugin as EPG, ErrorScreen, Errors$1 as Errors, FullscreenButton, WebMediaControl as GloboMediaControl, GloboYouBora, GoogleAnalytics, hlsjsPlayback_external as HlsjsPlayback, Horizon, container as HorizonContainerPlugins, core as HorizonCorePlugins, LiveButton, LiveIndicator, MediaControlPlugin, Overlay, PipPlugin as Pip, PlayButton, Playbacks, PlayerStats, Plugins, Poster, QuickSeek, QuickSeekHint, SeekTime, Seekbar, Settings, SkipIntro, SkipRecap, Spinner, StartOver, StreamSense, Subtitle, subtitle_config as SubtitleConfig, TapToUnmute, ThumbPreview, TimeIndicator, VideoInfo, Volume, WaitingRoom, WebmediaAPIHit, getPluginsWithState, mergeMediaControlPlugins, mergePlugins, css_248z$u as playerStyle, css_248z$v as resetStyle };
